import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null | undefined
export type InputMaybe<T> = T | null | undefined
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
export const namedOperations = {
  Query: {
    Common_GetStoreDepartmentsForAutocomplete:
      'Common_GetStoreDepartmentsForAutocomplete',
    AdminFilters_GetPaginatedStores: 'AdminFilters_GetPaginatedStores',
    AdminFilters_GetPaginatedUsers: 'AdminFilters_GetPaginatedUsers',
    App_GetCurrentUser: 'App_GetCurrentUser',
    App_GetCurrentUser_StoreDepartments: 'App_GetCurrentUser_StoreDepartments',
    Payments_GetCurrentVendorAdminInfo: 'Payments_GetCurrentVendorAdminInfo',
    Payments_GetCurrentBannerAdminInfo: 'Payments_GetCurrentBannerAdminInfo',
    Payments_GetCurrentStoreAdminInfo: 'Payments_GetCurrentStoreAdminInfo',
    Payments_GetCurrentLoggedInStoreAdminInfo:
      'Payments_GetCurrentLoggedInStoreAdminInfo',
    ProductsCatalog_GetVendorProductsForCatalog:
      'ProductsCatalog_GetVendorProductsForCatalog',
    ProductsCatalog_GetVendorProductForCatalog:
      'ProductsCatalog_GetVendorProductForCatalog',
    ProductsCatalog_GetVendorBrands: 'ProductsCatalog_GetVendorBrands',
    ProductsCatalog_GetVendorCategories: 'ProductsCatalog_GetVendorCategories',
    ProductsCatalog_GetVendorCatalogMetadata:
      'ProductsCatalog_GetVendorCatalogMetadata',
    ProductsCatalog_GetVendorCatalogMetadataByID:
      'ProductsCatalog_GetVendorCatalogMetadataByID',
    ProductsCatalog_GetAdminAllRetailers:
      'ProductsCatalog_GetAdminAllRetailers',
    ProductsCatalog_GetVendorAllRetailers:
      'ProductsCatalog_GetVendorAllRetailers',
    ProductsCatalog_GetRetailAllRetailers:
      'ProductsCatalog_GetRetailAllRetailers',
    ProductsCatalog_GetAdminAllStores: 'ProductsCatalog_GetAdminAllStores',
    ProductsCatalog_GetAdminAllVendors: 'ProductsCatalog_GetAdminAllVendors',
    ProductsCatalog_GetCSVUploadLogs: 'ProductsCatalog_GetCSVUploadLogs',
    ProductsCatalog_GetCSVUploadLogByID: 'ProductsCatalog_GetCSVUploadLogByID',
    ProductsCatalog_GetMatchingVendorProducts:
      'ProductsCatalog_GetMatchingVendorProducts',
    RetailBuyers_GetRetailUserByID: 'RetailBuyers_GetRetailUserByID',
    RetailBuyers_GetStoreBuyers: 'RetailBuyers_GetStoreBuyers',
    RetailBuyers_GetStoreDepartments: 'RetailBuyers_GetStoreDepartments',
    RetailVendorCatalog_GetAdminBannerBuyers:
      'RetailVendorCatalog_GetAdminBannerBuyers',
    RetailVendorCatalog_GetAllOrderGuides:
      'RetailVendorCatalog_GetAllOrderGuides',
    RetailVendorCatalog_GetVendorProducts:
      'RetailVendorCatalog_GetVendorProducts',
    RetailVendorCatalog_GetVendorProduct:
      'RetailVendorCatalog_GetVendorProduct',
    RetailVendorCatalog_GetVendorProductCustomPricing:
      'RetailVendorCatalog_GetVendorProductCustomPricing',
    RetailVendorCatalog_GetVendorBrands: 'RetailVendorCatalog_GetVendorBrands',
    RetailVendorCatalog_GetVendorCategories:
      'RetailVendorCatalog_GetVendorCategories',
    RetailVendorCatalog_GetRetailCompanyVendors:
      'RetailVendorCatalog_GetRetailCompanyVendors',
    RetailVendorCatalog_GetDiscoverableVendors:
      'RetailVendorCatalog_GetDiscoverableVendors',
    RetailBulkAction_GetAllStoreDepartments:
      'RetailBulkAction_GetAllStoreDepartments',
    Retail_GetUserStoreDepartments: 'Retail_GetUserStoreDepartments',
    Retail_GetVendors: 'Retail_GetVendors',
    RetailDepartments_GetStoreDepartments:
      'RetailDepartments_GetStoreDepartments',
    RetailDepartments_GetStoreDepartmentsNamesInUse:
      'RetailDepartments_GetStoreDepartmentsNamesInUse',
    RetailHome_GetStats: 'RetailHome_GetStats',
    RetailOrders_GetBannerOrders: 'RetailOrders_GetBannerOrders',
    RetailOrders_GetBannerStores: 'RetailOrders_GetBannerStores',
    RetailOrders_AdminGetBannerStores: 'RetailOrders_AdminGetBannerStores',
    RetailOrders_GetVendors: 'RetailOrders_GetVendors',
    RetailOrders_GetStoreDepartments: 'RetailOrders_GetStoreDepartments',
    RetailVendorSearch_GetProducts: 'RetailVendorSearch_GetProducts',
    StoreAdminSearchAuthorizedVendors: 'StoreAdminSearchAuthorizedVendors',
    RetailStores_GetBannerStores: 'RetailStores_GetBannerStores',
    RetailStores_GetStoreByID: 'RetailStores_GetStoreByID',
    RetailDepartment_GetStore: 'RetailDepartment_GetStore',
    RetailDepartment_GetDepartmentVendors:
      'RetailDepartment_GetDepartmentVendors',
    RetailDepartment_GetDepartmentOrders:
      'RetailDepartment_GetDepartmentOrders',
    RetailDepartment_GetDepartmentOrderByID:
      'RetailDepartment_GetDepartmentOrderByID',
    RetailOrderGuides_GetVendorStoreDepartmentAccountOrderGuide:
      'RetailOrderGuides_GetVendorStoreDepartmentAccountOrderGuide',
    RetailOrderGuides_GetStoreVendorProducts:
      'RetailOrderGuides_GetStoreVendorProducts',
    RetailDepartment_GetVendorStoreDepartmentAccountByVendorID:
      'RetailDepartment_GetVendorStoreDepartmentAccountByVendorID',
    StoreAdmin_GetDepartmentOrders: 'StoreAdmin_GetDepartmentOrders',
    VendorCustomers_GetVsdasForVendor: 'VendorCustomers_GetVsdasForVendor',
    VendorCustomers_GetVsdaDetail: 'VendorCustomers_GetVsdaDetail',
    VendorCustomers_GetOrderHistoryForVendorStoreAccount:
      'VendorCustomers_GetOrderHistoryForVendorStoreAccount',
    VendorCustomers_CheckForExistingStore:
      'VendorCustomers_CheckForExistingStore',
    VendorCustomers_BulkCheckForExistingStore:
      'VendorCustomers_BulkCheckForExistingStore',
    VendorHome_GetStats: 'VendorHome_GetStats',
    VendorOrders_GetOrders: 'VendorOrders_GetOrders',
    VendorOrders_GetOrderByID: 'VendorOrders_GetOrderByID',
    VendorOrders_GetProductSuggestions: 'VendorOrders_GetProductSuggestions',
    VendorOrders_GetStores: 'VendorOrders_GetStores',
    VendorOrders_GetStoreAccount: 'VendorOrders_GetStoreAccount',
    VendorProfile_GetProfile: 'VendorProfile_GetProfile',
    VendorProfile_GetPaginatedStores: 'VendorProfile_GetPaginatedStores',
    VendorProfile_GetOrderDeadlineInfo: 'VendorProfile_GetOrderDeadlineInfo',
    VendorProfile_GetVSDAOrderDeadlineInfo:
      'VendorProfile_GetVSDAOrderDeadlineInfo',
    VendorPromotions_GetAudiences: 'VendorPromotions_GetAudiences',
    VendorPromotions_GetDeal: 'VendorPromotions_GetDeal',
    VendorPromotions_GetAllPromotions: 'VendorPromotions_GetAllPromotions',
    VendorPromotions_GetPromotionDetail: 'VendorPromotions_GetPromotionDetail',
    VendorPromotions_GetPromotionConflicts:
      'VendorPromotions_GetPromotionConflicts',
    VendorPromotions_GetProducts: 'VendorPromotions_GetProducts',
    VendorPromotions_GetStoreAccounts: 'VendorPromotions_GetStoreAccounts',
    Common_GetStoreDepartmentsForRetailAdminSelect:
      'Common_GetStoreDepartmentsForRetailAdminSelect',
    Common_GetStoreDepartmentsForRetailAPSelect:
      'Common_GetStoreDepartmentsForRetailAPSelect',
    Common_GetStoreDepartmentsForRetailBuyerSelect:
      'Common_GetStoreDepartmentsForRetailBuyerSelect',
    Common_GetStoreDepartmentsForVendorAdminSelect:
      'Common_GetStoreDepartmentsForVendorAdminSelect',
    Common_GetStoresForRetailAdminSelect:
      'Common_GetStoresForRetailAdminSelect',
    Common_GetStoresForRetailAPSelect: 'Common_GetStoresForRetailAPSelect',
    Common_GetStoresForVendorAdminSelect:
      'Common_GetStoresForVendorAdminSelect',
    Common_GetStoresForVoriAdminSelect: 'Common_GetStoresForVoriAdminSelect',
    Common_GetVendorsForRetailAdminSelect:
      'Common_GetVendorsForRetailAdminSelect',
    Common_GetVendorsForRetailAPSelect: 'Common_GetVendorsForRetailAPSelect',
    Common_GetVendorsForRetailBuyerSelect:
      'Common_GetVendorsForRetailBuyerSelect',
    Common_GetVendorsForVoriAdminSelect: 'Common_GetVendorsForVoriAdminSelect',
    AdminBanners_GetAllBanners: 'AdminBanners_GetAllBanners',
    AdminBanners_GetBannerByID: 'AdminBanners_GetBannerByID',
    AdminBanners_GetAllStores: 'AdminBanners_GetAllStores',
    AdminCatalogs_ValidateBulkUploadVendorProducts:
      'AdminCatalogs_ValidateBulkUploadVendorProducts',
    AdminCatalogs_GetVendorOGProducts: 'AdminCatalogs_GetVendorOGProducts',
    AdminCatalogs_GetV2VSDAOrderGuide: 'AdminCatalogs_GetV2VSDAOrderGuide',
    AdminCatalogs_GetV2VSDAOrderGuides: 'AdminCatalogs_GetV2VSDAOrderGuides',
    AdminCatalogs_GetV2VSDAStoreAuthOrderGuides:
      'AdminCatalogs_GetV2VSDAStoreAuthOrderGuides',
    AdminCatalogs_GetsVSDAsForStoresAndVendors:
      'AdminCatalogs_GetsVSDAsForStoresAndVendors',
    AdminCatalogs_GetBannerV2VSDAOrderGuides:
      'AdminCatalogs_GetBannerV2VSDAOrderGuides',
    AdminCatalogs_CheckInvitationOrderGuideName:
      'AdminCatalogs_CheckInvitationOrderGuideName',
    AdminCatalogs_GetAllBanners: 'AdminCatalogs_GetAllBanners',
    AdminCatalogs_GetAllStores: 'AdminCatalogs_GetAllStores',
    AdminCatalogs_GetAllVendors: 'AdminCatalogs_GetAllVendors',
    AdminCatalogs_GetUsersForOGSelect: 'AdminCatalogs_GetUsersForOGSelect',
    AdminCatalogs_GetVendorsByID: 'AdminCatalogs_GetVendorsByID',
    AdminCatalogs_GetStoreDepartmentsAndUsers:
      'AdminCatalogs_GetStoreDepartmentsAndUsers',
    AdminCatalogs_GetBannerStoreDepartmentsAndUsers:
      'AdminCatalogs_GetBannerStoreDepartmentsAndUsers',
    AdminCatalogs_GetStoreVSDAs: 'AdminCatalogs_GetStoreVSDAs',
    AdminCatalogs_GetBannerVSDAs: 'AdminCatalogs_GetBannerVSDAs',
    AdminContainer_GetPaginatedUsers: 'AdminContainer_GetPaginatedUsers',
    AdminContainer_GetUserByID: 'AdminContainer_GetUserByID',
    AdminStores_GetAllStores: 'AdminStores_GetAllStores',
    AdminInvitations_GetStoreInvitations:
      'AdminInvitations_GetStoreInvitations',
    AdminInvitations_GetVendorInvitations:
      'AdminInvitations_GetVendorInvitations',
    AdminStores_GetPaginatedStores: 'AdminStores_GetPaginatedStores',
    AdminStores_GetPaginatedVendors: 'AdminStores_GetPaginatedVendors',
    AdminStores_GetStoreDetails: 'AdminStores_GetStoreDetails',
    AdminStores_GetVendorStoreDepartmentAccountsForStore:
      'AdminStores_GetVendorStoreDepartmentAccountsForStore',
    AdminStores_GetVendorStoreDepartmentAccountForVendorAndStore:
      'AdminStores_GetVendorStoreDepartmentAccountForVendorAndStore',
    AdminStores_GetStoreDepartmentsForStore:
      'AdminStores_GetStoreDepartmentsForStore',
    AdminStores_GetVendorStoreDepartmentAccountsForStoreDepartment:
      'AdminStores_GetVendorStoreDepartmentAccountsForStoreDepartment',
    AdminVendors_GetAllStores: 'AdminVendors_GetAllStores',
    AdminVendors_GetPaginatedVendors: 'AdminVendors_GetPaginatedVendors',
    AdminVendors_GetVendorByID: 'AdminVendors_GetVendorByID',
    BackOffice_GetCurrentUserStores: 'BackOffice_GetCurrentUserStores',
    CreateInvoice_GetStoreDepartmentsByStoreID:
      'CreateInvoice_GetStoreDepartmentsByStoreID',
    GetUnitOfMeasureValues: 'GetUnitOfMeasureValues',
    Retail_GetStoreDepartments: 'Retail_GetStoreDepartments',
    Retail_GetDepartmentById: 'Retail_GetDepartmentById',
    FrontOffice_GetBannerByID: 'FrontOffice_GetBannerByID',
    FrontOffice_GetMetabaseDashboardQuery:
      'FrontOffice_GetMetabaseDashboardQuery',
    FrontOffice_GetExploDashboardQuery: 'FrontOffice_GetExploDashboardQuery',
    APIntegrations_GetConfiguration: 'APIntegrations_GetConfiguration',
    APIntegrations_GetRecords: 'APIntegrations_GetRecords',
    BackOffice__QueryMasterCatalog: 'BackOffice__QueryMasterCatalog',
    ValidateBulkUploadStoreVendorProducts:
      'ValidateBulkUploadStoreVendorProducts',
    BackOffice_GetProductByBarcode: 'BackOffice_GetProductByBarcode',
    BackOfficeProductManagement_ExportEPLUM:
      'BackOfficeProductManagement_ExportEPLUM',
    BackOfficeTaxManagement_GetTaxRates: 'BackOfficeTaxManagement_GetTaxRates',
    BackOfficeTaxManagement_GetTaxRate: 'BackOfficeTaxManagement_GetTaxRate',
    BackOfficeVendorManagement_SearchVendors:
      'BackOfficeVendorManagement_SearchVendors',
    BackOfficeVendorManagement_GetVendor:
      'BackOfficeVendorManagement_GetVendor',
    BackOfficeVendorManagement_GetStoreVendors:
      'BackOfficeVendorManagement_GetStoreVendors',
  },
  Mutation: {
    Payments_CreatePlaidLinkToken: 'Payments_CreatePlaidLinkToken',
    Payments_CreateStripeBankAccountToken:
      'Payments_CreateStripeBankAccountToken',
    Payments_CreatePaymentProfile: 'Payments_CreatePaymentProfile',
    ProductsCatalog_CreateVendorProduct: 'ProductsCatalog_CreateVendorProduct',
    ProductsCatalog_UpdateVendorProduct: 'ProductsCatalog_UpdateVendorProduct',
    ProductsCatalog_BulkUpdateVendorProducts:
      'ProductsCatalog_BulkUpdateVendorProducts',
    ProductsCatalog_DeleteVendorProduct: 'ProductsCatalog_DeleteVendorProduct',
    ProductsCatalog_GetVendorCatalogDownloadURL:
      'ProductsCatalog_GetVendorCatalogDownloadURL',
    RetailBuyers_CreateBuyerAccount: 'RetailBuyers_CreateBuyerAccount',
    RetailBuyers_UpdateBuyerProfile: 'RetailBuyers_UpdateBuyerProfile',
    RetailBuyers_AddBuyerToStoreDepartment:
      'RetailBuyers_AddBuyerToStoreDepartment',
    RetailBuyers_RemoveBuyerFromStoreDepartment:
      'RetailBuyers_RemoveBuyerFromStoreDepartment',
    RetailVendorCatalog_AddProductToOrderGuide:
      'RetailVendorCatalog_AddProductToOrderGuide',
    RetailVendorCatalog_RemoveProductFromOrderGuide:
      'RetailVendorCatalog_RemoveProductFromOrderGuide',
    RetailVendorCatalog_UpdateStoreVendorProduct:
      'RetailVendorCatalog_UpdateStoreVendorProduct',
    RetailDepartments_CreateStoreDepartment:
      'RetailDepartments_CreateStoreDepartment',
    RetailOrders_ConfirmOrder: 'RetailOrders_ConfirmOrder',
    RetailDepartment_EnableVendorStoreDepartmentAccount:
      'RetailDepartment_EnableVendorStoreDepartmentAccount',
    RetailDepartment_DisableVendorStoreDepartmentAccount:
      'RetailDepartment_DisableVendorStoreDepartmentAccount',
    RetailDepartment_CreateVendorStoreDepartmentAccount:
      'RetailDepartment_CreateVendorStoreDepartmentAccount',
    RetailOrderGuides_AddProductToOrderGuide:
      'RetailOrderGuides_AddProductToOrderGuide',
    RetailOrderGuides_RemoveProductFromOrderGuide:
      'RetailOrderGuides_RemoveProductFromOrderGuide',
    RetailOrderGuides_CopyOrderGuide: 'RetailOrderGuides_CopyOrderGuide',
    RetailOrderGuides_GetOrderGuideExportURL:
      'RetailOrderGuides_GetOrderGuideExportURL',
    RetailOrderGuides_UpdateVendorStoreDepartmentAccount:
      'RetailOrderGuides_UpdateVendorStoreDepartmentAccount',
    VendorCustomers_UpdateVendorStoreDepartmentAccount:
      'VendorCustomers_UpdateVendorStoreDepartmentAccount',
    VendorCustomers_InviteStoreAccountsForVendor:
      'VendorCustomers_InviteStoreAccountsForVendor',
    VendorCustomers_CreateStoreAccountsForVendor:
      'VendorCustomers_CreateStoreAccountsForVendor',
    VendorCustomers_ValidateStoreAccountsForVendor:
      'VendorCustomers_ValidateStoreAccountsForVendor',
    VendorOrders_ConfirmOrder: 'VendorOrders_ConfirmOrder',
    VendorOrders_ResubmitOrder: 'VendorOrders_ResubmitOrder',
    VendorOrders_UpdateVendorStoreAccountNumber:
      'VendorOrders_UpdateVendorStoreAccountNumber',
    VendorProfile_UpdateProfile: 'VendorProfile_UpdateProfile',
    VendorProfile_UpdateOrderDeadlineInfo:
      'VendorProfile_UpdateOrderDeadlineInfo',
    VendorProfile_UpdateVSDAOrderDeadlineInfoForVendor:
      'VendorProfile_UpdateVSDAOrderDeadlineInfoForVendor',
    VendorPromotions_CreateAudience: 'VendorPromotions_CreateAudience',
    VendorPromotions_CreateDeal: 'VendorPromotions_CreateDeal',
    VendorPromotions_UpdateDeal: 'VendorPromotions_UpdateDeal',
    VendorPromotions_DeleteDeal: 'VendorPromotions_DeleteDeal',
    VendorPromotions_CreatePromotion: 'VendorPromotions_CreatePromotion',
    VendorPromotions_UpdatePromotion: 'VendorPromotions_UpdatePromotion',
    VendorPromotions_DeletePromotion: 'VendorPromotions_DeletePromotion',
    AdminBanners_DeleteBannerByID: 'AdminBanners_DeleteBannerByID',
    AdminBanners_CreateBanner: 'AdminBanners_CreateBanner',
    AdminBanners_UpdateBanner: 'AdminBanners_UpdateBanner',
    AdminCatalogs_ParseCSVOrderGuide: 'AdminCatalogs_ParseCSVOrderGuide',
    AdminCatalogs_BulkParseCSVOrderGuides:
      'AdminCatalogs_BulkParseCSVOrderGuides',
    AdminCatalogs_BulkUpdateV2OrderGuides:
      'AdminCatalogs_BulkUpdateV2OrderGuides',
    AdminCatalogs_AddProductsToV2OrderGuide:
      'AdminCatalogs_AddProductsToV2OrderGuide',
    AdminCatalogs_UpdateV2OrderGuide: 'AdminCatalogs_UpdateV2OrderGuide',
    AdminCatalogs_CreateInvitationOrderGuide:
      'AdminCatalogs_CreateInvitationOrderGuide',
    AdminCatalogs_UpdateBannerAuthFileV2OrderGuides:
      'AdminCatalogs_UpdateBannerAuthFileV2OrderGuides',
    AdminCatalogs_UpdateBannerV2OrderGuides:
      'AdminCatalogs_UpdateBannerV2OrderGuides',
    AdminCatalogs_BulkSingleVendorProductsUploadWorker:
      'AdminCatalogs_BulkSingleVendorProductsUploadWorker',
    AdminCatalogs_BulkMultiVendorProductsUploadWorker:
      'AdminCatalogs_BulkMultiVendorProductsUploadWorker',
    AdminESLUpload_SendESLFileUpdate: 'AdminESLUpload_SendESLFileUpdate',
    AdminContainer_CreateUser: 'AdminContainer_CreateUser',
    AdminContainer_UpdateUser: 'AdminContainer_UpdateUser',
    AdminContainer_DeleteUser: 'AdminContainer_DeleteUser',
    AdminInvitations_SendVendorInvitation:
      'AdminInvitations_SendVendorInvitation',
    AdminStores_UpdateStore: 'AdminStores_UpdateStore',
    AdminStores_UpdateVendorStoreDepartmentAccount:
      'AdminStores_UpdateVendorStoreDepartmentAccount',
    AdminStores_CreateStoreDepartment: 'AdminStores_CreateStoreDepartment',
    AdminStores_CreateVendorStoreDepartmentAccount:
      'AdminStores_CreateVendorStoreDepartmentAccount',
    AdminStores_BulkCreateVendorStoreDepartmentAccounts:
      'AdminStores_BulkCreateVendorStoreDepartmentAccounts',
    AdminStores_CreateUserStoreDepartment:
      'AdminStores_CreateUserStoreDepartment',
    AdminStores_DeleteUserStoreDepartment:
      'AdminStores_DeleteUserStoreDepartment',
    AdminStores_UpdateUser: 'AdminStores_UpdateUser',
    VendorsView_UpdateVendor: 'VendorsView_UpdateVendor',
    VendorsView_CreateVendor: 'VendorsView_CreateVendor',
    Retail_BulkUpdateStoreDepartments: 'Retail_BulkUpdateStoreDepartments',
    Retail_BulkAddStoreDepartment: 'Retail_BulkAddStoreDepartment',
    APIntegrations_MapIntegrationRecords:
      'APIntegrations_MapIntegrationRecords',
    Retail_UpdateStoreProduct: 'Retail_UpdateStoreProduct',
    BackOfficeProductManagement_BulkUpdateStoreProducts:
      'BackOfficeProductManagement_BulkUpdateStoreProducts',
    Retail_AddStoreProduct: 'Retail_AddStoreProduct',
    BulkUploadStoreVendorProductsWorker: 'BulkUploadStoreVendorProductsWorker',
    BackOfficeProductManagement_Export: 'BackOfficeProductManagement_Export',
    BackOfficeTaxManagement_AddTaxRate: 'BackOfficeTaxManagement_AddTaxRate',
    BackOfficeTaxManagement_UpdateTaxRate:
      'BackOfficeTaxManagement_UpdateTaxRate',
    BackOfficeVendorManagement_CreateVendor:
      'BackOfficeVendorManagement_CreateVendor',
    BackOfficeVendorManagement_UpdateVendor:
      'BackOfficeVendorManagement_UpdateVendor',
  },
  Fragment: {
    ProductsCatalog_VendorProductCatalogFields:
      'ProductsCatalog_VendorProductCatalogFields',
    ProductsCatalog_RetailersStoresFromBannerFields:
      'ProductsCatalog_RetailersStoresFromBannerFields',
    ProductsCatalog_RetailerSelectStoreFields:
      'ProductsCatalog_RetailerSelectStoreFields',
    ProductsCatalog_RetailerSelectBannerFields:
      'ProductsCatalog_RetailerSelectBannerFields',
    ProductsCatalog_AdminVendorFields: 'ProductsCatalog_AdminVendorFields',
    RetailBuyers_BuyerUserStoreDepartmentFields:
      'RetailBuyers_BuyerUserStoreDepartmentFields',
    RetailBuyers_BuyerFields: 'RetailBuyers_BuyerFields',
    RetailVendorCatalog_OrderGuideCatalogFields:
      'RetailVendorCatalog_OrderGuideCatalogFields',
    RetailVendorCatalog_VendorCatalogProductFields:
      'RetailVendorCatalog_VendorCatalogProductFields',
    RetailVendorCatalog_VendorCatalogFields:
      'RetailVendorCatalog_VendorCatalogFields',
    RetailBulkAction_StoreDepartmentsFields:
      'RetailBulkAction_StoreDepartmentsFields',
    RetailHome_StoreFields: 'RetailHome_StoreFields',
    RetailOrders_OrderLineItemFields: 'RetailOrders_OrderLineItemFields',
    RetailOrders_OrderProductFields: 'RetailOrders_OrderProductFields',
    RetailOrders_OrderFields: 'RetailOrders_OrderFields',
    RetailOrders_OrderStoreFields: 'RetailOrders_OrderStoreFields',
    RetailOrders_OrderVendorFields: 'RetailOrders_OrderVendorFields',
    RetailStores_StoreBuyerFields: 'RetailStores_StoreBuyerFields',
    RetailStores_StoreFields: 'RetailStores_StoreFields',
    RetailDepartment_DepartmentVendorFields:
      'RetailDepartment_DepartmentVendorFields',
    RetailDepartment_VendorStoreDepartmentAccountFields:
      'RetailDepartment_VendorStoreDepartmentAccountFields',
    RetailDepartment_DepartmentOrderFields:
      'RetailDepartment_DepartmentOrderFields',
    RetailOrderGuides_VendorProductFields:
      'RetailOrderGuides_VendorProductFields',
    VendorCustomers_VendorStoreDepartmentAccountFields:
      'VendorCustomers_VendorStoreDepartmentAccountFields',
    VendorOrders_MisscanLineItemFields: 'VendorOrders_MisscanLineItemFields',
    VendorOrders_OrderLineItemFields: 'VendorOrders_OrderLineItemFields',
    VendorOrders_ProductFields: 'VendorOrders_ProductFields',
    VendorOrders_OrderFields: 'VendorOrders_OrderFields',
    VendorOrders_StoreFields: 'VendorOrders_StoreFields',
    VendorProfile_ProfileFields: 'VendorProfile_ProfileFields',
    VendorPromotions_AudienceFields: 'VendorPromotions_AudienceFields',
    VendorPromotions_DealVendorProductFields:
      'VendorPromotions_DealVendorProductFields',
    VendorPromotions_DealFields: 'VendorPromotions_DealFields',
    VendorPromotions_PromotionItemFields:
      'VendorPromotions_PromotionItemFields',
    VendorPromotions_PromotionDetailFields:
      'VendorPromotions_PromotionDetailFields',
    VendorPromotions_PromotionConflictFields:
      'VendorPromotions_PromotionConflictFields',
    AdminBanners_BannerFields: 'AdminBanners_BannerFields',
    AdminContainer_UserDetails: 'AdminContainer_UserDetails',
    AdminStores_StoreDetailsFields: 'AdminStores_StoreDetailsFields',
    AdminStores_StoreDepartmentDetails: 'AdminStores_StoreDepartmentDetails',
    AdminStores_VendorStoreDepartmentAccountDetails:
      'AdminStores_VendorStoreDepartmentAccountDetails',
    VendorDetails: 'VendorDetails',
    Retail_StoreProduct: 'Retail_StoreProduct',
  },
}
export type CommonGetStoreDepartmentsForAutocompleteQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type CommonGetStoreDepartmentsForAutocompleteQuery = {
  __typename?: 'Query'
  getStoreDepartmentsByStoreID?:
    | Array<
        | {
            __typename?: 'StoreDepartment'
            id: string
            name: string
            imageURL?: string | null | undefined
            store: {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
            }
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type AdminFiltersGetPaginatedStoresQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type AdminFiltersGetPaginatedStoresQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    totalCount: number
    cursor: string
    hasMore: boolean
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
    }>
  }
}

export type AdminFiltersGetPaginatedUsersQueryVariables = Exact<{
  companyID?: InputMaybe<Scalars['String']>
  userTypes?: InputMaybe<Array<UserType> | UserType>
}>

export type AdminFiltersGetPaginatedUsersQuery = {
  __typename?: 'Query'
  adminAllUsers: {
    __typename?: 'UsersResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'User'
      id: string
      displayName?: string | null | undefined
      email?: string | null | undefined
      userType?: UserType | null | undefined
      retailUser?:
        | {
            __typename?: 'RetailUser'
            user: { __typename?: 'User'; id: string }
            retailCompany: {
              __typename?: 'RetailCompany'
              id: string
              name?: string | null | undefined
            }
          }
        | null
        | undefined
      vendorUser?:
        | {
            __typename?: 'VendorUser'
            vendor: {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          }
        | null
        | undefined
    }>
  }
}

export type AppGetCurrentUserQueryVariables = Exact<{
  gatedFeatures?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type AppGetCurrentUserQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userSqlID?: string | null | undefined
          companyImageURL?: string | null | undefined
          displayName?: string | null | undefined
          email?: string | null | undefined
          userType?: UserType | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                  status: VendorStatus
                  imgURL?: string | null | undefined
                  defaultOrderSubmissionMethod: SubmissionMethod
                }
              }
            | null
            | undefined
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  name?: string | null | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        address?: string | null | undefined
                        id: string
                        imageURL?: string | null | undefined
                        local_iana_timezone?: string | null | undefined
                        supports_wic: boolean
                        name?: string | null | undefined
                        serialID?: string | null | undefined
                        addressComponents?:
                          | {
                              __typename?: 'AddressComponents'
                              addressLine1?: string | null | undefined
                              addressLine2?: string | null | undefined
                            }
                          | null
                          | undefined
                        banner?:
                          | {
                              __typename?: 'Banner'
                              name?: string | null | undefined
                              id: string
                              imageURL?: string | null | undefined
                            }
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        name?: string | null | undefined
                        imageURL?: string | null | undefined
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            address?: string | null | undefined
                            id: string
                            imageURL?: string | null | undefined
                            local_iana_timezone?: string | null | undefined
                            name?: string | null | undefined
                            serialID?: string | null | undefined
                            supports_wic: boolean
                            addressComponents?:
                              | {
                                  __typename?: 'AddressComponents'
                                  addressLine1?: string | null | undefined
                                  addressLine2?: string | null | undefined
                                }
                              | null
                              | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
          canSeeFeatures: {
            __typename?: 'UserCanSeeFeaturesResult'
            enabledFeatures: Array<string>
          }
        }
      }
    | null
    | undefined
}

export type AppGetCurrentUserStoreDepartmentsQueryVariables = Exact<{
  [key: string]: never
}>

export type AppGetCurrentUserStoreDepartmentsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          storeDepartments: {
            __typename?: 'StoreDepartmentsResult'
            nodes: Array<{
              __typename?: 'StoreDepartment'
              deactivatedAt?: any | null | undefined
              id: string
              name: string
              imageURL?: string | null | undefined
              parentDepartment?:
                | { __typename?: 'StoreDepartment'; id: string }
                | null
                | undefined
              store: {
                __typename?: 'Store'
                id: string
                name?: string | null | undefined
                serialID?: string | null | undefined
              }
            }>
          }
        }
      }
    | null
    | undefined
}

export type PaymentsCreatePlaidLinkTokenMutationVariables = Exact<{
  clientUserID: Scalars['String']
}>

export type PaymentsCreatePlaidLinkTokenMutation = {
  __typename?: 'Mutation'
  createPlaidLinkToken: {
    __typename?: 'PlaidLinkTokenResponse'
    expiration: Date | string
    plaidLinkToken: string
    requestID: string
  }
}

export type PaymentsCreateStripeBankAccountTokenMutationVariables = Exact<{
  plaidAccountID: Scalars['String']
  plaidPublicToken: Scalars['String']
}>

export type PaymentsCreateStripeBankAccountTokenMutation = {
  __typename?: 'Mutation'
  createStripeBankAccountToken: {
    __typename?: 'StripeBankAccountTokenResponse'
    requestID: string
    stripeBankAccountToken: string
  }
}

export type PaymentsCreatePaymentProfileMutationVariables = Exact<{
  bannerID?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  name: Scalars['String']
  paymentMethodType: PaymentMethodType
  stripeBankAccountTokenID?: InputMaybe<Scalars['String']>
  stripeCardTokenID?: InputMaybe<Scalars['String']>
  storeID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}>

export type PaymentsCreatePaymentProfileMutation = {
  __typename?: 'Mutation'
  createPaymentProfile: {
    __typename?: 'PaymentProfile'
    bannerID?: string | null | undefined
    email: string
    id: string
    storeID?: string | null | undefined
    stripeCustomerID: string
    vendorID?: string | null | undefined
    paymentMethods: Array<{
      __typename?: 'PaymentMethod'
      accountHolderName?: string | null | undefined
      accountHolderType?: string | null | undefined
      bankName?: string | null | undefined
      brand?: string | null | undefined
      expMonth?: number | null | undefined
      expYear?: number | null | undefined
      last4: string
      paymentMethodType: PaymentMethodType
      routingNumber?: string | null | undefined
      stripeID: string
    }>
  }
}

export type PaymentsGetCurrentVendorAdminInfoQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type PaymentsGetCurrentVendorAdminInfoQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        imgURL?: string | null | undefined
      }
    | null
    | undefined
}

export type PaymentsGetCurrentBannerAdminInfoQueryVariables = Exact<{
  bannerID: Scalars['ID']
}>

export type PaymentsGetCurrentBannerAdminInfoQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        id: string
        name?: string | null | undefined
        imageURL?: string | null | undefined
      }
    | null
    | undefined
}

export type PaymentsGetCurrentStoreAdminInfoQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type PaymentsGetCurrentStoreAdminInfoQuery = {
  __typename?: 'Query'
  storeByID?:
    | { __typename?: 'Store'; id: string; name?: string | null | undefined }
    | null
    | undefined
}

export type PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type PaymentsGetCurrentLoggedInStoreAdminInfoQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  name?: string | null | undefined
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        imageURL?: string | null | undefined
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ProductsCatalogVendorProductCatalogFieldsFragment = {
  __typename?: 'VendorProduct'
  caseSize?: number | null | undefined
  id: string
  itemCode?: string | null | undefined
  notes?: string | null | undefined
  isPrivateLabelProduct: boolean
  status: VendorProductStatus
  updatedAt?: Date | string | null | undefined
  wholesalePricing: {
    __typename?: 'PricingInfo'
    casePrice?: number | null | undefined
    unitPrice?: number | null | undefined
  }
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    caseUPC?: string | null | undefined
    category?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    packUPC?: string | null | undefined
    unitUPC?: string | null | undefined
    unitVolume?: string | null | undefined
  }
  stores?:
    | Array<
        | {
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
            banner?:
              | {
                  __typename?: 'Banner'
                  id: string
                  name?: string | null | undefined
                  stores: {
                    __typename?: 'BannerStoresResult'
                    nodes: Array<{
                      __typename?: 'Store'
                      id: string
                      name?: string | null | undefined
                      banner?:
                        | { __typename?: 'Banner'; id: string }
                        | null
                        | undefined
                    }>
                  }
                }
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
  vendor?:
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
  allRetailerPricing: Array<{
    __typename?: 'RetailerPricingInfo'
    retailCompany: {
      __typename?: 'RetailCompany'
      id: string
      name?: string | null | undefined
    }
    pricing: {
      __typename?: 'PricingInfo'
      casePrice?: number | null | undefined
      unitPrice?: number | null | undefined
    }
  }>
  retailerDiscontinuedDates?:
    | Array<{
        __typename?: 'RetailerDiscontinuedDate'
        date?: Date | string | null | undefined
        retailCompany: {
          __typename?: 'RetailCompany'
          id: string
          name?: string | null | undefined
        }
      }>
    | null
    | undefined
}

export type ProductsCatalogRetailersStoresFromBannerFieldsFragment = {
  __typename?: 'Store'
  id: string
  name?: string | null | undefined
  banner?:
    | {
        __typename?: 'Banner'
        id: string
        name?: string | null | undefined
        stores: {
          __typename?: 'BannerStoresResult'
          nodes: Array<{
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
            banner?: { __typename?: 'Banner'; id: string } | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type ProductsCatalogRetailerSelectStoreFieldsFragment = {
  __typename?: 'Store'
  id: string
  name?: string | null | undefined
  banner?: { __typename?: 'Banner'; id: string } | null | undefined
}

export type ProductsCatalogRetailerSelectBannerFieldsFragment = {
  __typename?: 'Banner'
  id: string
  name?: string | null | undefined
  stores: {
    __typename?: 'BannerStoresResult'
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      banner?: { __typename?: 'Banner'; id: string } | null | undefined
    }>
  }
}

export type ProductsCatalogAdminVendorFieldsFragment = {
  __typename?: 'Vendor'
  id: string
  name?: string | null | undefined
}

export type ProductsCatalogCreateVendorProductMutationVariables = Exact<{
  accountSpecificCasePrice?: InputMaybe<
    Array<AccountSpecificPriceInput> | AccountSpecificPriceInput
  >
  accountSpecificUnitPrice?: InputMaybe<
    Array<AccountSpecificPriceInput> | AccountSpecificPriceInput
  >
  brand?: InputMaybe<Scalars['String']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  imgURLFile?: InputMaybe<Scalars['Upload']>
  imgURL?: InputMaybe<Scalars['String']>
  itemCode: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  privateLabelProductBannerIDs?: InputMaybe<
    Array<Scalars['ID']> | Scalars['ID']
  >
  privateLabelProductStoreIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  status?: InputMaybe<VendorProductStatus>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
  wholesaleCasePrice?: InputMaybe<Scalars['Currency']>
  wholesaleUnitPrice?: InputMaybe<Scalars['Currency']>
}>

export type ProductsCatalogCreateVendorProductMutation = {
  __typename?: 'Mutation'
  createVendorProduct: {
    __typename?: 'VendorProduct'
    caseSize?: number | null | undefined
    id: string
    itemCode?: string | null | undefined
    notes?: string | null | undefined
    isPrivateLabelProduct: boolean
    status: VendorProductStatus
    updatedAt?: Date | string | null | undefined
    wholesalePricing: {
      __typename?: 'PricingInfo'
      casePrice?: number | null | undefined
      unitPrice?: number | null | undefined
    }
    product: {
      __typename?: 'Product'
      brandName?: string | null | undefined
      caseUPC?: string | null | undefined
      category?: string | null | undefined
      description?: string | null | undefined
      id: string
      imgURL?: string | null | undefined
      packUPC?: string | null | undefined
      unitUPC?: string | null | undefined
      unitVolume?: string | null | undefined
    }
    stores?:
      | Array<
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
              banner?:
                | {
                    __typename?: 'Banner'
                    id: string
                    name?: string | null | undefined
                    stores: {
                      __typename?: 'BannerStoresResult'
                      nodes: Array<{
                        __typename?: 'Store'
                        id: string
                        name?: string | null | undefined
                        banner?:
                          | { __typename?: 'Banner'; id: string }
                          | null
                          | undefined
                      }>
                    }
                  }
                | null
                | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
    vendor?:
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    allRetailerPricing: Array<{
      __typename?: 'RetailerPricingInfo'
      retailCompany: {
        __typename?: 'RetailCompany'
        id: string
        name?: string | null | undefined
      }
      pricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
    }>
    retailerDiscontinuedDates?:
      | Array<{
          __typename?: 'RetailerDiscontinuedDate'
          date?: Date | string | null | undefined
          retailCompany: {
            __typename?: 'RetailCompany'
            id: string
            name?: string | null | undefined
          }
        }>
      | null
      | undefined
  }
}

export type ProductsCatalogUpdateVendorProductMutationVariables = Exact<{
  accountSpecificCasePrice?: InputMaybe<
    Array<AccountSpecificPriceInput> | AccountSpecificPriceInput
  >
  accountSpecificUnitPrice?: InputMaybe<
    Array<AccountSpecificPriceInput> | AccountSpecificPriceInput
  >
  brand?: InputMaybe<Scalars['String']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  imgURL?: InputMaybe<Scalars['String']>
  itemCode?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  privateLabelProductBannerIDs?: InputMaybe<
    Array<Scalars['ID']> | Scalars['ID']
  >
  privateLabelProductStoreIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  productID: Scalars['ID']
  status?: InputMaybe<VendorProductStatus>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  wholesaleCasePrice?: InputMaybe<Scalars['Currency']>
  wholesaleUnitPrice?: InputMaybe<Scalars['Currency']>
}>

export type ProductsCatalogUpdateVendorProductMutation = {
  __typename?: 'Mutation'
  updateVendorProduct: {
    __typename?: 'VendorProduct'
    caseSize?: number | null | undefined
    id: string
    itemCode?: string | null | undefined
    notes?: string | null | undefined
    isPrivateLabelProduct: boolean
    status: VendorProductStatus
    updatedAt?: Date | string | null | undefined
    wholesalePricing: {
      __typename?: 'PricingInfo'
      casePrice?: number | null | undefined
      unitPrice?: number | null | undefined
    }
    product: {
      __typename?: 'Product'
      brandName?: string | null | undefined
      caseUPC?: string | null | undefined
      category?: string | null | undefined
      description?: string | null | undefined
      id: string
      imgURL?: string | null | undefined
      packUPC?: string | null | undefined
      unitUPC?: string | null | undefined
      unitVolume?: string | null | undefined
    }
    stores?:
      | Array<
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
              banner?:
                | {
                    __typename?: 'Banner'
                    id: string
                    name?: string | null | undefined
                    stores: {
                      __typename?: 'BannerStoresResult'
                      nodes: Array<{
                        __typename?: 'Store'
                        id: string
                        name?: string | null | undefined
                        banner?:
                          | { __typename?: 'Banner'; id: string }
                          | null
                          | undefined
                      }>
                    }
                  }
                | null
                | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
    vendor?:
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    allRetailerPricing: Array<{
      __typename?: 'RetailerPricingInfo'
      retailCompany: {
        __typename?: 'RetailCompany'
        id: string
        name?: string | null | undefined
      }
      pricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
    }>
    retailerDiscontinuedDates?:
      | Array<{
          __typename?: 'RetailerDiscontinuedDate'
          date?: Date | string | null | undefined
          retailCompany: {
            __typename?: 'RetailCompany'
            id: string
            name?: string | null | undefined
          }
        }>
      | null
      | undefined
  }
}

export type ProductsCatalogBulkUpdateVendorProductsMutationVariables = Exact<{
  vendorProducts: Array<UpdateVendorProductInput> | UpdateVendorProductInput
}>

export type ProductsCatalogBulkUpdateVendorProductsMutation = {
  __typename?: 'Mutation'
  bulkUpdateVendorProducts: {
    __typename?: 'BulkUpdateVendorProductsResult'
    nodes: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      notes?: string | null | undefined
      isPrivateLabelProduct: boolean
      status: VendorProductStatus
      updatedAt?: Date | string | null | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        brandName?: string | null | undefined
        caseUPC?: string | null | undefined
        category?: string | null | undefined
        description?: string | null | undefined
        id: string
        imgURL?: string | null | undefined
        packUPC?: string | null | undefined
        unitUPC?: string | null | undefined
        unitVolume?: string | null | undefined
      }
      stores?:
        | Array<
            | {
                __typename?: 'Store'
                id: string
                name?: string | null | undefined
                banner?:
                  | {
                      __typename?: 'Banner'
                      id: string
                      name?: string | null | undefined
                      stores: {
                        __typename?: 'BannerStoresResult'
                        nodes: Array<{
                          __typename?: 'Store'
                          id: string
                          name?: string | null | undefined
                          banner?:
                            | { __typename?: 'Banner'; id: string }
                            | null
                            | undefined
                        }>
                      }
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          >
        | null
        | undefined
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
      allRetailerPricing: Array<{
        __typename?: 'RetailerPricingInfo'
        retailCompany: {
          __typename?: 'RetailCompany'
          id: string
          name?: string | null | undefined
        }
        pricing: {
          __typename?: 'PricingInfo'
          casePrice?: number | null | undefined
          unitPrice?: number | null | undefined
        }
      }>
      retailerDiscontinuedDates?:
        | Array<{
            __typename?: 'RetailerDiscontinuedDate'
            date?: Date | string | null | undefined
            retailCompany: {
              __typename?: 'RetailCompany'
              id: string
              name?: string | null | undefined
            }
          }>
        | null
        | undefined
    }>
  }
}

export type ProductsCatalogDeleteVendorProductMutationVariables = Exact<{
  productID: Scalars['ID']
  vendorID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
}>

export type ProductsCatalogDeleteVendorProductMutation = {
  __typename?: 'Mutation'
  deleteVendorProduct: {
    __typename?: 'DeleteVendorProductResult'
    deletedProductID: string
  }
}

export type ProductsCatalogGetVendorProductsForCatalogQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  filterByBrand?: InputMaybe<Scalars['String']>
  filterByCategory?: InputMaybe<Scalars['String']>
  filterByCustomPricing?: InputMaybe<Scalars['Boolean']>
  filterByPrivateLabel?: InputMaybe<Scalars['Boolean']>
  filterByRetailerIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  filterByStatus?: InputMaybe<Array<VendorProductStatus> | VendorProductStatus>
  search?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['ID']>
}>

export type ProductsCatalogGetVendorProductsForCatalogQuery = {
  __typename?: 'Query'
  vendorProducts: {
    __typename?: 'VendorProductsResult'
    cursor?: string | null | undefined
    hasMore?: boolean | null | undefined
    nodes: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      notes?: string | null | undefined
      isPrivateLabelProduct: boolean
      status: VendorProductStatus
      updatedAt?: Date | string | null | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        brandName?: string | null | undefined
        caseUPC?: string | null | undefined
        category?: string | null | undefined
        description?: string | null | undefined
        id: string
        imgURL?: string | null | undefined
        packUPC?: string | null | undefined
        unitUPC?: string | null | undefined
        unitVolume?: string | null | undefined
      }
      stores?:
        | Array<
            | {
                __typename?: 'Store'
                id: string
                name?: string | null | undefined
                banner?:
                  | {
                      __typename?: 'Banner'
                      id: string
                      name?: string | null | undefined
                      stores: {
                        __typename?: 'BannerStoresResult'
                        nodes: Array<{
                          __typename?: 'Store'
                          id: string
                          name?: string | null | undefined
                          banner?:
                            | { __typename?: 'Banner'; id: string }
                            | null
                            | undefined
                        }>
                      }
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          >
        | null
        | undefined
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
      allRetailerPricing: Array<{
        __typename?: 'RetailerPricingInfo'
        retailCompany: {
          __typename?: 'RetailCompany'
          id: string
          name?: string | null | undefined
        }
        pricing: {
          __typename?: 'PricingInfo'
          casePrice?: number | null | undefined
          unitPrice?: number | null | undefined
        }
      }>
      retailerDiscontinuedDates?:
        | Array<{
            __typename?: 'RetailerDiscontinuedDate'
            date?: Date | string | null | undefined
            retailCompany: {
              __typename?: 'RetailCompany'
              id: string
              name?: string | null | undefined
            }
          }>
        | null
        | undefined
    }>
  }
}

export type ProductsCatalogGetVendorProductForCatalogQueryVariables = Exact<{
  id: Scalars['String']
  storeID?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
}>

export type ProductsCatalogGetVendorProductForCatalogQuery = {
  __typename?: 'Query'
  vendorProductByID?:
    | {
        __typename?: 'VendorProduct'
        caseSize?: number | null | undefined
        id: string
        itemCode?: string | null | undefined
        notes?: string | null | undefined
        isPrivateLabelProduct: boolean
        status: VendorProductStatus
        updatedAt?: Date | string | null | undefined
        wholesalePricing: {
          __typename?: 'PricingInfo'
          casePrice?: number | null | undefined
          unitPrice?: number | null | undefined
        }
        product: {
          __typename?: 'Product'
          brandName?: string | null | undefined
          caseUPC?: string | null | undefined
          category?: string | null | undefined
          description?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          packUPC?: string | null | undefined
          unitUPC?: string | null | undefined
          unitVolume?: string | null | undefined
        }
        stores?:
          | Array<
              | {
                  __typename?: 'Store'
                  id: string
                  name?: string | null | undefined
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        name?: string | null | undefined
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            banner?:
                              | { __typename?: 'Banner'; id: string }
                              | null
                              | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        vendor?:
          | {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        allRetailerPricing: Array<{
          __typename?: 'RetailerPricingInfo'
          retailCompany: {
            __typename?: 'RetailCompany'
            id: string
            name?: string | null | undefined
          }
          pricing: {
            __typename?: 'PricingInfo'
            casePrice?: number | null | undefined
            unitPrice?: number | null | undefined
          }
        }>
        retailerDiscontinuedDates?:
          | Array<{
              __typename?: 'RetailerDiscontinuedDate'
              date?: Date | string | null | undefined
              retailCompany: {
                __typename?: 'RetailCompany'
                id: string
                name?: string | null | undefined
              }
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type ProductsCatalogGetVendorBrandsQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetVendorBrandsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  vendorBrands: {
                    __typename?: 'VendorBrandsResult'
                    nodes: Array<string>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ProductsCatalogGetVendorCategoriesQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetVendorCategoriesQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  vendorCategories: {
                    __typename?: 'VendorCategoriesResult'
                    nodes: Array<string>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ProductsCatalogGetVendorCatalogMetadataQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetVendorCatalogMetadataQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  lastVendorProductUpdate?: Date | string | null | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables = Exact<{
  ID: Scalars['ID']
}>

export type ProductsCatalogGetVendorCatalogMetadataByIdQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        lastVendorProductUpdate?: Date | string | null | undefined
      }
    | null
    | undefined
}

export type ProductsCatalogGetVendorCatalogDownloadUrlMutationVariables =
  Exact<{
    vendorID: Scalars['String']
  }>

export type ProductsCatalogGetVendorCatalogDownloadUrlMutation = {
  __typename?: 'Mutation'
  exportVendorCatalogToCSV: string
}

export type ProductsCatalogGetAdminAllRetailersQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetAdminAllRetailersQuery = {
  __typename?: 'Query'
  adminAllBanners: {
    __typename?: 'BannersResult'
    nodes: Array<{
      __typename?: 'Banner'
      id: string
      name?: string | null | undefined
      stores: {
        __typename?: 'BannerStoresResult'
        nodes: Array<{
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
          banner?: { __typename?: 'Banner'; id: string } | null | undefined
        }>
      }
    }>
  }
  adminAllStores: {
    __typename?: 'StoresResult'
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      banner?: { __typename?: 'Banner'; id: string } | null | undefined
    }>
  }
}

export type ProductsCatalogGetVendorAllRetailersQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetVendorAllRetailersQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  storeAccounts: {
                    __typename?: 'VendorStoreAccountsResult'
                    nodes: Array<{
                      __typename?: 'VendorStoreAccount'
                      store?:
                        | {
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            banner?:
                              | {
                                  __typename?: 'Banner'
                                  id: string
                                  name?: string | null | undefined
                                  stores: {
                                    __typename?: 'BannerStoresResult'
                                    nodes: Array<{
                                      __typename?: 'Store'
                                      id: string
                                      name?: string | null | undefined
                                      banner?:
                                        | { __typename?: 'Banner'; id: string }
                                        | null
                                        | undefined
                                    }>
                                  }
                                }
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                    }>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ProductsCatalogGetRetailAllRetailersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  search?: InputMaybe<Scalars['String']>
}>

export type ProductsCatalogGetRetailAllRetailersQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        imageURL?: string | null | undefined
                        stores: {
                          __typename?: 'BannerStoresResult'
                          cursor?: string | null | undefined
                          hasMore: boolean
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            imageURL?: string | null | undefined
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        imageURL?: string | null | undefined
                        name?: string | null | undefined
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type ProductsCatalogGetAdminAllStoresQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetAdminAllStoresQuery = {
  __typename?: 'Query'
  adminAllStores: {
    __typename?: 'StoresResult'
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      banner?: { __typename?: 'Banner'; id: string } | null | undefined
    }>
  }
}

export type ProductsCatalogGetAdminAllVendorsQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductsCatalogGetAdminAllVendorsQuery = {
  __typename?: 'Query'
  adminAllVendors: {
    __typename?: 'VendorsResult'
    nodes: Array<{
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
    }>
  }
}

export type ProductsCatalogGetCsvUploadLogsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  filterByVendorID?: InputMaybe<Scalars['String']>
}>

export type ProductsCatalogGetCsvUploadLogsQuery = {
  __typename?: 'Query'
  getCSVUploadLogs: {
    __typename?: 'GetCSVUploadLogsResult'
    cursor?: string | null | undefined
    hasMore: boolean
    nodes: Array<{
      __typename?: 'CSVUploadLog'
      id: string
      additions: number
      overwrites: number
      progress: number
      rowCount: number
      spreadsheetURL?: string | null | undefined
      status: CsvUploadLogStatus
      type?: CsvUploadLogType | null | undefined
      uploadedOn: Date | string
      retailAccounts: Array<{
        __typename?: 'RetailCompany'
        id: string
        name?: string | null | undefined
      }>
      uploadedBy?:
        | {
            __typename?: 'User'
            id: string
            email?: string | null | undefined
            displayName?: string | null | undefined
          }
        | null
        | undefined
      vendors: Array<{
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
      }>
    }>
  }
}

export type ProductsCatalogGetCsvUploadLogByIdQueryVariables = Exact<{
  ID: Scalars['ID']
}>

export type ProductsCatalogGetCsvUploadLogByIdQuery = {
  __typename?: 'Query'
  getCSVUploadLogByID?:
    | {
        __typename?: 'CSVUploadLog'
        id: string
        additions: number
        overwrites: number
        progress: number
        rowCount: number
        spreadsheetURL?: string | null | undefined
        status: CsvUploadLogStatus
        type?: CsvUploadLogType | null | undefined
        uploadedOn: Date | string
        retailAccounts: Array<{
          __typename?: 'RetailCompany'
          id: string
          name?: string | null | undefined
        }>
        uploadedBy?:
          | {
              __typename?: 'User'
              id: string
              email?: string | null | undefined
              displayName?: string | null | undefined
            }
          | null
          | undefined
        vendors: Array<{
          __typename?: 'Vendor'
          id: string
          name?: string | null | undefined
        }>
      }
    | null
    | undefined
}

export type ProductsCatalogGetMatchingVendorProductsQueryVariables = Exact<{
  itemCode?: InputMaybe<Scalars['String']>
  UPC?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}>

export type ProductsCatalogGetMatchingVendorProductsQuery = {
  __typename?: 'Query'
  getMatchingVendorProducts: {
    __typename?: 'GetMatchingVendorProductsResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'MatchingVendorProduct'
      matchedBy: MatchingVendorProductReason
      vendorProduct: {
        __typename?: 'VendorProduct'
        id: string
        itemCode?: string | null | undefined
        product: {
          __typename?: 'Product'
          brandName?: string | null | undefined
          description?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          unitUPC?: string | null | undefined
        }
      }
    }>
  }
}

export type RetailBuyersBuyerUserStoreDepartmentFieldsFragment = {
  __typename?: 'UserStoreDepartment'
  id: string
  storeDepartment: {
    __typename?: 'StoreDepartment'
    id: string
    name: string
    storeID: string
  }
}

export type RetailBuyersBuyerFieldsFragment = {
  __typename?: 'RetailUser'
  user: {
    __typename?: 'User'
    displayName?: string | null | undefined
    id: string
    email?: string | null | undefined
    defaultDepartmentName?: string | null | undefined
    retailUser?:
      | {
          __typename?: 'RetailUser'
          readOnlyOrderGuides?: boolean | null | undefined
          weeklyOrderSpending: number
          user: { __typename?: 'User'; id: string }
          weeklyOrders: Array<{ __typename?: 'Order'; id: string }>
        }
      | null
      | undefined
  }
}

export type RetailBuyersCreateBuyerAccountMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  password: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
  defaultDepartmentName?: InputMaybe<Scalars['String']>
}>

export type RetailBuyersCreateBuyerAccountMutation = {
  __typename?: 'Mutation'
  createBuyerAccount: {
    __typename?: 'RetailUser'
    user: {
      __typename?: 'User'
      displayName?: string | null | undefined
      id: string
      email?: string | null | undefined
      defaultDepartmentName?: string | null | undefined
      retailUser?:
        | {
            __typename?: 'RetailUser'
            readOnlyOrderGuides?: boolean | null | undefined
            weeklyOrderSpending: number
            user: { __typename?: 'User'; id: string }
            weeklyOrders: Array<{ __typename?: 'Order'; id: string }>
          }
        | null
        | undefined
    }
  }
}

export type RetailBuyersUpdateBuyerProfileMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
  defaultDepartmentName?: InputMaybe<Scalars['String']>
}>

export type RetailBuyersUpdateBuyerProfileMutation = {
  __typename?: 'Mutation'
  updateBuyerProfile: {
    __typename?: 'RetailUser'
    user: {
      __typename?: 'User'
      displayName?: string | null | undefined
      id: string
      email?: string | null | undefined
      defaultDepartmentName?: string | null | undefined
      retailUser?:
        | {
            __typename?: 'RetailUser'
            readOnlyOrderGuides?: boolean | null | undefined
            weeklyOrderSpending: number
            user: { __typename?: 'User'; id: string }
            weeklyOrders: Array<{ __typename?: 'Order'; id: string }>
          }
        | null
        | undefined
    }
  }
}

export type RetailBuyersAddBuyerToStoreDepartmentMutationVariables = Exact<{
  storeDepartmentID: Scalars['ID']
  userID: Scalars['ID']
}>

export type RetailBuyersAddBuyerToStoreDepartmentMutation = {
  __typename?: 'Mutation'
  createUserStoreDepartment: {
    __typename?: 'UserStoreDepartment'
    id: string
    user: {
      __typename?: 'User'
      id: string
      retailUser?:
        | {
            __typename?: 'RetailUser'
            user: { __typename?: 'User'; id: string }
            userStoreDepartments: {
              __typename?: 'UserStoreDepartmentsResult'
              nodes: Array<{
                __typename?: 'UserStoreDepartment'
                id: string
                storeDepartment: {
                  __typename?: 'StoreDepartment'
                  id: string
                  name: string
                  storeID: string
                }
              }>
            }
          }
        | null
        | undefined
    }
  }
}

export type RetailBuyersRemoveBuyerFromStoreDepartmentMutationVariables =
  Exact<{
    userStoreDepartmentID: Scalars['ID']
  }>

export type RetailBuyersRemoveBuyerFromStoreDepartmentMutation = {
  __typename?: 'Mutation'
  deleteUserStoreDepartment: {
    __typename?: 'UserStoreDepartment'
    id: string
    user: {
      __typename?: 'User'
      id: string
      retailUser?:
        | {
            __typename?: 'RetailUser'
            user: { __typename?: 'User'; id: string }
            userStoreDepartments: {
              __typename?: 'UserStoreDepartmentsResult'
              nodes: Array<{
                __typename?: 'UserStoreDepartment'
                id: string
                storeDepartment: {
                  __typename?: 'StoreDepartment'
                  id: string
                  name: string
                  storeID: string
                }
              }>
            }
          }
        | null
        | undefined
    }
  }
}

export type RetailBuyersGetRetailUserByIdQueryVariables = Exact<{
  storeID: Scalars['ID']
  userID: Scalars['ID']
}>

export type RetailBuyersGetRetailUserByIdQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
        retailUserByID?:
          | {
              __typename?: 'RetailUser'
              user: {
                __typename?: 'User'
                id: string
                displayName?: string | null | undefined
              }
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type RetailBuyersGetStoreBuyersQueryVariables = Exact<{
  storeID: Scalars['ID']
  query?: InputMaybe<Scalars['String']>
}>

export type RetailBuyersGetStoreBuyersQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        address?: string | null | undefined
        id: string
        name?: string | null | undefined
        retailUsers: {
          __typename?: 'RetailUsersResult'
          nodes: Array<{
            __typename?: 'RetailUser'
            user: {
              __typename?: 'User'
              displayName?: string | null | undefined
              id: string
              email?: string | null | undefined
              defaultDepartmentName?: string | null | undefined
              retailUser?:
                | {
                    __typename?: 'RetailUser'
                    readOnlyOrderGuides?: boolean | null | undefined
                    weeklyOrderSpending: number
                    user: { __typename?: 'User'; id: string }
                    weeklyOrders: Array<{ __typename?: 'Order'; id: string }>
                  }
                | null
                | undefined
            }
          }>
        }
      }
    | null
    | undefined
}

export type RetailBuyersGetStoreDepartmentsQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type RetailBuyersGetStoreDepartmentsQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
            imageURL?: string | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogOrderGuideCatalogFieldsFragment = {
  __typename?: 'V2OrderGuide'
  id: string
  vendorStoreDepartmentAccount: {
    __typename?: 'VendorStoreDepartmentAccount'
    id: string
    storeDepartmentID: string
  }
}

export type RetailVendorCatalogVendorCatalogProductFieldsFragment = {
  __typename?: 'VendorProduct'
  caseSize?: number | null | undefined
  id: string
  itemCode?: string | null | undefined
  status: VendorProductStatus
  isPrivateLabelProduct: boolean
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    category?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    unitUPC?: string | null | undefined
    unitVolume?: string | null | undefined
  }
  stores?:
    | Array<
        | { __typename?: 'Store'; id: string; name?: string | null | undefined }
        | null
        | undefined
      >
    | null
    | undefined
  vendor?:
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
  orderGuides?:
    | {
        __typename?: 'VendorProductOrderGuidesResult'
        totalCount: number
        nodes: Array<{
          __typename?: 'V2OrderGuide'
          id: string
          vendorStoreDepartmentAccount: {
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            storeDepartmentID: string
          }
        }>
      }
    | null
    | undefined
  retailerPricing: {
    __typename?: 'PricingInfo'
    unitPrice?: number | null | undefined
    casePrice?: number | null | undefined
  }
  activeDeal?:
    | { __typename?: 'BuyXGetYFreeDeal'; id: string; displayName: string }
    | { __typename?: 'FixedDeal'; id: string; displayName: string }
    | { __typename?: 'PercentageDeal'; id: string; displayName: string }
    | null
    | undefined
  retailerDiscontinuedDates?:
    | Array<{
        __typename?: 'RetailerDiscontinuedDate'
        date?: Date | string | null | undefined
        retailCompany: {
          __typename?: 'RetailCompany'
          id: string
          name?: string | null | undefined
        }
      }>
    | null
    | undefined
}

export type RetailVendorCatalogVendorCatalogFieldsFragment = {
  __typename?: 'Vendor'
  id: string
  imgURL?: string | null | undefined
  name?: string | null | undefined
}

export type RetailVendorCatalogAddProductToOrderGuideMutationVariables = Exact<{
  vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
  storeDepartmentID: Scalars['ID']
}>

export type RetailVendorCatalogAddProductToOrderGuideMutation = {
  __typename?: 'Mutation'
  addProductsToV2OrderGuideForStoreDepartment: {
    __typename?: 'AddProductsToV2OrderGuideResult'
    addedVendorProducts: Array<{ __typename?: 'VendorProduct'; id: string }>
    orderGuide: {
      __typename?: 'V2OrderGuide'
      id: string
      vendorStoreDepartmentAccount: {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        storeDepartmentID: string
      }
    }
  }
}

export type RetailVendorCatalogRemoveProductFromOrderGuideMutationVariables =
  Exact<{
    vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
    storeDepartmentID: Scalars['ID']
  }>

export type RetailVendorCatalogRemoveProductFromOrderGuideMutation = {
  __typename?: 'Mutation'
  removeProductsFromV2OrderGuideForStoreDepartment: {
    __typename?: 'RemoveProductsFromV2OrderGuideResult'
    removedVendorProducts: Array<{ __typename?: 'VendorProduct'; id: string }>
    orderGuide: {
      __typename?: 'V2OrderGuide'
      id: string
      vendorStoreDepartmentAccount: {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        storeDepartmentID: string
      }
    }
  }
}

export type RetailVendorCatalogUpdateStoreVendorProductMutationVariables =
  Exact<{
    accountSpecificCasePrice?: InputMaybe<
      Array<AccountSpecificPriceInput> | AccountSpecificPriceInput
    >
    accountSpecificUnitPrice?: InputMaybe<
      Array<AccountSpecificPriceInput> | AccountSpecificPriceInput
    >
    bannerID: Scalars['ID']
    retailerDiscontinuedDates?: InputMaybe<
      Array<RetailerDiscontinuedDateInput> | RetailerDiscontinuedDateInput
    >
    productID: Scalars['ID']
  }>

export type RetailVendorCatalogUpdateStoreVendorProductMutation = {
  __typename?: 'Mutation'
  updateStoreVendorProduct: {
    __typename?: 'VendorProduct'
    caseSize?: number | null | undefined
    id: string
    itemCode?: string | null | undefined
    status: VendorProductStatus
    isPrivateLabelProduct: boolean
    allRetailerPricing: Array<{
      __typename?: 'RetailerPricingInfo'
      retailCompany: {
        __typename?: 'RetailCompany'
        id: string
        name?: string | null | undefined
      }
      pricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
    }>
    product: {
      __typename?: 'Product'
      brandName?: string | null | undefined
      category?: string | null | undefined
      description?: string | null | undefined
      id: string
      imgURL?: string | null | undefined
      unitUPC?: string | null | undefined
      unitVolume?: string | null | undefined
    }
    stores?:
      | Array<
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
    vendor?:
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    orderGuides?:
      | {
          __typename?: 'VendorProductOrderGuidesResult'
          totalCount: number
          nodes: Array<{
            __typename?: 'V2OrderGuide'
            id: string
            vendorStoreDepartmentAccount: {
              __typename?: 'VendorStoreDepartmentAccount'
              id: string
              storeDepartmentID: string
            }
          }>
        }
      | null
      | undefined
    retailerPricing: {
      __typename?: 'PricingInfo'
      unitPrice?: number | null | undefined
      casePrice?: number | null | undefined
    }
    activeDeal?:
      | { __typename?: 'BuyXGetYFreeDeal'; id: string; displayName: string }
      | { __typename?: 'FixedDeal'; id: string; displayName: string }
      | { __typename?: 'PercentageDeal'; id: string; displayName: string }
      | null
      | undefined
    retailerDiscontinuedDates?:
      | Array<{
          __typename?: 'RetailerDiscontinuedDate'
          date?: Date | string | null | undefined
          retailCompany: {
            __typename?: 'RetailCompany'
            id: string
            name?: string | null | undefined
          }
        }>
      | null
      | undefined
  }
}

export type RetailVendorCatalogGetAdminBannerBuyersQueryVariables = Exact<{
  [key: string]: never
}>

export type RetailVendorCatalogGetAdminBannerBuyersQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            retailUsers: {
                              __typename?: 'RetailUsersResult'
                              nodes: Array<{
                                __typename?: 'RetailUser'
                                user: {
                                  __typename?: 'User'
                                  id: string
                                  displayName?: string | null | undefined
                                }
                              }>
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetAllOrderGuidesQueryVariables = Exact<{
  [key: string]: never
}>

export type RetailVendorCatalogGetAllOrderGuidesQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            storeDepartments: {
                              __typename?: 'StoreDepartmentsResult'
                              nodes: Array<{
                                __typename?: 'StoreDepartment'
                                id: string
                                name: string
                              }>
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        name?: string | null | undefined
                        storeDepartments: {
                          __typename?: 'StoreDepartmentsResult'
                          nodes: Array<{
                            __typename?: 'StoreDepartment'
                            id: string
                            name: string
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetVendorProductsQueryVariables = Exact<{
  bannerID: Scalars['ID']
  cursor?: InputMaybe<Scalars['ID']>
  filterByBrand?: InputMaybe<Scalars['String']>
  filterByCategory?: InputMaybe<Scalars['String']>
  search?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}>

export type RetailVendorCatalogGetVendorProductsQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        catalogLastUpdatedAt?: Date | string | null | undefined
        hasVendorDashAccess: boolean
        vendorProducts: {
          __typename?: 'VendorProductsResult'
          cursor?: string | null | undefined
          hasMore?: boolean | null | undefined
          nodes: Array<{
            __typename?: 'VendorProduct'
            caseSize?: number | null | undefined
            id: string
            itemCode?: string | null | undefined
            status: VendorProductStatus
            isPrivateLabelProduct: boolean
            product: {
              __typename?: 'Product'
              brandName?: string | null | undefined
              category?: string | null | undefined
              description?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              unitUPC?: string | null | undefined
              unitVolume?: string | null | undefined
            }
            stores?:
              | Array<
                  | {
                      __typename?: 'Store'
                      id: string
                      name?: string | null | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
            vendor?:
              | {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
            orderGuides?:
              | {
                  __typename?: 'VendorProductOrderGuidesResult'
                  totalCount: number
                  nodes: Array<{
                    __typename?: 'V2OrderGuide'
                    id: string
                    vendorStoreDepartmentAccount: {
                      __typename?: 'VendorStoreDepartmentAccount'
                      id: string
                      storeDepartmentID: string
                    }
                  }>
                }
              | null
              | undefined
            retailerPricing: {
              __typename?: 'PricingInfo'
              unitPrice?: number | null | undefined
              casePrice?: number | null | undefined
            }
            activeDeal?:
              | {
                  __typename?: 'BuyXGetYFreeDeal'
                  id: string
                  displayName: string
                }
              | { __typename?: 'FixedDeal'; id: string; displayName: string }
              | {
                  __typename?: 'PercentageDeal'
                  id: string
                  displayName: string
                }
              | null
              | undefined
            retailerDiscontinuedDates?:
              | Array<{
                  __typename?: 'RetailerDiscontinuedDate'
                  date?: Date | string | null | undefined
                  retailCompany: {
                    __typename?: 'RetailCompany'
                    id: string
                    name?: string | null | undefined
                  }
                }>
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetVendorProductQueryVariables = Exact<{
  bannerID: Scalars['ID']
  id: Scalars['String']
  vendorID: Scalars['String']
}>

export type RetailVendorCatalogGetVendorProductQuery = {
  __typename?: 'Query'
  vendorProductByID?:
    | {
        __typename?: 'VendorProduct'
        caseSize?: number | null | undefined
        id: string
        itemCode?: string | null | undefined
        status: VendorProductStatus
        isPrivateLabelProduct: boolean
        product: {
          __typename?: 'Product'
          brandName?: string | null | undefined
          category?: string | null | undefined
          description?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          unitUPC?: string | null | undefined
          unitVolume?: string | null | undefined
        }
        stores?:
          | Array<
              | {
                  __typename?: 'Store'
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        vendor?:
          | {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        orderGuides?:
          | {
              __typename?: 'VendorProductOrderGuidesResult'
              totalCount: number
              nodes: Array<{
                __typename?: 'V2OrderGuide'
                id: string
                vendorStoreDepartmentAccount: {
                  __typename?: 'VendorStoreDepartmentAccount'
                  id: string
                  storeDepartmentID: string
                }
              }>
            }
          | null
          | undefined
        retailerPricing: {
          __typename?: 'PricingInfo'
          unitPrice?: number | null | undefined
          casePrice?: number | null | undefined
        }
        activeDeal?:
          | { __typename?: 'BuyXGetYFreeDeal'; id: string; displayName: string }
          | { __typename?: 'FixedDeal'; id: string; displayName: string }
          | { __typename?: 'PercentageDeal'; id: string; displayName: string }
          | null
          | undefined
        retailerDiscontinuedDates?:
          | Array<{
              __typename?: 'RetailerDiscontinuedDate'
              date?: Date | string | null | undefined
              retailCompany: {
                __typename?: 'RetailCompany'
                id: string
                name?: string | null | undefined
              }
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetVendorProductCustomPricingQueryVariables =
  Exact<{
    id: Scalars['String']
    vendorID: Scalars['String']
  }>

export type RetailVendorCatalogGetVendorProductCustomPricingQuery = {
  __typename?: 'Query'
  vendorProductByID?:
    | {
        __typename?: 'VendorProduct'
        id: string
        allRetailerPricing: Array<{
          __typename?: 'RetailerPricingInfo'
          retailCompany: {
            __typename?: 'RetailCompany'
            id: string
            name?: string | null | undefined
          }
          pricing: {
            __typename?: 'PricingInfo'
            casePrice?: number | null | undefined
            unitPrice?: number | null | undefined
          }
        }>
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetVendorBrandsQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type RetailVendorCatalogGetVendorBrandsQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        vendorBrands: {
          __typename?: 'VendorBrandsResult'
          nodes: Array<string>
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetVendorCategoriesQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type RetailVendorCatalogGetVendorCategoriesQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        vendorCategories: {
          __typename?: 'VendorCategoriesResult'
          nodes: Array<string>
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetRetailCompanyVendorsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>
}>

export type RetailVendorCatalogGetRetailCompanyVendorsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        vendors: {
                          __typename?: 'BannerVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            imgURL?: string | null | undefined
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        vendors: {
                          __typename?: 'StoreVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            imgURL?: string | null | undefined
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailVendorCatalogGetDiscoverableVendorsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
}>

export type RetailVendorCatalogGetDiscoverableVendorsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        discoverableVendors: {
                          __typename?: 'VendorsResult'
                          cursor: string
                          hasMore: boolean
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            imgURL?: string | null | undefined
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        discoverableVendors: {
                          __typename?: 'VendorsResult'
                          cursor: string
                          hasMore: boolean
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            imgURL?: string | null | undefined
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailBulkActionStoreDepartmentsFieldsFragment = {
  __typename?: 'Store'
  id: string
  name?: string | null | undefined
  storeDepartments: {
    __typename?: 'StoreDepartmentsResult'
    nodes: Array<{ __typename?: 'StoreDepartment'; id: string; name: string }>
  }
}

export type RetailBulkActionGetAllStoreDepartmentsQueryVariables = Exact<{
  [key: string]: never
}>

export type RetailBulkActionGetAllStoreDepartmentsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            storeDepartments: {
                              __typename?: 'StoreDepartmentsResult'
                              nodes: Array<{
                                __typename?: 'StoreDepartment'
                                id: string
                                name: string
                              }>
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        name?: string | null | undefined
                        storeDepartments: {
                          __typename?: 'StoreDepartmentsResult'
                          nodes: Array<{
                            __typename?: 'StoreDepartment'
                            id: string
                            name: string
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailGetUserStoreDepartmentsQueryVariables = Exact<{
  storeID: Scalars['ID']
  buyerID: Scalars['ID']
  withDefaultDepartmentName: Scalars['Boolean']
  withUserStoreDepartments: Scalars['Boolean']
}>

export type RetailGetUserStoreDepartmentsQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
          }>
        }
        retailUserByID?:
          | {
              __typename?: 'RetailUser'
              user: {
                __typename?: 'User'
                id: string
                defaultDepartmentName?: string | null | undefined
              }
              userStoreDepartments?: {
                __typename?: 'UserStoreDepartmentsResult'
                nodes: Array<{
                  __typename?: 'UserStoreDepartment'
                  id: string
                  storeDepartment: {
                    __typename?: 'StoreDepartment'
                    id: string
                    name: string
                  }
                }>
              }
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type RetailGetVendorsQueryVariables = Exact<{ [key: string]: never }>

export type RetailGetVendorsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        vendors: {
                          __typename?: 'BannerVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        vendors: {
                          __typename?: 'StoreVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailDepartmentsCreateStoreDepartmentMutationVariables = Exact<{
  departmentName: Scalars['String']
  email?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
}>

export type RetailDepartmentsCreateStoreDepartmentMutation = {
  __typename?: 'Mutation'
  createStoreDepartment: {
    __typename?: 'StoreDepartment'
    email?: string | null | undefined
    id: string
    name: string
    totalBuyerCount?: number | null | undefined
    totalVendorCount?: number | null | undefined
  }
}

export type RetailDepartmentsGetStoreDepartmentsQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type RetailDepartmentsGetStoreDepartmentsQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            email?: string | null | undefined
            name: string
            totalBuyerCount?: number | null | undefined
            totalVendorCount?: number | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables =
  Exact<{
    storeID: Scalars['ID']
  }>

export type RetailDepartmentsGetStoreDepartmentsNamesInUseQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
          }>
        }
      }
    | null
    | undefined
}

export type RetailHomeStoreFieldsFragment = {
  __typename?: 'Store'
  address?: string | null | undefined
  bannerStoreID?: string | null | undefined
  emails: Array<string>
  id: string
  name?: string | null | undefined
  retailUsers: {
    __typename?: 'RetailUsersResult'
    nodes: Array<{
      __typename?: 'RetailUser'
      user: { __typename?: 'User'; id: string }
    }>
  }
  storeDepartments: {
    __typename?: 'StoreDepartmentsResult'
    nodes: Array<{ __typename?: 'StoreDepartment'; id: string }>
  }
  orders: {
    __typename?: 'StoreOrdersResult'
    nodes: Array<{
      __typename?: 'Order'
      id: string
      orderConfirmed: boolean
      totalPrice: number
    }>
  }
}

export type RetailHomeGetStatsQueryVariables = Exact<{ [key: string]: never }>

export type RetailHomeGetStatsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: {
                  __typename?: 'User'
                  displayName?: string | null | undefined
                  id: string
                }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            address?: string | null | undefined
                            bannerStoreID?: string | null | undefined
                            emails: Array<string>
                            id: string
                            name?: string | null | undefined
                            retailUsers: {
                              __typename?: 'RetailUsersResult'
                              nodes: Array<{
                                __typename?: 'RetailUser'
                                user: { __typename?: 'User'; id: string }
                              }>
                            }
                            storeDepartments: {
                              __typename?: 'StoreDepartmentsResult'
                              nodes: Array<{
                                __typename?: 'StoreDepartment'
                                id: string
                              }>
                            }
                            orders: {
                              __typename?: 'StoreOrdersResult'
                              nodes: Array<{
                                __typename?: 'Order'
                                id: string
                                orderConfirmed: boolean
                                totalPrice: number
                              }>
                            }
                          }>
                        }
                        vendors: {
                          __typename?: 'BannerVendorsResult'
                          totalCount: number
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            activePromotions?:
                              | {
                                  __typename?: 'PromotionsResults'
                                  nodes: Array<{
                                    __typename?: 'Promotion'
                                    id: string
                                  }>
                                }
                              | null
                              | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        address?: string | null | undefined
                        bannerStoreID?: string | null | undefined
                        emails: Array<string>
                        id: string
                        name?: string | null | undefined
                        vendors: {
                          __typename?: 'StoreVendorsResult'
                          totalCount: number
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            activePromotions?:
                              | {
                                  __typename?: 'PromotionsResults'
                                  nodes: Array<{
                                    __typename?: 'Promotion'
                                    id: string
                                  }>
                                }
                              | null
                              | undefined
                          }>
                        }
                        retailUsers: {
                          __typename?: 'RetailUsersResult'
                          nodes: Array<{
                            __typename?: 'RetailUser'
                            user: { __typename?: 'User'; id: string }
                          }>
                        }
                        storeDepartments: {
                          __typename?: 'StoreDepartmentsResult'
                          nodes: Array<{
                            __typename?: 'StoreDepartment'
                            id: string
                          }>
                        }
                        orders: {
                          __typename?: 'StoreOrdersResult'
                          nodes: Array<{
                            __typename?: 'Order'
                            id: string
                            orderConfirmed: boolean
                            totalPrice: number
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailOrdersOrderLineItemFieldsFragment = {
  __typename?: 'OrderLineItem'
  price: number
  quantity: number
  unitOfMeasure: UnitOfMeasure
  product?:
    | {
        __typename?: 'VendorProduct'
        id: string
        itemCode?: string | null | undefined
        product: {
          __typename?: 'Product'
          brandName?: string | null | undefined
          description?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          unitUPC?: string | null | undefined
        }
      }
    | null
    | undefined
}

export type RetailOrdersOrderProductFieldsFragment = {
  __typename?: 'VendorProduct'
  id: string
  itemCode?: string | null | undefined
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    unitUPC?: string | null | undefined
  }
}

export type RetailOrdersOrderFieldsFragment = {
  __typename?: 'Order'
  accountNumber: string
  buyerName: string
  deliveryDate?: Date | string | null | undefined
  id: string
  itemCount: number
  noteToVendor?: string | null | undefined
  orderConfirmed: boolean
  orderDateTime: Date | string
  orderEmailOpened: boolean
  orderPlaced: boolean
  orderPlacedByUserEmail: string
  purchaseOrderNum: string
  storeAddress: string
  storeID: string
  storeName: string
  totalPrice: number
  vendorID: string
  orderContents: Array<{
    __typename?: 'OrderLineItem'
    price: number
    quantity: number
    unitOfMeasure: UnitOfMeasure
    product?:
      | {
          __typename?: 'VendorProduct'
          id: string
          itemCode?: string | null | undefined
          product: {
            __typename?: 'Product'
            brandName?: string | null | undefined
            description?: string | null | undefined
            id: string
            imgURL?: string | null | undefined
            unitUPC?: string | null | undefined
          }
        }
      | null
      | undefined
  }>
  vendor: {
    __typename?: 'Vendor'
    id: string
    name?: string | null | undefined
  }
}

export type RetailOrdersOrderStoreFieldsFragment = {
  __typename?: 'Store'
  id: string
  name?: string | null | undefined
}

export type RetailOrdersOrderVendorFieldsFragment = {
  __typename?: 'Vendor'
  id: string
  name?: string | null | undefined
}

export type RetailOrdersConfirmOrderMutationVariables = Exact<{
  orderID: Scalars['ID']
  resolvedProducts?: InputMaybe<Scalars['String']>
}>

export type RetailOrdersConfirmOrderMutation = {
  __typename?: 'Mutation'
  confirmOrder: {
    __typename?: 'Order'
    accountNumber: string
    buyerName: string
    deliveryDate?: Date | string | null | undefined
    id: string
    itemCount: number
    noteToVendor?: string | null | undefined
    orderConfirmed: boolean
    orderDateTime: Date | string
    orderEmailOpened: boolean
    orderPlaced: boolean
    orderPlacedByUserEmail: string
    purchaseOrderNum: string
    storeAddress: string
    storeID: string
    storeName: string
    totalPrice: number
    vendorID: string
    orderContents: Array<{
      __typename?: 'OrderLineItem'
      price: number
      quantity: number
      unitOfMeasure: UnitOfMeasure
      product?:
        | {
            __typename?: 'VendorProduct'
            id: string
            itemCode?: string | null | undefined
            product: {
              __typename?: 'Product'
              brandName?: string | null | undefined
              description?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              unitUPC?: string | null | undefined
            }
          }
        | null
        | undefined
    }>
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
    }
  }
}

export type RetailOrdersGetBannerOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  filterByBuyer?: InputMaybe<Scalars['ID']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterBySent?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  filterByStoreDepartmentID?: InputMaybe<Scalars['ID']>
}>

export type RetailOrdersGetBannerOrdersQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{ __typename?: 'Store'; id: string }>
                        }
                        orders: {
                          __typename?: 'BannerOrdersResult'
                          cursor?: string | null | undefined
                          hasMore?: boolean | null | undefined
                          nodes: Array<{
                            __typename?: 'Order'
                            accountNumber: string
                            buyerName: string
                            deliveryDate?: Date | string | null | undefined
                            id: string
                            itemCount: number
                            noteToVendor?: string | null | undefined
                            orderConfirmed: boolean
                            orderDateTime: Date | string
                            orderEmailOpened: boolean
                            orderPlaced: boolean
                            orderPlacedByUserEmail: string
                            purchaseOrderNum: string
                            storeAddress: string
                            storeID: string
                            storeName: string
                            totalPrice: number
                            vendorID: string
                            orderContents: Array<{
                              __typename?: 'OrderLineItem'
                              price: number
                              quantity: number
                              unitOfMeasure: UnitOfMeasure
                              product?:
                                | {
                                    __typename?: 'VendorProduct'
                                    id: string
                                    itemCode?: string | null | undefined
                                    product: {
                                      __typename?: 'Product'
                                      brandName?: string | null | undefined
                                      description?: string | null | undefined
                                      id: string
                                      imgURL?: string | null | undefined
                                      unitUPC?: string | null | undefined
                                    }
                                  }
                                | null
                                | undefined
                            }>
                            vendor: {
                              __typename?: 'Vendor'
                              id: string
                              name?: string | null | undefined
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailOrdersGetBannerStoresQueryVariables = Exact<{
  [key: string]: never
}>

export type RetailOrdersGetBannerStoresQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  banner?:
                    | {
                        __typename?: 'Banner'
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailOrdersAdminGetBannerStoresQueryVariables = Exact<{
  [key: string]: never
}>

export type RetailOrdersAdminGetBannerStoresQuery = {
  __typename?: 'Query'
  allBanners: {
    __typename?: 'AllBannersResult'
    nodes: Array<{
      __typename?: 'Banner'
      id: string
      name?: string | null | undefined
      stores: {
        __typename?: 'BannerStoresResult'
        nodes: Array<{
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
        }>
      }
    }>
  }
}

export type RetailOrdersGetVendorsQueryVariables = Exact<{
  [key: string]: never
}>

export type RetailOrdersGetVendorsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  banner?:
                    | {
                        __typename?: 'Banner'
                        vendorAccounts: {
                          __typename?: 'BannerVendorStoreAccountsResult'
                          nodes: Array<{
                            __typename?: 'BannerVendorStoreAccount'
                            vendor: {
                              __typename?: 'Vendor'
                              id: string
                              name?: string | null | undefined
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailOrdersGetStoreDepartmentsQueryVariables = Exact<{
  bannerID: Scalars['ID']
}>

export type RetailOrdersGetStoreDepartmentsQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        stores: {
          __typename?: 'BannerStoresResult'
          nodes: Array<{
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
            storeDepartments: {
              __typename?: 'StoreDepartmentsResult'
              nodes: Array<{
                __typename?: 'StoreDepartment'
                id: string
                name: string
              }>
            }
          }>
        }
      }
    | null
    | undefined
}

export type RetailVendorSearchGetProductsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  search?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
  bannerID?: InputMaybe<Scalars['ID']>
  searchID?: InputMaybe<Scalars['String']>
}>

export type RetailVendorSearchGetProductsQuery = {
  __typename?: 'Query'
  searchAllVendorProducts: {
    __typename?: 'SearchAllVendorProductsQueryResult'
    cursor: string
    hasMore: boolean
    searchID: string
    nodes: Array<{
      __typename?: 'UniversalProductSearchItem'
      product: {
        __typename?: 'VendorProduct'
        caseSize?: number | null | undefined
        id: string
        itemCode?: string | null | undefined
        status: VendorProductStatus
        isPrivateLabelProduct: boolean
        product: {
          __typename?: 'Product'
          brandName?: string | null | undefined
          category?: string | null | undefined
          description?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          unitUPC?: string | null | undefined
          unitVolume?: string | null | undefined
        }
        stores?:
          | Array<
              | {
                  __typename?: 'Store'
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        vendor?:
          | {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        orderGuides?:
          | {
              __typename?: 'VendorProductOrderGuidesResult'
              totalCount: number
              nodes: Array<{
                __typename?: 'V2OrderGuide'
                id: string
                vendorStoreDepartmentAccount: {
                  __typename?: 'VendorStoreDepartmentAccount'
                  id: string
                  storeDepartmentID: string
                }
              }>
            }
          | null
          | undefined
        retailerPricing: {
          __typename?: 'PricingInfo'
          unitPrice?: number | null | undefined
          casePrice?: number | null | undefined
        }
        activeDeal?:
          | { __typename?: 'BuyXGetYFreeDeal'; id: string; displayName: string }
          | { __typename?: 'FixedDeal'; id: string; displayName: string }
          | { __typename?: 'PercentageDeal'; id: string; displayName: string }
          | null
          | undefined
        retailerDiscontinuedDates?:
          | Array<{
              __typename?: 'RetailerDiscontinuedDate'
              date?: Date | string | null | undefined
              retailCompany: {
                __typename?: 'RetailCompany'
                id: string
                name?: string | null | undefined
              }
            }>
          | null
          | undefined
      }
    }>
  }
}

export type StoreAdminSearchAuthorizedVendorsQueryVariables = Exact<{
  bannerID: Scalars['ID']
  cursor?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
}>

export type StoreAdminSearchAuthorizedVendorsQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        authorizedVendors: {
          __typename?: 'VendorsResult'
          cursor: string
          hasMore: boolean
          nodes: Array<{
            __typename?: 'Vendor'
            id: string
            imgURL?: string | null | undefined
            name?: string | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type RetailStoresStoreBuyerFieldsFragment = {
  __typename?: 'RetailUser'
  user: {
    __typename?: 'User'
    displayName?: string | null | undefined
    id: string
    retailUser?:
      | {
          __typename?: 'RetailUser'
          readOnlyOrderGuides?: boolean | null | undefined
          user: { __typename?: 'User'; id: string }
        }
      | null
      | undefined
  }
}

export type RetailStoresStoreFieldsFragment = {
  __typename?: 'Store'
  address?: string | null | undefined
  bannerStoreID?: string | null | undefined
  emails: Array<string>
  id: string
  name?: string | null | undefined
  storeDepartments: {
    __typename?: 'StoreDepartmentsResult'
    nodes: Array<{ __typename?: 'StoreDepartment'; id: string }>
  }
  retailUsers: {
    __typename?: 'RetailUsersResult'
    nodes: Array<{
      __typename?: 'RetailUser'
      user: {
        __typename?: 'User'
        displayName?: string | null | undefined
        id: string
        retailUser?:
          | {
              __typename?: 'RetailUser'
              readOnlyOrderGuides?: boolean | null | undefined
              user: { __typename?: 'User'; id: string }
            }
          | null
          | undefined
      }
    }>
  }
  orders: {
    __typename?: 'StoreOrdersResult'
    nodes: Array<{ __typename?: 'Order'; id: string; orderConfirmed: boolean }>
  }
  vendors: {
    __typename?: 'StoreVendorsResult'
    nodes: Array<{ __typename?: 'Vendor'; id: string }>
  }
}

export type RetailStoresGetBannerStoresQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  search?: InputMaybe<Scalars['String']>
}>

export type RetailStoresGetBannerStoresQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        imageURL?: string | null | undefined
                        stores: {
                          __typename?: 'BannerStoresResult'
                          cursor?: string | null | undefined
                          hasMore: boolean
                          nodes: Array<{
                            __typename?: 'Store'
                            address?: string | null | undefined
                            bannerStoreID?: string | null | undefined
                            emails: Array<string>
                            id: string
                            name?: string | null | undefined
                            storeDepartments: {
                              __typename?: 'StoreDepartmentsResult'
                              nodes: Array<{
                                __typename?: 'StoreDepartment'
                                id: string
                              }>
                            }
                            retailUsers: {
                              __typename?: 'RetailUsersResult'
                              nodes: Array<{
                                __typename?: 'RetailUser'
                                user: {
                                  __typename?: 'User'
                                  displayName?: string | null | undefined
                                  id: string
                                  retailUser?:
                                    | {
                                        __typename?: 'RetailUser'
                                        readOnlyOrderGuides?:
                                          | boolean
                                          | null
                                          | undefined
                                        user: {
                                          __typename?: 'User'
                                          id: string
                                        }
                                      }
                                    | null
                                    | undefined
                                }
                              }>
                            }
                            orders: {
                              __typename?: 'StoreOrdersResult'
                              nodes: Array<{
                                __typename?: 'Order'
                                id: string
                                orderConfirmed: boolean
                              }>
                            }
                            vendors: {
                              __typename?: 'StoreVendorsResult'
                              nodes: Array<{
                                __typename?: 'Vendor'
                                id: string
                              }>
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        address?: string | null | undefined
                        bannerStoreID?: string | null | undefined
                        emails: Array<string>
                        id: string
                        name?: string | null | undefined
                        storeDepartments: {
                          __typename?: 'StoreDepartmentsResult'
                          nodes: Array<{
                            __typename?: 'StoreDepartment'
                            id: string
                          }>
                        }
                        retailUsers: {
                          __typename?: 'RetailUsersResult'
                          nodes: Array<{
                            __typename?: 'RetailUser'
                            user: {
                              __typename?: 'User'
                              displayName?: string | null | undefined
                              id: string
                              retailUser?:
                                | {
                                    __typename?: 'RetailUser'
                                    readOnlyOrderGuides?:
                                      | boolean
                                      | null
                                      | undefined
                                    user: { __typename?: 'User'; id: string }
                                  }
                                | null
                                | undefined
                            }
                          }>
                        }
                        orders: {
                          __typename?: 'StoreOrdersResult'
                          nodes: Array<{
                            __typename?: 'Order'
                            id: string
                            orderConfirmed: boolean
                          }>
                        }
                        vendors: {
                          __typename?: 'StoreVendorsResult'
                          nodes: Array<{ __typename?: 'Vendor'; id: string }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailStoresGetStoreByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type RetailStoresGetStoreByIdQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        address?: string | null | undefined
        bannerStoreID?: string | null | undefined
        emails: Array<string>
        id: string
        name?: string | null | undefined
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{ __typename?: 'StoreDepartment'; id: string }>
        }
        retailUsers: {
          __typename?: 'RetailUsersResult'
          nodes: Array<{
            __typename?: 'RetailUser'
            user: {
              __typename?: 'User'
              displayName?: string | null | undefined
              id: string
              retailUser?:
                | {
                    __typename?: 'RetailUser'
                    readOnlyOrderGuides?: boolean | null | undefined
                    user: { __typename?: 'User'; id: string }
                  }
                | null
                | undefined
            }
          }>
        }
        orders: {
          __typename?: 'StoreOrdersResult'
          nodes: Array<{
            __typename?: 'Order'
            id: string
            orderConfirmed: boolean
          }>
        }
        vendors: {
          __typename?: 'StoreVendorsResult'
          nodes: Array<{ __typename?: 'Vendor'; id: string }>
        }
      }
    | null
    | undefined
}

export type RetailDepartmentDepartmentVendorFieldsFragment = {
  __typename?: 'Vendor'
  email?: string | null | undefined
  id: string
  imgURL?: string | null | undefined
  name?: string | null | undefined
  orderMin?: number | null | undefined
  orderMinimums?:
    | Array<{
        __typename?: 'VendorOrderMinimum'
        orderMin: number
        storeID: string
      }>
    | null
    | undefined
}

export type RetailDepartmentVendorStoreDepartmentAccountFieldsFragment = {
  __typename?: 'VendorStoreDepartmentAccount'
  accountNumber?: string | null | undefined
  id: string
  status: VendorStoreDepartmentAccountStatus
  vendorEmails: Array<{
    __typename?: 'VendorEmail'
    email: string
    type: VendorEmailType
  }>
  vendor: {
    __typename?: 'Vendor'
    email?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    name?: string | null | undefined
    orderMin?: number | null | undefined
    orderMinimums?:
      | Array<{
          __typename?: 'VendorOrderMinimum'
          orderMin: number
          storeID: string
        }>
      | null
      | undefined
  }
}

export type RetailDepartmentDepartmentOrderFieldsFragment = {
  __typename?: 'Order'
  accountNumber: string
  buyerName: string
  deliveryDate?: Date | string | null | undefined
  id: string
  itemCount: number
  noteToVendor?: string | null | undefined
  orderConfirmed: boolean
  orderDateTime: Date | string
  orderEmailOpened: boolean
  orderPlaced: boolean
  orderPlacedByUserEmail: string
  purchaseOrderNum: string
  storeAddress: string
  storeID: string
  storeName: string
  totalPrice: number
  vendorID: string
  orderContents: Array<{
    __typename?: 'OrderLineItem'
    price: number
    quantity: number
    unitOfMeasure: UnitOfMeasure
    product?:
      | {
          __typename?: 'VendorProduct'
          id: string
          itemCode?: string | null | undefined
          product: {
            __typename?: 'Product'
            brandName?: string | null | undefined
            description?: string | null | undefined
            id: string
            imgURL?: string | null | undefined
            unitUPC?: string | null | undefined
          }
        }
      | null
      | undefined
  }>
  vendor: {
    __typename?: 'Vendor'
    id: string
    name?: string | null | undefined
  }
}

export type RetailOrderGuidesVendorProductFieldsFragment = {
  __typename?: 'VendorProduct'
  caseSize?: number | null | undefined
  id: string
  itemCode?: string | null | undefined
  notes?: string | null | undefined
  status: VendorProductStatus
  retailerPricing: {
    __typename?: 'PricingInfo'
    unitPrice?: number | null | undefined
    casePrice?: number | null | undefined
  }
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    caseUPC?: string | null | undefined
    category?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    unitVolume?: string | null | undefined
    unitUPC?: string | null | undefined
  }
  stores?:
    | Array<
        | { __typename?: 'Store'; id: string; name?: string | null | undefined }
        | null
        | undefined
      >
    | null
    | undefined
  vendor?:
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
  activeDeal?:
    | { __typename?: 'BuyXGetYFreeDeal'; displayName: string; id: string }
    | { __typename?: 'FixedDeal'; displayName: string; id: string }
    | { __typename?: 'PercentageDeal'; displayName: string; id: string }
    | null
    | undefined
  retailerDiscontinuedDates?:
    | Array<{
        __typename?: 'RetailerDiscontinuedDate'
        date?: Date | string | null | undefined
        retailCompany: {
          __typename?: 'RetailCompany'
          id: string
          name?: string | null | undefined
        }
      }>
    | null
    | undefined
}

export type RetailDepartmentEnableVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    vendorStoreDepartmentAccountID: Scalars['ID']
  }>

export type RetailDepartmentEnableVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  updateVendorStoreDepartmentAccountStatus: {
    __typename?: 'VendorStoreDepartmentAccount'
    id: string
    status: VendorStoreDepartmentAccountStatus
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
    }
  }
}

export type RetailDepartmentDisableVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    vendorStoreDepartmentAccountID: Scalars['ID']
  }>

export type RetailDepartmentDisableVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  updateVendorStoreDepartmentAccountStatus: {
    __typename?: 'VendorStoreDepartmentAccount'
    id: string
    status: VendorStoreDepartmentAccountStatus
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
    }
  }
}

export type RetailDepartmentCreateVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    departmentID: Scalars['String']
    vendorID: Scalars['String']
  }>

export type RetailDepartmentCreateVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  createVendorStoreDepartmentAccount: {
    __typename?: 'VendorStoreDepartmentAccount'
    accountNumber?: string | null | undefined
    id: string
    status: VendorStoreDepartmentAccountStatus
    vendorEmails: Array<{
      __typename?: 'VendorEmail'
      email: string
      type: VendorEmailType
    }>
    vendor: {
      __typename?: 'Vendor'
      email?: string | null | undefined
      id: string
      imgURL?: string | null | undefined
      name?: string | null | undefined
      orderMin?: number | null | undefined
      orderMinimums?:
        | Array<{
            __typename?: 'VendorOrderMinimum'
            orderMin: number
            storeID: string
          }>
        | null
        | undefined
    }
  }
}

export type RetailOrderGuidesAddProductToOrderGuideMutationVariables = Exact<{
  vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
  storeID: Scalars['ID']
  storeDepartmentID: Scalars['ID']
  searchID?: InputMaybe<Scalars['String']>
}>

export type RetailOrderGuidesAddProductToOrderGuideMutation = {
  __typename?: 'Mutation'
  addProductsToV2OrderGuideForStoreDepartment: {
    __typename?: 'AddProductsToV2OrderGuideResult'
    addedVendorProducts: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      notes?: string | null | undefined
      status: VendorProductStatus
      retailerPricing: {
        __typename?: 'PricingInfo'
        unitPrice?: number | null | undefined
        casePrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        brandName?: string | null | undefined
        caseUPC?: string | null | undefined
        category?: string | null | undefined
        description?: string | null | undefined
        id: string
        imgURL?: string | null | undefined
        unitVolume?: string | null | undefined
        unitUPC?: string | null | undefined
      }
      stores?:
        | Array<
            | {
                __typename?: 'Store'
                id: string
                name?: string | null | undefined
              }
            | null
            | undefined
          >
        | null
        | undefined
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
      activeDeal?:
        | { __typename?: 'BuyXGetYFreeDeal'; displayName: string; id: string }
        | { __typename?: 'FixedDeal'; displayName: string; id: string }
        | { __typename?: 'PercentageDeal'; displayName: string; id: string }
        | null
        | undefined
      retailerDiscontinuedDates?:
        | Array<{
            __typename?: 'RetailerDiscontinuedDate'
            date?: Date | string | null | undefined
            retailCompany: {
              __typename?: 'RetailCompany'
              id: string
              name?: string | null | undefined
            }
          }>
        | null
        | undefined
    }>
    orderGuide: {
      __typename?: 'V2OrderGuide'
      id: string
      vendorProductIDs: Array<string>
      vendorStoreDepartmentAccount: {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        storeDepartmentID: string
      }
    }
  }
}

export type RetailOrderGuidesRemoveProductFromOrderGuideMutationVariables =
  Exact<{
    vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
    storeID: Scalars['ID']
    storeDepartmentID: Scalars['ID']
  }>

export type RetailOrderGuidesRemoveProductFromOrderGuideMutation = {
  __typename?: 'Mutation'
  removeProductsFromV2OrderGuideForStoreDepartment: {
    __typename?: 'RemoveProductsFromV2OrderGuideResult'
    removedVendorProducts: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      notes?: string | null | undefined
      status: VendorProductStatus
      retailerPricing: {
        __typename?: 'PricingInfo'
        unitPrice?: number | null | undefined
        casePrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        brandName?: string | null | undefined
        caseUPC?: string | null | undefined
        category?: string | null | undefined
        description?: string | null | undefined
        id: string
        imgURL?: string | null | undefined
        unitVolume?: string | null | undefined
        unitUPC?: string | null | undefined
      }
      stores?:
        | Array<
            | {
                __typename?: 'Store'
                id: string
                name?: string | null | undefined
              }
            | null
            | undefined
          >
        | null
        | undefined
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
      activeDeal?:
        | { __typename?: 'BuyXGetYFreeDeal'; displayName: string; id: string }
        | { __typename?: 'FixedDeal'; displayName: string; id: string }
        | { __typename?: 'PercentageDeal'; displayName: string; id: string }
        | null
        | undefined
      retailerDiscontinuedDates?:
        | Array<{
            __typename?: 'RetailerDiscontinuedDate'
            date?: Date | string | null | undefined
            retailCompany: {
              __typename?: 'RetailCompany'
              id: string
              name?: string | null | undefined
            }
          }>
        | null
        | undefined
    }>
    orderGuide: {
      __typename?: 'V2OrderGuide'
      id: string
      vendorProductIDs: Array<string>
      vendorStoreDepartmentAccount: {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        storeDepartmentID: string
      }
    }
  }
}

export type RetailOrderGuidesCopyOrderGuideMutationVariables = Exact<{
  fromVendorStoreDepartmentAccountID: Scalars['ID']
  toStoreDepartmentIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type RetailOrderGuidesCopyOrderGuideMutation = {
  __typename?: 'Mutation'
  copyV2OrderGuide: {
    __typename?: 'CopyV2OrderGuideResult'
    vendorStoreDepartmentAccounts: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      id: string
      vendorID: string
    }>
  }
}

export type RetailOrderGuidesGetOrderGuideExportUrlMutationVariables = Exact<{
  orderGuideID: Scalars['ID']
}>

export type RetailOrderGuidesGetOrderGuideExportUrlMutation = {
  __typename?: 'Mutation'
  exportV2OrderGuideToCSV: { __typename?: 'V2OrderGuideCSVResult'; url: string }
}

export type RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    accountNumber?: InputMaybe<Scalars['String']>
    vendorEmails?: InputMaybe<Array<VendorEmailInput> | VendorEmailInput>
    vendorStoreDepartmentAccountID: Scalars['ID']
  }>

export type RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  updateVendorStoreDepartmentAccount: {
    __typename?: 'VendorStoreDepartmentAccount'
    accountNumber?: string | null | undefined
    id: string
    vendorEmails: Array<{
      __typename?: 'VendorEmail'
      email: string
      type: VendorEmailType
    }>
  }
}

export type RetailDepartmentGetStoreQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type RetailDepartmentGetStoreQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
          }>
        }
      }
    | null
    | undefined
}

export type RetailDepartmentGetDepartmentVendorsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  departmentID: Scalars['ID']
  query?: InputMaybe<Scalars['String']>
}>

export type RetailDepartmentGetDepartmentVendorsQuery = {
  __typename?: 'Query'
  getStoreDepartmentByID?:
    | {
        __typename?: 'StoreDepartment'
        id: string
        name: string
        discoverableVendors: {
          __typename?: 'VendorsResult'
          cursor: string
          hasMore: boolean
          nodes: Array<{
            __typename?: 'Vendor'
            email?: string | null | undefined
            id: string
            imgURL?: string | null | undefined
            name?: string | null | undefined
            orderMin?: number | null | undefined
            orderMinimums?:
              | Array<{
                  __typename?: 'VendorOrderMinimum'
                  orderMin: number
                  storeID: string
                }>
              | null
              | undefined
          }>
        }
        store: {
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
        }
        vendorStoreDepartmentAccounts: {
          __typename?: 'VendorStoreDepartmentAccountResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            accountNumber?: string | null | undefined
            id: string
            status: VendorStoreDepartmentAccountStatus
            vendorEmails: Array<{
              __typename?: 'VendorEmail'
              email: string
              type: VendorEmailType
            }>
            vendor: {
              __typename?: 'Vendor'
              email?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              name?: string | null | undefined
              orderMin?: number | null | undefined
              orderMinimums?:
                | Array<{
                    __typename?: 'VendorOrderMinimum'
                    orderMin: number
                    storeID: string
                  }>
                | null
                | undefined
            }
          }>
        }
      }
    | null
    | undefined
}

export type RetailDepartmentGetDepartmentOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  departmentID: Scalars['ID']
  vendorID?: InputMaybe<Scalars['ID']>
}>

export type RetailDepartmentGetDepartmentOrdersQuery = {
  __typename?: 'Query'
  getStoreDepartmentByID?:
    | {
        __typename?: 'StoreDepartment'
        id: string
        name: string
        store: {
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
        }
        orders: {
          __typename?: 'StoreDepartmentOrdersResult'
          cursor?: string | null | undefined
          hasMore?: boolean | null | undefined
          nodes: Array<{
            __typename?: 'Order'
            accountNumber: string
            buyerName: string
            deliveryDate?: Date | string | null | undefined
            id: string
            itemCount: number
            noteToVendor?: string | null | undefined
            orderConfirmed: boolean
            orderDateTime: Date | string
            orderEmailOpened: boolean
            orderPlaced: boolean
            orderPlacedByUserEmail: string
            purchaseOrderNum: string
            storeAddress: string
            storeID: string
            storeName: string
            totalPrice: number
            vendorID: string
            orderContents: Array<{
              __typename?: 'OrderLineItem'
              price: number
              quantity: number
              unitOfMeasure: UnitOfMeasure
              product?:
                | {
                    __typename?: 'VendorProduct'
                    id: string
                    itemCode?: string | null | undefined
                    product: {
                      __typename?: 'Product'
                      brandName?: string | null | undefined
                      description?: string | null | undefined
                      id: string
                      imgURL?: string | null | undefined
                      unitUPC?: string | null | undefined
                    }
                  }
                | null
                | undefined
            }>
            vendor: {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          }>
        }
      }
    | null
    | undefined
}

export type RetailDepartmentGetDepartmentOrderByIdQueryVariables = Exact<{
  orderID: Scalars['ID']
}>

export type RetailDepartmentGetDepartmentOrderByIdQuery = {
  __typename?: 'Query'
  orderByID?:
    | {
        __typename?: 'Order'
        accountNumber: string
        buyerName: string
        deliveryDate?: Date | string | null | undefined
        id: string
        itemCount: number
        noteToVendor?: string | null | undefined
        orderConfirmed: boolean
        orderDateTime: Date | string
        orderEmailOpened: boolean
        orderPlaced: boolean
        orderPlacedByUserEmail: string
        purchaseOrderNum: string
        storeAddress: string
        storeID: string
        storeName: string
        totalPrice: number
        vendorID: string
        orderContents: Array<{
          __typename?: 'OrderLineItem'
          price: number
          quantity: number
          unitOfMeasure: UnitOfMeasure
          product?:
            | {
                __typename?: 'VendorProduct'
                id: string
                itemCode?: string | null | undefined
                product: {
                  __typename?: 'Product'
                  brandName?: string | null | undefined
                  description?: string | null | undefined
                  id: string
                  imgURL?: string | null | undefined
                  unitUPC?: string | null | undefined
                }
              }
            | null
            | undefined
        }>
        vendor: {
          __typename?: 'Vendor'
          id: string
          name?: string | null | undefined
        }
      }
    | null
    | undefined
}

export type RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables =
  Exact<{
    cursor?: InputMaybe<Scalars['ID']>
    query?: InputMaybe<Scalars['String']>
    storeID: Scalars['ID']
    vendorStoreDepartmentAccountID: Scalars['ID']
  }>

export type RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery = {
  __typename?: 'Query'
  getVendorStoreDepartmentAccountByID?:
    | {
        __typename?: 'VendorStoreDepartmentAccount'
        accountNumber?: string | null | undefined
        id: string
        orderDeadline?: string | null | undefined
        status: VendorStoreDepartmentAccountStatus
        orderGuide?:
          | {
              __typename?: 'V2OrderGuide'
              id: string
              readOnly?: boolean | null | undefined
              vendorProductIDs: Array<string>
              vendorProducts?:
                | {
                    __typename?: 'OrderGuideProductsResult'
                    cursor?: string | null | undefined
                    hasMore: boolean
                    nodes: Array<{
                      __typename?: 'VendorProduct'
                      caseSize?: number | null | undefined
                      id: string
                      itemCode?: string | null | undefined
                      notes?: string | null | undefined
                      status: VendorProductStatus
                      retailerPricing: {
                        __typename?: 'PricingInfo'
                        unitPrice?: number | null | undefined
                        casePrice?: number | null | undefined
                      }
                      product: {
                        __typename?: 'Product'
                        brandName?: string | null | undefined
                        caseUPC?: string | null | undefined
                        category?: string | null | undefined
                        description?: string | null | undefined
                        id: string
                        imgURL?: string | null | undefined
                        unitVolume?: string | null | undefined
                        unitUPC?: string | null | undefined
                      }
                      stores?:
                        | Array<
                            | {
                                __typename?: 'Store'
                                id: string
                                name?: string | null | undefined
                              }
                            | null
                            | undefined
                          >
                        | null
                        | undefined
                      vendor?:
                        | {
                            __typename?: 'Vendor'
                            id: string
                            name?: string | null | undefined
                          }
                        | null
                        | undefined
                      activeDeal?:
                        | {
                            __typename?: 'BuyXGetYFreeDeal'
                            displayName: string
                            id: string
                          }
                        | {
                            __typename?: 'FixedDeal'
                            displayName: string
                            id: string
                          }
                        | {
                            __typename?: 'PercentageDeal'
                            displayName: string
                            id: string
                          }
                        | null
                        | undefined
                      retailerDiscontinuedDates?:
                        | Array<{
                            __typename?: 'RetailerDiscontinuedDate'
                            date?: Date | string | null | undefined
                            retailCompany: {
                              __typename?: 'RetailCompany'
                              id: string
                              name?: string | null | undefined
                            }
                          }>
                        | null
                        | undefined
                    }>
                  }
                | null
                | undefined
            }
          | null
          | undefined
        vendor: {
          __typename?: 'Vendor'
          id: string
          name?: string | null | undefined
          orderMin?: number | null | undefined
        }
        vendorEmails: Array<{
          __typename?: 'VendorEmail'
          email: string
          type: VendorEmailType
        }>
      }
    | null
    | undefined
}

export type RetailOrderGuidesGetStoreVendorProductsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}>

export type RetailOrderGuidesGetStoreVendorProductsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        vendorProducts: {
                          __typename?: 'VendorProductsResult'
                          cursor?: string | null | undefined
                          hasMore?: boolean | null | undefined
                          nodes: Array<{
                            __typename?: 'VendorProduct'
                            caseSize?: number | null | undefined
                            id: string
                            itemCode?: string | null | undefined
                            notes?: string | null | undefined
                            status: VendorProductStatus
                            retailerPricing: {
                              __typename?: 'PricingInfo'
                              unitPrice?: number | null | undefined
                              casePrice?: number | null | undefined
                            }
                            product: {
                              __typename?: 'Product'
                              brandName?: string | null | undefined
                              caseUPC?: string | null | undefined
                              category?: string | null | undefined
                              description?: string | null | undefined
                              id: string
                              imgURL?: string | null | undefined
                              unitVolume?: string | null | undefined
                              unitUPC?: string | null | undefined
                            }
                            stores?:
                              | Array<
                                  | {
                                      __typename?: 'Store'
                                      id: string
                                      name?: string | null | undefined
                                    }
                                  | null
                                  | undefined
                                >
                              | null
                              | undefined
                            vendor?:
                              | {
                                  __typename?: 'Vendor'
                                  id: string
                                  name?: string | null | undefined
                                }
                              | null
                              | undefined
                            activeDeal?:
                              | {
                                  __typename?: 'BuyXGetYFreeDeal'
                                  displayName: string
                                  id: string
                                }
                              | {
                                  __typename?: 'FixedDeal'
                                  displayName: string
                                  id: string
                                }
                              | {
                                  __typename?: 'PercentageDeal'
                                  displayName: string
                                  id: string
                                }
                              | null
                              | undefined
                            retailerDiscontinuedDates?:
                              | Array<{
                                  __typename?: 'RetailerDiscontinuedDate'
                                  date?: Date | string | null | undefined
                                  retailCompany: {
                                    __typename?: 'RetailCompany'
                                    id: string
                                    name?: string | null | undefined
                                  }
                                }>
                              | null
                              | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables =
  Exact<{
    storeDepartmentID: Scalars['ID']
    vendorID: Scalars['ID']
  }>

export type RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery = {
  __typename?: 'Query'
  getVendorStoreDepartmentAccountForVendor?:
    | {
        __typename?: 'VendorStoreDepartmentAccount'
        accountNumber?: string | null | undefined
        id: string
        status: VendorStoreDepartmentAccountStatus
        vendorEmails: Array<{
          __typename?: 'VendorEmail'
          email: string
          type: VendorEmailType
        }>
        vendor: {
          __typename?: 'Vendor'
          email?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          name?: string | null | undefined
          orderMin?: number | null | undefined
          orderMinimums?:
            | Array<{
                __typename?: 'VendorOrderMinimum'
                orderMin: number
                storeID: string
              }>
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type StoreAdminGetDepartmentOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  departmentID: Scalars['ID']
  vendorID?: InputMaybe<Scalars['ID']>
}>

export type StoreAdminGetDepartmentOrdersQuery = {
  __typename?: 'Query'
  getStoreDepartmentByID?:
    | {
        __typename?: 'StoreDepartment'
        id: string
        orders: {
          __typename?: 'StoreDepartmentOrdersResult'
          cursor?: string | null | undefined
          hasMore?: boolean | null | undefined
          nodes: Array<{
            __typename?: 'Order'
            id: string
            totalPrice: number
            orderPlacedByUserEmail: string
            orderDateTime: Date | string
            vendor: {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          }>
        }
      }
    | null
    | undefined
}

export type VendorCustomersVendorStoreDepartmentAccountFieldsFragment = {
  __typename?: 'VendorStoreDepartmentAccount'
  id: string
  accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
  accountNumber?: string | null | undefined
  storeDepartmentID: string
  name: string
  orderSubmissionMethod?: SubmissionMethod | null | undefined
  orderDeadlineInfo?:
    | {
        __typename?: 'VendorOrderDeadlineInfo'
        timezone: string
        orderDeadlines: Array<{
          __typename?: 'VendorOrderDeadline'
          deadlineDay: DayOfWeek
          deliveryDay: DayOfWeek
          deadlineTime?: string | null | undefined
        }>
      }
    | null
    | undefined
  vendor: {
    __typename?: 'Vendor'
    id: string
    name?: string | null | undefined
    validOrderSubmissionMethods: Array<SubmissionMethod>
  }
  store?:
    | {
        __typename?: 'Store'
        emails: Array<string>
        id: string
        name?: string | null | undefined
        addressComponents?:
          | {
              __typename?: 'AddressComponents'
              addressLine1?: string | null | undefined
              addressLine2?: string | null | undefined
            }
          | null
          | undefined
        retailUsers: {
          __typename?: 'RetailUsersResult'
          nodes: Array<{
            __typename?: 'RetailUser'
            user: {
              __typename?: 'User'
              defaultDepartmentName?: string | null | undefined
              displayName?: string | null | undefined
              email?: string | null | undefined
              id: string
              userType?: UserType | null | undefined
            }
          }>
        }
      }
    | null
    | undefined
  storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
  lastOrder?:
    | { __typename?: 'Order'; id: string; orderDateTime: Date | string }
    | null
    | undefined
}

export type VendorCustomersUpdateVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    accountNumber?: InputMaybe<Scalars['String']>
    dunsNumber?: InputMaybe<Scalars['String']>
    orderSubmissionMethod?: InputMaybe<SubmissionMethod>
    storeEmails?: InputMaybe<Array<StoreEmailInput> | StoreEmailInput>
    vendorStoreDepartmentAccountID: Scalars['ID']
  }>

export type VendorCustomersUpdateVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  updateVendorStoreDepartmentAccount: {
    __typename?: 'VendorStoreDepartmentAccount'
    id: string
    accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
    accountNumber?: string | null | undefined
    storeDepartmentID: string
    name: string
    orderSubmissionMethod?: SubmissionMethod | null | undefined
    orderDeadlineInfo?:
      | {
          __typename?: 'VendorOrderDeadlineInfo'
          timezone: string
          orderDeadlines: Array<{
            __typename?: 'VendorOrderDeadline'
            deadlineDay: DayOfWeek
            deliveryDay: DayOfWeek
            deadlineTime?: string | null | undefined
          }>
        }
      | null
      | undefined
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
      validOrderSubmissionMethods: Array<SubmissionMethod>
    }
    store?:
      | {
          __typename?: 'Store'
          emails: Array<string>
          id: string
          name?: string | null | undefined
          addressComponents?:
            | {
                __typename?: 'AddressComponents'
                addressLine1?: string | null | undefined
                addressLine2?: string | null | undefined
              }
            | null
            | undefined
          retailUsers: {
            __typename?: 'RetailUsersResult'
            nodes: Array<{
              __typename?: 'RetailUser'
              user: {
                __typename?: 'User'
                defaultDepartmentName?: string | null | undefined
                displayName?: string | null | undefined
                email?: string | null | undefined
                id: string
                userType?: UserType | null | undefined
              }
            }>
          }
        }
      | null
      | undefined
    storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
    lastOrder?:
      | { __typename?: 'Order'; id: string; orderDateTime: Date | string }
      | null
      | undefined
  }
}

export type VendorCustomersInviteStoreAccountsForVendorMutationVariables =
  Exact<{
    vendorID: Scalars['ID']
    accounts: Array<InviteStoreAccountInput> | InviteStoreAccountInput
  }>

export type VendorCustomersInviteStoreAccountsForVendorMutation = {
  __typename?: 'Mutation'
  inviteStoreAccounts: {
    __typename?: 'InviteStoreAccountsResult'
    accounts: Array<{
      __typename?: 'VendorStoreAccount'
      accountNumber?: string | null | undefined
      status: VendorStoreAccountStatus
      store?:
        | { __typename?: 'Store'; id: string; name?: string | null | undefined }
        | null
        | undefined
    }>
  }
}

export type VendorCustomersCreateStoreAccountsForVendorMutationVariables =
  Exact<{
    vendorID: Scalars['ID']
    accounts:
      | Array<CreateStoreAccountsForVendorAccountInput>
      | CreateStoreAccountsForVendorAccountInput
    skipDuplicateCheck?: InputMaybe<Scalars['Boolean']>
  }>

export type VendorCustomersCreateStoreAccountsForVendorMutation = {
  __typename?: 'Mutation'
  createStoreAccountsForVendor: {
    __typename?: 'CreateStoreAccountsForVendorResult'
    accounts: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        validOrderSubmissionMethods: Array<SubmissionMethod>
        vendorStoreDepartmentAccounts: {
          __typename?: 'VendorVendorStoreDepartmentAccountsResult'
          totalCount: number
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            name: string
            orderSubmissionMethod?: SubmissionMethod | null | undefined
            accountNumber?: string | null | undefined
            dunsNumber?: string | null | undefined
            storeDepartmentID: string
            status: VendorStoreDepartmentAccountStatus
            accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
            storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
            store?:
              | {
                  __typename?: 'Store'
                  id: string
                  name?: string | null | undefined
                  address?: string | null | undefined
                  emails: Array<string>
                }
              | null
              | undefined
            lastOrder?:
              | {
                  __typename?: 'Order'
                  id: string
                  orderDateTime: Date | string
                }
              | null
              | undefined
          }>
        }
      }
    }>
    errors: Array<{
      __typename?: 'CreateStoreAccountForVendorError'
      error: CreateStoreAccountForVendorErrorType
      message: string
      inputAccountIndex: number
      existingStoreID?: string | null | undefined
    }>
  }
}

export type VendorCustomersValidateStoreAccountsForVendorMutationVariables =
  Exact<{
    vendorID: Scalars['ID']
    accounts:
      | Array<CreateStoreAccountsForVendorAccountInput>
      | CreateStoreAccountsForVendorAccountInput
    validateOnly?: InputMaybe<Scalars['Boolean']>
  }>

export type VendorCustomersValidateStoreAccountsForVendorMutation = {
  __typename?: 'Mutation'
  createStoreAccountsForVendor: {
    __typename?: 'CreateStoreAccountsForVendorResult'
    accounts: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
      }
    }>
    errors: Array<{
      __typename?: 'CreateStoreAccountForVendorError'
      error: CreateStoreAccountForVendorErrorType
      message: string
      inputAccountIndex: number
      existingStoreID?: string | null | undefined
    }>
  }
}

export type VendorCustomersGetVsdasForVendorQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type VendorCustomersGetVsdasForVendorQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        vendorStoreDepartmentAccounts: {
          __typename?: 'VendorVendorStoreDepartmentAccountsResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
            id: string
            name: string
            storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
            store?:
              | {
                  __typename?: 'Store'
                  address?: string | null | undefined
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type VendorCustomersGetVsdaDetailQueryVariables = Exact<{
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}>

export type VendorCustomersGetVsdaDetailQuery = {
  __typename?: 'Query'
  getVendorStoreDepartmentAccountsForVendorAndStore: {
    __typename?: 'VendorStoreDepartmentAccountResult'
    nodes: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      id: string
      accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
      accountNumber?: string | null | undefined
      storeDepartmentID: string
      name: string
      orderSubmissionMethod?: SubmissionMethod | null | undefined
      orderDeadlineInfo?:
        | {
            __typename?: 'VendorOrderDeadlineInfo'
            timezone: string
            orderDeadlines: Array<{
              __typename?: 'VendorOrderDeadline'
              deadlineDay: DayOfWeek
              deliveryDay: DayOfWeek
              deadlineTime?: string | null | undefined
            }>
          }
        | null
        | undefined
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        validOrderSubmissionMethods: Array<SubmissionMethod>
      }
      store?:
        | {
            __typename?: 'Store'
            emails: Array<string>
            id: string
            name?: string | null | undefined
            addressComponents?:
              | {
                  __typename?: 'AddressComponents'
                  addressLine1?: string | null | undefined
                  addressLine2?: string | null | undefined
                }
              | null
              | undefined
            retailUsers: {
              __typename?: 'RetailUsersResult'
              nodes: Array<{
                __typename?: 'RetailUser'
                user: {
                  __typename?: 'User'
                  defaultDepartmentName?: string | null | undefined
                  displayName?: string | null | undefined
                  email?: string | null | undefined
                  id: string
                  userType?: UserType | null | undefined
                }
              }>
            }
          }
        | null
        | undefined
      storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
      lastOrder?:
        | { __typename?: 'Order'; id: string; orderDateTime: Date | string }
        | null
        | undefined
    }>
  }
}

export type VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables =
  Exact<{
    orderWindowStartDate: Scalars['Timestamp']
    storeID: Scalars['ID']
  }>

export type VendorCustomersGetOrderHistoryForVendorStoreAccountQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  storeAccountByStoreID?:
                    | {
                        __typename?: 'VendorStoreAccount'
                        recentOrders: {
                          __typename?: 'VendorStoreAccountOrdersResult'
                          nodes: Array<{
                            __typename?: 'Order'
                            id: string
                            orderDateTime: Date | string
                            itemCount: number
                            totalPrice: number
                            subtotal: number
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorCustomersCheckForExistingStoreQueryVariables = Exact<{
  vendorID: Scalars['ID']
  address?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
}>

export type VendorCustomersCheckForExistingStoreQuery = {
  __typename?: 'Query'
  suggestStores: {
    __typename?: 'SuggestStoresResult'
    nodes: Array<{
      __typename?: 'SuggestStoresResultNode'
      suggestionType: StoreSuggestionType
      store: {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
        emails: Array<string>
        placeID?: string | null | undefined
        address?: string | null | undefined
        vendorAccountByVendorID?:
          | {
              __typename?: 'VendorStoreAccount'
              accountNumber?: string | null | undefined
            }
          | null
          | undefined
      }
    }>
  }
}

export type VendorCustomersBulkCheckForExistingStoreQueryVariables = Exact<{
  vendorID: Scalars['ID']
  stores: Array<BulkSuggestStoresInputStore> | BulkSuggestStoresInputStore
}>

export type VendorCustomersBulkCheckForExistingStoreQuery = {
  __typename?: 'Query'
  bulkSuggestStores: {
    __typename?: 'BulkSuggestStoresResult'
    suggestions: Array<{
      __typename?: 'SuggestStoresResult'
      nodes: Array<{
        __typename?: 'SuggestStoresResultNode'
        suggestionType: StoreSuggestionType
        store: {
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
          emails: Array<string>
          placeID?: string | null | undefined
          address?: string | null | undefined
          vendorAccountByVendorID?:
            | {
                __typename?: 'VendorStoreAccount'
                accountNumber?: string | null | undefined
              }
            | null
            | undefined
        }
      }>
    }>
  }
}

export type VendorHomeGetStatsQueryVariables = Exact<{
  sinceDate: Scalars['Timestamp']
}>

export type VendorHomeGetStatsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          displayName?: string | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                  description?: string | null | undefined
                  email?: string | null | undefined
                  imgURL?: string | null | undefined
                  status: VendorStatus
                  totalProductCount: number
                  lastVendorProductUpdate?: Date | string | null | undefined
                  retailUserCount: number
                  ordersSinceDate: {
                    __typename?: 'OrdersResult'
                    totalCount: number
                    nodes: Array<{ __typename?: 'Order'; totalPrice: number }>
                  }
                  storeAccounts: {
                    __typename?: 'VendorStoreAccountsResult'
                    totalCount: number
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorOrdersMisscanLineItemFieldsFragment = {
  __typename?: 'OrderMisscanLineItem'
  quantity: number
  unitOfMeasure: UnitOfMeasure
  misscanVendorProduct: {
    __typename?: 'MisscanVendorProduct'
    id: string
    upc: string
  }
  resolution: {
    __typename?: 'MisscanSubmission'
    description: string
    id: string
    photoURL?: string | null | undefined
  }
}

export type VendorOrdersOrderLineItemFieldsFragment = {
  __typename?: 'OrderLineItem'
  price: number
  quantity: number
  unitOfMeasure: UnitOfMeasure
  product?:
    | {
        __typename?: 'VendorProduct'
        id: string
        itemCode?: string | null | undefined
        product: {
          __typename?: 'Product'
          brandName?: string | null | undefined
          description?: string | null | undefined
          id: string
          imgURL?: string | null | undefined
          unitUPC?: string | null | undefined
        }
      }
    | null
    | undefined
}

export type VendorOrdersProductFieldsFragment = {
  __typename?: 'VendorProduct'
  id: string
  itemCode?: string | null | undefined
  product: {
    __typename?: 'Product'
    brandName?: string | null | undefined
    description?: string | null | undefined
    id: string
    imgURL?: string | null | undefined
    unitUPC?: string | null | undefined
  }
}

export type VendorOrdersOrderFieldsFragment = {
  __typename?: 'Order'
  accountNumber: string
  buyerName: string
  deliveryDate?: Date | string | null | undefined
  id: string
  itemCount: number
  noteToVendor?: string | null | undefined
  orderConfirmed: boolean
  orderDateTime: Date | string
  orderEmailOpened: boolean
  orderPlaced: boolean
  orderPlacedByUserEmail: string
  erpOrderSent: boolean
  purchaseOrderNum: string
  storeAddress: string
  storeID: string
  storeName: string
  totalPrice: number
  vendorID: string
  hasMisscans: boolean
  orderContents: Array<{
    __typename?: 'OrderLineItem'
    price: number
    quantity: number
    unitOfMeasure: UnitOfMeasure
    product?:
      | {
          __typename?: 'VendorProduct'
          id: string
          itemCode?: string | null | undefined
          product: {
            __typename?: 'Product'
            brandName?: string | null | undefined
            description?: string | null | undefined
            id: string
            imgURL?: string | null | undefined
            unitUPC?: string | null | undefined
          }
        }
      | null
      | undefined
  }>
  misscans: Array<{
    __typename?: 'OrderMisscanLineItem'
    quantity: number
    unitOfMeasure: UnitOfMeasure
    misscanVendorProduct: {
      __typename?: 'MisscanVendorProduct'
      id: string
      upc: string
    }
    resolution: {
      __typename?: 'MisscanSubmission'
      description: string
      id: string
      photoURL?: string | null | undefined
    }
  }>
}

export type VendorOrdersStoreFieldsFragment = {
  __typename?: 'Store'
  id: string
  name?: string | null | undefined
}

export type VendorOrdersConfirmOrderMutationVariables = Exact<{
  orderID: Scalars['ID']
  resolvedProducts?: InputMaybe<Scalars['String']>
}>

export type VendorOrdersConfirmOrderMutation = {
  __typename?: 'Mutation'
  confirmOrder: {
    __typename?: 'Order'
    accountNumber: string
    buyerName: string
    deliveryDate?: Date | string | null | undefined
    id: string
    itemCount: number
    noteToVendor?: string | null | undefined
    orderConfirmed: boolean
    orderDateTime: Date | string
    orderEmailOpened: boolean
    orderPlaced: boolean
    orderPlacedByUserEmail: string
    erpOrderSent: boolean
    purchaseOrderNum: string
    storeAddress: string
    storeID: string
    storeName: string
    totalPrice: number
    vendorID: string
    hasMisscans: boolean
    orderContents: Array<{
      __typename?: 'OrderLineItem'
      price: number
      quantity: number
      unitOfMeasure: UnitOfMeasure
      product?:
        | {
            __typename?: 'VendorProduct'
            id: string
            itemCode?: string | null | undefined
            product: {
              __typename?: 'Product'
              brandName?: string | null | undefined
              description?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              unitUPC?: string | null | undefined
            }
          }
        | null
        | undefined
    }>
    misscans: Array<{
      __typename?: 'OrderMisscanLineItem'
      quantity: number
      unitOfMeasure: UnitOfMeasure
      misscanVendorProduct: {
        __typename?: 'MisscanVendorProduct'
        id: string
        upc: string
      }
      resolution: {
        __typename?: 'MisscanSubmission'
        description: string
        id: string
        photoURL?: string | null | undefined
      }
    }>
  }
}

export type VendorOrdersResubmitOrderMutationVariables = Exact<{
  orderID: Scalars['ID']
}>

export type VendorOrdersResubmitOrderMutation = {
  __typename?: 'Mutation'
  submitOrder: {
    __typename?: 'Order'
    accountNumber: string
    buyerName: string
    deliveryDate?: Date | string | null | undefined
    id: string
    itemCount: number
    noteToVendor?: string | null | undefined
    orderConfirmed: boolean
    orderDateTime: Date | string
    orderEmailOpened: boolean
    orderPlaced: boolean
    orderPlacedByUserEmail: string
    erpOrderSent: boolean
    purchaseOrderNum: string
    storeAddress: string
    storeID: string
    storeName: string
    totalPrice: number
    vendorID: string
    hasMisscans: boolean
    orderContents: Array<{
      __typename?: 'OrderLineItem'
      price: number
      quantity: number
      unitOfMeasure: UnitOfMeasure
      product?:
        | {
            __typename?: 'VendorProduct'
            id: string
            itemCode?: string | null | undefined
            product: {
              __typename?: 'Product'
              brandName?: string | null | undefined
              description?: string | null | undefined
              id: string
              imgURL?: string | null | undefined
              unitUPC?: string | null | undefined
            }
          }
        | null
        | undefined
    }>
    misscans: Array<{
      __typename?: 'OrderMisscanLineItem'
      quantity: number
      unitOfMeasure: UnitOfMeasure
      misscanVendorProduct: {
        __typename?: 'MisscanVendorProduct'
        id: string
        upc: string
      }
      resolution: {
        __typename?: 'MisscanSubmission'
        description: string
        id: string
        photoURL?: string | null | undefined
      }
    }>
  }
}

export type VendorOrdersUpdateVendorStoreAccountNumberMutationVariables =
  Exact<{
    storeID: Scalars['String']
    vendorID: Scalars['String']
    accountNumber?: InputMaybe<Scalars['String']>
  }>

export type VendorOrdersUpdateVendorStoreAccountNumberMutation = {
  __typename?: 'Mutation'
  updateVendorStoreAccount: {
    __typename?: 'VendorStoreAccount'
    accountNumber?: string | null | undefined
  }
}

export type VendorOrdersGetOrdersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterByReceived?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}>

export type VendorOrdersGetOrdersQuery = {
  __typename?: 'Query'
  vendorOrders: {
    __typename?: 'VendorOrdersResult'
    cursor?: string | null | undefined
    hasMore?: boolean | null | undefined
    nodes: Array<{
      __typename?: 'Order'
      id: string
      orderDateTime: Date | string
      storeName: string
      totalPrice: number
      purchaseOrderNum: string
      orderConfirmed: boolean
      accountNumber: string
      hasMisscans: boolean
    }>
  }
}

export type VendorOrdersGetOrderByIdQueryVariables = Exact<{
  orderID: Scalars['ID']
}>

export type VendorOrdersGetOrderByIdQuery = {
  __typename?: 'Query'
  orderByID?:
    | {
        __typename?: 'Order'
        accountNumber: string
        buyerName: string
        deliveryDate?: Date | string | null | undefined
        id: string
        itemCount: number
        noteToVendor?: string | null | undefined
        orderConfirmed: boolean
        orderDateTime: Date | string
        orderEmailOpened: boolean
        orderPlaced: boolean
        orderPlacedByUserEmail: string
        erpOrderSent: boolean
        purchaseOrderNum: string
        storeAddress: string
        storeID: string
        storeName: string
        totalPrice: number
        vendorID: string
        hasMisscans: boolean
        orderContents: Array<{
          __typename?: 'OrderLineItem'
          price: number
          quantity: number
          unitOfMeasure: UnitOfMeasure
          product?:
            | {
                __typename?: 'VendorProduct'
                id: string
                itemCode?: string | null | undefined
                product: {
                  __typename?: 'Product'
                  brandName?: string | null | undefined
                  description?: string | null | undefined
                  id: string
                  imgURL?: string | null | undefined
                  unitUPC?: string | null | undefined
                }
              }
            | null
            | undefined
        }>
        misscans: Array<{
          __typename?: 'OrderMisscanLineItem'
          quantity: number
          unitOfMeasure: UnitOfMeasure
          misscanVendorProduct: {
            __typename?: 'MisscanVendorProduct'
            id: string
            upc: string
          }
          resolution: {
            __typename?: 'MisscanSubmission'
            description: string
            id: string
            photoURL?: string | null | undefined
          }
        }>
      }
    | null
    | undefined
}

export type VendorOrdersGetProductSuggestionsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  search?: InputMaybe<Scalars['String']>
}>

export type VendorOrdersGetProductSuggestionsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  vendorProducts: {
                    __typename?: 'VendorProductsResult'
                    cursor?: string | null | undefined
                    hasMore?: boolean | null | undefined
                    nodes: Array<{
                      __typename?: 'VendorProduct'
                      id: string
                      itemCode?: string | null | undefined
                      product: {
                        __typename?: 'Product'
                        brandName?: string | null | undefined
                        description?: string | null | undefined
                        id: string
                        imgURL?: string | null | undefined
                        unitUPC?: string | null | undefined
                      }
                    }>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorOrdersGetStoresQueryVariables = Exact<{
  vendorID: Scalars['ID']
  search?: InputMaybe<Scalars['String']>
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type VendorOrdersGetStoresQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        stores: {
          __typename?: 'StoresResult'
          totalCount?: number | null | undefined
          cursor?: string | null | undefined
          nodes: Array<{
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type VendorOrdersGetStoreAccountQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type VendorOrdersGetStoreAccountQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  storeAccountByStoreID?:
                    | {
                        __typename?: 'VendorStoreAccount'
                        accountNumber?: string | null | undefined
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorProfileProfileFieldsFragment = {
  __typename?: 'Vendor'
  id: string
  misscanPolicy?: VendorMisscanPolicy | null | undefined
  description?: string | null | undefined
  email?: string | null | undefined
  name?: string | null | undefined
  orderDeadline?: string | null | undefined
  headerImageURL?: string | null | undefined
  imgURL?: string | null | undefined
  lockUOMSelection?: UomLock | null | undefined
  disableOutOfStockPurchases: boolean
  disableDiscontinuedPurchases: boolean
  orderMin?: number | null | undefined
  isMarketEnabled: boolean
  showImages?: boolean | null | undefined
  slug?: string | null | undefined
  status: VendorStatus
  isInventoryEnabled: boolean
  address?: string | null | undefined
  acquisitionSource?: AcquisitionSource | null | undefined
  defaultOrderSubmissionMethod: SubmissionMethod
  trueCommerceTenetID?: string | null | undefined
  orderMinimums?:
    | Array<{
        __typename?: 'VendorOrderMinimum'
        orderMin: number
        storeID: string
      }>
    | null
    | undefined
  referredByCompany?:
    | { __typename?: 'Store'; id: string }
    | { __typename?: 'Vendor'; id: string }
    | null
    | undefined
}

export type VendorProfileUpdateProfileMutationVariables = Exact<{
  input: UpdateVendorInput
}>

export type VendorProfileUpdateProfileMutation = {
  __typename?: 'Mutation'
  updateVendor: {
    __typename?: 'Vendor'
    id: string
    misscanPolicy?: VendorMisscanPolicy | null | undefined
    description?: string | null | undefined
    email?: string | null | undefined
    name?: string | null | undefined
    orderDeadline?: string | null | undefined
    headerImageURL?: string | null | undefined
    imgURL?: string | null | undefined
    lockUOMSelection?: UomLock | null | undefined
    disableOutOfStockPurchases: boolean
    disableDiscontinuedPurchases: boolean
    orderMin?: number | null | undefined
    isMarketEnabled: boolean
    showImages?: boolean | null | undefined
    slug?: string | null | undefined
    status: VendorStatus
    isInventoryEnabled: boolean
    address?: string | null | undefined
    acquisitionSource?: AcquisitionSource | null | undefined
    defaultOrderSubmissionMethod: SubmissionMethod
    trueCommerceTenetID?: string | null | undefined
    orderMinimums?:
      | Array<{
          __typename?: 'VendorOrderMinimum'
          orderMin: number
          storeID: string
        }>
      | null
      | undefined
    referredByCompany?:
      | { __typename?: 'Store'; id: string }
      | { __typename?: 'Vendor'; id: string }
      | null
      | undefined
  }
}

export type VendorProfileUpdateOrderDeadlineInfoMutationVariables = Exact<{
  id: Scalars['ID']
  orderDeadlineInfo?: InputMaybe<VendorOrderDeadlineInfoInput>
}>

export type VendorProfileUpdateOrderDeadlineInfoMutation = {
  __typename?: 'Mutation'
  updateVendor: {
    __typename?: 'Vendor'
    orderDeadlineInfo?:
      | {
          __typename?: 'VendorOrderDeadlineInfo'
          timezone: string
          orderDeadlines: Array<{
            __typename?: 'VendorOrderDeadline'
            deadlineDay: DayOfWeek
            deadlineTime?: string | null | undefined
            deliveryDay: DayOfWeek
          }>
        }
      | null
      | undefined
  }
}

export type VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationVariables =
  Exact<{
    vendorID: Scalars['ID']
    storeDepartmentID: Scalars['ID']
    orderDeadlineInfo?: InputMaybe<VendorOrderDeadlineInfoInput>
  }>

export type VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation = {
  __typename?: 'Mutation'
  updateVendorStoreDepartmentAccountForVendor: {
    __typename?: 'VendorStoreDepartmentAccount'
    orderDeadlineInfo?:
      | {
          __typename?: 'VendorOrderDeadlineInfo'
          timezone: string
          orderDeadlines: Array<{
            __typename?: 'VendorOrderDeadline'
            deadlineDay: DayOfWeek
            deadlineTime?: string | null | undefined
            deliveryDay: DayOfWeek
          }>
        }
      | null
      | undefined
  }
}

export type VendorProfileGetProfileQueryVariables = Exact<{
  [key: string]: never
}>

export type VendorProfileGetProfileQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  misscanPolicy?: VendorMisscanPolicy | null | undefined
                  description?: string | null | undefined
                  email?: string | null | undefined
                  name?: string | null | undefined
                  orderDeadline?: string | null | undefined
                  headerImageURL?: string | null | undefined
                  imgURL?: string | null | undefined
                  lockUOMSelection?: UomLock | null | undefined
                  disableOutOfStockPurchases: boolean
                  disableDiscontinuedPurchases: boolean
                  orderMin?: number | null | undefined
                  isMarketEnabled: boolean
                  showImages?: boolean | null | undefined
                  slug?: string | null | undefined
                  status: VendorStatus
                  isInventoryEnabled: boolean
                  address?: string | null | undefined
                  acquisitionSource?: AcquisitionSource | null | undefined
                  defaultOrderSubmissionMethod: SubmissionMethod
                  trueCommerceTenetID?: string | null | undefined
                  orderMinimums?:
                    | Array<{
                        __typename?: 'VendorOrderMinimum'
                        orderMin: number
                        storeID: string
                      }>
                    | null
                    | undefined
                  referredByCompany?:
                    | { __typename?: 'Store'; id: string }
                    | { __typename?: 'Vendor'; id: string }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorProfileGetPaginatedStoresQueryVariables = Exact<{
  search: Scalars['String']
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type VendorProfileGetPaginatedStoresQuery = {
  __typename?: 'Query'
  searchStores: {
    __typename?: 'SearchStoresQueryResult'
    totalCount: number
    cursor?: string | null | undefined
    hasMore: boolean
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
    }>
  }
}

export type VendorProfileGetOrderDeadlineInfoQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type VendorProfileGetOrderDeadlineInfoQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        orderDeadlineInfo?:
          | {
              __typename?: 'VendorOrderDeadlineInfo'
              timezone: string
              orderDeadlines: Array<{
                __typename?: 'VendorOrderDeadline'
                deadlineDay: DayOfWeek
                deliveryDay: DayOfWeek
                deadlineTime?: string | null | undefined
              }>
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type VendorProfileGetVsdaOrderDeadlineInfoQueryVariables = Exact<{
  storeDepartmentID: Scalars['ID']
  vendorName: Scalars['String']
}>

export type VendorProfileGetVsdaOrderDeadlineInfoQuery = {
  __typename?: 'Query'
  getStoreDepartmentByID?:
    | {
        __typename?: 'StoreDepartment'
        id: string
        vendorStoreDepartmentAccounts: {
          __typename?: 'VendorStoreDepartmentAccountResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            vendorID: string
            orderDeadlineInfo?:
              | {
                  __typename?: 'VendorOrderDeadlineInfo'
                  timezone: string
                  orderDeadlines: Array<{
                    __typename?: 'VendorOrderDeadline'
                    deadlineDay: DayOfWeek
                    deliveryDay: DayOfWeek
                    deadlineTime?: string | null | undefined
                  }>
                }
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type VendorPromotionsAudienceFieldsFragment = {
  __typename?: 'Audience'
  id: string
  name: string
  prospectiveStoreAccounts: {
    __typename?: 'StoresResult'
    totalCount?: number | null | undefined
  }
  storeAccounts: {
    __typename?: 'VendorStoreAccountsResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'VendorStoreAccount'
      vendorID?: string | null | undefined
      store?:
        | {
            __typename?: 'Store'
            id: string
            banner?:
              | {
                  __typename?: 'Banner'
                  id: string
                  stores: {
                    __typename?: 'BannerStoresResult'
                    nodes: Array<{
                      __typename?: 'Store'
                      address?: string | null | undefined
                      id: string
                    }>
                  }
                }
              | null
              | undefined
          }
        | null
        | undefined
    }>
  }
}

export type VendorPromotionsDealVendorProductFieldsFragment = {
  __typename?: 'VendorProduct'
  caseSize?: number | null | undefined
  id: string
  itemCode?: string | null | undefined
  wholesalePricing: {
    __typename?: 'PricingInfo'
    casePrice?: number | null | undefined
    unitPrice?: number | null | undefined
  }
  retailerPricing: {
    __typename?: 'PricingInfo'
    casePrice?: number | null | undefined
    unitPrice?: number | null | undefined
  }
  product: {
    __typename?: 'Product'
    id: string
    brandName?: string | null | undefined
    description?: string | null | undefined
    imgURL?: string | null | undefined
    unitVolume?: string | null | undefined
  }
  vendor?:
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
}

export type VendorPromotionsDealFieldsBuyXGetYFreeDealFragment = {
  __typename?: 'BuyXGetYFreeDeal'
  unitOfMeasure: UnitOfMeasure
  freeCount: number
  threshold: number
  id: string
  type: DealType
  displayName: string
  vendorDiscountCode?: string | null | undefined
  vendorProducts: {
    __typename?: 'DealVendorProductsResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      retailerPricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        id: string
        brandName?: string | null | undefined
        description?: string | null | undefined
        imgURL?: string | null | undefined
        unitVolume?: string | null | undefined
      }
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type VendorPromotionsDealFieldsFixedDealFragment = {
  __typename?: 'FixedDeal'
  dealValue: number
  unitOfMeasure: UnitOfMeasure
  id: string
  type: DealType
  displayName: string
  vendorDiscountCode?: string | null | undefined
  vendorProducts: {
    __typename?: 'DealVendorProductsResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      retailerPricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        id: string
        brandName?: string | null | undefined
        description?: string | null | undefined
        imgURL?: string | null | undefined
        unitVolume?: string | null | undefined
      }
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type VendorPromotionsDealFieldsPercentageDealFragment = {
  __typename?: 'PercentageDeal'
  basisPoints: number
  id: string
  type: DealType
  displayName: string
  vendorDiscountCode?: string | null | undefined
  vendorProducts: {
    __typename?: 'DealVendorProductsResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'VendorProduct'
      caseSize?: number | null | undefined
      id: string
      itemCode?: string | null | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      retailerPricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        id: string
        brandName?: string | null | undefined
        description?: string | null | undefined
        imgURL?: string | null | undefined
        unitVolume?: string | null | undefined
      }
      vendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type VendorPromotionsDealFieldsFragment =
  | VendorPromotionsDealFieldsBuyXGetYFreeDealFragment
  | VendorPromotionsDealFieldsFixedDealFragment
  | VendorPromotionsDealFieldsPercentageDealFragment

export type VendorPromotionsPromotionItemFieldsFragment = {
  __typename?: 'Promotion'
  endDate?: Date | string | null | undefined
  id: string
  isPublished?: boolean | null | undefined
  name?: string | null | undefined
  startDate?: Date | string | null | undefined
  status: PromotionStatus
  allAccounts?: boolean | null | undefined
  audience?:
    | { __typename?: 'Audience'; id: string; name: string }
    | null
    | undefined
  deals: {
    __typename?: 'DealsResults'
    nodes: Array<
      | {
          __typename?: 'BuyXGetYFreeDeal'
          id: string
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            totalCount: number
          }
        }
      | {
          __typename?: 'FixedDeal'
          id: string
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            totalCount: number
          }
        }
      | {
          __typename?: 'PercentageDeal'
          id: string
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            totalCount: number
          }
        }
    >
  }
}

export type VendorPromotionsPromotionDetailFieldsFragment = {
  __typename?: 'Promotion'
  id: string
  name?: string | null | undefined
  startDate?: Date | string | null | undefined
  endDate?: Date | string | null | undefined
  status: PromotionStatus
  totalSales: number
  isPublished?: boolean | null | undefined
  allAccounts?: boolean | null | undefined
  audience?:
    | { __typename?: 'Audience'; id: string; name: string }
    | null
    | undefined
  deals: {
    __typename?: 'DealsResults'
    nodes: Array<
      | {
          __typename?: 'BuyXGetYFreeDeal'
          unitOfMeasure: UnitOfMeasure
          freeCount: number
          threshold: number
          id: string
          type: DealType
          displayName: string
          vendorDiscountCode?: string | null | undefined
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            totalCount: number
            nodes: Array<{
              __typename?: 'VendorProduct'
              caseSize?: number | null | undefined
              id: string
              itemCode?: string | null | undefined
              wholesalePricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              retailerPricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              product: {
                __typename?: 'Product'
                id: string
                brandName?: string | null | undefined
                description?: string | null | undefined
                imgURL?: string | null | undefined
                unitVolume?: string | null | undefined
              }
              vendor?:
                | {
                    __typename?: 'Vendor'
                    id: string
                    name?: string | null | undefined
                  }
                | null
                | undefined
            }>
          }
        }
      | {
          __typename?: 'FixedDeal'
          dealValue: number
          unitOfMeasure: UnitOfMeasure
          id: string
          type: DealType
          displayName: string
          vendorDiscountCode?: string | null | undefined
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            totalCount: number
            nodes: Array<{
              __typename?: 'VendorProduct'
              caseSize?: number | null | undefined
              id: string
              itemCode?: string | null | undefined
              wholesalePricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              retailerPricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              product: {
                __typename?: 'Product'
                id: string
                brandName?: string | null | undefined
                description?: string | null | undefined
                imgURL?: string | null | undefined
                unitVolume?: string | null | undefined
              }
              vendor?:
                | {
                    __typename?: 'Vendor'
                    id: string
                    name?: string | null | undefined
                  }
                | null
                | undefined
            }>
          }
        }
      | {
          __typename?: 'PercentageDeal'
          basisPoints: number
          id: string
          type: DealType
          displayName: string
          vendorDiscountCode?: string | null | undefined
          vendorProducts: {
            __typename?: 'DealVendorProductsResult'
            totalCount: number
            nodes: Array<{
              __typename?: 'VendorProduct'
              caseSize?: number | null | undefined
              id: string
              itemCode?: string | null | undefined
              wholesalePricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              retailerPricing: {
                __typename?: 'PricingInfo'
                casePrice?: number | null | undefined
                unitPrice?: number | null | undefined
              }
              product: {
                __typename?: 'Product'
                id: string
                brandName?: string | null | undefined
                description?: string | null | undefined
                imgURL?: string | null | undefined
                unitVolume?: string | null | undefined
              }
              vendor?:
                | {
                    __typename?: 'Vendor'
                    id: string
                    name?: string | null | undefined
                  }
                | null
                | undefined
            }>
          }
        }
    >
  }
}

export type VendorPromotionsPromotionConflictFieldsFragment = {
  __typename?: 'VendorProductPromotionConflict'
  vendorProduct: { __typename?: 'VendorProduct'; id: string }
  deal:
    | { __typename?: 'BuyXGetYFreeDeal'; id: string; type: DealType }
    | { __typename?: 'FixedDeal'; id: string; type: DealType }
    | { __typename?: 'PercentageDeal'; id: string; type: DealType }
}

export type VendorPromotionsCreateAudienceMutationVariables = Exact<{
  name: Scalars['String']
  vendorID: Scalars['ID']
  storeIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type VendorPromotionsCreateAudienceMutation = {
  __typename?: 'Mutation'
  createAudience: {
    __typename?: 'Audience'
    id: string
    name: string
    prospectiveStoreAccounts: {
      __typename?: 'StoresResult'
      totalCount?: number | null | undefined
    }
    storeAccounts: {
      __typename?: 'VendorStoreAccountsResult'
      totalCount: number
      nodes: Array<{
        __typename?: 'VendorStoreAccount'
        vendorID?: string | null | undefined
        store?:
          | {
              __typename?: 'Store'
              id: string
              banner?:
                | {
                    __typename?: 'Banner'
                    id: string
                    stores: {
                      __typename?: 'BannerStoresResult'
                      nodes: Array<{
                        __typename?: 'Store'
                        address?: string | null | undefined
                        id: string
                      }>
                    }
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }>
    }
  }
}

export type VendorPromotionsCreateDealMutationVariables = Exact<{
  type: DealType
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  promotionID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
  basisPoints?: InputMaybe<Scalars['Int']>
  dealValue?: InputMaybe<Scalars['Currency']>
  threshold?: InputMaybe<Scalars['Int']>
  freeCount?: InputMaybe<Scalars['Int']>
  vendorDiscountCode?: InputMaybe<Scalars['String']>
}>

export type VendorPromotionsCreateDealMutation = {
  __typename?: 'Mutation'
  createDeal:
    | {
        __typename?: 'BuyXGetYFreeDeal'
        id: string
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
        }
      }
    | {
        __typename?: 'FixedDeal'
        id: string
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
        }
      }
    | {
        __typename?: 'PercentageDeal'
        id: string
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
        }
      }
}

export type VendorPromotionsUpdateDealMutationVariables = Exact<{
  id: Scalars['ID']
  type?: InputMaybe<DealType>
  vendorProductIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  basisPoints?: InputMaybe<Scalars['Int']>
  dealValue?: InputMaybe<Scalars['Currency']>
  threshold?: InputMaybe<Scalars['Int']>
  freeCount?: InputMaybe<Scalars['Int']>
  vendorDiscountCode?: InputMaybe<Scalars['String']>
}>

export type VendorPromotionsUpdateDealMutation = {
  __typename?: 'Mutation'
  updateDeal:
    | {
        __typename?: 'BuyXGetYFreeDeal'
        id: string
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
        }
      }
    | {
        __typename?: 'FixedDeal'
        id: string
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
        }
      }
    | {
        __typename?: 'PercentageDeal'
        id: string
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
        }
      }
}

export type VendorPromotionsDeleteDealMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type VendorPromotionsDeleteDealMutation = {
  __typename?: 'Mutation'
  deleteDeal: { __typename?: 'DeleteDealResult'; deletedDealID: string }
}

export type VendorPromotionsCreatePromotionMutationVariables = Exact<{
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  isPublished: Scalars['Boolean']
  name: Scalars['String']
  startDate?: InputMaybe<Scalars['Timestamp']>
  vendorID: Scalars['ID']
}>

export type VendorPromotionsCreatePromotionMutation = {
  __typename?: 'Mutation'
  createPromotion: {
    __typename?: 'Promotion'
    endDate?: Date | string | null | undefined
    id: string
    isPublished?: boolean | null | undefined
    name?: string | null | undefined
    startDate?: Date | string | null | undefined
    status: PromotionStatus
    allAccounts?: boolean | null | undefined
    audience?:
      | { __typename?: 'Audience'; id: string; name: string }
      | null
      | undefined
    deals: {
      __typename?: 'DealsResults'
      nodes: Array<
        | {
            __typename?: 'BuyXGetYFreeDeal'
            id: string
            vendorProducts: {
              __typename?: 'DealVendorProductsResult'
              totalCount: number
            }
          }
        | {
            __typename?: 'FixedDeal'
            id: string
            vendorProducts: {
              __typename?: 'DealVendorProductsResult'
              totalCount: number
            }
          }
        | {
            __typename?: 'PercentageDeal'
            id: string
            vendorProducts: {
              __typename?: 'DealVendorProductsResult'
              totalCount: number
            }
          }
      >
    }
  }
}

export type VendorPromotionsUpdatePromotionMutationVariables = Exact<{
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  id: Scalars['ID']
  isPublished?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['Timestamp']>
}>

export type VendorPromotionsUpdatePromotionMutation = {
  __typename?: 'Mutation'
  updatePromotion: {
    __typename?: 'Promotion'
    endDate?: Date | string | null | undefined
    id: string
    isPublished?: boolean | null | undefined
    name?: string | null | undefined
    startDate?: Date | string | null | undefined
    status: PromotionStatus
    allAccounts?: boolean | null | undefined
    audience?:
      | { __typename?: 'Audience'; id: string; name: string }
      | null
      | undefined
    deals: {
      __typename?: 'DealsResults'
      nodes: Array<
        | {
            __typename?: 'BuyXGetYFreeDeal'
            id: string
            vendorProducts: {
              __typename?: 'DealVendorProductsResult'
              totalCount: number
            }
          }
        | {
            __typename?: 'FixedDeal'
            id: string
            vendorProducts: {
              __typename?: 'DealVendorProductsResult'
              totalCount: number
            }
          }
        | {
            __typename?: 'PercentageDeal'
            id: string
            vendorProducts: {
              __typename?: 'DealVendorProductsResult'
              totalCount: number
            }
          }
      >
    }
  }
}

export type VendorPromotionsDeletePromotionMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type VendorPromotionsDeletePromotionMutation = {
  __typename?: 'Mutation'
  deletePromotion: {
    __typename?: 'DeletePromotionResult'
    deletedPromotionID?: string | null | undefined
  }
}

export type VendorPromotionsGetAudiencesQueryVariables = Exact<{
  [key: string]: never
}>

export type VendorPromotionsGetAudiencesQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  audiences: {
                    __typename?: 'AudiencesResult'
                    nodes: Array<{
                      __typename?: 'Audience'
                      id: string
                      name: string
                      prospectiveStoreAccounts: {
                        __typename?: 'StoresResult'
                        totalCount?: number | null | undefined
                      }
                      storeAccounts: {
                        __typename?: 'VendorStoreAccountsResult'
                        totalCount: number
                        nodes: Array<{
                          __typename?: 'VendorStoreAccount'
                          vendorID?: string | null | undefined
                          store?:
                            | {
                                __typename?: 'Store'
                                id: string
                                banner?:
                                  | {
                                      __typename?: 'Banner'
                                      id: string
                                      stores: {
                                        __typename?: 'BannerStoresResult'
                                        nodes: Array<{
                                          __typename?: 'Store'
                                          address?: string | null | undefined
                                          id: string
                                        }>
                                      }
                                    }
                                  | null
                                  | undefined
                              }
                            | null
                            | undefined
                        }>
                      }
                    }>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorPromotionsGetDealQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type VendorPromotionsGetDealQuery = {
  __typename?: 'Query'
  dealByID?:
    | {
        __typename?: 'BuyXGetYFreeDeal'
        unitOfMeasure: UnitOfMeasure
        freeCount: number
        threshold: number
        id: string
        type: DealType
        displayName: string
        vendorDiscountCode?: string | null | undefined
        promotion: {
          __typename?: 'Promotion'
          id: string
          name?: string | null | undefined
        }
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
          nodes: Array<{
            __typename?: 'VendorProduct'
            caseSize?: number | null | undefined
            id: string
            itemCode?: string | null | undefined
            wholesalePricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            retailerPricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            product: {
              __typename?: 'Product'
              id: string
              brandName?: string | null | undefined
              description?: string | null | undefined
              imgURL?: string | null | undefined
              unitVolume?: string | null | undefined
            }
            vendor?:
              | {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
          }>
        }
      }
    | {
        __typename?: 'FixedDeal'
        dealValue: number
        unitOfMeasure: UnitOfMeasure
        id: string
        type: DealType
        displayName: string
        vendorDiscountCode?: string | null | undefined
        promotion: {
          __typename?: 'Promotion'
          id: string
          name?: string | null | undefined
        }
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
          nodes: Array<{
            __typename?: 'VendorProduct'
            caseSize?: number | null | undefined
            id: string
            itemCode?: string | null | undefined
            wholesalePricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            retailerPricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            product: {
              __typename?: 'Product'
              id: string
              brandName?: string | null | undefined
              description?: string | null | undefined
              imgURL?: string | null | undefined
              unitVolume?: string | null | undefined
            }
            vendor?:
              | {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
          }>
        }
      }
    | {
        __typename?: 'PercentageDeal'
        basisPoints: number
        id: string
        type: DealType
        displayName: string
        vendorDiscountCode?: string | null | undefined
        promotion: {
          __typename?: 'Promotion'
          id: string
          name?: string | null | undefined
        }
        vendorProducts: {
          __typename?: 'DealVendorProductsResult'
          totalCount: number
          nodes: Array<{
            __typename?: 'VendorProduct'
            caseSize?: number | null | undefined
            id: string
            itemCode?: string | null | undefined
            wholesalePricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            retailerPricing: {
              __typename?: 'PricingInfo'
              casePrice?: number | null | undefined
              unitPrice?: number | null | undefined
            }
            product: {
              __typename?: 'Product'
              id: string
              brandName?: string | null | undefined
              description?: string | null | undefined
              imgURL?: string | null | undefined
              unitVolume?: string | null | undefined
            }
            vendor?:
              | {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                }
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type VendorPromotionsGetAllPromotionsQueryVariables = Exact<{
  [key: string]: never
}>

export type VendorPromotionsGetAllPromotionsQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          userType?: UserType | null | undefined
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  allPromotions?:
                    | {
                        __typename?: 'PromotionsResults'
                        nodes: Array<{
                          __typename?: 'Promotion'
                          endDate?: Date | string | null | undefined
                          id: string
                          isPublished?: boolean | null | undefined
                          name?: string | null | undefined
                          startDate?: Date | string | null | undefined
                          status: PromotionStatus
                          allAccounts?: boolean | null | undefined
                          audience?:
                            | {
                                __typename?: 'Audience'
                                id: string
                                name: string
                              }
                            | null
                            | undefined
                          deals: {
                            __typename?: 'DealsResults'
                            nodes: Array<
                              | {
                                  __typename?: 'BuyXGetYFreeDeal'
                                  id: string
                                  vendorProducts: {
                                    __typename?: 'DealVendorProductsResult'
                                    totalCount: number
                                  }
                                }
                              | {
                                  __typename?: 'FixedDeal'
                                  id: string
                                  vendorProducts: {
                                    __typename?: 'DealVendorProductsResult'
                                    totalCount: number
                                  }
                                }
                              | {
                                  __typename?: 'PercentageDeal'
                                  id: string
                                  vendorProducts: {
                                    __typename?: 'DealVendorProductsResult'
                                    totalCount: number
                                  }
                                }
                            >
                          }
                        }>
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type VendorPromotionsGetPromotionDetailQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type VendorPromotionsGetPromotionDetailQuery = {
  __typename?: 'Query'
  promotionByID?:
    | {
        __typename?: 'Promotion'
        id: string
        name?: string | null | undefined
        startDate?: Date | string | null | undefined
        endDate?: Date | string | null | undefined
        status: PromotionStatus
        totalSales: number
        isPublished?: boolean | null | undefined
        allAccounts?: boolean | null | undefined
        audience?:
          | { __typename?: 'Audience'; id: string; name: string }
          | null
          | undefined
        deals: {
          __typename?: 'DealsResults'
          nodes: Array<
            | {
                __typename?: 'BuyXGetYFreeDeal'
                unitOfMeasure: UnitOfMeasure
                freeCount: number
                threshold: number
                id: string
                type: DealType
                displayName: string
                vendorDiscountCode?: string | null | undefined
                vendorProducts: {
                  __typename?: 'DealVendorProductsResult'
                  totalCount: number
                  nodes: Array<{
                    __typename?: 'VendorProduct'
                    caseSize?: number | null | undefined
                    id: string
                    itemCode?: string | null | undefined
                    wholesalePricing: {
                      __typename?: 'PricingInfo'
                      casePrice?: number | null | undefined
                      unitPrice?: number | null | undefined
                    }
                    retailerPricing: {
                      __typename?: 'PricingInfo'
                      casePrice?: number | null | undefined
                      unitPrice?: number | null | undefined
                    }
                    product: {
                      __typename?: 'Product'
                      id: string
                      brandName?: string | null | undefined
                      description?: string | null | undefined
                      imgURL?: string | null | undefined
                      unitVolume?: string | null | undefined
                    }
                    vendor?:
                      | {
                          __typename?: 'Vendor'
                          id: string
                          name?: string | null | undefined
                        }
                      | null
                      | undefined
                  }>
                }
              }
            | {
                __typename?: 'FixedDeal'
                dealValue: number
                unitOfMeasure: UnitOfMeasure
                id: string
                type: DealType
                displayName: string
                vendorDiscountCode?: string | null | undefined
                vendorProducts: {
                  __typename?: 'DealVendorProductsResult'
                  totalCount: number
                  nodes: Array<{
                    __typename?: 'VendorProduct'
                    caseSize?: number | null | undefined
                    id: string
                    itemCode?: string | null | undefined
                    wholesalePricing: {
                      __typename?: 'PricingInfo'
                      casePrice?: number | null | undefined
                      unitPrice?: number | null | undefined
                    }
                    retailerPricing: {
                      __typename?: 'PricingInfo'
                      casePrice?: number | null | undefined
                      unitPrice?: number | null | undefined
                    }
                    product: {
                      __typename?: 'Product'
                      id: string
                      brandName?: string | null | undefined
                      description?: string | null | undefined
                      imgURL?: string | null | undefined
                      unitVolume?: string | null | undefined
                    }
                    vendor?:
                      | {
                          __typename?: 'Vendor'
                          id: string
                          name?: string | null | undefined
                        }
                      | null
                      | undefined
                  }>
                }
              }
            | {
                __typename?: 'PercentageDeal'
                basisPoints: number
                id: string
                type: DealType
                displayName: string
                vendorDiscountCode?: string | null | undefined
                vendorProducts: {
                  __typename?: 'DealVendorProductsResult'
                  totalCount: number
                  nodes: Array<{
                    __typename?: 'VendorProduct'
                    caseSize?: number | null | undefined
                    id: string
                    itemCode?: string | null | undefined
                    wholesalePricing: {
                      __typename?: 'PricingInfo'
                      casePrice?: number | null | undefined
                      unitPrice?: number | null | undefined
                    }
                    retailerPricing: {
                      __typename?: 'PricingInfo'
                      casePrice?: number | null | undefined
                      unitPrice?: number | null | undefined
                    }
                    product: {
                      __typename?: 'Product'
                      id: string
                      brandName?: string | null | undefined
                      description?: string | null | undefined
                      imgURL?: string | null | undefined
                      unitVolume?: string | null | undefined
                    }
                    vendor?:
                      | {
                          __typename?: 'Vendor'
                          id: string
                          name?: string | null | undefined
                        }
                      | null
                      | undefined
                  }>
                }
              }
          >
        }
      }
    | null
    | undefined
}

export type VendorPromotionsGetPromotionConflictsQueryVariables = Exact<{
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate: Scalars['Timestamp']
  startDate: Scalars['Timestamp']
  vendorID: Scalars['ID']
}>

export type VendorPromotionsGetPromotionConflictsQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        potentialPromotionConflicts?:
          | {
              __typename?: 'PotentialPromotionConflictsResult'
              totalCount: number
              nodes: Array<{
                __typename?: 'VendorProductPromotionConflict'
                vendorProduct: { __typename?: 'VendorProduct'; id: string }
                deal:
                  | {
                      __typename?: 'BuyXGetYFreeDeal'
                      id: string
                      type: DealType
                    }
                  | { __typename?: 'FixedDeal'; id: string; type: DealType }
                  | {
                      __typename?: 'PercentageDeal'
                      id: string
                      type: DealType
                    }
              }>
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type VendorPromotionsGetProductsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}>

export type VendorPromotionsGetProductsQuery = {
  __typename?: 'Query'
  vendorProducts: {
    __typename?: 'VendorProductsResult'
    cursor?: string | null | undefined
    hasMore?: boolean | null | undefined
    nodes: Array<{
      __typename?: 'VendorProduct'
      id: string
      itemCode?: string | null | undefined
      wholesalePricing: {
        __typename?: 'PricingInfo'
        unitPrice?: number | null | undefined
        casePrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        id: string
        brandName?: string | null | undefined
        description?: string | null | undefined
        imgURL?: string | null | undefined
        unitUPC?: string | null | undefined
      }
    }>
  }
}

export type VendorPromotionsGetStoreAccountsQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type VendorPromotionsGetStoreAccountsQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        storeAccounts: {
          __typename?: 'VendorStoreAccountsResult'
          nodes: Array<{
            __typename?: 'VendorStoreAccount'
            vendorID?: string | null | undefined
            store?:
              | {
                  __typename?: 'Store'
                  address?: string | null | undefined
                  id: string
                  name?: string | null | undefined
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        name?: string | null | undefined
                        imageURL?: string | null | undefined
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            address?: string | null | undefined
                            id: string
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
          }>
        }
        prospectiveStoreAccounts: {
          __typename?: 'StoresResult'
          totalCount?: number | null | undefined
          nodes: Array<{
            __typename?: 'Store'
            id: string
            address?: string | null | undefined
            name?: string | null | undefined
            banner?:
              | {
                  __typename?: 'Banner'
                  id: string
                  name?: string | null | undefined
                  imageURL?: string | null | undefined
                  stores: {
                    __typename?: 'BannerStoresResult'
                    nodes: Array<{
                      __typename?: 'Store'
                      address?: string | null | undefined
                      id: string
                    }>
                  }
                }
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables =
  Exact<{ [key: string]: never }>

export type CommonGetStoreDepartmentsForRetailAdminSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            serialID?: string | null | undefined
                            storeDepartments: {
                              __typename?: 'StoreDepartmentsResult'
                              nodes: Array<{
                                __typename?: 'StoreDepartment'
                                deactivatedAt?: any | null | undefined
                                id: string
                                name: string
                                store: {
                                  __typename?: 'Store'
                                  id: string
                                  serialID?: string | null | undefined
                                }
                              }>
                            }
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoreDepartmentsForRetailApSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetStoreDepartmentsForRetailApSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                storeDepartments: {
                  __typename?: 'StoreDepartmentsResult'
                  nodes: Array<{
                    __typename?: 'StoreDepartment'
                    deactivatedAt?: any | null | undefined
                    id: string
                    name: string
                    store: {
                      __typename?: 'Store'
                      id: string
                      serialID?: string | null | undefined
                    }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables =
  Exact<{ [key: string]: never }>

export type CommonGetStoreDepartmentsForRetailBuyerSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                storeDepartments: {
                  __typename?: 'StoreDepartmentsResult'
                  nodes: Array<{
                    __typename?: 'StoreDepartment'
                    deactivatedAt?: any | null | undefined
                    id: string
                    name: string
                    store: {
                      __typename?: 'Store'
                      id: string
                      serialID?: string | null | undefined
                    }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables =
  Exact<{ [key: string]: never }>

export type CommonGetStoreDepartmentsForVendorAdminSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                user: { __typename?: 'User'; id: string }
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  vendorStoreDepartmentAccounts: {
                    __typename?: 'VendorVendorStoreDepartmentAccountsResult'
                    nodes: Array<{
                      __typename?: 'VendorStoreDepartmentAccount'
                      id: string
                      store?:
                        | {
                            __typename?: 'Store'
                            id: string
                            serialID?: string | null | undefined
                            name?: string | null | undefined
                          }
                        | null
                        | undefined
                      storeDepartment: {
                        __typename?: 'StoreDepartment'
                        deactivatedAt?: any | null | undefined
                        id: string
                        name: string
                        store: {
                          __typename?: 'Store'
                          id: string
                          serialID?: string | null | undefined
                        }
                      }
                    }>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoresForRetailAdminSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetStoresForRetailAdminSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            name?: string | null | undefined
                            serialID?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoresForRetailApSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetStoresForRetailApSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                storeDepartments: {
                  __typename?: 'StoreDepartmentsResult'
                  nodes: Array<{
                    __typename?: 'StoreDepartment'
                    store: {
                      __typename?: 'Store'
                      id: string
                      name?: string | null | undefined
                      serialID?: string | null | undefined
                    }
                  }>
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoresForVendorAdminSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetStoresForVendorAdminSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          vendorUser?:
            | {
                __typename?: 'VendorUser'
                user: { __typename?: 'User'; id: string }
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  stores: {
                    __typename?: 'StoresResult'
                    nodes: Array<{
                      __typename?: 'Store'
                      id: string
                      name?: string | null | undefined
                      serialID?: string | null | undefined
                    }>
                  }
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetStoresForVoriAdminSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetStoresForVoriAdminSelectQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      serialID?: string | null | undefined
    }>
  }
}

export type CommonGetVendorsForRetailAdminSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetVendorsForRetailAdminSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        vendors: {
                          __typename?: 'BannerVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetVendorsForRetailApSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetVendorsForRetailApSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        vendors: {
                          __typename?: 'StoreVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetVendorsForRetailBuyerSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetVendorsForRetailBuyerSelectQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                user: { __typename?: 'User'; id: string }
                retailCompany: {
                  __typename?: 'RetailCompany'
                  id: string
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        vendors: {
                          __typename?: 'StoreVendorsResult'
                          nodes: Array<{
                            __typename?: 'Vendor'
                            id: string
                            name?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CommonGetVendorsForVoriAdminSelectQueryVariables = Exact<{
  [key: string]: never
}>

export type CommonGetVendorsForVoriAdminSelectQuery = {
  __typename?: 'Query'
  allVendors: {
    __typename?: 'AllVendorsResult'
    nodes: Array<{
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
    }>
  }
}

export type AdminBannersBannerFieldsFragment = {
  __typename?: 'Banner'
  acquisitionDetail?: string | null | undefined
  acquisitionSource?: AcquisitionSource | null | undefined
  bannerType?: StoreType | null | undefined
  id: string
  serialID?: string | null | undefined
  imageURL?: string | null | undefined
  name?: string | null | undefined
  status?: BannerStatus | null | undefined
  referredByCompany?:
    | { __typename?: 'Store'; id: string; name?: string | null | undefined }
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
  vendorStoreDepartmentAccounts: {
    __typename?: 'BannerVendorStoreDepartmentAccountsResult'
    totalCount: number
  }
  stores: {
    __typename?: 'BannerStoresResult'
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
    }>
  }
}

export type AdminBannersDeleteBannerByIdMutationVariables = Exact<{
  bannerID: Scalars['ID']
}>

export type AdminBannersDeleteBannerByIdMutation = {
  __typename?: 'Mutation'
  deleteBanner: { __typename?: 'DeleteBannerResult'; deletedBannerID: string }
}

export type AdminBannersCreateBannerMutationVariables = Exact<{
  name: Scalars['String']
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  status?: InputMaybe<BannerStatus>
  storeIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  acquisitionDetail?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  bannerType?: InputMaybe<StoreType>
}>

export type AdminBannersCreateBannerMutation = {
  __typename?: 'Mutation'
  createBanner: {
    __typename?: 'Banner'
    acquisitionDetail?: string | null | undefined
    acquisitionSource?: AcquisitionSource | null | undefined
    bannerType?: StoreType | null | undefined
    id: string
    serialID?: string | null | undefined
    imageURL?: string | null | undefined
    name?: string | null | undefined
    status?: BannerStatus | null | undefined
    referredByCompany?:
      | { __typename?: 'Store'; id: string; name?: string | null | undefined }
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    vendorStoreDepartmentAccounts: {
      __typename?: 'BannerVendorStoreDepartmentAccountsResult'
      totalCount: number
    }
    stores: {
      __typename?: 'BannerStoresResult'
      nodes: Array<{
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
      }>
    }
  }
}

export type AdminBannersUpdateBannerMutationVariables = Exact<{
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  status?: InputMaybe<BannerStatus>
  storeIDs: Array<Scalars['ID']> | Scalars['ID']
  acquisitionSource?: InputMaybe<AcquisitionSource>
  acquisitionDetail?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  bannerType?: InputMaybe<StoreType>
}>

export type AdminBannersUpdateBannerMutation = {
  __typename?: 'Mutation'
  updateBanner: {
    __typename?: 'Banner'
    acquisitionDetail?: string | null | undefined
    acquisitionSource?: AcquisitionSource | null | undefined
    bannerType?: StoreType | null | undefined
    id: string
    serialID?: string | null | undefined
    imageURL?: string | null | undefined
    name?: string | null | undefined
    status?: BannerStatus | null | undefined
    referredByCompany?:
      | { __typename?: 'Store'; id: string; name?: string | null | undefined }
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    vendorStoreDepartmentAccounts: {
      __typename?: 'BannerVendorStoreDepartmentAccountsResult'
      totalCount: number
    }
    stores: {
      __typename?: 'BannerStoresResult'
      nodes: Array<{
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
      }>
    }
  }
}

export type AdminBannersGetAllBannersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  search?: InputMaybe<Scalars['String']>
}>

export type AdminBannersGetAllBannersQuery = {
  __typename?: 'Query'
  allBanners: {
    __typename?: 'AllBannersResult'
    cursor: string
    hasMore: boolean
    totalCount: number
    nodes: Array<{
      __typename?: 'Banner'
      acquisitionDetail?: string | null | undefined
      acquisitionSource?: AcquisitionSource | null | undefined
      bannerType?: StoreType | null | undefined
      id: string
      serialID?: string | null | undefined
      imageURL?: string | null | undefined
      name?: string | null | undefined
      status?: BannerStatus | null | undefined
      referredByCompany?:
        | { __typename?: 'Store'; id: string; name?: string | null | undefined }
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
      vendorStoreDepartmentAccounts: {
        __typename?: 'BannerVendorStoreDepartmentAccountsResult'
        totalCount: number
      }
      stores: {
        __typename?: 'BannerStoresResult'
        nodes: Array<{
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
        }>
      }
    }>
  }
}

export type AdminBannersGetBannerByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type AdminBannersGetBannerByIdQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        acquisitionDetail?: string | null | undefined
        acquisitionSource?: AcquisitionSource | null | undefined
        bannerType?: StoreType | null | undefined
        id: string
        serialID?: string | null | undefined
        imageURL?: string | null | undefined
        name?: string | null | undefined
        status?: BannerStatus | null | undefined
        referredByCompany?:
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
            }
          | {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        vendorStoreDepartmentAccounts: {
          __typename?: 'BannerVendorStoreDepartmentAccountsResult'
          totalCount: number
        }
        stores: {
          __typename?: 'BannerStoresResult'
          nodes: Array<{
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type AdminBannersGetAllStoresQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  search?: InputMaybe<Scalars['String']>
}>

export type AdminBannersGetAllStoresQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    cursor: string
    hasMore: boolean
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      banner?:
        | {
            __typename?: 'Banner'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminCatalogsParseCsvOrderGuideMutationVariables = Exact<{
  vendorID: Scalars['ID']
  csvInput: Array<OrderGuideCsvInput> | OrderGuideCsvInput
  forRetailAccountIDs?: InputMaybe<
    Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>
  >
  forInvitationOrderGuide: Scalars['Boolean']
}>

export type AdminCatalogsParseCsvOrderGuideMutation = {
  __typename?: 'Mutation'
  parseCSVOrderGuide: {
    __typename?: 'ParsedOrderGuideResult'
    vendorProductIDs: Array<string>
    errors: Array<number | null | undefined>
    hasErrors: boolean
  }
}

export type AdminCatalogsBulkParseCsvOrderGuidesMutationVariables = Exact<{
  vendors: Array<ParseCsvOrderGuideInput> | ParseCsvOrderGuideInput
}>

export type AdminCatalogsBulkParseCsvOrderGuidesMutation = {
  __typename?: 'Mutation'
  bulkParseCSVOrderGuides: {
    __typename?: 'BulkParsedOrderGuidesResult'
    nodes: Array<{
      __typename?: 'ParsedOrderGuideResult'
      vendorProductIDs: Array<string>
      retailAccountIDs?: Array<string> | null | undefined
      errors: Array<number | null | undefined>
      hasErrors: boolean
      vendorID: string
    }>
  }
}

export type AdminCatalogsBulkUpdateV2OrderGuidesMutationVariables = Exact<{
  addAccounts:
    | Array<AddProductsToV2OrderGuideInput>
    | AddProductsToV2OrderGuideInput
  updateAccounts: Array<UpdateV2OrderGuideInput> | UpdateV2OrderGuideInput
}>

export type AdminCatalogsBulkUpdateV2OrderGuidesMutation = {
  __typename?: 'Mutation'
  bulkAddProductsToV2OrderGuide: {
    __typename?: 'BulkAddProductsToV2OrderGuideResult'
    nodes?:
      | Array<{
          __typename?: 'AddProductsToV2OrderGuideResult'
          addedVendorProducts: Array<{
            __typename?: 'VendorProduct'
            id: string
          }>
        }>
      | null
      | undefined
  }
  bulkUpdateV2OrderGuides: {
    __typename?: 'BulkUpdateV2OrderGuidesResult'
    nodes?:
      | Array<{
          __typename?: 'V2OrderGuide'
          id: string
          vendorProductIDs: Array<string>
        }>
      | null
      | undefined
  }
}

export type AdminCatalogsAddProductsToV2OrderGuideMutationVariables = Exact<{
  vendorStoreDepartmentAccountID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsAddProductsToV2OrderGuideMutation = {
  __typename?: 'Mutation'
  addProductsToV2OrderGuide: {
    __typename?: 'AddProductsToV2OrderGuideResult'
    addedVendorProducts: Array<{ __typename?: 'VendorProduct'; id: string }>
  }
}

export type AdminCatalogsUpdateV2OrderGuideMutationVariables = Exact<{
  vendorStoreDepartmentAccountID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsUpdateV2OrderGuideMutation = {
  __typename?: 'Mutation'
  updateV2OrderGuide: {
    __typename?: 'V2OrderGuide'
    id: string
    vendorProductIDs: Array<string>
  }
}

export type AdminCatalogsCreateInvitationOrderGuideMutationVariables = Exact<{
  vendorID: Scalars['ID']
  productIDs: Array<Scalars['ID']> | Scalars['ID']
  orderGuideName: Scalars['String']
  departmentName?: InputMaybe<Scalars['String']>
}>

export type AdminCatalogsCreateInvitationOrderGuideMutation = {
  __typename?: 'Mutation'
  createInvitationOrderGuide: {
    __typename?: 'InvitationOrderGuide'
    id: string
    orderGuideName: string
    departmentName?: string | null | undefined
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
    }
    products: Array<{
      __typename?: 'VendorProduct'
      product: {
        __typename?: 'Product'
        id: string
        description?: string | null | undefined
      }
    }>
  }
}

export type AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationVariables =
  Exact<{
    bannerID: Scalars['ID']
    accounts:
      | Array<UpdateBannerAuthFileV2OrderGuidesAccountInput>
      | UpdateBannerAuthFileV2OrderGuidesAccountInput
  }>

export type AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation = {
  __typename?: 'Mutation'
  updateBannerAuthFileV2OrderGuides: {
    __typename?: 'BannerV2OrderGuidesUpdateResult'
    updatedVendorStoreDepartmentAccounts: Array<string>
    nodes: Array<{
      __typename?: 'V2OrderGuide'
      id: string
      vendorProductIDs: Array<string>
      vendorStoreDepartmentAccount: {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        name: string
      }
    }>
  }
}

export type AdminCatalogsUpdateBannerV2OrderGuidesMutationVariables = Exact<{
  vendorID: Scalars['ID']
  bannerID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']> | Scalars['ID']
  departmentName: DepartmentName
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
}>

export type AdminCatalogsUpdateBannerV2OrderGuidesMutation = {
  __typename?: 'Mutation'
  updateBannerV2OrderGuides: {
    __typename?: 'BannerV2OrderGuidesUpdateResult'
    updatedVendorStoreDepartmentAccounts: Array<string>
    nodes: Array<{
      __typename?: 'V2OrderGuide'
      id: string
      vendorProductIDs: Array<string>
      vendorStoreDepartmentAccount: {
        __typename?: 'VendorStoreDepartmentAccount'
        id: string
        name: string
      }
    }>
  }
}

export type AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationVariables =
  Exact<{
    vendorID: Scalars['ID']
    overwrite: Scalars['Boolean']
    inputProducts: Array<BulkVendorProductInput> | BulkVendorProductInput
    isBannerUpload: Scalars['Boolean']
    retailAccountID?: InputMaybe<Scalars['ID']>
    privateLabelUpload?: InputMaybe<Scalars['Boolean']>
    discontinueMissingProducts?: InputMaybe<Scalars['Boolean']>
    catalogSource?: InputMaybe<VendorProductCatalogSource>
  }>

export type AdminCatalogsBulkSingleVendorProductsUploadWorkerMutation = {
  __typename?: 'Mutation'
  bulkUploadSingleVendorProductsWorker: {
    __typename?: 'TaskResponse'
    jobID: string
  }
}

export type AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationVariables =
  Exact<{
    overwrite: Scalars['Boolean']
    isBannerUpload: Scalars['Boolean']
    retailAccountID?: InputMaybe<Scalars['ID']>
    inputProducts: Array<BulkVendorProductInput> | BulkVendorProductInput
    privateLabelUpload?: InputMaybe<Scalars['Boolean']>
    catalogSource?: InputMaybe<VendorProductCatalogSource>
  }>

export type AdminCatalogsBulkMultiVendorProductsUploadWorkerMutation = {
  __typename?: 'Mutation'
  bulkUploadMultiVendorProductsWorker: Array<{
    __typename?: 'TaskResponse'
    jobID: string
  }>
}

export type AdminCatalogsValidateBulkUploadVendorProductsQueryVariables =
  Exact<{
    inputProducts: Array<BulkVendorProductInput> | BulkVendorProductInput
    isMultiVendorUpload: Scalars['Boolean']
    vendorIDForSingleVendorValidation?: InputMaybe<Scalars['String']>
  }>

export type AdminCatalogsValidateBulkUploadVendorProductsQuery = {
  __typename?: 'Query'
  validateBulkUploadVendorProducts: Array<{
    __typename?: 'ValidateBulkUploadVendorProductsResult'
    spreadsheetURL: string
    numValidProducts: number
    numProducts: number
    numExistingProducts: number
    numDeletedProductsRestored: number
    numNewProducts: number
    errors: Array<{
      __typename?: 'UploadError'
      index: number
      errorMessages: Array<UploadErrorMessages>
    }>
    matchErrors: Array<{
      __typename?: 'MatchError'
      error: string
      index: number
    }>
    vendor: { __typename?: 'Vendor'; name?: string | null | undefined }
  }>
}

export type AdminCatalogsGetVendorOgProductsQueryVariables = Exact<{
  vendorID: Scalars['ID']
  filterByRetailerIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  search?: InputMaybe<Scalars['String']>
}>

export type AdminCatalogsGetVendorOgProductsQuery = {
  __typename?: 'Query'
  vendorProducts: {
    __typename?: 'VendorProductsResult'
    nodes: Array<{
      __typename?: 'VendorProduct'
      id: string
      itemCode?: string | null | undefined
      caseSize?: number | null | undefined
      retailerPricing: {
        __typename?: 'PricingInfo'
        casePrice?: number | null | undefined
        unitPrice?: number | null | undefined
      }
      product: {
        __typename?: 'Product'
        id: string
        imgURL?: string | null | undefined
        brandName?: string | null | undefined
        category?: string | null | undefined
        description?: string | null | undefined
        unitVolume?: string | null | undefined
        unitUPC?: string | null | undefined
        caseUPC?: string | null | undefined
      }
    }>
  }
}

export type AdminCatalogsGetV2VsdaOrderGuideQueryVariables = Exact<{
  storeID: Scalars['ID']
  vendorStoreDepartmentAccountIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsGetV2VsdaOrderGuideQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        vendorStoreDepartmentAccounts: {
          __typename?: 'StoreVendorStoreDepartmentAccountsResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            orderGuide?:
              | {
                  __typename?: 'V2OrderGuide'
                  id: string
                  vendorProductIDs: Array<string>
                }
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type AdminCatalogsGetV2VsdaOrderGuidesQueryVariables = Exact<{
  storeID: Scalars['ID']
  vendorIDs: Array<Scalars['ID']> | Scalars['ID']
  vendorStoreDepartmentAccountIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsGetV2VsdaOrderGuidesQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        vendorStoreDepartmentAccounts: {
          __typename?: 'StoreVendorStoreDepartmentAccountsResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            vendorID: string
            orderGuide?:
              | {
                  __typename?: 'V2OrderGuide'
                  id: string
                  vendorProductIDs: Array<string>
                }
              | null
              | undefined
          }>
        }
      }
    | null
    | undefined
}

export type AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables = Exact<{
  vendorStoreDepartmentAccountIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery = {
  __typename?: 'Query'
  adminVendorStoreDepartmentAccountsByID: {
    __typename?: 'AdminVendorStoreDepartmentAccountsResult'
    nodes: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      id: string
      name: string
      orderGuide?:
        | { __typename?: 'V2OrderGuide'; vendorProductIDs: Array<string> }
        | null
        | undefined
      store?:
        | { __typename?: 'Store'; id: string; name?: string | null | undefined }
        | null
        | undefined
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
      }
    }>
  }
}

export type AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID']
  vendorIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsGetsVsdAsForStoresAndVendorsQuery = {
  __typename?: 'Query'
  adminStoresByID: {
    __typename?: 'AdminStoresResult'
    nodes: Array<{
      __typename?: 'Store'
      id: string
      vendorStoreDepartmentAccounts: {
        __typename?: 'StoreVendorStoreDepartmentAccountsResult'
        nodes: Array<{
          __typename?: 'VendorStoreDepartmentAccount'
          id: string
          name: string
          store?:
            | {
                __typename?: 'Store'
                id: string
                name?: string | null | undefined
              }
            | null
            | undefined
          vendor: {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        }>
      }
    }>
  }
}

export type AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables = Exact<{
  bannerID: Scalars['ID']
  vendorIDs: Array<Scalars['ID']> | Scalars['ID']
  vendorStoreDepartmentAccountIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsGetBannerV2VsdaOrderGuidesQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        stores: {
          __typename?: 'BannerStoresResult'
          nodes: Array<{
            __typename?: 'Store'
            vendorStoreDepartmentAccounts: {
              __typename?: 'StoreVendorStoreDepartmentAccountsResult'
              nodes: Array<{
                __typename?: 'VendorStoreDepartmentAccount'
                id: string
                vendorID: string
                orderGuide?:
                  | {
                      __typename?: 'V2OrderGuide'
                      id: string
                      vendorProductIDs: Array<string>
                    }
                  | null
                  | undefined
              }>
            }
          }>
        }
      }
    | null
    | undefined
}

export type AdminCatalogsCheckInvitationOrderGuideNameQueryVariables = Exact<{
  orderGuideNames: Array<Scalars['String']> | Scalars['String']
  vendorID: Scalars['ID']
}>

export type AdminCatalogsCheckInvitationOrderGuideNameQuery = {
  __typename?: 'Query'
  validateInvitationOrderGuideNames?:
    | {
        __typename?: 'ValidateInvitationOrderGuideNamesResult'
        duplicates: Array<string>
      }
    | null
    | undefined
}

export type AdminCatalogsGetAllBannersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>
  cursor?: InputMaybe<Scalars['String']>
}>

export type AdminCatalogsGetAllBannersQuery = {
  __typename?: 'Query'
  allBanners: {
    __typename?: 'AllBannersResult'
    hasMore: boolean
    cursor: string
    totalCount: number
    nodes: Array<{
      __typename?: 'Banner'
      id: string
      name?: string | null | undefined
      imageURL?: string | null | undefined
    }>
  }
}

export type AdminCatalogsGetAllStoresQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>
  cursor?: InputMaybe<Scalars['String']>
}>

export type AdminCatalogsGetAllStoresQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    hasMore: boolean
    cursor: string
    totalCount: number
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      banner?:
        | {
            __typename?: 'Banner'
            id: string
            imageURL?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminCatalogsGetAllVendorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>
  cursor?: InputMaybe<Scalars['String']>
}>

export type AdminCatalogsGetAllVendorsQuery = {
  __typename?: 'Query'
  allVendors: {
    __typename?: 'AllVendorsResult'
    hasMore: boolean
    cursor: string
    totalCount: number
    nodes: Array<{
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
      imgURL?: string | null | undefined
    }>
  }
}

export type AdminCatalogsGetUsersForOgSelectQueryVariables = Exact<{
  storeID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}>

export type AdminCatalogsGetUsersForOgSelectQuery = {
  __typename?: 'Query'
  retailUsers: {
    __typename?: 'UsersResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'User'
      id: string
      displayName?: string | null | undefined
      email?: string | null | undefined
      userType?: UserType | null | undefined
    }>
  }
  vendorUsers: {
    __typename?: 'UsersResult'
    totalCount: number
    nodes: Array<{
      __typename?: 'User'
      id: string
      displayName?: string | null | undefined
      email?: string | null | undefined
      userType?: UserType | null | undefined
    }>
  }
}

export type AdminCatalogsGetVendorsByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID']
}>

export type AdminCatalogsGetVendorsByIdQuery = {
  __typename?: 'Query'
  adminVendorsByID: {
    __typename?: 'AdminVendorsResult'
    nodes: Array<
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    >
  }
}

export type AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables = Exact<{
  storeID: Scalars['ID']
  includeInactiveVSDAs?: InputMaybe<Scalars['Boolean']>
}>

export type AdminCatalogsGetStoreDepartmentsAndUsersQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        retailUsers: {
          __typename?: 'RetailUsersResult'
          nodes: Array<{
            __typename?: 'RetailUser'
            user: {
              __typename?: 'User'
              id: string
              displayName?: string | null | undefined
              email?: string | null | undefined
              storeDepartments: {
                __typename?: 'StoreDepartmentsResult'
                nodes: Array<{
                  __typename?: 'StoreDepartment'
                  id: string
                  name: string
                }>
              }
            }
          }>
        }
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
            vendorStoreDepartmentAccounts: {
              __typename?: 'VendorStoreDepartmentAccountResult'
              nodes: Array<{
                __typename?: 'VendorStoreDepartmentAccount'
                id: string
                name: string
                vendor: {
                  __typename?: 'Vendor'
                  id: string
                  name?: string | null | undefined
                }
              }>
            }
          }>
        }
      }
    | null
    | undefined
}

export type AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables =
  Exact<{
    bannerID: Scalars['ID']
    includeInactiveVSDAs?: InputMaybe<Scalars['Boolean']>
  }>

export type AdminCatalogsGetBannerStoreDepartmentsAndUsersQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        stores: {
          __typename?: 'BannerStoresResult'
          nodes: Array<{
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
            retailUsers: {
              __typename?: 'RetailUsersResult'
              nodes: Array<{
                __typename?: 'RetailUser'
                user: {
                  __typename?: 'User'
                  id: string
                  displayName?: string | null | undefined
                  email?: string | null | undefined
                  storeDepartments: {
                    __typename?: 'StoreDepartmentsResult'
                    nodes: Array<{
                      __typename?: 'StoreDepartment'
                      id: string
                      name: string
                    }>
                  }
                }
              }>
            }
            storeDepartments: {
              __typename?: 'StoreDepartmentsResult'
              nodes: Array<{
                __typename?: 'StoreDepartment'
                id: string
                name: string
                vendorStoreDepartmentAccounts: {
                  __typename?: 'VendorStoreDepartmentAccountResult'
                  nodes: Array<{
                    __typename?: 'VendorStoreDepartmentAccount'
                    id: string
                    name: string
                    vendor: {
                      __typename?: 'Vendor'
                      id: string
                      name?: string | null | undefined
                    }
                  }>
                }
              }>
            }
          }>
        }
      }
    | null
    | undefined
}

export type AdminCatalogsGetStoreVsdAsQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type AdminCatalogsGetStoreVsdAsQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        vendorStoreDepartmentAccounts: {
          __typename?: 'StoreVendorStoreDepartmentAccountsResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            name: string
            vendor: {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          }>
        }
      }
    | null
    | undefined
}

export type AdminCatalogsGetBannerVsdAsQueryVariables = Exact<{
  bannerID: Scalars['ID']
}>

export type AdminCatalogsGetBannerVsdAsQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        vendorStoreDepartmentAccounts: {
          __typename?: 'BannerVendorStoreDepartmentAccountsResult'
          nodes: Array<{
            __typename?: 'VendorStoreDepartmentAccount'
            id: string
            name: string
            vendor: {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          }>
        }
      }
    | null
    | undefined
}

export type AdminEslUploadSendEslFileUpdateMutationVariables = Exact<{
  file: Scalars['Upload']
  type: EslType
  storeIDs: Array<Scalars['String']> | Scalars['String']
}>

export type AdminEslUploadSendEslFileUpdateMutation = {
  __typename?: 'Mutation'
  sendESLFileUpdate: Array<{
    __typename?: 'SendESLFileUpdateResult'
    status: SendEslFileUpdateLogStatus
    statusMessage: string
  }>
}

export type AdminContainerUserDetailsFragment = {
  __typename?: 'User'
  id: string
  displayName?: string | null | undefined
  email?: string | null | undefined
  userType?: UserType | null | undefined
  signupDate?: Date | string | null | undefined
  phoneNumber?: string | null | undefined
  defaultDepartmentName?: string | null | undefined
  primaryCompanyName?: string | null | undefined
  primaryCompanyID?: string | null | undefined
  primaryCompanyType?: string | null | undefined
  readOnlyOrderGuides?: boolean | null | undefined
}

export type AdminContainerCreateUserMutationVariables = Exact<{
  email: Scalars['String']
  password: Scalars['String']
  userType: UserType
  displayName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  companyID?: InputMaybe<Scalars['String']>
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
}>

export type AdminContainerCreateUserMutation = {
  __typename?: 'Mutation'
  createUser: {
    __typename?: 'User'
    id: string
    displayName?: string | null | undefined
    email?: string | null | undefined
    userType?: UserType | null | undefined
    signupDate?: Date | string | null | undefined
    phoneNumber?: string | null | undefined
    defaultDepartmentName?: string | null | undefined
    primaryCompanyName?: string | null | undefined
    primaryCompanyID?: string | null | undefined
    primaryCompanyType?: string | null | undefined
    readOnlyOrderGuides?: boolean | null | undefined
  }
}

export type AdminContainerUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']
  email: Scalars['String']
  userType: UserType
  displayName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  companyID?: InputMaybe<Scalars['String']>
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
}>

export type AdminContainerUpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'User'
    id: string
    displayName?: string | null | undefined
    email?: string | null | undefined
    userType?: UserType | null | undefined
    signupDate?: Date | string | null | undefined
    phoneNumber?: string | null | undefined
    defaultDepartmentName?: string | null | undefined
    primaryCompanyName?: string | null | undefined
    primaryCompanyID?: string | null | undefined
    primaryCompanyType?: string | null | undefined
    readOnlyOrderGuides?: boolean | null | undefined
  }
}

export type AdminContainerDeleteUserMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type AdminContainerDeleteUserMutation = {
  __typename?: 'Mutation'
  deleteUser: { __typename?: 'DeleteUserResult'; deletedUserID: string }
}

export type AdminContainerGetPaginatedUsersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  filter?: InputMaybe<AdminUsersPaginatedFilters>
}>

export type AdminContainerGetPaginatedUsersQuery = {
  __typename?: 'Query'
  adminUsersPaginated: {
    __typename?: 'UsersResult'
    totalCount: number
    cursor?: string | null | undefined
    hasMore?: boolean | null | undefined
    nodes: Array<{
      __typename?: 'User'
      id: string
      displayName?: string | null | undefined
      email?: string | null | undefined
      userType?: UserType | null | undefined
      signupDate?: Date | string | null | undefined
      phoneNumber?: string | null | undefined
      defaultDepartmentName?: string | null | undefined
      primaryCompanyName?: string | null | undefined
      primaryCompanyID?: string | null | undefined
      primaryCompanyType?: string | null | undefined
      readOnlyOrderGuides?: boolean | null | undefined
    }>
  }
}

export type AdminContainerGetUserByIdQueryVariables = Exact<{
  userID: Scalars['ID']
}>

export type AdminContainerGetUserByIdQuery = {
  __typename?: 'Query'
  userByID?:
    | {
        __typename?: 'User'
        id: string
        displayName?: string | null | undefined
        email?: string | null | undefined
        userType?: UserType | null | undefined
        signupDate?: Date | string | null | undefined
        phoneNumber?: string | null | undefined
        defaultDepartmentName?: string | null | undefined
        primaryCompanyName?: string | null | undefined
        primaryCompanyID?: string | null | undefined
        primaryCompanyType?: string | null | undefined
        readOnlyOrderGuides?: boolean | null | undefined
      }
    | null
    | undefined
}

export type AdminStoresGetAllStoresQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
}>

export type AdminStoresGetAllStoresQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    hasMore: boolean
    totalCount: number
    cursor: string
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      address?: string | null | undefined
      emails: Array<string>
      placeID?: string | null | undefined
      storeType: StoreType
      serialID?: string | null | undefined
      bannerStoreID?: string | null | undefined
      userCount: number
      vendorCount: number
      banner?:
        | {
            __typename?: 'Banner'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminInvitationsSendVendorInvitationMutationVariables = Exact<{
  vendorID: Scalars['ID']
  invitedByStoreID: Scalars['ID']
  invitedByUserID: Scalars['ID']
  email: Scalars['String']
}>

export type AdminInvitationsSendVendorInvitationMutation = {
  __typename?: 'Mutation'
  sendVendorInvitation?:
    | {
        __typename?: 'VendorInvitation'
        id: string
        email: string
        status: InvitationStatus
        invitedByStore?:
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        invitedByUser?:
          | {
              __typename?: 'User'
              id: string
              displayName?: string | null | undefined
              email?: string | null | undefined
            }
          | null
          | undefined
        vendor: {
          __typename?: 'Vendor'
          id: string
          name?: string | null | undefined
        }
      }
    | null
    | undefined
}

export type AdminInvitationsGetStoreInvitationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<InvitationStatus>
  email?: InputMaybe<Scalars['String']>
  signedUpEmail?: InputMaybe<Scalars['String']>
  invitedByUserEmail?: InputMaybe<Scalars['String']>
}>

export type AdminInvitationsGetStoreInvitationsQuery = {
  __typename?: 'Query'
  adminStoreInvitations: {
    __typename?: 'StoreInvitationsResult'
    totalCount: number
    cursor?: string | null | undefined
    hasMore: boolean
    nodes: Array<{
      __typename?: 'StoreInvitation'
      id?: string | null | undefined
      email: string
      status: InvitationStatus
      signedUpEmail?: string | null | undefined
      store: {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
      }
      lastOrderPlaced?:
        | {
            __typename?: 'Order'
            id: string
            totalPrice: number
            orderDateTime: Date | string
          }
        | null
        | undefined
      invitedByUser?:
        | {
            __typename?: 'User'
            id: string
            email?: string | null | undefined
            userType?: UserType | null | undefined
          }
        | null
        | undefined
      invitedByVendor?:
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
            email?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminInvitationsGetVendorInvitationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<InvitationStatus>
  invitedByUserEmail?: InputMaybe<Scalars['String']>
  inviteEmail?: InputMaybe<Scalars['String']>
}>

export type AdminInvitationsGetVendorInvitationsQuery = {
  __typename?: 'Query'
  adminVendorInvitations: {
    __typename?: 'AdminVendorInvitationsResult'
    totalCount: number
    cursor?: string | null | undefined
    hasMore: boolean
    nodes: Array<{
      __typename?: 'VendorInvitation'
      id: string
      status: InvitationStatus
      email: string
      invitedByStore?:
        | {
            __typename?: 'Store'
            id: string
            name?: string | null | undefined
            emails: Array<string>
          }
        | null
        | undefined
      invitedByUser?:
        | {
            __typename?: 'User'
            id: string
            email?: string | null | undefined
            userType?: UserType | null | undefined
          }
        | null
        | undefined
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
      }
    }>
  }
}

export type AdminStoresStoreDetailsFieldsFragment = {
  __typename?: 'Store'
  id: string
  name?: string | null | undefined
  address?: string | null | undefined
  emails: Array<string>
  placeID?: string | null | undefined
  bannerStoreID?: string | null | undefined
  storeType: StoreType
  acquisitionSource?: AcquisitionSource | null | undefined
  acquisitionDetail?: string | null | undefined
  supports_wic: boolean
  referredByCompany?:
    | { __typename?: 'Store'; id: string; name?: string | null | undefined }
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
  storeDepartments: {
    __typename?: 'StoreDepartmentsResult'
    nodes: Array<{ __typename?: 'StoreDepartment'; id: string; name: string }>
  }
  banner?:
    | { __typename?: 'Banner'; id: string; name?: string | null | undefined }
    | null
    | undefined
  buyerUsers: {
    __typename?: 'BuyerUsersResult'
    nodes: Array<{
      __typename?: 'User'
      id: string
      displayName?: string | null | undefined
      email?: string | null | undefined
      userType?: UserType | null | undefined
      defaultDepartmentName?: string | null | undefined
    }>
  }
}

export type AdminStoresStoreDepartmentDetailsFragment = {
  __typename?: 'StoreDepartment'
  id: string
  name: string
}

export type AdminStoresVendorStoreDepartmentAccountDetailsFragment = {
  __typename?: 'VendorStoreDepartmentAccount'
  id: string
  name: string
  accountNumber?: string | null | undefined
  dunsNumber?: string | null | undefined
  orderDeadline?: string | null | undefined
  defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
  orderSubmissionMethod?: SubmissionMethod | null | undefined
  orderSubmissionUOMLock?: UomLock | null | undefined
  status: VendorStoreDepartmentAccountStatus
  storeDepartment: { __typename?: 'StoreDepartment'; id: string; name: string }
  storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
  vendorEmails: Array<{
    __typename?: 'VendorEmail'
    type: VendorEmailType
    email: string
  }>
  vendor: {
    __typename?: 'Vendor'
    id: string
    name?: string | null | undefined
    imgURL?: string | null | undefined
  }
}

export type AdminStoresUpdateStoreMutationVariables = Exact<{
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  address?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  storeType?: InputMaybe<StoreType>
  vendorIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  acquisitionDetail?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  supportsWic?: InputMaybe<Scalars['Boolean']>
}>

export type AdminStoresUpdateStoreMutation = {
  __typename?: 'Mutation'
  updateStore: {
    __typename?: 'Store'
    id: string
    name?: string | null | undefined
    address?: string | null | undefined
    emails: Array<string>
    placeID?: string | null | undefined
    bannerStoreID?: string | null | undefined
    storeType: StoreType
    acquisitionSource?: AcquisitionSource | null | undefined
    acquisitionDetail?: string | null | undefined
    supports_wic: boolean
    referredByCompany?:
      | { __typename?: 'Store'; id: string; name?: string | null | undefined }
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
    storeDepartments: {
      __typename?: 'StoreDepartmentsResult'
      nodes: Array<{ __typename?: 'StoreDepartment'; id: string; name: string }>
    }
    banner?:
      | { __typename?: 'Banner'; id: string; name?: string | null | undefined }
      | null
      | undefined
    buyerUsers: {
      __typename?: 'BuyerUsersResult'
      nodes: Array<{
        __typename?: 'User'
        id: string
        displayName?: string | null | undefined
        email?: string | null | undefined
        userType?: UserType | null | undefined
        defaultDepartmentName?: string | null | undefined
      }>
    }
  }
}

export type AdminStoresUpdateVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    accountNumber?: InputMaybe<Scalars['String']>
    dunsNumber?: InputMaybe<Scalars['String']>
    defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
    orderSubmissionUOMLock?: InputMaybe<UomLock>
    id: Scalars['ID']
    name?: InputMaybe<Scalars['String']>
    orderDeadline?: InputMaybe<Scalars['String']>
    orderSubmissionMethod?: InputMaybe<SubmissionMethod>
    status?: InputMaybe<VendorStoreDepartmentAccountStatus>
    storeEmails?: InputMaybe<Array<StoreEmailInput> | StoreEmailInput>
    vendorEmails?: InputMaybe<Array<VendorEmailInput> | VendorEmailInput>
  }>

export type AdminStoresUpdateVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  updateVendorStoreDepartmentAccount: {
    __typename?: 'VendorStoreDepartmentAccount'
    id: string
    name: string
    accountNumber?: string | null | undefined
    dunsNumber?: string | null | undefined
    orderDeadline?: string | null | undefined
    defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
    orderSubmissionMethod?: SubmissionMethod | null | undefined
    orderSubmissionUOMLock?: UomLock | null | undefined
    status: VendorStoreDepartmentAccountStatus
    storeDepartment: {
      __typename?: 'StoreDepartment'
      id: string
      name: string
    }
    storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
    vendorEmails: Array<{
      __typename?: 'VendorEmail'
      type: VendorEmailType
      email: string
    }>
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
      imgURL?: string | null | undefined
    }
  }
}

export type AdminStoresCreateStoreDepartmentMutationVariables = Exact<{
  storeID: Scalars['ID']
  departmentName: Scalars['String']
}>

export type AdminStoresCreateStoreDepartmentMutation = {
  __typename?: 'Mutation'
  createStoreDepartment: {
    __typename?: 'StoreDepartment'
    id: string
    name: string
  }
}

export type AdminStoresCreateVendorStoreDepartmentAccountMutationVariables =
  Exact<{
    vendorID: Scalars['String']
    storeDepartmentID: Scalars['String']
  }>

export type AdminStoresCreateVendorStoreDepartmentAccountMutation = {
  __typename?: 'Mutation'
  createVendorStoreDepartmentAccount: {
    __typename?: 'VendorStoreDepartmentAccount'
    id: string
    name: string
    accountNumber?: string | null | undefined
    dunsNumber?: string | null | undefined
    orderDeadline?: string | null | undefined
    defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
    orderSubmissionMethod?: SubmissionMethod | null | undefined
    orderSubmissionUOMLock?: UomLock | null | undefined
    status: VendorStoreDepartmentAccountStatus
    storeDepartment: {
      __typename?: 'StoreDepartment'
      id: string
      name: string
    }
    storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
    vendorEmails: Array<{
      __typename?: 'VendorEmail'
      type: VendorEmailType
      email: string
    }>
    vendor: {
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
      imgURL?: string | null | undefined
    }
  }
}

export type AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationVariables =
  Exact<{
    input:
      | Array<CreateVendorStoreDepartmentAccountForm>
      | CreateVendorStoreDepartmentAccountForm
  }>

export type AdminStoresBulkCreateVendorStoreDepartmentAccountsMutation = {
  __typename?: 'Mutation'
  bulkCreateVendorStoreDepartmentAccounts: {
    __typename?: 'BulkCreateVendorStoreDepartmentAccountsResult'
    nodes?:
      | Array<{
          __typename?: 'VendorStoreDepartmentAccount'
          id: string
          name: string
          accountNumber?: string | null | undefined
          dunsNumber?: string | null | undefined
          orderDeadline?: string | null | undefined
          defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
          orderSubmissionMethod?: SubmissionMethod | null | undefined
          orderSubmissionUOMLock?: UomLock | null | undefined
          status: VendorStoreDepartmentAccountStatus
          storeDepartment: {
            __typename?: 'StoreDepartment'
            id: string
            name: string
          }
          storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
          vendorEmails: Array<{
            __typename?: 'VendorEmail'
            type: VendorEmailType
            email: string
          }>
          vendor: {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
            imgURL?: string | null | undefined
          }
        }>
      | null
      | undefined
    errors?:
      | Array<{
          __typename?: 'BulkCreateVendorStoreDepartmentAccountsErrors'
          storeDepartmentID: string
          vendorID: string
          errors?: Array<string> | null | undefined
        }>
      | null
      | undefined
  }
}

export type AdminStoresCreateUserStoreDepartmentMutationVariables = Exact<{
  userID: Scalars['ID']
  storeDepartmentID: Scalars['ID']
}>

export type AdminStoresCreateUserStoreDepartmentMutation = {
  __typename?: 'Mutation'
  createUserStoreDepartment: {
    __typename?: 'UserStoreDepartment'
    id: string
    user: { __typename?: 'User'; id: string }
    storeDepartment: {
      __typename?: 'StoreDepartment'
      id: string
      name: string
      store: { __typename?: 'Store'; id: string }
    }
  }
}

export type AdminStoresDeleteUserStoreDepartmentMutationVariables = Exact<{
  userStoreDepartmentID: Scalars['ID']
}>

export type AdminStoresDeleteUserStoreDepartmentMutation = {
  __typename?: 'Mutation'
  deleteUserStoreDepartment: {
    __typename?: 'UserStoreDepartment'
    id: string
    user: { __typename?: 'User'; id: string }
    storeDepartment: {
      __typename?: 'StoreDepartment'
      id: string
      name: string
      store: { __typename?: 'Store'; id: string }
    }
  }
}

export type AdminStoresUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']
  defaultDepartmentName?: InputMaybe<Scalars['String']>
}>

export type AdminStoresUpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'User'
    id: string
    defaultDepartmentName?: string | null | undefined
  }
}

export type AdminStoresGetPaginatedStoresQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
}>

export type AdminStoresGetPaginatedStoresQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    hasMore: boolean
    totalCount: number
    cursor: string
    nodes: Array<{
      __typename?: 'Store'
      id: string
      serialID?: string | null | undefined
      firestoreID?: string | null | undefined
      name?: string | null | undefined
      address?: string | null | undefined
      emails: Array<string>
      placeID?: string | null | undefined
      storeType: StoreType
      bannerStoreID?: string | null | undefined
      userCount: number
      vendorCount: number
      banner?:
        | {
            __typename?: 'Banner'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminStoresGetPaginatedVendorsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type AdminStoresGetPaginatedVendorsQuery = {
  __typename?: 'Query'
  allVendors: {
    __typename?: 'AllVendorsResult'
    totalCount: number
    cursor: string
    hasMore: boolean
    nodes: Array<{
      __typename?: 'Vendor'
      id: string
      name?: string | null | undefined
      imgURL?: string | null | undefined
    }>
  }
}

export type AdminStoresGetStoreDetailsQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type AdminStoresGetStoreDetailsQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        id: string
        name?: string | null | undefined
        address?: string | null | undefined
        emails: Array<string>
        placeID?: string | null | undefined
        bannerStoreID?: string | null | undefined
        storeType: StoreType
        acquisitionSource?: AcquisitionSource | null | undefined
        acquisitionDetail?: string | null | undefined
        supports_wic: boolean
        referredByCompany?:
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
            }
          | {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
          }>
        }
        banner?:
          | {
              __typename?: 'Banner'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
        buyerUsers: {
          __typename?: 'BuyerUsersResult'
          nodes: Array<{
            __typename?: 'User'
            id: string
            displayName?: string | null | undefined
            email?: string | null | undefined
            userType?: UserType | null | undefined
            defaultDepartmentName?: string | null | undefined
          }>
        }
      }
    | null
    | undefined
}

export type AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables =
  Exact<{
    storeID: Scalars['ID']
  }>

export type AdminStoresGetVendorStoreDepartmentAccountsForStoreQuery = {
  __typename?: 'Query'
  getVendorStoreDepartmentAccountsForStore: {
    __typename?: 'VendorStoreDepartmentAccountResult'
    nodes: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      id: string
      name: string
      accountNumber?: string | null | undefined
      dunsNumber?: string | null | undefined
      orderDeadline?: string | null | undefined
      defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
      orderSubmissionMethod?: SubmissionMethod | null | undefined
      orderSubmissionUOMLock?: UomLock | null | undefined
      status: VendorStoreDepartmentAccountStatus
      storeDepartment: {
        __typename?: 'StoreDepartment'
        id: string
        name: string
      }
      storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
      vendorEmails: Array<{
        __typename?: 'VendorEmail'
        type: VendorEmailType
        email: string
      }>
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        imgURL?: string | null | undefined
      }
    }>
  }
}

export type AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables =
  Exact<{
    vendorID: Scalars['ID']
    storeID: Scalars['ID']
  }>

export type AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery = {
  __typename?: 'Query'
  getVendorStoreDepartmentAccountsForVendorAndStore: {
    __typename?: 'VendorStoreDepartmentAccountResult'
    nodes: Array<{
      __typename?: 'VendorStoreDepartmentAccount'
      id: string
      name: string
      accountNumber?: string | null | undefined
      dunsNumber?: string | null | undefined
      orderDeadline?: string | null | undefined
      defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
      orderSubmissionMethod?: SubmissionMethod | null | undefined
      orderSubmissionUOMLock?: UomLock | null | undefined
      status: VendorStoreDepartmentAccountStatus
      storeDepartment: {
        __typename?: 'StoreDepartment'
        id: string
        name: string
      }
      storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
      vendorEmails: Array<{
        __typename?: 'VendorEmail'
        type: VendorEmailType
        email: string
      }>
      vendor: {
        __typename?: 'Vendor'
        id: string
        name?: string | null | undefined
        imgURL?: string | null | undefined
      }
    }>
  }
}

export type AdminStoresGetStoreDepartmentsForStoreQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type AdminStoresGetStoreDepartmentsForStoreQuery = {
  __typename?: 'Query'
  storeByID?:
    | {
        __typename?: 'Store'
        storeDepartments: {
          __typename?: 'StoreDepartmentsResult'
          nodes: Array<{
            __typename?: 'StoreDepartment'
            id: string
            name: string
          }>
        }
      }
    | null
    | undefined
}

export type AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables =
  Exact<{
    storeDepartmentID: Scalars['ID']
  }>

export type AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery =
  {
    __typename?: 'Query'
    getStoreDepartmentByID?:
      | {
          __typename?: 'StoreDepartment'
          id: string
          vendorStoreDepartmentAccounts: {
            __typename?: 'VendorStoreDepartmentAccountResult'
            nodes: Array<{
              __typename?: 'VendorStoreDepartmentAccount'
              id: string
              name: string
              accountNumber?: string | null | undefined
              dunsNumber?: string | null | undefined
              orderDeadline?: string | null | undefined
              defaultUnitOfMeasure?: UnitOfMeasure | null | undefined
              orderSubmissionMethod?: SubmissionMethod | null | undefined
              orderSubmissionUOMLock?: UomLock | null | undefined
              status: VendorStoreDepartmentAccountStatus
              storeDepartment: {
                __typename?: 'StoreDepartment'
                id: string
                name: string
              }
              storeEmails: Array<{ __typename?: 'StoreEmail'; email: string }>
              vendorEmails: Array<{
                __typename?: 'VendorEmail'
                type: VendorEmailType
                email: string
              }>
              vendor: {
                __typename?: 'Vendor'
                id: string
                name?: string | null | undefined
                imgURL?: string | null | undefined
              }
            }>
          }
        }
      | null
      | undefined
  }

export type VendorDetailsFragment = {
  __typename?: 'Vendor'
  id: string
  headerImageURL?: string | null | undefined
  description?: string | null | undefined
  email?: string | null | undefined
  imgURL?: string | null | undefined
  name?: string | null | undefined
  orderMin?: number | null | undefined
  orderDeadline?: string | null | undefined
  lockUOMSelection?: UomLock | null | undefined
  status: VendorStatus
  misscanPolicy?: VendorMisscanPolicy | null | undefined
  useAccountMetadataEmailOverVendorEmail: boolean
  showImages?: boolean | null | undefined
  isInventoryEnabled: boolean
  address?: string | null | undefined
  acquisitionSource?: AcquisitionSource | null | undefined
  vendorManagedCatalog?: boolean | null | undefined
  orderSubmissionUOMLock?: UomLock | null | undefined
  orderMinimums?:
    | Array<{
        __typename?: 'VendorOrderMinimum'
        storeID: string
        orderMin: number
      }>
    | null
    | undefined
  billingInfo?:
    | {
        __typename?: 'BillingInfo'
        billingEmail: string
        billingType: BillingType
        perOrderCharge: number
      }
    | null
    | undefined
  referredByCompany?:
    | { __typename?: 'Store'; id: string; name?: string | null | undefined }
    | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
    | null
    | undefined
}

export type VendorsViewUpdateVendorMutationVariables = Exact<{
  input: UpdateVendorInput
}>

export type VendorsViewUpdateVendorMutation = {
  __typename?: 'Mutation'
  updateVendor: {
    __typename?: 'Vendor'
    id: string
    headerImageURL?: string | null | undefined
    description?: string | null | undefined
    email?: string | null | undefined
    imgURL?: string | null | undefined
    name?: string | null | undefined
    orderMin?: number | null | undefined
    orderDeadline?: string | null | undefined
    lockUOMSelection?: UomLock | null | undefined
    status: VendorStatus
    misscanPolicy?: VendorMisscanPolicy | null | undefined
    useAccountMetadataEmailOverVendorEmail: boolean
    showImages?: boolean | null | undefined
    isInventoryEnabled: boolean
    address?: string | null | undefined
    acquisitionSource?: AcquisitionSource | null | undefined
    vendorManagedCatalog?: boolean | null | undefined
    orderSubmissionUOMLock?: UomLock | null | undefined
    orderMinimums?:
      | Array<{
          __typename?: 'VendorOrderMinimum'
          storeID: string
          orderMin: number
        }>
      | null
      | undefined
    billingInfo?:
      | {
          __typename?: 'BillingInfo'
          billingEmail: string
          billingType: BillingType
          perOrderCharge: number
        }
      | null
      | undefined
    referredByCompany?:
      | { __typename?: 'Store'; id: string; name?: string | null | undefined }
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
  }
}

export type VendorsViewCreateVendorMutationVariables = Exact<{
  input: CreateVendorInput
}>

export type VendorsViewCreateVendorMutation = {
  __typename?: 'Mutation'
  createVendor: {
    __typename?: 'Vendor'
    id: string
    headerImageURL?: string | null | undefined
    description?: string | null | undefined
    email?: string | null | undefined
    imgURL?: string | null | undefined
    name?: string | null | undefined
    orderMin?: number | null | undefined
    orderDeadline?: string | null | undefined
    lockUOMSelection?: UomLock | null | undefined
    status: VendorStatus
    misscanPolicy?: VendorMisscanPolicy | null | undefined
    useAccountMetadataEmailOverVendorEmail: boolean
    showImages?: boolean | null | undefined
    isInventoryEnabled: boolean
    address?: string | null | undefined
    acquisitionSource?: AcquisitionSource | null | undefined
    vendorManagedCatalog?: boolean | null | undefined
    orderSubmissionUOMLock?: UomLock | null | undefined
    orderMinimums?:
      | Array<{
          __typename?: 'VendorOrderMinimum'
          storeID: string
          orderMin: number
        }>
      | null
      | undefined
    billingInfo?:
      | {
          __typename?: 'BillingInfo'
          billingEmail: string
          billingType: BillingType
          perOrderCharge: number
        }
      | null
      | undefined
    referredByCompany?:
      | { __typename?: 'Store'; id: string; name?: string | null | undefined }
      | { __typename?: 'Vendor'; id: string; name?: string | null | undefined }
      | null
      | undefined
  }
}

export type AdminVendorsGetAllStoresQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  search?: InputMaybe<Scalars['String']>
}>

export type AdminVendorsGetAllStoresQuery = {
  __typename?: 'Query'
  allStores: {
    __typename?: 'AllStoresResult'
    cursor: string
    hasMore: boolean
    nodes: Array<{
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      address?: string | null | undefined
      emails: Array<string>
      placeID?: string | null | undefined
      storeType: StoreType
      bannerStoreID?: string | null | undefined
      banner?:
        | {
            __typename?: 'Banner'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminVendorsGetPaginatedVendorsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  search?: InputMaybe<Scalars['String']>
  filterStoreVendors?: InputMaybe<Scalars['Boolean']>
}>

export type AdminVendorsGetPaginatedVendorsQuery = {
  __typename?: 'Query'
  allVendors: {
    __typename?: 'AllVendorsResult'
    totalCount: number
    cursor: string
    hasMore: boolean
    nodes: Array<{
      __typename?: 'Vendor'
      id: string
      description?: string | null | undefined
      email?: string | null | undefined
      imgURL?: string | null | undefined
      name?: string | null | undefined
      orderMin?: number | null | undefined
      orderDeadline?: string | null | undefined
      lockUOMSelection?: UomLock | null | undefined
      status: VendorStatus
      misscanPolicy?: VendorMisscanPolicy | null | undefined
      useAccountMetadataEmailOverVendorEmail: boolean
      showImages?: boolean | null | undefined
      isInventoryEnabled: boolean
      address?: string | null | undefined
      acquisitionSource?: AcquisitionSource | null | undefined
      orderSubmissionUOMLock?: UomLock | null | undefined
      headerImageURL?: string | null | undefined
      referredByCompany?:
        | { __typename?: 'Store'; id: string; name?: string | null | undefined }
        | {
            __typename?: 'Vendor'
            id: string
            name?: string | null | undefined
          }
        | null
        | undefined
    }>
  }
}

export type AdminVendorsGetVendorByIdQueryVariables = Exact<{
  vendorID: Scalars['ID']
}>

export type AdminVendorsGetVendorByIdQuery = {
  __typename?: 'Query'
  vendorByID?:
    | {
        __typename?: 'Vendor'
        id: string
        description?: string | null | undefined
        email?: string | null | undefined
        imgURL?: string | null | undefined
        name?: string | null | undefined
        orderMin?: number | null | undefined
        orderDeadline?: string | null | undefined
        lockUOMSelection?: UomLock | null | undefined
        status: VendorStatus
        misscanPolicy?: VendorMisscanPolicy | null | undefined
        useAccountMetadataEmailOverVendorEmail: boolean
        showImages?: boolean | null | undefined
        isInventoryEnabled: boolean
        address?: string | null | undefined
        acquisitionSource?: AcquisitionSource | null | undefined
        orderSubmissionUOMLock?: UomLock | null | undefined
        vendorManagedCatalog?: boolean | null | undefined
        headerImageURL?: string | null | undefined
        orderMinimums?:
          | Array<{
              __typename?: 'VendorOrderMinimum'
              storeID: string
              orderMin: number
            }>
          | null
          | undefined
        orderDeadlineInfo?:
          | {
              __typename?: 'VendorOrderDeadlineInfo'
              timezone: string
              orderDeadlines: Array<{
                __typename?: 'VendorOrderDeadline'
                deadlineDay: DayOfWeek
                deliveryDay: DayOfWeek
                deadlineTime?: string | null | undefined
              }>
            }
          | null
          | undefined
        referredByCompany?:
          | {
              __typename?: 'Store'
              id: string
              name?: string | null | undefined
            }
          | {
              __typename?: 'Vendor'
              id: string
              name?: string | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type BackOfficeGetCurrentUserStoresQueryVariables = Exact<{
  [key: string]: never
}>

export type BackOfficeGetCurrentUserStoresQuery = {
  __typename?: 'Query'
  me?:
    | {
        __typename?: 'Viewer'
        user: {
          __typename?: 'User'
          id: string
          retailUser?:
            | {
                __typename?: 'RetailUser'
                retailCompany: {
                  __typename?: 'RetailCompany'
                  banner?:
                    | {
                        __typename?: 'Banner'
                        id: string
                        stores: {
                          __typename?: 'BannerStoresResult'
                          nodes: Array<{
                            __typename?: 'Store'
                            id: string
                            local_iana_timezone?: string | null | undefined
                            name?: string | null | undefined
                            serialID?: string | null | undefined
                          }>
                        }
                      }
                    | null
                    | undefined
                  store?:
                    | {
                        __typename?: 'Store'
                        id: string
                        local_iana_timezone?: string | null | undefined
                        name?: string | null | undefined
                        serialID?: string | null | undefined
                      }
                    | null
                    | undefined
                }
                user: { __typename?: 'User'; id: string }
              }
            | null
            | undefined
        }
      }
    | null
    | undefined
}

export type CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables = Exact<{
  storeID: Scalars['ID']
}>

export type CreateInvoiceGetStoreDepartmentsByStoreIdQuery = {
  __typename?: 'Query'
  storeDepartmentsForCompany: {
    __typename?: 'StoreDepartmentViewConnection'
    edges: Array<{
      __typename?: 'StoreDepartmentEdge'
      node: {
        __typename?: 'StoreDepartment'
        id: string
        name: string
        deactivatedAt?: any | null | undefined
        store: {
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
        }
      }
    }>
  }
}

export type GetUnitOfMeasureValuesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUnitOfMeasureValuesQuery = {
  __typename?: 'Query'
  __type?:
    | {
        __typename?: '__Type'
        enumValues?:
          | Array<{ __typename?: '__EnumValue'; name: string }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type RetailBulkUpdateStoreDepartmentsMutationVariables = Exact<{
  data: BulkUpdateStoreDepartmentsInput
}>

export type RetailBulkUpdateStoreDepartmentsMutation = {
  __typename?: 'Mutation'
  bulkUpdateStoreDepartments: Array<{
    __typename?: 'StoreDepartment'
    id: string
    storeID: string
    name: string
    deactivatedAt?: any | null | undefined
    imageURL?: string | null | undefined
    parentDepartment?:
      | { __typename?: 'StoreDepartment'; id: string; name: string }
      | null
      | undefined
  }>
}

export type RetailBulkAddStoreDepartmentMutationVariables = Exact<{
  data: CreateStoreDepartmentsInput
}>

export type RetailBulkAddStoreDepartmentMutation = {
  __typename?: 'Mutation'
  createStoreDepartments: Array<{
    __typename?: 'StoreDepartment'
    id: string
    storeID: string
    imageURL?: string | null | undefined
    name: string
    deactivatedAt?: any | null | undefined
    parentDepartment?:
      | { __typename?: 'StoreDepartment'; id: string; name: string }
      | null
      | undefined
  }>
}

export type RetailGetStoreDepartmentsQueryVariables = Exact<{
  bannerID: Scalars['ID']
  filterByStoreID?: InputMaybe<Scalars['ID']>
}>

export type RetailGetStoreDepartmentsQuery = {
  __typename?: 'Query'
  storeDepartments: Array<{
    __typename?: 'StoreDepartment'
    id: string
    name: string
    storeID: string
    deactivatedAt?: any | null | undefined
    productCount: number
    imageURL?: string | null | undefined
    parentDepartment?:
      | { __typename?: 'StoreDepartment'; id: string; name: string }
      | null
      | undefined
    subDepartments?:
      | Array<{ __typename?: 'StoreDepartment'; id: string; name: string }>
      | null
      | undefined
    store: {
      __typename?: 'Store'
      id: string
      serialID?: string | null | undefined
      name?: string | null | undefined
    }
  }>
}

export type RetailGetDepartmentByIdQueryVariables = Exact<{
  departmentID: Scalars['ID']
}>

export type RetailGetDepartmentByIdQuery = {
  __typename?: 'Query'
  getStoreDepartmentByID?:
    | {
        __typename?: 'StoreDepartment'
        id: string
        name: string
        deactivatedAt?: any | null | undefined
        storeID: string
        productCount: number
        imageURL?: string | null | undefined
        parentDepartment?:
          | { __typename?: 'StoreDepartment'; id: string; name: string }
          | null
          | undefined
        subDepartments?:
          | Array<{ __typename?: 'StoreDepartment'; id: string; name: string }>
          | null
          | undefined
        store: {
          __typename?: 'Store'
          id: string
          name?: string | null | undefined
        }
      }
    | null
    | undefined
}

export type FrontOfficeGetBannerByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type FrontOfficeGetBannerByIdQuery = {
  __typename?: 'Query'
  bannerByID?:
    | {
        __typename?: 'Banner'
        id: string
        name?: string | null | undefined
        frontOfficeURL?: string | null | undefined
      }
    | null
    | undefined
}

export type FrontOfficeGetMetabaseDashboardQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type FrontOfficeGetMetabaseDashboardQueryQuery = {
  __typename?: 'Query'
  getMetabaseDashboardForUserQuery: string
}

export type FrontOfficeGetExploDashboardQueryQueryVariables = Exact<{
  [key: string]: never
}>

export type FrontOfficeGetExploDashboardQueryQuery = {
  __typename?: 'Query'
  getExploDashboardForUserQuery: {
    __typename?: 'ExploConfig'
    customerToken: string
    metricsURL: string
    reportBuilderURL: string
    timezone: string
    overviewURL: string
    promotionsURL: string
    transactionsURL: string
    tillsURL: string
    eodURL: string
    loyaltyURL: string
  }
}

export type ApIntegrationsMapIntegrationRecordsMutationVariables = Exact<{
  sourceID: Scalars['ID']
  sourceType: AccountingIntegrationSourceType
  targetID?: InputMaybe<Scalars['ID']>
  targetType: AccountingIntegrationTargetType
}>

export type ApIntegrationsMapIntegrationRecordsMutation = {
  __typename?: 'Mutation'
  mapAccountingIntegrationRecords: boolean
}

export type ApIntegrationsGetConfigurationQueryVariables = Exact<{
  [key: string]: never
}>

export type ApIntegrationsGetConfigurationQuery = {
  __typename?: 'Query'
  accountingIntegrationMappingConfiguration: {
    __typename?: 'AccountingIntegrationMappingConfig'
    tabs: Array<{
      __typename?: 'AccountingIntegrationModelMapping'
      source: {
        __typename?: 'AccountingIntegrationSourceModel'
        name: string
        type: AccountingIntegrationSourceType
      }
      target: {
        __typename?: 'AccountingIntegrationTargetModel'
        name: string
        type: AccountingIntegrationTargetType
      }
    }>
  }
}

export type ApIntegrationsGetRecordsQueryVariables = Exact<{
  sourceType: AccountingIntegrationSourceType
  storeIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
  targetType: AccountingIntegrationTargetType
}>

export type ApIntegrationsGetRecordsQuery = {
  __typename?: 'Query'
  accountingIntegrationRecords: {
    __typename?: 'AccountingIntegrationRecords'
    sourceRecords: Array<{
      __typename?: 'AccountingIntegrationSourceRecord'
      id: string
      imageURL: string
      name: string
      targetRecordID?: string | null | undefined
      details: {
        __typename?: 'AccountingIntegrationSourceDetails'
        header: string
        subtitle?: string | null | undefined
        title: string
      }
    }>
    targetRecords: Array<{
      __typename?: 'AccountingIntegrationTargetRecord'
      id: string
      name: string
    }>
  }
}

export type RetailStoreProductFragment = {
  __typename?: 'GQLStoreProduct'
  id: string
  active: boolean
  name: string
  storeID: string
  storeDepartmentID: string
  upc: string
  barcode: string
  price?: any | null | undefined
  brand?: string | null | undefined
  wicEnabled: boolean
  targetMargin?: number | null | undefined
  loyaltyPoints?: any | null | undefined
  minCustomerAge: number
  caseSize?: number | null | undefined
  snapEnabled: boolean
  ebtEnabled: boolean
  ecommerceEnabled: boolean
  variableSalePrice: boolean
  soldByWeight: boolean
  unitOfMeasure?: string | null | undefined
  unitOfMeasureAmount?: any | null | undefined
  retailPriceUnitOfMeasureID?: string | null | undefined
  taxRates: Array<{
    __typename?: 'GQLTaxRate'
    id: string
    name: string
    value: string
    status: boolean
  }>
}

export type RetailUpdateStoreProductMutationVariables = Exact<{
  id: Scalars['String']
  data: EditableStoreProductFields
}>

export type RetailUpdateStoreProductMutation = {
  __typename?: 'Mutation'
  updateStoreProduct: {
    __typename?: 'GQLStoreProduct'
    id: string
    active: boolean
    name: string
    storeID: string
    storeDepartmentID: string
    upc: string
    barcode: string
    price?: any | null | undefined
    brand?: string | null | undefined
    wicEnabled: boolean
    targetMargin?: number | null | undefined
    loyaltyPoints?: any | null | undefined
    minCustomerAge: number
    caseSize?: number | null | undefined
    snapEnabled: boolean
    ebtEnabled: boolean
    ecommerceEnabled: boolean
    variableSalePrice: boolean
    soldByWeight: boolean
    unitOfMeasure?: string | null | undefined
    unitOfMeasureAmount?: any | null | undefined
    retailPriceUnitOfMeasureID?: string | null | undefined
    taxRates: Array<{
      __typename?: 'GQLTaxRate'
      id: string
      name: string
      value: string
      status: boolean
    }>
  }
}

export type BackOfficeProductManagementBulkUpdateStoreProductsMutationVariables =
  Exact<{
    ids: Array<Scalars['ID']> | Scalars['ID']
    data: EditableStoreProductFields
  }>

export type BackOfficeProductManagementBulkUpdateStoreProductsMutation = {
  __typename?: 'Mutation'
  bulkUpdateStoreProducts: Array<{ __typename?: 'GQLStoreProduct'; id: string }>
}

export type RetailAddStoreProductMutationVariables = Exact<{
  data: CreateStoreProductsInput
}>

export type RetailAddStoreProductMutation = {
  __typename?: 'Mutation'
  createStoreProducts: Array<{
    __typename?: 'GQLStoreProduct'
    id: string
    active: boolean
    name: string
    storeID: string
    storeDepartmentID: string
    upc: string
    barcode: string
    price?: any | null | undefined
    brand?: string | null | undefined
    wicEnabled: boolean
    targetMargin?: number | null | undefined
    loyaltyPoints?: any | null | undefined
    minCustomerAge: number
    caseSize?: number | null | undefined
    snapEnabled: boolean
    ebtEnabled: boolean
    ecommerceEnabled: boolean
    variableSalePrice: boolean
    soldByWeight: boolean
    unitOfMeasure?: string | null | undefined
    unitOfMeasureAmount?: any | null | undefined
    retailPriceUnitOfMeasureID?: string | null | undefined
    taxRates: Array<{
      __typename?: 'GQLTaxRate'
      id: string
      name: string
      value: string
      status: boolean
    }>
  }>
}

export type BackOfficeQueryMasterCatalogQueryVariables = Exact<{
  barcode: Scalars['String']
}>

export type BackOfficeQueryMasterCatalogQuery = {
  __typename?: 'Query'
  queryMasterCatalogProductMetadataByBarcode?:
    | {
        __typename?: 'GQLMasterCatalogProductMetadata'
        brandName?: string | null | undefined
        barcode: string
        caseSize?: number | null | undefined
        unitVolume?: string | null | undefined
        photoURL?: string | null | undefined
        wholesaleEachCost?: number | null | undefined
        source: string
        name: string
        timestamp: any
      }
    | null
    | undefined
}

export type BulkUploadStoreVendorProductsWorkerMutationVariables = Exact<{
  inputProducts:
    | Array<BulkStoreVendorProductInput>
    | BulkStoreVendorProductInput
  overwrite: Scalars['Boolean']
  bannerSQLID: Scalars['ID']
  storeSQLIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type BulkUploadStoreVendorProductsWorkerMutation = {
  __typename?: 'Mutation'
  bulkUploadStoreVendorProductsWorker: {
    __typename?: 'TaskResponse'
    jobID: string
  }
}

export type ValidateBulkUploadStoreVendorProductsQueryVariables = Exact<{
  inputProducts:
    | Array<BulkStoreVendorProductInput>
    | BulkStoreVendorProductInput
  storeSQLIDs: Array<Scalars['ID']> | Scalars['ID']
}>

export type ValidateBulkUploadStoreVendorProductsQuery = {
  __typename?: 'Query'
  validateBulkUploadStoreVendorProducts: Array<{
    __typename?: 'ValidateBulkUploadStoreVendorProductsResult'
    spreadsheetURL: string
    numValidProducts: number
    numProducts: number
    numExistingProducts: number
    numNewProducts: number
    errors: Array<{
      __typename?: 'UploadError'
      index: number
      errorMessages: Array<UploadErrorMessages>
    }>
  }>
}

export type BackOfficeProductManagementExportMutationVariables = Exact<{
  endDate?: InputMaybe<Scalars['Timestamp']>
  filterByStoreProductSQLIDs?: InputMaybe<
    Array<Scalars['String']> | Scalars['String']
  >
  filterByStoreSQLIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  startDate?: InputMaybe<Scalars['Timestamp']>
}>

export type BackOfficeProductManagementExportMutation = {
  __typename?: 'Mutation'
  exportStoreVendorProductsToCSV: string
}

export type BackOfficeGetProductByBarcodeQueryVariables = Exact<{
  barcode: Scalars['String']
  storeID: Scalars['String']
}>

export type BackOfficeGetProductByBarcodeQuery = {
  __typename?: 'Query'
  queryStoreProductByBarcode: Array<{
    __typename?: 'GQLStoreProduct'
    id: string
    name: string
    storeID: string
  }>
}

export type BackOfficeProductManagementExportEplumQueryVariables = Exact<{
  storeID: Scalars['String']
}>

export type BackOfficeProductManagementExportEplumQuery = {
  __typename?: 'Query'
  getEPLUMProductsForStoreQuery: string
}

export type BackOfficeTaxManagementAddTaxRateMutationVariables = Exact<{
  object: MutateTaxRateInput
}>

export type BackOfficeTaxManagementAddTaxRateMutation = {
  __typename?: 'Mutation'
  createTaxRate: {
    __typename?: 'GQLTaxRate'
    id: string
    type: TaxRateType
    value: string
    status: boolean
    createdAt: any
    name: string
  }
}

export type BackOfficeTaxManagementUpdateTaxRateMutationVariables = Exact<{
  object: MutateTaxRateInput
  id: Scalars['String']
}>

export type BackOfficeTaxManagementUpdateTaxRateMutation = {
  __typename?: 'Mutation'
  updateTaxRate: {
    __typename?: 'GQLTaxRate'
    id: string
    type: TaxRateType
    value: string
    status: boolean
    createdAt: any
    name: string
  }
}

export type BackOfficeTaxManagementGetTaxRatesQueryVariables = Exact<{
  [key: string]: never
}>

export type BackOfficeTaxManagementGetTaxRatesQuery = {
  __typename?: 'Query'
  taxRates: Array<{
    __typename?: 'GQLTaxRate'
    createdAt: any
    updatedAt: any
    id: string
    name: string
    productCount: number
    status: boolean
    type: TaxRateType
    taxType: TaxType
    value: string
  }>
}

export type BackOfficeTaxManagementGetTaxRateQueryVariables = Exact<{
  id: Scalars['String']
}>

export type BackOfficeTaxManagementGetTaxRateQuery = {
  __typename?: 'Query'
  taxRate: {
    __typename?: 'GQLTaxRate'
    createdAt: any
    updatedAt: any
    id: string
    name: string
    productCount: number
    status: boolean
    taxType: TaxType
    type: TaxRateType
    value: string
  }
}

export type BackOfficeVendorManagementCreateVendorMutationVariables = Exact<{
  bannerFirestoreID: Scalars['String']
  data: StoreVendorCreateFields
  storeSerialIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type BackOfficeVendorManagementCreateVendorMutation = {
  __typename?: 'Mutation'
  createStoreVendors: Array<{ __typename?: 'GQLStoreVendor'; id: string }>
}

export type BackOfficeVendorManagementUpdateVendorMutationVariables = Exact<{
  data: StoreVendorEditableFields
  id: Scalars['ID']
}>

export type BackOfficeVendorManagementUpdateVendorMutation = {
  __typename?: 'Mutation'
  updateStoreVendor: { __typename?: 'GQLStoreVendor'; id: string }
}

export type BackOfficeVendorManagementSearchVendorsQueryVariables = Exact<{
  query: Scalars['String']
}>

export type BackOfficeVendorManagementSearchVendorsQuery = {
  __typename?: 'Query'
  searchVendors: {
    __typename?: 'SearchVendorsQueryResult'
    nodes: Array<{
      __typename?: 'Vendor'
      id: string
      serialID?: string | null | undefined
      imgURL?: string | null | undefined
      name?: string | null | undefined
    }>
  }
}

export type BackOfficeVendorManagementGetVendorQueryVariables = Exact<{
  id: Scalars['String']
}>

export type BackOfficeVendorManagementGetVendorQuery = {
  __typename?: 'Query'
  storeVendor: {
    __typename?: 'GQLStoreVendor'
    billingName?: string | null | undefined
    contactName?: string | null | undefined
    contactPhone?: string | null | undefined
    deactivatedAt?: any | null | undefined
    id: string
    minOrderValue?: any | null | undefined
    name: string
    ordersEmail?: string | null | undefined
    taxID?: string | null | undefined
    vendorID?: string | null | undefined
    billingAddress?:
      | {
          __typename?: 'AddressComponents'
          addressLine1?: string | null | undefined
          addressLine2?: string | null | undefined
        }
      | null
      | undefined
    store: {
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      serialID?: string | null | undefined
    }
  }
}

export type BackOfficeVendorManagementGetStoreVendorsQueryVariables = Exact<{
  [key: string]: never
}>

export type BackOfficeVendorManagementGetStoreVendorsQuery = {
  __typename?: 'Query'
  storeVendors: Array<{
    __typename?: 'GQLStoreVendor'
    contactName?: string | null | undefined
    contactPhone?: string | null | undefined
    deactivatedAt?: any | null | undefined
    id: string
    name: string
    vendorID?: string | null | undefined
    store: {
      __typename?: 'Store'
      id: string
      name?: string | null | undefined
      serialID?: string | null | undefined
    }
  }>
}

export const ProductsCatalogRetailersStoresFromBannerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProductsCatalog_RetailersStoresFromBannerFields on Store {
    id
    name
    banner {
      id
      name
      stores {
        nodes {
          id
          name
          banner {
            id
          }
        }
      }
    }
  }
`
export const ProductsCatalogVendorProductCatalogFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProductsCatalog_VendorProductCatalogFields on VendorProduct {
    caseSize
    id
    itemCode
    notes
    wholesalePricing {
      casePrice
      unitPrice
    }
    product {
      brandName
      caseUPC
      category
      description
      id
      imgURL
      packUPC
      unitUPC
      unitVolume
    }
    stores {
      ...ProductsCatalog_RetailersStoresFromBannerFields
    }
    vendor {
      id
      name
    }
    isPrivateLabelProduct
    status
    updatedAt
    allRetailerPricing {
      retailCompany {
        id
        name
      }
      pricing {
        casePrice
        unitPrice
      }
    }
    retailerDiscontinuedDates {
      date
      retailCompany {
        id
        name
      }
    }
  }
  ${ProductsCatalogRetailersStoresFromBannerFieldsFragmentDoc}
`
export const ProductsCatalogRetailerSelectStoreFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProductsCatalog_RetailerSelectStoreFields on Store {
    id
    name
    banner {
      id
    }
  }
`
export const ProductsCatalogRetailerSelectBannerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProductsCatalog_RetailerSelectBannerFields on Banner {
    id
    name
    stores {
      nodes {
        ...ProductsCatalog_RetailerSelectStoreFields
      }
    }
  }
  ${ProductsCatalogRetailerSelectStoreFieldsFragmentDoc}
`
export const ProductsCatalogAdminVendorFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProductsCatalog_AdminVendorFields on Vendor {
    id
    name
  }
`
export const RetailBuyersBuyerUserStoreDepartmentFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailBuyers_BuyerUserStoreDepartmentFields on UserStoreDepartment {
    id
    storeDepartment {
      id
      name
      storeID
    }
  }
`
export const RetailBuyersBuyerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailBuyers_BuyerFields on RetailUser {
    user {
      displayName
      id
      email
      defaultDepartmentName
      retailUser {
        user {
          id
        }
        readOnlyOrderGuides
        weeklyOrders(storeID: $storeID) {
          id
        }
        weeklyOrderSpending(storeID: $storeID)
      }
    }
  }
`
export const RetailVendorCatalogOrderGuideCatalogFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailVendorCatalog_OrderGuideCatalogFields on V2OrderGuide {
    id
    vendorStoreDepartmentAccount {
      id
      storeDepartmentID
    }
  }
`
export const RetailVendorCatalogVendorCatalogProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailVendorCatalog_VendorCatalogProductFields on VendorProduct {
    caseSize
    id
    itemCode
    product {
      brandName
      category
      description
      id
      imgURL
      unitUPC
      unitVolume
    }
    stores {
      id
      name
    }
    vendor {
      id
      name
    }
    orderGuides(input: { bannerID: $bannerID }) {
      totalCount
      nodes {
        ...RetailVendorCatalog_OrderGuideCatalogFields
      }
    }
    retailerPricing {
      unitPrice
      casePrice
    }
    activeDeal {
      id
      displayName
    }
    status
    retailerDiscontinuedDates {
      date
      retailCompany {
        id
        name
      }
    }
    isPrivateLabelProduct
  }
  ${RetailVendorCatalogOrderGuideCatalogFieldsFragmentDoc}
`
export const RetailVendorCatalogVendorCatalogFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailVendorCatalog_VendorCatalogFields on Vendor {
    id
    imgURL
    name
  }
`
export const RetailBulkActionStoreDepartmentsFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailBulkAction_StoreDepartmentsFields on Store {
    id
    name
    storeDepartments {
      nodes {
        id
        name
      }
    }
  }
`
export const RetailHomeStoreFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailHome_StoreFields on Store {
    address
    bannerStoreID
    emails
    id
    name
    retailUsers {
      nodes {
        user {
          id
        }
      }
    }
    storeDepartments {
      nodes {
        id
      }
    }
    orders(input: { filterByThisWeek: true }) {
      nodes {
        id
        orderConfirmed
        totalPrice
      }
    }
  }
`
export const RetailOrdersOrderProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailOrders_OrderProductFields on VendorProduct {
    id
    itemCode
    product {
      brandName
      description
      id
      imgURL
      unitUPC
    }
  }
`
export const RetailOrdersOrderLineItemFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailOrders_OrderLineItemFields on OrderLineItem {
    price
    product {
      ...RetailOrders_OrderProductFields
    }
    quantity
    unitOfMeasure
  }
  ${RetailOrdersOrderProductFieldsFragmentDoc}
`
export const RetailOrdersOrderFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailOrders_OrderFields on Order {
    accountNumber
    buyerName
    deliveryDate
    id
    itemCount
    noteToVendor
    orderConfirmed
    orderContents {
      ...RetailOrders_OrderLineItemFields
    }
    orderDateTime
    orderEmailOpened
    orderPlaced
    orderPlacedByUserEmail
    purchaseOrderNum
    storeAddress
    storeID
    storeName
    totalPrice
    vendorID
    vendor {
      id
      name
    }
  }
  ${RetailOrdersOrderLineItemFieldsFragmentDoc}
`
export const RetailOrdersOrderStoreFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailOrders_OrderStoreFields on Store {
    id
    name
  }
`
export const RetailOrdersOrderVendorFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailOrders_OrderVendorFields on Vendor {
    id
    name
  }
`
export const RetailStoresStoreBuyerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailStores_StoreBuyerFields on RetailUser {
    user {
      displayName
      id
      retailUser {
        user {
          id
        }
        readOnlyOrderGuides
      }
    }
  }
`
export const RetailStoresStoreFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailStores_StoreFields on Store {
    address
    bannerStoreID
    emails
    id
    name
    storeDepartments {
      nodes {
        id
      }
    }
    retailUsers {
      nodes {
        ...RetailStores_StoreBuyerFields
      }
    }
    orders(input: { filterByThisWeek: true }) {
      nodes {
        id
        orderConfirmed
      }
    }
    vendors {
      nodes {
        id
      }
    }
  }
  ${RetailStoresStoreBuyerFieldsFragmentDoc}
`
export const RetailDepartmentDepartmentVendorFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailDepartment_DepartmentVendorFields on Vendor {
    email
    id
    imgURL
    name
    orderMin
    orderMinimums {
      orderMin
      storeID
    }
  }
`
export const RetailDepartmentVendorStoreDepartmentAccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailDepartment_VendorStoreDepartmentAccountFields on VendorStoreDepartmentAccount {
    accountNumber
    id
    status
    vendorEmails {
      email
      type
    }
    vendor {
      ...RetailDepartment_DepartmentVendorFields
    }
  }
  ${RetailDepartmentDepartmentVendorFieldsFragmentDoc}
`
export const RetailDepartmentDepartmentOrderFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailDepartment_DepartmentOrderFields on Order {
    accountNumber
    buyerName
    deliveryDate
    id
    itemCount
    noteToVendor
    orderConfirmed
    orderContents {
      price
      product {
        id
        itemCode
        product {
          brandName
          description
          id
          imgURL
          unitUPC
        }
      }
      quantity
      unitOfMeasure
    }
    orderDateTime
    orderEmailOpened
    orderPlaced
    orderPlacedByUserEmail
    purchaseOrderNum
    storeAddress
    storeID
    storeName
    totalPrice
    vendorID
    vendor {
      id
      name
    }
  }
`
export const RetailOrderGuidesVendorProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment RetailOrderGuides_VendorProductFields on VendorProduct {
    caseSize
    id
    itemCode
    notes
    retailerPricing(input: { retailCompanyID: $storeID }) {
      unitPrice
      casePrice
    }
    product {
      brandName
      caseUPC
      category
      description
      id
      imgURL
      unitVolume
      unitUPC
    }
    stores {
      id
      name
    }
    vendor {
      id
      name
    }
    status
    activeDeal {
      displayName
      id
    }
    retailerDiscontinuedDates {
      date
      retailCompany {
        id
        name
      }
    }
  }
`
export const VendorCustomersVendorStoreDepartmentAccountFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorCustomers_VendorStoreDepartmentAccountFields on VendorStoreDepartmentAccount {
    id
    accountActivityStatus
    accountNumber
    storeDepartmentID
    name
    orderSubmissionMethod
    orderDeadlineInfo {
      timezone
      orderDeadlines {
        deadlineDay
        deliveryDay
        deadlineTime
      }
    }
    vendor {
      id
      name
      validOrderSubmissionMethods
    }
    store {
      addressComponents {
        addressLine1
        addressLine2
      }
      retailUsers {
        nodes {
          user {
            defaultDepartmentName
            displayName
            email
            id
            userType
          }
        }
      }
      emails
      id
      name
    }
    storeEmails {
      email
    }
    lastOrder {
      id
      orderDateTime
    }
  }
`
export const VendorOrdersProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorOrders_ProductFields on VendorProduct {
    id
    itemCode
    product {
      brandName
      description
      id
      imgURL
      unitUPC
    }
  }
`
export const VendorOrdersOrderLineItemFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorOrders_OrderLineItemFields on OrderLineItem {
    price
    product {
      ...VendorOrders_ProductFields
    }
    quantity
    unitOfMeasure
  }
  ${VendorOrdersProductFieldsFragmentDoc}
`
export const VendorOrdersMisscanLineItemFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorOrders_MisscanLineItemFields on OrderMisscanLineItem {
    misscanVendorProduct {
      id
      upc
    }
    resolution {
      description
      id
      photoURL
    }
    quantity
    unitOfMeasure
  }
`
export const VendorOrdersOrderFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorOrders_OrderFields on Order {
    accountNumber
    buyerName
    deliveryDate
    id
    itemCount
    noteToVendor
    orderConfirmed
    orderContents {
      ...VendorOrders_OrderLineItemFields
    }
    orderDateTime
    orderEmailOpened
    orderPlaced
    orderPlacedByUserEmail
    erpOrderSent
    purchaseOrderNum
    storeAddress
    storeID
    storeName
    totalPrice
    vendorID
    hasMisscans
    misscans {
      ...VendorOrders_MisscanLineItemFields
    }
  }
  ${VendorOrdersOrderLineItemFieldsFragmentDoc}
  ${VendorOrdersMisscanLineItemFieldsFragmentDoc}
`
export const VendorOrdersStoreFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorOrders_StoreFields on Store {
    id
    name
  }
`
export const VendorProfileProfileFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorProfile_ProfileFields on Vendor {
    id
    misscanPolicy
    description
    email
    name
    orderDeadline
    headerImageURL
    imgURL
    lockUOMSelection
    disableOutOfStockPurchases
    disableDiscontinuedPurchases
    orderMin
    orderMinimums {
      orderMin
      storeID
    }
    isMarketEnabled
    showImages
    slug
    status
    isInventoryEnabled
    address
    acquisitionSource
    defaultOrderSubmissionMethod
    trueCommerceTenetID
    referredByCompany {
      ... on Vendor {
        id
      }
      ... on Store {
        id
      }
    }
  }
`
export const VendorPromotionsAudienceFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPromotions_AudienceFields on Audience {
    id
    name
    prospectiveStoreAccounts {
      totalCount
    }
    storeAccounts {
      nodes {
        vendorID
        store {
          id
          banner {
            id
            stores {
              nodes {
                address
                id
              }
            }
          }
        }
      }
      totalCount
    }
  }
`
export const VendorPromotionsPromotionItemFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPromotions_PromotionItemFields on Promotion {
    audience {
      id
      name
    }
    deals {
      nodes {
        id
        vendorProducts {
          totalCount
        }
      }
    }
    endDate
    id
    isPublished
    name
    startDate
    status
    allAccounts
  }
`
export const VendorPromotionsDealVendorProductFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPromotions_DealVendorProductFields on VendorProduct {
    caseSize
    id
    itemCode
    wholesalePricing {
      casePrice
      unitPrice
    }
    retailerPricing {
      casePrice
      unitPrice
    }
    product {
      id
      brandName
      description
      imgURL
      unitVolume
    }
    vendor {
      id
      name
    }
  }
`
export const VendorPromotionsDealFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPromotions_DealFields on Deal {
    id
    type
    displayName
    vendorDiscountCode
    ... on PercentageDeal {
      basisPoints
    }
    ... on FixedDeal {
      dealValue
      unitOfMeasure
    }
    ... on BuyXGetYFreeDeal {
      unitOfMeasure
      freeCount
      threshold
    }
    vendorProducts {
      totalCount
      nodes {
        ...VendorPromotions_DealVendorProductFields
      }
    }
  }
  ${VendorPromotionsDealVendorProductFieldsFragmentDoc}
`
export const VendorPromotionsPromotionDetailFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPromotions_PromotionDetailFields on Promotion {
    id
    name
    startDate
    endDate
    status
    totalSales
    isPublished
    audience {
      id
      name
    }
    deals {
      nodes {
        ...VendorPromotions_DealFields
      }
    }
    allAccounts
  }
  ${VendorPromotionsDealFieldsFragmentDoc}
`
export const VendorPromotionsPromotionConflictFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorPromotions_PromotionConflictFields on VendorProductPromotionConflict {
    vendorProduct {
      id
    }
    deal {
      id
      type
    }
  }
`
export const AdminBannersBannerFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminBanners_BannerFields on Banner {
    acquisitionDetail
    acquisitionSource
    bannerType
    id
    serialID
    imageURL
    name
    status
    referredByCompany {
      ... on Vendor {
        id
        name
      }
      ... on Store {
        id
        name
      }
    }
    vendorStoreDepartmentAccounts {
      totalCount
    }
    stores {
      nodes {
        id
        name
      }
    }
  }
`
export const AdminContainerUserDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminContainer_UserDetails on User {
    id
    displayName
    email
    userType
    signupDate
    phoneNumber
    defaultDepartmentName
    primaryCompanyName
    primaryCompanyID
    primaryCompanyType
    readOnlyOrderGuides
  }
`
export const AdminStoresStoreDetailsFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminStores_StoreDetailsFields on Store {
    id
    name
    address
    emails
    placeID
    bannerStoreID
    storeType
    acquisitionSource
    acquisitionDetail
    supports_wic
    referredByCompany {
      ... on Vendor {
        id
        name
      }
      ... on Store {
        id
        name
      }
    }
    storeDepartments {
      nodes {
        id
        name
      }
    }
    banner {
      id
      name
    }
    buyerUsers {
      nodes {
        id
        displayName
        email
        userType
        defaultDepartmentName
      }
    }
  }
`
export const AdminStoresStoreDepartmentDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminStores_StoreDepartmentDetails on StoreDepartment {
    id
    name
  }
`
export const AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminStores_VendorStoreDepartmentAccountDetails on VendorStoreDepartmentAccount {
    id
    name
    accountNumber
    dunsNumber
    orderDeadline
    defaultUnitOfMeasure
    orderSubmissionMethod
    orderSubmissionUOMLock
    status
    storeDepartment {
      id
      name
    }
    storeEmails {
      email
    }
    vendorEmails {
      type
      email
    }
    vendor {
      id
      name
      imgURL
    }
  }
`
export const VendorDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment VendorDetails on Vendor {
    id
    headerImageURL
    description
    email
    imgURL
    name
    orderMin
    orderMinimums {
      storeID
      orderMin
    }
    orderDeadline
    lockUOMSelection
    status
    misscanPolicy
    useAccountMetadataEmailOverVendorEmail
    showImages
    billingInfo {
      billingEmail
      billingType
      perOrderCharge
    }
    isInventoryEnabled
    address
    acquisitionSource
    vendorManagedCatalog
    orderSubmissionUOMLock
    referredByCompany {
      ... on Vendor {
        id
        name
      }
      ... on Store {
        id
        name
      }
    }
  }
`
export const RetailStoreProductFragmentDoc = /*#__PURE__*/ gql`
  fragment Retail_StoreProduct on GQLStoreProduct {
    id
    active
    name
    storeID
    storeDepartmentID
    upc
    barcode
    price
    brand
    wicEnabled
    targetMargin
    loyaltyPoints
    minCustomerAge
    caseSize
    wicEnabled
    snapEnabled
    ebtEnabled
    ecommerceEnabled
    variableSalePrice
    soldByWeight
    unitOfMeasure
    unitOfMeasureAmount
    retailPriceUnitOfMeasureID
    taxRates {
      id
      name
      value
      status
    }
  }
`
export const CommonGetStoreDepartmentsForAutocompleteDocument = /*#__PURE__*/ gql`
  query Common_GetStoreDepartmentsForAutocomplete($storeID: ID!) {
    getStoreDepartmentsByStoreID(id: $storeID) {
      id
      name
      imageURL
      store {
        id
        name
      }
    }
  }
`

/**
 * __useCommonGetStoreDepartmentsForAutocompleteQuery__
 *
 * To run a query within a React component, call `useCommonGetStoreDepartmentsForAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoreDepartmentsForAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoreDepartmentsForAutocompleteQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useCommonGetStoreDepartmentsForAutocompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    CommonGetStoreDepartmentsForAutocompleteQuery,
    CommonGetStoreDepartmentsForAutocompleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoreDepartmentsForAutocompleteQuery,
    CommonGetStoreDepartmentsForAutocompleteQueryVariables
  >(CommonGetStoreDepartmentsForAutocompleteDocument, options)
}
export function useCommonGetStoreDepartmentsForAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoreDepartmentsForAutocompleteQuery,
    CommonGetStoreDepartmentsForAutocompleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoreDepartmentsForAutocompleteQuery,
    CommonGetStoreDepartmentsForAutocompleteQueryVariables
  >(CommonGetStoreDepartmentsForAutocompleteDocument, options)
}
export type CommonGetStoreDepartmentsForAutocompleteQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForAutocompleteQuery>
export type CommonGetStoreDepartmentsForAutocompleteLazyQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForAutocompleteLazyQuery>
export type CommonGetStoreDepartmentsForAutocompleteQueryResult =
  Apollo.QueryResult<
    CommonGetStoreDepartmentsForAutocompleteQuery,
    CommonGetStoreDepartmentsForAutocompleteQueryVariables
  >
export function refetchCommonGetStoreDepartmentsForAutocompleteQuery(
  variables: CommonGetStoreDepartmentsForAutocompleteQueryVariables,
) {
  return {
    query: CommonGetStoreDepartmentsForAutocompleteDocument,
    variables: variables,
  }
}
export const AdminFiltersGetPaginatedStoresDocument = /*#__PURE__*/ gql`
  query AdminFilters_GetPaginatedStores(
    $search: String
    $cursor: String
    $limit: Int
  ) {
    allStores(input: { search: $search, cursor: $cursor, limit: $limit }) {
      nodes {
        id
        name
      }
      totalCount
      cursor
      hasMore
    }
  }
`

/**
 * __useAdminFiltersGetPaginatedStoresQuery__
 *
 * To run a query within a React component, call `useAdminFiltersGetPaginatedStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFiltersGetPaginatedStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFiltersGetPaginatedStoresQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminFiltersGetPaginatedStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminFiltersGetPaginatedStoresQuery,
    AdminFiltersGetPaginatedStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminFiltersGetPaginatedStoresQuery,
    AdminFiltersGetPaginatedStoresQueryVariables
  >(AdminFiltersGetPaginatedStoresDocument, options)
}
export function useAdminFiltersGetPaginatedStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminFiltersGetPaginatedStoresQuery,
    AdminFiltersGetPaginatedStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminFiltersGetPaginatedStoresQuery,
    AdminFiltersGetPaginatedStoresQueryVariables
  >(AdminFiltersGetPaginatedStoresDocument, options)
}
export type AdminFiltersGetPaginatedStoresQueryHookResult = ReturnType<
  typeof useAdminFiltersGetPaginatedStoresQuery
>
export type AdminFiltersGetPaginatedStoresLazyQueryHookResult = ReturnType<
  typeof useAdminFiltersGetPaginatedStoresLazyQuery
>
export type AdminFiltersGetPaginatedStoresQueryResult = Apollo.QueryResult<
  AdminFiltersGetPaginatedStoresQuery,
  AdminFiltersGetPaginatedStoresQueryVariables
>
export function refetchAdminFiltersGetPaginatedStoresQuery(
  variables?: AdminFiltersGetPaginatedStoresQueryVariables,
) {
  return { query: AdminFiltersGetPaginatedStoresDocument, variables: variables }
}
export const AdminFiltersGetPaginatedUsersDocument = /*#__PURE__*/ gql`
  query AdminFilters_GetPaginatedUsers(
    $companyID: String
    $userTypes: [UserType!]
  ) {
    adminAllUsers(
      input: { companyID: $companyID, userTypeFilter: $userTypes }
    ) {
      nodes {
        id
        displayName
        email
        userType
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            name
          }
        }
        vendorUser {
          vendor {
            id
            name
          }
        }
      }
      totalCount
    }
  }
`

/**
 * __useAdminFiltersGetPaginatedUsersQuery__
 *
 * To run a query within a React component, call `useAdminFiltersGetPaginatedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFiltersGetPaginatedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFiltersGetPaginatedUsersQuery({
 *   variables: {
 *      companyID: // value for 'companyID'
 *      userTypes: // value for 'userTypes'
 *   },
 * });
 */
export function useAdminFiltersGetPaginatedUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminFiltersGetPaginatedUsersQuery,
    AdminFiltersGetPaginatedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminFiltersGetPaginatedUsersQuery,
    AdminFiltersGetPaginatedUsersQueryVariables
  >(AdminFiltersGetPaginatedUsersDocument, options)
}
export function useAdminFiltersGetPaginatedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminFiltersGetPaginatedUsersQuery,
    AdminFiltersGetPaginatedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminFiltersGetPaginatedUsersQuery,
    AdminFiltersGetPaginatedUsersQueryVariables
  >(AdminFiltersGetPaginatedUsersDocument, options)
}
export type AdminFiltersGetPaginatedUsersQueryHookResult = ReturnType<
  typeof useAdminFiltersGetPaginatedUsersQuery
>
export type AdminFiltersGetPaginatedUsersLazyQueryHookResult = ReturnType<
  typeof useAdminFiltersGetPaginatedUsersLazyQuery
>
export type AdminFiltersGetPaginatedUsersQueryResult = Apollo.QueryResult<
  AdminFiltersGetPaginatedUsersQuery,
  AdminFiltersGetPaginatedUsersQueryVariables
>
export function refetchAdminFiltersGetPaginatedUsersQuery(
  variables?: AdminFiltersGetPaginatedUsersQueryVariables,
) {
  return { query: AdminFiltersGetPaginatedUsersDocument, variables: variables }
}
export const AppGetCurrentUserDocument = /*#__PURE__*/ gql`
  query App_GetCurrentUser($gatedFeatures: [String!]) {
    me {
      user {
        id
        userSqlID
        companyImageURL
        displayName
        email
        userType
        vendorUser {
          vendor {
            id
            name
            status
            imgURL
            defaultOrderSubmissionMethod
          }
        }
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            name
            store {
              address
              addressComponents {
                addressLine1
                addressLine2
              }
              id
              imageURL
              local_iana_timezone
              supports_wic
              name
              serialID
              banner {
                name
                id
                imageURL
              }
            }
            banner {
              id
              name
              imageURL
              stores {
                nodes {
                  address
                  addressComponents {
                    addressLine1
                    addressLine2
                  }
                  id
                  imageURL
                  local_iana_timezone
                  name
                  serialID
                  supports_wic
                }
              }
            }
          }
        }
        canSeeFeatures(input: { featureIDs: $gatedFeatures }) {
          enabledFeatures
        }
      }
    }
  }
`

/**
 * __useAppGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useAppGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppGetCurrentUserQuery({
 *   variables: {
 *      gatedFeatures: // value for 'gatedFeatures'
 *   },
 * });
 */
export function useAppGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AppGetCurrentUserQuery,
    AppGetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AppGetCurrentUserQuery,
    AppGetCurrentUserQueryVariables
  >(AppGetCurrentUserDocument, options)
}
export function useAppGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppGetCurrentUserQuery,
    AppGetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AppGetCurrentUserQuery,
    AppGetCurrentUserQueryVariables
  >(AppGetCurrentUserDocument, options)
}
export type AppGetCurrentUserQueryHookResult = ReturnType<
  typeof useAppGetCurrentUserQuery
>
export type AppGetCurrentUserLazyQueryHookResult = ReturnType<
  typeof useAppGetCurrentUserLazyQuery
>
export type AppGetCurrentUserQueryResult = Apollo.QueryResult<
  AppGetCurrentUserQuery,
  AppGetCurrentUserQueryVariables
>
export function refetchAppGetCurrentUserQuery(
  variables?: AppGetCurrentUserQueryVariables,
) {
  return { query: AppGetCurrentUserDocument, variables: variables }
}
export const AppGetCurrentUserStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query App_GetCurrentUser_StoreDepartments {
    me {
      user {
        id
        storeDepartments {
          nodes {
            deactivatedAt
            parentDepartment {
              id
            }
            id
            name
            imageURL
            store {
              id
              name
              serialID
            }
          }
        }
      }
    }
  }
`

/**
 * __useAppGetCurrentUserStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useAppGetCurrentUserStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppGetCurrentUserStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppGetCurrentUserStoreDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppGetCurrentUserStoreDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AppGetCurrentUserStoreDepartmentsQuery,
    AppGetCurrentUserStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AppGetCurrentUserStoreDepartmentsQuery,
    AppGetCurrentUserStoreDepartmentsQueryVariables
  >(AppGetCurrentUserStoreDepartmentsDocument, options)
}
export function useAppGetCurrentUserStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppGetCurrentUserStoreDepartmentsQuery,
    AppGetCurrentUserStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AppGetCurrentUserStoreDepartmentsQuery,
    AppGetCurrentUserStoreDepartmentsQueryVariables
  >(AppGetCurrentUserStoreDepartmentsDocument, options)
}
export type AppGetCurrentUserStoreDepartmentsQueryHookResult = ReturnType<
  typeof useAppGetCurrentUserStoreDepartmentsQuery
>
export type AppGetCurrentUserStoreDepartmentsLazyQueryHookResult = ReturnType<
  typeof useAppGetCurrentUserStoreDepartmentsLazyQuery
>
export type AppGetCurrentUserStoreDepartmentsQueryResult = Apollo.QueryResult<
  AppGetCurrentUserStoreDepartmentsQuery,
  AppGetCurrentUserStoreDepartmentsQueryVariables
>
export function refetchAppGetCurrentUserStoreDepartmentsQuery(
  variables?: AppGetCurrentUserStoreDepartmentsQueryVariables,
) {
  return {
    query: AppGetCurrentUserStoreDepartmentsDocument,
    variables: variables,
  }
}
export const PaymentsCreatePlaidLinkTokenDocument = /*#__PURE__*/ gql`
  mutation Payments_CreatePlaidLinkToken($clientUserID: String!) {
    createPlaidLinkToken(clientUserID: $clientUserID) {
      expiration
      plaidLinkToken
      requestID
    }
  }
`
export type PaymentsCreatePlaidLinkTokenMutationFn = Apollo.MutationFunction<
  PaymentsCreatePlaidLinkTokenMutation,
  PaymentsCreatePlaidLinkTokenMutationVariables
>

/**
 * __usePaymentsCreatePlaidLinkTokenMutation__
 *
 * To run a mutation, you first call `usePaymentsCreatePlaidLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsCreatePlaidLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsCreatePlaidLinkTokenMutation, { data, loading, error }] = usePaymentsCreatePlaidLinkTokenMutation({
 *   variables: {
 *      clientUserID: // value for 'clientUserID'
 *   },
 * });
 */
export function usePaymentsCreatePlaidLinkTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentsCreatePlaidLinkTokenMutation,
    PaymentsCreatePlaidLinkTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PaymentsCreatePlaidLinkTokenMutation,
    PaymentsCreatePlaidLinkTokenMutationVariables
  >(PaymentsCreatePlaidLinkTokenDocument, options)
}
export type PaymentsCreatePlaidLinkTokenMutationHookResult = ReturnType<
  typeof usePaymentsCreatePlaidLinkTokenMutation
>
export type PaymentsCreatePlaidLinkTokenMutationResult =
  Apollo.MutationResult<PaymentsCreatePlaidLinkTokenMutation>
export type PaymentsCreatePlaidLinkTokenMutationOptions =
  Apollo.BaseMutationOptions<
    PaymentsCreatePlaidLinkTokenMutation,
    PaymentsCreatePlaidLinkTokenMutationVariables
  >
export const PaymentsCreateStripeBankAccountTokenDocument = /*#__PURE__*/ gql`
  mutation Payments_CreateStripeBankAccountToken(
    $plaidAccountID: String!
    $plaidPublicToken: String!
  ) {
    createStripeBankAccountToken(
      input: {
        plaidAccountID: $plaidAccountID
        plaidPublicToken: $plaidPublicToken
      }
    ) {
      requestID
      stripeBankAccountToken
    }
  }
`
export type PaymentsCreateStripeBankAccountTokenMutationFn =
  Apollo.MutationFunction<
    PaymentsCreateStripeBankAccountTokenMutation,
    PaymentsCreateStripeBankAccountTokenMutationVariables
  >

/**
 * __usePaymentsCreateStripeBankAccountTokenMutation__
 *
 * To run a mutation, you first call `usePaymentsCreateStripeBankAccountTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsCreateStripeBankAccountTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsCreateStripeBankAccountTokenMutation, { data, loading, error }] = usePaymentsCreateStripeBankAccountTokenMutation({
 *   variables: {
 *      plaidAccountID: // value for 'plaidAccountID'
 *      plaidPublicToken: // value for 'plaidPublicToken'
 *   },
 * });
 */
export function usePaymentsCreateStripeBankAccountTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentsCreateStripeBankAccountTokenMutation,
    PaymentsCreateStripeBankAccountTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PaymentsCreateStripeBankAccountTokenMutation,
    PaymentsCreateStripeBankAccountTokenMutationVariables
  >(PaymentsCreateStripeBankAccountTokenDocument, options)
}
export type PaymentsCreateStripeBankAccountTokenMutationHookResult = ReturnType<
  typeof usePaymentsCreateStripeBankAccountTokenMutation
>
export type PaymentsCreateStripeBankAccountTokenMutationResult =
  Apollo.MutationResult<PaymentsCreateStripeBankAccountTokenMutation>
export type PaymentsCreateStripeBankAccountTokenMutationOptions =
  Apollo.BaseMutationOptions<
    PaymentsCreateStripeBankAccountTokenMutation,
    PaymentsCreateStripeBankAccountTokenMutationVariables
  >
export const PaymentsCreatePaymentProfileDocument = /*#__PURE__*/ gql`
  mutation Payments_CreatePaymentProfile(
    $bannerID: String
    $email: String!
    $name: String!
    $paymentMethodType: PaymentMethodType!
    $stripeBankAccountTokenID: String
    $stripeCardTokenID: String
    $storeID: String
    $vendorID: String
  ) {
    createPaymentProfile(
      input: {
        bannerID: $bannerID
        email: $email
        name: $name
        paymentMethodType: $paymentMethodType
        stripeBankAccountTokenID: $stripeBankAccountTokenID
        stripeCardTokenID: $stripeCardTokenID
        storeID: $storeID
        vendorID: $vendorID
      }
    ) {
      bannerID
      email
      id
      paymentMethods {
        accountHolderName
        accountHolderType
        bankName
        brand
        expMonth
        expYear
        last4
        paymentMethodType
        routingNumber
        stripeID
      }
      storeID
      stripeCustomerID
      vendorID
    }
  }
`
export type PaymentsCreatePaymentProfileMutationFn = Apollo.MutationFunction<
  PaymentsCreatePaymentProfileMutation,
  PaymentsCreatePaymentProfileMutationVariables
>

/**
 * __usePaymentsCreatePaymentProfileMutation__
 *
 * To run a mutation, you first call `usePaymentsCreatePaymentProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentsCreatePaymentProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentsCreatePaymentProfileMutation, { data, loading, error }] = usePaymentsCreatePaymentProfileMutation({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      paymentMethodType: // value for 'paymentMethodType'
 *      stripeBankAccountTokenID: // value for 'stripeBankAccountTokenID'
 *      stripeCardTokenID: // value for 'stripeCardTokenID'
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePaymentsCreatePaymentProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentsCreatePaymentProfileMutation,
    PaymentsCreatePaymentProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PaymentsCreatePaymentProfileMutation,
    PaymentsCreatePaymentProfileMutationVariables
  >(PaymentsCreatePaymentProfileDocument, options)
}
export type PaymentsCreatePaymentProfileMutationHookResult = ReturnType<
  typeof usePaymentsCreatePaymentProfileMutation
>
export type PaymentsCreatePaymentProfileMutationResult =
  Apollo.MutationResult<PaymentsCreatePaymentProfileMutation>
export type PaymentsCreatePaymentProfileMutationOptions =
  Apollo.BaseMutationOptions<
    PaymentsCreatePaymentProfileMutation,
    PaymentsCreatePaymentProfileMutationVariables
  >
export const PaymentsGetCurrentVendorAdminInfoDocument = /*#__PURE__*/ gql`
  query Payments_GetCurrentVendorAdminInfo($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      name
      imgURL
    }
  }
`

/**
 * __usePaymentsGetCurrentVendorAdminInfoQuery__
 *
 * To run a query within a React component, call `usePaymentsGetCurrentVendorAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsGetCurrentVendorAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsGetCurrentVendorAdminInfoQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function usePaymentsGetCurrentVendorAdminInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaymentsGetCurrentVendorAdminInfoQuery,
    PaymentsGetCurrentVendorAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PaymentsGetCurrentVendorAdminInfoQuery,
    PaymentsGetCurrentVendorAdminInfoQueryVariables
  >(PaymentsGetCurrentVendorAdminInfoDocument, options)
}
export function usePaymentsGetCurrentVendorAdminInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentsGetCurrentVendorAdminInfoQuery,
    PaymentsGetCurrentVendorAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PaymentsGetCurrentVendorAdminInfoQuery,
    PaymentsGetCurrentVendorAdminInfoQueryVariables
  >(PaymentsGetCurrentVendorAdminInfoDocument, options)
}
export type PaymentsGetCurrentVendorAdminInfoQueryHookResult = ReturnType<
  typeof usePaymentsGetCurrentVendorAdminInfoQuery
>
export type PaymentsGetCurrentVendorAdminInfoLazyQueryHookResult = ReturnType<
  typeof usePaymentsGetCurrentVendorAdminInfoLazyQuery
>
export type PaymentsGetCurrentVendorAdminInfoQueryResult = Apollo.QueryResult<
  PaymentsGetCurrentVendorAdminInfoQuery,
  PaymentsGetCurrentVendorAdminInfoQueryVariables
>
export function refetchPaymentsGetCurrentVendorAdminInfoQuery(
  variables: PaymentsGetCurrentVendorAdminInfoQueryVariables,
) {
  return {
    query: PaymentsGetCurrentVendorAdminInfoDocument,
    variables: variables,
  }
}
export const PaymentsGetCurrentBannerAdminInfoDocument = /*#__PURE__*/ gql`
  query Payments_GetCurrentBannerAdminInfo($bannerID: ID!) {
    bannerByID(id: $bannerID) {
      id
      name
      imageURL
    }
  }
`

/**
 * __usePaymentsGetCurrentBannerAdminInfoQuery__
 *
 * To run a query within a React component, call `usePaymentsGetCurrentBannerAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsGetCurrentBannerAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsGetCurrentBannerAdminInfoQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *   },
 * });
 */
export function usePaymentsGetCurrentBannerAdminInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaymentsGetCurrentBannerAdminInfoQuery,
    PaymentsGetCurrentBannerAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PaymentsGetCurrentBannerAdminInfoQuery,
    PaymentsGetCurrentBannerAdminInfoQueryVariables
  >(PaymentsGetCurrentBannerAdminInfoDocument, options)
}
export function usePaymentsGetCurrentBannerAdminInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentsGetCurrentBannerAdminInfoQuery,
    PaymentsGetCurrentBannerAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PaymentsGetCurrentBannerAdminInfoQuery,
    PaymentsGetCurrentBannerAdminInfoQueryVariables
  >(PaymentsGetCurrentBannerAdminInfoDocument, options)
}
export type PaymentsGetCurrentBannerAdminInfoQueryHookResult = ReturnType<
  typeof usePaymentsGetCurrentBannerAdminInfoQuery
>
export type PaymentsGetCurrentBannerAdminInfoLazyQueryHookResult = ReturnType<
  typeof usePaymentsGetCurrentBannerAdminInfoLazyQuery
>
export type PaymentsGetCurrentBannerAdminInfoQueryResult = Apollo.QueryResult<
  PaymentsGetCurrentBannerAdminInfoQuery,
  PaymentsGetCurrentBannerAdminInfoQueryVariables
>
export function refetchPaymentsGetCurrentBannerAdminInfoQuery(
  variables: PaymentsGetCurrentBannerAdminInfoQueryVariables,
) {
  return {
    query: PaymentsGetCurrentBannerAdminInfoDocument,
    variables: variables,
  }
}
export const PaymentsGetCurrentStoreAdminInfoDocument = /*#__PURE__*/ gql`
  query Payments_GetCurrentStoreAdminInfo($storeID: ID!) {
    storeByID(id: $storeID) {
      id
      name
    }
  }
`

/**
 * __usePaymentsGetCurrentStoreAdminInfoQuery__
 *
 * To run a query within a React component, call `usePaymentsGetCurrentStoreAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsGetCurrentStoreAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsGetCurrentStoreAdminInfoQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function usePaymentsGetCurrentStoreAdminInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaymentsGetCurrentStoreAdminInfoQuery,
    PaymentsGetCurrentStoreAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PaymentsGetCurrentStoreAdminInfoQuery,
    PaymentsGetCurrentStoreAdminInfoQueryVariables
  >(PaymentsGetCurrentStoreAdminInfoDocument, options)
}
export function usePaymentsGetCurrentStoreAdminInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentsGetCurrentStoreAdminInfoQuery,
    PaymentsGetCurrentStoreAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PaymentsGetCurrentStoreAdminInfoQuery,
    PaymentsGetCurrentStoreAdminInfoQueryVariables
  >(PaymentsGetCurrentStoreAdminInfoDocument, options)
}
export type PaymentsGetCurrentStoreAdminInfoQueryHookResult = ReturnType<
  typeof usePaymentsGetCurrentStoreAdminInfoQuery
>
export type PaymentsGetCurrentStoreAdminInfoLazyQueryHookResult = ReturnType<
  typeof usePaymentsGetCurrentStoreAdminInfoLazyQuery
>
export type PaymentsGetCurrentStoreAdminInfoQueryResult = Apollo.QueryResult<
  PaymentsGetCurrentStoreAdminInfoQuery,
  PaymentsGetCurrentStoreAdminInfoQueryVariables
>
export function refetchPaymentsGetCurrentStoreAdminInfoQuery(
  variables: PaymentsGetCurrentStoreAdminInfoQueryVariables,
) {
  return {
    query: PaymentsGetCurrentStoreAdminInfoDocument,
    variables: variables,
  }
}
export const PaymentsGetCurrentLoggedInStoreAdminInfoDocument = /*#__PURE__*/ gql`
  query Payments_GetCurrentLoggedInStoreAdminInfo {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            name
            banner {
              id
              imageURL
            }
          }
        }
      }
    }
  }
`

/**
 * __usePaymentsGetCurrentLoggedInStoreAdminInfoQuery__
 *
 * To run a query within a React component, call `usePaymentsGetCurrentLoggedInStoreAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsGetCurrentLoggedInStoreAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsGetCurrentLoggedInStoreAdminInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentsGetCurrentLoggedInStoreAdminInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentsGetCurrentLoggedInStoreAdminInfoQuery,
    PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PaymentsGetCurrentLoggedInStoreAdminInfoQuery,
    PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables
  >(PaymentsGetCurrentLoggedInStoreAdminInfoDocument, options)
}
export function usePaymentsGetCurrentLoggedInStoreAdminInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentsGetCurrentLoggedInStoreAdminInfoQuery,
    PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PaymentsGetCurrentLoggedInStoreAdminInfoQuery,
    PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables
  >(PaymentsGetCurrentLoggedInStoreAdminInfoDocument, options)
}
export type PaymentsGetCurrentLoggedInStoreAdminInfoQueryHookResult =
  ReturnType<typeof usePaymentsGetCurrentLoggedInStoreAdminInfoQuery>
export type PaymentsGetCurrentLoggedInStoreAdminInfoLazyQueryHookResult =
  ReturnType<typeof usePaymentsGetCurrentLoggedInStoreAdminInfoLazyQuery>
export type PaymentsGetCurrentLoggedInStoreAdminInfoQueryResult =
  Apollo.QueryResult<
    PaymentsGetCurrentLoggedInStoreAdminInfoQuery,
    PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables
  >
export function refetchPaymentsGetCurrentLoggedInStoreAdminInfoQuery(
  variables?: PaymentsGetCurrentLoggedInStoreAdminInfoQueryVariables,
) {
  return {
    query: PaymentsGetCurrentLoggedInStoreAdminInfoDocument,
    variables: variables,
  }
}
export const ProductsCatalogCreateVendorProductDocument = /*#__PURE__*/ gql`
  mutation ProductsCatalog_CreateVendorProduct(
    $accountSpecificCasePrice: [AccountSpecificPriceInput!]
    $accountSpecificUnitPrice: [AccountSpecificPriceInput!]
    $brand: String
    $caseSize: Float
    $caseUPC: String
    $category: String
    $departmentName: String
    $description: String!
    $imgURLFile: Upload
    $imgURL: String
    $itemCode: String!
    $notes: String
    $packUPC: String
    $privateLabelProductBannerIDs: [ID!]
    $privateLabelProductStoreIDs: [ID!]
    $status: VendorProductStatus
    $unitUPC: String
    $unitVolume: String
    $vendorID: String!
    $wholesaleCasePrice: Currency
    $wholesaleUnitPrice: Currency
  ) {
    createVendorProduct(
      input: {
        accountSpecificCasePrice: $accountSpecificCasePrice
        accountSpecificUnitPrice: $accountSpecificUnitPrice
        brand: $brand
        caseSize: $caseSize
        caseUPC: $caseUPC
        category: $category
        departmentName: $departmentName
        description: $description
        imgURLFile: $imgURLFile
        imgURL: $imgURL
        itemCode: $itemCode
        notes: $notes
        packUPC: $packUPC
        privateLabelProductBannerIDs: $privateLabelProductBannerIDs
        privateLabelProductStoreIDs: $privateLabelProductStoreIDs
        status: $status
        unitUPC: $unitUPC
        unitVolume: $unitVolume
        vendorID: $vendorID
        wholesaleCasePrice: $wholesaleCasePrice
        wholesaleUnitPrice: $wholesaleUnitPrice
      }
    ) {
      ...ProductsCatalog_VendorProductCatalogFields
    }
  }
  ${ProductsCatalogVendorProductCatalogFieldsFragmentDoc}
`
export type ProductsCatalogCreateVendorProductMutationFn =
  Apollo.MutationFunction<
    ProductsCatalogCreateVendorProductMutation,
    ProductsCatalogCreateVendorProductMutationVariables
  >

/**
 * __useProductsCatalogCreateVendorProductMutation__
 *
 * To run a mutation, you first call `useProductsCatalogCreateVendorProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogCreateVendorProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsCatalogCreateVendorProductMutation, { data, loading, error }] = useProductsCatalogCreateVendorProductMutation({
 *   variables: {
 *      accountSpecificCasePrice: // value for 'accountSpecificCasePrice'
 *      accountSpecificUnitPrice: // value for 'accountSpecificUnitPrice'
 *      brand: // value for 'brand'
 *      caseSize: // value for 'caseSize'
 *      caseUPC: // value for 'caseUPC'
 *      category: // value for 'category'
 *      departmentName: // value for 'departmentName'
 *      description: // value for 'description'
 *      imgURLFile: // value for 'imgURLFile'
 *      imgURL: // value for 'imgURL'
 *      itemCode: // value for 'itemCode'
 *      notes: // value for 'notes'
 *      packUPC: // value for 'packUPC'
 *      privateLabelProductBannerIDs: // value for 'privateLabelProductBannerIDs'
 *      privateLabelProductStoreIDs: // value for 'privateLabelProductStoreIDs'
 *      status: // value for 'status'
 *      unitUPC: // value for 'unitUPC'
 *      unitVolume: // value for 'unitVolume'
 *      vendorID: // value for 'vendorID'
 *      wholesaleCasePrice: // value for 'wholesaleCasePrice'
 *      wholesaleUnitPrice: // value for 'wholesaleUnitPrice'
 *   },
 * });
 */
export function useProductsCatalogCreateVendorProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProductsCatalogCreateVendorProductMutation,
    ProductsCatalogCreateVendorProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProductsCatalogCreateVendorProductMutation,
    ProductsCatalogCreateVendorProductMutationVariables
  >(ProductsCatalogCreateVendorProductDocument, options)
}
export type ProductsCatalogCreateVendorProductMutationHookResult = ReturnType<
  typeof useProductsCatalogCreateVendorProductMutation
>
export type ProductsCatalogCreateVendorProductMutationResult =
  Apollo.MutationResult<ProductsCatalogCreateVendorProductMutation>
export type ProductsCatalogCreateVendorProductMutationOptions =
  Apollo.BaseMutationOptions<
    ProductsCatalogCreateVendorProductMutation,
    ProductsCatalogCreateVendorProductMutationVariables
  >
export const ProductsCatalogUpdateVendorProductDocument = /*#__PURE__*/ gql`
  mutation ProductsCatalog_UpdateVendorProduct(
    $accountSpecificCasePrice: [AccountSpecificPriceInput!]
    $accountSpecificUnitPrice: [AccountSpecificPriceInput!]
    $brand: String
    $caseSize: Float
    $caseUPC: String
    $category: String
    $departmentName: String
    $description: String
    $imgURLFile: Upload
    $imgURL: String
    $itemCode: String
    $notes: String
    $packUPC: String
    $privateLabelProductBannerIDs: [ID!]
    $privateLabelProductStoreIDs: [ID!]
    $productID: ID!
    $status: VendorProductStatus
    $unitUPC: String
    $unitVolume: String
    $wholesaleCasePrice: Currency
    $wholesaleUnitPrice: Currency
  ) {
    updateVendorProduct(
      input: {
        accountSpecificCasePrice: $accountSpecificCasePrice
        accountSpecificUnitPrice: $accountSpecificUnitPrice
        brand: $brand
        caseSize: $caseSize
        caseUPC: $caseUPC
        category: $category
        departmentName: $departmentName
        description: $description
        imgURLFile: $imgURLFile
        imgURL: $imgURL
        itemCode: $itemCode
        notes: $notes
        packUPC: $packUPC
        privateLabelProductBannerIDs: $privateLabelProductBannerIDs
        privateLabelProductStoreIDs: $privateLabelProductStoreIDs
        productID: $productID
        status: $status
        unitUPC: $unitUPC
        unitVolume: $unitVolume
        wholesaleCasePrice: $wholesaleCasePrice
        wholesaleUnitPrice: $wholesaleUnitPrice
      }
    ) {
      ...ProductsCatalog_VendorProductCatalogFields
    }
  }
  ${ProductsCatalogVendorProductCatalogFieldsFragmentDoc}
`
export type ProductsCatalogUpdateVendorProductMutationFn =
  Apollo.MutationFunction<
    ProductsCatalogUpdateVendorProductMutation,
    ProductsCatalogUpdateVendorProductMutationVariables
  >

/**
 * __useProductsCatalogUpdateVendorProductMutation__
 *
 * To run a mutation, you first call `useProductsCatalogUpdateVendorProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogUpdateVendorProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsCatalogUpdateVendorProductMutation, { data, loading, error }] = useProductsCatalogUpdateVendorProductMutation({
 *   variables: {
 *      accountSpecificCasePrice: // value for 'accountSpecificCasePrice'
 *      accountSpecificUnitPrice: // value for 'accountSpecificUnitPrice'
 *      brand: // value for 'brand'
 *      caseSize: // value for 'caseSize'
 *      caseUPC: // value for 'caseUPC'
 *      category: // value for 'category'
 *      departmentName: // value for 'departmentName'
 *      description: // value for 'description'
 *      imgURLFile: // value for 'imgURLFile'
 *      imgURL: // value for 'imgURL'
 *      itemCode: // value for 'itemCode'
 *      notes: // value for 'notes'
 *      packUPC: // value for 'packUPC'
 *      privateLabelProductBannerIDs: // value for 'privateLabelProductBannerIDs'
 *      privateLabelProductStoreIDs: // value for 'privateLabelProductStoreIDs'
 *      productID: // value for 'productID'
 *      status: // value for 'status'
 *      unitUPC: // value for 'unitUPC'
 *      unitVolume: // value for 'unitVolume'
 *      wholesaleCasePrice: // value for 'wholesaleCasePrice'
 *      wholesaleUnitPrice: // value for 'wholesaleUnitPrice'
 *   },
 * });
 */
export function useProductsCatalogUpdateVendorProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProductsCatalogUpdateVendorProductMutation,
    ProductsCatalogUpdateVendorProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProductsCatalogUpdateVendorProductMutation,
    ProductsCatalogUpdateVendorProductMutationVariables
  >(ProductsCatalogUpdateVendorProductDocument, options)
}
export type ProductsCatalogUpdateVendorProductMutationHookResult = ReturnType<
  typeof useProductsCatalogUpdateVendorProductMutation
>
export type ProductsCatalogUpdateVendorProductMutationResult =
  Apollo.MutationResult<ProductsCatalogUpdateVendorProductMutation>
export type ProductsCatalogUpdateVendorProductMutationOptions =
  Apollo.BaseMutationOptions<
    ProductsCatalogUpdateVendorProductMutation,
    ProductsCatalogUpdateVendorProductMutationVariables
  >
export const ProductsCatalogBulkUpdateVendorProductsDocument = /*#__PURE__*/ gql`
  mutation ProductsCatalog_BulkUpdateVendorProducts(
    $vendorProducts: [UpdateVendorProductInput!]!
  ) {
    bulkUpdateVendorProducts(input: { vendorProducts: $vendorProducts }) {
      nodes {
        ...ProductsCatalog_VendorProductCatalogFields
      }
    }
  }
  ${ProductsCatalogVendorProductCatalogFieldsFragmentDoc}
`
export type ProductsCatalogBulkUpdateVendorProductsMutationFn =
  Apollo.MutationFunction<
    ProductsCatalogBulkUpdateVendorProductsMutation,
    ProductsCatalogBulkUpdateVendorProductsMutationVariables
  >

/**
 * __useProductsCatalogBulkUpdateVendorProductsMutation__
 *
 * To run a mutation, you first call `useProductsCatalogBulkUpdateVendorProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogBulkUpdateVendorProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsCatalogBulkUpdateVendorProductsMutation, { data, loading, error }] = useProductsCatalogBulkUpdateVendorProductsMutation({
 *   variables: {
 *      vendorProducts: // value for 'vendorProducts'
 *   },
 * });
 */
export function useProductsCatalogBulkUpdateVendorProductsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProductsCatalogBulkUpdateVendorProductsMutation,
    ProductsCatalogBulkUpdateVendorProductsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProductsCatalogBulkUpdateVendorProductsMutation,
    ProductsCatalogBulkUpdateVendorProductsMutationVariables
  >(ProductsCatalogBulkUpdateVendorProductsDocument, options)
}
export type ProductsCatalogBulkUpdateVendorProductsMutationHookResult =
  ReturnType<typeof useProductsCatalogBulkUpdateVendorProductsMutation>
export type ProductsCatalogBulkUpdateVendorProductsMutationResult =
  Apollo.MutationResult<ProductsCatalogBulkUpdateVendorProductsMutation>
export type ProductsCatalogBulkUpdateVendorProductsMutationOptions =
  Apollo.BaseMutationOptions<
    ProductsCatalogBulkUpdateVendorProductsMutation,
    ProductsCatalogBulkUpdateVendorProductsMutationVariables
  >
export const ProductsCatalogDeleteVendorProductDocument = /*#__PURE__*/ gql`
  mutation ProductsCatalog_DeleteVendorProduct(
    $productID: ID!
    $vendorID: ID
    $storeID: ID
  ) {
    deleteVendorProduct(
      input: { productID: $productID, vendorID: $vendorID, storeID: $storeID }
    ) {
      deletedProductID
    }
  }
`
export type ProductsCatalogDeleteVendorProductMutationFn =
  Apollo.MutationFunction<
    ProductsCatalogDeleteVendorProductMutation,
    ProductsCatalogDeleteVendorProductMutationVariables
  >

/**
 * __useProductsCatalogDeleteVendorProductMutation__
 *
 * To run a mutation, you first call `useProductsCatalogDeleteVendorProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogDeleteVendorProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsCatalogDeleteVendorProductMutation, { data, loading, error }] = useProductsCatalogDeleteVendorProductMutation({
 *   variables: {
 *      productID: // value for 'productID'
 *      vendorID: // value for 'vendorID'
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useProductsCatalogDeleteVendorProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProductsCatalogDeleteVendorProductMutation,
    ProductsCatalogDeleteVendorProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProductsCatalogDeleteVendorProductMutation,
    ProductsCatalogDeleteVendorProductMutationVariables
  >(ProductsCatalogDeleteVendorProductDocument, options)
}
export type ProductsCatalogDeleteVendorProductMutationHookResult = ReturnType<
  typeof useProductsCatalogDeleteVendorProductMutation
>
export type ProductsCatalogDeleteVendorProductMutationResult =
  Apollo.MutationResult<ProductsCatalogDeleteVendorProductMutation>
export type ProductsCatalogDeleteVendorProductMutationOptions =
  Apollo.BaseMutationOptions<
    ProductsCatalogDeleteVendorProductMutation,
    ProductsCatalogDeleteVendorProductMutationVariables
  >
export const ProductsCatalogGetVendorProductsForCatalogDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorProductsForCatalog(
    $cursor: ID
    $filterByBrand: String
    $filterByCategory: String
    $filterByCustomPricing: Boolean
    $filterByPrivateLabel: Boolean
    $filterByRetailerIDs: [ID!]
    $filterByStatus: [VendorProductStatus!]
    $search: String
    $vendorID: ID
  ) {
    vendorProducts(
      input: {
        filterByBrand: $filterByBrand
        filterByCategory: $filterByCategory
        filterByCustomPricing: $filterByCustomPricing
        filterByPrivateLabel: $filterByPrivateLabel
        filterByRetailerIDs: $filterByRetailerIDs
        filterByStatus: $filterByStatus
        vendorID: $vendorID
        limit: 50
        pagination: { cursor: $cursor }
        search: $search
        sortBy: { field: ITEM_CODE }
      }
    ) {
      cursor
      hasMore
      nodes {
        ...ProductsCatalog_VendorProductCatalogFields
      }
    }
  }
  ${ProductsCatalogVendorProductCatalogFieldsFragmentDoc}
`

/**
 * __useProductsCatalogGetVendorProductsForCatalogQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorProductsForCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorProductsForCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorProductsForCatalogQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filterByBrand: // value for 'filterByBrand'
 *      filterByCategory: // value for 'filterByCategory'
 *      filterByCustomPricing: // value for 'filterByCustomPricing'
 *      filterByPrivateLabel: // value for 'filterByPrivateLabel'
 *      filterByRetailerIDs: // value for 'filterByRetailerIDs'
 *      filterByStatus: // value for 'filterByStatus'
 *      search: // value for 'search'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useProductsCatalogGetVendorProductsForCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorProductsForCatalogQuery,
    ProductsCatalogGetVendorProductsForCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorProductsForCatalogQuery,
    ProductsCatalogGetVendorProductsForCatalogQueryVariables
  >(ProductsCatalogGetVendorProductsForCatalogDocument, options)
}
export function useProductsCatalogGetVendorProductsForCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorProductsForCatalogQuery,
    ProductsCatalogGetVendorProductsForCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorProductsForCatalogQuery,
    ProductsCatalogGetVendorProductsForCatalogQueryVariables
  >(ProductsCatalogGetVendorProductsForCatalogDocument, options)
}
export type ProductsCatalogGetVendorProductsForCatalogQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorProductsForCatalogQuery>
export type ProductsCatalogGetVendorProductsForCatalogLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorProductsForCatalogLazyQuery>
export type ProductsCatalogGetVendorProductsForCatalogQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetVendorProductsForCatalogQuery,
    ProductsCatalogGetVendorProductsForCatalogQueryVariables
  >
export function refetchProductsCatalogGetVendorProductsForCatalogQuery(
  variables?: ProductsCatalogGetVendorProductsForCatalogQueryVariables,
) {
  return {
    query: ProductsCatalogGetVendorProductsForCatalogDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetVendorProductForCatalogDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorProductForCatalog(
    $id: String!
    $storeID: String
    $vendorID: String!
  ) {
    vendorProductByID(id: $id, storeID: $storeID, vendorID: $vendorID) {
      ...ProductsCatalog_VendorProductCatalogFields
    }
  }
  ${ProductsCatalogVendorProductCatalogFieldsFragmentDoc}
`

/**
 * __useProductsCatalogGetVendorProductForCatalogQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorProductForCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorProductForCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorProductForCatalogQuery({
 *   variables: {
 *      id: // value for 'id'
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useProductsCatalogGetVendorProductForCatalogQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorProductForCatalogQuery,
    ProductsCatalogGetVendorProductForCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorProductForCatalogQuery,
    ProductsCatalogGetVendorProductForCatalogQueryVariables
  >(ProductsCatalogGetVendorProductForCatalogDocument, options)
}
export function useProductsCatalogGetVendorProductForCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorProductForCatalogQuery,
    ProductsCatalogGetVendorProductForCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorProductForCatalogQuery,
    ProductsCatalogGetVendorProductForCatalogQueryVariables
  >(ProductsCatalogGetVendorProductForCatalogDocument, options)
}
export type ProductsCatalogGetVendorProductForCatalogQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorProductForCatalogQuery>
export type ProductsCatalogGetVendorProductForCatalogLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorProductForCatalogLazyQuery>
export type ProductsCatalogGetVendorProductForCatalogQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetVendorProductForCatalogQuery,
    ProductsCatalogGetVendorProductForCatalogQueryVariables
  >
export function refetchProductsCatalogGetVendorProductForCatalogQuery(
  variables: ProductsCatalogGetVendorProductForCatalogQueryVariables,
) {
  return {
    query: ProductsCatalogGetVendorProductForCatalogDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetVendorBrandsDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorBrands {
    me {
      user {
        id
        userType
        vendorUser {
          vendor {
            id
            vendorBrands {
              nodes
            }
          }
        }
      }
    }
  }
`

/**
 * __useProductsCatalogGetVendorBrandsQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetVendorBrandsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorBrandsQuery,
    ProductsCatalogGetVendorBrandsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorBrandsQuery,
    ProductsCatalogGetVendorBrandsQueryVariables
  >(ProductsCatalogGetVendorBrandsDocument, options)
}
export function useProductsCatalogGetVendorBrandsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorBrandsQuery,
    ProductsCatalogGetVendorBrandsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorBrandsQuery,
    ProductsCatalogGetVendorBrandsQueryVariables
  >(ProductsCatalogGetVendorBrandsDocument, options)
}
export type ProductsCatalogGetVendorBrandsQueryHookResult = ReturnType<
  typeof useProductsCatalogGetVendorBrandsQuery
>
export type ProductsCatalogGetVendorBrandsLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetVendorBrandsLazyQuery
>
export type ProductsCatalogGetVendorBrandsQueryResult = Apollo.QueryResult<
  ProductsCatalogGetVendorBrandsQuery,
  ProductsCatalogGetVendorBrandsQueryVariables
>
export function refetchProductsCatalogGetVendorBrandsQuery(
  variables?: ProductsCatalogGetVendorBrandsQueryVariables,
) {
  return { query: ProductsCatalogGetVendorBrandsDocument, variables: variables }
}
export const ProductsCatalogGetVendorCategoriesDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorCategories {
    me {
      user {
        id
        userType
        vendorUser {
          vendor {
            id
            vendorCategories {
              nodes
            }
          }
        }
      }
    }
  }
`

/**
 * __useProductsCatalogGetVendorCategoriesQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetVendorCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorCategoriesQuery,
    ProductsCatalogGetVendorCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorCategoriesQuery,
    ProductsCatalogGetVendorCategoriesQueryVariables
  >(ProductsCatalogGetVendorCategoriesDocument, options)
}
export function useProductsCatalogGetVendorCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorCategoriesQuery,
    ProductsCatalogGetVendorCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorCategoriesQuery,
    ProductsCatalogGetVendorCategoriesQueryVariables
  >(ProductsCatalogGetVendorCategoriesDocument, options)
}
export type ProductsCatalogGetVendorCategoriesQueryHookResult = ReturnType<
  typeof useProductsCatalogGetVendorCategoriesQuery
>
export type ProductsCatalogGetVendorCategoriesLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetVendorCategoriesLazyQuery
>
export type ProductsCatalogGetVendorCategoriesQueryResult = Apollo.QueryResult<
  ProductsCatalogGetVendorCategoriesQuery,
  ProductsCatalogGetVendorCategoriesQueryVariables
>
export function refetchProductsCatalogGetVendorCategoriesQuery(
  variables?: ProductsCatalogGetVendorCategoriesQueryVariables,
) {
  return {
    query: ProductsCatalogGetVendorCategoriesDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetVendorCatalogMetadataDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorCatalogMetadata {
    me {
      user {
        vendorUser {
          vendor {
            lastVendorProductUpdate
          }
        }
      }
    }
  }
`

/**
 * __useProductsCatalogGetVendorCatalogMetadataQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorCatalogMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorCatalogMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorCatalogMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetVendorCatalogMetadataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorCatalogMetadataQuery,
    ProductsCatalogGetVendorCatalogMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorCatalogMetadataQuery,
    ProductsCatalogGetVendorCatalogMetadataQueryVariables
  >(ProductsCatalogGetVendorCatalogMetadataDocument, options)
}
export function useProductsCatalogGetVendorCatalogMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorCatalogMetadataQuery,
    ProductsCatalogGetVendorCatalogMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorCatalogMetadataQuery,
    ProductsCatalogGetVendorCatalogMetadataQueryVariables
  >(ProductsCatalogGetVendorCatalogMetadataDocument, options)
}
export type ProductsCatalogGetVendorCatalogMetadataQueryHookResult = ReturnType<
  typeof useProductsCatalogGetVendorCatalogMetadataQuery
>
export type ProductsCatalogGetVendorCatalogMetadataLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorCatalogMetadataLazyQuery>
export type ProductsCatalogGetVendorCatalogMetadataQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetVendorCatalogMetadataQuery,
    ProductsCatalogGetVendorCatalogMetadataQueryVariables
  >
export function refetchProductsCatalogGetVendorCatalogMetadataQuery(
  variables?: ProductsCatalogGetVendorCatalogMetadataQueryVariables,
) {
  return {
    query: ProductsCatalogGetVendorCatalogMetadataDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetVendorCatalogMetadataByIdDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorCatalogMetadataByID($ID: ID!) {
    vendorByID(id: $ID) {
      lastVendorProductUpdate
    }
  }
`

/**
 * __useProductsCatalogGetVendorCatalogMetadataByIdQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorCatalogMetadataByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorCatalogMetadataByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorCatalogMetadataByIdQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useProductsCatalogGetVendorCatalogMetadataByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorCatalogMetadataByIdQuery,
    ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorCatalogMetadataByIdQuery,
    ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables
  >(ProductsCatalogGetVendorCatalogMetadataByIdDocument, options)
}
export function useProductsCatalogGetVendorCatalogMetadataByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorCatalogMetadataByIdQuery,
    ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorCatalogMetadataByIdQuery,
    ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables
  >(ProductsCatalogGetVendorCatalogMetadataByIdDocument, options)
}
export type ProductsCatalogGetVendorCatalogMetadataByIdQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorCatalogMetadataByIdQuery>
export type ProductsCatalogGetVendorCatalogMetadataByIdLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorCatalogMetadataByIdLazyQuery>
export type ProductsCatalogGetVendorCatalogMetadataByIdQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetVendorCatalogMetadataByIdQuery,
    ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables
  >
export function refetchProductsCatalogGetVendorCatalogMetadataByIdQuery(
  variables: ProductsCatalogGetVendorCatalogMetadataByIdQueryVariables,
) {
  return {
    query: ProductsCatalogGetVendorCatalogMetadataByIdDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetVendorCatalogDownloadUrlDocument = /*#__PURE__*/ gql`
  mutation ProductsCatalog_GetVendorCatalogDownloadURL($vendorID: String!) {
    exportVendorCatalogToCSV(vendorID: $vendorID)
  }
`
export type ProductsCatalogGetVendorCatalogDownloadUrlMutationFn =
  Apollo.MutationFunction<
    ProductsCatalogGetVendorCatalogDownloadUrlMutation,
    ProductsCatalogGetVendorCatalogDownloadUrlMutationVariables
  >

/**
 * __useProductsCatalogGetVendorCatalogDownloadUrlMutation__
 *
 * To run a mutation, you first call `useProductsCatalogGetVendorCatalogDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorCatalogDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsCatalogGetVendorCatalogDownloadUrlMutation, { data, loading, error }] = useProductsCatalogGetVendorCatalogDownloadUrlMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useProductsCatalogGetVendorCatalogDownloadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProductsCatalogGetVendorCatalogDownloadUrlMutation,
    ProductsCatalogGetVendorCatalogDownloadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProductsCatalogGetVendorCatalogDownloadUrlMutation,
    ProductsCatalogGetVendorCatalogDownloadUrlMutationVariables
  >(ProductsCatalogGetVendorCatalogDownloadUrlDocument, options)
}
export type ProductsCatalogGetVendorCatalogDownloadUrlMutationHookResult =
  ReturnType<typeof useProductsCatalogGetVendorCatalogDownloadUrlMutation>
export type ProductsCatalogGetVendorCatalogDownloadUrlMutationResult =
  Apollo.MutationResult<ProductsCatalogGetVendorCatalogDownloadUrlMutation>
export type ProductsCatalogGetVendorCatalogDownloadUrlMutationOptions =
  Apollo.BaseMutationOptions<
    ProductsCatalogGetVendorCatalogDownloadUrlMutation,
    ProductsCatalogGetVendorCatalogDownloadUrlMutationVariables
  >
export const ProductsCatalogGetAdminAllRetailersDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetAdminAllRetailers {
    adminAllBanners {
      nodes {
        ...ProductsCatalog_RetailerSelectBannerFields
      }
    }
    adminAllStores {
      nodes {
        ...ProductsCatalog_RetailerSelectStoreFields
      }
    }
  }
  ${ProductsCatalogRetailerSelectBannerFieldsFragmentDoc}
  ${ProductsCatalogRetailerSelectStoreFieldsFragmentDoc}
`

/**
 * __useProductsCatalogGetAdminAllRetailersQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetAdminAllRetailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetAdminAllRetailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetAdminAllRetailersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetAdminAllRetailersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetAdminAllRetailersQuery,
    ProductsCatalogGetAdminAllRetailersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetAdminAllRetailersQuery,
    ProductsCatalogGetAdminAllRetailersQueryVariables
  >(ProductsCatalogGetAdminAllRetailersDocument, options)
}
export function useProductsCatalogGetAdminAllRetailersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetAdminAllRetailersQuery,
    ProductsCatalogGetAdminAllRetailersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetAdminAllRetailersQuery,
    ProductsCatalogGetAdminAllRetailersQueryVariables
  >(ProductsCatalogGetAdminAllRetailersDocument, options)
}
export type ProductsCatalogGetAdminAllRetailersQueryHookResult = ReturnType<
  typeof useProductsCatalogGetAdminAllRetailersQuery
>
export type ProductsCatalogGetAdminAllRetailersLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetAdminAllRetailersLazyQuery
>
export type ProductsCatalogGetAdminAllRetailersQueryResult = Apollo.QueryResult<
  ProductsCatalogGetAdminAllRetailersQuery,
  ProductsCatalogGetAdminAllRetailersQueryVariables
>
export function refetchProductsCatalogGetAdminAllRetailersQuery(
  variables?: ProductsCatalogGetAdminAllRetailersQueryVariables,
) {
  return {
    query: ProductsCatalogGetAdminAllRetailersDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetVendorAllRetailersDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetVendorAllRetailers {
    me {
      user {
        vendorUser {
          vendor {
            storeAccounts {
              nodes {
                store {
                  ...ProductsCatalog_RetailersStoresFromBannerFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${ProductsCatalogRetailersStoresFromBannerFieldsFragmentDoc}
`

/**
 * __useProductsCatalogGetVendorAllRetailersQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetVendorAllRetailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetVendorAllRetailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetVendorAllRetailersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetVendorAllRetailersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetVendorAllRetailersQuery,
    ProductsCatalogGetVendorAllRetailersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetVendorAllRetailersQuery,
    ProductsCatalogGetVendorAllRetailersQueryVariables
  >(ProductsCatalogGetVendorAllRetailersDocument, options)
}
export function useProductsCatalogGetVendorAllRetailersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetVendorAllRetailersQuery,
    ProductsCatalogGetVendorAllRetailersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetVendorAllRetailersQuery,
    ProductsCatalogGetVendorAllRetailersQueryVariables
  >(ProductsCatalogGetVendorAllRetailersDocument, options)
}
export type ProductsCatalogGetVendorAllRetailersQueryHookResult = ReturnType<
  typeof useProductsCatalogGetVendorAllRetailersQuery
>
export type ProductsCatalogGetVendorAllRetailersLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetVendorAllRetailersLazyQuery>
export type ProductsCatalogGetVendorAllRetailersQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetVendorAllRetailersQuery,
    ProductsCatalogGetVendorAllRetailersQueryVariables
  >
export function refetchProductsCatalogGetVendorAllRetailersQuery(
  variables?: ProductsCatalogGetVendorAllRetailersQueryVariables,
) {
  return {
    query: ProductsCatalogGetVendorAllRetailersDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetRetailAllRetailersDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetRetailAllRetailers($cursor: ID, $search: String) {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              imageURL
              stores(
                input: {
                  limit: 15
                  pagination: { cursor: $cursor }
                  search: $search
                }
              ) {
                cursor
                hasMore
                nodes {
                  id
                  imageURL
                  name
                }
              }
            }
            store {
              id
              imageURL
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useProductsCatalogGetRetailAllRetailersQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetRetailAllRetailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetRetailAllRetailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetRetailAllRetailersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useProductsCatalogGetRetailAllRetailersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetRetailAllRetailersQuery,
    ProductsCatalogGetRetailAllRetailersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetRetailAllRetailersQuery,
    ProductsCatalogGetRetailAllRetailersQueryVariables
  >(ProductsCatalogGetRetailAllRetailersDocument, options)
}
export function useProductsCatalogGetRetailAllRetailersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetRetailAllRetailersQuery,
    ProductsCatalogGetRetailAllRetailersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetRetailAllRetailersQuery,
    ProductsCatalogGetRetailAllRetailersQueryVariables
  >(ProductsCatalogGetRetailAllRetailersDocument, options)
}
export type ProductsCatalogGetRetailAllRetailersQueryHookResult = ReturnType<
  typeof useProductsCatalogGetRetailAllRetailersQuery
>
export type ProductsCatalogGetRetailAllRetailersLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetRetailAllRetailersLazyQuery>
export type ProductsCatalogGetRetailAllRetailersQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetRetailAllRetailersQuery,
    ProductsCatalogGetRetailAllRetailersQueryVariables
  >
export function refetchProductsCatalogGetRetailAllRetailersQuery(
  variables?: ProductsCatalogGetRetailAllRetailersQueryVariables,
) {
  return {
    query: ProductsCatalogGetRetailAllRetailersDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetAdminAllStoresDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetAdminAllStores {
    adminAllStores {
      nodes {
        ...ProductsCatalog_RetailerSelectStoreFields
      }
    }
  }
  ${ProductsCatalogRetailerSelectStoreFieldsFragmentDoc}
`

/**
 * __useProductsCatalogGetAdminAllStoresQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetAdminAllStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetAdminAllStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetAdminAllStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetAdminAllStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetAdminAllStoresQuery,
    ProductsCatalogGetAdminAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetAdminAllStoresQuery,
    ProductsCatalogGetAdminAllStoresQueryVariables
  >(ProductsCatalogGetAdminAllStoresDocument, options)
}
export function useProductsCatalogGetAdminAllStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetAdminAllStoresQuery,
    ProductsCatalogGetAdminAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetAdminAllStoresQuery,
    ProductsCatalogGetAdminAllStoresQueryVariables
  >(ProductsCatalogGetAdminAllStoresDocument, options)
}
export type ProductsCatalogGetAdminAllStoresQueryHookResult = ReturnType<
  typeof useProductsCatalogGetAdminAllStoresQuery
>
export type ProductsCatalogGetAdminAllStoresLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetAdminAllStoresLazyQuery
>
export type ProductsCatalogGetAdminAllStoresQueryResult = Apollo.QueryResult<
  ProductsCatalogGetAdminAllStoresQuery,
  ProductsCatalogGetAdminAllStoresQueryVariables
>
export function refetchProductsCatalogGetAdminAllStoresQuery(
  variables?: ProductsCatalogGetAdminAllStoresQueryVariables,
) {
  return {
    query: ProductsCatalogGetAdminAllStoresDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetAdminAllVendorsDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetAdminAllVendors {
    adminAllVendors {
      nodes {
        ...ProductsCatalog_AdminVendorFields
      }
    }
  }
  ${ProductsCatalogAdminVendorFieldsFragmentDoc}
`

/**
 * __useProductsCatalogGetAdminAllVendorsQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetAdminAllVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetAdminAllVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetAdminAllVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsCatalogGetAdminAllVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetAdminAllVendorsQuery,
    ProductsCatalogGetAdminAllVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetAdminAllVendorsQuery,
    ProductsCatalogGetAdminAllVendorsQueryVariables
  >(ProductsCatalogGetAdminAllVendorsDocument, options)
}
export function useProductsCatalogGetAdminAllVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetAdminAllVendorsQuery,
    ProductsCatalogGetAdminAllVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetAdminAllVendorsQuery,
    ProductsCatalogGetAdminAllVendorsQueryVariables
  >(ProductsCatalogGetAdminAllVendorsDocument, options)
}
export type ProductsCatalogGetAdminAllVendorsQueryHookResult = ReturnType<
  typeof useProductsCatalogGetAdminAllVendorsQuery
>
export type ProductsCatalogGetAdminAllVendorsLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetAdminAllVendorsLazyQuery
>
export type ProductsCatalogGetAdminAllVendorsQueryResult = Apollo.QueryResult<
  ProductsCatalogGetAdminAllVendorsQuery,
  ProductsCatalogGetAdminAllVendorsQueryVariables
>
export function refetchProductsCatalogGetAdminAllVendorsQuery(
  variables?: ProductsCatalogGetAdminAllVendorsQueryVariables,
) {
  return {
    query: ProductsCatalogGetAdminAllVendorsDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetCsvUploadLogsDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetCSVUploadLogs(
    $cursor: ID
    $filterByVendorID: String
  ) {
    getCSVUploadLogs(
      input: {
        filterByVendorID: $filterByVendorID
        limit: 35
        pagination: { cursor: $cursor }
      }
    ) {
      cursor
      hasMore
      nodes {
        id
        additions
        overwrites
        progress
        retailAccounts {
          id
          name
        }
        rowCount
        spreadsheetURL
        status
        type
        uploadedBy {
          id
          email
          displayName
        }
        uploadedOn
        vendors {
          id
          name
        }
      }
    }
  }
`

/**
 * __useProductsCatalogGetCsvUploadLogsQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetCsvUploadLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetCsvUploadLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetCsvUploadLogsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filterByVendorID: // value for 'filterByVendorID'
 *   },
 * });
 */
export function useProductsCatalogGetCsvUploadLogsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductsCatalogGetCsvUploadLogsQuery,
    ProductsCatalogGetCsvUploadLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetCsvUploadLogsQuery,
    ProductsCatalogGetCsvUploadLogsQueryVariables
  >(ProductsCatalogGetCsvUploadLogsDocument, options)
}
export function useProductsCatalogGetCsvUploadLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetCsvUploadLogsQuery,
    ProductsCatalogGetCsvUploadLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetCsvUploadLogsQuery,
    ProductsCatalogGetCsvUploadLogsQueryVariables
  >(ProductsCatalogGetCsvUploadLogsDocument, options)
}
export type ProductsCatalogGetCsvUploadLogsQueryHookResult = ReturnType<
  typeof useProductsCatalogGetCsvUploadLogsQuery
>
export type ProductsCatalogGetCsvUploadLogsLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetCsvUploadLogsLazyQuery
>
export type ProductsCatalogGetCsvUploadLogsQueryResult = Apollo.QueryResult<
  ProductsCatalogGetCsvUploadLogsQuery,
  ProductsCatalogGetCsvUploadLogsQueryVariables
>
export function refetchProductsCatalogGetCsvUploadLogsQuery(
  variables?: ProductsCatalogGetCsvUploadLogsQueryVariables,
) {
  return {
    query: ProductsCatalogGetCsvUploadLogsDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetCsvUploadLogByIdDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetCSVUploadLogByID($ID: ID!) {
    getCSVUploadLogByID(id: $ID) {
      id
      additions
      overwrites
      progress
      retailAccounts {
        id
        name
      }
      rowCount
      spreadsheetURL
      status
      type
      uploadedBy {
        id
        email
        displayName
      }
      uploadedOn
      vendors {
        id
        name
      }
    }
  }
`

/**
 * __useProductsCatalogGetCsvUploadLogByIdQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetCsvUploadLogByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetCsvUploadLogByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetCsvUploadLogByIdQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useProductsCatalogGetCsvUploadLogByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductsCatalogGetCsvUploadLogByIdQuery,
    ProductsCatalogGetCsvUploadLogByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetCsvUploadLogByIdQuery,
    ProductsCatalogGetCsvUploadLogByIdQueryVariables
  >(ProductsCatalogGetCsvUploadLogByIdDocument, options)
}
export function useProductsCatalogGetCsvUploadLogByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetCsvUploadLogByIdQuery,
    ProductsCatalogGetCsvUploadLogByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetCsvUploadLogByIdQuery,
    ProductsCatalogGetCsvUploadLogByIdQueryVariables
  >(ProductsCatalogGetCsvUploadLogByIdDocument, options)
}
export type ProductsCatalogGetCsvUploadLogByIdQueryHookResult = ReturnType<
  typeof useProductsCatalogGetCsvUploadLogByIdQuery
>
export type ProductsCatalogGetCsvUploadLogByIdLazyQueryHookResult = ReturnType<
  typeof useProductsCatalogGetCsvUploadLogByIdLazyQuery
>
export type ProductsCatalogGetCsvUploadLogByIdQueryResult = Apollo.QueryResult<
  ProductsCatalogGetCsvUploadLogByIdQuery,
  ProductsCatalogGetCsvUploadLogByIdQueryVariables
>
export function refetchProductsCatalogGetCsvUploadLogByIdQuery(
  variables: ProductsCatalogGetCsvUploadLogByIdQueryVariables,
) {
  return {
    query: ProductsCatalogGetCsvUploadLogByIdDocument,
    variables: variables,
  }
}
export const ProductsCatalogGetMatchingVendorProductsDocument = /*#__PURE__*/ gql`
  query ProductsCatalog_GetMatchingVendorProducts(
    $itemCode: String
    $UPC: String
    $vendorID: ID!
  ) {
    getMatchingVendorProducts(
      input: { itemCode: $itemCode, UPC: $UPC, vendorID: $vendorID }
    ) {
      totalCount
      nodes {
        matchedBy
        vendorProduct {
          id
          itemCode
          product {
            brandName
            description
            id
            imgURL
            unitUPC
          }
        }
      }
    }
  }
`

/**
 * __useProductsCatalogGetMatchingVendorProductsQuery__
 *
 * To run a query within a React component, call `useProductsCatalogGetMatchingVendorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsCatalogGetMatchingVendorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsCatalogGetMatchingVendorProductsQuery({
 *   variables: {
 *      itemCode: // value for 'itemCode'
 *      UPC: // value for 'UPC'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useProductsCatalogGetMatchingVendorProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductsCatalogGetMatchingVendorProductsQuery,
    ProductsCatalogGetMatchingVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductsCatalogGetMatchingVendorProductsQuery,
    ProductsCatalogGetMatchingVendorProductsQueryVariables
  >(ProductsCatalogGetMatchingVendorProductsDocument, options)
}
export function useProductsCatalogGetMatchingVendorProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsCatalogGetMatchingVendorProductsQuery,
    ProductsCatalogGetMatchingVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductsCatalogGetMatchingVendorProductsQuery,
    ProductsCatalogGetMatchingVendorProductsQueryVariables
  >(ProductsCatalogGetMatchingVendorProductsDocument, options)
}
export type ProductsCatalogGetMatchingVendorProductsQueryHookResult =
  ReturnType<typeof useProductsCatalogGetMatchingVendorProductsQuery>
export type ProductsCatalogGetMatchingVendorProductsLazyQueryHookResult =
  ReturnType<typeof useProductsCatalogGetMatchingVendorProductsLazyQuery>
export type ProductsCatalogGetMatchingVendorProductsQueryResult =
  Apollo.QueryResult<
    ProductsCatalogGetMatchingVendorProductsQuery,
    ProductsCatalogGetMatchingVendorProductsQueryVariables
  >
export function refetchProductsCatalogGetMatchingVendorProductsQuery(
  variables: ProductsCatalogGetMatchingVendorProductsQueryVariables,
) {
  return {
    query: ProductsCatalogGetMatchingVendorProductsDocument,
    variables: variables,
  }
}
export const RetailBuyersCreateBuyerAccountDocument = /*#__PURE__*/ gql`
  mutation RetailBuyers_CreateBuyerAccount(
    $displayName: String
    $email: String!
    $password: String!
    $phoneNumber: String
    $readOnlyOrderGuides: Boolean
    $storeID: ID!
    $defaultDepartmentName: String
  ) {
    createBuyerAccount(
      input: {
        displayName: $displayName
        email: $email
        password: $password
        phoneNumber: $phoneNumber
        readOnlyOrderGuides: $readOnlyOrderGuides
        storeID: $storeID
        defaultDepartmentName: $defaultDepartmentName
      }
    ) {
      ...RetailBuyers_BuyerFields
    }
  }
  ${RetailBuyersBuyerFieldsFragmentDoc}
`
export type RetailBuyersCreateBuyerAccountMutationFn = Apollo.MutationFunction<
  RetailBuyersCreateBuyerAccountMutation,
  RetailBuyersCreateBuyerAccountMutationVariables
>

/**
 * __useRetailBuyersCreateBuyerAccountMutation__
 *
 * To run a mutation, you first call `useRetailBuyersCreateBuyerAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersCreateBuyerAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailBuyersCreateBuyerAccountMutation, { data, loading, error }] = useRetailBuyersCreateBuyerAccountMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      phoneNumber: // value for 'phoneNumber'
 *      readOnlyOrderGuides: // value for 'readOnlyOrderGuides'
 *      storeID: // value for 'storeID'
 *      defaultDepartmentName: // value for 'defaultDepartmentName'
 *   },
 * });
 */
export function useRetailBuyersCreateBuyerAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailBuyersCreateBuyerAccountMutation,
    RetailBuyersCreateBuyerAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailBuyersCreateBuyerAccountMutation,
    RetailBuyersCreateBuyerAccountMutationVariables
  >(RetailBuyersCreateBuyerAccountDocument, options)
}
export type RetailBuyersCreateBuyerAccountMutationHookResult = ReturnType<
  typeof useRetailBuyersCreateBuyerAccountMutation
>
export type RetailBuyersCreateBuyerAccountMutationResult =
  Apollo.MutationResult<RetailBuyersCreateBuyerAccountMutation>
export type RetailBuyersCreateBuyerAccountMutationOptions =
  Apollo.BaseMutationOptions<
    RetailBuyersCreateBuyerAccountMutation,
    RetailBuyersCreateBuyerAccountMutationVariables
  >
export const RetailBuyersUpdateBuyerProfileDocument = /*#__PURE__*/ gql`
  mutation RetailBuyers_UpdateBuyerProfile(
    $displayName: String
    $email: String
    $id: ID!
    $phoneNumber: String
    $readOnlyOrderGuides: Boolean
    $storeID: ID!
    $defaultDepartmentName: String
  ) {
    updateBuyerProfile(
      input: {
        displayName: $displayName
        email: $email
        id: $id
        phoneNumber: $phoneNumber
        readOnlyOrderGuides: $readOnlyOrderGuides
        defaultDepartmentName: $defaultDepartmentName
      }
    ) {
      ...RetailBuyers_BuyerFields
    }
  }
  ${RetailBuyersBuyerFieldsFragmentDoc}
`
export type RetailBuyersUpdateBuyerProfileMutationFn = Apollo.MutationFunction<
  RetailBuyersUpdateBuyerProfileMutation,
  RetailBuyersUpdateBuyerProfileMutationVariables
>

/**
 * __useRetailBuyersUpdateBuyerProfileMutation__
 *
 * To run a mutation, you first call `useRetailBuyersUpdateBuyerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersUpdateBuyerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailBuyersUpdateBuyerProfileMutation, { data, loading, error }] = useRetailBuyersUpdateBuyerProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      phoneNumber: // value for 'phoneNumber'
 *      readOnlyOrderGuides: // value for 'readOnlyOrderGuides'
 *      storeID: // value for 'storeID'
 *      defaultDepartmentName: // value for 'defaultDepartmentName'
 *   },
 * });
 */
export function useRetailBuyersUpdateBuyerProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailBuyersUpdateBuyerProfileMutation,
    RetailBuyersUpdateBuyerProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailBuyersUpdateBuyerProfileMutation,
    RetailBuyersUpdateBuyerProfileMutationVariables
  >(RetailBuyersUpdateBuyerProfileDocument, options)
}
export type RetailBuyersUpdateBuyerProfileMutationHookResult = ReturnType<
  typeof useRetailBuyersUpdateBuyerProfileMutation
>
export type RetailBuyersUpdateBuyerProfileMutationResult =
  Apollo.MutationResult<RetailBuyersUpdateBuyerProfileMutation>
export type RetailBuyersUpdateBuyerProfileMutationOptions =
  Apollo.BaseMutationOptions<
    RetailBuyersUpdateBuyerProfileMutation,
    RetailBuyersUpdateBuyerProfileMutationVariables
  >
export const RetailBuyersAddBuyerToStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation RetailBuyers_AddBuyerToStoreDepartment(
    $storeDepartmentID: ID!
    $userID: ID!
  ) {
    createUserStoreDepartment(
      input: { storeDepartmentID: $storeDepartmentID, userID: $userID }
    ) {
      id
      user {
        id
        retailUser {
          user {
            id
          }
          userStoreDepartments {
            nodes {
              ...RetailBuyers_BuyerUserStoreDepartmentFields
            }
          }
        }
      }
    }
  }
  ${RetailBuyersBuyerUserStoreDepartmentFieldsFragmentDoc}
`
export type RetailBuyersAddBuyerToStoreDepartmentMutationFn =
  Apollo.MutationFunction<
    RetailBuyersAddBuyerToStoreDepartmentMutation,
    RetailBuyersAddBuyerToStoreDepartmentMutationVariables
  >

/**
 * __useRetailBuyersAddBuyerToStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useRetailBuyersAddBuyerToStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersAddBuyerToStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailBuyersAddBuyerToStoreDepartmentMutation, { data, loading, error }] = useRetailBuyersAddBuyerToStoreDepartmentMutation({
 *   variables: {
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useRetailBuyersAddBuyerToStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailBuyersAddBuyerToStoreDepartmentMutation,
    RetailBuyersAddBuyerToStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailBuyersAddBuyerToStoreDepartmentMutation,
    RetailBuyersAddBuyerToStoreDepartmentMutationVariables
  >(RetailBuyersAddBuyerToStoreDepartmentDocument, options)
}
export type RetailBuyersAddBuyerToStoreDepartmentMutationHookResult =
  ReturnType<typeof useRetailBuyersAddBuyerToStoreDepartmentMutation>
export type RetailBuyersAddBuyerToStoreDepartmentMutationResult =
  Apollo.MutationResult<RetailBuyersAddBuyerToStoreDepartmentMutation>
export type RetailBuyersAddBuyerToStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    RetailBuyersAddBuyerToStoreDepartmentMutation,
    RetailBuyersAddBuyerToStoreDepartmentMutationVariables
  >
export const RetailBuyersRemoveBuyerFromStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation RetailBuyers_RemoveBuyerFromStoreDepartment(
    $userStoreDepartmentID: ID!
  ) {
    deleteUserStoreDepartment(
      input: { userStoreDepartmentID: $userStoreDepartmentID }
    ) {
      id
      user {
        id
        retailUser {
          user {
            id
          }
          userStoreDepartments {
            nodes {
              ...RetailBuyers_BuyerUserStoreDepartmentFields
            }
          }
        }
      }
    }
  }
  ${RetailBuyersBuyerUserStoreDepartmentFieldsFragmentDoc}
`
export type RetailBuyersRemoveBuyerFromStoreDepartmentMutationFn =
  Apollo.MutationFunction<
    RetailBuyersRemoveBuyerFromStoreDepartmentMutation,
    RetailBuyersRemoveBuyerFromStoreDepartmentMutationVariables
  >

/**
 * __useRetailBuyersRemoveBuyerFromStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useRetailBuyersRemoveBuyerFromStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersRemoveBuyerFromStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailBuyersRemoveBuyerFromStoreDepartmentMutation, { data, loading, error }] = useRetailBuyersRemoveBuyerFromStoreDepartmentMutation({
 *   variables: {
 *      userStoreDepartmentID: // value for 'userStoreDepartmentID'
 *   },
 * });
 */
export function useRetailBuyersRemoveBuyerFromStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailBuyersRemoveBuyerFromStoreDepartmentMutation,
    RetailBuyersRemoveBuyerFromStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailBuyersRemoveBuyerFromStoreDepartmentMutation,
    RetailBuyersRemoveBuyerFromStoreDepartmentMutationVariables
  >(RetailBuyersRemoveBuyerFromStoreDepartmentDocument, options)
}
export type RetailBuyersRemoveBuyerFromStoreDepartmentMutationHookResult =
  ReturnType<typeof useRetailBuyersRemoveBuyerFromStoreDepartmentMutation>
export type RetailBuyersRemoveBuyerFromStoreDepartmentMutationResult =
  Apollo.MutationResult<RetailBuyersRemoveBuyerFromStoreDepartmentMutation>
export type RetailBuyersRemoveBuyerFromStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    RetailBuyersRemoveBuyerFromStoreDepartmentMutation,
    RetailBuyersRemoveBuyerFromStoreDepartmentMutationVariables
  >
export const RetailBuyersGetRetailUserByIdDocument = /*#__PURE__*/ gql`
  query RetailBuyers_GetRetailUserByID($storeID: ID!, $userID: ID!) {
    storeByID(id: $storeID) {
      id
      name
      retailUserByID(id: $userID) {
        user {
          id
          displayName
        }
      }
    }
  }
`

/**
 * __useRetailBuyersGetRetailUserByIdQuery__
 *
 * To run a query within a React component, call `useRetailBuyersGetRetailUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersGetRetailUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailBuyersGetRetailUserByIdQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useRetailBuyersGetRetailUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailBuyersGetRetailUserByIdQuery,
    RetailBuyersGetRetailUserByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailBuyersGetRetailUserByIdQuery,
    RetailBuyersGetRetailUserByIdQueryVariables
  >(RetailBuyersGetRetailUserByIdDocument, options)
}
export function useRetailBuyersGetRetailUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailBuyersGetRetailUserByIdQuery,
    RetailBuyersGetRetailUserByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailBuyersGetRetailUserByIdQuery,
    RetailBuyersGetRetailUserByIdQueryVariables
  >(RetailBuyersGetRetailUserByIdDocument, options)
}
export type RetailBuyersGetRetailUserByIdQueryHookResult = ReturnType<
  typeof useRetailBuyersGetRetailUserByIdQuery
>
export type RetailBuyersGetRetailUserByIdLazyQueryHookResult = ReturnType<
  typeof useRetailBuyersGetRetailUserByIdLazyQuery
>
export type RetailBuyersGetRetailUserByIdQueryResult = Apollo.QueryResult<
  RetailBuyersGetRetailUserByIdQuery,
  RetailBuyersGetRetailUserByIdQueryVariables
>
export function refetchRetailBuyersGetRetailUserByIdQuery(
  variables: RetailBuyersGetRetailUserByIdQueryVariables,
) {
  return { query: RetailBuyersGetRetailUserByIdDocument, variables: variables }
}
export const RetailBuyersGetStoreBuyersDocument = /*#__PURE__*/ gql`
  query RetailBuyers_GetStoreBuyers($storeID: ID!, $query: String) {
    storeByID(id: $storeID) {
      address
      id
      name
      retailUsers(input: { query: $query }) {
        nodes {
          ...RetailBuyers_BuyerFields
        }
      }
    }
  }
  ${RetailBuyersBuyerFieldsFragmentDoc}
`

/**
 * __useRetailBuyersGetStoreBuyersQuery__
 *
 * To run a query within a React component, call `useRetailBuyersGetStoreBuyersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersGetStoreBuyersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailBuyersGetStoreBuyersQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRetailBuyersGetStoreBuyersQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailBuyersGetStoreBuyersQuery,
    RetailBuyersGetStoreBuyersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailBuyersGetStoreBuyersQuery,
    RetailBuyersGetStoreBuyersQueryVariables
  >(RetailBuyersGetStoreBuyersDocument, options)
}
export function useRetailBuyersGetStoreBuyersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailBuyersGetStoreBuyersQuery,
    RetailBuyersGetStoreBuyersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailBuyersGetStoreBuyersQuery,
    RetailBuyersGetStoreBuyersQueryVariables
  >(RetailBuyersGetStoreBuyersDocument, options)
}
export type RetailBuyersGetStoreBuyersQueryHookResult = ReturnType<
  typeof useRetailBuyersGetStoreBuyersQuery
>
export type RetailBuyersGetStoreBuyersLazyQueryHookResult = ReturnType<
  typeof useRetailBuyersGetStoreBuyersLazyQuery
>
export type RetailBuyersGetStoreBuyersQueryResult = Apollo.QueryResult<
  RetailBuyersGetStoreBuyersQuery,
  RetailBuyersGetStoreBuyersQueryVariables
>
export function refetchRetailBuyersGetStoreBuyersQuery(
  variables: RetailBuyersGetStoreBuyersQueryVariables,
) {
  return { query: RetailBuyersGetStoreBuyersDocument, variables: variables }
}
export const RetailBuyersGetStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query RetailBuyers_GetStoreDepartments($storeID: ID!) {
    storeByID(id: $storeID) {
      id
      name
      storeDepartments {
        nodes {
          id
          name
          imageURL
        }
      }
    }
  }
`

/**
 * __useRetailBuyersGetStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useRetailBuyersGetStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailBuyersGetStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailBuyersGetStoreDepartmentsQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useRetailBuyersGetStoreDepartmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailBuyersGetStoreDepartmentsQuery,
    RetailBuyersGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailBuyersGetStoreDepartmentsQuery,
    RetailBuyersGetStoreDepartmentsQueryVariables
  >(RetailBuyersGetStoreDepartmentsDocument, options)
}
export function useRetailBuyersGetStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailBuyersGetStoreDepartmentsQuery,
    RetailBuyersGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailBuyersGetStoreDepartmentsQuery,
    RetailBuyersGetStoreDepartmentsQueryVariables
  >(RetailBuyersGetStoreDepartmentsDocument, options)
}
export type RetailBuyersGetStoreDepartmentsQueryHookResult = ReturnType<
  typeof useRetailBuyersGetStoreDepartmentsQuery
>
export type RetailBuyersGetStoreDepartmentsLazyQueryHookResult = ReturnType<
  typeof useRetailBuyersGetStoreDepartmentsLazyQuery
>
export type RetailBuyersGetStoreDepartmentsQueryResult = Apollo.QueryResult<
  RetailBuyersGetStoreDepartmentsQuery,
  RetailBuyersGetStoreDepartmentsQueryVariables
>
export function refetchRetailBuyersGetStoreDepartmentsQuery(
  variables: RetailBuyersGetStoreDepartmentsQueryVariables,
) {
  return {
    query: RetailBuyersGetStoreDepartmentsDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogAddProductToOrderGuideDocument = /*#__PURE__*/ gql`
  mutation RetailVendorCatalog_AddProductToOrderGuide(
    $vendorProductIDs: [ID!]!
    $storeDepartmentID: ID!
  ) {
    addProductsToV2OrderGuideForStoreDepartment(
      input: {
        storeDepartmentID: $storeDepartmentID
        vendorProductIDs: $vendorProductIDs
      }
    ) {
      addedVendorProducts {
        id
      }
      orderGuide {
        ...RetailVendorCatalog_OrderGuideCatalogFields
      }
    }
  }
  ${RetailVendorCatalogOrderGuideCatalogFieldsFragmentDoc}
`
export type RetailVendorCatalogAddProductToOrderGuideMutationFn =
  Apollo.MutationFunction<
    RetailVendorCatalogAddProductToOrderGuideMutation,
    RetailVendorCatalogAddProductToOrderGuideMutationVariables
  >

/**
 * __useRetailVendorCatalogAddProductToOrderGuideMutation__
 *
 * To run a mutation, you first call `useRetailVendorCatalogAddProductToOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogAddProductToOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailVendorCatalogAddProductToOrderGuideMutation, { data, loading, error }] = useRetailVendorCatalogAddProductToOrderGuideMutation({
 *   variables: {
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *   },
 * });
 */
export function useRetailVendorCatalogAddProductToOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailVendorCatalogAddProductToOrderGuideMutation,
    RetailVendorCatalogAddProductToOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailVendorCatalogAddProductToOrderGuideMutation,
    RetailVendorCatalogAddProductToOrderGuideMutationVariables
  >(RetailVendorCatalogAddProductToOrderGuideDocument, options)
}
export type RetailVendorCatalogAddProductToOrderGuideMutationHookResult =
  ReturnType<typeof useRetailVendorCatalogAddProductToOrderGuideMutation>
export type RetailVendorCatalogAddProductToOrderGuideMutationResult =
  Apollo.MutationResult<RetailVendorCatalogAddProductToOrderGuideMutation>
export type RetailVendorCatalogAddProductToOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    RetailVendorCatalogAddProductToOrderGuideMutation,
    RetailVendorCatalogAddProductToOrderGuideMutationVariables
  >
export const RetailVendorCatalogRemoveProductFromOrderGuideDocument = /*#__PURE__*/ gql`
  mutation RetailVendorCatalog_RemoveProductFromOrderGuide(
    $vendorProductIDs: [ID!]!
    $storeDepartmentID: ID!
  ) {
    removeProductsFromV2OrderGuideForStoreDepartment(
      input: {
        storeDepartmentID: $storeDepartmentID
        vendorProductIDs: $vendorProductIDs
      }
    ) {
      removedVendorProducts {
        id
      }
      orderGuide {
        ...RetailVendorCatalog_OrderGuideCatalogFields
      }
    }
  }
  ${RetailVendorCatalogOrderGuideCatalogFieldsFragmentDoc}
`
export type RetailVendorCatalogRemoveProductFromOrderGuideMutationFn =
  Apollo.MutationFunction<
    RetailVendorCatalogRemoveProductFromOrderGuideMutation,
    RetailVendorCatalogRemoveProductFromOrderGuideMutationVariables
  >

/**
 * __useRetailVendorCatalogRemoveProductFromOrderGuideMutation__
 *
 * To run a mutation, you first call `useRetailVendorCatalogRemoveProductFromOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogRemoveProductFromOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailVendorCatalogRemoveProductFromOrderGuideMutation, { data, loading, error }] = useRetailVendorCatalogRemoveProductFromOrderGuideMutation({
 *   variables: {
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *   },
 * });
 */
export function useRetailVendorCatalogRemoveProductFromOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailVendorCatalogRemoveProductFromOrderGuideMutation,
    RetailVendorCatalogRemoveProductFromOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailVendorCatalogRemoveProductFromOrderGuideMutation,
    RetailVendorCatalogRemoveProductFromOrderGuideMutationVariables
  >(RetailVendorCatalogRemoveProductFromOrderGuideDocument, options)
}
export type RetailVendorCatalogRemoveProductFromOrderGuideMutationHookResult =
  ReturnType<typeof useRetailVendorCatalogRemoveProductFromOrderGuideMutation>
export type RetailVendorCatalogRemoveProductFromOrderGuideMutationResult =
  Apollo.MutationResult<RetailVendorCatalogRemoveProductFromOrderGuideMutation>
export type RetailVendorCatalogRemoveProductFromOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    RetailVendorCatalogRemoveProductFromOrderGuideMutation,
    RetailVendorCatalogRemoveProductFromOrderGuideMutationVariables
  >
export const RetailVendorCatalogUpdateStoreVendorProductDocument = /*#__PURE__*/ gql`
  mutation RetailVendorCatalog_UpdateStoreVendorProduct(
    $accountSpecificCasePrice: [AccountSpecificPriceInput!]
    $accountSpecificUnitPrice: [AccountSpecificPriceInput!]
    $bannerID: ID!
    $retailerDiscontinuedDates: [RetailerDiscontinuedDateInput!]
    $productID: ID!
  ) {
    updateStoreVendorProduct(
      input: {
        accountSpecificCasePrice: $accountSpecificCasePrice
        accountSpecificUnitPrice: $accountSpecificUnitPrice
        retailerDiscontinuedDates: $retailerDiscontinuedDates
        productID: $productID
      }
    ) {
      ...RetailVendorCatalog_VendorCatalogProductFields
      allRetailerPricing {
        retailCompany {
          id
          name
        }
        pricing {
          casePrice
          unitPrice
        }
      }
    }
  }
  ${RetailVendorCatalogVendorCatalogProductFieldsFragmentDoc}
`
export type RetailVendorCatalogUpdateStoreVendorProductMutationFn =
  Apollo.MutationFunction<
    RetailVendorCatalogUpdateStoreVendorProductMutation,
    RetailVendorCatalogUpdateStoreVendorProductMutationVariables
  >

/**
 * __useRetailVendorCatalogUpdateStoreVendorProductMutation__
 *
 * To run a mutation, you first call `useRetailVendorCatalogUpdateStoreVendorProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogUpdateStoreVendorProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailVendorCatalogUpdateStoreVendorProductMutation, { data, loading, error }] = useRetailVendorCatalogUpdateStoreVendorProductMutation({
 *   variables: {
 *      accountSpecificCasePrice: // value for 'accountSpecificCasePrice'
 *      accountSpecificUnitPrice: // value for 'accountSpecificUnitPrice'
 *      bannerID: // value for 'bannerID'
 *      retailerDiscontinuedDates: // value for 'retailerDiscontinuedDates'
 *      productID: // value for 'productID'
 *   },
 * });
 */
export function useRetailVendorCatalogUpdateStoreVendorProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailVendorCatalogUpdateStoreVendorProductMutation,
    RetailVendorCatalogUpdateStoreVendorProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailVendorCatalogUpdateStoreVendorProductMutation,
    RetailVendorCatalogUpdateStoreVendorProductMutationVariables
  >(RetailVendorCatalogUpdateStoreVendorProductDocument, options)
}
export type RetailVendorCatalogUpdateStoreVendorProductMutationHookResult =
  ReturnType<typeof useRetailVendorCatalogUpdateStoreVendorProductMutation>
export type RetailVendorCatalogUpdateStoreVendorProductMutationResult =
  Apollo.MutationResult<RetailVendorCatalogUpdateStoreVendorProductMutation>
export type RetailVendorCatalogUpdateStoreVendorProductMutationOptions =
  Apollo.BaseMutationOptions<
    RetailVendorCatalogUpdateStoreVendorProductMutation,
    RetailVendorCatalogUpdateStoreVendorProductMutationVariables
  >
export const RetailVendorCatalogGetAdminBannerBuyersDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetAdminBannerBuyers {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              stores {
                nodes {
                  id
                  name
                  retailUsers {
                    nodes {
                      user {
                        id
                        displayName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useRetailVendorCatalogGetAdminBannerBuyersQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetAdminBannerBuyersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetAdminBannerBuyersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetAdminBannerBuyersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailVendorCatalogGetAdminBannerBuyersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailVendorCatalogGetAdminBannerBuyersQuery,
    RetailVendorCatalogGetAdminBannerBuyersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetAdminBannerBuyersQuery,
    RetailVendorCatalogGetAdminBannerBuyersQueryVariables
  >(RetailVendorCatalogGetAdminBannerBuyersDocument, options)
}
export function useRetailVendorCatalogGetAdminBannerBuyersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetAdminBannerBuyersQuery,
    RetailVendorCatalogGetAdminBannerBuyersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetAdminBannerBuyersQuery,
    RetailVendorCatalogGetAdminBannerBuyersQueryVariables
  >(RetailVendorCatalogGetAdminBannerBuyersDocument, options)
}
export type RetailVendorCatalogGetAdminBannerBuyersQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetAdminBannerBuyersQuery
>
export type RetailVendorCatalogGetAdminBannerBuyersLazyQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetAdminBannerBuyersLazyQuery>
export type RetailVendorCatalogGetAdminBannerBuyersQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetAdminBannerBuyersQuery,
    RetailVendorCatalogGetAdminBannerBuyersQueryVariables
  >
export function refetchRetailVendorCatalogGetAdminBannerBuyersQuery(
  variables?: RetailVendorCatalogGetAdminBannerBuyersQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetAdminBannerBuyersDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetAllOrderGuidesDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetAllOrderGuides {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              stores {
                nodes {
                  id
                  name
                  storeDepartments {
                    nodes {
                      id
                      name
                    }
                  }
                }
              }
            }
            store {
              id
              name
              storeDepartments {
                nodes {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useRetailVendorCatalogGetAllOrderGuidesQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetAllOrderGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetAllOrderGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetAllOrderGuidesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailVendorCatalogGetAllOrderGuidesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailVendorCatalogGetAllOrderGuidesQuery,
    RetailVendorCatalogGetAllOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetAllOrderGuidesQuery,
    RetailVendorCatalogGetAllOrderGuidesQueryVariables
  >(RetailVendorCatalogGetAllOrderGuidesDocument, options)
}
export function useRetailVendorCatalogGetAllOrderGuidesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetAllOrderGuidesQuery,
    RetailVendorCatalogGetAllOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetAllOrderGuidesQuery,
    RetailVendorCatalogGetAllOrderGuidesQueryVariables
  >(RetailVendorCatalogGetAllOrderGuidesDocument, options)
}
export type RetailVendorCatalogGetAllOrderGuidesQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetAllOrderGuidesQuery
>
export type RetailVendorCatalogGetAllOrderGuidesLazyQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetAllOrderGuidesLazyQuery>
export type RetailVendorCatalogGetAllOrderGuidesQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetAllOrderGuidesQuery,
    RetailVendorCatalogGetAllOrderGuidesQueryVariables
  >
export function refetchRetailVendorCatalogGetAllOrderGuidesQuery(
  variables?: RetailVendorCatalogGetAllOrderGuidesQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetAllOrderGuidesDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetVendorProductsDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetVendorProducts(
    $bannerID: ID!
    $cursor: ID
    $filterByBrand: String
    $filterByCategory: String
    $search: String
    $vendorID: ID!
  ) {
    vendorByID(id: $vendorID) {
      id
      name
      catalogLastUpdatedAt
      hasVendorDashAccess
      vendorProducts(
        input: {
          filterByBrand: $filterByBrand
          filterByCategory: $filterByCategory
          limit: 15
          pagination: { cursor: $cursor }
          search: $search
          sortBy: { field: ITEM_CODE }
        }
      ) {
        cursor
        hasMore
        nodes {
          ...RetailVendorCatalog_VendorCatalogProductFields
        }
      }
    }
  }
  ${RetailVendorCatalogVendorCatalogProductFieldsFragmentDoc}
`

/**
 * __useRetailVendorCatalogGetVendorProductsQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetVendorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetVendorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetVendorProductsQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      cursor: // value for 'cursor'
 *      filterByBrand: // value for 'filterByBrand'
 *      filterByCategory: // value for 'filterByCategory'
 *      search: // value for 'search'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailVendorCatalogGetVendorProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailVendorCatalogGetVendorProductsQuery,
    RetailVendorCatalogGetVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetVendorProductsQuery,
    RetailVendorCatalogGetVendorProductsQueryVariables
  >(RetailVendorCatalogGetVendorProductsDocument, options)
}
export function useRetailVendorCatalogGetVendorProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetVendorProductsQuery,
    RetailVendorCatalogGetVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetVendorProductsQuery,
    RetailVendorCatalogGetVendorProductsQueryVariables
  >(RetailVendorCatalogGetVendorProductsDocument, options)
}
export type RetailVendorCatalogGetVendorProductsQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetVendorProductsQuery
>
export type RetailVendorCatalogGetVendorProductsLazyQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetVendorProductsLazyQuery>
export type RetailVendorCatalogGetVendorProductsQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetVendorProductsQuery,
    RetailVendorCatalogGetVendorProductsQueryVariables
  >
export function refetchRetailVendorCatalogGetVendorProductsQuery(
  variables: RetailVendorCatalogGetVendorProductsQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetVendorProductsDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetVendorProductDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetVendorProduct(
    $bannerID: ID!
    $id: String!
    $vendorID: String!
  ) {
    vendorProductByID(id: $id, vendorID: $vendorID) {
      ...RetailVendorCatalog_VendorCatalogProductFields
    }
  }
  ${RetailVendorCatalogVendorCatalogProductFieldsFragmentDoc}
`

/**
 * __useRetailVendorCatalogGetVendorProductQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetVendorProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetVendorProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetVendorProductQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      id: // value for 'id'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailVendorCatalogGetVendorProductQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailVendorCatalogGetVendorProductQuery,
    RetailVendorCatalogGetVendorProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetVendorProductQuery,
    RetailVendorCatalogGetVendorProductQueryVariables
  >(RetailVendorCatalogGetVendorProductDocument, options)
}
export function useRetailVendorCatalogGetVendorProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetVendorProductQuery,
    RetailVendorCatalogGetVendorProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetVendorProductQuery,
    RetailVendorCatalogGetVendorProductQueryVariables
  >(RetailVendorCatalogGetVendorProductDocument, options)
}
export type RetailVendorCatalogGetVendorProductQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetVendorProductQuery
>
export type RetailVendorCatalogGetVendorProductLazyQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetVendorProductLazyQuery
>
export type RetailVendorCatalogGetVendorProductQueryResult = Apollo.QueryResult<
  RetailVendorCatalogGetVendorProductQuery,
  RetailVendorCatalogGetVendorProductQueryVariables
>
export function refetchRetailVendorCatalogGetVendorProductQuery(
  variables: RetailVendorCatalogGetVendorProductQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetVendorProductDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetVendorProductCustomPricingDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetVendorProductCustomPricing(
    $id: String!
    $vendorID: String!
  ) {
    vendorProductByID(id: $id, vendorID: $vendorID) {
      id
      allRetailerPricing {
        retailCompany {
          id
          name
        }
        pricing {
          casePrice
          unitPrice
        }
      }
    }
  }
`

/**
 * __useRetailVendorCatalogGetVendorProductCustomPricingQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetVendorProductCustomPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetVendorProductCustomPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetVendorProductCustomPricingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailVendorCatalogGetVendorProductCustomPricingQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailVendorCatalogGetVendorProductCustomPricingQuery,
    RetailVendorCatalogGetVendorProductCustomPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetVendorProductCustomPricingQuery,
    RetailVendorCatalogGetVendorProductCustomPricingQueryVariables
  >(RetailVendorCatalogGetVendorProductCustomPricingDocument, options)
}
export function useRetailVendorCatalogGetVendorProductCustomPricingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetVendorProductCustomPricingQuery,
    RetailVendorCatalogGetVendorProductCustomPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetVendorProductCustomPricingQuery,
    RetailVendorCatalogGetVendorProductCustomPricingQueryVariables
  >(RetailVendorCatalogGetVendorProductCustomPricingDocument, options)
}
export type RetailVendorCatalogGetVendorProductCustomPricingQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetVendorProductCustomPricingQuery>
export type RetailVendorCatalogGetVendorProductCustomPricingLazyQueryHookResult =
  ReturnType<
    typeof useRetailVendorCatalogGetVendorProductCustomPricingLazyQuery
  >
export type RetailVendorCatalogGetVendorProductCustomPricingQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetVendorProductCustomPricingQuery,
    RetailVendorCatalogGetVendorProductCustomPricingQueryVariables
  >
export function refetchRetailVendorCatalogGetVendorProductCustomPricingQuery(
  variables: RetailVendorCatalogGetVendorProductCustomPricingQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetVendorProductCustomPricingDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetVendorBrandsDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetVendorBrands($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      vendorBrands {
        nodes
      }
    }
  }
`

/**
 * __useRetailVendorCatalogGetVendorBrandsQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetVendorBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetVendorBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetVendorBrandsQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailVendorCatalogGetVendorBrandsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailVendorCatalogGetVendorBrandsQuery,
    RetailVendorCatalogGetVendorBrandsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetVendorBrandsQuery,
    RetailVendorCatalogGetVendorBrandsQueryVariables
  >(RetailVendorCatalogGetVendorBrandsDocument, options)
}
export function useRetailVendorCatalogGetVendorBrandsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetVendorBrandsQuery,
    RetailVendorCatalogGetVendorBrandsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetVendorBrandsQuery,
    RetailVendorCatalogGetVendorBrandsQueryVariables
  >(RetailVendorCatalogGetVendorBrandsDocument, options)
}
export type RetailVendorCatalogGetVendorBrandsQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetVendorBrandsQuery
>
export type RetailVendorCatalogGetVendorBrandsLazyQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetVendorBrandsLazyQuery
>
export type RetailVendorCatalogGetVendorBrandsQueryResult = Apollo.QueryResult<
  RetailVendorCatalogGetVendorBrandsQuery,
  RetailVendorCatalogGetVendorBrandsQueryVariables
>
export function refetchRetailVendorCatalogGetVendorBrandsQuery(
  variables: RetailVendorCatalogGetVendorBrandsQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetVendorBrandsDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetVendorCategoriesDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetVendorCategories($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      vendorCategories {
        nodes
      }
    }
  }
`

/**
 * __useRetailVendorCatalogGetVendorCategoriesQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetVendorCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetVendorCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetVendorCategoriesQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailVendorCatalogGetVendorCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailVendorCatalogGetVendorCategoriesQuery,
    RetailVendorCatalogGetVendorCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetVendorCategoriesQuery,
    RetailVendorCatalogGetVendorCategoriesQueryVariables
  >(RetailVendorCatalogGetVendorCategoriesDocument, options)
}
export function useRetailVendorCatalogGetVendorCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetVendorCategoriesQuery,
    RetailVendorCatalogGetVendorCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetVendorCategoriesQuery,
    RetailVendorCatalogGetVendorCategoriesQueryVariables
  >(RetailVendorCatalogGetVendorCategoriesDocument, options)
}
export type RetailVendorCatalogGetVendorCategoriesQueryHookResult = ReturnType<
  typeof useRetailVendorCatalogGetVendorCategoriesQuery
>
export type RetailVendorCatalogGetVendorCategoriesLazyQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetVendorCategoriesLazyQuery>
export type RetailVendorCatalogGetVendorCategoriesQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetVendorCategoriesQuery,
    RetailVendorCatalogGetVendorCategoriesQueryVariables
  >
export function refetchRetailVendorCatalogGetVendorCategoriesQuery(
  variables: RetailVendorCatalogGetVendorCategoriesQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetVendorCategoriesDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetRetailCompanyVendorsDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetRetailCompanyVendors($query: String) {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              vendors(input: { query: $query }) {
                nodes {
                  ...RetailVendorCatalog_VendorCatalogFields
                }
              }
            }
            store {
              id
              vendors(input: { query: $query }) {
                nodes {
                  ...RetailVendorCatalog_VendorCatalogFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${RetailVendorCatalogVendorCatalogFieldsFragmentDoc}
`

/**
 * __useRetailVendorCatalogGetRetailCompanyVendorsQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetRetailCompanyVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetRetailCompanyVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetRetailCompanyVendorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRetailVendorCatalogGetRetailCompanyVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailVendorCatalogGetRetailCompanyVendorsQuery,
    RetailVendorCatalogGetRetailCompanyVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetRetailCompanyVendorsQuery,
    RetailVendorCatalogGetRetailCompanyVendorsQueryVariables
  >(RetailVendorCatalogGetRetailCompanyVendorsDocument, options)
}
export function useRetailVendorCatalogGetRetailCompanyVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetRetailCompanyVendorsQuery,
    RetailVendorCatalogGetRetailCompanyVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetRetailCompanyVendorsQuery,
    RetailVendorCatalogGetRetailCompanyVendorsQueryVariables
  >(RetailVendorCatalogGetRetailCompanyVendorsDocument, options)
}
export type RetailVendorCatalogGetRetailCompanyVendorsQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetRetailCompanyVendorsQuery>
export type RetailVendorCatalogGetRetailCompanyVendorsLazyQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetRetailCompanyVendorsLazyQuery>
export type RetailVendorCatalogGetRetailCompanyVendorsQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetRetailCompanyVendorsQuery,
    RetailVendorCatalogGetRetailCompanyVendorsQueryVariables
  >
export function refetchRetailVendorCatalogGetRetailCompanyVendorsQuery(
  variables?: RetailVendorCatalogGetRetailCompanyVendorsQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetRetailCompanyVendorsDocument,
    variables: variables,
  }
}
export const RetailVendorCatalogGetDiscoverableVendorsDocument = /*#__PURE__*/ gql`
  query RetailVendorCatalog_GetDiscoverableVendors(
    $cursor: String
    $query: String
  ) {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              discoverableVendors(
                input: { cursor: $cursor, limit: 50, query: $query }
              ) {
                cursor
                hasMore
                nodes {
                  ...RetailVendorCatalog_VendorCatalogFields
                }
              }
            }
            store {
              id
              discoverableVendors(
                input: { cursor: $cursor, limit: 50, query: $query }
              ) {
                cursor
                hasMore
                nodes {
                  ...RetailVendorCatalog_VendorCatalogFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${RetailVendorCatalogVendorCatalogFieldsFragmentDoc}
`

/**
 * __useRetailVendorCatalogGetDiscoverableVendorsQuery__
 *
 * To run a query within a React component, call `useRetailVendorCatalogGetDiscoverableVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorCatalogGetDiscoverableVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorCatalogGetDiscoverableVendorsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRetailVendorCatalogGetDiscoverableVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailVendorCatalogGetDiscoverableVendorsQuery,
    RetailVendorCatalogGetDiscoverableVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorCatalogGetDiscoverableVendorsQuery,
    RetailVendorCatalogGetDiscoverableVendorsQueryVariables
  >(RetailVendorCatalogGetDiscoverableVendorsDocument, options)
}
export function useRetailVendorCatalogGetDiscoverableVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorCatalogGetDiscoverableVendorsQuery,
    RetailVendorCatalogGetDiscoverableVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorCatalogGetDiscoverableVendorsQuery,
    RetailVendorCatalogGetDiscoverableVendorsQueryVariables
  >(RetailVendorCatalogGetDiscoverableVendorsDocument, options)
}
export type RetailVendorCatalogGetDiscoverableVendorsQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetDiscoverableVendorsQuery>
export type RetailVendorCatalogGetDiscoverableVendorsLazyQueryHookResult =
  ReturnType<typeof useRetailVendorCatalogGetDiscoverableVendorsLazyQuery>
export type RetailVendorCatalogGetDiscoverableVendorsQueryResult =
  Apollo.QueryResult<
    RetailVendorCatalogGetDiscoverableVendorsQuery,
    RetailVendorCatalogGetDiscoverableVendorsQueryVariables
  >
export function refetchRetailVendorCatalogGetDiscoverableVendorsQuery(
  variables?: RetailVendorCatalogGetDiscoverableVendorsQueryVariables,
) {
  return {
    query: RetailVendorCatalogGetDiscoverableVendorsDocument,
    variables: variables,
  }
}
export const RetailBulkActionGetAllStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query RetailBulkAction_GetAllStoreDepartments {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              stores {
                nodes {
                  ...RetailBulkAction_StoreDepartmentsFields
                }
              }
            }
            store {
              ...RetailBulkAction_StoreDepartmentsFields
            }
          }
        }
      }
    }
  }
  ${RetailBulkActionStoreDepartmentsFieldsFragmentDoc}
`

/**
 * __useRetailBulkActionGetAllStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useRetailBulkActionGetAllStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailBulkActionGetAllStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailBulkActionGetAllStoreDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailBulkActionGetAllStoreDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailBulkActionGetAllStoreDepartmentsQuery,
    RetailBulkActionGetAllStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailBulkActionGetAllStoreDepartmentsQuery,
    RetailBulkActionGetAllStoreDepartmentsQueryVariables
  >(RetailBulkActionGetAllStoreDepartmentsDocument, options)
}
export function useRetailBulkActionGetAllStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailBulkActionGetAllStoreDepartmentsQuery,
    RetailBulkActionGetAllStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailBulkActionGetAllStoreDepartmentsQuery,
    RetailBulkActionGetAllStoreDepartmentsQueryVariables
  >(RetailBulkActionGetAllStoreDepartmentsDocument, options)
}
export type RetailBulkActionGetAllStoreDepartmentsQueryHookResult = ReturnType<
  typeof useRetailBulkActionGetAllStoreDepartmentsQuery
>
export type RetailBulkActionGetAllStoreDepartmentsLazyQueryHookResult =
  ReturnType<typeof useRetailBulkActionGetAllStoreDepartmentsLazyQuery>
export type RetailBulkActionGetAllStoreDepartmentsQueryResult =
  Apollo.QueryResult<
    RetailBulkActionGetAllStoreDepartmentsQuery,
    RetailBulkActionGetAllStoreDepartmentsQueryVariables
  >
export function refetchRetailBulkActionGetAllStoreDepartmentsQuery(
  variables?: RetailBulkActionGetAllStoreDepartmentsQueryVariables,
) {
  return {
    query: RetailBulkActionGetAllStoreDepartmentsDocument,
    variables: variables,
  }
}
export const RetailGetUserStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query Retail_GetUserStoreDepartments(
    $storeID: ID!
    $buyerID: ID!
    $withDefaultDepartmentName: Boolean!
    $withUserStoreDepartments: Boolean!
  ) {
    storeByID(id: $storeID) {
      id
      storeDepartments {
        nodes {
          id
          name
        }
      }
      retailUserByID(id: $buyerID) {
        user {
          id
          defaultDepartmentName @include(if: $withDefaultDepartmentName)
        }
        userStoreDepartments @include(if: $withUserStoreDepartments) {
          nodes {
            id
            storeDepartment {
              id
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useRetailGetUserStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useRetailGetUserStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailGetUserStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailGetUserStoreDepartmentsQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      buyerID: // value for 'buyerID'
 *      withDefaultDepartmentName: // value for 'withDefaultDepartmentName'
 *      withUserStoreDepartments: // value for 'withUserStoreDepartments'
 *   },
 * });
 */
export function useRetailGetUserStoreDepartmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailGetUserStoreDepartmentsQuery,
    RetailGetUserStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailGetUserStoreDepartmentsQuery,
    RetailGetUserStoreDepartmentsQueryVariables
  >(RetailGetUserStoreDepartmentsDocument, options)
}
export function useRetailGetUserStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailGetUserStoreDepartmentsQuery,
    RetailGetUserStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailGetUserStoreDepartmentsQuery,
    RetailGetUserStoreDepartmentsQueryVariables
  >(RetailGetUserStoreDepartmentsDocument, options)
}
export type RetailGetUserStoreDepartmentsQueryHookResult = ReturnType<
  typeof useRetailGetUserStoreDepartmentsQuery
>
export type RetailGetUserStoreDepartmentsLazyQueryHookResult = ReturnType<
  typeof useRetailGetUserStoreDepartmentsLazyQuery
>
export type RetailGetUserStoreDepartmentsQueryResult = Apollo.QueryResult<
  RetailGetUserStoreDepartmentsQuery,
  RetailGetUserStoreDepartmentsQueryVariables
>
export function refetchRetailGetUserStoreDepartmentsQuery(
  variables: RetailGetUserStoreDepartmentsQueryVariables,
) {
  return { query: RetailGetUserStoreDepartmentsDocument, variables: variables }
}
export const RetailGetVendorsDocument = /*#__PURE__*/ gql`
  query Retail_GetVendors {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              vendors {
                nodes {
                  id
                  name
                }
              }
            }
            store {
              id
              vendors {
                nodes {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useRetailGetVendorsQuery__
 *
 * To run a query within a React component, call `useRetailGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailGetVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailGetVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailGetVendorsQuery,
    RetailGetVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RetailGetVendorsQuery, RetailGetVendorsQueryVariables>(
    RetailGetVendorsDocument,
    options,
  )
}
export function useRetailGetVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailGetVendorsQuery,
    RetailGetVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailGetVendorsQuery,
    RetailGetVendorsQueryVariables
  >(RetailGetVendorsDocument, options)
}
export type RetailGetVendorsQueryHookResult = ReturnType<
  typeof useRetailGetVendorsQuery
>
export type RetailGetVendorsLazyQueryHookResult = ReturnType<
  typeof useRetailGetVendorsLazyQuery
>
export type RetailGetVendorsQueryResult = Apollo.QueryResult<
  RetailGetVendorsQuery,
  RetailGetVendorsQueryVariables
>
export function refetchRetailGetVendorsQuery(
  variables?: RetailGetVendorsQueryVariables,
) {
  return { query: RetailGetVendorsDocument, variables: variables }
}
export const RetailDepartmentsCreateStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation RetailDepartments_CreateStoreDepartment(
    $departmentName: String!
    $email: String
    $storeID: ID!
  ) {
    createStoreDepartment(
      input: {
        departmentName: $departmentName
        email: $email
        storeID: $storeID
      }
    ) {
      email
      id
      name
      totalBuyerCount
      totalVendorCount
    }
  }
`
export type RetailDepartmentsCreateStoreDepartmentMutationFn =
  Apollo.MutationFunction<
    RetailDepartmentsCreateStoreDepartmentMutation,
    RetailDepartmentsCreateStoreDepartmentMutationVariables
  >

/**
 * __useRetailDepartmentsCreateStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useRetailDepartmentsCreateStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentsCreateStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailDepartmentsCreateStoreDepartmentMutation, { data, loading, error }] = useRetailDepartmentsCreateStoreDepartmentMutation({
 *   variables: {
 *      departmentName: // value for 'departmentName'
 *      email: // value for 'email'
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useRetailDepartmentsCreateStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailDepartmentsCreateStoreDepartmentMutation,
    RetailDepartmentsCreateStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailDepartmentsCreateStoreDepartmentMutation,
    RetailDepartmentsCreateStoreDepartmentMutationVariables
  >(RetailDepartmentsCreateStoreDepartmentDocument, options)
}
export type RetailDepartmentsCreateStoreDepartmentMutationHookResult =
  ReturnType<typeof useRetailDepartmentsCreateStoreDepartmentMutation>
export type RetailDepartmentsCreateStoreDepartmentMutationResult =
  Apollo.MutationResult<RetailDepartmentsCreateStoreDepartmentMutation>
export type RetailDepartmentsCreateStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    RetailDepartmentsCreateStoreDepartmentMutation,
    RetailDepartmentsCreateStoreDepartmentMutationVariables
  >
export const RetailDepartmentsGetStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query RetailDepartments_GetStoreDepartments($storeID: ID!) {
    storeByID(id: $storeID) {
      id
      name
      storeDepartments {
        nodes {
          id
          email
          name
          totalBuyerCount
          totalVendorCount
        }
      }
    }
  }
`

/**
 * __useRetailDepartmentsGetStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentsGetStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentsGetStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentsGetStoreDepartmentsQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useRetailDepartmentsGetStoreDepartmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentsGetStoreDepartmentsQuery,
    RetailDepartmentsGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentsGetStoreDepartmentsQuery,
    RetailDepartmentsGetStoreDepartmentsQueryVariables
  >(RetailDepartmentsGetStoreDepartmentsDocument, options)
}
export function useRetailDepartmentsGetStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentsGetStoreDepartmentsQuery,
    RetailDepartmentsGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentsGetStoreDepartmentsQuery,
    RetailDepartmentsGetStoreDepartmentsQueryVariables
  >(RetailDepartmentsGetStoreDepartmentsDocument, options)
}
export type RetailDepartmentsGetStoreDepartmentsQueryHookResult = ReturnType<
  typeof useRetailDepartmentsGetStoreDepartmentsQuery
>
export type RetailDepartmentsGetStoreDepartmentsLazyQueryHookResult =
  ReturnType<typeof useRetailDepartmentsGetStoreDepartmentsLazyQuery>
export type RetailDepartmentsGetStoreDepartmentsQueryResult =
  Apollo.QueryResult<
    RetailDepartmentsGetStoreDepartmentsQuery,
    RetailDepartmentsGetStoreDepartmentsQueryVariables
  >
export function refetchRetailDepartmentsGetStoreDepartmentsQuery(
  variables: RetailDepartmentsGetStoreDepartmentsQueryVariables,
) {
  return {
    query: RetailDepartmentsGetStoreDepartmentsDocument,
    variables: variables,
  }
}
export const RetailDepartmentsGetStoreDepartmentsNamesInUseDocument = /*#__PURE__*/ gql`
  query RetailDepartments_GetStoreDepartmentsNamesInUse($storeID: ID!) {
    storeByID(id: $storeID) {
      id
      storeDepartments {
        nodes {
          id
          name
        }
      }
    }
  }
`

/**
 * __useRetailDepartmentsGetStoreDepartmentsNamesInUseQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentsGetStoreDepartmentsNamesInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentsGetStoreDepartmentsNamesInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentsGetStoreDepartmentsNamesInUseQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useRetailDepartmentsGetStoreDepartmentsNamesInUseQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentsGetStoreDepartmentsNamesInUseQuery,
    RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentsGetStoreDepartmentsNamesInUseQuery,
    RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables
  >(RetailDepartmentsGetStoreDepartmentsNamesInUseDocument, options)
}
export function useRetailDepartmentsGetStoreDepartmentsNamesInUseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentsGetStoreDepartmentsNamesInUseQuery,
    RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentsGetStoreDepartmentsNamesInUseQuery,
    RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables
  >(RetailDepartmentsGetStoreDepartmentsNamesInUseDocument, options)
}
export type RetailDepartmentsGetStoreDepartmentsNamesInUseQueryHookResult =
  ReturnType<typeof useRetailDepartmentsGetStoreDepartmentsNamesInUseQuery>
export type RetailDepartmentsGetStoreDepartmentsNamesInUseLazyQueryHookResult =
  ReturnType<typeof useRetailDepartmentsGetStoreDepartmentsNamesInUseLazyQuery>
export type RetailDepartmentsGetStoreDepartmentsNamesInUseQueryResult =
  Apollo.QueryResult<
    RetailDepartmentsGetStoreDepartmentsNamesInUseQuery,
    RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables
  >
export function refetchRetailDepartmentsGetStoreDepartmentsNamesInUseQuery(
  variables: RetailDepartmentsGetStoreDepartmentsNamesInUseQueryVariables,
) {
  return {
    query: RetailDepartmentsGetStoreDepartmentsNamesInUseDocument,
    variables: variables,
  }
}
export const RetailHomeGetStatsDocument = /*#__PURE__*/ gql`
  query RetailHome_GetStats {
    me {
      user {
        id
        retailUser {
          user {
            displayName
            id
          }
          retailCompany {
            id
            banner {
              id
              stores {
                nodes {
                  ...RetailHome_StoreFields
                }
              }
              vendors {
                nodes {
                  activePromotions {
                    nodes {
                      id
                    }
                  }
                  id
                }
                totalCount
              }
            }
            store {
              vendors {
                nodes {
                  activePromotions {
                    nodes {
                      id
                    }
                  }
                  id
                }
                totalCount
              }
              ...RetailHome_StoreFields
            }
          }
        }
      }
    }
  }
  ${RetailHomeStoreFieldsFragmentDoc}
`

/**
 * __useRetailHomeGetStatsQuery__
 *
 * To run a query within a React component, call `useRetailHomeGetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailHomeGetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailHomeGetStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailHomeGetStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailHomeGetStatsQuery,
    RetailHomeGetStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailHomeGetStatsQuery,
    RetailHomeGetStatsQueryVariables
  >(RetailHomeGetStatsDocument, options)
}
export function useRetailHomeGetStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailHomeGetStatsQuery,
    RetailHomeGetStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailHomeGetStatsQuery,
    RetailHomeGetStatsQueryVariables
  >(RetailHomeGetStatsDocument, options)
}
export type RetailHomeGetStatsQueryHookResult = ReturnType<
  typeof useRetailHomeGetStatsQuery
>
export type RetailHomeGetStatsLazyQueryHookResult = ReturnType<
  typeof useRetailHomeGetStatsLazyQuery
>
export type RetailHomeGetStatsQueryResult = Apollo.QueryResult<
  RetailHomeGetStatsQuery,
  RetailHomeGetStatsQueryVariables
>
export function refetchRetailHomeGetStatsQuery(
  variables?: RetailHomeGetStatsQueryVariables,
) {
  return { query: RetailHomeGetStatsDocument, variables: variables }
}
export const RetailOrdersConfirmOrderDocument = /*#__PURE__*/ gql`
  mutation RetailOrders_ConfirmOrder($orderID: ID!, $resolvedProducts: String) {
    confirmOrder(
      input: {
        orderID: $orderID
        removeMisscans: true
        resolvedProducts: $resolvedProducts
      }
    ) {
      ...RetailOrders_OrderFields
    }
  }
  ${RetailOrdersOrderFieldsFragmentDoc}
`
export type RetailOrdersConfirmOrderMutationFn = Apollo.MutationFunction<
  RetailOrdersConfirmOrderMutation,
  RetailOrdersConfirmOrderMutationVariables
>

/**
 * __useRetailOrdersConfirmOrderMutation__
 *
 * To run a mutation, you first call `useRetailOrdersConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailOrdersConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailOrdersConfirmOrderMutation, { data, loading, error }] = useRetailOrdersConfirmOrderMutation({
 *   variables: {
 *      orderID: // value for 'orderID'
 *      resolvedProducts: // value for 'resolvedProducts'
 *   },
 * });
 */
export function useRetailOrdersConfirmOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailOrdersConfirmOrderMutation,
    RetailOrdersConfirmOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailOrdersConfirmOrderMutation,
    RetailOrdersConfirmOrderMutationVariables
  >(RetailOrdersConfirmOrderDocument, options)
}
export type RetailOrdersConfirmOrderMutationHookResult = ReturnType<
  typeof useRetailOrdersConfirmOrderMutation
>
export type RetailOrdersConfirmOrderMutationResult =
  Apollo.MutationResult<RetailOrdersConfirmOrderMutation>
export type RetailOrdersConfirmOrderMutationOptions =
  Apollo.BaseMutationOptions<
    RetailOrdersConfirmOrderMutation,
    RetailOrdersConfirmOrderMutationVariables
  >
export const RetailOrdersGetBannerOrdersDocument = /*#__PURE__*/ gql`
  query RetailOrders_GetBannerOrders(
    $cursor: ID
    $filterByBuyer: ID
    $filterByConfirmed: Boolean
    $filterBySent: Boolean
    $filterByStore: ID
    $filterByVendor: ID
    $filterByStoreDepartmentID: ID
  ) {
    me {
      user {
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              stores {
                nodes {
                  id
                }
              }
              orders(
                input: {
                  filterByBuyer: $filterByBuyer
                  filterByConfirmed: $filterByConfirmed
                  filterBySent: $filterBySent
                  filterByStore: $filterByStore
                  filterByVendor: $filterByVendor
                  filterByStoreDepartmentID: $filterByStoreDepartmentID
                  limit: 15
                  pagination: { cursor: $cursor }
                }
              ) {
                cursor
                hasMore
                nodes {
                  ...RetailOrders_OrderFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${RetailOrdersOrderFieldsFragmentDoc}
`

/**
 * __useRetailOrdersGetBannerOrdersQuery__
 *
 * To run a query within a React component, call `useRetailOrdersGetBannerOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrdersGetBannerOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrdersGetBannerOrdersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filterByBuyer: // value for 'filterByBuyer'
 *      filterByConfirmed: // value for 'filterByConfirmed'
 *      filterBySent: // value for 'filterBySent'
 *      filterByStore: // value for 'filterByStore'
 *      filterByVendor: // value for 'filterByVendor'
 *      filterByStoreDepartmentID: // value for 'filterByStoreDepartmentID'
 *   },
 * });
 */
export function useRetailOrdersGetBannerOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailOrdersGetBannerOrdersQuery,
    RetailOrdersGetBannerOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrdersGetBannerOrdersQuery,
    RetailOrdersGetBannerOrdersQueryVariables
  >(RetailOrdersGetBannerOrdersDocument, options)
}
export function useRetailOrdersGetBannerOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrdersGetBannerOrdersQuery,
    RetailOrdersGetBannerOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrdersGetBannerOrdersQuery,
    RetailOrdersGetBannerOrdersQueryVariables
  >(RetailOrdersGetBannerOrdersDocument, options)
}
export type RetailOrdersGetBannerOrdersQueryHookResult = ReturnType<
  typeof useRetailOrdersGetBannerOrdersQuery
>
export type RetailOrdersGetBannerOrdersLazyQueryHookResult = ReturnType<
  typeof useRetailOrdersGetBannerOrdersLazyQuery
>
export type RetailOrdersGetBannerOrdersQueryResult = Apollo.QueryResult<
  RetailOrdersGetBannerOrdersQuery,
  RetailOrdersGetBannerOrdersQueryVariables
>
export function refetchRetailOrdersGetBannerOrdersQuery(
  variables?: RetailOrdersGetBannerOrdersQueryVariables,
) {
  return { query: RetailOrdersGetBannerOrdersDocument, variables: variables }
}
export const RetailOrdersGetBannerStoresDocument = /*#__PURE__*/ gql`
  query RetailOrders_GetBannerStores {
    me {
      user {
        id
        userType
        retailUser {
          user {
            id
          }
          retailCompany {
            banner {
              stores {
                nodes {
                  ...RetailOrders_OrderStoreFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${RetailOrdersOrderStoreFieldsFragmentDoc}
`

/**
 * __useRetailOrdersGetBannerStoresQuery__
 *
 * To run a query within a React component, call `useRetailOrdersGetBannerStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrdersGetBannerStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrdersGetBannerStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailOrdersGetBannerStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailOrdersGetBannerStoresQuery,
    RetailOrdersGetBannerStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrdersGetBannerStoresQuery,
    RetailOrdersGetBannerStoresQueryVariables
  >(RetailOrdersGetBannerStoresDocument, options)
}
export function useRetailOrdersGetBannerStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrdersGetBannerStoresQuery,
    RetailOrdersGetBannerStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrdersGetBannerStoresQuery,
    RetailOrdersGetBannerStoresQueryVariables
  >(RetailOrdersGetBannerStoresDocument, options)
}
export type RetailOrdersGetBannerStoresQueryHookResult = ReturnType<
  typeof useRetailOrdersGetBannerStoresQuery
>
export type RetailOrdersGetBannerStoresLazyQueryHookResult = ReturnType<
  typeof useRetailOrdersGetBannerStoresLazyQuery
>
export type RetailOrdersGetBannerStoresQueryResult = Apollo.QueryResult<
  RetailOrdersGetBannerStoresQuery,
  RetailOrdersGetBannerStoresQueryVariables
>
export function refetchRetailOrdersGetBannerStoresQuery(
  variables?: RetailOrdersGetBannerStoresQueryVariables,
) {
  return { query: RetailOrdersGetBannerStoresDocument, variables: variables }
}
export const RetailOrdersAdminGetBannerStoresDocument = /*#__PURE__*/ gql`
  query RetailOrders_AdminGetBannerStores {
    allBanners {
      nodes {
        id
        name
        stores {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useRetailOrdersAdminGetBannerStoresQuery__
 *
 * To run a query within a React component, call `useRetailOrdersAdminGetBannerStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrdersAdminGetBannerStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrdersAdminGetBannerStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailOrdersAdminGetBannerStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailOrdersAdminGetBannerStoresQuery,
    RetailOrdersAdminGetBannerStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrdersAdminGetBannerStoresQuery,
    RetailOrdersAdminGetBannerStoresQueryVariables
  >(RetailOrdersAdminGetBannerStoresDocument, options)
}
export function useRetailOrdersAdminGetBannerStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrdersAdminGetBannerStoresQuery,
    RetailOrdersAdminGetBannerStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrdersAdminGetBannerStoresQuery,
    RetailOrdersAdminGetBannerStoresQueryVariables
  >(RetailOrdersAdminGetBannerStoresDocument, options)
}
export type RetailOrdersAdminGetBannerStoresQueryHookResult = ReturnType<
  typeof useRetailOrdersAdminGetBannerStoresQuery
>
export type RetailOrdersAdminGetBannerStoresLazyQueryHookResult = ReturnType<
  typeof useRetailOrdersAdminGetBannerStoresLazyQuery
>
export type RetailOrdersAdminGetBannerStoresQueryResult = Apollo.QueryResult<
  RetailOrdersAdminGetBannerStoresQuery,
  RetailOrdersAdminGetBannerStoresQueryVariables
>
export function refetchRetailOrdersAdminGetBannerStoresQuery(
  variables?: RetailOrdersAdminGetBannerStoresQueryVariables,
) {
  return {
    query: RetailOrdersAdminGetBannerStoresDocument,
    variables: variables,
  }
}
export const RetailOrdersGetVendorsDocument = /*#__PURE__*/ gql`
  query RetailOrders_GetVendors {
    me {
      user {
        id
        userType
        retailUser {
          user {
            id
          }
          retailCompany {
            banner {
              vendorAccounts {
                nodes {
                  vendor {
                    ...RetailOrders_OrderVendorFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${RetailOrdersOrderVendorFieldsFragmentDoc}
`

/**
 * __useRetailOrdersGetVendorsQuery__
 *
 * To run a query within a React component, call `useRetailOrdersGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrdersGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrdersGetVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetailOrdersGetVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailOrdersGetVendorsQuery,
    RetailOrdersGetVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrdersGetVendorsQuery,
    RetailOrdersGetVendorsQueryVariables
  >(RetailOrdersGetVendorsDocument, options)
}
export function useRetailOrdersGetVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrdersGetVendorsQuery,
    RetailOrdersGetVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrdersGetVendorsQuery,
    RetailOrdersGetVendorsQueryVariables
  >(RetailOrdersGetVendorsDocument, options)
}
export type RetailOrdersGetVendorsQueryHookResult = ReturnType<
  typeof useRetailOrdersGetVendorsQuery
>
export type RetailOrdersGetVendorsLazyQueryHookResult = ReturnType<
  typeof useRetailOrdersGetVendorsLazyQuery
>
export type RetailOrdersGetVendorsQueryResult = Apollo.QueryResult<
  RetailOrdersGetVendorsQuery,
  RetailOrdersGetVendorsQueryVariables
>
export function refetchRetailOrdersGetVendorsQuery(
  variables?: RetailOrdersGetVendorsQueryVariables,
) {
  return { query: RetailOrdersGetVendorsDocument, variables: variables }
}
export const RetailOrdersGetStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query RetailOrders_GetStoreDepartments($bannerID: ID!) {
    bannerByID(id: $bannerID) {
      stores {
        nodes {
          id
          name
          storeDepartments {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useRetailOrdersGetStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useRetailOrdersGetStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrdersGetStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrdersGetStoreDepartmentsQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *   },
 * });
 */
export function useRetailOrdersGetStoreDepartmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailOrdersGetStoreDepartmentsQuery,
    RetailOrdersGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrdersGetStoreDepartmentsQuery,
    RetailOrdersGetStoreDepartmentsQueryVariables
  >(RetailOrdersGetStoreDepartmentsDocument, options)
}
export function useRetailOrdersGetStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrdersGetStoreDepartmentsQuery,
    RetailOrdersGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrdersGetStoreDepartmentsQuery,
    RetailOrdersGetStoreDepartmentsQueryVariables
  >(RetailOrdersGetStoreDepartmentsDocument, options)
}
export type RetailOrdersGetStoreDepartmentsQueryHookResult = ReturnType<
  typeof useRetailOrdersGetStoreDepartmentsQuery
>
export type RetailOrdersGetStoreDepartmentsLazyQueryHookResult = ReturnType<
  typeof useRetailOrdersGetStoreDepartmentsLazyQuery
>
export type RetailOrdersGetStoreDepartmentsQueryResult = Apollo.QueryResult<
  RetailOrdersGetStoreDepartmentsQuery,
  RetailOrdersGetStoreDepartmentsQueryVariables
>
export function refetchRetailOrdersGetStoreDepartmentsQuery(
  variables: RetailOrdersGetStoreDepartmentsQueryVariables,
) {
  return {
    query: RetailOrdersGetStoreDepartmentsDocument,
    variables: variables,
  }
}
export const RetailVendorSearchGetProductsDocument = /*#__PURE__*/ gql`
  query RetailVendorSearch_GetProducts(
    $cursor: ID
    $search: String
    $vendorID: ID
    $storeID: ID
    $bannerID: ID
    $searchID: String
  ) {
    searchAllVendorProducts(
      input: {
        limit: 15
        paginationInput: { cursor: $cursor }
        query: $search
        vendorID: $vendorID
        storeID: $storeID
        searchID: $searchID
        authorizedVendorsOnly: true
      }
    ) {
      cursor
      hasMore
      searchID
      nodes {
        product {
          ...RetailVendorCatalog_VendorCatalogProductFields
        }
      }
    }
  }
  ${RetailVendorCatalogVendorCatalogProductFieldsFragmentDoc}
`

/**
 * __useRetailVendorSearchGetProductsQuery__
 *
 * To run a query within a React component, call `useRetailVendorSearchGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailVendorSearchGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailVendorSearchGetProductsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *      vendorID: // value for 'vendorID'
 *      storeID: // value for 'storeID'
 *      bannerID: // value for 'bannerID'
 *      searchID: // value for 'searchID'
 *   },
 * });
 */
export function useRetailVendorSearchGetProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailVendorSearchGetProductsQuery,
    RetailVendorSearchGetProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailVendorSearchGetProductsQuery,
    RetailVendorSearchGetProductsQueryVariables
  >(RetailVendorSearchGetProductsDocument, options)
}
export function useRetailVendorSearchGetProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailVendorSearchGetProductsQuery,
    RetailVendorSearchGetProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailVendorSearchGetProductsQuery,
    RetailVendorSearchGetProductsQueryVariables
  >(RetailVendorSearchGetProductsDocument, options)
}
export type RetailVendorSearchGetProductsQueryHookResult = ReturnType<
  typeof useRetailVendorSearchGetProductsQuery
>
export type RetailVendorSearchGetProductsLazyQueryHookResult = ReturnType<
  typeof useRetailVendorSearchGetProductsLazyQuery
>
export type RetailVendorSearchGetProductsQueryResult = Apollo.QueryResult<
  RetailVendorSearchGetProductsQuery,
  RetailVendorSearchGetProductsQueryVariables
>
export function refetchRetailVendorSearchGetProductsQuery(
  variables?: RetailVendorSearchGetProductsQueryVariables,
) {
  return { query: RetailVendorSearchGetProductsDocument, variables: variables }
}
export const StoreAdminSearchAuthorizedVendorsDocument = /*#__PURE__*/ gql`
  query StoreAdminSearchAuthorizedVendors(
    $bannerID: ID!
    $cursor: String
    $query: String
  ) {
    bannerByID(id: $bannerID) {
      authorizedVendors(input: { limit: 30, query: $query, cursor: $cursor }) {
        cursor
        hasMore
        nodes {
          ...RetailVendorCatalog_VendorCatalogFields
        }
      }
    }
  }
  ${RetailVendorCatalogVendorCatalogFieldsFragmentDoc}
`

/**
 * __useStoreAdminSearchAuthorizedVendorsQuery__
 *
 * To run a query within a React component, call `useStoreAdminSearchAuthorizedVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreAdminSearchAuthorizedVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreAdminSearchAuthorizedVendorsQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useStoreAdminSearchAuthorizedVendorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    StoreAdminSearchAuthorizedVendorsQuery,
    StoreAdminSearchAuthorizedVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    StoreAdminSearchAuthorizedVendorsQuery,
    StoreAdminSearchAuthorizedVendorsQueryVariables
  >(StoreAdminSearchAuthorizedVendorsDocument, options)
}
export function useStoreAdminSearchAuthorizedVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreAdminSearchAuthorizedVendorsQuery,
    StoreAdminSearchAuthorizedVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    StoreAdminSearchAuthorizedVendorsQuery,
    StoreAdminSearchAuthorizedVendorsQueryVariables
  >(StoreAdminSearchAuthorizedVendorsDocument, options)
}
export type StoreAdminSearchAuthorizedVendorsQueryHookResult = ReturnType<
  typeof useStoreAdminSearchAuthorizedVendorsQuery
>
export type StoreAdminSearchAuthorizedVendorsLazyQueryHookResult = ReturnType<
  typeof useStoreAdminSearchAuthorizedVendorsLazyQuery
>
export type StoreAdminSearchAuthorizedVendorsQueryResult = Apollo.QueryResult<
  StoreAdminSearchAuthorizedVendorsQuery,
  StoreAdminSearchAuthorizedVendorsQueryVariables
>
export function refetchStoreAdminSearchAuthorizedVendorsQuery(
  variables: StoreAdminSearchAuthorizedVendorsQueryVariables,
) {
  return {
    query: StoreAdminSearchAuthorizedVendorsDocument,
    variables: variables,
  }
}
export const RetailStoresGetBannerStoresDocument = /*#__PURE__*/ gql`
  query RetailStores_GetBannerStores($cursor: ID, $search: String) {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              imageURL
              stores(
                input: {
                  limit: 15
                  pagination: { cursor: $cursor }
                  search: $search
                }
              ) {
                cursor
                hasMore
                nodes {
                  ...RetailStores_StoreFields
                }
              }
            }
            store {
              ...RetailStores_StoreFields
            }
          }
        }
      }
    }
  }
  ${RetailStoresStoreFieldsFragmentDoc}
`

/**
 * __useRetailStoresGetBannerStoresQuery__
 *
 * To run a query within a React component, call `useRetailStoresGetBannerStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailStoresGetBannerStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailStoresGetBannerStoresQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useRetailStoresGetBannerStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetailStoresGetBannerStoresQuery,
    RetailStoresGetBannerStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailStoresGetBannerStoresQuery,
    RetailStoresGetBannerStoresQueryVariables
  >(RetailStoresGetBannerStoresDocument, options)
}
export function useRetailStoresGetBannerStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailStoresGetBannerStoresQuery,
    RetailStoresGetBannerStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailStoresGetBannerStoresQuery,
    RetailStoresGetBannerStoresQueryVariables
  >(RetailStoresGetBannerStoresDocument, options)
}
export type RetailStoresGetBannerStoresQueryHookResult = ReturnType<
  typeof useRetailStoresGetBannerStoresQuery
>
export type RetailStoresGetBannerStoresLazyQueryHookResult = ReturnType<
  typeof useRetailStoresGetBannerStoresLazyQuery
>
export type RetailStoresGetBannerStoresQueryResult = Apollo.QueryResult<
  RetailStoresGetBannerStoresQuery,
  RetailStoresGetBannerStoresQueryVariables
>
export function refetchRetailStoresGetBannerStoresQuery(
  variables?: RetailStoresGetBannerStoresQueryVariables,
) {
  return { query: RetailStoresGetBannerStoresDocument, variables: variables }
}
export const RetailStoresGetStoreByIdDocument = /*#__PURE__*/ gql`
  query RetailStores_GetStoreByID($id: ID!) {
    storeByID(id: $id) {
      ...RetailStores_StoreFields
    }
  }
  ${RetailStoresStoreFieldsFragmentDoc}
`

/**
 * __useRetailStoresGetStoreByIdQuery__
 *
 * To run a query within a React component, call `useRetailStoresGetStoreByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailStoresGetStoreByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailStoresGetStoreByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetailStoresGetStoreByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailStoresGetStoreByIdQuery,
    RetailStoresGetStoreByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailStoresGetStoreByIdQuery,
    RetailStoresGetStoreByIdQueryVariables
  >(RetailStoresGetStoreByIdDocument, options)
}
export function useRetailStoresGetStoreByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailStoresGetStoreByIdQuery,
    RetailStoresGetStoreByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailStoresGetStoreByIdQuery,
    RetailStoresGetStoreByIdQueryVariables
  >(RetailStoresGetStoreByIdDocument, options)
}
export type RetailStoresGetStoreByIdQueryHookResult = ReturnType<
  typeof useRetailStoresGetStoreByIdQuery
>
export type RetailStoresGetStoreByIdLazyQueryHookResult = ReturnType<
  typeof useRetailStoresGetStoreByIdLazyQuery
>
export type RetailStoresGetStoreByIdQueryResult = Apollo.QueryResult<
  RetailStoresGetStoreByIdQuery,
  RetailStoresGetStoreByIdQueryVariables
>
export function refetchRetailStoresGetStoreByIdQuery(
  variables: RetailStoresGetStoreByIdQueryVariables,
) {
  return { query: RetailStoresGetStoreByIdDocument, variables: variables }
}
export const RetailDepartmentEnableVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation RetailDepartment_EnableVendorStoreDepartmentAccount(
    $vendorStoreDepartmentAccountID: ID!
  ) {
    updateVendorStoreDepartmentAccountStatus(
      id: $vendorStoreDepartmentAccountID
      status: ACTIVE
    ) {
      id
      status
      vendor {
        id
        name
      }
    }
  }
`
export type RetailDepartmentEnableVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    RetailDepartmentEnableVendorStoreDepartmentAccountMutation,
    RetailDepartmentEnableVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useRetailDepartmentEnableVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useRetailDepartmentEnableVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentEnableVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailDepartmentEnableVendorStoreDepartmentAccountMutation, { data, loading, error }] = useRetailDepartmentEnableVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *   },
 * });
 */
export function useRetailDepartmentEnableVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailDepartmentEnableVendorStoreDepartmentAccountMutation,
    RetailDepartmentEnableVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailDepartmentEnableVendorStoreDepartmentAccountMutation,
    RetailDepartmentEnableVendorStoreDepartmentAccountMutationVariables
  >(RetailDepartmentEnableVendorStoreDepartmentAccountDocument, options)
}
export type RetailDepartmentEnableVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<
    typeof useRetailDepartmentEnableVendorStoreDepartmentAccountMutation
  >
export type RetailDepartmentEnableVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<RetailDepartmentEnableVendorStoreDepartmentAccountMutation>
export type RetailDepartmentEnableVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    RetailDepartmentEnableVendorStoreDepartmentAccountMutation,
    RetailDepartmentEnableVendorStoreDepartmentAccountMutationVariables
  >
export const RetailDepartmentDisableVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation RetailDepartment_DisableVendorStoreDepartmentAccount(
    $vendorStoreDepartmentAccountID: ID!
  ) {
    updateVendorStoreDepartmentAccountStatus(
      id: $vendorStoreDepartmentAccountID
      status: INACTIVE
    ) {
      id
      status
      vendor {
        id
        name
      }
    }
  }
`
export type RetailDepartmentDisableVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    RetailDepartmentDisableVendorStoreDepartmentAccountMutation,
    RetailDepartmentDisableVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useRetailDepartmentDisableVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useRetailDepartmentDisableVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentDisableVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailDepartmentDisableVendorStoreDepartmentAccountMutation, { data, loading, error }] = useRetailDepartmentDisableVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *   },
 * });
 */
export function useRetailDepartmentDisableVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailDepartmentDisableVendorStoreDepartmentAccountMutation,
    RetailDepartmentDisableVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailDepartmentDisableVendorStoreDepartmentAccountMutation,
    RetailDepartmentDisableVendorStoreDepartmentAccountMutationVariables
  >(RetailDepartmentDisableVendorStoreDepartmentAccountDocument, options)
}
export type RetailDepartmentDisableVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<
    typeof useRetailDepartmentDisableVendorStoreDepartmentAccountMutation
  >
export type RetailDepartmentDisableVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<RetailDepartmentDisableVendorStoreDepartmentAccountMutation>
export type RetailDepartmentDisableVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    RetailDepartmentDisableVendorStoreDepartmentAccountMutation,
    RetailDepartmentDisableVendorStoreDepartmentAccountMutationVariables
  >
export const RetailDepartmentCreateVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation RetailDepartment_CreateVendorStoreDepartmentAccount(
    $departmentID: String!
    $vendorID: String!
  ) {
    createVendorStoreDepartmentAccount(
      input: { storeDepartmentID: $departmentID, vendorID: $vendorID }
    ) {
      ...RetailDepartment_VendorStoreDepartmentAccountFields
    }
  }
  ${RetailDepartmentVendorStoreDepartmentAccountFieldsFragmentDoc}
`
export type RetailDepartmentCreateVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    RetailDepartmentCreateVendorStoreDepartmentAccountMutation,
    RetailDepartmentCreateVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useRetailDepartmentCreateVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useRetailDepartmentCreateVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentCreateVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailDepartmentCreateVendorStoreDepartmentAccountMutation, { data, loading, error }] = useRetailDepartmentCreateVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      departmentID: // value for 'departmentID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailDepartmentCreateVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailDepartmentCreateVendorStoreDepartmentAccountMutation,
    RetailDepartmentCreateVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailDepartmentCreateVendorStoreDepartmentAccountMutation,
    RetailDepartmentCreateVendorStoreDepartmentAccountMutationVariables
  >(RetailDepartmentCreateVendorStoreDepartmentAccountDocument, options)
}
export type RetailDepartmentCreateVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<
    typeof useRetailDepartmentCreateVendorStoreDepartmentAccountMutation
  >
export type RetailDepartmentCreateVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<RetailDepartmentCreateVendorStoreDepartmentAccountMutation>
export type RetailDepartmentCreateVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    RetailDepartmentCreateVendorStoreDepartmentAccountMutation,
    RetailDepartmentCreateVendorStoreDepartmentAccountMutationVariables
  >
export const RetailOrderGuidesAddProductToOrderGuideDocument = /*#__PURE__*/ gql`
  mutation RetailOrderGuides_AddProductToOrderGuide(
    $vendorProductIDs: [ID!]!
    $storeID: ID!
    $storeDepartmentID: ID!
    $searchID: String
  ) {
    addProductsToV2OrderGuideForStoreDepartment(
      input: {
        storeDepartmentID: $storeDepartmentID
        vendorProductIDs: $vendorProductIDs
        searchID: $searchID
      }
    ) {
      addedVendorProducts {
        ...RetailOrderGuides_VendorProductFields
      }
      orderGuide {
        id
        vendorProductIDs
        vendorStoreDepartmentAccount {
          id
          storeDepartmentID
        }
      }
    }
  }
  ${RetailOrderGuidesVendorProductFieldsFragmentDoc}
`
export type RetailOrderGuidesAddProductToOrderGuideMutationFn =
  Apollo.MutationFunction<
    RetailOrderGuidesAddProductToOrderGuideMutation,
    RetailOrderGuidesAddProductToOrderGuideMutationVariables
  >

/**
 * __useRetailOrderGuidesAddProductToOrderGuideMutation__
 *
 * To run a mutation, you first call `useRetailOrderGuidesAddProductToOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesAddProductToOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailOrderGuidesAddProductToOrderGuideMutation, { data, loading, error }] = useRetailOrderGuidesAddProductToOrderGuideMutation({
 *   variables: {
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      storeID: // value for 'storeID'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *      searchID: // value for 'searchID'
 *   },
 * });
 */
export function useRetailOrderGuidesAddProductToOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailOrderGuidesAddProductToOrderGuideMutation,
    RetailOrderGuidesAddProductToOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailOrderGuidesAddProductToOrderGuideMutation,
    RetailOrderGuidesAddProductToOrderGuideMutationVariables
  >(RetailOrderGuidesAddProductToOrderGuideDocument, options)
}
export type RetailOrderGuidesAddProductToOrderGuideMutationHookResult =
  ReturnType<typeof useRetailOrderGuidesAddProductToOrderGuideMutation>
export type RetailOrderGuidesAddProductToOrderGuideMutationResult =
  Apollo.MutationResult<RetailOrderGuidesAddProductToOrderGuideMutation>
export type RetailOrderGuidesAddProductToOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    RetailOrderGuidesAddProductToOrderGuideMutation,
    RetailOrderGuidesAddProductToOrderGuideMutationVariables
  >
export const RetailOrderGuidesRemoveProductFromOrderGuideDocument = /*#__PURE__*/ gql`
  mutation RetailOrderGuides_RemoveProductFromOrderGuide(
    $vendorProductIDs: [ID!]!
    $storeID: ID!
    $storeDepartmentID: ID!
  ) {
    removeProductsFromV2OrderGuideForStoreDepartment(
      input: {
        storeDepartmentID: $storeDepartmentID
        vendorProductIDs: $vendorProductIDs
      }
    ) {
      removedVendorProducts {
        ...RetailOrderGuides_VendorProductFields
      }
      orderGuide {
        id
        vendorProductIDs
        vendorStoreDepartmentAccount {
          id
          storeDepartmentID
        }
      }
    }
  }
  ${RetailOrderGuidesVendorProductFieldsFragmentDoc}
`
export type RetailOrderGuidesRemoveProductFromOrderGuideMutationFn =
  Apollo.MutationFunction<
    RetailOrderGuidesRemoveProductFromOrderGuideMutation,
    RetailOrderGuidesRemoveProductFromOrderGuideMutationVariables
  >

/**
 * __useRetailOrderGuidesRemoveProductFromOrderGuideMutation__
 *
 * To run a mutation, you first call `useRetailOrderGuidesRemoveProductFromOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesRemoveProductFromOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailOrderGuidesRemoveProductFromOrderGuideMutation, { data, loading, error }] = useRetailOrderGuidesRemoveProductFromOrderGuideMutation({
 *   variables: {
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      storeID: // value for 'storeID'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *   },
 * });
 */
export function useRetailOrderGuidesRemoveProductFromOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailOrderGuidesRemoveProductFromOrderGuideMutation,
    RetailOrderGuidesRemoveProductFromOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailOrderGuidesRemoveProductFromOrderGuideMutation,
    RetailOrderGuidesRemoveProductFromOrderGuideMutationVariables
  >(RetailOrderGuidesRemoveProductFromOrderGuideDocument, options)
}
export type RetailOrderGuidesRemoveProductFromOrderGuideMutationHookResult =
  ReturnType<typeof useRetailOrderGuidesRemoveProductFromOrderGuideMutation>
export type RetailOrderGuidesRemoveProductFromOrderGuideMutationResult =
  Apollo.MutationResult<RetailOrderGuidesRemoveProductFromOrderGuideMutation>
export type RetailOrderGuidesRemoveProductFromOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    RetailOrderGuidesRemoveProductFromOrderGuideMutation,
    RetailOrderGuidesRemoveProductFromOrderGuideMutationVariables
  >
export const RetailOrderGuidesCopyOrderGuideDocument = /*#__PURE__*/ gql`
  mutation RetailOrderGuides_CopyOrderGuide(
    $fromVendorStoreDepartmentAccountID: ID!
    $toStoreDepartmentIDs: [ID!]!
  ) {
    copyV2OrderGuide(
      input: {
        fromVendorStoreDepartmentAccountID: $fromVendorStoreDepartmentAccountID
        toStoreDepartmentIDs: $toStoreDepartmentIDs
      }
    ) {
      vendorStoreDepartmentAccounts {
        id
        vendorID
      }
    }
  }
`
export type RetailOrderGuidesCopyOrderGuideMutationFn = Apollo.MutationFunction<
  RetailOrderGuidesCopyOrderGuideMutation,
  RetailOrderGuidesCopyOrderGuideMutationVariables
>

/**
 * __useRetailOrderGuidesCopyOrderGuideMutation__
 *
 * To run a mutation, you first call `useRetailOrderGuidesCopyOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesCopyOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailOrderGuidesCopyOrderGuideMutation, { data, loading, error }] = useRetailOrderGuidesCopyOrderGuideMutation({
 *   variables: {
 *      fromVendorStoreDepartmentAccountID: // value for 'fromVendorStoreDepartmentAccountID'
 *      toStoreDepartmentIDs: // value for 'toStoreDepartmentIDs'
 *   },
 * });
 */
export function useRetailOrderGuidesCopyOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailOrderGuidesCopyOrderGuideMutation,
    RetailOrderGuidesCopyOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailOrderGuidesCopyOrderGuideMutation,
    RetailOrderGuidesCopyOrderGuideMutationVariables
  >(RetailOrderGuidesCopyOrderGuideDocument, options)
}
export type RetailOrderGuidesCopyOrderGuideMutationHookResult = ReturnType<
  typeof useRetailOrderGuidesCopyOrderGuideMutation
>
export type RetailOrderGuidesCopyOrderGuideMutationResult =
  Apollo.MutationResult<RetailOrderGuidesCopyOrderGuideMutation>
export type RetailOrderGuidesCopyOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    RetailOrderGuidesCopyOrderGuideMutation,
    RetailOrderGuidesCopyOrderGuideMutationVariables
  >
export const RetailOrderGuidesGetOrderGuideExportUrlDocument = /*#__PURE__*/ gql`
  mutation RetailOrderGuides_GetOrderGuideExportURL($orderGuideID: ID!) {
    exportV2OrderGuideToCSV(id: $orderGuideID) {
      url
    }
  }
`
export type RetailOrderGuidesGetOrderGuideExportUrlMutationFn =
  Apollo.MutationFunction<
    RetailOrderGuidesGetOrderGuideExportUrlMutation,
    RetailOrderGuidesGetOrderGuideExportUrlMutationVariables
  >

/**
 * __useRetailOrderGuidesGetOrderGuideExportUrlMutation__
 *
 * To run a mutation, you first call `useRetailOrderGuidesGetOrderGuideExportUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesGetOrderGuideExportUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailOrderGuidesGetOrderGuideExportUrlMutation, { data, loading, error }] = useRetailOrderGuidesGetOrderGuideExportUrlMutation({
 *   variables: {
 *      orderGuideID: // value for 'orderGuideID'
 *   },
 * });
 */
export function useRetailOrderGuidesGetOrderGuideExportUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailOrderGuidesGetOrderGuideExportUrlMutation,
    RetailOrderGuidesGetOrderGuideExportUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailOrderGuidesGetOrderGuideExportUrlMutation,
    RetailOrderGuidesGetOrderGuideExportUrlMutationVariables
  >(RetailOrderGuidesGetOrderGuideExportUrlDocument, options)
}
export type RetailOrderGuidesGetOrderGuideExportUrlMutationHookResult =
  ReturnType<typeof useRetailOrderGuidesGetOrderGuideExportUrlMutation>
export type RetailOrderGuidesGetOrderGuideExportUrlMutationResult =
  Apollo.MutationResult<RetailOrderGuidesGetOrderGuideExportUrlMutation>
export type RetailOrderGuidesGetOrderGuideExportUrlMutationOptions =
  Apollo.BaseMutationOptions<
    RetailOrderGuidesGetOrderGuideExportUrlMutation,
    RetailOrderGuidesGetOrderGuideExportUrlMutationVariables
  >
export const RetailOrderGuidesUpdateVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation RetailOrderGuides_UpdateVendorStoreDepartmentAccount(
    $accountNumber: String
    $vendorEmails: [VendorEmailInput!]
    $vendorStoreDepartmentAccountID: ID!
  ) {
    updateVendorStoreDepartmentAccount(
      id: $vendorStoreDepartmentAccountID
      input: { accountNumber: $accountNumber, vendorEmails: $vendorEmails }
    ) {
      accountNumber
      id
      vendorEmails {
        email
        type
      }
    }
  }
`
export type RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation,
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useRetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useRetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailOrderGuidesUpdateVendorStoreDepartmentAccountMutation, { data, loading, error }] = useRetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *      vendorEmails: // value for 'vendorEmails'
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *   },
 * });
 */
export function useRetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation,
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation,
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationVariables
  >(RetailOrderGuidesUpdateVendorStoreDepartmentAccountDocument, options)
}
export type RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<
    typeof useRetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation
  >
export type RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation>
export type RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutation,
    RetailOrderGuidesUpdateVendorStoreDepartmentAccountMutationVariables
  >
export const RetailDepartmentGetStoreDocument = /*#__PURE__*/ gql`
  query RetailDepartment_GetStore($storeID: ID!) {
    storeByID(id: $storeID) {
      id
      name
      storeDepartments {
        nodes {
          id
          name
        }
      }
    }
  }
`

/**
 * __useRetailDepartmentGetStoreQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentGetStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentGetStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentGetStoreQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useRetailDepartmentGetStoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentGetStoreQuery,
    RetailDepartmentGetStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentGetStoreQuery,
    RetailDepartmentGetStoreQueryVariables
  >(RetailDepartmentGetStoreDocument, options)
}
export function useRetailDepartmentGetStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentGetStoreQuery,
    RetailDepartmentGetStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentGetStoreQuery,
    RetailDepartmentGetStoreQueryVariables
  >(RetailDepartmentGetStoreDocument, options)
}
export type RetailDepartmentGetStoreQueryHookResult = ReturnType<
  typeof useRetailDepartmentGetStoreQuery
>
export type RetailDepartmentGetStoreLazyQueryHookResult = ReturnType<
  typeof useRetailDepartmentGetStoreLazyQuery
>
export type RetailDepartmentGetStoreQueryResult = Apollo.QueryResult<
  RetailDepartmentGetStoreQuery,
  RetailDepartmentGetStoreQueryVariables
>
export function refetchRetailDepartmentGetStoreQuery(
  variables: RetailDepartmentGetStoreQueryVariables,
) {
  return { query: RetailDepartmentGetStoreDocument, variables: variables }
}
export const RetailDepartmentGetDepartmentVendorsDocument = /*#__PURE__*/ gql`
  query RetailDepartment_GetDepartmentVendors(
    $cursor: String
    $departmentID: ID!
    $query: String
  ) {
    getStoreDepartmentByID(id: $departmentID) {
      id
      name
      discoverableVendors(
        input: { cursor: $cursor, limit: 50, query: $query }
      ) {
        cursor
        hasMore
        nodes {
          ...RetailDepartment_DepartmentVendorFields
        }
      }
      store {
        id
        name
      }
      vendorStoreDepartmentAccounts(
        input: { includeInactive: true, searchByVendor: $query }
      ) {
        nodes {
          ...RetailDepartment_VendorStoreDepartmentAccountFields
        }
      }
    }
  }
  ${RetailDepartmentDepartmentVendorFieldsFragmentDoc}
  ${RetailDepartmentVendorStoreDepartmentAccountFieldsFragmentDoc}
`

/**
 * __useRetailDepartmentGetDepartmentVendorsQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentGetDepartmentVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentGetDepartmentVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentGetDepartmentVendorsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      departmentID: // value for 'departmentID'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useRetailDepartmentGetDepartmentVendorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentGetDepartmentVendorsQuery,
    RetailDepartmentGetDepartmentVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentGetDepartmentVendorsQuery,
    RetailDepartmentGetDepartmentVendorsQueryVariables
  >(RetailDepartmentGetDepartmentVendorsDocument, options)
}
export function useRetailDepartmentGetDepartmentVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentGetDepartmentVendorsQuery,
    RetailDepartmentGetDepartmentVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentGetDepartmentVendorsQuery,
    RetailDepartmentGetDepartmentVendorsQueryVariables
  >(RetailDepartmentGetDepartmentVendorsDocument, options)
}
export type RetailDepartmentGetDepartmentVendorsQueryHookResult = ReturnType<
  typeof useRetailDepartmentGetDepartmentVendorsQuery
>
export type RetailDepartmentGetDepartmentVendorsLazyQueryHookResult =
  ReturnType<typeof useRetailDepartmentGetDepartmentVendorsLazyQuery>
export type RetailDepartmentGetDepartmentVendorsQueryResult =
  Apollo.QueryResult<
    RetailDepartmentGetDepartmentVendorsQuery,
    RetailDepartmentGetDepartmentVendorsQueryVariables
  >
export function refetchRetailDepartmentGetDepartmentVendorsQuery(
  variables: RetailDepartmentGetDepartmentVendorsQueryVariables,
) {
  return {
    query: RetailDepartmentGetDepartmentVendorsDocument,
    variables: variables,
  }
}
export const RetailDepartmentGetDepartmentOrdersDocument = /*#__PURE__*/ gql`
  query RetailDepartment_GetDepartmentOrders(
    $cursor: ID
    $departmentID: ID!
    $vendorID: ID
  ) {
    getStoreDepartmentByID(id: $departmentID) {
      id
      name
      store {
        id
        name
      }
      orders(
        input: {
          filterByVendor: $vendorID
          limit: 15
          pagination: { cursor: $cursor }
        }
      ) {
        cursor
        hasMore
        nodes {
          ...RetailDepartment_DepartmentOrderFields
        }
      }
    }
  }
  ${RetailDepartmentDepartmentOrderFieldsFragmentDoc}
`

/**
 * __useRetailDepartmentGetDepartmentOrdersQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentGetDepartmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentGetDepartmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentGetDepartmentOrdersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      departmentID: // value for 'departmentID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailDepartmentGetDepartmentOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentGetDepartmentOrdersQuery,
    RetailDepartmentGetDepartmentOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentGetDepartmentOrdersQuery,
    RetailDepartmentGetDepartmentOrdersQueryVariables
  >(RetailDepartmentGetDepartmentOrdersDocument, options)
}
export function useRetailDepartmentGetDepartmentOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentGetDepartmentOrdersQuery,
    RetailDepartmentGetDepartmentOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentGetDepartmentOrdersQuery,
    RetailDepartmentGetDepartmentOrdersQueryVariables
  >(RetailDepartmentGetDepartmentOrdersDocument, options)
}
export type RetailDepartmentGetDepartmentOrdersQueryHookResult = ReturnType<
  typeof useRetailDepartmentGetDepartmentOrdersQuery
>
export type RetailDepartmentGetDepartmentOrdersLazyQueryHookResult = ReturnType<
  typeof useRetailDepartmentGetDepartmentOrdersLazyQuery
>
export type RetailDepartmentGetDepartmentOrdersQueryResult = Apollo.QueryResult<
  RetailDepartmentGetDepartmentOrdersQuery,
  RetailDepartmentGetDepartmentOrdersQueryVariables
>
export function refetchRetailDepartmentGetDepartmentOrdersQuery(
  variables: RetailDepartmentGetDepartmentOrdersQueryVariables,
) {
  return {
    query: RetailDepartmentGetDepartmentOrdersDocument,
    variables: variables,
  }
}
export const RetailDepartmentGetDepartmentOrderByIdDocument = /*#__PURE__*/ gql`
  query RetailDepartment_GetDepartmentOrderByID($orderID: ID!) {
    orderByID(id: $orderID) {
      ...RetailDepartment_DepartmentOrderFields
    }
  }
  ${RetailDepartmentDepartmentOrderFieldsFragmentDoc}
`

/**
 * __useRetailDepartmentGetDepartmentOrderByIdQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentGetDepartmentOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentGetDepartmentOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentGetDepartmentOrderByIdQuery({
 *   variables: {
 *      orderID: // value for 'orderID'
 *   },
 * });
 */
export function useRetailDepartmentGetDepartmentOrderByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentGetDepartmentOrderByIdQuery,
    RetailDepartmentGetDepartmentOrderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentGetDepartmentOrderByIdQuery,
    RetailDepartmentGetDepartmentOrderByIdQueryVariables
  >(RetailDepartmentGetDepartmentOrderByIdDocument, options)
}
export function useRetailDepartmentGetDepartmentOrderByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentGetDepartmentOrderByIdQuery,
    RetailDepartmentGetDepartmentOrderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentGetDepartmentOrderByIdQuery,
    RetailDepartmentGetDepartmentOrderByIdQueryVariables
  >(RetailDepartmentGetDepartmentOrderByIdDocument, options)
}
export type RetailDepartmentGetDepartmentOrderByIdQueryHookResult = ReturnType<
  typeof useRetailDepartmentGetDepartmentOrderByIdQuery
>
export type RetailDepartmentGetDepartmentOrderByIdLazyQueryHookResult =
  ReturnType<typeof useRetailDepartmentGetDepartmentOrderByIdLazyQuery>
export type RetailDepartmentGetDepartmentOrderByIdQueryResult =
  Apollo.QueryResult<
    RetailDepartmentGetDepartmentOrderByIdQuery,
    RetailDepartmentGetDepartmentOrderByIdQueryVariables
  >
export function refetchRetailDepartmentGetDepartmentOrderByIdQuery(
  variables: RetailDepartmentGetDepartmentOrderByIdQueryVariables,
) {
  return {
    query: RetailDepartmentGetDepartmentOrderByIdDocument,
    variables: variables,
  }
}
export const RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideDocument = /*#__PURE__*/ gql`
  query RetailOrderGuides_GetVendorStoreDepartmentAccountOrderGuide(
    $cursor: ID
    $query: String
    $storeID: ID!
    $vendorStoreDepartmentAccountID: ID!
  ) {
    getVendorStoreDepartmentAccountByID(id: $vendorStoreDepartmentAccountID) {
      accountNumber
      id
      orderDeadline
      orderGuide {
        id
        readOnly
        vendorProducts(input: { cursor: $cursor, limit: 25, query: $query }) {
          cursor
          hasMore
          nodes {
            ...RetailOrderGuides_VendorProductFields
          }
        }
        vendorProductIDs
      }
      status
      vendor {
        id
        name
        orderMin
      }
      vendorEmails {
        email
        type
      }
    }
  }
  ${RetailOrderGuidesVendorProductFieldsFragmentDoc}
`

/**
 * __useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery__
 *
 * To run a query within a React component, call `useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      storeID: // value for 'storeID'
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *   },
 * });
 */
export function useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery,
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery,
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables
  >(RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideDocument, options)
}
export function useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery,
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery,
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables
  >(RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideDocument, options)
}
export type RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryHookResult =
  ReturnType<
    typeof useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery
  >
export type RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideLazyQueryHookResult =
  ReturnType<
    typeof useRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideLazyQuery
  >
export type RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryResult =
  Apollo.QueryResult<
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery,
    RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables
  >
export function refetchRetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQuery(
  variables: RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideQueryVariables,
) {
  return {
    query: RetailOrderGuidesGetVendorStoreDepartmentAccountOrderGuideDocument,
    variables: variables,
  }
}
export const RetailOrderGuidesGetStoreVendorProductsDocument = /*#__PURE__*/ gql`
  query RetailOrderGuides_GetStoreVendorProducts(
    $cursor: String
    $query: String
    $storeID: ID!
    $vendorID: ID!
  ) {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              vendorProducts(
                input: {
                  cursor: $cursor
                  limit: 25
                  query: $query
                  vendorID: $vendorID
                }
              ) {
                cursor
                hasMore
                nodes {
                  ...RetailOrderGuides_VendorProductFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${RetailOrderGuidesVendorProductFieldsFragmentDoc}
`

/**
 * __useRetailOrderGuidesGetStoreVendorProductsQuery__
 *
 * To run a query within a React component, call `useRetailOrderGuidesGetStoreVendorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailOrderGuidesGetStoreVendorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailOrderGuidesGetStoreVendorProductsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailOrderGuidesGetStoreVendorProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailOrderGuidesGetStoreVendorProductsQuery,
    RetailOrderGuidesGetStoreVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailOrderGuidesGetStoreVendorProductsQuery,
    RetailOrderGuidesGetStoreVendorProductsQueryVariables
  >(RetailOrderGuidesGetStoreVendorProductsDocument, options)
}
export function useRetailOrderGuidesGetStoreVendorProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailOrderGuidesGetStoreVendorProductsQuery,
    RetailOrderGuidesGetStoreVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailOrderGuidesGetStoreVendorProductsQuery,
    RetailOrderGuidesGetStoreVendorProductsQueryVariables
  >(RetailOrderGuidesGetStoreVendorProductsDocument, options)
}
export type RetailOrderGuidesGetStoreVendorProductsQueryHookResult = ReturnType<
  typeof useRetailOrderGuidesGetStoreVendorProductsQuery
>
export type RetailOrderGuidesGetStoreVendorProductsLazyQueryHookResult =
  ReturnType<typeof useRetailOrderGuidesGetStoreVendorProductsLazyQuery>
export type RetailOrderGuidesGetStoreVendorProductsQueryResult =
  Apollo.QueryResult<
    RetailOrderGuidesGetStoreVendorProductsQuery,
    RetailOrderGuidesGetStoreVendorProductsQueryVariables
  >
export function refetchRetailOrderGuidesGetStoreVendorProductsQuery(
  variables: RetailOrderGuidesGetStoreVendorProductsQueryVariables,
) {
  return {
    query: RetailOrderGuidesGetStoreVendorProductsDocument,
    variables: variables,
  }
}
export const RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdDocument = /*#__PURE__*/ gql`
  query RetailDepartment_GetVendorStoreDepartmentAccountByVendorID(
    $storeDepartmentID: ID!
    $vendorID: ID!
  ) {
    getVendorStoreDepartmentAccountForVendor(
      storeDepartmentID: $storeDepartmentID
      vendorID: $vendorID
    ) {
      ...RetailDepartment_VendorStoreDepartmentAccountFields
    }
  }
  ${RetailDepartmentVendorStoreDepartmentAccountFieldsFragmentDoc}
`

/**
 * __useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery__
 *
 * To run a query within a React component, call `useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery({
 *   variables: {
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery,
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery,
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables
  >(RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdDocument, options)
}
export function useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery,
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery,
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables
  >(RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdDocument, options)
}
export type RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryHookResult =
  ReturnType<
    typeof useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery
  >
export type RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdLazyQueryHookResult =
  ReturnType<
    typeof useRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdLazyQuery
  >
export type RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryResult =
  Apollo.QueryResult<
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery,
    RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables
  >
export function refetchRetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQuery(
  variables: RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdQueryVariables,
) {
  return {
    query: RetailDepartmentGetVendorStoreDepartmentAccountByVendorIdDocument,
    variables: variables,
  }
}
export const StoreAdminGetDepartmentOrdersDocument = /*#__PURE__*/ gql`
  query StoreAdmin_GetDepartmentOrders(
    $cursor: ID
    $departmentID: ID!
    $vendorID: ID
  ) {
    getStoreDepartmentByID(id: $departmentID) {
      id
      orders(
        input: {
          filterByVendor: $vendorID
          limit: 10
          pagination: { cursor: $cursor }
        }
      ) {
        cursor
        hasMore
        nodes {
          id
          totalPrice
          orderPlacedByUserEmail
          orderDateTime
          vendor {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useStoreAdminGetDepartmentOrdersQuery__
 *
 * To run a query within a React component, call `useStoreAdminGetDepartmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreAdminGetDepartmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreAdminGetDepartmentOrdersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      departmentID: // value for 'departmentID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useStoreAdminGetDepartmentOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    StoreAdminGetDepartmentOrdersQuery,
    StoreAdminGetDepartmentOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    StoreAdminGetDepartmentOrdersQuery,
    StoreAdminGetDepartmentOrdersQueryVariables
  >(StoreAdminGetDepartmentOrdersDocument, options)
}
export function useStoreAdminGetDepartmentOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreAdminGetDepartmentOrdersQuery,
    StoreAdminGetDepartmentOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    StoreAdminGetDepartmentOrdersQuery,
    StoreAdminGetDepartmentOrdersQueryVariables
  >(StoreAdminGetDepartmentOrdersDocument, options)
}
export type StoreAdminGetDepartmentOrdersQueryHookResult = ReturnType<
  typeof useStoreAdminGetDepartmentOrdersQuery
>
export type StoreAdminGetDepartmentOrdersLazyQueryHookResult = ReturnType<
  typeof useStoreAdminGetDepartmentOrdersLazyQuery
>
export type StoreAdminGetDepartmentOrdersQueryResult = Apollo.QueryResult<
  StoreAdminGetDepartmentOrdersQuery,
  StoreAdminGetDepartmentOrdersQueryVariables
>
export function refetchStoreAdminGetDepartmentOrdersQuery(
  variables: StoreAdminGetDepartmentOrdersQueryVariables,
) {
  return { query: StoreAdminGetDepartmentOrdersDocument, variables: variables }
}
export const VendorCustomersUpdateVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation VendorCustomers_UpdateVendorStoreDepartmentAccount(
    $accountNumber: String
    $dunsNumber: String
    $orderSubmissionMethod: SubmissionMethod
    $storeEmails: [StoreEmailInput!]
    $vendorStoreDepartmentAccountID: ID!
  ) {
    updateVendorStoreDepartmentAccount(
      id: $vendorStoreDepartmentAccountID
      input: {
        accountNumber: $accountNumber
        dunsNumber: $dunsNumber
        orderSubmissionMethod: $orderSubmissionMethod
        storeEmails: $storeEmails
      }
    ) {
      ...VendorCustomers_VendorStoreDepartmentAccountFields
    }
  }
  ${VendorCustomersVendorStoreDepartmentAccountFieldsFragmentDoc}
`
export type VendorCustomersUpdateVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    VendorCustomersUpdateVendorStoreDepartmentAccountMutation,
    VendorCustomersUpdateVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useVendorCustomersUpdateVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useVendorCustomersUpdateVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersUpdateVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCustomersUpdateVendorStoreDepartmentAccountMutation, { data, loading, error }] = useVendorCustomersUpdateVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *      dunsNumber: // value for 'dunsNumber'
 *      orderSubmissionMethod: // value for 'orderSubmissionMethod'
 *      storeEmails: // value for 'storeEmails'
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *   },
 * });
 */
export function useVendorCustomersUpdateVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorCustomersUpdateVendorStoreDepartmentAccountMutation,
    VendorCustomersUpdateVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorCustomersUpdateVendorStoreDepartmentAccountMutation,
    VendorCustomersUpdateVendorStoreDepartmentAccountMutationVariables
  >(VendorCustomersUpdateVendorStoreDepartmentAccountDocument, options)
}
export type VendorCustomersUpdateVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<
    typeof useVendorCustomersUpdateVendorStoreDepartmentAccountMutation
  >
export type VendorCustomersUpdateVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<VendorCustomersUpdateVendorStoreDepartmentAccountMutation>
export type VendorCustomersUpdateVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    VendorCustomersUpdateVendorStoreDepartmentAccountMutation,
    VendorCustomersUpdateVendorStoreDepartmentAccountMutationVariables
  >
export const VendorCustomersInviteStoreAccountsForVendorDocument = /*#__PURE__*/ gql`
  mutation VendorCustomers_InviteStoreAccountsForVendor(
    $vendorID: ID!
    $accounts: [InviteStoreAccountInput!]!
  ) {
    inviteStoreAccounts(input: { vendorID: $vendorID, accounts: $accounts }) {
      accounts {
        accountNumber
        store {
          id
          name
        }
        status
      }
    }
  }
`
export type VendorCustomersInviteStoreAccountsForVendorMutationFn =
  Apollo.MutationFunction<
    VendorCustomersInviteStoreAccountsForVendorMutation,
    VendorCustomersInviteStoreAccountsForVendorMutationVariables
  >

/**
 * __useVendorCustomersInviteStoreAccountsForVendorMutation__
 *
 * To run a mutation, you first call `useVendorCustomersInviteStoreAccountsForVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersInviteStoreAccountsForVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCustomersInviteStoreAccountsForVendorMutation, { data, loading, error }] = useVendorCustomersInviteStoreAccountsForVendorMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useVendorCustomersInviteStoreAccountsForVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorCustomersInviteStoreAccountsForVendorMutation,
    VendorCustomersInviteStoreAccountsForVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorCustomersInviteStoreAccountsForVendorMutation,
    VendorCustomersInviteStoreAccountsForVendorMutationVariables
  >(VendorCustomersInviteStoreAccountsForVendorDocument, options)
}
export type VendorCustomersInviteStoreAccountsForVendorMutationHookResult =
  ReturnType<typeof useVendorCustomersInviteStoreAccountsForVendorMutation>
export type VendorCustomersInviteStoreAccountsForVendorMutationResult =
  Apollo.MutationResult<VendorCustomersInviteStoreAccountsForVendorMutation>
export type VendorCustomersInviteStoreAccountsForVendorMutationOptions =
  Apollo.BaseMutationOptions<
    VendorCustomersInviteStoreAccountsForVendorMutation,
    VendorCustomersInviteStoreAccountsForVendorMutationVariables
  >
export const VendorCustomersCreateStoreAccountsForVendorDocument = /*#__PURE__*/ gql`
  mutation VendorCustomers_CreateStoreAccountsForVendor(
    $vendorID: ID!
    $accounts: [CreateStoreAccountsForVendorAccountInput!]!
    $skipDuplicateCheck: Boolean
  ) {
    createStoreAccountsForVendor(
      input: {
        vendorID: $vendorID
        accounts: $accounts
        skipDuplicateCheck: $skipDuplicateCheck
      }
    ) {
      accounts {
        vendor {
          id
          name
          validOrderSubmissionMethods
          vendorStoreDepartmentAccounts {
            nodes {
              id
              name
              orderSubmissionMethod
              accountNumber
              dunsNumber
              storeDepartmentID
              status
              accountActivityStatus
              storeEmails {
                email
              }
              store {
                id
                name
                address
                emails
              }
              lastOrder {
                id
                orderDateTime
              }
            }
            totalCount
          }
        }
      }
      errors {
        error
        message
        inputAccountIndex
        existingStoreID
      }
    }
  }
`
export type VendorCustomersCreateStoreAccountsForVendorMutationFn =
  Apollo.MutationFunction<
    VendorCustomersCreateStoreAccountsForVendorMutation,
    VendorCustomersCreateStoreAccountsForVendorMutationVariables
  >

/**
 * __useVendorCustomersCreateStoreAccountsForVendorMutation__
 *
 * To run a mutation, you first call `useVendorCustomersCreateStoreAccountsForVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersCreateStoreAccountsForVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCustomersCreateStoreAccountsForVendorMutation, { data, loading, error }] = useVendorCustomersCreateStoreAccountsForVendorMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      accounts: // value for 'accounts'
 *      skipDuplicateCheck: // value for 'skipDuplicateCheck'
 *   },
 * });
 */
export function useVendorCustomersCreateStoreAccountsForVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorCustomersCreateStoreAccountsForVendorMutation,
    VendorCustomersCreateStoreAccountsForVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorCustomersCreateStoreAccountsForVendorMutation,
    VendorCustomersCreateStoreAccountsForVendorMutationVariables
  >(VendorCustomersCreateStoreAccountsForVendorDocument, options)
}
export type VendorCustomersCreateStoreAccountsForVendorMutationHookResult =
  ReturnType<typeof useVendorCustomersCreateStoreAccountsForVendorMutation>
export type VendorCustomersCreateStoreAccountsForVendorMutationResult =
  Apollo.MutationResult<VendorCustomersCreateStoreAccountsForVendorMutation>
export type VendorCustomersCreateStoreAccountsForVendorMutationOptions =
  Apollo.BaseMutationOptions<
    VendorCustomersCreateStoreAccountsForVendorMutation,
    VendorCustomersCreateStoreAccountsForVendorMutationVariables
  >
export const VendorCustomersValidateStoreAccountsForVendorDocument = /*#__PURE__*/ gql`
  mutation VendorCustomers_ValidateStoreAccountsForVendor(
    $vendorID: ID!
    $accounts: [CreateStoreAccountsForVendorAccountInput!]!
    $validateOnly: Boolean
  ) {
    createStoreAccountsForVendor(
      input: {
        vendorID: $vendorID
        accounts: $accounts
        validateOnly: $validateOnly
      }
    ) {
      accounts {
        vendor {
          id
          name
        }
      }
      errors {
        error
        message
        inputAccountIndex
        existingStoreID
      }
    }
  }
`
export type VendorCustomersValidateStoreAccountsForVendorMutationFn =
  Apollo.MutationFunction<
    VendorCustomersValidateStoreAccountsForVendorMutation,
    VendorCustomersValidateStoreAccountsForVendorMutationVariables
  >

/**
 * __useVendorCustomersValidateStoreAccountsForVendorMutation__
 *
 * To run a mutation, you first call `useVendorCustomersValidateStoreAccountsForVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersValidateStoreAccountsForVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCustomersValidateStoreAccountsForVendorMutation, { data, loading, error }] = useVendorCustomersValidateStoreAccountsForVendorMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      accounts: // value for 'accounts'
 *      validateOnly: // value for 'validateOnly'
 *   },
 * });
 */
export function useVendorCustomersValidateStoreAccountsForVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorCustomersValidateStoreAccountsForVendorMutation,
    VendorCustomersValidateStoreAccountsForVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorCustomersValidateStoreAccountsForVendorMutation,
    VendorCustomersValidateStoreAccountsForVendorMutationVariables
  >(VendorCustomersValidateStoreAccountsForVendorDocument, options)
}
export type VendorCustomersValidateStoreAccountsForVendorMutationHookResult =
  ReturnType<typeof useVendorCustomersValidateStoreAccountsForVendorMutation>
export type VendorCustomersValidateStoreAccountsForVendorMutationResult =
  Apollo.MutationResult<VendorCustomersValidateStoreAccountsForVendorMutation>
export type VendorCustomersValidateStoreAccountsForVendorMutationOptions =
  Apollo.BaseMutationOptions<
    VendorCustomersValidateStoreAccountsForVendorMutation,
    VendorCustomersValidateStoreAccountsForVendorMutationVariables
  >
export const VendorCustomersGetVsdasForVendorDocument = /*#__PURE__*/ gql`
  query VendorCustomers_GetVsdasForVendor($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      name
      vendorStoreDepartmentAccounts {
        nodes {
          accountActivityStatus
          id
          name
          storeEmails {
            email
          }
          store {
            address
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useVendorCustomersGetVsdasForVendorQuery__
 *
 * To run a query within a React component, call `useVendorCustomersGetVsdasForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersGetVsdasForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomersGetVsdasForVendorQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorCustomersGetVsdasForVendorQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorCustomersGetVsdasForVendorQuery,
    VendorCustomersGetVsdasForVendorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorCustomersGetVsdasForVendorQuery,
    VendorCustomersGetVsdasForVendorQueryVariables
  >(VendorCustomersGetVsdasForVendorDocument, options)
}
export function useVendorCustomersGetVsdasForVendorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorCustomersGetVsdasForVendorQuery,
    VendorCustomersGetVsdasForVendorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorCustomersGetVsdasForVendorQuery,
    VendorCustomersGetVsdasForVendorQueryVariables
  >(VendorCustomersGetVsdasForVendorDocument, options)
}
export type VendorCustomersGetVsdasForVendorQueryHookResult = ReturnType<
  typeof useVendorCustomersGetVsdasForVendorQuery
>
export type VendorCustomersGetVsdasForVendorLazyQueryHookResult = ReturnType<
  typeof useVendorCustomersGetVsdasForVendorLazyQuery
>
export type VendorCustomersGetVsdasForVendorQueryResult = Apollo.QueryResult<
  VendorCustomersGetVsdasForVendorQuery,
  VendorCustomersGetVsdasForVendorQueryVariables
>
export function refetchVendorCustomersGetVsdasForVendorQuery(
  variables: VendorCustomersGetVsdasForVendorQueryVariables,
) {
  return {
    query: VendorCustomersGetVsdasForVendorDocument,
    variables: variables,
  }
}
export const VendorCustomersGetVsdaDetailDocument = /*#__PURE__*/ gql`
  query VendorCustomers_GetVsdaDetail($storeID: ID!, $vendorID: ID!) {
    getVendorStoreDepartmentAccountsForVendorAndStore(
      storeID: $storeID
      vendorID: $vendorID
    ) {
      nodes {
        ...VendorCustomers_VendorStoreDepartmentAccountFields
      }
    }
  }
  ${VendorCustomersVendorStoreDepartmentAccountFieldsFragmentDoc}
`

/**
 * __useVendorCustomersGetVsdaDetailQuery__
 *
 * To run a query within a React component, call `useVendorCustomersGetVsdaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersGetVsdaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomersGetVsdaDetailQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorCustomersGetVsdaDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorCustomersGetVsdaDetailQuery,
    VendorCustomersGetVsdaDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorCustomersGetVsdaDetailQuery,
    VendorCustomersGetVsdaDetailQueryVariables
  >(VendorCustomersGetVsdaDetailDocument, options)
}
export function useVendorCustomersGetVsdaDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorCustomersGetVsdaDetailQuery,
    VendorCustomersGetVsdaDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorCustomersGetVsdaDetailQuery,
    VendorCustomersGetVsdaDetailQueryVariables
  >(VendorCustomersGetVsdaDetailDocument, options)
}
export type VendorCustomersGetVsdaDetailQueryHookResult = ReturnType<
  typeof useVendorCustomersGetVsdaDetailQuery
>
export type VendorCustomersGetVsdaDetailLazyQueryHookResult = ReturnType<
  typeof useVendorCustomersGetVsdaDetailLazyQuery
>
export type VendorCustomersGetVsdaDetailQueryResult = Apollo.QueryResult<
  VendorCustomersGetVsdaDetailQuery,
  VendorCustomersGetVsdaDetailQueryVariables
>
export function refetchVendorCustomersGetVsdaDetailQuery(
  variables: VendorCustomersGetVsdaDetailQueryVariables,
) {
  return { query: VendorCustomersGetVsdaDetailDocument, variables: variables }
}
export const VendorCustomersGetOrderHistoryForVendorStoreAccountDocument = /*#__PURE__*/ gql`
  query VendorCustomers_GetOrderHistoryForVendorStoreAccount(
    $orderWindowStartDate: Timestamp!
    $storeID: ID!
  ) {
    me {
      user {
        id
        vendorUser {
          vendor {
            id
            storeAccountByStoreID(storeID: $storeID) {
              recentOrders(input: { after: $orderWindowStartDate }) {
                nodes {
                  id
                  orderDateTime
                  itemCount
                  totalPrice
                  subtotal
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useVendorCustomersGetOrderHistoryForVendorStoreAccountQuery__
 *
 * To run a query within a React component, call `useVendorCustomersGetOrderHistoryForVendorStoreAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersGetOrderHistoryForVendorStoreAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomersGetOrderHistoryForVendorStoreAccountQuery({
 *   variables: {
 *      orderWindowStartDate: // value for 'orderWindowStartDate'
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useVendorCustomersGetOrderHistoryForVendorStoreAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorCustomersGetOrderHistoryForVendorStoreAccountQuery,
    VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorCustomersGetOrderHistoryForVendorStoreAccountQuery,
    VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables
  >(VendorCustomersGetOrderHistoryForVendorStoreAccountDocument, options)
}
export function useVendorCustomersGetOrderHistoryForVendorStoreAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorCustomersGetOrderHistoryForVendorStoreAccountQuery,
    VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorCustomersGetOrderHistoryForVendorStoreAccountQuery,
    VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables
  >(VendorCustomersGetOrderHistoryForVendorStoreAccountDocument, options)
}
export type VendorCustomersGetOrderHistoryForVendorStoreAccountQueryHookResult =
  ReturnType<typeof useVendorCustomersGetOrderHistoryForVendorStoreAccountQuery>
export type VendorCustomersGetOrderHistoryForVendorStoreAccountLazyQueryHookResult =
  ReturnType<
    typeof useVendorCustomersGetOrderHistoryForVendorStoreAccountLazyQuery
  >
export type VendorCustomersGetOrderHistoryForVendorStoreAccountQueryResult =
  Apollo.QueryResult<
    VendorCustomersGetOrderHistoryForVendorStoreAccountQuery,
    VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables
  >
export function refetchVendorCustomersGetOrderHistoryForVendorStoreAccountQuery(
  variables: VendorCustomersGetOrderHistoryForVendorStoreAccountQueryVariables,
) {
  return {
    query: VendorCustomersGetOrderHistoryForVendorStoreAccountDocument,
    variables: variables,
  }
}
export const VendorCustomersCheckForExistingStoreDocument = /*#__PURE__*/ gql`
  query VendorCustomers_CheckForExistingStore(
    $vendorID: ID!
    $address: String
    $name: String
    $placeID: String
  ) {
    suggestStores(
      input: {
        vendorID: $vendorID
        address: $address
        name: $name
        placeID: $placeID
      }
    ) {
      nodes {
        store {
          id
          name
          emails
          placeID
          address
          vendorAccountByVendorID(vendorID: $vendorID) {
            accountNumber
          }
        }
        suggestionType
      }
    }
  }
`

/**
 * __useVendorCustomersCheckForExistingStoreQuery__
 *
 * To run a query within a React component, call `useVendorCustomersCheckForExistingStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersCheckForExistingStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomersCheckForExistingStoreQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      address: // value for 'address'
 *      name: // value for 'name'
 *      placeID: // value for 'placeID'
 *   },
 * });
 */
export function useVendorCustomersCheckForExistingStoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorCustomersCheckForExistingStoreQuery,
    VendorCustomersCheckForExistingStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorCustomersCheckForExistingStoreQuery,
    VendorCustomersCheckForExistingStoreQueryVariables
  >(VendorCustomersCheckForExistingStoreDocument, options)
}
export function useVendorCustomersCheckForExistingStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorCustomersCheckForExistingStoreQuery,
    VendorCustomersCheckForExistingStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorCustomersCheckForExistingStoreQuery,
    VendorCustomersCheckForExistingStoreQueryVariables
  >(VendorCustomersCheckForExistingStoreDocument, options)
}
export type VendorCustomersCheckForExistingStoreQueryHookResult = ReturnType<
  typeof useVendorCustomersCheckForExistingStoreQuery
>
export type VendorCustomersCheckForExistingStoreLazyQueryHookResult =
  ReturnType<typeof useVendorCustomersCheckForExistingStoreLazyQuery>
export type VendorCustomersCheckForExistingStoreQueryResult =
  Apollo.QueryResult<
    VendorCustomersCheckForExistingStoreQuery,
    VendorCustomersCheckForExistingStoreQueryVariables
  >
export function refetchVendorCustomersCheckForExistingStoreQuery(
  variables: VendorCustomersCheckForExistingStoreQueryVariables,
) {
  return {
    query: VendorCustomersCheckForExistingStoreDocument,
    variables: variables,
  }
}
export const VendorCustomersBulkCheckForExistingStoreDocument = /*#__PURE__*/ gql`
  query VendorCustomers_BulkCheckForExistingStore(
    $vendorID: ID!
    $stores: [BulkSuggestStoresInputStore!]!
  ) {
    bulkSuggestStores(input: { vendorID: $vendorID, stores: $stores }) {
      suggestions {
        nodes {
          store {
            id
            name
            emails
            placeID
            address
            vendorAccountByVendorID(vendorID: $vendorID) {
              accountNumber
            }
          }
          suggestionType
        }
      }
    }
  }
`

/**
 * __useVendorCustomersBulkCheckForExistingStoreQuery__
 *
 * To run a query within a React component, call `useVendorCustomersBulkCheckForExistingStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorCustomersBulkCheckForExistingStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorCustomersBulkCheckForExistingStoreQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      stores: // value for 'stores'
 *   },
 * });
 */
export function useVendorCustomersBulkCheckForExistingStoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorCustomersBulkCheckForExistingStoreQuery,
    VendorCustomersBulkCheckForExistingStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorCustomersBulkCheckForExistingStoreQuery,
    VendorCustomersBulkCheckForExistingStoreQueryVariables
  >(VendorCustomersBulkCheckForExistingStoreDocument, options)
}
export function useVendorCustomersBulkCheckForExistingStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorCustomersBulkCheckForExistingStoreQuery,
    VendorCustomersBulkCheckForExistingStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorCustomersBulkCheckForExistingStoreQuery,
    VendorCustomersBulkCheckForExistingStoreQueryVariables
  >(VendorCustomersBulkCheckForExistingStoreDocument, options)
}
export type VendorCustomersBulkCheckForExistingStoreQueryHookResult =
  ReturnType<typeof useVendorCustomersBulkCheckForExistingStoreQuery>
export type VendorCustomersBulkCheckForExistingStoreLazyQueryHookResult =
  ReturnType<typeof useVendorCustomersBulkCheckForExistingStoreLazyQuery>
export type VendorCustomersBulkCheckForExistingStoreQueryResult =
  Apollo.QueryResult<
    VendorCustomersBulkCheckForExistingStoreQuery,
    VendorCustomersBulkCheckForExistingStoreQueryVariables
  >
export function refetchVendorCustomersBulkCheckForExistingStoreQuery(
  variables: VendorCustomersBulkCheckForExistingStoreQueryVariables,
) {
  return {
    query: VendorCustomersBulkCheckForExistingStoreDocument,
    variables: variables,
  }
}
export const VendorHomeGetStatsDocument = /*#__PURE__*/ gql`
  query VendorHome_GetStats($sinceDate: Timestamp!) {
    me {
      user {
        id
        displayName
        vendorUser {
          vendor {
            id
            name
            description
            email
            imgURL
            status
            totalProductCount
            lastVendorProductUpdate
            ordersSinceDate(input: { since: $sinceDate }) {
              totalCount
              nodes {
                totalPrice
              }
            }
            retailUserCount
            storeAccounts {
              totalCount
            }
          }
        }
      }
    }
  }
`

/**
 * __useVendorHomeGetStatsQuery__
 *
 * To run a query within a React component, call `useVendorHomeGetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorHomeGetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorHomeGetStatsQuery({
 *   variables: {
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useVendorHomeGetStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorHomeGetStatsQuery,
    VendorHomeGetStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorHomeGetStatsQuery,
    VendorHomeGetStatsQueryVariables
  >(VendorHomeGetStatsDocument, options)
}
export function useVendorHomeGetStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorHomeGetStatsQuery,
    VendorHomeGetStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorHomeGetStatsQuery,
    VendorHomeGetStatsQueryVariables
  >(VendorHomeGetStatsDocument, options)
}
export type VendorHomeGetStatsQueryHookResult = ReturnType<
  typeof useVendorHomeGetStatsQuery
>
export type VendorHomeGetStatsLazyQueryHookResult = ReturnType<
  typeof useVendorHomeGetStatsLazyQuery
>
export type VendorHomeGetStatsQueryResult = Apollo.QueryResult<
  VendorHomeGetStatsQuery,
  VendorHomeGetStatsQueryVariables
>
export function refetchVendorHomeGetStatsQuery(
  variables: VendorHomeGetStatsQueryVariables,
) {
  return { query: VendorHomeGetStatsDocument, variables: variables }
}
export const VendorOrdersConfirmOrderDocument = /*#__PURE__*/ gql`
  mutation VendorOrders_ConfirmOrder($orderID: ID!, $resolvedProducts: String) {
    confirmOrder(
      input: {
        orderID: $orderID
        removeMisscans: true
        resolvedProducts: $resolvedProducts
      }
    ) {
      ...VendorOrders_OrderFields
    }
  }
  ${VendorOrdersOrderFieldsFragmentDoc}
`
export type VendorOrdersConfirmOrderMutationFn = Apollo.MutationFunction<
  VendorOrdersConfirmOrderMutation,
  VendorOrdersConfirmOrderMutationVariables
>

/**
 * __useVendorOrdersConfirmOrderMutation__
 *
 * To run a mutation, you first call `useVendorOrdersConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorOrdersConfirmOrderMutation, { data, loading, error }] = useVendorOrdersConfirmOrderMutation({
 *   variables: {
 *      orderID: // value for 'orderID'
 *      resolvedProducts: // value for 'resolvedProducts'
 *   },
 * });
 */
export function useVendorOrdersConfirmOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorOrdersConfirmOrderMutation,
    VendorOrdersConfirmOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorOrdersConfirmOrderMutation,
    VendorOrdersConfirmOrderMutationVariables
  >(VendorOrdersConfirmOrderDocument, options)
}
export type VendorOrdersConfirmOrderMutationHookResult = ReturnType<
  typeof useVendorOrdersConfirmOrderMutation
>
export type VendorOrdersConfirmOrderMutationResult =
  Apollo.MutationResult<VendorOrdersConfirmOrderMutation>
export type VendorOrdersConfirmOrderMutationOptions =
  Apollo.BaseMutationOptions<
    VendorOrdersConfirmOrderMutation,
    VendorOrdersConfirmOrderMutationVariables
  >
export const VendorOrdersResubmitOrderDocument = /*#__PURE__*/ gql`
  mutation VendorOrders_ResubmitOrder($orderID: ID!) {
    submitOrder(orderID: $orderID) {
      ...VendorOrders_OrderFields
    }
  }
  ${VendorOrdersOrderFieldsFragmentDoc}
`
export type VendorOrdersResubmitOrderMutationFn = Apollo.MutationFunction<
  VendorOrdersResubmitOrderMutation,
  VendorOrdersResubmitOrderMutationVariables
>

/**
 * __useVendorOrdersResubmitOrderMutation__
 *
 * To run a mutation, you first call `useVendorOrdersResubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersResubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorOrdersResubmitOrderMutation, { data, loading, error }] = useVendorOrdersResubmitOrderMutation({
 *   variables: {
 *      orderID: // value for 'orderID'
 *   },
 * });
 */
export function useVendorOrdersResubmitOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorOrdersResubmitOrderMutation,
    VendorOrdersResubmitOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorOrdersResubmitOrderMutation,
    VendorOrdersResubmitOrderMutationVariables
  >(VendorOrdersResubmitOrderDocument, options)
}
export type VendorOrdersResubmitOrderMutationHookResult = ReturnType<
  typeof useVendorOrdersResubmitOrderMutation
>
export type VendorOrdersResubmitOrderMutationResult =
  Apollo.MutationResult<VendorOrdersResubmitOrderMutation>
export type VendorOrdersResubmitOrderMutationOptions =
  Apollo.BaseMutationOptions<
    VendorOrdersResubmitOrderMutation,
    VendorOrdersResubmitOrderMutationVariables
  >
export const VendorOrdersUpdateVendorStoreAccountNumberDocument = /*#__PURE__*/ gql`
  mutation VendorOrders_UpdateVendorStoreAccountNumber(
    $storeID: String!
    $vendorID: String!
    $accountNumber: String
  ) {
    updateVendorStoreAccount(
      input: {
        storeID: $storeID
        vendorID: $vendorID
        accountNumber: $accountNumber
      }
    ) {
      accountNumber
    }
  }
`
export type VendorOrdersUpdateVendorStoreAccountNumberMutationFn =
  Apollo.MutationFunction<
    VendorOrdersUpdateVendorStoreAccountNumberMutation,
    VendorOrdersUpdateVendorStoreAccountNumberMutationVariables
  >

/**
 * __useVendorOrdersUpdateVendorStoreAccountNumberMutation__
 *
 * To run a mutation, you first call `useVendorOrdersUpdateVendorStoreAccountNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersUpdateVendorStoreAccountNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorOrdersUpdateVendorStoreAccountNumberMutation, { data, loading, error }] = useVendorOrdersUpdateVendorStoreAccountNumberMutation({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useVendorOrdersUpdateVendorStoreAccountNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorOrdersUpdateVendorStoreAccountNumberMutation,
    VendorOrdersUpdateVendorStoreAccountNumberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorOrdersUpdateVendorStoreAccountNumberMutation,
    VendorOrdersUpdateVendorStoreAccountNumberMutationVariables
  >(VendorOrdersUpdateVendorStoreAccountNumberDocument, options)
}
export type VendorOrdersUpdateVendorStoreAccountNumberMutationHookResult =
  ReturnType<typeof useVendorOrdersUpdateVendorStoreAccountNumberMutation>
export type VendorOrdersUpdateVendorStoreAccountNumberMutationResult =
  Apollo.MutationResult<VendorOrdersUpdateVendorStoreAccountNumberMutation>
export type VendorOrdersUpdateVendorStoreAccountNumberMutationOptions =
  Apollo.BaseMutationOptions<
    VendorOrdersUpdateVendorStoreAccountNumberMutation,
    VendorOrdersUpdateVendorStoreAccountNumberMutationVariables
  >
export const VendorOrdersGetOrdersDocument = /*#__PURE__*/ gql`
  query VendorOrders_GetOrders(
    $cursor: ID
    $filterByActionRequired: Boolean
    $filterByConfirmed: Boolean
    $filterByReceived: Boolean
    $filterByStore: ID
    $vendorID: ID!
  ) {
    vendorOrders(
      input: {
        filterByActionRequired: $filterByActionRequired
        filterByConfirmed: $filterByConfirmed
        filterByReceived: $filterByReceived
        filterByStore: $filterByStore
        limit: 15
        pagination: { cursor: $cursor }
        vendorID: $vendorID
      }
    ) {
      cursor
      hasMore
      nodes {
        id
        orderDateTime
        storeName
        totalPrice
        purchaseOrderNum
        orderConfirmed
        accountNumber
        hasMisscans
      }
    }
  }
`

/**
 * __useVendorOrdersGetOrdersQuery__
 *
 * To run a query within a React component, call `useVendorOrdersGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrdersGetOrdersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filterByActionRequired: // value for 'filterByActionRequired'
 *      filterByConfirmed: // value for 'filterByConfirmed'
 *      filterByReceived: // value for 'filterByReceived'
 *      filterByStore: // value for 'filterByStore'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorOrdersGetOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorOrdersGetOrdersQuery,
    VendorOrdersGetOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorOrdersGetOrdersQuery,
    VendorOrdersGetOrdersQueryVariables
  >(VendorOrdersGetOrdersDocument, options)
}
export function useVendorOrdersGetOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorOrdersGetOrdersQuery,
    VendorOrdersGetOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorOrdersGetOrdersQuery,
    VendorOrdersGetOrdersQueryVariables
  >(VendorOrdersGetOrdersDocument, options)
}
export type VendorOrdersGetOrdersQueryHookResult = ReturnType<
  typeof useVendorOrdersGetOrdersQuery
>
export type VendorOrdersGetOrdersLazyQueryHookResult = ReturnType<
  typeof useVendorOrdersGetOrdersLazyQuery
>
export type VendorOrdersGetOrdersQueryResult = Apollo.QueryResult<
  VendorOrdersGetOrdersQuery,
  VendorOrdersGetOrdersQueryVariables
>
export function refetchVendorOrdersGetOrdersQuery(
  variables: VendorOrdersGetOrdersQueryVariables,
) {
  return { query: VendorOrdersGetOrdersDocument, variables: variables }
}
export const VendorOrdersGetOrderByIdDocument = /*#__PURE__*/ gql`
  query VendorOrders_GetOrderByID($orderID: ID!) {
    orderByID(id: $orderID) {
      ...VendorOrders_OrderFields
    }
  }
  ${VendorOrdersOrderFieldsFragmentDoc}
`

/**
 * __useVendorOrdersGetOrderByIdQuery__
 *
 * To run a query within a React component, call `useVendorOrdersGetOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersGetOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrdersGetOrderByIdQuery({
 *   variables: {
 *      orderID: // value for 'orderID'
 *   },
 * });
 */
export function useVendorOrdersGetOrderByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorOrdersGetOrderByIdQuery,
    VendorOrdersGetOrderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorOrdersGetOrderByIdQuery,
    VendorOrdersGetOrderByIdQueryVariables
  >(VendorOrdersGetOrderByIdDocument, options)
}
export function useVendorOrdersGetOrderByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorOrdersGetOrderByIdQuery,
    VendorOrdersGetOrderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorOrdersGetOrderByIdQuery,
    VendorOrdersGetOrderByIdQueryVariables
  >(VendorOrdersGetOrderByIdDocument, options)
}
export type VendorOrdersGetOrderByIdQueryHookResult = ReturnType<
  typeof useVendorOrdersGetOrderByIdQuery
>
export type VendorOrdersGetOrderByIdLazyQueryHookResult = ReturnType<
  typeof useVendorOrdersGetOrderByIdLazyQuery
>
export type VendorOrdersGetOrderByIdQueryResult = Apollo.QueryResult<
  VendorOrdersGetOrderByIdQuery,
  VendorOrdersGetOrderByIdQueryVariables
>
export function refetchVendorOrdersGetOrderByIdQuery(
  variables: VendorOrdersGetOrderByIdQueryVariables,
) {
  return { query: VendorOrdersGetOrderByIdDocument, variables: variables }
}
export const VendorOrdersGetProductSuggestionsDocument = /*#__PURE__*/ gql`
  query VendorOrders_GetProductSuggestions($cursor: ID, $search: String) {
    me {
      user {
        id
        userType
        vendorUser {
          vendor {
            id
            vendorProducts(
              input: {
                limit: 5
                pagination: { cursor: $cursor }
                search: $search
                sortBy: { field: ITEM_CODE }
              }
            ) {
              cursor
              hasMore
              nodes {
                ...VendorOrders_ProductFields
              }
            }
          }
        }
      }
    }
  }
  ${VendorOrdersProductFieldsFragmentDoc}
`

/**
 * __useVendorOrdersGetProductSuggestionsQuery__
 *
 * To run a query within a React component, call `useVendorOrdersGetProductSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersGetProductSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrdersGetProductSuggestionsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useVendorOrdersGetProductSuggestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VendorOrdersGetProductSuggestionsQuery,
    VendorOrdersGetProductSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorOrdersGetProductSuggestionsQuery,
    VendorOrdersGetProductSuggestionsQueryVariables
  >(VendorOrdersGetProductSuggestionsDocument, options)
}
export function useVendorOrdersGetProductSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorOrdersGetProductSuggestionsQuery,
    VendorOrdersGetProductSuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorOrdersGetProductSuggestionsQuery,
    VendorOrdersGetProductSuggestionsQueryVariables
  >(VendorOrdersGetProductSuggestionsDocument, options)
}
export type VendorOrdersGetProductSuggestionsQueryHookResult = ReturnType<
  typeof useVendorOrdersGetProductSuggestionsQuery
>
export type VendorOrdersGetProductSuggestionsLazyQueryHookResult = ReturnType<
  typeof useVendorOrdersGetProductSuggestionsLazyQuery
>
export type VendorOrdersGetProductSuggestionsQueryResult = Apollo.QueryResult<
  VendorOrdersGetProductSuggestionsQuery,
  VendorOrdersGetProductSuggestionsQueryVariables
>
export function refetchVendorOrdersGetProductSuggestionsQuery(
  variables?: VendorOrdersGetProductSuggestionsQueryVariables,
) {
  return {
    query: VendorOrdersGetProductSuggestionsDocument,
    variables: variables,
  }
}
export const VendorOrdersGetStoresDocument = /*#__PURE__*/ gql`
  query VendorOrders_GetStores(
    $vendorID: ID!
    $search: String
    $cursor: String
    $limit: Int
  ) {
    vendorByID(id: $vendorID) {
      id
      stores(input: { query: $search, cursor: $cursor, limit: $limit }) {
        nodes {
          ...VendorOrders_StoreFields
        }
        totalCount
        cursor
      }
    }
  }
  ${VendorOrdersStoreFieldsFragmentDoc}
`

/**
 * __useVendorOrdersGetStoresQuery__
 *
 * To run a query within a React component, call `useVendorOrdersGetStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersGetStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrdersGetStoresQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVendorOrdersGetStoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorOrdersGetStoresQuery,
    VendorOrdersGetStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorOrdersGetStoresQuery,
    VendorOrdersGetStoresQueryVariables
  >(VendorOrdersGetStoresDocument, options)
}
export function useVendorOrdersGetStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorOrdersGetStoresQuery,
    VendorOrdersGetStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorOrdersGetStoresQuery,
    VendorOrdersGetStoresQueryVariables
  >(VendorOrdersGetStoresDocument, options)
}
export type VendorOrdersGetStoresQueryHookResult = ReturnType<
  typeof useVendorOrdersGetStoresQuery
>
export type VendorOrdersGetStoresLazyQueryHookResult = ReturnType<
  typeof useVendorOrdersGetStoresLazyQuery
>
export type VendorOrdersGetStoresQueryResult = Apollo.QueryResult<
  VendorOrdersGetStoresQuery,
  VendorOrdersGetStoresQueryVariables
>
export function refetchVendorOrdersGetStoresQuery(
  variables: VendorOrdersGetStoresQueryVariables,
) {
  return { query: VendorOrdersGetStoresDocument, variables: variables }
}
export const VendorOrdersGetStoreAccountDocument = /*#__PURE__*/ gql`
  query VendorOrders_GetStoreAccount($storeID: ID!) {
    me {
      user {
        id
        vendorUser {
          vendor {
            id
            storeAccountByStoreID(storeID: $storeID) {
              accountNumber
            }
          }
        }
      }
    }
  }
`

/**
 * __useVendorOrdersGetStoreAccountQuery__
 *
 * To run a query within a React component, call `useVendorOrdersGetStoreAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorOrdersGetStoreAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorOrdersGetStoreAccountQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useVendorOrdersGetStoreAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorOrdersGetStoreAccountQuery,
    VendorOrdersGetStoreAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorOrdersGetStoreAccountQuery,
    VendorOrdersGetStoreAccountQueryVariables
  >(VendorOrdersGetStoreAccountDocument, options)
}
export function useVendorOrdersGetStoreAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorOrdersGetStoreAccountQuery,
    VendorOrdersGetStoreAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorOrdersGetStoreAccountQuery,
    VendorOrdersGetStoreAccountQueryVariables
  >(VendorOrdersGetStoreAccountDocument, options)
}
export type VendorOrdersGetStoreAccountQueryHookResult = ReturnType<
  typeof useVendorOrdersGetStoreAccountQuery
>
export type VendorOrdersGetStoreAccountLazyQueryHookResult = ReturnType<
  typeof useVendorOrdersGetStoreAccountLazyQuery
>
export type VendorOrdersGetStoreAccountQueryResult = Apollo.QueryResult<
  VendorOrdersGetStoreAccountQuery,
  VendorOrdersGetStoreAccountQueryVariables
>
export function refetchVendorOrdersGetStoreAccountQuery(
  variables: VendorOrdersGetStoreAccountQueryVariables,
) {
  return { query: VendorOrdersGetStoreAccountDocument, variables: variables }
}
export const VendorProfileUpdateProfileDocument = /*#__PURE__*/ gql`
  mutation VendorProfile_UpdateProfile($input: UpdateVendorInput!) {
    updateVendor(input: $input) {
      ...VendorProfile_ProfileFields
    }
  }
  ${VendorProfileProfileFieldsFragmentDoc}
`
export type VendorProfileUpdateProfileMutationFn = Apollo.MutationFunction<
  VendorProfileUpdateProfileMutation,
  VendorProfileUpdateProfileMutationVariables
>

/**
 * __useVendorProfileUpdateProfileMutation__
 *
 * To run a mutation, you first call `useVendorProfileUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorProfileUpdateProfileMutation, { data, loading, error }] = useVendorProfileUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorProfileUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorProfileUpdateProfileMutation,
    VendorProfileUpdateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorProfileUpdateProfileMutation,
    VendorProfileUpdateProfileMutationVariables
  >(VendorProfileUpdateProfileDocument, options)
}
export type VendorProfileUpdateProfileMutationHookResult = ReturnType<
  typeof useVendorProfileUpdateProfileMutation
>
export type VendorProfileUpdateProfileMutationResult =
  Apollo.MutationResult<VendorProfileUpdateProfileMutation>
export type VendorProfileUpdateProfileMutationOptions =
  Apollo.BaseMutationOptions<
    VendorProfileUpdateProfileMutation,
    VendorProfileUpdateProfileMutationVariables
  >
export const VendorProfileUpdateOrderDeadlineInfoDocument = /*#__PURE__*/ gql`
  mutation VendorProfile_UpdateOrderDeadlineInfo(
    $id: ID!
    $orderDeadlineInfo: VendorOrderDeadlineInfoInput
  ) {
    updateVendor(input: { id: $id, orderDeadlineInfo: $orderDeadlineInfo }) {
      orderDeadlineInfo {
        timezone
        orderDeadlines {
          deadlineDay
          deadlineTime
          deliveryDay
        }
      }
    }
  }
`
export type VendorProfileUpdateOrderDeadlineInfoMutationFn =
  Apollo.MutationFunction<
    VendorProfileUpdateOrderDeadlineInfoMutation,
    VendorProfileUpdateOrderDeadlineInfoMutationVariables
  >

/**
 * __useVendorProfileUpdateOrderDeadlineInfoMutation__
 *
 * To run a mutation, you first call `useVendorProfileUpdateOrderDeadlineInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileUpdateOrderDeadlineInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorProfileUpdateOrderDeadlineInfoMutation, { data, loading, error }] = useVendorProfileUpdateOrderDeadlineInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderDeadlineInfo: // value for 'orderDeadlineInfo'
 *   },
 * });
 */
export function useVendorProfileUpdateOrderDeadlineInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorProfileUpdateOrderDeadlineInfoMutation,
    VendorProfileUpdateOrderDeadlineInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorProfileUpdateOrderDeadlineInfoMutation,
    VendorProfileUpdateOrderDeadlineInfoMutationVariables
  >(VendorProfileUpdateOrderDeadlineInfoDocument, options)
}
export type VendorProfileUpdateOrderDeadlineInfoMutationHookResult = ReturnType<
  typeof useVendorProfileUpdateOrderDeadlineInfoMutation
>
export type VendorProfileUpdateOrderDeadlineInfoMutationResult =
  Apollo.MutationResult<VendorProfileUpdateOrderDeadlineInfoMutation>
export type VendorProfileUpdateOrderDeadlineInfoMutationOptions =
  Apollo.BaseMutationOptions<
    VendorProfileUpdateOrderDeadlineInfoMutation,
    VendorProfileUpdateOrderDeadlineInfoMutationVariables
  >
export const VendorProfileUpdateVsdaOrderDeadlineInfoForVendorDocument = /*#__PURE__*/ gql`
  mutation VendorProfile_UpdateVSDAOrderDeadlineInfoForVendor(
    $vendorID: ID!
    $storeDepartmentID: ID!
    $orderDeadlineInfo: VendorOrderDeadlineInfoInput
  ) {
    updateVendorStoreDepartmentAccountForVendor(
      vendorID: $vendorID
      storeDepartmentID: $storeDepartmentID
      input: { orderDeadlineInfo: $orderDeadlineInfo }
    ) {
      orderDeadlineInfo {
        timezone
        orderDeadlines {
          deadlineDay
          deadlineTime
          deliveryDay
        }
      }
    }
  }
`
export type VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationFn =
  Apollo.MutationFunction<
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation,
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationVariables
  >

/**
 * __useVendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation__
 *
 * To run a mutation, you first call `useVendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation, { data, loading, error }] = useVendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *      orderDeadlineInfo: // value for 'orderDeadlineInfo'
 *   },
 * });
 */
export function useVendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation,
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation,
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationVariables
  >(VendorProfileUpdateVsdaOrderDeadlineInfoForVendorDocument, options)
}
export type VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationHookResult =
  ReturnType<
    typeof useVendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation
  >
export type VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationResult =
  Apollo.MutationResult<VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation>
export type VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationOptions =
  Apollo.BaseMutationOptions<
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutation,
    VendorProfileUpdateVsdaOrderDeadlineInfoForVendorMutationVariables
  >
export const VendorProfileGetProfileDocument = /*#__PURE__*/ gql`
  query VendorProfile_GetProfile {
    me {
      user {
        id
        vendorUser {
          vendor {
            ...VendorProfile_ProfileFields
          }
        }
      }
    }
  }
  ${VendorProfileProfileFieldsFragmentDoc}
`

/**
 * __useVendorProfileGetProfileQuery__
 *
 * To run a query within a React component, call `useVendorProfileGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorProfileGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorProfileGetProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VendorProfileGetProfileQuery,
    VendorProfileGetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorProfileGetProfileQuery,
    VendorProfileGetProfileQueryVariables
  >(VendorProfileGetProfileDocument, options)
}
export function useVendorProfileGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorProfileGetProfileQuery,
    VendorProfileGetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorProfileGetProfileQuery,
    VendorProfileGetProfileQueryVariables
  >(VendorProfileGetProfileDocument, options)
}
export type VendorProfileGetProfileQueryHookResult = ReturnType<
  typeof useVendorProfileGetProfileQuery
>
export type VendorProfileGetProfileLazyQueryHookResult = ReturnType<
  typeof useVendorProfileGetProfileLazyQuery
>
export type VendorProfileGetProfileQueryResult = Apollo.QueryResult<
  VendorProfileGetProfileQuery,
  VendorProfileGetProfileQueryVariables
>
export function refetchVendorProfileGetProfileQuery(
  variables?: VendorProfileGetProfileQueryVariables,
) {
  return { query: VendorProfileGetProfileDocument, variables: variables }
}
export const VendorProfileGetPaginatedStoresDocument = /*#__PURE__*/ gql`
  query VendorProfile_GetPaginatedStores(
    $search: String!
    $cursor: ID
    $limit: Int
  ) {
    searchStores(
      input: { limit: $limit, search: $search, pagination: { cursor: $cursor } }
    ) {
      nodes {
        id
        name
      }
      totalCount
      cursor
      hasMore
    }
  }
`

/**
 * __useVendorProfileGetPaginatedStoresQuery__
 *
 * To run a query within a React component, call `useVendorProfileGetPaginatedStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileGetPaginatedStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorProfileGetPaginatedStoresQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVendorProfileGetPaginatedStoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorProfileGetPaginatedStoresQuery,
    VendorProfileGetPaginatedStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorProfileGetPaginatedStoresQuery,
    VendorProfileGetPaginatedStoresQueryVariables
  >(VendorProfileGetPaginatedStoresDocument, options)
}
export function useVendorProfileGetPaginatedStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorProfileGetPaginatedStoresQuery,
    VendorProfileGetPaginatedStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorProfileGetPaginatedStoresQuery,
    VendorProfileGetPaginatedStoresQueryVariables
  >(VendorProfileGetPaginatedStoresDocument, options)
}
export type VendorProfileGetPaginatedStoresQueryHookResult = ReturnType<
  typeof useVendorProfileGetPaginatedStoresQuery
>
export type VendorProfileGetPaginatedStoresLazyQueryHookResult = ReturnType<
  typeof useVendorProfileGetPaginatedStoresLazyQuery
>
export type VendorProfileGetPaginatedStoresQueryResult = Apollo.QueryResult<
  VendorProfileGetPaginatedStoresQuery,
  VendorProfileGetPaginatedStoresQueryVariables
>
export function refetchVendorProfileGetPaginatedStoresQuery(
  variables: VendorProfileGetPaginatedStoresQueryVariables,
) {
  return {
    query: VendorProfileGetPaginatedStoresDocument,
    variables: variables,
  }
}
export const VendorProfileGetOrderDeadlineInfoDocument = /*#__PURE__*/ gql`
  query VendorProfile_GetOrderDeadlineInfo($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      orderDeadlineInfo {
        timezone
        orderDeadlines {
          deadlineDay
          deliveryDay
          deadlineTime
        }
      }
    }
  }
`

/**
 * __useVendorProfileGetOrderDeadlineInfoQuery__
 *
 * To run a query within a React component, call `useVendorProfileGetOrderDeadlineInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileGetOrderDeadlineInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorProfileGetOrderDeadlineInfoQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorProfileGetOrderDeadlineInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorProfileGetOrderDeadlineInfoQuery,
    VendorProfileGetOrderDeadlineInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorProfileGetOrderDeadlineInfoQuery,
    VendorProfileGetOrderDeadlineInfoQueryVariables
  >(VendorProfileGetOrderDeadlineInfoDocument, options)
}
export function useVendorProfileGetOrderDeadlineInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorProfileGetOrderDeadlineInfoQuery,
    VendorProfileGetOrderDeadlineInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorProfileGetOrderDeadlineInfoQuery,
    VendorProfileGetOrderDeadlineInfoQueryVariables
  >(VendorProfileGetOrderDeadlineInfoDocument, options)
}
export type VendorProfileGetOrderDeadlineInfoQueryHookResult = ReturnType<
  typeof useVendorProfileGetOrderDeadlineInfoQuery
>
export type VendorProfileGetOrderDeadlineInfoLazyQueryHookResult = ReturnType<
  typeof useVendorProfileGetOrderDeadlineInfoLazyQuery
>
export type VendorProfileGetOrderDeadlineInfoQueryResult = Apollo.QueryResult<
  VendorProfileGetOrderDeadlineInfoQuery,
  VendorProfileGetOrderDeadlineInfoQueryVariables
>
export function refetchVendorProfileGetOrderDeadlineInfoQuery(
  variables: VendorProfileGetOrderDeadlineInfoQueryVariables,
) {
  return {
    query: VendorProfileGetOrderDeadlineInfoDocument,
    variables: variables,
  }
}
export const VendorProfileGetVsdaOrderDeadlineInfoDocument = /*#__PURE__*/ gql`
  query VendorProfile_GetVSDAOrderDeadlineInfo(
    $storeDepartmentID: ID!
    $vendorName: String!
  ) {
    getStoreDepartmentByID(id: $storeDepartmentID) {
      id
      vendorStoreDepartmentAccounts(input: { searchByVendor: $vendorName }) {
        nodes {
          id
          vendorID
          orderDeadlineInfo {
            timezone
            orderDeadlines {
              deadlineDay
              deliveryDay
              deadlineTime
            }
          }
        }
      }
    }
  }
`

/**
 * __useVendorProfileGetVsdaOrderDeadlineInfoQuery__
 *
 * To run a query within a React component, call `useVendorProfileGetVsdaOrderDeadlineInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorProfileGetVsdaOrderDeadlineInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorProfileGetVsdaOrderDeadlineInfoQuery({
 *   variables: {
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *      vendorName: // value for 'vendorName'
 *   },
 * });
 */
export function useVendorProfileGetVsdaOrderDeadlineInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorProfileGetVsdaOrderDeadlineInfoQuery,
    VendorProfileGetVsdaOrderDeadlineInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorProfileGetVsdaOrderDeadlineInfoQuery,
    VendorProfileGetVsdaOrderDeadlineInfoQueryVariables
  >(VendorProfileGetVsdaOrderDeadlineInfoDocument, options)
}
export function useVendorProfileGetVsdaOrderDeadlineInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorProfileGetVsdaOrderDeadlineInfoQuery,
    VendorProfileGetVsdaOrderDeadlineInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorProfileGetVsdaOrderDeadlineInfoQuery,
    VendorProfileGetVsdaOrderDeadlineInfoQueryVariables
  >(VendorProfileGetVsdaOrderDeadlineInfoDocument, options)
}
export type VendorProfileGetVsdaOrderDeadlineInfoQueryHookResult = ReturnType<
  typeof useVendorProfileGetVsdaOrderDeadlineInfoQuery
>
export type VendorProfileGetVsdaOrderDeadlineInfoLazyQueryHookResult =
  ReturnType<typeof useVendorProfileGetVsdaOrderDeadlineInfoLazyQuery>
export type VendorProfileGetVsdaOrderDeadlineInfoQueryResult =
  Apollo.QueryResult<
    VendorProfileGetVsdaOrderDeadlineInfoQuery,
    VendorProfileGetVsdaOrderDeadlineInfoQueryVariables
  >
export function refetchVendorProfileGetVsdaOrderDeadlineInfoQuery(
  variables: VendorProfileGetVsdaOrderDeadlineInfoQueryVariables,
) {
  return {
    query: VendorProfileGetVsdaOrderDeadlineInfoDocument,
    variables: variables,
  }
}
export const VendorPromotionsCreateAudienceDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_CreateAudience(
    $name: String!
    $vendorID: ID!
    $storeIDs: [ID!]!
  ) {
    createAudience(
      input: { name: $name, vendorID: $vendorID, storeIDs: $storeIDs }
    ) {
      ...VendorPromotions_AudienceFields
    }
  }
  ${VendorPromotionsAudienceFieldsFragmentDoc}
`
export type VendorPromotionsCreateAudienceMutationFn = Apollo.MutationFunction<
  VendorPromotionsCreateAudienceMutation,
  VendorPromotionsCreateAudienceMutationVariables
>

/**
 * __useVendorPromotionsCreateAudienceMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsCreateAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsCreateAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsCreateAudienceMutation, { data, loading, error }] = useVendorPromotionsCreateAudienceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      vendorID: // value for 'vendorID'
 *      storeIDs: // value for 'storeIDs'
 *   },
 * });
 */
export function useVendorPromotionsCreateAudienceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsCreateAudienceMutation,
    VendorPromotionsCreateAudienceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsCreateAudienceMutation,
    VendorPromotionsCreateAudienceMutationVariables
  >(VendorPromotionsCreateAudienceDocument, options)
}
export type VendorPromotionsCreateAudienceMutationHookResult = ReturnType<
  typeof useVendorPromotionsCreateAudienceMutation
>
export type VendorPromotionsCreateAudienceMutationResult =
  Apollo.MutationResult<VendorPromotionsCreateAudienceMutation>
export type VendorPromotionsCreateAudienceMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsCreateAudienceMutation,
    VendorPromotionsCreateAudienceMutationVariables
  >
export const VendorPromotionsCreateDealDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_CreateDeal(
    $type: DealType!
    $unitOfMeasure: UnitOfMeasure
    $promotionID: ID!
    $vendorProductIDs: [ID!]!
    $basisPoints: Int
    $dealValue: Currency
    $threshold: Int
    $freeCount: Int
    $vendorDiscountCode: String
  ) {
    createDeal(
      input: {
        type: $type
        unitOfMeasure: $unitOfMeasure
        promotionID: $promotionID
        vendorProductIDs: $vendorProductIDs
        basisPoints: $basisPoints
        dealValue: $dealValue
        threshold: $threshold
        freeCount: $freeCount
        vendorDiscountCode: $vendorDiscountCode
      }
    ) {
      id
      vendorProducts {
        totalCount
      }
    }
  }
`
export type VendorPromotionsCreateDealMutationFn = Apollo.MutationFunction<
  VendorPromotionsCreateDealMutation,
  VendorPromotionsCreateDealMutationVariables
>

/**
 * __useVendorPromotionsCreateDealMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsCreateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsCreateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsCreateDealMutation, { data, loading, error }] = useVendorPromotionsCreateDealMutation({
 *   variables: {
 *      type: // value for 'type'
 *      unitOfMeasure: // value for 'unitOfMeasure'
 *      promotionID: // value for 'promotionID'
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      basisPoints: // value for 'basisPoints'
 *      dealValue: // value for 'dealValue'
 *      threshold: // value for 'threshold'
 *      freeCount: // value for 'freeCount'
 *      vendorDiscountCode: // value for 'vendorDiscountCode'
 *   },
 * });
 */
export function useVendorPromotionsCreateDealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsCreateDealMutation,
    VendorPromotionsCreateDealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsCreateDealMutation,
    VendorPromotionsCreateDealMutationVariables
  >(VendorPromotionsCreateDealDocument, options)
}
export type VendorPromotionsCreateDealMutationHookResult = ReturnType<
  typeof useVendorPromotionsCreateDealMutation
>
export type VendorPromotionsCreateDealMutationResult =
  Apollo.MutationResult<VendorPromotionsCreateDealMutation>
export type VendorPromotionsCreateDealMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsCreateDealMutation,
    VendorPromotionsCreateDealMutationVariables
  >
export const VendorPromotionsUpdateDealDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_UpdateDeal(
    $id: ID!
    $type: DealType
    $vendorProductIDs: [ID!]
    $unitOfMeasure: UnitOfMeasure
    $basisPoints: Int
    $dealValue: Currency
    $threshold: Int
    $freeCount: Int
    $vendorDiscountCode: String
  ) {
    updateDeal(
      input: {
        id: $id
        type: $type
        vendorProductIDs: $vendorProductIDs
        unitOfMeasure: $unitOfMeasure
        basisPoints: $basisPoints
        dealValue: $dealValue
        threshold: $threshold
        freeCount: $freeCount
        vendorDiscountCode: $vendorDiscountCode
      }
    ) {
      id
      vendorProducts {
        totalCount
      }
    }
  }
`
export type VendorPromotionsUpdateDealMutationFn = Apollo.MutationFunction<
  VendorPromotionsUpdateDealMutation,
  VendorPromotionsUpdateDealMutationVariables
>

/**
 * __useVendorPromotionsUpdateDealMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsUpdateDealMutation, { data, loading, error }] = useVendorPromotionsUpdateDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      unitOfMeasure: // value for 'unitOfMeasure'
 *      basisPoints: // value for 'basisPoints'
 *      dealValue: // value for 'dealValue'
 *      threshold: // value for 'threshold'
 *      freeCount: // value for 'freeCount'
 *      vendorDiscountCode: // value for 'vendorDiscountCode'
 *   },
 * });
 */
export function useVendorPromotionsUpdateDealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsUpdateDealMutation,
    VendorPromotionsUpdateDealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsUpdateDealMutation,
    VendorPromotionsUpdateDealMutationVariables
  >(VendorPromotionsUpdateDealDocument, options)
}
export type VendorPromotionsUpdateDealMutationHookResult = ReturnType<
  typeof useVendorPromotionsUpdateDealMutation
>
export type VendorPromotionsUpdateDealMutationResult =
  Apollo.MutationResult<VendorPromotionsUpdateDealMutation>
export type VendorPromotionsUpdateDealMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsUpdateDealMutation,
    VendorPromotionsUpdateDealMutationVariables
  >
export const VendorPromotionsDeleteDealDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_DeleteDeal($id: ID!) {
    deleteDeal(input: { id: $id }) {
      deletedDealID
    }
  }
`
export type VendorPromotionsDeleteDealMutationFn = Apollo.MutationFunction<
  VendorPromotionsDeleteDealMutation,
  VendorPromotionsDeleteDealMutationVariables
>

/**
 * __useVendorPromotionsDeleteDealMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsDeleteDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsDeleteDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsDeleteDealMutation, { data, loading, error }] = useVendorPromotionsDeleteDealMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorPromotionsDeleteDealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsDeleteDealMutation,
    VendorPromotionsDeleteDealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsDeleteDealMutation,
    VendorPromotionsDeleteDealMutationVariables
  >(VendorPromotionsDeleteDealDocument, options)
}
export type VendorPromotionsDeleteDealMutationHookResult = ReturnType<
  typeof useVendorPromotionsDeleteDealMutation
>
export type VendorPromotionsDeleteDealMutationResult =
  Apollo.MutationResult<VendorPromotionsDeleteDealMutation>
export type VendorPromotionsDeleteDealMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsDeleteDealMutation,
    VendorPromotionsDeleteDealMutationVariables
  >
export const VendorPromotionsCreatePromotionDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_CreatePromotion(
    $allAccounts: Boolean
    $audienceID: ID
    $endDate: Timestamp
    $isPublished: Boolean!
    $name: String!
    $startDate: Timestamp
    $vendorID: ID!
  ) {
    createPromotion(
      input: {
        allAccounts: $allAccounts
        audienceID: $audienceID
        endDate: $endDate
        isPublished: $isPublished
        name: $name
        startDate: $startDate
        vendorID: $vendorID
      }
    ) {
      ...VendorPromotions_PromotionItemFields
    }
  }
  ${VendorPromotionsPromotionItemFieldsFragmentDoc}
`
export type VendorPromotionsCreatePromotionMutationFn = Apollo.MutationFunction<
  VendorPromotionsCreatePromotionMutation,
  VendorPromotionsCreatePromotionMutationVariables
>

/**
 * __useVendorPromotionsCreatePromotionMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsCreatePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsCreatePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsCreatePromotionMutation, { data, loading, error }] = useVendorPromotionsCreatePromotionMutation({
 *   variables: {
 *      allAccounts: // value for 'allAccounts'
 *      audienceID: // value for 'audienceID'
 *      endDate: // value for 'endDate'
 *      isPublished: // value for 'isPublished'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorPromotionsCreatePromotionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsCreatePromotionMutation,
    VendorPromotionsCreatePromotionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsCreatePromotionMutation,
    VendorPromotionsCreatePromotionMutationVariables
  >(VendorPromotionsCreatePromotionDocument, options)
}
export type VendorPromotionsCreatePromotionMutationHookResult = ReturnType<
  typeof useVendorPromotionsCreatePromotionMutation
>
export type VendorPromotionsCreatePromotionMutationResult =
  Apollo.MutationResult<VendorPromotionsCreatePromotionMutation>
export type VendorPromotionsCreatePromotionMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsCreatePromotionMutation,
    VendorPromotionsCreatePromotionMutationVariables
  >
export const VendorPromotionsUpdatePromotionDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_UpdatePromotion(
    $allAccounts: Boolean
    $audienceID: ID
    $endDate: Timestamp
    $id: ID!
    $isPublished: Boolean
    $name: String
    $startDate: Timestamp
  ) {
    updatePromotion(
      input: {
        allAccounts: $allAccounts
        audienceID: $audienceID
        endDate: $endDate
        id: $id
        isPublished: $isPublished
        name: $name
        startDate: $startDate
      }
    ) {
      ...VendorPromotions_PromotionItemFields
    }
  }
  ${VendorPromotionsPromotionItemFieldsFragmentDoc}
`
export type VendorPromotionsUpdatePromotionMutationFn = Apollo.MutationFunction<
  VendorPromotionsUpdatePromotionMutation,
  VendorPromotionsUpdatePromotionMutationVariables
>

/**
 * __useVendorPromotionsUpdatePromotionMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsUpdatePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsUpdatePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsUpdatePromotionMutation, { data, loading, error }] = useVendorPromotionsUpdatePromotionMutation({
 *   variables: {
 *      allAccounts: // value for 'allAccounts'
 *      audienceID: // value for 'audienceID'
 *      endDate: // value for 'endDate'
 *      id: // value for 'id'
 *      isPublished: // value for 'isPublished'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useVendorPromotionsUpdatePromotionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsUpdatePromotionMutation,
    VendorPromotionsUpdatePromotionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsUpdatePromotionMutation,
    VendorPromotionsUpdatePromotionMutationVariables
  >(VendorPromotionsUpdatePromotionDocument, options)
}
export type VendorPromotionsUpdatePromotionMutationHookResult = ReturnType<
  typeof useVendorPromotionsUpdatePromotionMutation
>
export type VendorPromotionsUpdatePromotionMutationResult =
  Apollo.MutationResult<VendorPromotionsUpdatePromotionMutation>
export type VendorPromotionsUpdatePromotionMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsUpdatePromotionMutation,
    VendorPromotionsUpdatePromotionMutationVariables
  >
export const VendorPromotionsDeletePromotionDocument = /*#__PURE__*/ gql`
  mutation VendorPromotions_DeletePromotion($id: ID!) {
    deletePromotion(input: { id: $id }) {
      deletedPromotionID
    }
  }
`
export type VendorPromotionsDeletePromotionMutationFn = Apollo.MutationFunction<
  VendorPromotionsDeletePromotionMutation,
  VendorPromotionsDeletePromotionMutationVariables
>

/**
 * __useVendorPromotionsDeletePromotionMutation__
 *
 * To run a mutation, you first call `useVendorPromotionsDeletePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsDeletePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorPromotionsDeletePromotionMutation, { data, loading, error }] = useVendorPromotionsDeletePromotionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorPromotionsDeletePromotionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorPromotionsDeletePromotionMutation,
    VendorPromotionsDeletePromotionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorPromotionsDeletePromotionMutation,
    VendorPromotionsDeletePromotionMutationVariables
  >(VendorPromotionsDeletePromotionDocument, options)
}
export type VendorPromotionsDeletePromotionMutationHookResult = ReturnType<
  typeof useVendorPromotionsDeletePromotionMutation
>
export type VendorPromotionsDeletePromotionMutationResult =
  Apollo.MutationResult<VendorPromotionsDeletePromotionMutation>
export type VendorPromotionsDeletePromotionMutationOptions =
  Apollo.BaseMutationOptions<
    VendorPromotionsDeletePromotionMutation,
    VendorPromotionsDeletePromotionMutationVariables
  >
export const VendorPromotionsGetAudiencesDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetAudiences {
    me {
      user {
        id
        userType
        vendorUser {
          vendor {
            audiences {
              nodes {
                ...VendorPromotions_AudienceFields
              }
            }
            id
          }
        }
      }
    }
  }
  ${VendorPromotionsAudienceFieldsFragmentDoc}
`

/**
 * __useVendorPromotionsGetAudiencesQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetAudiencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorPromotionsGetAudiencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VendorPromotionsGetAudiencesQuery,
    VendorPromotionsGetAudiencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetAudiencesQuery,
    VendorPromotionsGetAudiencesQueryVariables
  >(VendorPromotionsGetAudiencesDocument, options)
}
export function useVendorPromotionsGetAudiencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetAudiencesQuery,
    VendorPromotionsGetAudiencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetAudiencesQuery,
    VendorPromotionsGetAudiencesQueryVariables
  >(VendorPromotionsGetAudiencesDocument, options)
}
export type VendorPromotionsGetAudiencesQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetAudiencesQuery
>
export type VendorPromotionsGetAudiencesLazyQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetAudiencesLazyQuery
>
export type VendorPromotionsGetAudiencesQueryResult = Apollo.QueryResult<
  VendorPromotionsGetAudiencesQuery,
  VendorPromotionsGetAudiencesQueryVariables
>
export function refetchVendorPromotionsGetAudiencesQuery(
  variables?: VendorPromotionsGetAudiencesQueryVariables,
) {
  return { query: VendorPromotionsGetAudiencesDocument, variables: variables }
}
export const VendorPromotionsGetDealDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetDeal($id: ID!) {
    dealByID(id: $id) {
      ...VendorPromotions_DealFields
      promotion {
        id
        name
      }
    }
  }
  ${VendorPromotionsDealFieldsFragmentDoc}
`

/**
 * __useVendorPromotionsGetDealQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorPromotionsGetDealQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorPromotionsGetDealQuery,
    VendorPromotionsGetDealQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetDealQuery,
    VendorPromotionsGetDealQueryVariables
  >(VendorPromotionsGetDealDocument, options)
}
export function useVendorPromotionsGetDealLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetDealQuery,
    VendorPromotionsGetDealQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetDealQuery,
    VendorPromotionsGetDealQueryVariables
  >(VendorPromotionsGetDealDocument, options)
}
export type VendorPromotionsGetDealQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetDealQuery
>
export type VendorPromotionsGetDealLazyQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetDealLazyQuery
>
export type VendorPromotionsGetDealQueryResult = Apollo.QueryResult<
  VendorPromotionsGetDealQuery,
  VendorPromotionsGetDealQueryVariables
>
export function refetchVendorPromotionsGetDealQuery(
  variables: VendorPromotionsGetDealQueryVariables,
) {
  return { query: VendorPromotionsGetDealDocument, variables: variables }
}
export const VendorPromotionsGetAllPromotionsDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetAllPromotions {
    me {
      user {
        id
        userType
        vendorUser {
          vendor {
            id
            allPromotions {
              nodes {
                ...VendorPromotions_PromotionItemFields
              }
            }
          }
        }
      }
    }
  }
  ${VendorPromotionsPromotionItemFieldsFragmentDoc}
`

/**
 * __useVendorPromotionsGetAllPromotionsQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetAllPromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetAllPromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetAllPromotionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorPromotionsGetAllPromotionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VendorPromotionsGetAllPromotionsQuery,
    VendorPromotionsGetAllPromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetAllPromotionsQuery,
    VendorPromotionsGetAllPromotionsQueryVariables
  >(VendorPromotionsGetAllPromotionsDocument, options)
}
export function useVendorPromotionsGetAllPromotionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetAllPromotionsQuery,
    VendorPromotionsGetAllPromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetAllPromotionsQuery,
    VendorPromotionsGetAllPromotionsQueryVariables
  >(VendorPromotionsGetAllPromotionsDocument, options)
}
export type VendorPromotionsGetAllPromotionsQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetAllPromotionsQuery
>
export type VendorPromotionsGetAllPromotionsLazyQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetAllPromotionsLazyQuery
>
export type VendorPromotionsGetAllPromotionsQueryResult = Apollo.QueryResult<
  VendorPromotionsGetAllPromotionsQuery,
  VendorPromotionsGetAllPromotionsQueryVariables
>
export function refetchVendorPromotionsGetAllPromotionsQuery(
  variables?: VendorPromotionsGetAllPromotionsQueryVariables,
) {
  return {
    query: VendorPromotionsGetAllPromotionsDocument,
    variables: variables,
  }
}
export const VendorPromotionsGetPromotionDetailDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetPromotionDetail($id: ID!) {
    promotionByID(id: $id) {
      ...VendorPromotions_PromotionDetailFields
    }
  }
  ${VendorPromotionsPromotionDetailFieldsFragmentDoc}
`

/**
 * __useVendorPromotionsGetPromotionDetailQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetPromotionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetPromotionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetPromotionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorPromotionsGetPromotionDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorPromotionsGetPromotionDetailQuery,
    VendorPromotionsGetPromotionDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetPromotionDetailQuery,
    VendorPromotionsGetPromotionDetailQueryVariables
  >(VendorPromotionsGetPromotionDetailDocument, options)
}
export function useVendorPromotionsGetPromotionDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetPromotionDetailQuery,
    VendorPromotionsGetPromotionDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetPromotionDetailQuery,
    VendorPromotionsGetPromotionDetailQueryVariables
  >(VendorPromotionsGetPromotionDetailDocument, options)
}
export type VendorPromotionsGetPromotionDetailQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetPromotionDetailQuery
>
export type VendorPromotionsGetPromotionDetailLazyQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetPromotionDetailLazyQuery
>
export type VendorPromotionsGetPromotionDetailQueryResult = Apollo.QueryResult<
  VendorPromotionsGetPromotionDetailQuery,
  VendorPromotionsGetPromotionDetailQueryVariables
>
export function refetchVendorPromotionsGetPromotionDetailQuery(
  variables: VendorPromotionsGetPromotionDetailQueryVariables,
) {
  return {
    query: VendorPromotionsGetPromotionDetailDocument,
    variables: variables,
  }
}
export const VendorPromotionsGetPromotionConflictsDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetPromotionConflicts(
    $allAccounts: Boolean
    $audienceID: ID
    $endDate: Timestamp!
    $startDate: Timestamp!
    $vendorID: ID!
  ) {
    vendorByID(id: $vendorID) {
      id
      potentialPromotionConflicts(
        input: {
          allAccounts: $allAccounts
          audienceID: $audienceID
          endDate: $endDate
          startDate: $startDate
        }
      ) {
        totalCount
        nodes {
          ...VendorPromotions_PromotionConflictFields
        }
      }
    }
  }
  ${VendorPromotionsPromotionConflictFieldsFragmentDoc}
`

/**
 * __useVendorPromotionsGetPromotionConflictsQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetPromotionConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetPromotionConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetPromotionConflictsQuery({
 *   variables: {
 *      allAccounts: // value for 'allAccounts'
 *      audienceID: // value for 'audienceID'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorPromotionsGetPromotionConflictsQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorPromotionsGetPromotionConflictsQuery,
    VendorPromotionsGetPromotionConflictsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetPromotionConflictsQuery,
    VendorPromotionsGetPromotionConflictsQueryVariables
  >(VendorPromotionsGetPromotionConflictsDocument, options)
}
export function useVendorPromotionsGetPromotionConflictsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetPromotionConflictsQuery,
    VendorPromotionsGetPromotionConflictsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetPromotionConflictsQuery,
    VendorPromotionsGetPromotionConflictsQueryVariables
  >(VendorPromotionsGetPromotionConflictsDocument, options)
}
export type VendorPromotionsGetPromotionConflictsQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetPromotionConflictsQuery
>
export type VendorPromotionsGetPromotionConflictsLazyQueryHookResult =
  ReturnType<typeof useVendorPromotionsGetPromotionConflictsLazyQuery>
export type VendorPromotionsGetPromotionConflictsQueryResult =
  Apollo.QueryResult<
    VendorPromotionsGetPromotionConflictsQuery,
    VendorPromotionsGetPromotionConflictsQueryVariables
  >
export function refetchVendorPromotionsGetPromotionConflictsQuery(
  variables: VendorPromotionsGetPromotionConflictsQueryVariables,
) {
  return {
    query: VendorPromotionsGetPromotionConflictsDocument,
    variables: variables,
  }
}
export const VendorPromotionsGetProductsDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetProducts($cursor: ID, $vendorID: ID!) {
    vendorProducts(
      input: {
        limit: 500
        pagination: { cursor: $cursor }
        vendorID: $vendorID
      }
    ) {
      cursor
      hasMore
      nodes {
        id
        itemCode
        wholesalePricing {
          unitPrice
          casePrice
        }
        product {
          id
          brandName
          description
          imgURL
          unitUPC
        }
      }
    }
  }
`

/**
 * __useVendorPromotionsGetProductsQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetProductsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorPromotionsGetProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorPromotionsGetProductsQuery,
    VendorPromotionsGetProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetProductsQuery,
    VendorPromotionsGetProductsQueryVariables
  >(VendorPromotionsGetProductsDocument, options)
}
export function useVendorPromotionsGetProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetProductsQuery,
    VendorPromotionsGetProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetProductsQuery,
    VendorPromotionsGetProductsQueryVariables
  >(VendorPromotionsGetProductsDocument, options)
}
export type VendorPromotionsGetProductsQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetProductsQuery
>
export type VendorPromotionsGetProductsLazyQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetProductsLazyQuery
>
export type VendorPromotionsGetProductsQueryResult = Apollo.QueryResult<
  VendorPromotionsGetProductsQuery,
  VendorPromotionsGetProductsQueryVariables
>
export function refetchVendorPromotionsGetProductsQuery(
  variables: VendorPromotionsGetProductsQueryVariables,
) {
  return { query: VendorPromotionsGetProductsDocument, variables: variables }
}
export const VendorPromotionsGetStoreAccountsDocument = /*#__PURE__*/ gql`
  query VendorPromotions_GetStoreAccounts($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      storeAccounts {
        nodes {
          vendorID
          store {
            address
            banner {
              id
              name
              imageURL
              stores {
                nodes {
                  address
                  id
                }
              }
            }
            id
            name
          }
        }
      }
      prospectiveStoreAccounts {
        nodes {
          id
          address
          name
          banner {
            id
            name
            imageURL
            stores {
              nodes {
                address
                id
              }
            }
          }
        }
        totalCount
      }
    }
  }
`

/**
 * __useVendorPromotionsGetStoreAccountsQuery__
 *
 * To run a query within a React component, call `useVendorPromotionsGetStoreAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorPromotionsGetStoreAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorPromotionsGetStoreAccountsQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useVendorPromotionsGetStoreAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    VendorPromotionsGetStoreAccountsQuery,
    VendorPromotionsGetStoreAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VendorPromotionsGetStoreAccountsQuery,
    VendorPromotionsGetStoreAccountsQueryVariables
  >(VendorPromotionsGetStoreAccountsDocument, options)
}
export function useVendorPromotionsGetStoreAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VendorPromotionsGetStoreAccountsQuery,
    VendorPromotionsGetStoreAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VendorPromotionsGetStoreAccountsQuery,
    VendorPromotionsGetStoreAccountsQueryVariables
  >(VendorPromotionsGetStoreAccountsDocument, options)
}
export type VendorPromotionsGetStoreAccountsQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetStoreAccountsQuery
>
export type VendorPromotionsGetStoreAccountsLazyQueryHookResult = ReturnType<
  typeof useVendorPromotionsGetStoreAccountsLazyQuery
>
export type VendorPromotionsGetStoreAccountsQueryResult = Apollo.QueryResult<
  VendorPromotionsGetStoreAccountsQuery,
  VendorPromotionsGetStoreAccountsQueryVariables
>
export function refetchVendorPromotionsGetStoreAccountsQuery(
  variables: VendorPromotionsGetStoreAccountsQueryVariables,
) {
  return {
    query: VendorPromotionsGetStoreAccountsDocument,
    variables: variables,
  }
}
export const CommonGetStoreDepartmentsForRetailAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoreDepartmentsForRetailAdminSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              stores {
                nodes {
                  id
                  name
                  serialID
                  storeDepartments {
                    nodes {
                      deactivatedAt
                      id
                      name
                      store {
                        id
                        serialID
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoreDepartmentsForRetailAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoreDepartmentsForRetailAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoreDepartmentsForRetailAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoreDepartmentsForRetailAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoreDepartmentsForRetailAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoreDepartmentsForRetailAdminSelectQuery,
    CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoreDepartmentsForRetailAdminSelectQuery,
    CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables
  >(CommonGetStoreDepartmentsForRetailAdminSelectDocument, options)
}
export function useCommonGetStoreDepartmentsForRetailAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoreDepartmentsForRetailAdminSelectQuery,
    CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoreDepartmentsForRetailAdminSelectQuery,
    CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables
  >(CommonGetStoreDepartmentsForRetailAdminSelectDocument, options)
}
export type CommonGetStoreDepartmentsForRetailAdminSelectQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForRetailAdminSelectQuery>
export type CommonGetStoreDepartmentsForRetailAdminSelectLazyQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForRetailAdminSelectLazyQuery>
export type CommonGetStoreDepartmentsForRetailAdminSelectQueryResult =
  Apollo.QueryResult<
    CommonGetStoreDepartmentsForRetailAdminSelectQuery,
    CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables
  >
export function refetchCommonGetStoreDepartmentsForRetailAdminSelectQuery(
  variables?: CommonGetStoreDepartmentsForRetailAdminSelectQueryVariables,
) {
  return {
    query: CommonGetStoreDepartmentsForRetailAdminSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoreDepartmentsForRetailApSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoreDepartmentsForRetailAPSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          storeDepartments {
            nodes {
              deactivatedAt
              id
              name
              store {
                id
                serialID
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoreDepartmentsForRetailApSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoreDepartmentsForRetailApSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoreDepartmentsForRetailApSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoreDepartmentsForRetailApSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoreDepartmentsForRetailApSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoreDepartmentsForRetailApSelectQuery,
    CommonGetStoreDepartmentsForRetailApSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoreDepartmentsForRetailApSelectQuery,
    CommonGetStoreDepartmentsForRetailApSelectQueryVariables
  >(CommonGetStoreDepartmentsForRetailApSelectDocument, options)
}
export function useCommonGetStoreDepartmentsForRetailApSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoreDepartmentsForRetailApSelectQuery,
    CommonGetStoreDepartmentsForRetailApSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoreDepartmentsForRetailApSelectQuery,
    CommonGetStoreDepartmentsForRetailApSelectQueryVariables
  >(CommonGetStoreDepartmentsForRetailApSelectDocument, options)
}
export type CommonGetStoreDepartmentsForRetailApSelectQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForRetailApSelectQuery>
export type CommonGetStoreDepartmentsForRetailApSelectLazyQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForRetailApSelectLazyQuery>
export type CommonGetStoreDepartmentsForRetailApSelectQueryResult =
  Apollo.QueryResult<
    CommonGetStoreDepartmentsForRetailApSelectQuery,
    CommonGetStoreDepartmentsForRetailApSelectQueryVariables
  >
export function refetchCommonGetStoreDepartmentsForRetailApSelectQuery(
  variables?: CommonGetStoreDepartmentsForRetailApSelectQueryVariables,
) {
  return {
    query: CommonGetStoreDepartmentsForRetailApSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoreDepartmentsForRetailBuyerSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoreDepartmentsForRetailBuyerSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          storeDepartments {
            nodes {
              deactivatedAt
              id
              name
              store {
                id
                serialID
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoreDepartmentsForRetailBuyerSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoreDepartmentsForRetailBuyerSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoreDepartmentsForRetailBuyerSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoreDepartmentsForRetailBuyerSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoreDepartmentsForRetailBuyerSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoreDepartmentsForRetailBuyerSelectQuery,
    CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoreDepartmentsForRetailBuyerSelectQuery,
    CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables
  >(CommonGetStoreDepartmentsForRetailBuyerSelectDocument, options)
}
export function useCommonGetStoreDepartmentsForRetailBuyerSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoreDepartmentsForRetailBuyerSelectQuery,
    CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoreDepartmentsForRetailBuyerSelectQuery,
    CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables
  >(CommonGetStoreDepartmentsForRetailBuyerSelectDocument, options)
}
export type CommonGetStoreDepartmentsForRetailBuyerSelectQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForRetailBuyerSelectQuery>
export type CommonGetStoreDepartmentsForRetailBuyerSelectLazyQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForRetailBuyerSelectLazyQuery>
export type CommonGetStoreDepartmentsForRetailBuyerSelectQueryResult =
  Apollo.QueryResult<
    CommonGetStoreDepartmentsForRetailBuyerSelectQuery,
    CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables
  >
export function refetchCommonGetStoreDepartmentsForRetailBuyerSelectQuery(
  variables?: CommonGetStoreDepartmentsForRetailBuyerSelectQueryVariables,
) {
  return {
    query: CommonGetStoreDepartmentsForRetailBuyerSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoreDepartmentsForVendorAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoreDepartmentsForVendorAdminSelect {
    me {
      user {
        id
        vendorUser {
          user {
            id
          }
          vendor {
            id
            vendorStoreDepartmentAccounts {
              nodes {
                id
                store {
                  id
                  serialID
                  name
                }
                storeDepartment {
                  deactivatedAt
                  id
                  name
                  store {
                    id
                    serialID
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoreDepartmentsForVendorAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoreDepartmentsForVendorAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoreDepartmentsForVendorAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoreDepartmentsForVendorAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoreDepartmentsForVendorAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoreDepartmentsForVendorAdminSelectQuery,
    CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoreDepartmentsForVendorAdminSelectQuery,
    CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables
  >(CommonGetStoreDepartmentsForVendorAdminSelectDocument, options)
}
export function useCommonGetStoreDepartmentsForVendorAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoreDepartmentsForVendorAdminSelectQuery,
    CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoreDepartmentsForVendorAdminSelectQuery,
    CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables
  >(CommonGetStoreDepartmentsForVendorAdminSelectDocument, options)
}
export type CommonGetStoreDepartmentsForVendorAdminSelectQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForVendorAdminSelectQuery>
export type CommonGetStoreDepartmentsForVendorAdminSelectLazyQueryHookResult =
  ReturnType<typeof useCommonGetStoreDepartmentsForVendorAdminSelectLazyQuery>
export type CommonGetStoreDepartmentsForVendorAdminSelectQueryResult =
  Apollo.QueryResult<
    CommonGetStoreDepartmentsForVendorAdminSelectQuery,
    CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables
  >
export function refetchCommonGetStoreDepartmentsForVendorAdminSelectQuery(
  variables?: CommonGetStoreDepartmentsForVendorAdminSelectQueryVariables,
) {
  return {
    query: CommonGetStoreDepartmentsForVendorAdminSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoresForRetailAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoresForRetailAdminSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              stores {
                nodes {
                  id
                  name
                  serialID
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoresForRetailAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoresForRetailAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoresForRetailAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoresForRetailAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoresForRetailAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoresForRetailAdminSelectQuery,
    CommonGetStoresForRetailAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoresForRetailAdminSelectQuery,
    CommonGetStoresForRetailAdminSelectQueryVariables
  >(CommonGetStoresForRetailAdminSelectDocument, options)
}
export function useCommonGetStoresForRetailAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoresForRetailAdminSelectQuery,
    CommonGetStoresForRetailAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoresForRetailAdminSelectQuery,
    CommonGetStoresForRetailAdminSelectQueryVariables
  >(CommonGetStoresForRetailAdminSelectDocument, options)
}
export type CommonGetStoresForRetailAdminSelectQueryHookResult = ReturnType<
  typeof useCommonGetStoresForRetailAdminSelectQuery
>
export type CommonGetStoresForRetailAdminSelectLazyQueryHookResult = ReturnType<
  typeof useCommonGetStoresForRetailAdminSelectLazyQuery
>
export type CommonGetStoresForRetailAdminSelectQueryResult = Apollo.QueryResult<
  CommonGetStoresForRetailAdminSelectQuery,
  CommonGetStoresForRetailAdminSelectQueryVariables
>
export function refetchCommonGetStoresForRetailAdminSelectQuery(
  variables?: CommonGetStoresForRetailAdminSelectQueryVariables,
) {
  return {
    query: CommonGetStoresForRetailAdminSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoresForRetailApSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoresForRetailAPSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          storeDepartments {
            nodes {
              store {
                id
                name
                serialID
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoresForRetailApSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoresForRetailApSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoresForRetailApSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoresForRetailApSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoresForRetailApSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoresForRetailApSelectQuery,
    CommonGetStoresForRetailApSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoresForRetailApSelectQuery,
    CommonGetStoresForRetailApSelectQueryVariables
  >(CommonGetStoresForRetailApSelectDocument, options)
}
export function useCommonGetStoresForRetailApSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoresForRetailApSelectQuery,
    CommonGetStoresForRetailApSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoresForRetailApSelectQuery,
    CommonGetStoresForRetailApSelectQueryVariables
  >(CommonGetStoresForRetailApSelectDocument, options)
}
export type CommonGetStoresForRetailApSelectQueryHookResult = ReturnType<
  typeof useCommonGetStoresForRetailApSelectQuery
>
export type CommonGetStoresForRetailApSelectLazyQueryHookResult = ReturnType<
  typeof useCommonGetStoresForRetailApSelectLazyQuery
>
export type CommonGetStoresForRetailApSelectQueryResult = Apollo.QueryResult<
  CommonGetStoresForRetailApSelectQuery,
  CommonGetStoresForRetailApSelectQueryVariables
>
export function refetchCommonGetStoresForRetailApSelectQuery(
  variables?: CommonGetStoresForRetailApSelectQueryVariables,
) {
  return {
    query: CommonGetStoresForRetailApSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoresForVendorAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoresForVendorAdminSelect {
    me {
      user {
        id
        vendorUser {
          user {
            id
          }
          vendor {
            id
            stores {
              nodes {
                id
                name
                serialID
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetStoresForVendorAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoresForVendorAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoresForVendorAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoresForVendorAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoresForVendorAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoresForVendorAdminSelectQuery,
    CommonGetStoresForVendorAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoresForVendorAdminSelectQuery,
    CommonGetStoresForVendorAdminSelectQueryVariables
  >(CommonGetStoresForVendorAdminSelectDocument, options)
}
export function useCommonGetStoresForVendorAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoresForVendorAdminSelectQuery,
    CommonGetStoresForVendorAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoresForVendorAdminSelectQuery,
    CommonGetStoresForVendorAdminSelectQueryVariables
  >(CommonGetStoresForVendorAdminSelectDocument, options)
}
export type CommonGetStoresForVendorAdminSelectQueryHookResult = ReturnType<
  typeof useCommonGetStoresForVendorAdminSelectQuery
>
export type CommonGetStoresForVendorAdminSelectLazyQueryHookResult = ReturnType<
  typeof useCommonGetStoresForVendorAdminSelectLazyQuery
>
export type CommonGetStoresForVendorAdminSelectQueryResult = Apollo.QueryResult<
  CommonGetStoresForVendorAdminSelectQuery,
  CommonGetStoresForVendorAdminSelectQueryVariables
>
export function refetchCommonGetStoresForVendorAdminSelectQuery(
  variables?: CommonGetStoresForVendorAdminSelectQueryVariables,
) {
  return {
    query: CommonGetStoresForVendorAdminSelectDocument,
    variables: variables,
  }
}
export const CommonGetStoresForVoriAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetStoresForVoriAdminSelect {
    allStores(input: { limit: 10000 }) {
      nodes {
        id
        name
        serialID
      }
    }
  }
`

/**
 * __useCommonGetStoresForVoriAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetStoresForVoriAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetStoresForVoriAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetStoresForVoriAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetStoresForVoriAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetStoresForVoriAdminSelectQuery,
    CommonGetStoresForVoriAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetStoresForVoriAdminSelectQuery,
    CommonGetStoresForVoriAdminSelectQueryVariables
  >(CommonGetStoresForVoriAdminSelectDocument, options)
}
export function useCommonGetStoresForVoriAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetStoresForVoriAdminSelectQuery,
    CommonGetStoresForVoriAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetStoresForVoriAdminSelectQuery,
    CommonGetStoresForVoriAdminSelectQueryVariables
  >(CommonGetStoresForVoriAdminSelectDocument, options)
}
export type CommonGetStoresForVoriAdminSelectQueryHookResult = ReturnType<
  typeof useCommonGetStoresForVoriAdminSelectQuery
>
export type CommonGetStoresForVoriAdminSelectLazyQueryHookResult = ReturnType<
  typeof useCommonGetStoresForVoriAdminSelectLazyQuery
>
export type CommonGetStoresForVoriAdminSelectQueryResult = Apollo.QueryResult<
  CommonGetStoresForVoriAdminSelectQuery,
  CommonGetStoresForVoriAdminSelectQueryVariables
>
export function refetchCommonGetStoresForVoriAdminSelectQuery(
  variables?: CommonGetStoresForVoriAdminSelectQueryVariables,
) {
  return {
    query: CommonGetStoresForVoriAdminSelectDocument,
    variables: variables,
  }
}
export const CommonGetVendorsForRetailAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetVendorsForRetailAdminSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            banner {
              id
              vendors {
                nodes {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetVendorsForRetailAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetVendorsForRetailAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetVendorsForRetailAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetVendorsForRetailAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetVendorsForRetailAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetVendorsForRetailAdminSelectQuery,
    CommonGetVendorsForRetailAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetVendorsForRetailAdminSelectQuery,
    CommonGetVendorsForRetailAdminSelectQueryVariables
  >(CommonGetVendorsForRetailAdminSelectDocument, options)
}
export function useCommonGetVendorsForRetailAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetVendorsForRetailAdminSelectQuery,
    CommonGetVendorsForRetailAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetVendorsForRetailAdminSelectQuery,
    CommonGetVendorsForRetailAdminSelectQueryVariables
  >(CommonGetVendorsForRetailAdminSelectDocument, options)
}
export type CommonGetVendorsForRetailAdminSelectQueryHookResult = ReturnType<
  typeof useCommonGetVendorsForRetailAdminSelectQuery
>
export type CommonGetVendorsForRetailAdminSelectLazyQueryHookResult =
  ReturnType<typeof useCommonGetVendorsForRetailAdminSelectLazyQuery>
export type CommonGetVendorsForRetailAdminSelectQueryResult =
  Apollo.QueryResult<
    CommonGetVendorsForRetailAdminSelectQuery,
    CommonGetVendorsForRetailAdminSelectQueryVariables
  >
export function refetchCommonGetVendorsForRetailAdminSelectQuery(
  variables?: CommonGetVendorsForRetailAdminSelectQueryVariables,
) {
  return {
    query: CommonGetVendorsForRetailAdminSelectDocument,
    variables: variables,
  }
}
export const CommonGetVendorsForRetailApSelectDocument = /*#__PURE__*/ gql`
  query Common_GetVendorsForRetailAPSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            store {
              id
              vendors {
                nodes {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetVendorsForRetailApSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetVendorsForRetailApSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetVendorsForRetailApSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetVendorsForRetailApSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetVendorsForRetailApSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetVendorsForRetailApSelectQuery,
    CommonGetVendorsForRetailApSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetVendorsForRetailApSelectQuery,
    CommonGetVendorsForRetailApSelectQueryVariables
  >(CommonGetVendorsForRetailApSelectDocument, options)
}
export function useCommonGetVendorsForRetailApSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetVendorsForRetailApSelectQuery,
    CommonGetVendorsForRetailApSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetVendorsForRetailApSelectQuery,
    CommonGetVendorsForRetailApSelectQueryVariables
  >(CommonGetVendorsForRetailApSelectDocument, options)
}
export type CommonGetVendorsForRetailApSelectQueryHookResult = ReturnType<
  typeof useCommonGetVendorsForRetailApSelectQuery
>
export type CommonGetVendorsForRetailApSelectLazyQueryHookResult = ReturnType<
  typeof useCommonGetVendorsForRetailApSelectLazyQuery
>
export type CommonGetVendorsForRetailApSelectQueryResult = Apollo.QueryResult<
  CommonGetVendorsForRetailApSelectQuery,
  CommonGetVendorsForRetailApSelectQueryVariables
>
export function refetchCommonGetVendorsForRetailApSelectQuery(
  variables?: CommonGetVendorsForRetailApSelectQueryVariables,
) {
  return {
    query: CommonGetVendorsForRetailApSelectDocument,
    variables: variables,
  }
}
export const CommonGetVendorsForRetailBuyerSelectDocument = /*#__PURE__*/ gql`
  query Common_GetVendorsForRetailBuyerSelect {
    me {
      user {
        id
        retailUser {
          user {
            id
          }
          retailCompany {
            id
            store {
              id
              vendors {
                nodes {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useCommonGetVendorsForRetailBuyerSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetVendorsForRetailBuyerSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetVendorsForRetailBuyerSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetVendorsForRetailBuyerSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetVendorsForRetailBuyerSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetVendorsForRetailBuyerSelectQuery,
    CommonGetVendorsForRetailBuyerSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetVendorsForRetailBuyerSelectQuery,
    CommonGetVendorsForRetailBuyerSelectQueryVariables
  >(CommonGetVendorsForRetailBuyerSelectDocument, options)
}
export function useCommonGetVendorsForRetailBuyerSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetVendorsForRetailBuyerSelectQuery,
    CommonGetVendorsForRetailBuyerSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetVendorsForRetailBuyerSelectQuery,
    CommonGetVendorsForRetailBuyerSelectQueryVariables
  >(CommonGetVendorsForRetailBuyerSelectDocument, options)
}
export type CommonGetVendorsForRetailBuyerSelectQueryHookResult = ReturnType<
  typeof useCommonGetVendorsForRetailBuyerSelectQuery
>
export type CommonGetVendorsForRetailBuyerSelectLazyQueryHookResult =
  ReturnType<typeof useCommonGetVendorsForRetailBuyerSelectLazyQuery>
export type CommonGetVendorsForRetailBuyerSelectQueryResult =
  Apollo.QueryResult<
    CommonGetVendorsForRetailBuyerSelectQuery,
    CommonGetVendorsForRetailBuyerSelectQueryVariables
  >
export function refetchCommonGetVendorsForRetailBuyerSelectQuery(
  variables?: CommonGetVendorsForRetailBuyerSelectQueryVariables,
) {
  return {
    query: CommonGetVendorsForRetailBuyerSelectDocument,
    variables: variables,
  }
}
export const CommonGetVendorsForVoriAdminSelectDocument = /*#__PURE__*/ gql`
  query Common_GetVendorsForVoriAdminSelect {
    allVendors(input: { limit: 10000 }) {
      nodes {
        id
        name
      }
    }
  }
`

/**
 * __useCommonGetVendorsForVoriAdminSelectQuery__
 *
 * To run a query within a React component, call `useCommonGetVendorsForVoriAdminSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonGetVendorsForVoriAdminSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonGetVendorsForVoriAdminSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommonGetVendorsForVoriAdminSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommonGetVendorsForVoriAdminSelectQuery,
    CommonGetVendorsForVoriAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CommonGetVendorsForVoriAdminSelectQuery,
    CommonGetVendorsForVoriAdminSelectQueryVariables
  >(CommonGetVendorsForVoriAdminSelectDocument, options)
}
export function useCommonGetVendorsForVoriAdminSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommonGetVendorsForVoriAdminSelectQuery,
    CommonGetVendorsForVoriAdminSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CommonGetVendorsForVoriAdminSelectQuery,
    CommonGetVendorsForVoriAdminSelectQueryVariables
  >(CommonGetVendorsForVoriAdminSelectDocument, options)
}
export type CommonGetVendorsForVoriAdminSelectQueryHookResult = ReturnType<
  typeof useCommonGetVendorsForVoriAdminSelectQuery
>
export type CommonGetVendorsForVoriAdminSelectLazyQueryHookResult = ReturnType<
  typeof useCommonGetVendorsForVoriAdminSelectLazyQuery
>
export type CommonGetVendorsForVoriAdminSelectQueryResult = Apollo.QueryResult<
  CommonGetVendorsForVoriAdminSelectQuery,
  CommonGetVendorsForVoriAdminSelectQueryVariables
>
export function refetchCommonGetVendorsForVoriAdminSelectQuery(
  variables?: CommonGetVendorsForVoriAdminSelectQueryVariables,
) {
  return {
    query: CommonGetVendorsForVoriAdminSelectDocument,
    variables: variables,
  }
}
export const AdminBannersDeleteBannerByIdDocument = /*#__PURE__*/ gql`
  mutation AdminBanners_DeleteBannerByID($bannerID: ID!) {
    deleteBanner(input: { bannerID: $bannerID }) {
      deletedBannerID
    }
  }
`
export type AdminBannersDeleteBannerByIdMutationFn = Apollo.MutationFunction<
  AdminBannersDeleteBannerByIdMutation,
  AdminBannersDeleteBannerByIdMutationVariables
>

/**
 * __useAdminBannersDeleteBannerByIdMutation__
 *
 * To run a mutation, you first call `useAdminBannersDeleteBannerByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBannersDeleteBannerByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBannersDeleteBannerByIdMutation, { data, loading, error }] = useAdminBannersDeleteBannerByIdMutation({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *   },
 * });
 */
export function useAdminBannersDeleteBannerByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminBannersDeleteBannerByIdMutation,
    AdminBannersDeleteBannerByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminBannersDeleteBannerByIdMutation,
    AdminBannersDeleteBannerByIdMutationVariables
  >(AdminBannersDeleteBannerByIdDocument, options)
}
export type AdminBannersDeleteBannerByIdMutationHookResult = ReturnType<
  typeof useAdminBannersDeleteBannerByIdMutation
>
export type AdminBannersDeleteBannerByIdMutationResult =
  Apollo.MutationResult<AdminBannersDeleteBannerByIdMutation>
export type AdminBannersDeleteBannerByIdMutationOptions =
  Apollo.BaseMutationOptions<
    AdminBannersDeleteBannerByIdMutation,
    AdminBannersDeleteBannerByIdMutationVariables
  >
export const AdminBannersCreateBannerDocument = /*#__PURE__*/ gql`
  mutation AdminBanners_CreateBanner(
    $name: String!
    $imageURL: String
    $imageURLFile: Upload
    $status: BannerStatus
    $storeIDs: [ID!]
    $acquisitionSource: AcquisitionSource
    $acquisitionDetail: String
    $referredByCompanyID: ID
    $bannerType: StoreType
  ) {
    createBanner(
      input: {
        name: $name
        imageURL: $imageURL
        imageURLFile: $imageURLFile
        status: $status
        storeIDs: $storeIDs
        acquisitionSource: $acquisitionSource
        acquisitionDetail: $acquisitionDetail
        referredByCompanyID: $referredByCompanyID
        bannerType: $bannerType
      }
    ) {
      ...AdminBanners_BannerFields
    }
  }
  ${AdminBannersBannerFieldsFragmentDoc}
`
export type AdminBannersCreateBannerMutationFn = Apollo.MutationFunction<
  AdminBannersCreateBannerMutation,
  AdminBannersCreateBannerMutationVariables
>

/**
 * __useAdminBannersCreateBannerMutation__
 *
 * To run a mutation, you first call `useAdminBannersCreateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBannersCreateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBannersCreateBannerMutation, { data, loading, error }] = useAdminBannersCreateBannerMutation({
 *   variables: {
 *      name: // value for 'name'
 *      imageURL: // value for 'imageURL'
 *      imageURLFile: // value for 'imageURLFile'
 *      status: // value for 'status'
 *      storeIDs: // value for 'storeIDs'
 *      acquisitionSource: // value for 'acquisitionSource'
 *      acquisitionDetail: // value for 'acquisitionDetail'
 *      referredByCompanyID: // value for 'referredByCompanyID'
 *      bannerType: // value for 'bannerType'
 *   },
 * });
 */
export function useAdminBannersCreateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminBannersCreateBannerMutation,
    AdminBannersCreateBannerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminBannersCreateBannerMutation,
    AdminBannersCreateBannerMutationVariables
  >(AdminBannersCreateBannerDocument, options)
}
export type AdminBannersCreateBannerMutationHookResult = ReturnType<
  typeof useAdminBannersCreateBannerMutation
>
export type AdminBannersCreateBannerMutationResult =
  Apollo.MutationResult<AdminBannersCreateBannerMutation>
export type AdminBannersCreateBannerMutationOptions =
  Apollo.BaseMutationOptions<
    AdminBannersCreateBannerMutation,
    AdminBannersCreateBannerMutationVariables
  >
export const AdminBannersUpdateBannerDocument = /*#__PURE__*/ gql`
  mutation AdminBanners_UpdateBanner(
    $id: ID!
    $name: String
    $imageURL: String
    $imageURLFile: Upload
    $status: BannerStatus
    $storeIDs: [ID!]!
    $acquisitionSource: AcquisitionSource
    $acquisitionDetail: String
    $referredByCompanyID: ID
    $bannerType: StoreType
  ) {
    updateBanner(
      input: {
        id: $id
        name: $name
        imageURL: $imageURL
        imageURLFile: $imageURLFile
        status: $status
        storeIDs: $storeIDs
        acquisitionSource: $acquisitionSource
        acquisitionDetail: $acquisitionDetail
        referredByCompanyID: $referredByCompanyID
        bannerType: $bannerType
      }
    ) {
      ...AdminBanners_BannerFields
    }
  }
  ${AdminBannersBannerFieldsFragmentDoc}
`
export type AdminBannersUpdateBannerMutationFn = Apollo.MutationFunction<
  AdminBannersUpdateBannerMutation,
  AdminBannersUpdateBannerMutationVariables
>

/**
 * __useAdminBannersUpdateBannerMutation__
 *
 * To run a mutation, you first call `useAdminBannersUpdateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBannersUpdateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBannersUpdateBannerMutation, { data, loading, error }] = useAdminBannersUpdateBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      imageURL: // value for 'imageURL'
 *      imageURLFile: // value for 'imageURLFile'
 *      status: // value for 'status'
 *      storeIDs: // value for 'storeIDs'
 *      acquisitionSource: // value for 'acquisitionSource'
 *      acquisitionDetail: // value for 'acquisitionDetail'
 *      referredByCompanyID: // value for 'referredByCompanyID'
 *      bannerType: // value for 'bannerType'
 *   },
 * });
 */
export function useAdminBannersUpdateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminBannersUpdateBannerMutation,
    AdminBannersUpdateBannerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminBannersUpdateBannerMutation,
    AdminBannersUpdateBannerMutationVariables
  >(AdminBannersUpdateBannerDocument, options)
}
export type AdminBannersUpdateBannerMutationHookResult = ReturnType<
  typeof useAdminBannersUpdateBannerMutation
>
export type AdminBannersUpdateBannerMutationResult =
  Apollo.MutationResult<AdminBannersUpdateBannerMutation>
export type AdminBannersUpdateBannerMutationOptions =
  Apollo.BaseMutationOptions<
    AdminBannersUpdateBannerMutation,
    AdminBannersUpdateBannerMutationVariables
  >
export const AdminBannersGetAllBannersDocument = /*#__PURE__*/ gql`
  query AdminBanners_GetAllBanners($cursor: String, $search: String) {
    allBanners(input: { cursor: $cursor, limit: 2, search: $search }) {
      nodes {
        ...AdminBanners_BannerFields
      }
      cursor
      hasMore
      totalCount
    }
  }
  ${AdminBannersBannerFieldsFragmentDoc}
`

/**
 * __useAdminBannersGetAllBannersQuery__
 *
 * To run a query within a React component, call `useAdminBannersGetAllBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBannersGetAllBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBannersGetAllBannersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminBannersGetAllBannersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminBannersGetAllBannersQuery,
    AdminBannersGetAllBannersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminBannersGetAllBannersQuery,
    AdminBannersGetAllBannersQueryVariables
  >(AdminBannersGetAllBannersDocument, options)
}
export function useAdminBannersGetAllBannersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminBannersGetAllBannersQuery,
    AdminBannersGetAllBannersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminBannersGetAllBannersQuery,
    AdminBannersGetAllBannersQueryVariables
  >(AdminBannersGetAllBannersDocument, options)
}
export type AdminBannersGetAllBannersQueryHookResult = ReturnType<
  typeof useAdminBannersGetAllBannersQuery
>
export type AdminBannersGetAllBannersLazyQueryHookResult = ReturnType<
  typeof useAdminBannersGetAllBannersLazyQuery
>
export type AdminBannersGetAllBannersQueryResult = Apollo.QueryResult<
  AdminBannersGetAllBannersQuery,
  AdminBannersGetAllBannersQueryVariables
>
export function refetchAdminBannersGetAllBannersQuery(
  variables?: AdminBannersGetAllBannersQueryVariables,
) {
  return { query: AdminBannersGetAllBannersDocument, variables: variables }
}
export const AdminBannersGetBannerByIdDocument = /*#__PURE__*/ gql`
  query AdminBanners_GetBannerByID($id: ID!) {
    bannerByID(id: $id) {
      ...AdminBanners_BannerFields
    }
  }
  ${AdminBannersBannerFieldsFragmentDoc}
`

/**
 * __useAdminBannersGetBannerByIdQuery__
 *
 * To run a query within a React component, call `useAdminBannersGetBannerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBannersGetBannerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBannersGetBannerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminBannersGetBannerByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminBannersGetBannerByIdQuery,
    AdminBannersGetBannerByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminBannersGetBannerByIdQuery,
    AdminBannersGetBannerByIdQueryVariables
  >(AdminBannersGetBannerByIdDocument, options)
}
export function useAdminBannersGetBannerByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminBannersGetBannerByIdQuery,
    AdminBannersGetBannerByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminBannersGetBannerByIdQuery,
    AdminBannersGetBannerByIdQueryVariables
  >(AdminBannersGetBannerByIdDocument, options)
}
export type AdminBannersGetBannerByIdQueryHookResult = ReturnType<
  typeof useAdminBannersGetBannerByIdQuery
>
export type AdminBannersGetBannerByIdLazyQueryHookResult = ReturnType<
  typeof useAdminBannersGetBannerByIdLazyQuery
>
export type AdminBannersGetBannerByIdQueryResult = Apollo.QueryResult<
  AdminBannersGetBannerByIdQuery,
  AdminBannersGetBannerByIdQueryVariables
>
export function refetchAdminBannersGetBannerByIdQuery(
  variables: AdminBannersGetBannerByIdQueryVariables,
) {
  return { query: AdminBannersGetBannerByIdDocument, variables: variables }
}
export const AdminBannersGetAllStoresDocument = /*#__PURE__*/ gql`
  query AdminBanners_GetAllStores($cursor: String, $search: String) {
    allStores(input: { limit: 10, cursor: $cursor, search: $search }) {
      cursor
      hasMore
      nodes {
        id
        name
        banner {
          id
          name
        }
      }
    }
  }
`

/**
 * __useAdminBannersGetAllStoresQuery__
 *
 * To run a query within a React component, call `useAdminBannersGetAllStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBannersGetAllStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBannersGetAllStoresQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminBannersGetAllStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminBannersGetAllStoresQuery,
    AdminBannersGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminBannersGetAllStoresQuery,
    AdminBannersGetAllStoresQueryVariables
  >(AdminBannersGetAllStoresDocument, options)
}
export function useAdminBannersGetAllStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminBannersGetAllStoresQuery,
    AdminBannersGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminBannersGetAllStoresQuery,
    AdminBannersGetAllStoresQueryVariables
  >(AdminBannersGetAllStoresDocument, options)
}
export type AdminBannersGetAllStoresQueryHookResult = ReturnType<
  typeof useAdminBannersGetAllStoresQuery
>
export type AdminBannersGetAllStoresLazyQueryHookResult = ReturnType<
  typeof useAdminBannersGetAllStoresLazyQuery
>
export type AdminBannersGetAllStoresQueryResult = Apollo.QueryResult<
  AdminBannersGetAllStoresQuery,
  AdminBannersGetAllStoresQueryVariables
>
export function refetchAdminBannersGetAllStoresQuery(
  variables?: AdminBannersGetAllStoresQueryVariables,
) {
  return { query: AdminBannersGetAllStoresDocument, variables: variables }
}
export const AdminCatalogsParseCsvOrderGuideDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_ParseCSVOrderGuide(
    $vendorID: ID!
    $csvInput: [OrderGuideCSVInput!]!
    $forRetailAccountIDs: [ID]
    $forInvitationOrderGuide: Boolean!
  ) {
    parseCSVOrderGuide(
      input: {
        vendorID: $vendorID
        forRetailAccountIDs: $forRetailAccountIDs
        orderGuideCSVInput: $csvInput
        forInvitationOrderGuide: $forInvitationOrderGuide
      }
    ) {
      vendorProductIDs
      errors
      hasErrors
    }
  }
`
export type AdminCatalogsParseCsvOrderGuideMutationFn = Apollo.MutationFunction<
  AdminCatalogsParseCsvOrderGuideMutation,
  AdminCatalogsParseCsvOrderGuideMutationVariables
>

/**
 * __useAdminCatalogsParseCsvOrderGuideMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsParseCsvOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsParseCsvOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsParseCsvOrderGuideMutation, { data, loading, error }] = useAdminCatalogsParseCsvOrderGuideMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      csvInput: // value for 'csvInput'
 *      forRetailAccountIDs: // value for 'forRetailAccountIDs'
 *      forInvitationOrderGuide: // value for 'forInvitationOrderGuide'
 *   },
 * });
 */
export function useAdminCatalogsParseCsvOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsParseCsvOrderGuideMutation,
    AdminCatalogsParseCsvOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsParseCsvOrderGuideMutation,
    AdminCatalogsParseCsvOrderGuideMutationVariables
  >(AdminCatalogsParseCsvOrderGuideDocument, options)
}
export type AdminCatalogsParseCsvOrderGuideMutationHookResult = ReturnType<
  typeof useAdminCatalogsParseCsvOrderGuideMutation
>
export type AdminCatalogsParseCsvOrderGuideMutationResult =
  Apollo.MutationResult<AdminCatalogsParseCsvOrderGuideMutation>
export type AdminCatalogsParseCsvOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsParseCsvOrderGuideMutation,
    AdminCatalogsParseCsvOrderGuideMutationVariables
  >
export const AdminCatalogsBulkParseCsvOrderGuidesDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_BulkParseCSVOrderGuides(
    $vendors: [ParseCSVOrderGuideInput!]!
  ) {
    bulkParseCSVOrderGuides(input: { vendors: $vendors }) {
      nodes {
        vendorProductIDs
        retailAccountIDs
        errors
        hasErrors
        vendorID
      }
    }
  }
`
export type AdminCatalogsBulkParseCsvOrderGuidesMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsBulkParseCsvOrderGuidesMutation,
    AdminCatalogsBulkParseCsvOrderGuidesMutationVariables
  >

/**
 * __useAdminCatalogsBulkParseCsvOrderGuidesMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsBulkParseCsvOrderGuidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsBulkParseCsvOrderGuidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsBulkParseCsvOrderGuidesMutation, { data, loading, error }] = useAdminCatalogsBulkParseCsvOrderGuidesMutation({
 *   variables: {
 *      vendors: // value for 'vendors'
 *   },
 * });
 */
export function useAdminCatalogsBulkParseCsvOrderGuidesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsBulkParseCsvOrderGuidesMutation,
    AdminCatalogsBulkParseCsvOrderGuidesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsBulkParseCsvOrderGuidesMutation,
    AdminCatalogsBulkParseCsvOrderGuidesMutationVariables
  >(AdminCatalogsBulkParseCsvOrderGuidesDocument, options)
}
export type AdminCatalogsBulkParseCsvOrderGuidesMutationHookResult = ReturnType<
  typeof useAdminCatalogsBulkParseCsvOrderGuidesMutation
>
export type AdminCatalogsBulkParseCsvOrderGuidesMutationResult =
  Apollo.MutationResult<AdminCatalogsBulkParseCsvOrderGuidesMutation>
export type AdminCatalogsBulkParseCsvOrderGuidesMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsBulkParseCsvOrderGuidesMutation,
    AdminCatalogsBulkParseCsvOrderGuidesMutationVariables
  >
export const AdminCatalogsBulkUpdateV2OrderGuidesDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_BulkUpdateV2OrderGuides(
    $addAccounts: [AddProductsToV2OrderGuideInput!]!
    $updateAccounts: [UpdateV2OrderGuideInput!]!
  ) {
    bulkAddProductsToV2OrderGuide(
      input: { addOrderGuideProductsInput: $addAccounts }
    ) {
      nodes {
        addedVendorProducts {
          id
        }
      }
    }
    bulkUpdateV2OrderGuides(
      input: { updateOrderGuideProductsInput: $updateAccounts }
    ) {
      nodes {
        id
        vendorProductIDs
      }
    }
  }
`
export type AdminCatalogsBulkUpdateV2OrderGuidesMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsBulkUpdateV2OrderGuidesMutation,
    AdminCatalogsBulkUpdateV2OrderGuidesMutationVariables
  >

/**
 * __useAdminCatalogsBulkUpdateV2OrderGuidesMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsBulkUpdateV2OrderGuidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsBulkUpdateV2OrderGuidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsBulkUpdateV2OrderGuidesMutation, { data, loading, error }] = useAdminCatalogsBulkUpdateV2OrderGuidesMutation({
 *   variables: {
 *      addAccounts: // value for 'addAccounts'
 *      updateAccounts: // value for 'updateAccounts'
 *   },
 * });
 */
export function useAdminCatalogsBulkUpdateV2OrderGuidesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsBulkUpdateV2OrderGuidesMutation,
    AdminCatalogsBulkUpdateV2OrderGuidesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsBulkUpdateV2OrderGuidesMutation,
    AdminCatalogsBulkUpdateV2OrderGuidesMutationVariables
  >(AdminCatalogsBulkUpdateV2OrderGuidesDocument, options)
}
export type AdminCatalogsBulkUpdateV2OrderGuidesMutationHookResult = ReturnType<
  typeof useAdminCatalogsBulkUpdateV2OrderGuidesMutation
>
export type AdminCatalogsBulkUpdateV2OrderGuidesMutationResult =
  Apollo.MutationResult<AdminCatalogsBulkUpdateV2OrderGuidesMutation>
export type AdminCatalogsBulkUpdateV2OrderGuidesMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsBulkUpdateV2OrderGuidesMutation,
    AdminCatalogsBulkUpdateV2OrderGuidesMutationVariables
  >
export const AdminCatalogsAddProductsToV2OrderGuideDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_AddProductsToV2OrderGuide(
    $vendorStoreDepartmentAccountID: ID!
    $vendorProductIDs: [ID!]!
  ) {
    addProductsToV2OrderGuide(
      input: {
        vendorStoreDepartmentAccountID: $vendorStoreDepartmentAccountID
        vendorProductIDs: $vendorProductIDs
      }
    ) {
      addedVendorProducts {
        id
      }
    }
  }
`
export type AdminCatalogsAddProductsToV2OrderGuideMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsAddProductsToV2OrderGuideMutation,
    AdminCatalogsAddProductsToV2OrderGuideMutationVariables
  >

/**
 * __useAdminCatalogsAddProductsToV2OrderGuideMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsAddProductsToV2OrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsAddProductsToV2OrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsAddProductsToV2OrderGuideMutation, { data, loading, error }] = useAdminCatalogsAddProductsToV2OrderGuideMutation({
 *   variables: {
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *   },
 * });
 */
export function useAdminCatalogsAddProductsToV2OrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsAddProductsToV2OrderGuideMutation,
    AdminCatalogsAddProductsToV2OrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsAddProductsToV2OrderGuideMutation,
    AdminCatalogsAddProductsToV2OrderGuideMutationVariables
  >(AdminCatalogsAddProductsToV2OrderGuideDocument, options)
}
export type AdminCatalogsAddProductsToV2OrderGuideMutationHookResult =
  ReturnType<typeof useAdminCatalogsAddProductsToV2OrderGuideMutation>
export type AdminCatalogsAddProductsToV2OrderGuideMutationResult =
  Apollo.MutationResult<AdminCatalogsAddProductsToV2OrderGuideMutation>
export type AdminCatalogsAddProductsToV2OrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsAddProductsToV2OrderGuideMutation,
    AdminCatalogsAddProductsToV2OrderGuideMutationVariables
  >
export const AdminCatalogsUpdateV2OrderGuideDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_UpdateV2OrderGuide(
    $vendorStoreDepartmentAccountID: ID!
    $vendorProductIDs: [ID!]!
  ) {
    updateV2OrderGuide(
      input: {
        vendorStoreDepartmentAccountID: $vendorStoreDepartmentAccountID
        vendorProductIDs: $vendorProductIDs
      }
    ) {
      id
      vendorProductIDs
    }
  }
`
export type AdminCatalogsUpdateV2OrderGuideMutationFn = Apollo.MutationFunction<
  AdminCatalogsUpdateV2OrderGuideMutation,
  AdminCatalogsUpdateV2OrderGuideMutationVariables
>

/**
 * __useAdminCatalogsUpdateV2OrderGuideMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsUpdateV2OrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsUpdateV2OrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsUpdateV2OrderGuideMutation, { data, loading, error }] = useAdminCatalogsUpdateV2OrderGuideMutation({
 *   variables: {
 *      vendorStoreDepartmentAccountID: // value for 'vendorStoreDepartmentAccountID'
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *   },
 * });
 */
export function useAdminCatalogsUpdateV2OrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsUpdateV2OrderGuideMutation,
    AdminCatalogsUpdateV2OrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsUpdateV2OrderGuideMutation,
    AdminCatalogsUpdateV2OrderGuideMutationVariables
  >(AdminCatalogsUpdateV2OrderGuideDocument, options)
}
export type AdminCatalogsUpdateV2OrderGuideMutationHookResult = ReturnType<
  typeof useAdminCatalogsUpdateV2OrderGuideMutation
>
export type AdminCatalogsUpdateV2OrderGuideMutationResult =
  Apollo.MutationResult<AdminCatalogsUpdateV2OrderGuideMutation>
export type AdminCatalogsUpdateV2OrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsUpdateV2OrderGuideMutation,
    AdminCatalogsUpdateV2OrderGuideMutationVariables
  >
export const AdminCatalogsCreateInvitationOrderGuideDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_CreateInvitationOrderGuide(
    $vendorID: ID!
    $productIDs: [ID!]!
    $orderGuideName: String!
    $departmentName: String
  ) {
    createInvitationOrderGuide(
      input: {
        vendorID: $vendorID
        orderGuideName: $orderGuideName
        productIDs: $productIDs
        departmentName: $departmentName
      }
    ) {
      id
      vendor {
        id
        name
      }
      orderGuideName
      departmentName
      products {
        product {
          id
          description
        }
      }
    }
  }
`
export type AdminCatalogsCreateInvitationOrderGuideMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsCreateInvitationOrderGuideMutation,
    AdminCatalogsCreateInvitationOrderGuideMutationVariables
  >

/**
 * __useAdminCatalogsCreateInvitationOrderGuideMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsCreateInvitationOrderGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsCreateInvitationOrderGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsCreateInvitationOrderGuideMutation, { data, loading, error }] = useAdminCatalogsCreateInvitationOrderGuideMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      productIDs: // value for 'productIDs'
 *      orderGuideName: // value for 'orderGuideName'
 *      departmentName: // value for 'departmentName'
 *   },
 * });
 */
export function useAdminCatalogsCreateInvitationOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsCreateInvitationOrderGuideMutation,
    AdminCatalogsCreateInvitationOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsCreateInvitationOrderGuideMutation,
    AdminCatalogsCreateInvitationOrderGuideMutationVariables
  >(AdminCatalogsCreateInvitationOrderGuideDocument, options)
}
export type AdminCatalogsCreateInvitationOrderGuideMutationHookResult =
  ReturnType<typeof useAdminCatalogsCreateInvitationOrderGuideMutation>
export type AdminCatalogsCreateInvitationOrderGuideMutationResult =
  Apollo.MutationResult<AdminCatalogsCreateInvitationOrderGuideMutation>
export type AdminCatalogsCreateInvitationOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsCreateInvitationOrderGuideMutation,
    AdminCatalogsCreateInvitationOrderGuideMutationVariables
  >
export const AdminCatalogsUpdateBannerAuthFileV2OrderGuidesDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_UpdateBannerAuthFileV2OrderGuides(
    $bannerID: ID!
    $accounts: [UpdateBannerAuthFileV2OrderGuidesAccountInput!]!
  ) {
    updateBannerAuthFileV2OrderGuides(
      input: { bannerID: $bannerID, accounts: $accounts }
    ) {
      nodes {
        id
        vendorProductIDs
        vendorStoreDepartmentAccount {
          id
          name
        }
      }
      updatedVendorStoreDepartmentAccounts
    }
  }
`
export type AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationVariables
  >

/**
 * __useAdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation, { data, loading, error }] = useAdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useAdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationVariables
  >(AdminCatalogsUpdateBannerAuthFileV2OrderGuidesDocument, options)
}
export type AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationHookResult =
  ReturnType<typeof useAdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation>
export type AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationResult =
  Apollo.MutationResult<AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation>
export type AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerAuthFileV2OrderGuidesMutationVariables
  >
export const AdminCatalogsUpdateBannerV2OrderGuidesDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_UpdateBannerV2OrderGuides(
    $vendorID: ID!
    $bannerID: ID!
    $vendorProductIDs: [ID!]!
    $departmentName: DepartmentName!
    $shouldOverwrite: Boolean
  ) {
    updateBannerV2OrderGuides(
      input: {
        vendorID: $vendorID
        bannerID: $bannerID
        vendorProductIDs: $vendorProductIDs
        departmentName: $departmentName
        shouldOverwrite: $shouldOverwrite
      }
    ) {
      nodes {
        id
        vendorProductIDs
        vendorStoreDepartmentAccount {
          id
          name
        }
      }
      updatedVendorStoreDepartmentAccounts
    }
  }
`
export type AdminCatalogsUpdateBannerV2OrderGuidesMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsUpdateBannerV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerV2OrderGuidesMutationVariables
  >

/**
 * __useAdminCatalogsUpdateBannerV2OrderGuidesMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsUpdateBannerV2OrderGuidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsUpdateBannerV2OrderGuidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsUpdateBannerV2OrderGuidesMutation, { data, loading, error }] = useAdminCatalogsUpdateBannerV2OrderGuidesMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      bannerID: // value for 'bannerID'
 *      vendorProductIDs: // value for 'vendorProductIDs'
 *      departmentName: // value for 'departmentName'
 *      shouldOverwrite: // value for 'shouldOverwrite'
 *   },
 * });
 */
export function useAdminCatalogsUpdateBannerV2OrderGuidesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsUpdateBannerV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerV2OrderGuidesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsUpdateBannerV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerV2OrderGuidesMutationVariables
  >(AdminCatalogsUpdateBannerV2OrderGuidesDocument, options)
}
export type AdminCatalogsUpdateBannerV2OrderGuidesMutationHookResult =
  ReturnType<typeof useAdminCatalogsUpdateBannerV2OrderGuidesMutation>
export type AdminCatalogsUpdateBannerV2OrderGuidesMutationResult =
  Apollo.MutationResult<AdminCatalogsUpdateBannerV2OrderGuidesMutation>
export type AdminCatalogsUpdateBannerV2OrderGuidesMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsUpdateBannerV2OrderGuidesMutation,
    AdminCatalogsUpdateBannerV2OrderGuidesMutationVariables
  >
export const AdminCatalogsBulkSingleVendorProductsUploadWorkerDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_BulkSingleVendorProductsUploadWorker(
    $vendorID: ID!
    $overwrite: Boolean!
    $inputProducts: [BulkVendorProductInput!]!
    $isBannerUpload: Boolean!
    $retailAccountID: ID
    $privateLabelUpload: Boolean
    $discontinueMissingProducts: Boolean
    $catalogSource: VendorProductCatalogSource
  ) {
    bulkUploadSingleVendorProductsWorker(
      input: {
        catalogSource: $catalogSource
        discontinueMissingProducts: $discontinueMissingProducts
        inputProducts: $inputProducts
        isBannerUpload: $isBannerUpload
        overwrite: $overwrite
        privateLabelUpload: $privateLabelUpload
        retailAccountID: $retailAccountID
        vendorID: $vendorID
      }
    ) {
      jobID
    }
  }
`
export type AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationVariables
  >

/**
 * __useAdminCatalogsBulkSingleVendorProductsUploadWorkerMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsBulkSingleVendorProductsUploadWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsBulkSingleVendorProductsUploadWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsBulkSingleVendorProductsUploadWorkerMutation, { data, loading, error }] = useAdminCatalogsBulkSingleVendorProductsUploadWorkerMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      overwrite: // value for 'overwrite'
 *      inputProducts: // value for 'inputProducts'
 *      isBannerUpload: // value for 'isBannerUpload'
 *      retailAccountID: // value for 'retailAccountID'
 *      privateLabelUpload: // value for 'privateLabelUpload'
 *      discontinueMissingProducts: // value for 'discontinueMissingProducts'
 *      catalogSource: // value for 'catalogSource'
 *   },
 * });
 */
export function useAdminCatalogsBulkSingleVendorProductsUploadWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationVariables
  >(AdminCatalogsBulkSingleVendorProductsUploadWorkerDocument, options)
}
export type AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationHookResult =
  ReturnType<
    typeof useAdminCatalogsBulkSingleVendorProductsUploadWorkerMutation
  >
export type AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationResult =
  Apollo.MutationResult<AdminCatalogsBulkSingleVendorProductsUploadWorkerMutation>
export type AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkSingleVendorProductsUploadWorkerMutationVariables
  >
export const AdminCatalogsBulkMultiVendorProductsUploadWorkerDocument = /*#__PURE__*/ gql`
  mutation AdminCatalogs_BulkMultiVendorProductsUploadWorker(
    $overwrite: Boolean!
    $isBannerUpload: Boolean!
    $retailAccountID: ID
    $inputProducts: [BulkVendorProductInput!]!
    $privateLabelUpload: Boolean
    $catalogSource: VendorProductCatalogSource
  ) {
    bulkUploadMultiVendorProductsWorker(
      input: {
        catalogSource: $catalogSource
        inputProducts: $inputProducts
        isBannerUpload: $isBannerUpload
        overwrite: $overwrite
        privateLabelUpload: $privateLabelUpload
        retailAccountID: $retailAccountID
      }
    ) {
      jobID
    }
  }
`
export type AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationFn =
  Apollo.MutationFunction<
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationVariables
  >

/**
 * __useAdminCatalogsBulkMultiVendorProductsUploadWorkerMutation__
 *
 * To run a mutation, you first call `useAdminCatalogsBulkMultiVendorProductsUploadWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsBulkMultiVendorProductsUploadWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCatalogsBulkMultiVendorProductsUploadWorkerMutation, { data, loading, error }] = useAdminCatalogsBulkMultiVendorProductsUploadWorkerMutation({
 *   variables: {
 *      overwrite: // value for 'overwrite'
 *      isBannerUpload: // value for 'isBannerUpload'
 *      retailAccountID: // value for 'retailAccountID'
 *      inputProducts: // value for 'inputProducts'
 *      privateLabelUpload: // value for 'privateLabelUpload'
 *      catalogSource: // value for 'catalogSource'
 *   },
 * });
 */
export function useAdminCatalogsBulkMultiVendorProductsUploadWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationVariables
  >(AdminCatalogsBulkMultiVendorProductsUploadWorkerDocument, options)
}
export type AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationHookResult =
  ReturnType<typeof useAdminCatalogsBulkMultiVendorProductsUploadWorkerMutation>
export type AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationResult =
  Apollo.MutationResult<AdminCatalogsBulkMultiVendorProductsUploadWorkerMutation>
export type AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationOptions =
  Apollo.BaseMutationOptions<
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutation,
    AdminCatalogsBulkMultiVendorProductsUploadWorkerMutationVariables
  >
export const AdminCatalogsValidateBulkUploadVendorProductsDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_ValidateBulkUploadVendorProducts(
    $inputProducts: [BulkVendorProductInput!]!
    $isMultiVendorUpload: Boolean!
    $vendorIDForSingleVendorValidation: String
  ) {
    validateBulkUploadVendorProducts(
      vendorIDForSingleVendorValidation: $vendorIDForSingleVendorValidation
      isMultiVendorUpload: $isMultiVendorUpload
      inputProducts: $inputProducts
    ) {
      spreadsheetURL
      numValidProducts
      numProducts
      numExistingProducts
      numDeletedProductsRestored
      numNewProducts
      errors {
        index
        errorMessages
      }
      matchErrors {
        error
        index
      }
      vendor {
        name
      }
    }
  }
`

/**
 * __useAdminCatalogsValidateBulkUploadVendorProductsQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsValidateBulkUploadVendorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsValidateBulkUploadVendorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsValidateBulkUploadVendorProductsQuery({
 *   variables: {
 *      inputProducts: // value for 'inputProducts'
 *      isMultiVendorUpload: // value for 'isMultiVendorUpload'
 *      vendorIDForSingleVendorValidation: // value for 'vendorIDForSingleVendorValidation'
 *   },
 * });
 */
export function useAdminCatalogsValidateBulkUploadVendorProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsValidateBulkUploadVendorProductsQuery,
    AdminCatalogsValidateBulkUploadVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsValidateBulkUploadVendorProductsQuery,
    AdminCatalogsValidateBulkUploadVendorProductsQueryVariables
  >(AdminCatalogsValidateBulkUploadVendorProductsDocument, options)
}
export function useAdminCatalogsValidateBulkUploadVendorProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsValidateBulkUploadVendorProductsQuery,
    AdminCatalogsValidateBulkUploadVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsValidateBulkUploadVendorProductsQuery,
    AdminCatalogsValidateBulkUploadVendorProductsQueryVariables
  >(AdminCatalogsValidateBulkUploadVendorProductsDocument, options)
}
export type AdminCatalogsValidateBulkUploadVendorProductsQueryHookResult =
  ReturnType<typeof useAdminCatalogsValidateBulkUploadVendorProductsQuery>
export type AdminCatalogsValidateBulkUploadVendorProductsLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsValidateBulkUploadVendorProductsLazyQuery>
export type AdminCatalogsValidateBulkUploadVendorProductsQueryResult =
  Apollo.QueryResult<
    AdminCatalogsValidateBulkUploadVendorProductsQuery,
    AdminCatalogsValidateBulkUploadVendorProductsQueryVariables
  >
export function refetchAdminCatalogsValidateBulkUploadVendorProductsQuery(
  variables: AdminCatalogsValidateBulkUploadVendorProductsQueryVariables,
) {
  return {
    query: AdminCatalogsValidateBulkUploadVendorProductsDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetVendorOgProductsDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetVendorOGProducts(
    $vendorID: ID!
    $filterByRetailerIDs: [ID!]
    $limit: Int
    $search: String
  ) {
    vendorProducts(
      input: {
        vendorID: $vendorID
        filterByRetailerIDs: $filterByRetailerIDs
        limit: $limit
        search: $search
      }
    ) {
      nodes {
        id
        itemCode
        retailerPricing {
          casePrice
          unitPrice
        }
        caseSize
        product {
          id
          imgURL
          brandName
          category
          description
          unitVolume
          unitUPC
          caseUPC
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetVendorOgProductsQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetVendorOgProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetVendorOgProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetVendorOgProductsQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      filterByRetailerIDs: // value for 'filterByRetailerIDs'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminCatalogsGetVendorOgProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetVendorOgProductsQuery,
    AdminCatalogsGetVendorOgProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetVendorOgProductsQuery,
    AdminCatalogsGetVendorOgProductsQueryVariables
  >(AdminCatalogsGetVendorOgProductsDocument, options)
}
export function useAdminCatalogsGetVendorOgProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetVendorOgProductsQuery,
    AdminCatalogsGetVendorOgProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetVendorOgProductsQuery,
    AdminCatalogsGetVendorOgProductsQueryVariables
  >(AdminCatalogsGetVendorOgProductsDocument, options)
}
export type AdminCatalogsGetVendorOgProductsQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetVendorOgProductsQuery
>
export type AdminCatalogsGetVendorOgProductsLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetVendorOgProductsLazyQuery
>
export type AdminCatalogsGetVendorOgProductsQueryResult = Apollo.QueryResult<
  AdminCatalogsGetVendorOgProductsQuery,
  AdminCatalogsGetVendorOgProductsQueryVariables
>
export function refetchAdminCatalogsGetVendorOgProductsQuery(
  variables: AdminCatalogsGetVendorOgProductsQueryVariables,
) {
  return {
    query: AdminCatalogsGetVendorOgProductsDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetV2VsdaOrderGuideDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetV2VSDAOrderGuide(
    $storeID: ID!
    $vendorStoreDepartmentAccountIDs: [ID!]!
  ) {
    storeByID(id: $storeID) {
      vendorStoreDepartmentAccounts(
        input: {
          vendorStoreDepartmentAccountIDs: $vendorStoreDepartmentAccountIDs
        }
      ) {
        nodes {
          id
          orderGuide {
            id
            vendorProductIDs
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetV2VsdaOrderGuideQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetV2VsdaOrderGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetV2VsdaOrderGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetV2VsdaOrderGuideQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      vendorStoreDepartmentAccountIDs: // value for 'vendorStoreDepartmentAccountIDs'
 *   },
 * });
 */
export function useAdminCatalogsGetV2VsdaOrderGuideQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetV2VsdaOrderGuideQuery,
    AdminCatalogsGetV2VsdaOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetV2VsdaOrderGuideQuery,
    AdminCatalogsGetV2VsdaOrderGuideQueryVariables
  >(AdminCatalogsGetV2VsdaOrderGuideDocument, options)
}
export function useAdminCatalogsGetV2VsdaOrderGuideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetV2VsdaOrderGuideQuery,
    AdminCatalogsGetV2VsdaOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetV2VsdaOrderGuideQuery,
    AdminCatalogsGetV2VsdaOrderGuideQueryVariables
  >(AdminCatalogsGetV2VsdaOrderGuideDocument, options)
}
export type AdminCatalogsGetV2VsdaOrderGuideQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetV2VsdaOrderGuideQuery
>
export type AdminCatalogsGetV2VsdaOrderGuideLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetV2VsdaOrderGuideLazyQuery
>
export type AdminCatalogsGetV2VsdaOrderGuideQueryResult = Apollo.QueryResult<
  AdminCatalogsGetV2VsdaOrderGuideQuery,
  AdminCatalogsGetV2VsdaOrderGuideQueryVariables
>
export function refetchAdminCatalogsGetV2VsdaOrderGuideQuery(
  variables: AdminCatalogsGetV2VsdaOrderGuideQueryVariables,
) {
  return {
    query: AdminCatalogsGetV2VsdaOrderGuideDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetV2VsdaOrderGuidesDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetV2VSDAOrderGuides(
    $storeID: ID!
    $vendorIDs: [ID!]!
    $vendorStoreDepartmentAccountIDs: [ID!]!
  ) {
    storeByID(id: $storeID) {
      vendorStoreDepartmentAccounts(
        input: {
          vendorIDs: $vendorIDs
          vendorStoreDepartmentAccountIDs: $vendorStoreDepartmentAccountIDs
        }
      ) {
        nodes {
          id
          vendorID
          orderGuide {
            id
            vendorProductIDs
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetV2VsdaOrderGuidesQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetV2VsdaOrderGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetV2VsdaOrderGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetV2VsdaOrderGuidesQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      vendorIDs: // value for 'vendorIDs'
 *      vendorStoreDepartmentAccountIDs: // value for 'vendorStoreDepartmentAccountIDs'
 *   },
 * });
 */
export function useAdminCatalogsGetV2VsdaOrderGuidesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetV2VsdaOrderGuidesQuery,
    AdminCatalogsGetV2VsdaOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetV2VsdaOrderGuidesQuery,
    AdminCatalogsGetV2VsdaOrderGuidesQueryVariables
  >(AdminCatalogsGetV2VsdaOrderGuidesDocument, options)
}
export function useAdminCatalogsGetV2VsdaOrderGuidesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetV2VsdaOrderGuidesQuery,
    AdminCatalogsGetV2VsdaOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetV2VsdaOrderGuidesQuery,
    AdminCatalogsGetV2VsdaOrderGuidesQueryVariables
  >(AdminCatalogsGetV2VsdaOrderGuidesDocument, options)
}
export type AdminCatalogsGetV2VsdaOrderGuidesQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetV2VsdaOrderGuidesQuery
>
export type AdminCatalogsGetV2VsdaOrderGuidesLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetV2VsdaOrderGuidesLazyQuery
>
export type AdminCatalogsGetV2VsdaOrderGuidesQueryResult = Apollo.QueryResult<
  AdminCatalogsGetV2VsdaOrderGuidesQuery,
  AdminCatalogsGetV2VsdaOrderGuidesQueryVariables
>
export function refetchAdminCatalogsGetV2VsdaOrderGuidesQuery(
  variables: AdminCatalogsGetV2VsdaOrderGuidesQueryVariables,
) {
  return {
    query: AdminCatalogsGetV2VsdaOrderGuidesDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetV2VsdaStoreAuthOrderGuidesDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetV2VSDAStoreAuthOrderGuides(
    $vendorStoreDepartmentAccountIDs: [ID!]!
  ) {
    adminVendorStoreDepartmentAccountsByID(
      ids: $vendorStoreDepartmentAccountIDs
    ) {
      nodes {
        id
        name
        orderGuide {
          vendorProductIDs
        }
        store {
          id
          name
        }
        vendor {
          id
          name
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery({
 *   variables: {
 *      vendorStoreDepartmentAccountIDs: // value for 'vendorStoreDepartmentAccountIDs'
 *   },
 * });
 */
export function useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery,
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery,
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables
  >(AdminCatalogsGetV2VsdaStoreAuthOrderGuidesDocument, options)
}
export function useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery,
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery,
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables
  >(AdminCatalogsGetV2VsdaStoreAuthOrderGuidesDocument, options)
}
export type AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery>
export type AdminCatalogsGetV2VsdaStoreAuthOrderGuidesLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetV2VsdaStoreAuthOrderGuidesLazyQuery>
export type AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryResult =
  Apollo.QueryResult<
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery,
    AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables
  >
export function refetchAdminCatalogsGetV2VsdaStoreAuthOrderGuidesQuery(
  variables: AdminCatalogsGetV2VsdaStoreAuthOrderGuidesQueryVariables,
) {
  return {
    query: AdminCatalogsGetV2VsdaStoreAuthOrderGuidesDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetsVsdAsForStoresAndVendorsDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetsVSDAsForStoresAndVendors(
    $ids: [ID!]!
    $vendorIDs: [ID!]!
  ) {
    adminStoresByID(ids: $ids) {
      nodes {
        id
        vendorStoreDepartmentAccounts(input: { vendorIDs: $vendorIDs }) {
          nodes {
            id
            name
            store {
              id
              name
            }
            vendor {
              id
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetsVsdAsForStoresAndVendorsQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetsVsdAsForStoresAndVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetsVsdAsForStoresAndVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetsVsdAsForStoresAndVendorsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      vendorIDs: // value for 'vendorIDs'
 *   },
 * });
 */
export function useAdminCatalogsGetsVsdAsForStoresAndVendorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetsVsdAsForStoresAndVendorsQuery,
    AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetsVsdAsForStoresAndVendorsQuery,
    AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables
  >(AdminCatalogsGetsVsdAsForStoresAndVendorsDocument, options)
}
export function useAdminCatalogsGetsVsdAsForStoresAndVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetsVsdAsForStoresAndVendorsQuery,
    AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetsVsdAsForStoresAndVendorsQuery,
    AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables
  >(AdminCatalogsGetsVsdAsForStoresAndVendorsDocument, options)
}
export type AdminCatalogsGetsVsdAsForStoresAndVendorsQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetsVsdAsForStoresAndVendorsQuery>
export type AdminCatalogsGetsVsdAsForStoresAndVendorsLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetsVsdAsForStoresAndVendorsLazyQuery>
export type AdminCatalogsGetsVsdAsForStoresAndVendorsQueryResult =
  Apollo.QueryResult<
    AdminCatalogsGetsVsdAsForStoresAndVendorsQuery,
    AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables
  >
export function refetchAdminCatalogsGetsVsdAsForStoresAndVendorsQuery(
  variables: AdminCatalogsGetsVsdAsForStoresAndVendorsQueryVariables,
) {
  return {
    query: AdminCatalogsGetsVsdAsForStoresAndVendorsDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetBannerV2VsdaOrderGuidesDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetBannerV2VSDAOrderGuides(
    $bannerID: ID!
    $vendorIDs: [ID!]!
    $vendorStoreDepartmentAccountIDs: [ID!]!
  ) {
    bannerByID(id: $bannerID) {
      stores {
        nodes {
          vendorStoreDepartmentAccounts(
            input: {
              vendorIDs: $vendorIDs
              vendorStoreDepartmentAccountIDs: $vendorStoreDepartmentAccountIDs
            }
          ) {
            nodes {
              id
              vendorID
              orderGuide {
                id
                vendorProductIDs
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetBannerV2VsdaOrderGuidesQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetBannerV2VsdaOrderGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetBannerV2VsdaOrderGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetBannerV2VsdaOrderGuidesQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      vendorIDs: // value for 'vendorIDs'
 *      vendorStoreDepartmentAccountIDs: // value for 'vendorStoreDepartmentAccountIDs'
 *   },
 * });
 */
export function useAdminCatalogsGetBannerV2VsdaOrderGuidesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetBannerV2VsdaOrderGuidesQuery,
    AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetBannerV2VsdaOrderGuidesQuery,
    AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables
  >(AdminCatalogsGetBannerV2VsdaOrderGuidesDocument, options)
}
export function useAdminCatalogsGetBannerV2VsdaOrderGuidesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetBannerV2VsdaOrderGuidesQuery,
    AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetBannerV2VsdaOrderGuidesQuery,
    AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables
  >(AdminCatalogsGetBannerV2VsdaOrderGuidesDocument, options)
}
export type AdminCatalogsGetBannerV2VsdaOrderGuidesQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetBannerV2VsdaOrderGuidesQuery
>
export type AdminCatalogsGetBannerV2VsdaOrderGuidesLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetBannerV2VsdaOrderGuidesLazyQuery>
export type AdminCatalogsGetBannerV2VsdaOrderGuidesQueryResult =
  Apollo.QueryResult<
    AdminCatalogsGetBannerV2VsdaOrderGuidesQuery,
    AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables
  >
export function refetchAdminCatalogsGetBannerV2VsdaOrderGuidesQuery(
  variables: AdminCatalogsGetBannerV2VsdaOrderGuidesQueryVariables,
) {
  return {
    query: AdminCatalogsGetBannerV2VsdaOrderGuidesDocument,
    variables: variables,
  }
}
export const AdminCatalogsCheckInvitationOrderGuideNameDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_CheckInvitationOrderGuideName(
    $orderGuideNames: [String!]!
    $vendorID: ID!
  ) {
    validateInvitationOrderGuideNames(
      orderGuideNames: $orderGuideNames
      vendorID: $vendorID
    ) {
      duplicates
    }
  }
`

/**
 * __useAdminCatalogsCheckInvitationOrderGuideNameQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsCheckInvitationOrderGuideNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsCheckInvitationOrderGuideNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsCheckInvitationOrderGuideNameQuery({
 *   variables: {
 *      orderGuideNames: // value for 'orderGuideNames'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useAdminCatalogsCheckInvitationOrderGuideNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsCheckInvitationOrderGuideNameQuery,
    AdminCatalogsCheckInvitationOrderGuideNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsCheckInvitationOrderGuideNameQuery,
    AdminCatalogsCheckInvitationOrderGuideNameQueryVariables
  >(AdminCatalogsCheckInvitationOrderGuideNameDocument, options)
}
export function useAdminCatalogsCheckInvitationOrderGuideNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsCheckInvitationOrderGuideNameQuery,
    AdminCatalogsCheckInvitationOrderGuideNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsCheckInvitationOrderGuideNameQuery,
    AdminCatalogsCheckInvitationOrderGuideNameQueryVariables
  >(AdminCatalogsCheckInvitationOrderGuideNameDocument, options)
}
export type AdminCatalogsCheckInvitationOrderGuideNameQueryHookResult =
  ReturnType<typeof useAdminCatalogsCheckInvitationOrderGuideNameQuery>
export type AdminCatalogsCheckInvitationOrderGuideNameLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsCheckInvitationOrderGuideNameLazyQuery>
export type AdminCatalogsCheckInvitationOrderGuideNameQueryResult =
  Apollo.QueryResult<
    AdminCatalogsCheckInvitationOrderGuideNameQuery,
    AdminCatalogsCheckInvitationOrderGuideNameQueryVariables
  >
export function refetchAdminCatalogsCheckInvitationOrderGuideNameQuery(
  variables: AdminCatalogsCheckInvitationOrderGuideNameQueryVariables,
) {
  return {
    query: AdminCatalogsCheckInvitationOrderGuideNameDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetAllBannersDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetAllBanners($search: String, $cursor: String) {
    allBanners(input: { search: $search, cursor: $cursor }) {
      nodes {
        id
        name
        imageURL
      }
      hasMore
      cursor
      totalCount
    }
  }
`

/**
 * __useAdminCatalogsGetAllBannersQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetAllBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetAllBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetAllBannersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAdminCatalogsGetAllBannersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminCatalogsGetAllBannersQuery,
    AdminCatalogsGetAllBannersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetAllBannersQuery,
    AdminCatalogsGetAllBannersQueryVariables
  >(AdminCatalogsGetAllBannersDocument, options)
}
export function useAdminCatalogsGetAllBannersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetAllBannersQuery,
    AdminCatalogsGetAllBannersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetAllBannersQuery,
    AdminCatalogsGetAllBannersQueryVariables
  >(AdminCatalogsGetAllBannersDocument, options)
}
export type AdminCatalogsGetAllBannersQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetAllBannersQuery
>
export type AdminCatalogsGetAllBannersLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetAllBannersLazyQuery
>
export type AdminCatalogsGetAllBannersQueryResult = Apollo.QueryResult<
  AdminCatalogsGetAllBannersQuery,
  AdminCatalogsGetAllBannersQueryVariables
>
export function refetchAdminCatalogsGetAllBannersQuery(
  variables?: AdminCatalogsGetAllBannersQueryVariables,
) {
  return { query: AdminCatalogsGetAllBannersDocument, variables: variables }
}
export const AdminCatalogsGetAllStoresDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetAllStores($search: String, $cursor: String) {
    allStores(input: { search: $search, cursor: $cursor }) {
      nodes {
        id
        name
        banner {
          id
          imageURL
        }
      }
      hasMore
      cursor
      totalCount
    }
  }
`

/**
 * __useAdminCatalogsGetAllStoresQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetAllStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetAllStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetAllStoresQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAdminCatalogsGetAllStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminCatalogsGetAllStoresQuery,
    AdminCatalogsGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetAllStoresQuery,
    AdminCatalogsGetAllStoresQueryVariables
  >(AdminCatalogsGetAllStoresDocument, options)
}
export function useAdminCatalogsGetAllStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetAllStoresQuery,
    AdminCatalogsGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetAllStoresQuery,
    AdminCatalogsGetAllStoresQueryVariables
  >(AdminCatalogsGetAllStoresDocument, options)
}
export type AdminCatalogsGetAllStoresQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetAllStoresQuery
>
export type AdminCatalogsGetAllStoresLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetAllStoresLazyQuery
>
export type AdminCatalogsGetAllStoresQueryResult = Apollo.QueryResult<
  AdminCatalogsGetAllStoresQuery,
  AdminCatalogsGetAllStoresQueryVariables
>
export function refetchAdminCatalogsGetAllStoresQuery(
  variables?: AdminCatalogsGetAllStoresQueryVariables,
) {
  return { query: AdminCatalogsGetAllStoresDocument, variables: variables }
}
export const AdminCatalogsGetAllVendorsDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetAllVendors($search: String, $cursor: String) {
    allVendors(input: { search: $search, cursor: $cursor }) {
      nodes {
        id
        name
        imgURL
      }
      hasMore
      cursor
      totalCount
    }
  }
`

/**
 * __useAdminCatalogsGetAllVendorsQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetAllVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetAllVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetAllVendorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAdminCatalogsGetAllVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminCatalogsGetAllVendorsQuery,
    AdminCatalogsGetAllVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetAllVendorsQuery,
    AdminCatalogsGetAllVendorsQueryVariables
  >(AdminCatalogsGetAllVendorsDocument, options)
}
export function useAdminCatalogsGetAllVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetAllVendorsQuery,
    AdminCatalogsGetAllVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetAllVendorsQuery,
    AdminCatalogsGetAllVendorsQueryVariables
  >(AdminCatalogsGetAllVendorsDocument, options)
}
export type AdminCatalogsGetAllVendorsQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetAllVendorsQuery
>
export type AdminCatalogsGetAllVendorsLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetAllVendorsLazyQuery
>
export type AdminCatalogsGetAllVendorsQueryResult = Apollo.QueryResult<
  AdminCatalogsGetAllVendorsQuery,
  AdminCatalogsGetAllVendorsQueryVariables
>
export function refetchAdminCatalogsGetAllVendorsQuery(
  variables?: AdminCatalogsGetAllVendorsQueryVariables,
) {
  return { query: AdminCatalogsGetAllVendorsDocument, variables: variables }
}
export const AdminCatalogsGetUsersForOgSelectDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetUsersForOGSelect($storeID: String, $vendorID: String) {
    retailUsers: adminAllUsers(
      input: { companyID: $storeID, userTypeFilter: [BUYER, STORE_ADMIN] }
    ) {
      nodes {
        id
        displayName
        email
        userType
      }
      totalCount
    }
    vendorUsers: adminAllUsers(
      input: { companyID: $vendorID, userTypeFilter: [SALES_REP] }
    ) {
      nodes {
        id
        displayName
        email
        userType
      }
      totalCount
    }
  }
`

/**
 * __useAdminCatalogsGetUsersForOgSelectQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetUsersForOgSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetUsersForOgSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetUsersForOgSelectQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useAdminCatalogsGetUsersForOgSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminCatalogsGetUsersForOgSelectQuery,
    AdminCatalogsGetUsersForOgSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetUsersForOgSelectQuery,
    AdminCatalogsGetUsersForOgSelectQueryVariables
  >(AdminCatalogsGetUsersForOgSelectDocument, options)
}
export function useAdminCatalogsGetUsersForOgSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetUsersForOgSelectQuery,
    AdminCatalogsGetUsersForOgSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetUsersForOgSelectQuery,
    AdminCatalogsGetUsersForOgSelectQueryVariables
  >(AdminCatalogsGetUsersForOgSelectDocument, options)
}
export type AdminCatalogsGetUsersForOgSelectQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetUsersForOgSelectQuery
>
export type AdminCatalogsGetUsersForOgSelectLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetUsersForOgSelectLazyQuery
>
export type AdminCatalogsGetUsersForOgSelectQueryResult = Apollo.QueryResult<
  AdminCatalogsGetUsersForOgSelectQuery,
  AdminCatalogsGetUsersForOgSelectQueryVariables
>
export function refetchAdminCatalogsGetUsersForOgSelectQuery(
  variables?: AdminCatalogsGetUsersForOgSelectQueryVariables,
) {
  return {
    query: AdminCatalogsGetUsersForOgSelectDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetVendorsByIdDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetVendorsByID($ids: [ID!]!) {
    adminVendorsByID(ids: $ids) {
      nodes {
        id
        name
      }
    }
  }
`

/**
 * __useAdminCatalogsGetVendorsByIdQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetVendorsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetVendorsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetVendorsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAdminCatalogsGetVendorsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetVendorsByIdQuery,
    AdminCatalogsGetVendorsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetVendorsByIdQuery,
    AdminCatalogsGetVendorsByIdQueryVariables
  >(AdminCatalogsGetVendorsByIdDocument, options)
}
export function useAdminCatalogsGetVendorsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetVendorsByIdQuery,
    AdminCatalogsGetVendorsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetVendorsByIdQuery,
    AdminCatalogsGetVendorsByIdQueryVariables
  >(AdminCatalogsGetVendorsByIdDocument, options)
}
export type AdminCatalogsGetVendorsByIdQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetVendorsByIdQuery
>
export type AdminCatalogsGetVendorsByIdLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetVendorsByIdLazyQuery
>
export type AdminCatalogsGetVendorsByIdQueryResult = Apollo.QueryResult<
  AdminCatalogsGetVendorsByIdQuery,
  AdminCatalogsGetVendorsByIdQueryVariables
>
export function refetchAdminCatalogsGetVendorsByIdQuery(
  variables: AdminCatalogsGetVendorsByIdQueryVariables,
) {
  return { query: AdminCatalogsGetVendorsByIdDocument, variables: variables }
}
export const AdminCatalogsGetStoreDepartmentsAndUsersDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetStoreDepartmentsAndUsers(
    $storeID: ID!
    $includeInactiveVSDAs: Boolean
  ) {
    storeByID(id: $storeID) {
      retailUsers {
        nodes {
          user {
            id
            displayName
            email
            storeDepartments(input: { filterByStoreID: $storeID }) {
              nodes {
                id
                name
              }
            }
          }
        }
      }
      storeDepartments {
        nodes {
          id
          name
          vendorStoreDepartmentAccounts(
            input: { includeInactive: $includeInactiveVSDAs }
          ) {
            nodes {
              id
              name
              vendor {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetStoreDepartmentsAndUsersQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetStoreDepartmentsAndUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetStoreDepartmentsAndUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetStoreDepartmentsAndUsersQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      includeInactiveVSDAs: // value for 'includeInactiveVSDAs'
 *   },
 * });
 */
export function useAdminCatalogsGetStoreDepartmentsAndUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables
  >(AdminCatalogsGetStoreDepartmentsAndUsersDocument, options)
}
export function useAdminCatalogsGetStoreDepartmentsAndUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables
  >(AdminCatalogsGetStoreDepartmentsAndUsersDocument, options)
}
export type AdminCatalogsGetStoreDepartmentsAndUsersQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetStoreDepartmentsAndUsersQuery>
export type AdminCatalogsGetStoreDepartmentsAndUsersLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetStoreDepartmentsAndUsersLazyQuery>
export type AdminCatalogsGetStoreDepartmentsAndUsersQueryResult =
  Apollo.QueryResult<
    AdminCatalogsGetStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables
  >
export function refetchAdminCatalogsGetStoreDepartmentsAndUsersQuery(
  variables: AdminCatalogsGetStoreDepartmentsAndUsersQueryVariables,
) {
  return {
    query: AdminCatalogsGetStoreDepartmentsAndUsersDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetBannerStoreDepartmentsAndUsersDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetBannerStoreDepartmentsAndUsers(
    $bannerID: ID!
    $includeInactiveVSDAs: Boolean
  ) {
    bannerByID(id: $bannerID) {
      stores {
        nodes {
          id
          name
          retailUsers {
            nodes {
              user {
                id
                displayName
                email
                storeDepartments {
                  nodes {
                    id
                    name
                  }
                }
              }
            }
          }
          storeDepartments {
            nodes {
              id
              name
              vendorStoreDepartmentAccounts(
                input: { includeInactive: $includeInactiveVSDAs }
              ) {
                nodes {
                  id
                  name
                  vendor {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      includeInactiveVSDAs: // value for 'includeInactiveVSDAs'
 *   },
 * });
 */
export function useAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables
  >(AdminCatalogsGetBannerStoreDepartmentsAndUsersDocument, options)
}
export function useAdminCatalogsGetBannerStoreDepartmentsAndUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables
  >(AdminCatalogsGetBannerStoreDepartmentsAndUsersDocument, options)
}
export type AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery>
export type AdminCatalogsGetBannerStoreDepartmentsAndUsersLazyQueryHookResult =
  ReturnType<typeof useAdminCatalogsGetBannerStoreDepartmentsAndUsersLazyQuery>
export type AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryResult =
  Apollo.QueryResult<
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQuery,
    AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables
  >
export function refetchAdminCatalogsGetBannerStoreDepartmentsAndUsersQuery(
  variables: AdminCatalogsGetBannerStoreDepartmentsAndUsersQueryVariables,
) {
  return {
    query: AdminCatalogsGetBannerStoreDepartmentsAndUsersDocument,
    variables: variables,
  }
}
export const AdminCatalogsGetStoreVsdAsDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetStoreVSDAs($storeID: ID!) {
    storeByID(id: $storeID) {
      vendorStoreDepartmentAccounts {
        nodes {
          id
          name
          vendor {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetStoreVsdAsQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetStoreVsdAsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetStoreVsdAsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetStoreVsdAsQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useAdminCatalogsGetStoreVsdAsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetStoreVsdAsQuery,
    AdminCatalogsGetStoreVsdAsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetStoreVsdAsQuery,
    AdminCatalogsGetStoreVsdAsQueryVariables
  >(AdminCatalogsGetStoreVsdAsDocument, options)
}
export function useAdminCatalogsGetStoreVsdAsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetStoreVsdAsQuery,
    AdminCatalogsGetStoreVsdAsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetStoreVsdAsQuery,
    AdminCatalogsGetStoreVsdAsQueryVariables
  >(AdminCatalogsGetStoreVsdAsDocument, options)
}
export type AdminCatalogsGetStoreVsdAsQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetStoreVsdAsQuery
>
export type AdminCatalogsGetStoreVsdAsLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetStoreVsdAsLazyQuery
>
export type AdminCatalogsGetStoreVsdAsQueryResult = Apollo.QueryResult<
  AdminCatalogsGetStoreVsdAsQuery,
  AdminCatalogsGetStoreVsdAsQueryVariables
>
export function refetchAdminCatalogsGetStoreVsdAsQuery(
  variables: AdminCatalogsGetStoreVsdAsQueryVariables,
) {
  return { query: AdminCatalogsGetStoreVsdAsDocument, variables: variables }
}
export const AdminCatalogsGetBannerVsdAsDocument = /*#__PURE__*/ gql`
  query AdminCatalogs_GetBannerVSDAs($bannerID: ID!) {
    bannerByID(id: $bannerID) {
      vendorStoreDepartmentAccounts {
        nodes {
          id
          name
          vendor {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useAdminCatalogsGetBannerVsdAsQuery__
 *
 * To run a query within a React component, call `useAdminCatalogsGetBannerVsdAsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCatalogsGetBannerVsdAsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCatalogsGetBannerVsdAsQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *   },
 * });
 */
export function useAdminCatalogsGetBannerVsdAsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminCatalogsGetBannerVsdAsQuery,
    AdminCatalogsGetBannerVsdAsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminCatalogsGetBannerVsdAsQuery,
    AdminCatalogsGetBannerVsdAsQueryVariables
  >(AdminCatalogsGetBannerVsdAsDocument, options)
}
export function useAdminCatalogsGetBannerVsdAsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminCatalogsGetBannerVsdAsQuery,
    AdminCatalogsGetBannerVsdAsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminCatalogsGetBannerVsdAsQuery,
    AdminCatalogsGetBannerVsdAsQueryVariables
  >(AdminCatalogsGetBannerVsdAsDocument, options)
}
export type AdminCatalogsGetBannerVsdAsQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetBannerVsdAsQuery
>
export type AdminCatalogsGetBannerVsdAsLazyQueryHookResult = ReturnType<
  typeof useAdminCatalogsGetBannerVsdAsLazyQuery
>
export type AdminCatalogsGetBannerVsdAsQueryResult = Apollo.QueryResult<
  AdminCatalogsGetBannerVsdAsQuery,
  AdminCatalogsGetBannerVsdAsQueryVariables
>
export function refetchAdminCatalogsGetBannerVsdAsQuery(
  variables: AdminCatalogsGetBannerVsdAsQueryVariables,
) {
  return { query: AdminCatalogsGetBannerVsdAsDocument, variables: variables }
}
export const AdminEslUploadSendEslFileUpdateDocument = /*#__PURE__*/ gql`
  mutation AdminESLUpload_SendESLFileUpdate(
    $file: Upload!
    $type: ESLType!
    $storeIDs: [String!]!
  ) {
    sendESLFileUpdate(
      input: { file: $file, type: $type, storeIDs: $storeIDs }
    ) {
      status
      statusMessage
    }
  }
`
export type AdminEslUploadSendEslFileUpdateMutationFn = Apollo.MutationFunction<
  AdminEslUploadSendEslFileUpdateMutation,
  AdminEslUploadSendEslFileUpdateMutationVariables
>

/**
 * __useAdminEslUploadSendEslFileUpdateMutation__
 *
 * To run a mutation, you first call `useAdminEslUploadSendEslFileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEslUploadSendEslFileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEslUploadSendEslFileUpdateMutation, { data, loading, error }] = useAdminEslUploadSendEslFileUpdateMutation({
 *   variables: {
 *      file: // value for 'file'
 *      type: // value for 'type'
 *      storeIDs: // value for 'storeIDs'
 *   },
 * });
 */
export function useAdminEslUploadSendEslFileUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminEslUploadSendEslFileUpdateMutation,
    AdminEslUploadSendEslFileUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminEslUploadSendEslFileUpdateMutation,
    AdminEslUploadSendEslFileUpdateMutationVariables
  >(AdminEslUploadSendEslFileUpdateDocument, options)
}
export type AdminEslUploadSendEslFileUpdateMutationHookResult = ReturnType<
  typeof useAdminEslUploadSendEslFileUpdateMutation
>
export type AdminEslUploadSendEslFileUpdateMutationResult =
  Apollo.MutationResult<AdminEslUploadSendEslFileUpdateMutation>
export type AdminEslUploadSendEslFileUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    AdminEslUploadSendEslFileUpdateMutation,
    AdminEslUploadSendEslFileUpdateMutationVariables
  >
export const AdminContainerCreateUserDocument = /*#__PURE__*/ gql`
  mutation AdminContainer_CreateUser(
    $email: String!
    $password: String!
    $userType: UserType!
    $displayName: String
    $phoneNumber: String
    $companyID: String
    $defaultDepartmentName: String
    $readOnlyOrderGuides: Boolean
  ) {
    createUser(
      input: {
        email: $email
        password: $password
        displayName: $displayName
        phoneNumber: $phoneNumber
        userType: $userType
        companyID: $companyID
        defaultDepartmentName: $defaultDepartmentName
        readOnlyOrderGuides: $readOnlyOrderGuides
      }
    ) {
      ...AdminContainer_UserDetails
    }
  }
  ${AdminContainerUserDetailsFragmentDoc}
`
export type AdminContainerCreateUserMutationFn = Apollo.MutationFunction<
  AdminContainerCreateUserMutation,
  AdminContainerCreateUserMutationVariables
>

/**
 * __useAdminContainerCreateUserMutation__
 *
 * To run a mutation, you first call `useAdminContainerCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminContainerCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminContainerCreateUserMutation, { data, loading, error }] = useAdminContainerCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      userType: // value for 'userType'
 *      displayName: // value for 'displayName'
 *      phoneNumber: // value for 'phoneNumber'
 *      companyID: // value for 'companyID'
 *      defaultDepartmentName: // value for 'defaultDepartmentName'
 *      readOnlyOrderGuides: // value for 'readOnlyOrderGuides'
 *   },
 * });
 */
export function useAdminContainerCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminContainerCreateUserMutation,
    AdminContainerCreateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminContainerCreateUserMutation,
    AdminContainerCreateUserMutationVariables
  >(AdminContainerCreateUserDocument, options)
}
export type AdminContainerCreateUserMutationHookResult = ReturnType<
  typeof useAdminContainerCreateUserMutation
>
export type AdminContainerCreateUserMutationResult =
  Apollo.MutationResult<AdminContainerCreateUserMutation>
export type AdminContainerCreateUserMutationOptions =
  Apollo.BaseMutationOptions<
    AdminContainerCreateUserMutation,
    AdminContainerCreateUserMutationVariables
  >
export const AdminContainerUpdateUserDocument = /*#__PURE__*/ gql`
  mutation AdminContainer_UpdateUser(
    $id: ID!
    $email: String!
    $userType: UserType!
    $displayName: String
    $phoneNumber: String
    $companyID: String
    $defaultDepartmentName: String
    $readOnlyOrderGuides: Boolean
  ) {
    updateUser(
      input: {
        id: $id
        email: $email
        displayName: $displayName
        phoneNumber: $phoneNumber
        userType: $userType
        companyID: $companyID
        defaultDepartmentName: $defaultDepartmentName
        readOnlyOrderGuides: $readOnlyOrderGuides
      }
    ) {
      ...AdminContainer_UserDetails
    }
  }
  ${AdminContainerUserDetailsFragmentDoc}
`
export type AdminContainerUpdateUserMutationFn = Apollo.MutationFunction<
  AdminContainerUpdateUserMutation,
  AdminContainerUpdateUserMutationVariables
>

/**
 * __useAdminContainerUpdateUserMutation__
 *
 * To run a mutation, you first call `useAdminContainerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminContainerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminContainerUpdateUserMutation, { data, loading, error }] = useAdminContainerUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      userType: // value for 'userType'
 *      displayName: // value for 'displayName'
 *      phoneNumber: // value for 'phoneNumber'
 *      companyID: // value for 'companyID'
 *      defaultDepartmentName: // value for 'defaultDepartmentName'
 *      readOnlyOrderGuides: // value for 'readOnlyOrderGuides'
 *   },
 * });
 */
export function useAdminContainerUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminContainerUpdateUserMutation,
    AdminContainerUpdateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminContainerUpdateUserMutation,
    AdminContainerUpdateUserMutationVariables
  >(AdminContainerUpdateUserDocument, options)
}
export type AdminContainerUpdateUserMutationHookResult = ReturnType<
  typeof useAdminContainerUpdateUserMutation
>
export type AdminContainerUpdateUserMutationResult =
  Apollo.MutationResult<AdminContainerUpdateUserMutation>
export type AdminContainerUpdateUserMutationOptions =
  Apollo.BaseMutationOptions<
    AdminContainerUpdateUserMutation,
    AdminContainerUpdateUserMutationVariables
  >
export const AdminContainerDeleteUserDocument = /*#__PURE__*/ gql`
  mutation AdminContainer_DeleteUser($id: ID!) {
    deleteUser(input: { id: $id }) {
      deletedUserID
    }
  }
`
export type AdminContainerDeleteUserMutationFn = Apollo.MutationFunction<
  AdminContainerDeleteUserMutation,
  AdminContainerDeleteUserMutationVariables
>

/**
 * __useAdminContainerDeleteUserMutation__
 *
 * To run a mutation, you first call `useAdminContainerDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminContainerDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminContainerDeleteUserMutation, { data, loading, error }] = useAdminContainerDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminContainerDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminContainerDeleteUserMutation,
    AdminContainerDeleteUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminContainerDeleteUserMutation,
    AdminContainerDeleteUserMutationVariables
  >(AdminContainerDeleteUserDocument, options)
}
export type AdminContainerDeleteUserMutationHookResult = ReturnType<
  typeof useAdminContainerDeleteUserMutation
>
export type AdminContainerDeleteUserMutationResult =
  Apollo.MutationResult<AdminContainerDeleteUserMutation>
export type AdminContainerDeleteUserMutationOptions =
  Apollo.BaseMutationOptions<
    AdminContainerDeleteUserMutation,
    AdminContainerDeleteUserMutationVariables
  >
export const AdminContainerGetPaginatedUsersDocument = /*#__PURE__*/ gql`
  query AdminContainer_GetPaginatedUsers(
    $cursor: ID
    $filter: AdminUsersPaginatedFilters
  ) {
    adminUsersPaginated(input: { cursor: $cursor, filter: $filter }) {
      nodes {
        ...AdminContainer_UserDetails
      }
      totalCount
      cursor
      hasMore
    }
  }
  ${AdminContainerUserDetailsFragmentDoc}
`

/**
 * __useAdminContainerGetPaginatedUsersQuery__
 *
 * To run a query within a React component, call `useAdminContainerGetPaginatedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminContainerGetPaginatedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContainerGetPaginatedUsersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminContainerGetPaginatedUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminContainerGetPaginatedUsersQuery,
    AdminContainerGetPaginatedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminContainerGetPaginatedUsersQuery,
    AdminContainerGetPaginatedUsersQueryVariables
  >(AdminContainerGetPaginatedUsersDocument, options)
}
export function useAdminContainerGetPaginatedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminContainerGetPaginatedUsersQuery,
    AdminContainerGetPaginatedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminContainerGetPaginatedUsersQuery,
    AdminContainerGetPaginatedUsersQueryVariables
  >(AdminContainerGetPaginatedUsersDocument, options)
}
export type AdminContainerGetPaginatedUsersQueryHookResult = ReturnType<
  typeof useAdminContainerGetPaginatedUsersQuery
>
export type AdminContainerGetPaginatedUsersLazyQueryHookResult = ReturnType<
  typeof useAdminContainerGetPaginatedUsersLazyQuery
>
export type AdminContainerGetPaginatedUsersQueryResult = Apollo.QueryResult<
  AdminContainerGetPaginatedUsersQuery,
  AdminContainerGetPaginatedUsersQueryVariables
>
export function refetchAdminContainerGetPaginatedUsersQuery(
  variables?: AdminContainerGetPaginatedUsersQueryVariables,
) {
  return {
    query: AdminContainerGetPaginatedUsersDocument,
    variables: variables,
  }
}
export const AdminContainerGetUserByIdDocument = /*#__PURE__*/ gql`
  query AdminContainer_GetUserByID($userID: ID!) {
    userByID(id: $userID) {
      ...AdminContainer_UserDetails
    }
  }
  ${AdminContainerUserDetailsFragmentDoc}
`

/**
 * __useAdminContainerGetUserByIdQuery__
 *
 * To run a query within a React component, call `useAdminContainerGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminContainerGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminContainerGetUserByIdQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useAdminContainerGetUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminContainerGetUserByIdQuery,
    AdminContainerGetUserByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminContainerGetUserByIdQuery,
    AdminContainerGetUserByIdQueryVariables
  >(AdminContainerGetUserByIdDocument, options)
}
export function useAdminContainerGetUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminContainerGetUserByIdQuery,
    AdminContainerGetUserByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminContainerGetUserByIdQuery,
    AdminContainerGetUserByIdQueryVariables
  >(AdminContainerGetUserByIdDocument, options)
}
export type AdminContainerGetUserByIdQueryHookResult = ReturnType<
  typeof useAdminContainerGetUserByIdQuery
>
export type AdminContainerGetUserByIdLazyQueryHookResult = ReturnType<
  typeof useAdminContainerGetUserByIdLazyQuery
>
export type AdminContainerGetUserByIdQueryResult = Apollo.QueryResult<
  AdminContainerGetUserByIdQuery,
  AdminContainerGetUserByIdQueryVariables
>
export function refetchAdminContainerGetUserByIdQuery(
  variables: AdminContainerGetUserByIdQueryVariables,
) {
  return { query: AdminContainerGetUserByIdDocument, variables: variables }
}
export const AdminStoresGetAllStoresDocument = /*#__PURE__*/ gql`
  query AdminStores_GetAllStores($cursor: String, $query: String) {
    allStores(input: { cursor: $cursor, search: $query, limit: 30 }) {
      nodes {
        id
        name
        address
        emails
        placeID
        storeType
        serialID
        banner {
          id
          name
        }
        bannerStoreID
        userCount
        vendorCount
      }
      hasMore
      totalCount
      cursor
    }
  }
`

/**
 * __useAdminStoresGetAllStoresQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetAllStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetAllStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetAllStoresQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAdminStoresGetAllStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminStoresGetAllStoresQuery,
    AdminStoresGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetAllStoresQuery,
    AdminStoresGetAllStoresQueryVariables
  >(AdminStoresGetAllStoresDocument, options)
}
export function useAdminStoresGetAllStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetAllStoresQuery,
    AdminStoresGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetAllStoresQuery,
    AdminStoresGetAllStoresQueryVariables
  >(AdminStoresGetAllStoresDocument, options)
}
export type AdminStoresGetAllStoresQueryHookResult = ReturnType<
  typeof useAdminStoresGetAllStoresQuery
>
export type AdminStoresGetAllStoresLazyQueryHookResult = ReturnType<
  typeof useAdminStoresGetAllStoresLazyQuery
>
export type AdminStoresGetAllStoresQueryResult = Apollo.QueryResult<
  AdminStoresGetAllStoresQuery,
  AdminStoresGetAllStoresQueryVariables
>
export function refetchAdminStoresGetAllStoresQuery(
  variables?: AdminStoresGetAllStoresQueryVariables,
) {
  return { query: AdminStoresGetAllStoresDocument, variables: variables }
}
export const AdminInvitationsSendVendorInvitationDocument = /*#__PURE__*/ gql`
  mutation AdminInvitations_SendVendorInvitation(
    $vendorID: ID!
    $invitedByStoreID: ID!
    $invitedByUserID: ID!
    $email: String!
  ) {
    sendVendorInvitation(
      input: {
        vendorID: $vendorID
        invitedByStoreID: $invitedByStoreID
        invitedByUserID: $invitedByUserID
        email: $email
      }
    ) {
      id
      email
      status
      invitedByStore {
        id
        name
      }
      invitedByUser {
        id
        displayName
        email
      }
      vendor {
        id
        name
      }
    }
  }
`
export type AdminInvitationsSendVendorInvitationMutationFn =
  Apollo.MutationFunction<
    AdminInvitationsSendVendorInvitationMutation,
    AdminInvitationsSendVendorInvitationMutationVariables
  >

/**
 * __useAdminInvitationsSendVendorInvitationMutation__
 *
 * To run a mutation, you first call `useAdminInvitationsSendVendorInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInvitationsSendVendorInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInvitationsSendVendorInvitationMutation, { data, loading, error }] = useAdminInvitationsSendVendorInvitationMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      invitedByStoreID: // value for 'invitedByStoreID'
 *      invitedByUserID: // value for 'invitedByUserID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAdminInvitationsSendVendorInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminInvitationsSendVendorInvitationMutation,
    AdminInvitationsSendVendorInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminInvitationsSendVendorInvitationMutation,
    AdminInvitationsSendVendorInvitationMutationVariables
  >(AdminInvitationsSendVendorInvitationDocument, options)
}
export type AdminInvitationsSendVendorInvitationMutationHookResult = ReturnType<
  typeof useAdminInvitationsSendVendorInvitationMutation
>
export type AdminInvitationsSendVendorInvitationMutationResult =
  Apollo.MutationResult<AdminInvitationsSendVendorInvitationMutation>
export type AdminInvitationsSendVendorInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    AdminInvitationsSendVendorInvitationMutation,
    AdminInvitationsSendVendorInvitationMutationVariables
  >
export const AdminInvitationsGetStoreInvitationsDocument = /*#__PURE__*/ gql`
  query AdminInvitations_GetStoreInvitations(
    $cursor: ID
    $vendorID: ID
    $storeID: ID
    $status: InvitationStatus
    $email: String
    $signedUpEmail: String
    $invitedByUserEmail: String
  ) {
    adminStoreInvitations(
      input: {
        cursor: $cursor
        vendorID: $vendorID
        storeID: $storeID
        status: $status
        email: $email
        signedUpEmail: $signedUpEmail
        invitedByUserEmail: $invitedByUserEmail
      }
    ) {
      nodes {
        id
        email
        status
        store {
          id
          name
        }
        signedUpEmail
        lastOrderPlaced {
          id
          totalPrice
          orderDateTime
        }
        invitedByUser {
          id
          email
          userType
        }
        invitedByVendor {
          id
          name
          email
        }
      }
      totalCount
      cursor
      hasMore
    }
  }
`

/**
 * __useAdminInvitationsGetStoreInvitationsQuery__
 *
 * To run a query within a React component, call `useAdminInvitationsGetStoreInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminInvitationsGetStoreInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminInvitationsGetStoreInvitationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      vendorID: // value for 'vendorID'
 *      storeID: // value for 'storeID'
 *      status: // value for 'status'
 *      email: // value for 'email'
 *      signedUpEmail: // value for 'signedUpEmail'
 *      invitedByUserEmail: // value for 'invitedByUserEmail'
 *   },
 * });
 */
export function useAdminInvitationsGetStoreInvitationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminInvitationsGetStoreInvitationsQuery,
    AdminInvitationsGetStoreInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminInvitationsGetStoreInvitationsQuery,
    AdminInvitationsGetStoreInvitationsQueryVariables
  >(AdminInvitationsGetStoreInvitationsDocument, options)
}
export function useAdminInvitationsGetStoreInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminInvitationsGetStoreInvitationsQuery,
    AdminInvitationsGetStoreInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminInvitationsGetStoreInvitationsQuery,
    AdminInvitationsGetStoreInvitationsQueryVariables
  >(AdminInvitationsGetStoreInvitationsDocument, options)
}
export type AdminInvitationsGetStoreInvitationsQueryHookResult = ReturnType<
  typeof useAdminInvitationsGetStoreInvitationsQuery
>
export type AdminInvitationsGetStoreInvitationsLazyQueryHookResult = ReturnType<
  typeof useAdminInvitationsGetStoreInvitationsLazyQuery
>
export type AdminInvitationsGetStoreInvitationsQueryResult = Apollo.QueryResult<
  AdminInvitationsGetStoreInvitationsQuery,
  AdminInvitationsGetStoreInvitationsQueryVariables
>
export function refetchAdminInvitationsGetStoreInvitationsQuery(
  variables?: AdminInvitationsGetStoreInvitationsQueryVariables,
) {
  return {
    query: AdminInvitationsGetStoreInvitationsDocument,
    variables: variables,
  }
}
export const AdminInvitationsGetVendorInvitationsDocument = /*#__PURE__*/ gql`
  query AdminInvitations_GetVendorInvitations(
    $cursor: ID
    $vendorID: ID
    $storeID: ID
    $status: InvitationStatus
    $invitedByUserEmail: String
    $inviteEmail: String
  ) {
    adminVendorInvitations(
      input: {
        cursor: $cursor
        vendorID: $vendorID
        storeID: $storeID
        status: $status
        invitedByUserEmail: $invitedByUserEmail
        inviteEmail: $inviteEmail
      }
    ) {
      nodes {
        id
        status
        invitedByStore {
          id
          name
          emails
        }
        email
        invitedByUser {
          id
          email
          userType
        }
        vendor {
          id
          name
        }
      }
      totalCount
      cursor
      hasMore
    }
  }
`

/**
 * __useAdminInvitationsGetVendorInvitationsQuery__
 *
 * To run a query within a React component, call `useAdminInvitationsGetVendorInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminInvitationsGetVendorInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminInvitationsGetVendorInvitationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      vendorID: // value for 'vendorID'
 *      storeID: // value for 'storeID'
 *      status: // value for 'status'
 *      invitedByUserEmail: // value for 'invitedByUserEmail'
 *      inviteEmail: // value for 'inviteEmail'
 *   },
 * });
 */
export function useAdminInvitationsGetVendorInvitationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminInvitationsGetVendorInvitationsQuery,
    AdminInvitationsGetVendorInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminInvitationsGetVendorInvitationsQuery,
    AdminInvitationsGetVendorInvitationsQueryVariables
  >(AdminInvitationsGetVendorInvitationsDocument, options)
}
export function useAdminInvitationsGetVendorInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminInvitationsGetVendorInvitationsQuery,
    AdminInvitationsGetVendorInvitationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminInvitationsGetVendorInvitationsQuery,
    AdminInvitationsGetVendorInvitationsQueryVariables
  >(AdminInvitationsGetVendorInvitationsDocument, options)
}
export type AdminInvitationsGetVendorInvitationsQueryHookResult = ReturnType<
  typeof useAdminInvitationsGetVendorInvitationsQuery
>
export type AdminInvitationsGetVendorInvitationsLazyQueryHookResult =
  ReturnType<typeof useAdminInvitationsGetVendorInvitationsLazyQuery>
export type AdminInvitationsGetVendorInvitationsQueryResult =
  Apollo.QueryResult<
    AdminInvitationsGetVendorInvitationsQuery,
    AdminInvitationsGetVendorInvitationsQueryVariables
  >
export function refetchAdminInvitationsGetVendorInvitationsQuery(
  variables?: AdminInvitationsGetVendorInvitationsQueryVariables,
) {
  return {
    query: AdminInvitationsGetVendorInvitationsDocument,
    variables: variables,
  }
}
export const AdminStoresUpdateStoreDocument = /*#__PURE__*/ gql`
  mutation AdminStores_UpdateStore(
    $id: ID!
    $name: String
    $emails: [String!]
    $address: String
    $placeID: String
    $bannerID: String
    $bannerStoreID: String
    $storeType: StoreType
    $vendorIDs: [String!]
    $acquisitionSource: AcquisitionSource
    $acquisitionDetail: String
    $referredByCompanyID: ID
    $supportsWic: Boolean
  ) {
    updateStore(
      input: {
        id: $id
        name: $name
        emails: $emails
        address: $address
        placeID: $placeID
        bannerID: $bannerID
        bannerStoreID: $bannerStoreID
        storeType: $storeType
        vendorIDs: $vendorIDs
        acquisitionSource: $acquisitionSource
        acquisitionDetail: $acquisitionDetail
        referredByCompanyID: $referredByCompanyID
        supportsWic: $supportsWic
      }
    ) {
      ...AdminStores_StoreDetailsFields
    }
  }
  ${AdminStoresStoreDetailsFieldsFragmentDoc}
`
export type AdminStoresUpdateStoreMutationFn = Apollo.MutationFunction<
  AdminStoresUpdateStoreMutation,
  AdminStoresUpdateStoreMutationVariables
>

/**
 * __useAdminStoresUpdateStoreMutation__
 *
 * To run a mutation, you first call `useAdminStoresUpdateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresUpdateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresUpdateStoreMutation, { data, loading, error }] = useAdminStoresUpdateStoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      emails: // value for 'emails'
 *      address: // value for 'address'
 *      placeID: // value for 'placeID'
 *      bannerID: // value for 'bannerID'
 *      bannerStoreID: // value for 'bannerStoreID'
 *      storeType: // value for 'storeType'
 *      vendorIDs: // value for 'vendorIDs'
 *      acquisitionSource: // value for 'acquisitionSource'
 *      acquisitionDetail: // value for 'acquisitionDetail'
 *      referredByCompanyID: // value for 'referredByCompanyID'
 *      supportsWic: // value for 'supportsWic'
 *   },
 * });
 */
export function useAdminStoresUpdateStoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresUpdateStoreMutation,
    AdminStoresUpdateStoreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresUpdateStoreMutation,
    AdminStoresUpdateStoreMutationVariables
  >(AdminStoresUpdateStoreDocument, options)
}
export type AdminStoresUpdateStoreMutationHookResult = ReturnType<
  typeof useAdminStoresUpdateStoreMutation
>
export type AdminStoresUpdateStoreMutationResult =
  Apollo.MutationResult<AdminStoresUpdateStoreMutation>
export type AdminStoresUpdateStoreMutationOptions = Apollo.BaseMutationOptions<
  AdminStoresUpdateStoreMutation,
  AdminStoresUpdateStoreMutationVariables
>
export const AdminStoresUpdateVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation AdminStores_UpdateVendorStoreDepartmentAccount(
    $accountNumber: String
    $dunsNumber: String
    $defaultUnitOfMeasure: UnitOfMeasure
    $orderSubmissionUOMLock: UOMLock
    $id: ID!
    $name: String
    $orderDeadline: String
    $orderSubmissionMethod: SubmissionMethod
    $status: VendorStoreDepartmentAccountStatus
    $storeEmails: [StoreEmailInput!]
    $vendorEmails: [VendorEmailInput!]
  ) {
    updateVendorStoreDepartmentAccount(
      id: $id
      input: {
        accountNumber: $accountNumber
        dunsNumber: $dunsNumber
        defaultUnitOfMeasure: $defaultUnitOfMeasure
        name: $name
        orderDeadline: $orderDeadline
        orderSubmissionMethod: $orderSubmissionMethod
        storeEmails: $storeEmails
        vendorEmails: $vendorEmails
        status: $status
        orderSubmissionUOMLock: $orderSubmissionUOMLock
      }
    ) {
      ...AdminStores_VendorStoreDepartmentAccountDetails
    }
  }
  ${AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc}
`
export type AdminStoresUpdateVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    AdminStoresUpdateVendorStoreDepartmentAccountMutation,
    AdminStoresUpdateVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useAdminStoresUpdateVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useAdminStoresUpdateVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresUpdateVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresUpdateVendorStoreDepartmentAccountMutation, { data, loading, error }] = useAdminStoresUpdateVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *      dunsNumber: // value for 'dunsNumber'
 *      defaultUnitOfMeasure: // value for 'defaultUnitOfMeasure'
 *      orderSubmissionUOMLock: // value for 'orderSubmissionUOMLock'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      orderDeadline: // value for 'orderDeadline'
 *      orderSubmissionMethod: // value for 'orderSubmissionMethod'
 *      status: // value for 'status'
 *      storeEmails: // value for 'storeEmails'
 *      vendorEmails: // value for 'vendorEmails'
 *   },
 * });
 */
export function useAdminStoresUpdateVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresUpdateVendorStoreDepartmentAccountMutation,
    AdminStoresUpdateVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresUpdateVendorStoreDepartmentAccountMutation,
    AdminStoresUpdateVendorStoreDepartmentAccountMutationVariables
  >(AdminStoresUpdateVendorStoreDepartmentAccountDocument, options)
}
export type AdminStoresUpdateVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<typeof useAdminStoresUpdateVendorStoreDepartmentAccountMutation>
export type AdminStoresUpdateVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<AdminStoresUpdateVendorStoreDepartmentAccountMutation>
export type AdminStoresUpdateVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    AdminStoresUpdateVendorStoreDepartmentAccountMutation,
    AdminStoresUpdateVendorStoreDepartmentAccountMutationVariables
  >
export const AdminStoresCreateStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation AdminStores_CreateStoreDepartment(
    $storeID: ID!
    $departmentName: String!
  ) {
    createStoreDepartment(
      input: { storeID: $storeID, departmentName: $departmentName }
    ) {
      id
      name
    }
  }
`
export type AdminStoresCreateStoreDepartmentMutationFn =
  Apollo.MutationFunction<
    AdminStoresCreateStoreDepartmentMutation,
    AdminStoresCreateStoreDepartmentMutationVariables
  >

/**
 * __useAdminStoresCreateStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useAdminStoresCreateStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresCreateStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresCreateStoreDepartmentMutation, { data, loading, error }] = useAdminStoresCreateStoreDepartmentMutation({
 *   variables: {
 *      storeID: // value for 'storeID'
 *      departmentName: // value for 'departmentName'
 *   },
 * });
 */
export function useAdminStoresCreateStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresCreateStoreDepartmentMutation,
    AdminStoresCreateStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresCreateStoreDepartmentMutation,
    AdminStoresCreateStoreDepartmentMutationVariables
  >(AdminStoresCreateStoreDepartmentDocument, options)
}
export type AdminStoresCreateStoreDepartmentMutationHookResult = ReturnType<
  typeof useAdminStoresCreateStoreDepartmentMutation
>
export type AdminStoresCreateStoreDepartmentMutationResult =
  Apollo.MutationResult<AdminStoresCreateStoreDepartmentMutation>
export type AdminStoresCreateStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    AdminStoresCreateStoreDepartmentMutation,
    AdminStoresCreateStoreDepartmentMutationVariables
  >
export const AdminStoresCreateVendorStoreDepartmentAccountDocument = /*#__PURE__*/ gql`
  mutation AdminStores_CreateVendorStoreDepartmentAccount(
    $vendorID: String!
    $storeDepartmentID: String!
  ) {
    createVendorStoreDepartmentAccount(
      input: { vendorID: $vendorID, storeDepartmentID: $storeDepartmentID }
    ) {
      ...AdminStores_VendorStoreDepartmentAccountDetails
    }
  }
  ${AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc}
`
export type AdminStoresCreateVendorStoreDepartmentAccountMutationFn =
  Apollo.MutationFunction<
    AdminStoresCreateVendorStoreDepartmentAccountMutation,
    AdminStoresCreateVendorStoreDepartmentAccountMutationVariables
  >

/**
 * __useAdminStoresCreateVendorStoreDepartmentAccountMutation__
 *
 * To run a mutation, you first call `useAdminStoresCreateVendorStoreDepartmentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresCreateVendorStoreDepartmentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresCreateVendorStoreDepartmentAccountMutation, { data, loading, error }] = useAdminStoresCreateVendorStoreDepartmentAccountMutation({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *   },
 * });
 */
export function useAdminStoresCreateVendorStoreDepartmentAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresCreateVendorStoreDepartmentAccountMutation,
    AdminStoresCreateVendorStoreDepartmentAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresCreateVendorStoreDepartmentAccountMutation,
    AdminStoresCreateVendorStoreDepartmentAccountMutationVariables
  >(AdminStoresCreateVendorStoreDepartmentAccountDocument, options)
}
export type AdminStoresCreateVendorStoreDepartmentAccountMutationHookResult =
  ReturnType<typeof useAdminStoresCreateVendorStoreDepartmentAccountMutation>
export type AdminStoresCreateVendorStoreDepartmentAccountMutationResult =
  Apollo.MutationResult<AdminStoresCreateVendorStoreDepartmentAccountMutation>
export type AdminStoresCreateVendorStoreDepartmentAccountMutationOptions =
  Apollo.BaseMutationOptions<
    AdminStoresCreateVendorStoreDepartmentAccountMutation,
    AdminStoresCreateVendorStoreDepartmentAccountMutationVariables
  >
export const AdminStoresBulkCreateVendorStoreDepartmentAccountsDocument = /*#__PURE__*/ gql`
  mutation AdminStores_BulkCreateVendorStoreDepartmentAccounts(
    $input: [CreateVendorStoreDepartmentAccountForm!]!
  ) {
    bulkCreateVendorStoreDepartmentAccounts(input: $input) {
      nodes {
        ...AdminStores_VendorStoreDepartmentAccountDetails
      }
      errors {
        storeDepartmentID
        vendorID
        errors
      }
    }
  }
  ${AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc}
`
export type AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationFn =
  Apollo.MutationFunction<
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutation,
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationVariables
  >

/**
 * __useAdminStoresBulkCreateVendorStoreDepartmentAccountsMutation__
 *
 * To run a mutation, you first call `useAdminStoresBulkCreateVendorStoreDepartmentAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresBulkCreateVendorStoreDepartmentAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresBulkCreateVendorStoreDepartmentAccountsMutation, { data, loading, error }] = useAdminStoresBulkCreateVendorStoreDepartmentAccountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminStoresBulkCreateVendorStoreDepartmentAccountsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutation,
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutation,
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationVariables
  >(AdminStoresBulkCreateVendorStoreDepartmentAccountsDocument, options)
}
export type AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationHookResult =
  ReturnType<
    typeof useAdminStoresBulkCreateVendorStoreDepartmentAccountsMutation
  >
export type AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationResult =
  Apollo.MutationResult<AdminStoresBulkCreateVendorStoreDepartmentAccountsMutation>
export type AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationOptions =
  Apollo.BaseMutationOptions<
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutation,
    AdminStoresBulkCreateVendorStoreDepartmentAccountsMutationVariables
  >
export const AdminStoresCreateUserStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation AdminStores_CreateUserStoreDepartment(
    $userID: ID!
    $storeDepartmentID: ID!
  ) {
    createUserStoreDepartment(
      input: { userID: $userID, storeDepartmentID: $storeDepartmentID }
    ) {
      id
      user {
        id
      }
      storeDepartment {
        id
        name
        store {
          id
        }
      }
    }
  }
`
export type AdminStoresCreateUserStoreDepartmentMutationFn =
  Apollo.MutationFunction<
    AdminStoresCreateUserStoreDepartmentMutation,
    AdminStoresCreateUserStoreDepartmentMutationVariables
  >

/**
 * __useAdminStoresCreateUserStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useAdminStoresCreateUserStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresCreateUserStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresCreateUserStoreDepartmentMutation, { data, loading, error }] = useAdminStoresCreateUserStoreDepartmentMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *   },
 * });
 */
export function useAdminStoresCreateUserStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresCreateUserStoreDepartmentMutation,
    AdminStoresCreateUserStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresCreateUserStoreDepartmentMutation,
    AdminStoresCreateUserStoreDepartmentMutationVariables
  >(AdminStoresCreateUserStoreDepartmentDocument, options)
}
export type AdminStoresCreateUserStoreDepartmentMutationHookResult = ReturnType<
  typeof useAdminStoresCreateUserStoreDepartmentMutation
>
export type AdminStoresCreateUserStoreDepartmentMutationResult =
  Apollo.MutationResult<AdminStoresCreateUserStoreDepartmentMutation>
export type AdminStoresCreateUserStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    AdminStoresCreateUserStoreDepartmentMutation,
    AdminStoresCreateUserStoreDepartmentMutationVariables
  >
export const AdminStoresDeleteUserStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation AdminStores_DeleteUserStoreDepartment($userStoreDepartmentID: ID!) {
    deleteUserStoreDepartment(
      input: { userStoreDepartmentID: $userStoreDepartmentID }
    ) {
      id
      user {
        id
      }
      storeDepartment {
        id
        name
        store {
          id
        }
      }
    }
  }
`
export type AdminStoresDeleteUserStoreDepartmentMutationFn =
  Apollo.MutationFunction<
    AdminStoresDeleteUserStoreDepartmentMutation,
    AdminStoresDeleteUserStoreDepartmentMutationVariables
  >

/**
 * __useAdminStoresDeleteUserStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useAdminStoresDeleteUserStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresDeleteUserStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresDeleteUserStoreDepartmentMutation, { data, loading, error }] = useAdminStoresDeleteUserStoreDepartmentMutation({
 *   variables: {
 *      userStoreDepartmentID: // value for 'userStoreDepartmentID'
 *   },
 * });
 */
export function useAdminStoresDeleteUserStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresDeleteUserStoreDepartmentMutation,
    AdminStoresDeleteUserStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresDeleteUserStoreDepartmentMutation,
    AdminStoresDeleteUserStoreDepartmentMutationVariables
  >(AdminStoresDeleteUserStoreDepartmentDocument, options)
}
export type AdminStoresDeleteUserStoreDepartmentMutationHookResult = ReturnType<
  typeof useAdminStoresDeleteUserStoreDepartmentMutation
>
export type AdminStoresDeleteUserStoreDepartmentMutationResult =
  Apollo.MutationResult<AdminStoresDeleteUserStoreDepartmentMutation>
export type AdminStoresDeleteUserStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    AdminStoresDeleteUserStoreDepartmentMutation,
    AdminStoresDeleteUserStoreDepartmentMutationVariables
  >
export const AdminStoresUpdateUserDocument = /*#__PURE__*/ gql`
  mutation AdminStores_UpdateUser($id: ID!, $defaultDepartmentName: String) {
    updateUser(
      input: { id: $id, defaultDepartmentName: $defaultDepartmentName }
    ) {
      id
      defaultDepartmentName
    }
  }
`
export type AdminStoresUpdateUserMutationFn = Apollo.MutationFunction<
  AdminStoresUpdateUserMutation,
  AdminStoresUpdateUserMutationVariables
>

/**
 * __useAdminStoresUpdateUserMutation__
 *
 * To run a mutation, you first call `useAdminStoresUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStoresUpdateUserMutation, { data, loading, error }] = useAdminStoresUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      defaultDepartmentName: // value for 'defaultDepartmentName'
 *   },
 * });
 */
export function useAdminStoresUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminStoresUpdateUserMutation,
    AdminStoresUpdateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdminStoresUpdateUserMutation,
    AdminStoresUpdateUserMutationVariables
  >(AdminStoresUpdateUserDocument, options)
}
export type AdminStoresUpdateUserMutationHookResult = ReturnType<
  typeof useAdminStoresUpdateUserMutation
>
export type AdminStoresUpdateUserMutationResult =
  Apollo.MutationResult<AdminStoresUpdateUserMutation>
export type AdminStoresUpdateUserMutationOptions = Apollo.BaseMutationOptions<
  AdminStoresUpdateUserMutation,
  AdminStoresUpdateUserMutationVariables
>
export const AdminStoresGetPaginatedStoresDocument = /*#__PURE__*/ gql`
  query AdminStores_GetPaginatedStores($cursor: String, $query: String) {
    allStores(input: { cursor: $cursor, search: $query, limit: 30 }) {
      nodes {
        id
        serialID
        firestoreID
        name
        address
        emails
        placeID
        storeType
        banner {
          id
          name
        }
        bannerStoreID
        userCount
        vendorCount
      }
      hasMore
      totalCount
      cursor
    }
  }
`

/**
 * __useAdminStoresGetPaginatedStoresQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetPaginatedStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetPaginatedStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetPaginatedStoresQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAdminStoresGetPaginatedStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminStoresGetPaginatedStoresQuery,
    AdminStoresGetPaginatedStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetPaginatedStoresQuery,
    AdminStoresGetPaginatedStoresQueryVariables
  >(AdminStoresGetPaginatedStoresDocument, options)
}
export function useAdminStoresGetPaginatedStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetPaginatedStoresQuery,
    AdminStoresGetPaginatedStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetPaginatedStoresQuery,
    AdminStoresGetPaginatedStoresQueryVariables
  >(AdminStoresGetPaginatedStoresDocument, options)
}
export type AdminStoresGetPaginatedStoresQueryHookResult = ReturnType<
  typeof useAdminStoresGetPaginatedStoresQuery
>
export type AdminStoresGetPaginatedStoresLazyQueryHookResult = ReturnType<
  typeof useAdminStoresGetPaginatedStoresLazyQuery
>
export type AdminStoresGetPaginatedStoresQueryResult = Apollo.QueryResult<
  AdminStoresGetPaginatedStoresQuery,
  AdminStoresGetPaginatedStoresQueryVariables
>
export function refetchAdminStoresGetPaginatedStoresQuery(
  variables?: AdminStoresGetPaginatedStoresQueryVariables,
) {
  return { query: AdminStoresGetPaginatedStoresDocument, variables: variables }
}
export const AdminStoresGetPaginatedVendorsDocument = /*#__PURE__*/ gql`
  query AdminStores_GetPaginatedVendors(
    $cursor: String
    $query: String
    $limit: Int
  ) {
    allVendors(input: { search: $query, cursor: $cursor, limit: $limit }) {
      nodes {
        id
        name
        imgURL
      }
      totalCount
      cursor
      hasMore
    }
  }
`

/**
 * __useAdminStoresGetPaginatedVendorsQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetPaginatedVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetPaginatedVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetPaginatedVendorsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminStoresGetPaginatedVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminStoresGetPaginatedVendorsQuery,
    AdminStoresGetPaginatedVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetPaginatedVendorsQuery,
    AdminStoresGetPaginatedVendorsQueryVariables
  >(AdminStoresGetPaginatedVendorsDocument, options)
}
export function useAdminStoresGetPaginatedVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetPaginatedVendorsQuery,
    AdminStoresGetPaginatedVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetPaginatedVendorsQuery,
    AdminStoresGetPaginatedVendorsQueryVariables
  >(AdminStoresGetPaginatedVendorsDocument, options)
}
export type AdminStoresGetPaginatedVendorsQueryHookResult = ReturnType<
  typeof useAdminStoresGetPaginatedVendorsQuery
>
export type AdminStoresGetPaginatedVendorsLazyQueryHookResult = ReturnType<
  typeof useAdminStoresGetPaginatedVendorsLazyQuery
>
export type AdminStoresGetPaginatedVendorsQueryResult = Apollo.QueryResult<
  AdminStoresGetPaginatedVendorsQuery,
  AdminStoresGetPaginatedVendorsQueryVariables
>
export function refetchAdminStoresGetPaginatedVendorsQuery(
  variables?: AdminStoresGetPaginatedVendorsQueryVariables,
) {
  return { query: AdminStoresGetPaginatedVendorsDocument, variables: variables }
}
export const AdminStoresGetStoreDetailsDocument = /*#__PURE__*/ gql`
  query AdminStores_GetStoreDetails($id: ID!) {
    storeByID(id: $id) {
      ...AdminStores_StoreDetailsFields
    }
  }
  ${AdminStoresStoreDetailsFieldsFragmentDoc}
`

/**
 * __useAdminStoresGetStoreDetailsQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetStoreDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetStoreDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetStoreDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminStoresGetStoreDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStoresGetStoreDetailsQuery,
    AdminStoresGetStoreDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetStoreDetailsQuery,
    AdminStoresGetStoreDetailsQueryVariables
  >(AdminStoresGetStoreDetailsDocument, options)
}
export function useAdminStoresGetStoreDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetStoreDetailsQuery,
    AdminStoresGetStoreDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetStoreDetailsQuery,
    AdminStoresGetStoreDetailsQueryVariables
  >(AdminStoresGetStoreDetailsDocument, options)
}
export type AdminStoresGetStoreDetailsQueryHookResult = ReturnType<
  typeof useAdminStoresGetStoreDetailsQuery
>
export type AdminStoresGetStoreDetailsLazyQueryHookResult = ReturnType<
  typeof useAdminStoresGetStoreDetailsLazyQuery
>
export type AdminStoresGetStoreDetailsQueryResult = Apollo.QueryResult<
  AdminStoresGetStoreDetailsQuery,
  AdminStoresGetStoreDetailsQueryVariables
>
export function refetchAdminStoresGetStoreDetailsQuery(
  variables: AdminStoresGetStoreDetailsQueryVariables,
) {
  return { query: AdminStoresGetStoreDetailsDocument, variables: variables }
}
export const AdminStoresGetVendorStoreDepartmentAccountsForStoreDocument = /*#__PURE__*/ gql`
  query AdminStores_GetVendorStoreDepartmentAccountsForStore($storeID: ID!) {
    getVendorStoreDepartmentAccountsForStore(
      storeID: $storeID
      includeInactive: true
    ) {
      nodes {
        ...AdminStores_VendorStoreDepartmentAccountDetails
      }
    }
  }
  ${AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc}
`

/**
 * __useAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables
  >(AdminStoresGetVendorStoreDepartmentAccountsForStoreDocument, options)
}
export function useAdminStoresGetVendorStoreDepartmentAccountsForStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables
  >(AdminStoresGetVendorStoreDepartmentAccountsForStoreDocument, options)
}
export type AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryHookResult =
  ReturnType<typeof useAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery>
export type AdminStoresGetVendorStoreDepartmentAccountsForStoreLazyQueryHookResult =
  ReturnType<
    typeof useAdminStoresGetVendorStoreDepartmentAccountsForStoreLazyQuery
  >
export type AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryResult =
  Apollo.QueryResult<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables
  >
export function refetchAdminStoresGetVendorStoreDepartmentAccountsForStoreQuery(
  variables: AdminStoresGetVendorStoreDepartmentAccountsForStoreQueryVariables,
) {
  return {
    query: AdminStoresGetVendorStoreDepartmentAccountsForStoreDocument,
    variables: variables,
  }
}
export const AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreDocument = /*#__PURE__*/ gql`
  query AdminStores_GetVendorStoreDepartmentAccountForVendorAndStore(
    $vendorID: ID!
    $storeID: ID!
  ) {
    getVendorStoreDepartmentAccountsForVendorAndStore(
      vendorID: $vendorID
      storeID: $storeID
    ) {
      nodes {
        ...AdminStores_VendorStoreDepartmentAccountDetails
      }
    }
  }
  ${AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc}
`

/**
 * __useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables
  >(
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreDocument,
    options,
  )
}
export function useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables
  >(
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreDocument,
    options,
  )
}
export type AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryHookResult =
  ReturnType<
    typeof useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery
  >
export type AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreLazyQueryHookResult =
  ReturnType<
    typeof useAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreLazyQuery
  >
export type AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryResult =
  Apollo.QueryResult<
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery,
    AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables
  >
export function refetchAdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQuery(
  variables: AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreQueryVariables,
) {
  return {
    query: AdminStoresGetVendorStoreDepartmentAccountForVendorAndStoreDocument,
    variables: variables,
  }
}
export const AdminStoresGetStoreDepartmentsForStoreDocument = /*#__PURE__*/ gql`
  query AdminStores_GetStoreDepartmentsForStore($storeID: ID!) {
    storeByID(id: $storeID) {
      storeDepartments {
        nodes {
          ...AdminStores_StoreDepartmentDetails
        }
      }
    }
  }
  ${AdminStoresStoreDepartmentDetailsFragmentDoc}
`

/**
 * __useAdminStoresGetStoreDepartmentsForStoreQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetStoreDepartmentsForStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetStoreDepartmentsForStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetStoreDepartmentsForStoreQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useAdminStoresGetStoreDepartmentsForStoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStoresGetStoreDepartmentsForStoreQuery,
    AdminStoresGetStoreDepartmentsForStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetStoreDepartmentsForStoreQuery,
    AdminStoresGetStoreDepartmentsForStoreQueryVariables
  >(AdminStoresGetStoreDepartmentsForStoreDocument, options)
}
export function useAdminStoresGetStoreDepartmentsForStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetStoreDepartmentsForStoreQuery,
    AdminStoresGetStoreDepartmentsForStoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetStoreDepartmentsForStoreQuery,
    AdminStoresGetStoreDepartmentsForStoreQueryVariables
  >(AdminStoresGetStoreDepartmentsForStoreDocument, options)
}
export type AdminStoresGetStoreDepartmentsForStoreQueryHookResult = ReturnType<
  typeof useAdminStoresGetStoreDepartmentsForStoreQuery
>
export type AdminStoresGetStoreDepartmentsForStoreLazyQueryHookResult =
  ReturnType<typeof useAdminStoresGetStoreDepartmentsForStoreLazyQuery>
export type AdminStoresGetStoreDepartmentsForStoreQueryResult =
  Apollo.QueryResult<
    AdminStoresGetStoreDepartmentsForStoreQuery,
    AdminStoresGetStoreDepartmentsForStoreQueryVariables
  >
export function refetchAdminStoresGetStoreDepartmentsForStoreQuery(
  variables: AdminStoresGetStoreDepartmentsForStoreQueryVariables,
) {
  return {
    query: AdminStoresGetStoreDepartmentsForStoreDocument,
    variables: variables,
  }
}
export const AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentDocument = /*#__PURE__*/ gql`
  query AdminStores_GetVendorStoreDepartmentAccountsForStoreDepartment(
    $storeDepartmentID: ID!
  ) {
    getStoreDepartmentByID(id: $storeDepartmentID) {
      id
      vendorStoreDepartmentAccounts(input: { includeInactive: true }) {
        nodes {
          ...AdminStores_VendorStoreDepartmentAccountDetails
        }
      }
    }
  }
  ${AdminStoresVendorStoreDepartmentAccountDetailsFragmentDoc}
`

/**
 * __useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery__
 *
 * To run a query within a React component, call `useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery({
 *   variables: {
 *      storeDepartmentID: // value for 'storeDepartmentID'
 *   },
 * });
 */
export function useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables
  >(
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentDocument,
    options,
  )
}
export function useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables
  >(
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentDocument,
    options,
  )
}
export type AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryHookResult =
  ReturnType<
    typeof useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery
  >
export type AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentLazyQueryHookResult =
  ReturnType<
    typeof useAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentLazyQuery
  >
export type AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryResult =
  Apollo.QueryResult<
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery,
    AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables
  >
export function refetchAdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQuery(
  variables: AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentQueryVariables,
) {
  return {
    query:
      AdminStoresGetVendorStoreDepartmentAccountsForStoreDepartmentDocument,
    variables: variables,
  }
}
export const VendorsViewUpdateVendorDocument = /*#__PURE__*/ gql`
  mutation VendorsView_UpdateVendor($input: UpdateVendorInput!) {
    updateVendor(input: $input) {
      ...VendorDetails
    }
  }
  ${VendorDetailsFragmentDoc}
`
export type VendorsViewUpdateVendorMutationFn = Apollo.MutationFunction<
  VendorsViewUpdateVendorMutation,
  VendorsViewUpdateVendorMutationVariables
>

/**
 * __useVendorsViewUpdateVendorMutation__
 *
 * To run a mutation, you first call `useVendorsViewUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorsViewUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorsViewUpdateVendorMutation, { data, loading, error }] = useVendorsViewUpdateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorsViewUpdateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorsViewUpdateVendorMutation,
    VendorsViewUpdateVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorsViewUpdateVendorMutation,
    VendorsViewUpdateVendorMutationVariables
  >(VendorsViewUpdateVendorDocument, options)
}
export type VendorsViewUpdateVendorMutationHookResult = ReturnType<
  typeof useVendorsViewUpdateVendorMutation
>
export type VendorsViewUpdateVendorMutationResult =
  Apollo.MutationResult<VendorsViewUpdateVendorMutation>
export type VendorsViewUpdateVendorMutationOptions = Apollo.BaseMutationOptions<
  VendorsViewUpdateVendorMutation,
  VendorsViewUpdateVendorMutationVariables
>
export const VendorsViewCreateVendorDocument = /*#__PURE__*/ gql`
  mutation VendorsView_CreateVendor($input: CreateVendorInput!) {
    createVendor(input: $input) {
      ...VendorDetails
    }
  }
  ${VendorDetailsFragmentDoc}
`
export type VendorsViewCreateVendorMutationFn = Apollo.MutationFunction<
  VendorsViewCreateVendorMutation,
  VendorsViewCreateVendorMutationVariables
>

/**
 * __useVendorsViewCreateVendorMutation__
 *
 * To run a mutation, you first call `useVendorsViewCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorsViewCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorsViewCreateVendorMutation, { data, loading, error }] = useVendorsViewCreateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorsViewCreateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VendorsViewCreateVendorMutation,
    VendorsViewCreateVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VendorsViewCreateVendorMutation,
    VendorsViewCreateVendorMutationVariables
  >(VendorsViewCreateVendorDocument, options)
}
export type VendorsViewCreateVendorMutationHookResult = ReturnType<
  typeof useVendorsViewCreateVendorMutation
>
export type VendorsViewCreateVendorMutationResult =
  Apollo.MutationResult<VendorsViewCreateVendorMutation>
export type VendorsViewCreateVendorMutationOptions = Apollo.BaseMutationOptions<
  VendorsViewCreateVendorMutation,
  VendorsViewCreateVendorMutationVariables
>
export const AdminVendorsGetAllStoresDocument = /*#__PURE__*/ gql`
  query AdminVendors_GetAllStores($cursor: String, $search: String) {
    allStores(input: { cursor: $cursor, search: $search, limit: 30 }) {
      cursor
      hasMore
      nodes {
        id
        name
        address
        emails
        placeID
        storeType
        banner {
          id
          name
        }
        bannerStoreID
      }
    }
  }
`

/**
 * __useAdminVendorsGetAllStoresQuery__
 *
 * To run a query within a React component, call `useAdminVendorsGetAllStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminVendorsGetAllStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminVendorsGetAllStoresQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminVendorsGetAllStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminVendorsGetAllStoresQuery,
    AdminVendorsGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminVendorsGetAllStoresQuery,
    AdminVendorsGetAllStoresQueryVariables
  >(AdminVendorsGetAllStoresDocument, options)
}
export function useAdminVendorsGetAllStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminVendorsGetAllStoresQuery,
    AdminVendorsGetAllStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminVendorsGetAllStoresQuery,
    AdminVendorsGetAllStoresQueryVariables
  >(AdminVendorsGetAllStoresDocument, options)
}
export type AdminVendorsGetAllStoresQueryHookResult = ReturnType<
  typeof useAdminVendorsGetAllStoresQuery
>
export type AdminVendorsGetAllStoresLazyQueryHookResult = ReturnType<
  typeof useAdminVendorsGetAllStoresLazyQuery
>
export type AdminVendorsGetAllStoresQueryResult = Apollo.QueryResult<
  AdminVendorsGetAllStoresQuery,
  AdminVendorsGetAllStoresQueryVariables
>
export function refetchAdminVendorsGetAllStoresQuery(
  variables?: AdminVendorsGetAllStoresQueryVariables,
) {
  return { query: AdminVendorsGetAllStoresDocument, variables: variables }
}
export const AdminVendorsGetPaginatedVendorsDocument = /*#__PURE__*/ gql`
  query AdminVendors_GetPaginatedVendors(
    $cursor: String
    $limit: Int
    $search: String
    $filterStoreVendors: Boolean
  ) {
    allVendors(
      input: { cursor: $cursor, search: $search, limit: $limit }
      filterStoreVendors: $filterStoreVendors
    ) {
      nodes {
        id
        description
        email
        imgURL
        name
        orderMin
        orderDeadline
        lockUOMSelection
        status
        misscanPolicy
        useAccountMetadataEmailOverVendorEmail
        showImages
        isInventoryEnabled
        address
        acquisitionSource
        orderSubmissionUOMLock
        referredByCompany {
          ... on Vendor {
            id
            name
          }
          ... on Store {
            id
            name
          }
        }
        headerImageURL
      }
      totalCount
      cursor
      hasMore
    }
  }
`

/**
 * __useAdminVendorsGetPaginatedVendorsQuery__
 *
 * To run a query within a React component, call `useAdminVendorsGetPaginatedVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminVendorsGetPaginatedVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminVendorsGetPaginatedVendorsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      filterStoreVendors: // value for 'filterStoreVendors'
 *   },
 * });
 */
export function useAdminVendorsGetPaginatedVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminVendorsGetPaginatedVendorsQuery,
    AdminVendorsGetPaginatedVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminVendorsGetPaginatedVendorsQuery,
    AdminVendorsGetPaginatedVendorsQueryVariables
  >(AdminVendorsGetPaginatedVendorsDocument, options)
}
export function useAdminVendorsGetPaginatedVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminVendorsGetPaginatedVendorsQuery,
    AdminVendorsGetPaginatedVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminVendorsGetPaginatedVendorsQuery,
    AdminVendorsGetPaginatedVendorsQueryVariables
  >(AdminVendorsGetPaginatedVendorsDocument, options)
}
export type AdminVendorsGetPaginatedVendorsQueryHookResult = ReturnType<
  typeof useAdminVendorsGetPaginatedVendorsQuery
>
export type AdminVendorsGetPaginatedVendorsLazyQueryHookResult = ReturnType<
  typeof useAdminVendorsGetPaginatedVendorsLazyQuery
>
export type AdminVendorsGetPaginatedVendorsQueryResult = Apollo.QueryResult<
  AdminVendorsGetPaginatedVendorsQuery,
  AdminVendorsGetPaginatedVendorsQueryVariables
>
export function refetchAdminVendorsGetPaginatedVendorsQuery(
  variables?: AdminVendorsGetPaginatedVendorsQueryVariables,
) {
  return {
    query: AdminVendorsGetPaginatedVendorsDocument,
    variables: variables,
  }
}
export const AdminVendorsGetVendorByIdDocument = /*#__PURE__*/ gql`
  query AdminVendors_GetVendorByID($vendorID: ID!) {
    vendorByID(id: $vendorID) {
      id
      description
      email
      imgURL
      name
      orderMin
      orderMinimums {
        storeID
        orderMin
      }
      orderDeadline
      lockUOMSelection
      status
      misscanPolicy
      useAccountMetadataEmailOverVendorEmail
      showImages
      isInventoryEnabled
      address
      acquisitionSource
      orderSubmissionUOMLock
      vendorManagedCatalog
      orderDeadlineInfo {
        timezone
        orderDeadlines {
          deadlineDay
          deliveryDay
          deadlineTime
        }
      }
      referredByCompany {
        ... on Vendor {
          id
          name
        }
        ... on Store {
          id
          name
        }
      }
      headerImageURL
    }
  }
`

/**
 * __useAdminVendorsGetVendorByIdQuery__
 *
 * To run a query within a React component, call `useAdminVendorsGetVendorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminVendorsGetVendorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminVendorsGetVendorByIdQuery({
 *   variables: {
 *      vendorID: // value for 'vendorID'
 *   },
 * });
 */
export function useAdminVendorsGetVendorByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminVendorsGetVendorByIdQuery,
    AdminVendorsGetVendorByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminVendorsGetVendorByIdQuery,
    AdminVendorsGetVendorByIdQueryVariables
  >(AdminVendorsGetVendorByIdDocument, options)
}
export function useAdminVendorsGetVendorByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminVendorsGetVendorByIdQuery,
    AdminVendorsGetVendorByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminVendorsGetVendorByIdQuery,
    AdminVendorsGetVendorByIdQueryVariables
  >(AdminVendorsGetVendorByIdDocument, options)
}
export type AdminVendorsGetVendorByIdQueryHookResult = ReturnType<
  typeof useAdminVendorsGetVendorByIdQuery
>
export type AdminVendorsGetVendorByIdLazyQueryHookResult = ReturnType<
  typeof useAdminVendorsGetVendorByIdLazyQuery
>
export type AdminVendorsGetVendorByIdQueryResult = Apollo.QueryResult<
  AdminVendorsGetVendorByIdQuery,
  AdminVendorsGetVendorByIdQueryVariables
>
export function refetchAdminVendorsGetVendorByIdQuery(
  variables: AdminVendorsGetVendorByIdQueryVariables,
) {
  return { query: AdminVendorsGetVendorByIdDocument, variables: variables }
}
export const BackOfficeGetCurrentUserStoresDocument = /*#__PURE__*/ gql`
  query BackOffice_GetCurrentUserStores {
    me {
      user {
        id
        retailUser {
          retailCompany {
            banner {
              id
              stores {
                nodes {
                  id
                  local_iana_timezone
                  name
                  serialID
                }
              }
            }
            store {
              id
              local_iana_timezone
              name
              serialID
            }
          }
          user {
            id
          }
        }
      }
    }
  }
`

/**
 * __useBackOfficeGetCurrentUserStoresQuery__
 *
 * To run a query within a React component, call `useBackOfficeGetCurrentUserStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeGetCurrentUserStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeGetCurrentUserStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackOfficeGetCurrentUserStoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackOfficeGetCurrentUserStoresQuery,
    BackOfficeGetCurrentUserStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeGetCurrentUserStoresQuery,
    BackOfficeGetCurrentUserStoresQueryVariables
  >(BackOfficeGetCurrentUserStoresDocument, options)
}
export function useBackOfficeGetCurrentUserStoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeGetCurrentUserStoresQuery,
    BackOfficeGetCurrentUserStoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeGetCurrentUserStoresQuery,
    BackOfficeGetCurrentUserStoresQueryVariables
  >(BackOfficeGetCurrentUserStoresDocument, options)
}
export type BackOfficeGetCurrentUserStoresQueryHookResult = ReturnType<
  typeof useBackOfficeGetCurrentUserStoresQuery
>
export type BackOfficeGetCurrentUserStoresLazyQueryHookResult = ReturnType<
  typeof useBackOfficeGetCurrentUserStoresLazyQuery
>
export type BackOfficeGetCurrentUserStoresQueryResult = Apollo.QueryResult<
  BackOfficeGetCurrentUserStoresQuery,
  BackOfficeGetCurrentUserStoresQueryVariables
>
export function refetchBackOfficeGetCurrentUserStoresQuery(
  variables?: BackOfficeGetCurrentUserStoresQueryVariables,
) {
  return { query: BackOfficeGetCurrentUserStoresDocument, variables: variables }
}
export const CreateInvoiceGetStoreDepartmentsByStoreIdDocument = /*#__PURE__*/ gql`
  query CreateInvoice_GetStoreDepartmentsByStoreID($storeID: ID!) {
    storeDepartmentsForCompany(input: { first: 500, storeIDs: [$storeID] }) {
      edges {
        node {
          id
          name
          deactivatedAt
          store {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useCreateInvoiceGetStoreDepartmentsByStoreIdQuery__
 *
 * To run a query within a React component, call `useCreateInvoiceGetStoreDepartmentsByStoreIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceGetStoreDepartmentsByStoreIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateInvoiceGetStoreDepartmentsByStoreIdQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useCreateInvoiceGetStoreDepartmentsByStoreIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateInvoiceGetStoreDepartmentsByStoreIdQuery,
    CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CreateInvoiceGetStoreDepartmentsByStoreIdQuery,
    CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables
  >(CreateInvoiceGetStoreDepartmentsByStoreIdDocument, options)
}
export function useCreateInvoiceGetStoreDepartmentsByStoreIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateInvoiceGetStoreDepartmentsByStoreIdQuery,
    CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CreateInvoiceGetStoreDepartmentsByStoreIdQuery,
    CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables
  >(CreateInvoiceGetStoreDepartmentsByStoreIdDocument, options)
}
export type CreateInvoiceGetStoreDepartmentsByStoreIdQueryHookResult =
  ReturnType<typeof useCreateInvoiceGetStoreDepartmentsByStoreIdQuery>
export type CreateInvoiceGetStoreDepartmentsByStoreIdLazyQueryHookResult =
  ReturnType<typeof useCreateInvoiceGetStoreDepartmentsByStoreIdLazyQuery>
export type CreateInvoiceGetStoreDepartmentsByStoreIdQueryResult =
  Apollo.QueryResult<
    CreateInvoiceGetStoreDepartmentsByStoreIdQuery,
    CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables
  >
export function refetchCreateInvoiceGetStoreDepartmentsByStoreIdQuery(
  variables: CreateInvoiceGetStoreDepartmentsByStoreIdQueryVariables,
) {
  return {
    query: CreateInvoiceGetStoreDepartmentsByStoreIdDocument,
    variables: variables,
  }
}
export const GetUnitOfMeasureValuesDocument = /*#__PURE__*/ gql`
  query GetUnitOfMeasureValues {
    __type(name: "UnitOfMeasure") {
      enumValues {
        name
      }
    }
  }
`

/**
 * __useGetUnitOfMeasureValuesQuery__
 *
 * To run a query within a React component, call `useGetUnitOfMeasureValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitOfMeasureValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitOfMeasureValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitOfMeasureValuesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnitOfMeasureValuesQuery,
    GetUnitOfMeasureValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUnitOfMeasureValuesQuery,
    GetUnitOfMeasureValuesQueryVariables
  >(GetUnitOfMeasureValuesDocument, options)
}
export function useGetUnitOfMeasureValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnitOfMeasureValuesQuery,
    GetUnitOfMeasureValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUnitOfMeasureValuesQuery,
    GetUnitOfMeasureValuesQueryVariables
  >(GetUnitOfMeasureValuesDocument, options)
}
export type GetUnitOfMeasureValuesQueryHookResult = ReturnType<
  typeof useGetUnitOfMeasureValuesQuery
>
export type GetUnitOfMeasureValuesLazyQueryHookResult = ReturnType<
  typeof useGetUnitOfMeasureValuesLazyQuery
>
export type GetUnitOfMeasureValuesQueryResult = Apollo.QueryResult<
  GetUnitOfMeasureValuesQuery,
  GetUnitOfMeasureValuesQueryVariables
>
export function refetchGetUnitOfMeasureValuesQuery(
  variables?: GetUnitOfMeasureValuesQueryVariables,
) {
  return { query: GetUnitOfMeasureValuesDocument, variables: variables }
}
export const RetailBulkUpdateStoreDepartmentsDocument = /*#__PURE__*/ gql`
  mutation Retail_BulkUpdateStoreDepartments(
    $data: BulkUpdateStoreDepartmentsInput!
  ) {
    bulkUpdateStoreDepartments(data: $data) {
      id
      storeID
      name
      deactivatedAt
      imageURL
      parentDepartment {
        id
        name
      }
    }
  }
`
export type RetailBulkUpdateStoreDepartmentsMutationFn =
  Apollo.MutationFunction<
    RetailBulkUpdateStoreDepartmentsMutation,
    RetailBulkUpdateStoreDepartmentsMutationVariables
  >

/**
 * __useRetailBulkUpdateStoreDepartmentsMutation__
 *
 * To run a mutation, you first call `useRetailBulkUpdateStoreDepartmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailBulkUpdateStoreDepartmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailBulkUpdateStoreDepartmentsMutation, { data, loading, error }] = useRetailBulkUpdateStoreDepartmentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRetailBulkUpdateStoreDepartmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailBulkUpdateStoreDepartmentsMutation,
    RetailBulkUpdateStoreDepartmentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailBulkUpdateStoreDepartmentsMutation,
    RetailBulkUpdateStoreDepartmentsMutationVariables
  >(RetailBulkUpdateStoreDepartmentsDocument, options)
}
export type RetailBulkUpdateStoreDepartmentsMutationHookResult = ReturnType<
  typeof useRetailBulkUpdateStoreDepartmentsMutation
>
export type RetailBulkUpdateStoreDepartmentsMutationResult =
  Apollo.MutationResult<RetailBulkUpdateStoreDepartmentsMutation>
export type RetailBulkUpdateStoreDepartmentsMutationOptions =
  Apollo.BaseMutationOptions<
    RetailBulkUpdateStoreDepartmentsMutation,
    RetailBulkUpdateStoreDepartmentsMutationVariables
  >
export const RetailBulkAddStoreDepartmentDocument = /*#__PURE__*/ gql`
  mutation Retail_BulkAddStoreDepartment($data: CreateStoreDepartmentsInput!) {
    createStoreDepartments(data: $data) {
      id
      storeID
      imageURL
      name
      deactivatedAt
      parentDepartment {
        id
        name
      }
    }
  }
`
export type RetailBulkAddStoreDepartmentMutationFn = Apollo.MutationFunction<
  RetailBulkAddStoreDepartmentMutation,
  RetailBulkAddStoreDepartmentMutationVariables
>

/**
 * __useRetailBulkAddStoreDepartmentMutation__
 *
 * To run a mutation, you first call `useRetailBulkAddStoreDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailBulkAddStoreDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailBulkAddStoreDepartmentMutation, { data, loading, error }] = useRetailBulkAddStoreDepartmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRetailBulkAddStoreDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailBulkAddStoreDepartmentMutation,
    RetailBulkAddStoreDepartmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailBulkAddStoreDepartmentMutation,
    RetailBulkAddStoreDepartmentMutationVariables
  >(RetailBulkAddStoreDepartmentDocument, options)
}
export type RetailBulkAddStoreDepartmentMutationHookResult = ReturnType<
  typeof useRetailBulkAddStoreDepartmentMutation
>
export type RetailBulkAddStoreDepartmentMutationResult =
  Apollo.MutationResult<RetailBulkAddStoreDepartmentMutation>
export type RetailBulkAddStoreDepartmentMutationOptions =
  Apollo.BaseMutationOptions<
    RetailBulkAddStoreDepartmentMutation,
    RetailBulkAddStoreDepartmentMutationVariables
  >
export const RetailGetStoreDepartmentsDocument = /*#__PURE__*/ gql`
  query Retail_GetStoreDepartments($bannerID: ID!, $filterByStoreID: ID) {
    storeDepartments(
      data: { bannerID: $bannerID, filterByStoreID: $filterByStoreID }
    ) {
      id
      name
      storeID
      deactivatedAt
      productCount
      imageURL
      parentDepartment {
        id
        name
      }
      subDepartments {
        id
        name
      }
      store {
        id
        serialID
        name
      }
    }
  }
`

/**
 * __useRetailGetStoreDepartmentsQuery__
 *
 * To run a query within a React component, call `useRetailGetStoreDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailGetStoreDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailGetStoreDepartmentsQuery({
 *   variables: {
 *      bannerID: // value for 'bannerID'
 *      filterByStoreID: // value for 'filterByStoreID'
 *   },
 * });
 */
export function useRetailGetStoreDepartmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailGetStoreDepartmentsQuery,
    RetailGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailGetStoreDepartmentsQuery,
    RetailGetStoreDepartmentsQueryVariables
  >(RetailGetStoreDepartmentsDocument, options)
}
export function useRetailGetStoreDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailGetStoreDepartmentsQuery,
    RetailGetStoreDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailGetStoreDepartmentsQuery,
    RetailGetStoreDepartmentsQueryVariables
  >(RetailGetStoreDepartmentsDocument, options)
}
export type RetailGetStoreDepartmentsQueryHookResult = ReturnType<
  typeof useRetailGetStoreDepartmentsQuery
>
export type RetailGetStoreDepartmentsLazyQueryHookResult = ReturnType<
  typeof useRetailGetStoreDepartmentsLazyQuery
>
export type RetailGetStoreDepartmentsQueryResult = Apollo.QueryResult<
  RetailGetStoreDepartmentsQuery,
  RetailGetStoreDepartmentsQueryVariables
>
export function refetchRetailGetStoreDepartmentsQuery(
  variables: RetailGetStoreDepartmentsQueryVariables,
) {
  return { query: RetailGetStoreDepartmentsDocument, variables: variables }
}
export const RetailGetDepartmentByIdDocument = /*#__PURE__*/ gql`
  query Retail_GetDepartmentById($departmentID: ID!) {
    getStoreDepartmentByID(id: $departmentID) {
      id
      name
      deactivatedAt
      storeID
      productCount
      imageURL
      parentDepartment {
        id
        name
      }
      subDepartments {
        id
        name
      }
      store {
        id
        name
      }
    }
  }
`

/**
 * __useRetailGetDepartmentByIdQuery__
 *
 * To run a query within a React component, call `useRetailGetDepartmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailGetDepartmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailGetDepartmentByIdQuery({
 *   variables: {
 *      departmentID: // value for 'departmentID'
 *   },
 * });
 */
export function useRetailGetDepartmentByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RetailGetDepartmentByIdQuery,
    RetailGetDepartmentByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RetailGetDepartmentByIdQuery,
    RetailGetDepartmentByIdQueryVariables
  >(RetailGetDepartmentByIdDocument, options)
}
export function useRetailGetDepartmentByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetailGetDepartmentByIdQuery,
    RetailGetDepartmentByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RetailGetDepartmentByIdQuery,
    RetailGetDepartmentByIdQueryVariables
  >(RetailGetDepartmentByIdDocument, options)
}
export type RetailGetDepartmentByIdQueryHookResult = ReturnType<
  typeof useRetailGetDepartmentByIdQuery
>
export type RetailGetDepartmentByIdLazyQueryHookResult = ReturnType<
  typeof useRetailGetDepartmentByIdLazyQuery
>
export type RetailGetDepartmentByIdQueryResult = Apollo.QueryResult<
  RetailGetDepartmentByIdQuery,
  RetailGetDepartmentByIdQueryVariables
>
export function refetchRetailGetDepartmentByIdQuery(
  variables: RetailGetDepartmentByIdQueryVariables,
) {
  return { query: RetailGetDepartmentByIdDocument, variables: variables }
}
export const FrontOfficeGetBannerByIdDocument = /*#__PURE__*/ gql`
  query FrontOffice_GetBannerByID($id: ID!) {
    bannerByID(id: $id) {
      id
      name
      frontOfficeURL
    }
  }
`

/**
 * __useFrontOfficeGetBannerByIdQuery__
 *
 * To run a query within a React component, call `useFrontOfficeGetBannerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontOfficeGetBannerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontOfficeGetBannerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFrontOfficeGetBannerByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FrontOfficeGetBannerByIdQuery,
    FrontOfficeGetBannerByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FrontOfficeGetBannerByIdQuery,
    FrontOfficeGetBannerByIdQueryVariables
  >(FrontOfficeGetBannerByIdDocument, options)
}
export function useFrontOfficeGetBannerByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FrontOfficeGetBannerByIdQuery,
    FrontOfficeGetBannerByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FrontOfficeGetBannerByIdQuery,
    FrontOfficeGetBannerByIdQueryVariables
  >(FrontOfficeGetBannerByIdDocument, options)
}
export type FrontOfficeGetBannerByIdQueryHookResult = ReturnType<
  typeof useFrontOfficeGetBannerByIdQuery
>
export type FrontOfficeGetBannerByIdLazyQueryHookResult = ReturnType<
  typeof useFrontOfficeGetBannerByIdLazyQuery
>
export type FrontOfficeGetBannerByIdQueryResult = Apollo.QueryResult<
  FrontOfficeGetBannerByIdQuery,
  FrontOfficeGetBannerByIdQueryVariables
>
export function refetchFrontOfficeGetBannerByIdQuery(
  variables: FrontOfficeGetBannerByIdQueryVariables,
) {
  return { query: FrontOfficeGetBannerByIdDocument, variables: variables }
}
export const FrontOfficeGetMetabaseDashboardQueryDocument = /*#__PURE__*/ gql`
  query FrontOffice_GetMetabaseDashboardQuery {
    getMetabaseDashboardForUserQuery
  }
`

/**
 * __useFrontOfficeGetMetabaseDashboardQueryQuery__
 *
 * To run a query within a React component, call `useFrontOfficeGetMetabaseDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontOfficeGetMetabaseDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontOfficeGetMetabaseDashboardQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrontOfficeGetMetabaseDashboardQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FrontOfficeGetMetabaseDashboardQueryQuery,
    FrontOfficeGetMetabaseDashboardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FrontOfficeGetMetabaseDashboardQueryQuery,
    FrontOfficeGetMetabaseDashboardQueryQueryVariables
  >(FrontOfficeGetMetabaseDashboardQueryDocument, options)
}
export function useFrontOfficeGetMetabaseDashboardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FrontOfficeGetMetabaseDashboardQueryQuery,
    FrontOfficeGetMetabaseDashboardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FrontOfficeGetMetabaseDashboardQueryQuery,
    FrontOfficeGetMetabaseDashboardQueryQueryVariables
  >(FrontOfficeGetMetabaseDashboardQueryDocument, options)
}
export type FrontOfficeGetMetabaseDashboardQueryQueryHookResult = ReturnType<
  typeof useFrontOfficeGetMetabaseDashboardQueryQuery
>
export type FrontOfficeGetMetabaseDashboardQueryLazyQueryHookResult =
  ReturnType<typeof useFrontOfficeGetMetabaseDashboardQueryLazyQuery>
export type FrontOfficeGetMetabaseDashboardQueryQueryResult =
  Apollo.QueryResult<
    FrontOfficeGetMetabaseDashboardQueryQuery,
    FrontOfficeGetMetabaseDashboardQueryQueryVariables
  >
export function refetchFrontOfficeGetMetabaseDashboardQueryQuery(
  variables?: FrontOfficeGetMetabaseDashboardQueryQueryVariables,
) {
  return {
    query: FrontOfficeGetMetabaseDashboardQueryDocument,
    variables: variables,
  }
}
export const FrontOfficeGetExploDashboardQueryDocument = /*#__PURE__*/ gql`
  query FrontOffice_GetExploDashboardQuery {
    getExploDashboardForUserQuery {
      customerToken
      metricsURL
      reportBuilderURL
      timezone
      overviewURL
      promotionsURL
      transactionsURL
      tillsURL
      eodURL
      loyaltyURL
    }
  }
`

/**
 * __useFrontOfficeGetExploDashboardQueryQuery__
 *
 * To run a query within a React component, call `useFrontOfficeGetExploDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontOfficeGetExploDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontOfficeGetExploDashboardQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrontOfficeGetExploDashboardQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FrontOfficeGetExploDashboardQueryQuery,
    FrontOfficeGetExploDashboardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FrontOfficeGetExploDashboardQueryQuery,
    FrontOfficeGetExploDashboardQueryQueryVariables
  >(FrontOfficeGetExploDashboardQueryDocument, options)
}
export function useFrontOfficeGetExploDashboardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FrontOfficeGetExploDashboardQueryQuery,
    FrontOfficeGetExploDashboardQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FrontOfficeGetExploDashboardQueryQuery,
    FrontOfficeGetExploDashboardQueryQueryVariables
  >(FrontOfficeGetExploDashboardQueryDocument, options)
}
export type FrontOfficeGetExploDashboardQueryQueryHookResult = ReturnType<
  typeof useFrontOfficeGetExploDashboardQueryQuery
>
export type FrontOfficeGetExploDashboardQueryLazyQueryHookResult = ReturnType<
  typeof useFrontOfficeGetExploDashboardQueryLazyQuery
>
export type FrontOfficeGetExploDashboardQueryQueryResult = Apollo.QueryResult<
  FrontOfficeGetExploDashboardQueryQuery,
  FrontOfficeGetExploDashboardQueryQueryVariables
>
export function refetchFrontOfficeGetExploDashboardQueryQuery(
  variables?: FrontOfficeGetExploDashboardQueryQueryVariables,
) {
  return {
    query: FrontOfficeGetExploDashboardQueryDocument,
    variables: variables,
  }
}
export const ApIntegrationsMapIntegrationRecordsDocument = /*#__PURE__*/ gql`
  mutation APIntegrations_MapIntegrationRecords(
    $sourceID: ID!
    $sourceType: AccountingIntegrationSourceType!
    $targetID: ID
    $targetType: AccountingIntegrationTargetType!
  ) {
    mapAccountingIntegrationRecords(
      input: {
        sourceID: $sourceID
        sourceType: $sourceType
        targetID: $targetID
        targetType: $targetType
      }
    )
  }
`
export type ApIntegrationsMapIntegrationRecordsMutationFn =
  Apollo.MutationFunction<
    ApIntegrationsMapIntegrationRecordsMutation,
    ApIntegrationsMapIntegrationRecordsMutationVariables
  >

/**
 * __useApIntegrationsMapIntegrationRecordsMutation__
 *
 * To run a mutation, you first call `useApIntegrationsMapIntegrationRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApIntegrationsMapIntegrationRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apIntegrationsMapIntegrationRecordsMutation, { data, loading, error }] = useApIntegrationsMapIntegrationRecordsMutation({
 *   variables: {
 *      sourceID: // value for 'sourceID'
 *      sourceType: // value for 'sourceType'
 *      targetID: // value for 'targetID'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useApIntegrationsMapIntegrationRecordsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApIntegrationsMapIntegrationRecordsMutation,
    ApIntegrationsMapIntegrationRecordsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ApIntegrationsMapIntegrationRecordsMutation,
    ApIntegrationsMapIntegrationRecordsMutationVariables
  >(ApIntegrationsMapIntegrationRecordsDocument, options)
}
export type ApIntegrationsMapIntegrationRecordsMutationHookResult = ReturnType<
  typeof useApIntegrationsMapIntegrationRecordsMutation
>
export type ApIntegrationsMapIntegrationRecordsMutationResult =
  Apollo.MutationResult<ApIntegrationsMapIntegrationRecordsMutation>
export type ApIntegrationsMapIntegrationRecordsMutationOptions =
  Apollo.BaseMutationOptions<
    ApIntegrationsMapIntegrationRecordsMutation,
    ApIntegrationsMapIntegrationRecordsMutationVariables
  >
export const ApIntegrationsGetConfigurationDocument = /*#__PURE__*/ gql`
  query APIntegrations_GetConfiguration {
    accountingIntegrationMappingConfiguration {
      tabs {
        source {
          name
          type
        }
        target {
          name
          type
        }
      }
    }
  }
`

/**
 * __useApIntegrationsGetConfigurationQuery__
 *
 * To run a query within a React component, call `useApIntegrationsGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApIntegrationsGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApIntegrationsGetConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useApIntegrationsGetConfigurationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ApIntegrationsGetConfigurationQuery,
    ApIntegrationsGetConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ApIntegrationsGetConfigurationQuery,
    ApIntegrationsGetConfigurationQueryVariables
  >(ApIntegrationsGetConfigurationDocument, options)
}
export function useApIntegrationsGetConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApIntegrationsGetConfigurationQuery,
    ApIntegrationsGetConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ApIntegrationsGetConfigurationQuery,
    ApIntegrationsGetConfigurationQueryVariables
  >(ApIntegrationsGetConfigurationDocument, options)
}
export type ApIntegrationsGetConfigurationQueryHookResult = ReturnType<
  typeof useApIntegrationsGetConfigurationQuery
>
export type ApIntegrationsGetConfigurationLazyQueryHookResult = ReturnType<
  typeof useApIntegrationsGetConfigurationLazyQuery
>
export type ApIntegrationsGetConfigurationQueryResult = Apollo.QueryResult<
  ApIntegrationsGetConfigurationQuery,
  ApIntegrationsGetConfigurationQueryVariables
>
export function refetchApIntegrationsGetConfigurationQuery(
  variables?: ApIntegrationsGetConfigurationQueryVariables,
) {
  return { query: ApIntegrationsGetConfigurationDocument, variables: variables }
}
export const ApIntegrationsGetRecordsDocument = /*#__PURE__*/ gql`
  query APIntegrations_GetRecords(
    $sourceType: AccountingIntegrationSourceType!
    $storeIDs: [ID!]
    $targetType: AccountingIntegrationTargetType!
  ) {
    accountingIntegrationRecords(
      input: {
        sourceType: $sourceType
        storeIDs: $storeIDs
        targetType: $targetType
      }
    ) {
      sourceRecords {
        details {
          header
          subtitle
          title
        }
        id
        imageURL
        name
        targetRecordID
      }
      targetRecords {
        id
        name
      }
    }
  }
`

/**
 * __useApIntegrationsGetRecordsQuery__
 *
 * To run a query within a React component, call `useApIntegrationsGetRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApIntegrationsGetRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApIntegrationsGetRecordsQuery({
 *   variables: {
 *      sourceType: // value for 'sourceType'
 *      storeIDs: // value for 'storeIDs'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useApIntegrationsGetRecordsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApIntegrationsGetRecordsQuery,
    ApIntegrationsGetRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ApIntegrationsGetRecordsQuery,
    ApIntegrationsGetRecordsQueryVariables
  >(ApIntegrationsGetRecordsDocument, options)
}
export function useApIntegrationsGetRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApIntegrationsGetRecordsQuery,
    ApIntegrationsGetRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ApIntegrationsGetRecordsQuery,
    ApIntegrationsGetRecordsQueryVariables
  >(ApIntegrationsGetRecordsDocument, options)
}
export type ApIntegrationsGetRecordsQueryHookResult = ReturnType<
  typeof useApIntegrationsGetRecordsQuery
>
export type ApIntegrationsGetRecordsLazyQueryHookResult = ReturnType<
  typeof useApIntegrationsGetRecordsLazyQuery
>
export type ApIntegrationsGetRecordsQueryResult = Apollo.QueryResult<
  ApIntegrationsGetRecordsQuery,
  ApIntegrationsGetRecordsQueryVariables
>
export function refetchApIntegrationsGetRecordsQuery(
  variables: ApIntegrationsGetRecordsQueryVariables,
) {
  return { query: ApIntegrationsGetRecordsDocument, variables: variables }
}
export const RetailUpdateStoreProductDocument = /*#__PURE__*/ gql`
  mutation Retail_UpdateStoreProduct(
    $id: String!
    $data: EditableStoreProductFields!
  ) {
    updateStoreProduct(id: $id, data: $data) {
      ...Retail_StoreProduct
    }
  }
  ${RetailStoreProductFragmentDoc}
`
export type RetailUpdateStoreProductMutationFn = Apollo.MutationFunction<
  RetailUpdateStoreProductMutation,
  RetailUpdateStoreProductMutationVariables
>

/**
 * __useRetailUpdateStoreProductMutation__
 *
 * To run a mutation, you first call `useRetailUpdateStoreProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailUpdateStoreProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailUpdateStoreProductMutation, { data, loading, error }] = useRetailUpdateStoreProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRetailUpdateStoreProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailUpdateStoreProductMutation,
    RetailUpdateStoreProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailUpdateStoreProductMutation,
    RetailUpdateStoreProductMutationVariables
  >(RetailUpdateStoreProductDocument, options)
}
export type RetailUpdateStoreProductMutationHookResult = ReturnType<
  typeof useRetailUpdateStoreProductMutation
>
export type RetailUpdateStoreProductMutationResult =
  Apollo.MutationResult<RetailUpdateStoreProductMutation>
export type RetailUpdateStoreProductMutationOptions =
  Apollo.BaseMutationOptions<
    RetailUpdateStoreProductMutation,
    RetailUpdateStoreProductMutationVariables
  >
export const BackOfficeProductManagementBulkUpdateStoreProductsDocument = /*#__PURE__*/ gql`
  mutation BackOfficeProductManagement_BulkUpdateStoreProducts(
    $ids: [ID!]!
    $data: EditableStoreProductFields!
  ) {
    bulkUpdateStoreProducts(ids: $ids, data: $data) {
      id
    }
  }
`
export type BackOfficeProductManagementBulkUpdateStoreProductsMutationFn =
  Apollo.MutationFunction<
    BackOfficeProductManagementBulkUpdateStoreProductsMutation,
    BackOfficeProductManagementBulkUpdateStoreProductsMutationVariables
  >

/**
 * __useBackOfficeProductManagementBulkUpdateStoreProductsMutation__
 *
 * To run a mutation, you first call `useBackOfficeProductManagementBulkUpdateStoreProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeProductManagementBulkUpdateStoreProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backOfficeProductManagementBulkUpdateStoreProductsMutation, { data, loading, error }] = useBackOfficeProductManagementBulkUpdateStoreProductsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBackOfficeProductManagementBulkUpdateStoreProductsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackOfficeProductManagementBulkUpdateStoreProductsMutation,
    BackOfficeProductManagementBulkUpdateStoreProductsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackOfficeProductManagementBulkUpdateStoreProductsMutation,
    BackOfficeProductManagementBulkUpdateStoreProductsMutationVariables
  >(BackOfficeProductManagementBulkUpdateStoreProductsDocument, options)
}
export type BackOfficeProductManagementBulkUpdateStoreProductsMutationHookResult =
  ReturnType<
    typeof useBackOfficeProductManagementBulkUpdateStoreProductsMutation
  >
export type BackOfficeProductManagementBulkUpdateStoreProductsMutationResult =
  Apollo.MutationResult<BackOfficeProductManagementBulkUpdateStoreProductsMutation>
export type BackOfficeProductManagementBulkUpdateStoreProductsMutationOptions =
  Apollo.BaseMutationOptions<
    BackOfficeProductManagementBulkUpdateStoreProductsMutation,
    BackOfficeProductManagementBulkUpdateStoreProductsMutationVariables
  >
export const RetailAddStoreProductDocument = /*#__PURE__*/ gql`
  mutation Retail_AddStoreProduct($data: CreateStoreProductsInput!) {
    createStoreProducts(data: $data) {
      ...Retail_StoreProduct
    }
  }
  ${RetailStoreProductFragmentDoc}
`
export type RetailAddStoreProductMutationFn = Apollo.MutationFunction<
  RetailAddStoreProductMutation,
  RetailAddStoreProductMutationVariables
>

/**
 * __useRetailAddStoreProductMutation__
 *
 * To run a mutation, you first call `useRetailAddStoreProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetailAddStoreProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retailAddStoreProductMutation, { data, loading, error }] = useRetailAddStoreProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRetailAddStoreProductMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetailAddStoreProductMutation,
    RetailAddStoreProductMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetailAddStoreProductMutation,
    RetailAddStoreProductMutationVariables
  >(RetailAddStoreProductDocument, options)
}
export type RetailAddStoreProductMutationHookResult = ReturnType<
  typeof useRetailAddStoreProductMutation
>
export type RetailAddStoreProductMutationResult =
  Apollo.MutationResult<RetailAddStoreProductMutation>
export type RetailAddStoreProductMutationOptions = Apollo.BaseMutationOptions<
  RetailAddStoreProductMutation,
  RetailAddStoreProductMutationVariables
>
export const BackOfficeQueryMasterCatalogDocument = /*#__PURE__*/ gql`
  query BackOffice__QueryMasterCatalog($barcode: String!) {
    queryMasterCatalogProductMetadataByBarcode(barcode: $barcode) {
      brandName
      barcode
      caseSize
      unitVolume
      photoURL
      wholesaleEachCost
      source
      name
      timestamp
    }
  }
`

/**
 * __useBackOfficeQueryMasterCatalogQuery__
 *
 * To run a query within a React component, call `useBackOfficeQueryMasterCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeQueryMasterCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeQueryMasterCatalogQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function useBackOfficeQueryMasterCatalogQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackOfficeQueryMasterCatalogQuery,
    BackOfficeQueryMasterCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeQueryMasterCatalogQuery,
    BackOfficeQueryMasterCatalogQueryVariables
  >(BackOfficeQueryMasterCatalogDocument, options)
}
export function useBackOfficeQueryMasterCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeQueryMasterCatalogQuery,
    BackOfficeQueryMasterCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeQueryMasterCatalogQuery,
    BackOfficeQueryMasterCatalogQueryVariables
  >(BackOfficeQueryMasterCatalogDocument, options)
}
export type BackOfficeQueryMasterCatalogQueryHookResult = ReturnType<
  typeof useBackOfficeQueryMasterCatalogQuery
>
export type BackOfficeQueryMasterCatalogLazyQueryHookResult = ReturnType<
  typeof useBackOfficeQueryMasterCatalogLazyQuery
>
export type BackOfficeQueryMasterCatalogQueryResult = Apollo.QueryResult<
  BackOfficeQueryMasterCatalogQuery,
  BackOfficeQueryMasterCatalogQueryVariables
>
export function refetchBackOfficeQueryMasterCatalogQuery(
  variables: BackOfficeQueryMasterCatalogQueryVariables,
) {
  return { query: BackOfficeQueryMasterCatalogDocument, variables: variables }
}
export const BulkUploadStoreVendorProductsWorkerDocument = /*#__PURE__*/ gql`
  mutation BulkUploadStoreVendorProductsWorker(
    $inputProducts: [BulkStoreVendorProductInput!]!
    $overwrite: Boolean!
    $bannerSQLID: ID!
    $storeSQLIDs: [ID!]!
  ) {
    bulkUploadStoreVendorProductsWorker(
      input: {
        inputProducts: $inputProducts
        overwrite: $overwrite
        bannerSQLID: $bannerSQLID
        storeSQLIDs: $storeSQLIDs
      }
    ) {
      jobID
    }
  }
`
export type BulkUploadStoreVendorProductsWorkerMutationFn =
  Apollo.MutationFunction<
    BulkUploadStoreVendorProductsWorkerMutation,
    BulkUploadStoreVendorProductsWorkerMutationVariables
  >

/**
 * __useBulkUploadStoreVendorProductsWorkerMutation__
 *
 * To run a mutation, you first call `useBulkUploadStoreVendorProductsWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadStoreVendorProductsWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadStoreVendorProductsWorkerMutation, { data, loading, error }] = useBulkUploadStoreVendorProductsWorkerMutation({
 *   variables: {
 *      inputProducts: // value for 'inputProducts'
 *      overwrite: // value for 'overwrite'
 *      bannerSQLID: // value for 'bannerSQLID'
 *      storeSQLIDs: // value for 'storeSQLIDs'
 *   },
 * });
 */
export function useBulkUploadStoreVendorProductsWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUploadStoreVendorProductsWorkerMutation,
    BulkUploadStoreVendorProductsWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkUploadStoreVendorProductsWorkerMutation,
    BulkUploadStoreVendorProductsWorkerMutationVariables
  >(BulkUploadStoreVendorProductsWorkerDocument, options)
}
export type BulkUploadStoreVendorProductsWorkerMutationHookResult = ReturnType<
  typeof useBulkUploadStoreVendorProductsWorkerMutation
>
export type BulkUploadStoreVendorProductsWorkerMutationResult =
  Apollo.MutationResult<BulkUploadStoreVendorProductsWorkerMutation>
export type BulkUploadStoreVendorProductsWorkerMutationOptions =
  Apollo.BaseMutationOptions<
    BulkUploadStoreVendorProductsWorkerMutation,
    BulkUploadStoreVendorProductsWorkerMutationVariables
  >
export const ValidateBulkUploadStoreVendorProductsDocument = /*#__PURE__*/ gql`
  query ValidateBulkUploadStoreVendorProducts(
    $inputProducts: [BulkStoreVendorProductInput!]!
    $storeSQLIDs: [ID!]!
  ) {
    validateBulkUploadStoreVendorProducts(
      inputProducts: $inputProducts
      storeSQLIDs: $storeSQLIDs
    ) {
      errors {
        index
        errorMessages
      }
      spreadsheetURL
      numValidProducts
      numProducts
      numExistingProducts
      numNewProducts
    }
  }
`

/**
 * __useValidateBulkUploadStoreVendorProductsQuery__
 *
 * To run a query within a React component, call `useValidateBulkUploadStoreVendorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBulkUploadStoreVendorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBulkUploadStoreVendorProductsQuery({
 *   variables: {
 *      inputProducts: // value for 'inputProducts'
 *      storeSQLIDs: // value for 'storeSQLIDs'
 *   },
 * });
 */
export function useValidateBulkUploadStoreVendorProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateBulkUploadStoreVendorProductsQuery,
    ValidateBulkUploadStoreVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ValidateBulkUploadStoreVendorProductsQuery,
    ValidateBulkUploadStoreVendorProductsQueryVariables
  >(ValidateBulkUploadStoreVendorProductsDocument, options)
}
export function useValidateBulkUploadStoreVendorProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateBulkUploadStoreVendorProductsQuery,
    ValidateBulkUploadStoreVendorProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ValidateBulkUploadStoreVendorProductsQuery,
    ValidateBulkUploadStoreVendorProductsQueryVariables
  >(ValidateBulkUploadStoreVendorProductsDocument, options)
}
export type ValidateBulkUploadStoreVendorProductsQueryHookResult = ReturnType<
  typeof useValidateBulkUploadStoreVendorProductsQuery
>
export type ValidateBulkUploadStoreVendorProductsLazyQueryHookResult =
  ReturnType<typeof useValidateBulkUploadStoreVendorProductsLazyQuery>
export type ValidateBulkUploadStoreVendorProductsQueryResult =
  Apollo.QueryResult<
    ValidateBulkUploadStoreVendorProductsQuery,
    ValidateBulkUploadStoreVendorProductsQueryVariables
  >
export function refetchValidateBulkUploadStoreVendorProductsQuery(
  variables: ValidateBulkUploadStoreVendorProductsQueryVariables,
) {
  return {
    query: ValidateBulkUploadStoreVendorProductsDocument,
    variables: variables,
  }
}
export const BackOfficeProductManagementExportDocument = /*#__PURE__*/ gql`
  mutation BackOfficeProductManagement_Export(
    $endDate: Timestamp
    $filterByStoreProductSQLIDs: [String!]
    $filterByStoreSQLIDs: [String!]
    $startDate: Timestamp
  ) {
    exportStoreVendorProductsToCSV(
      endDate: $endDate
      filterByStoreProductSQLIDs: $filterByStoreProductSQLIDs
      filterByStoreSQLIDs: $filterByStoreSQLIDs
      startDate: $startDate
    )
  }
`
export type BackOfficeProductManagementExportMutationFn =
  Apollo.MutationFunction<
    BackOfficeProductManagementExportMutation,
    BackOfficeProductManagementExportMutationVariables
  >

/**
 * __useBackOfficeProductManagementExportMutation__
 *
 * To run a mutation, you first call `useBackOfficeProductManagementExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeProductManagementExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backOfficeProductManagementExportMutation, { data, loading, error }] = useBackOfficeProductManagementExportMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      filterByStoreProductSQLIDs: // value for 'filterByStoreProductSQLIDs'
 *      filterByStoreSQLIDs: // value for 'filterByStoreSQLIDs'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useBackOfficeProductManagementExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackOfficeProductManagementExportMutation,
    BackOfficeProductManagementExportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackOfficeProductManagementExportMutation,
    BackOfficeProductManagementExportMutationVariables
  >(BackOfficeProductManagementExportDocument, options)
}
export type BackOfficeProductManagementExportMutationHookResult = ReturnType<
  typeof useBackOfficeProductManagementExportMutation
>
export type BackOfficeProductManagementExportMutationResult =
  Apollo.MutationResult<BackOfficeProductManagementExportMutation>
export type BackOfficeProductManagementExportMutationOptions =
  Apollo.BaseMutationOptions<
    BackOfficeProductManagementExportMutation,
    BackOfficeProductManagementExportMutationVariables
  >
export const BackOfficeGetProductByBarcodeDocument = /*#__PURE__*/ gql`
  query BackOffice_GetProductByBarcode($barcode: String!, $storeID: String!) {
    queryStoreProductByBarcode(
      barcode: $barcode
      filterByStoreSQLIDs: [$storeID]
    ) {
      id
      name
      storeID
    }
  }
`

/**
 * __useBackOfficeGetProductByBarcodeQuery__
 *
 * To run a query within a React component, call `useBackOfficeGetProductByBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeGetProductByBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeGetProductByBarcodeQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useBackOfficeGetProductByBarcodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackOfficeGetProductByBarcodeQuery,
    BackOfficeGetProductByBarcodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeGetProductByBarcodeQuery,
    BackOfficeGetProductByBarcodeQueryVariables
  >(BackOfficeGetProductByBarcodeDocument, options)
}
export function useBackOfficeGetProductByBarcodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeGetProductByBarcodeQuery,
    BackOfficeGetProductByBarcodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeGetProductByBarcodeQuery,
    BackOfficeGetProductByBarcodeQueryVariables
  >(BackOfficeGetProductByBarcodeDocument, options)
}
export type BackOfficeGetProductByBarcodeQueryHookResult = ReturnType<
  typeof useBackOfficeGetProductByBarcodeQuery
>
export type BackOfficeGetProductByBarcodeLazyQueryHookResult = ReturnType<
  typeof useBackOfficeGetProductByBarcodeLazyQuery
>
export type BackOfficeGetProductByBarcodeQueryResult = Apollo.QueryResult<
  BackOfficeGetProductByBarcodeQuery,
  BackOfficeGetProductByBarcodeQueryVariables
>
export function refetchBackOfficeGetProductByBarcodeQuery(
  variables: BackOfficeGetProductByBarcodeQueryVariables,
) {
  return { query: BackOfficeGetProductByBarcodeDocument, variables: variables }
}
export const BackOfficeProductManagementExportEplumDocument = /*#__PURE__*/ gql`
  query BackOfficeProductManagement_ExportEPLUM($storeID: String!) {
    getEPLUMProductsForStoreQuery(storeID: $storeID)
  }
`

/**
 * __useBackOfficeProductManagementExportEplumQuery__
 *
 * To run a query within a React component, call `useBackOfficeProductManagementExportEplumQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeProductManagementExportEplumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeProductManagementExportEplumQuery({
 *   variables: {
 *      storeID: // value for 'storeID'
 *   },
 * });
 */
export function useBackOfficeProductManagementExportEplumQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackOfficeProductManagementExportEplumQuery,
    BackOfficeProductManagementExportEplumQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeProductManagementExportEplumQuery,
    BackOfficeProductManagementExportEplumQueryVariables
  >(BackOfficeProductManagementExportEplumDocument, options)
}
export function useBackOfficeProductManagementExportEplumLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeProductManagementExportEplumQuery,
    BackOfficeProductManagementExportEplumQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeProductManagementExportEplumQuery,
    BackOfficeProductManagementExportEplumQueryVariables
  >(BackOfficeProductManagementExportEplumDocument, options)
}
export type BackOfficeProductManagementExportEplumQueryHookResult = ReturnType<
  typeof useBackOfficeProductManagementExportEplumQuery
>
export type BackOfficeProductManagementExportEplumLazyQueryHookResult =
  ReturnType<typeof useBackOfficeProductManagementExportEplumLazyQuery>
export type BackOfficeProductManagementExportEplumQueryResult =
  Apollo.QueryResult<
    BackOfficeProductManagementExportEplumQuery,
    BackOfficeProductManagementExportEplumQueryVariables
  >
export function refetchBackOfficeProductManagementExportEplumQuery(
  variables: BackOfficeProductManagementExportEplumQueryVariables,
) {
  return {
    query: BackOfficeProductManagementExportEplumDocument,
    variables: variables,
  }
}
export const BackOfficeTaxManagementAddTaxRateDocument = /*#__PURE__*/ gql`
  mutation BackOfficeTaxManagement_AddTaxRate($object: MutateTaxRateInput!) {
    createTaxRate(data: $object) {
      id
      type
      value
      status
      createdAt
      name
    }
  }
`
export type BackOfficeTaxManagementAddTaxRateMutationFn =
  Apollo.MutationFunction<
    BackOfficeTaxManagementAddTaxRateMutation,
    BackOfficeTaxManagementAddTaxRateMutationVariables
  >

/**
 * __useBackOfficeTaxManagementAddTaxRateMutation__
 *
 * To run a mutation, you first call `useBackOfficeTaxManagementAddTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeTaxManagementAddTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backOfficeTaxManagementAddTaxRateMutation, { data, loading, error }] = useBackOfficeTaxManagementAddTaxRateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useBackOfficeTaxManagementAddTaxRateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackOfficeTaxManagementAddTaxRateMutation,
    BackOfficeTaxManagementAddTaxRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackOfficeTaxManagementAddTaxRateMutation,
    BackOfficeTaxManagementAddTaxRateMutationVariables
  >(BackOfficeTaxManagementAddTaxRateDocument, options)
}
export type BackOfficeTaxManagementAddTaxRateMutationHookResult = ReturnType<
  typeof useBackOfficeTaxManagementAddTaxRateMutation
>
export type BackOfficeTaxManagementAddTaxRateMutationResult =
  Apollo.MutationResult<BackOfficeTaxManagementAddTaxRateMutation>
export type BackOfficeTaxManagementAddTaxRateMutationOptions =
  Apollo.BaseMutationOptions<
    BackOfficeTaxManagementAddTaxRateMutation,
    BackOfficeTaxManagementAddTaxRateMutationVariables
  >
export const BackOfficeTaxManagementUpdateTaxRateDocument = /*#__PURE__*/ gql`
  mutation BackOfficeTaxManagement_UpdateTaxRate(
    $object: MutateTaxRateInput!
    $id: String!
  ) {
    updateTaxRate(data: $object, id: $id) {
      id
      type
      value
      status
      createdAt
      name
    }
  }
`
export type BackOfficeTaxManagementUpdateTaxRateMutationFn =
  Apollo.MutationFunction<
    BackOfficeTaxManagementUpdateTaxRateMutation,
    BackOfficeTaxManagementUpdateTaxRateMutationVariables
  >

/**
 * __useBackOfficeTaxManagementUpdateTaxRateMutation__
 *
 * To run a mutation, you first call `useBackOfficeTaxManagementUpdateTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeTaxManagementUpdateTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backOfficeTaxManagementUpdateTaxRateMutation, { data, loading, error }] = useBackOfficeTaxManagementUpdateTaxRateMutation({
 *   variables: {
 *      object: // value for 'object'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackOfficeTaxManagementUpdateTaxRateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackOfficeTaxManagementUpdateTaxRateMutation,
    BackOfficeTaxManagementUpdateTaxRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackOfficeTaxManagementUpdateTaxRateMutation,
    BackOfficeTaxManagementUpdateTaxRateMutationVariables
  >(BackOfficeTaxManagementUpdateTaxRateDocument, options)
}
export type BackOfficeTaxManagementUpdateTaxRateMutationHookResult = ReturnType<
  typeof useBackOfficeTaxManagementUpdateTaxRateMutation
>
export type BackOfficeTaxManagementUpdateTaxRateMutationResult =
  Apollo.MutationResult<BackOfficeTaxManagementUpdateTaxRateMutation>
export type BackOfficeTaxManagementUpdateTaxRateMutationOptions =
  Apollo.BaseMutationOptions<
    BackOfficeTaxManagementUpdateTaxRateMutation,
    BackOfficeTaxManagementUpdateTaxRateMutationVariables
  >
export const BackOfficeTaxManagementGetTaxRatesDocument = /*#__PURE__*/ gql`
  query BackOfficeTaxManagement_GetTaxRates {
    taxRates {
      createdAt
      updatedAt
      id
      name
      productCount
      status
      type
      taxType
      value
    }
  }
`

/**
 * __useBackOfficeTaxManagementGetTaxRatesQuery__
 *
 * To run a query within a React component, call `useBackOfficeTaxManagementGetTaxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeTaxManagementGetTaxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeTaxManagementGetTaxRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackOfficeTaxManagementGetTaxRatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackOfficeTaxManagementGetTaxRatesQuery,
    BackOfficeTaxManagementGetTaxRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeTaxManagementGetTaxRatesQuery,
    BackOfficeTaxManagementGetTaxRatesQueryVariables
  >(BackOfficeTaxManagementGetTaxRatesDocument, options)
}
export function useBackOfficeTaxManagementGetTaxRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeTaxManagementGetTaxRatesQuery,
    BackOfficeTaxManagementGetTaxRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeTaxManagementGetTaxRatesQuery,
    BackOfficeTaxManagementGetTaxRatesQueryVariables
  >(BackOfficeTaxManagementGetTaxRatesDocument, options)
}
export type BackOfficeTaxManagementGetTaxRatesQueryHookResult = ReturnType<
  typeof useBackOfficeTaxManagementGetTaxRatesQuery
>
export type BackOfficeTaxManagementGetTaxRatesLazyQueryHookResult = ReturnType<
  typeof useBackOfficeTaxManagementGetTaxRatesLazyQuery
>
export type BackOfficeTaxManagementGetTaxRatesQueryResult = Apollo.QueryResult<
  BackOfficeTaxManagementGetTaxRatesQuery,
  BackOfficeTaxManagementGetTaxRatesQueryVariables
>
export function refetchBackOfficeTaxManagementGetTaxRatesQuery(
  variables?: BackOfficeTaxManagementGetTaxRatesQueryVariables,
) {
  return {
    query: BackOfficeTaxManagementGetTaxRatesDocument,
    variables: variables,
  }
}
export const BackOfficeTaxManagementGetTaxRateDocument = /*#__PURE__*/ gql`
  query BackOfficeTaxManagement_GetTaxRate($id: String!) {
    taxRate(id: $id) {
      createdAt
      updatedAt
      id
      name
      productCount
      status
      taxType
      type
      value
    }
  }
`

/**
 * __useBackOfficeTaxManagementGetTaxRateQuery__
 *
 * To run a query within a React component, call `useBackOfficeTaxManagementGetTaxRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeTaxManagementGetTaxRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeTaxManagementGetTaxRateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackOfficeTaxManagementGetTaxRateQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackOfficeTaxManagementGetTaxRateQuery,
    BackOfficeTaxManagementGetTaxRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeTaxManagementGetTaxRateQuery,
    BackOfficeTaxManagementGetTaxRateQueryVariables
  >(BackOfficeTaxManagementGetTaxRateDocument, options)
}
export function useBackOfficeTaxManagementGetTaxRateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeTaxManagementGetTaxRateQuery,
    BackOfficeTaxManagementGetTaxRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeTaxManagementGetTaxRateQuery,
    BackOfficeTaxManagementGetTaxRateQueryVariables
  >(BackOfficeTaxManagementGetTaxRateDocument, options)
}
export type BackOfficeTaxManagementGetTaxRateQueryHookResult = ReturnType<
  typeof useBackOfficeTaxManagementGetTaxRateQuery
>
export type BackOfficeTaxManagementGetTaxRateLazyQueryHookResult = ReturnType<
  typeof useBackOfficeTaxManagementGetTaxRateLazyQuery
>
export type BackOfficeTaxManagementGetTaxRateQueryResult = Apollo.QueryResult<
  BackOfficeTaxManagementGetTaxRateQuery,
  BackOfficeTaxManagementGetTaxRateQueryVariables
>
export function refetchBackOfficeTaxManagementGetTaxRateQuery(
  variables: BackOfficeTaxManagementGetTaxRateQueryVariables,
) {
  return {
    query: BackOfficeTaxManagementGetTaxRateDocument,
    variables: variables,
  }
}
export const BackOfficeVendorManagementCreateVendorDocument = /*#__PURE__*/ gql`
  mutation BackOfficeVendorManagement_CreateVendor(
    $bannerFirestoreID: String!
    $data: StoreVendorCreateFields!
    $storeSerialIDs: [String!]
  ) {
    createStoreVendors(
      bannerFirestoreID: $bannerFirestoreID
      data: $data
      storeSerialIDs: $storeSerialIDs
    ) {
      id
    }
  }
`
export type BackOfficeVendorManagementCreateVendorMutationFn =
  Apollo.MutationFunction<
    BackOfficeVendorManagementCreateVendorMutation,
    BackOfficeVendorManagementCreateVendorMutationVariables
  >

/**
 * __useBackOfficeVendorManagementCreateVendorMutation__
 *
 * To run a mutation, you first call `useBackOfficeVendorManagementCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeVendorManagementCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backOfficeVendorManagementCreateVendorMutation, { data, loading, error }] = useBackOfficeVendorManagementCreateVendorMutation({
 *   variables: {
 *      bannerFirestoreID: // value for 'bannerFirestoreID'
 *      data: // value for 'data'
 *      storeSerialIDs: // value for 'storeSerialIDs'
 *   },
 * });
 */
export function useBackOfficeVendorManagementCreateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackOfficeVendorManagementCreateVendorMutation,
    BackOfficeVendorManagementCreateVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackOfficeVendorManagementCreateVendorMutation,
    BackOfficeVendorManagementCreateVendorMutationVariables
  >(BackOfficeVendorManagementCreateVendorDocument, options)
}
export type BackOfficeVendorManagementCreateVendorMutationHookResult =
  ReturnType<typeof useBackOfficeVendorManagementCreateVendorMutation>
export type BackOfficeVendorManagementCreateVendorMutationResult =
  Apollo.MutationResult<BackOfficeVendorManagementCreateVendorMutation>
export type BackOfficeVendorManagementCreateVendorMutationOptions =
  Apollo.BaseMutationOptions<
    BackOfficeVendorManagementCreateVendorMutation,
    BackOfficeVendorManagementCreateVendorMutationVariables
  >
export const BackOfficeVendorManagementUpdateVendorDocument = /*#__PURE__*/ gql`
  mutation BackOfficeVendorManagement_UpdateVendor(
    $data: StoreVendorEditableFields!
    $id: ID!
  ) {
    updateStoreVendor(id: $id, data: $data) {
      id
    }
  }
`
export type BackOfficeVendorManagementUpdateVendorMutationFn =
  Apollo.MutationFunction<
    BackOfficeVendorManagementUpdateVendorMutation,
    BackOfficeVendorManagementUpdateVendorMutationVariables
  >

/**
 * __useBackOfficeVendorManagementUpdateVendorMutation__
 *
 * To run a mutation, you first call `useBackOfficeVendorManagementUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeVendorManagementUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backOfficeVendorManagementUpdateVendorMutation, { data, loading, error }] = useBackOfficeVendorManagementUpdateVendorMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackOfficeVendorManagementUpdateVendorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackOfficeVendorManagementUpdateVendorMutation,
    BackOfficeVendorManagementUpdateVendorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackOfficeVendorManagementUpdateVendorMutation,
    BackOfficeVendorManagementUpdateVendorMutationVariables
  >(BackOfficeVendorManagementUpdateVendorDocument, options)
}
export type BackOfficeVendorManagementUpdateVendorMutationHookResult =
  ReturnType<typeof useBackOfficeVendorManagementUpdateVendorMutation>
export type BackOfficeVendorManagementUpdateVendorMutationResult =
  Apollo.MutationResult<BackOfficeVendorManagementUpdateVendorMutation>
export type BackOfficeVendorManagementUpdateVendorMutationOptions =
  Apollo.BaseMutationOptions<
    BackOfficeVendorManagementUpdateVendorMutation,
    BackOfficeVendorManagementUpdateVendorMutationVariables
  >
export const BackOfficeVendorManagementSearchVendorsDocument = /*#__PURE__*/ gql`
  query BackOfficeVendorManagement_SearchVendors($query: String!) {
    searchVendors(input: { search: $query, limit: 10 }) {
      nodes {
        id
        serialID
        imgURL
        name
      }
    }
  }
`

/**
 * __useBackOfficeVendorManagementSearchVendorsQuery__
 *
 * To run a query within a React component, call `useBackOfficeVendorManagementSearchVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeVendorManagementSearchVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeVendorManagementSearchVendorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBackOfficeVendorManagementSearchVendorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackOfficeVendorManagementSearchVendorsQuery,
    BackOfficeVendorManagementSearchVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeVendorManagementSearchVendorsQuery,
    BackOfficeVendorManagementSearchVendorsQueryVariables
  >(BackOfficeVendorManagementSearchVendorsDocument, options)
}
export function useBackOfficeVendorManagementSearchVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeVendorManagementSearchVendorsQuery,
    BackOfficeVendorManagementSearchVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeVendorManagementSearchVendorsQuery,
    BackOfficeVendorManagementSearchVendorsQueryVariables
  >(BackOfficeVendorManagementSearchVendorsDocument, options)
}
export type BackOfficeVendorManagementSearchVendorsQueryHookResult = ReturnType<
  typeof useBackOfficeVendorManagementSearchVendorsQuery
>
export type BackOfficeVendorManagementSearchVendorsLazyQueryHookResult =
  ReturnType<typeof useBackOfficeVendorManagementSearchVendorsLazyQuery>
export type BackOfficeVendorManagementSearchVendorsQueryResult =
  Apollo.QueryResult<
    BackOfficeVendorManagementSearchVendorsQuery,
    BackOfficeVendorManagementSearchVendorsQueryVariables
  >
export function refetchBackOfficeVendorManagementSearchVendorsQuery(
  variables: BackOfficeVendorManagementSearchVendorsQueryVariables,
) {
  return {
    query: BackOfficeVendorManagementSearchVendorsDocument,
    variables: variables,
  }
}
export const BackOfficeVendorManagementGetVendorDocument = /*#__PURE__*/ gql`
  query BackOfficeVendorManagement_GetVendor($id: String!) {
    storeVendor(id: $id) {
      billingName
      contactName
      contactPhone
      deactivatedAt
      id
      minOrderValue
      name
      ordersEmail
      taxID
      vendorID
      billingAddress {
        addressLine1
        addressLine2
      }
      store {
        id
        name
        serialID
      }
    }
  }
`

/**
 * __useBackOfficeVendorManagementGetVendorQuery__
 *
 * To run a query within a React component, call `useBackOfficeVendorManagementGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeVendorManagementGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeVendorManagementGetVendorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackOfficeVendorManagementGetVendorQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackOfficeVendorManagementGetVendorQuery,
    BackOfficeVendorManagementGetVendorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeVendorManagementGetVendorQuery,
    BackOfficeVendorManagementGetVendorQueryVariables
  >(BackOfficeVendorManagementGetVendorDocument, options)
}
export function useBackOfficeVendorManagementGetVendorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeVendorManagementGetVendorQuery,
    BackOfficeVendorManagementGetVendorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeVendorManagementGetVendorQuery,
    BackOfficeVendorManagementGetVendorQueryVariables
  >(BackOfficeVendorManagementGetVendorDocument, options)
}
export type BackOfficeVendorManagementGetVendorQueryHookResult = ReturnType<
  typeof useBackOfficeVendorManagementGetVendorQuery
>
export type BackOfficeVendorManagementGetVendorLazyQueryHookResult = ReturnType<
  typeof useBackOfficeVendorManagementGetVendorLazyQuery
>
export type BackOfficeVendorManagementGetVendorQueryResult = Apollo.QueryResult<
  BackOfficeVendorManagementGetVendorQuery,
  BackOfficeVendorManagementGetVendorQueryVariables
>
export function refetchBackOfficeVendorManagementGetVendorQuery(
  variables: BackOfficeVendorManagementGetVendorQueryVariables,
) {
  return {
    query: BackOfficeVendorManagementGetVendorDocument,
    variables: variables,
  }
}
export const BackOfficeVendorManagementGetStoreVendorsDocument = /*#__PURE__*/ gql`
  query BackOfficeVendorManagement_GetStoreVendors {
    storeVendors {
      contactName
      contactPhone
      deactivatedAt
      id
      name
      vendorID
      store {
        id
        name
        serialID
      }
    }
  }
`

/**
 * __useBackOfficeVendorManagementGetStoreVendorsQuery__
 *
 * To run a query within a React component, call `useBackOfficeVendorManagementGetStoreVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackOfficeVendorManagementGetStoreVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackOfficeVendorManagementGetStoreVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackOfficeVendorManagementGetStoreVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackOfficeVendorManagementGetStoreVendorsQuery,
    BackOfficeVendorManagementGetStoreVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackOfficeVendorManagementGetStoreVendorsQuery,
    BackOfficeVendorManagementGetStoreVendorsQueryVariables
  >(BackOfficeVendorManagementGetStoreVendorsDocument, options)
}
export function useBackOfficeVendorManagementGetStoreVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackOfficeVendorManagementGetStoreVendorsQuery,
    BackOfficeVendorManagementGetStoreVendorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackOfficeVendorManagementGetStoreVendorsQuery,
    BackOfficeVendorManagementGetStoreVendorsQueryVariables
  >(BackOfficeVendorManagementGetStoreVendorsDocument, options)
}
export type BackOfficeVendorManagementGetStoreVendorsQueryHookResult =
  ReturnType<typeof useBackOfficeVendorManagementGetStoreVendorsQuery>
export type BackOfficeVendorManagementGetStoreVendorsLazyQueryHookResult =
  ReturnType<typeof useBackOfficeVendorManagementGetStoreVendorsLazyQuery>
export type BackOfficeVendorManagementGetStoreVendorsQueryResult =
  Apollo.QueryResult<
    BackOfficeVendorManagementGetStoreVendorsQuery,
    BackOfficeVendorManagementGetStoreVendorsQueryVariables
  >
export function refetchBackOfficeVendorManagementGetStoreVendorsQuery(
  variables?: BackOfficeVendorManagementGetStoreVendorsQueryVariables,
) {
  return {
    query: BackOfficeVendorManagementGetStoreVendorsDocument,
    variables: variables,
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Currency: number
  /** Base64 encoded pagination cursor */
  Cursor: any
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any
  Decimal: any
  /** Custom timestamp scalar type */
  Timestamp: Date | string
  /** The `Upload` scalar type represents a file upload. */
  Upload: any
}

export type AccountSpecificPrice = {
  __typename?: 'AccountSpecificPrice'
  accountID: Scalars['String']
  price: Scalars['Currency']
}

export type AccountSpecificPriceInput = {
  accountID: Scalars['String']
  price?: InputMaybe<Scalars['Currency']>
}

/**
 * ****************************
 *     Accounting Integration
 * ****************************
 */
export type AccountingIntegration = {
  __typename?: 'AccountingIntegration'
  complete: Scalars['Boolean']
  vendorMappingOneWay: Scalars['Boolean']
}

export type AccountingIntegrationMappingConfig = {
  __typename?: 'AccountingIntegrationMappingConfig'
  tabs: Array<AccountingIntegrationModelMapping>
}

export type AccountingIntegrationModelMapping = {
  __typename?: 'AccountingIntegrationModelMapping'
  source: AccountingIntegrationSourceModel
  target: AccountingIntegrationTargetModel
}

export type AccountingIntegrationRecords = {
  __typename?: 'AccountingIntegrationRecords'
  sourceRecords: Array<AccountingIntegrationSourceRecord>
  targetRecords: Array<AccountingIntegrationTargetRecord>
}

export type AccountingIntegrationRecordsInput = {
  sourceType: AccountingIntegrationSourceType
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
  targetType: AccountingIntegrationTargetType
}

export type AccountingIntegrationSourceDetails = {
  __typename?: 'AccountingIntegrationSourceDetails'
  header: Scalars['String']
  subtitle?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type AccountingIntegrationSourceModel = {
  __typename?: 'AccountingIntegrationSourceModel'
  name: Scalars['String']
  type: AccountingIntegrationSourceType
}

export type AccountingIntegrationSourceRecord = {
  __typename?: 'AccountingIntegrationSourceRecord'
  details: AccountingIntegrationSourceDetails
  id: Scalars['ID']
  imageURL: Scalars['String']
  name: Scalars['String']
  targetRecordID?: Maybe<Scalars['ID']>
}

export enum AccountingIntegrationSourceType {
  Department = 'DEPARTMENT',
  Store = 'STORE',
  StoreVendor = 'STORE_VENDOR',
  Vendor = 'VENDOR',
}

export type AccountingIntegrationTargetModel = {
  __typename?: 'AccountingIntegrationTargetModel'
  name: Scalars['String']
  type: AccountingIntegrationTargetType
}

export type AccountingIntegrationTargetRecord = {
  __typename?: 'AccountingIntegrationTargetRecord'
  id: Scalars['ID']
  name: Scalars['String']
}

export enum AccountingIntegrationTargetType {
  CodatAccount = 'CODAT_ACCOUNT',
  CodatSupplier = 'CODAT_SUPPLIER',
  CodatTrackingCategory = 'CODAT_TRACKING_CATEGORY',
  FmsDepartment = 'FMS_DEPARTMENT',
  FmsStore = 'FMS_STORE',
  FmsVendor = 'FMS_VENDOR',
}

export enum AccountingPlatformInvoiceSyncStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export enum AcquisitionSource {
  EmailCampaign = 'EMAIL_CAMPAIGN',
  Event = 'EVENT',
  ListPurchase = 'LIST_PURCHASE',
  Partner = 'PARTNER',
  SalesOutbound = 'SALES_OUTBOUND',
  StoreReferral = 'STORE_REFERRAL',
  ThirdPartyDigitalAd = 'THIRD_PARTY_DIGITAL_AD',
  VendorReferral = 'VENDOR_REFERRAL',
  Webinar = 'WEBINAR',
  Website = 'WEBSITE',
}

export type AddProductsToOrderGuideInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  /** Optional: which user's OrderGuide to update. If not provided, this mutation defaults to the authenticated user. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type AddProductsToV2OrderGuideForStoreDepartmentInput = {
  searchID?: InputMaybe<Scalars['String']>
  storeDepartmentID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type AddProductsToV2OrderGuideInput = {
  vendorProductIDs: Array<Scalars['ID']>
  vendorStoreDepartmentAccountID: Scalars['ID']
}

export type AddProductsToV2OrderGuideResult = {
  __typename?: 'AddProductsToV2OrderGuideResult'
  addedVendorProducts: Array<VendorProduct>
  orderGuide: V2OrderGuide
}

export type AddressComponents = {
  __typename?: 'AddressComponents'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  county?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type AdminAllOrdersInput = {
  limit?: InputMaybe<Scalars['Int']>
  orderDateSince?: InputMaybe<Scalars['Timestamp']>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type AdminAllStoresInput = {
  /** Filter stores by name, address, email, placeID or geographicCoordinates */
  query?: InputMaybe<Scalars['String']>
}

export type AdminAllUsersInput = {
  companyID?: InputMaybe<Scalars['String']>
  storeID?: InputMaybe<Scalars['String']>
  /** Optional list of user types to filter by */
  userTypeFilter?: InputMaybe<Array<UserType>>
}

/**
 * ****************************
 *     EDI Service Admin
 * ****************************
 */
export type AdminCreateEdiPartnerInput = {
  ediPartnerName: Scalars['ID']
  interchangeNumber?: InputMaybe<Scalars['Int']>
  vendorID: Scalars['ID']
}

export type AdminCreateFeatureFlagInput = {
  /** The name=ID of the feature flag. This is the string clients use to check a user's access to the flagged feature. */
  name: Scalars['String']
}

export type AdminCreateSftpGoUserInput = {
  description?: InputMaybe<Scalars['String']>
  fileType: SftpFileType
  password: Scalars['String']
  username: Scalars['String']
}

export type AdminSimilarStoresInput = {
  address: Scalars['String']
  geographicCoordinates?: InputMaybe<Scalars['String']>
  /** Find similar / duplicate stores by name, address, email, geographicCoordinates or placeID */
  name: Scalars['String']
  placeID: Scalars['String']
}

export type AdminStoreInvitationsInput = {
  cursor?: InputMaybe<Scalars['ID']>
  email?: InputMaybe<Scalars['String']>
  invitedByUserEmail?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  signedUpEmail?: InputMaybe<Scalars['String']>
  status?: InputMaybe<InvitationStatus>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type AdminStoreVendorProductsQueryResult = {
  __typename?: 'AdminStoreVendorProductsQueryResult'
  cursor: Scalars['Float']
  hasMore: Scalars['Boolean']
  nodes: Array<StoreVendorProductResult>
  totalCount: Scalars['Float']
}

export type AdminStoreVendorsQueryResult = {
  __typename?: 'AdminStoreVendorsQueryResult'
  cursor: Scalars['Float']
  hasMore: Scalars['Boolean']
  nodes: Array<StoreVendorResult>
  totalCount: Scalars['Float']
}

export type AdminStoresResult = {
  __typename?: 'AdminStoresResult'
  nodes: Array<Store>
}

export type AdminUpdateFeatureFlagInput = {
  defaultBehavior?: InputMaybe<FeatureFlagDefaultBehavior>
  description?: InputMaybe<Scalars['String']>
  excludedLaneIDs?: InputMaybe<Array<Scalars['ID']>>
  excludedUserIDs?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  includedLaneIDs?: InputMaybe<Array<Scalars['ID']>>
  includedUserIDs?: InputMaybe<Array<Scalars['ID']>>
  rules?: InputMaybe<Array<FeatureFlagRuleInput>>
}

export type AdminUsersPaginatedFilters = {
  companyID?: InputMaybe<Scalars['ID']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  userTypes?: InputMaybe<Array<UserType>>
}

export type AdminUsersPaginatedInput = {
  cursor?: InputMaybe<Scalars['ID']>
  filter?: InputMaybe<AdminUsersPaginatedFilters>
  limit?: InputMaybe<Scalars['Int']>
}

export type AdminVendorInvitationsInput = {
  cursor?: InputMaybe<Scalars['ID']>
  inviteEmail?: InputMaybe<Scalars['String']>
  invitedByUserEmail?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  status?: InputMaybe<InvitationStatus>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type AdminVendorInvitationsResult = {
  __typename?: 'AdminVendorInvitationsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<VendorInvitation>
  totalCount: Scalars['Int']
}

export type AdminVendorStoreDepartmentAccountsResult = {
  __typename?: 'AdminVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
}

export type AdminVendorsResult = {
  __typename?: 'AdminVendorsResult'
  nodes: Array<Maybe<Vendor>>
}

export type AllBannersResult = {
  __typename?: 'AllBannersResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Banner>
  totalCount: Scalars['Int']
}

export type AllOrderGuideProductsInput = {
  productIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type AllOrderGuideProductsResult = {
  __typename?: 'AllOrderGuideProductsResult'
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type AllStoresResult = {
  __typename?: 'AllStoresResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Store>
  totalCount: Scalars['Int']
}

export type AllVendorsResult = {
  __typename?: 'AllVendorsResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type ArchivedOrderGuide = {
  __typename?: 'ArchivedOrderGuide'
  added?: Maybe<Array<Scalars['String']>>
  orderGuide?: Maybe<Array<Scalars['String']>>
  removed?: Maybe<Array<Scalars['String']>>
  timestamp: Scalars['String']
  timestampFull?: Maybe<Scalars['Timestamp']>
}

export type ArchivedOrderGuidesResult = {
  __typename?: 'ArchivedOrderGuidesResult'
  nodes: Array<ArchivedOrderGuide>
  totalCount: Scalars['Int']
}

export type Audience = {
  __typename?: 'Audience'
  id: Scalars['ID']
  name: Scalars['String']
  prospectiveStoreAccounts: StoresResult
  storeAccounts: VendorStoreAccountsResult
  vendor: Vendor
}

export type AudiencesResult = {
  __typename?: 'AudiencesResult'
  nodes: Array<Audience>
}

export type AuthorizedVendorsInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export enum BillingType {
  FlatCharge = 'FLAT_CHARGE',
  PercentageCharge = 'PERCENTAGE_CHARGE',
  PerOrderCharge = 'PER_ORDER_CHARGE',
  PerStoreCharge = 'PER_STORE_CHARGE',
}

export type Banner = {
  __typename?: 'Banner'
  acquisitionDetail?: Maybe<Scalars['String']>
  acquisitionSource?: Maybe<AcquisitionSource>
  authorizedVendors: VendorsResult
  bannerType?: Maybe<StoreType>
  billingInfo?: Maybe<BillingInfo>
  discoverableVendors: VendorsResult
  frontOfficeURL?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  orders: BannerOrdersResult
  paymentProfile?: Maybe<PaymentProfile>
  referredByCompany?: Maybe<Company>
  serialID?: Maybe<Scalars['ID']>
  status?: Maybe<BannerStatus>
  stores: BannerStoresResult
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccounts: BannerVendorStoreAccountsResult
  /** All vendorProducts for a given Vendor, including store-private products across all of the banner's stores */
  vendorProducts: VendorProductsResult
  /** Returns VendorStoreDepartmentAccounts across all stores. */
  vendorStoreDepartmentAccounts: BannerVendorStoreDepartmentAccountsResult
  /** Returns a deduped list of Vendors across all stores based on all VendorStoreDepartmentAccounts. */
  vendors: BannerVendorsResult
}

export type BannerAuthorizedVendorsArgs = {
  input?: InputMaybe<AuthorizedVendorsInput>
}

export type BannerDiscoverableVendorsArgs = {
  input?: InputMaybe<DiscoverableVendorsInput>
}

export type BannerOrdersArgs = {
  input?: InputMaybe<BannerOrdersInput>
}

export type BannerStoresArgs = {
  input?: InputMaybe<BannerStoresInput>
}

export type BannerVendorAccountsArgs = {
  input?: InputMaybe<BannerVendorStoreAccountInput>
}

export type BannerVendorProductsArgs = {
  input: BannerVendorProductsInput
}

export type BannerVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<BannerVendorStoreDepartmentAccountsInput>
}

export type BannerVendorsArgs = {
  input?: InputMaybe<BannerVendorsInput>
}

export type BannerOrderGuideUpdateResult = {
  __typename?: 'BannerOrderGuideUpdateResult'
  bannerStores: Array<Store>
  productsAddedToOrderGuide: Array<VendorProduct>
  users: Array<User>
}

export type BannerOrdersInput = {
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  /**
   * Use the buyer's email address or their id, to apply this filter; This is due
   * to the data structure of orders, only saving the buyer's email as an identifier.
   */
  filterByBuyer?: InputMaybe<Scalars['ID']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterBySent?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByStoreDepartmentID?: InputMaybe<Scalars['ID']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  receivingStatus?: InputMaybe<OrderReceivingStatus>
}

export type BannerOrdersInputRoot = {
  bannerID: Scalars['ID']
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  /**
   * Use the buyer's email address or their id, to apply this filter; This is due
   * to the data structure of orders, only saving the buyer's email as an identifier.
   */
  filterByBuyer?: InputMaybe<Scalars['ID']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterBySent?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
}

export type BannerOrdersResult = {
  __typename?: 'BannerOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export enum BannerStatus {
  Certified = 'CERTIFIED',
  None = 'NONE',
}

export type BannerStoresInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<BannerStoresSortingInput>
}

export type BannerStoresResult = {
  __typename?: 'BannerStoresResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<Store>
}

export enum BannerStoresSortingField {
  Name = 'NAME',
}

export type BannerStoresSortingInput = {
  direction?: InputMaybe<SortingDirection>
  field: BannerStoresSortingField
}

export type BannerV2OrderGuidesUpdateResult = {
  __typename?: 'BannerV2OrderGuidesUpdateResult'
  nodes: Array<V2OrderGuide>
  updatedVendorStoreDepartmentAccounts: Array<Scalars['String']>
}

export type BannerVendorProductsInput = {
  cursor?: InputMaybe<Scalars['String']>
  filterBySource?: InputMaybe<ProductSourceFilter>
  lastRequestedAt?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

export type BannerVendorStoreAccount = {
  __typename?: 'BannerVendorStoreAccount'
  vendor: Vendor
}

export type BannerVendorStoreAccountInput = {
  query?: InputMaybe<Scalars['String']>
}

export type BannerVendorStoreAccountsResult = {
  __typename?: 'BannerVendorStoreAccountsResult'
  nodes: Array<BannerVendorStoreAccount>
  totalCount: Scalars['Int']
}

export type BannerVendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  /** Note: This input will be superseded by any given `searchByVendor` input */
  query?: InputMaybe<Scalars['String']>
  /** Note: This input will supersede any given `query` input */
  searchByVendor?: InputMaybe<Scalars['String']>
}

export type BannerVendorStoreDepartmentAccountsResult = {
  __typename?: 'BannerVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type BannerVendorsInput = {
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type BannerVendorsResult = {
  __typename?: 'BannerVendorsResult'
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type BannersResult = {
  __typename?: 'BannersResult'
  nodes: Array<Banner>
}

export type BillingInfo = {
  __typename?: 'BillingInfo'
  billingEmail: Scalars['String']
  billingType: BillingType
  perOrderCharge: Scalars['Currency']
  rate?: Maybe<Scalars['Int']>
  stripeBillingID?: Maybe<Scalars['String']>
}

export type BillingInfoInput = {
  billingEmail: Scalars['String']
  billingType: BillingType
  perOrderCharge: Scalars['Currency']
  rate?: InputMaybe<Scalars['Int']>
  stripeBillingID?: InputMaybe<Scalars['String']>
}

export type BulkAddProductsToV2OrderGuideInput = {
  addOrderGuideProductsInput: Array<AddProductsToV2OrderGuideInput>
}

export type BulkAddProductsToV2OrderGuideResult = {
  __typename?: 'BulkAddProductsToV2OrderGuideResult'
  nodes?: Maybe<Array<AddProductsToV2OrderGuideResult>>
}

export type BulkCopyUserAccount = {
  copyToUserID: Scalars['String']
  storeID: Scalars['String']
}

export type BulkCopyUserOrderGuideInput = {
  accounts: Array<BulkCopyUserAccount>
  productIDs: Array<Scalars['String']>
  vendorID: Scalars['ID']
}

export type BulkCopyV2OrderGuideInput = {
  fromVendorStoreDepartmentAccountIDs: Array<Scalars['ID']>
  toStoreDepartmentIDs: Array<Scalars['ID']>
}

export type BulkCreateOrUpdateVendorStoreDepartmentAccountsResult = {
  __typename?: 'BulkCreateOrUpdateVendorStoreDepartmentAccountsResult'
  createdNodes?: Maybe<Array<VendorStoreDepartmentAccount>>
  errors?: Maybe<Array<BulkCreateVendorStoreDepartmentAccountsErrors>>
  updatedNodes?: Maybe<Array<VendorStoreDepartmentAccount>>
}

export type BulkCreateStoreFields = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']>>
  geographicCoordinates?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  placeID?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  storeType?: InputMaybe<StoreType>
  vendorIDs?: InputMaybe<Array<Scalars['String']>>
}

export type BulkCreateStoresInput = {
  storesInput: Array<BulkCreateStoreFields>
}

export type BulkCreateStoresResult = {
  __typename?: 'BulkCreateStoresResult'
  nodes?: Maybe<Array<Store>>
}

export type BulkCreateTaskInput = {
  payloadJsons: Array<Scalars['String']>
  taskName: Scalars['String']
}

export type BulkCreateVendorInvitationInput = {
  invitedByStoreID: Scalars['ID']
  invitedByUserID: Scalars['ID']
  uploadList: Array<SendBulkVendorInvitationInput>
}

export type BulkCreateVendorStoreDepartmentAccountsErrors = {
  __typename?: 'BulkCreateVendorStoreDepartmentAccountsErrors'
  errors?: Maybe<Array<Scalars['String']>>
  storeDepartmentID: Scalars['String']
  vendorID: Scalars['String']
}

export type BulkCreateVendorStoreDepartmentAccountsResult = {
  __typename?: 'BulkCreateVendorStoreDepartmentAccountsResult'
  errors?: Maybe<Array<BulkCreateVendorStoreDepartmentAccountsErrors>>
  nodes?: Maybe<Array<VendorStoreDepartmentAccount>>
}

export type BulkGetOrderStoreCountByVendorIDsResult = {
  __typename?: 'BulkGetOrderStoreCountByVendorIDsResult'
  nodes: Array<BulkGetOrderStoreCountResult>
}

export type BulkGetOrderStoreCountResult = {
  __typename?: 'BulkGetOrderStoreCountResult'
  numOfOrders: Scalars['Int']
  numOfStores: Scalars['Int']
  vendorID: Scalars['ID']
}

export type BulkGetVsdAsOrderGuidesInput = {
  vendorStoreDepartmentAccountIDs: Array<Scalars['ID']>
}

export type BulkParseCsvOrderGuidesInput = {
  vendors: Array<ParseCsvOrderGuideInput>
}

export type BulkParsedOrderGuidesResult = {
  __typename?: 'BulkParsedOrderGuidesResult'
  nodes: Array<ParsedOrderGuideResult>
}

export type BulkStoreVendorProductInput = {
  active?: InputMaybe<Scalars['Boolean']>
  ageRestriction?: InputMaybe<Scalars['Int']>
  barcode: Scalars['String']
  brandName?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName: Scalars['String']
  ebtEnabled?: InputMaybe<Scalars['Boolean']>
  ecommEnabled?: InputMaybe<Scalars['Boolean']>
  eslEnabled?: InputMaybe<Scalars['Boolean']>
  existingProductID?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  primaryVendorCost?: InputMaybe<Scalars['Float']>
  primaryVendorItemCode?: InputMaybe<Scalars['String']>
  primaryVendorName?: InputMaybe<Scalars['String']>
  printPhysicalTag?: InputMaybe<Scalars['Boolean']>
  promptForQuantity?: InputMaybe<Scalars['Boolean']>
  receiptDescription?: InputMaybe<Scalars['String']>
  retailPrice?: InputMaybe<Scalars['Float']>
  snapEnabled?: InputMaybe<Scalars['Boolean']>
  soldByWeight?: InputMaybe<Scalars['Boolean']>
  targetMargin?: InputMaybe<Scalars['Float']>
  taxRateID?: InputMaybe<Scalars['Int']>
  taxRateID2?: InputMaybe<Scalars['Int']>
  taxRateID3?: InputMaybe<Scalars['Int']>
  unitOfMeasure?: InputMaybe<Scalars['String']>
  unitOfMeasureAmount?: InputMaybe<Scalars['Float']>
  unitVolume?: InputMaybe<Scalars['String']>
  wicEnabled?: InputMaybe<Scalars['Boolean']>
}

export type BulkSuggestStoresInput = {
  stores: Array<BulkSuggestStoresInputStore>
  vendorID: Scalars['ID']
}

export type BulkSuggestStoresInputStore = {
  address?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
}

export type BulkSuggestStoresResult = {
  __typename?: 'BulkSuggestStoresResult'
  suggestions: Array<SuggestStoresResult>
}

export type BulkUpdateStoreDepartmentsInput = {
  deactivatedAt?: InputMaybe<Scalars['DateTime']>
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name?: InputMaybe<Scalars['String']>
  parentDepartmentID?: InputMaybe<Scalars['ID']>
  storeDepartmentIDs: Array<Scalars['ID']>
}

export type BulkUpdateUserAccountListInput = {
  overwriteExisting?: InputMaybe<Scalars['Boolean']>
  storesInput: Array<BulkUpdateUserAccountStoresInput>
  userID: Scalars['ID']
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type BulkUpdateUserAccountListResult = {
  __typename?: 'BulkUpdateUserAccountListResult'
  nodes?: Maybe<Array<User>>
}

export type BulkUpdateUserAccountStoresInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  address: Scalars['String']
  departmentName?: InputMaybe<DepartmentName>
  dunsNumber?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type BulkUpdateUserOrderGuideInput = {
  accounts: Array<UpdateUserOrderGuideAccountInput>
}

export type BulkUpdateUserOrderGuideResult = {
  __typename?: 'BulkUpdateUserOrderGuideResult'
  nodes: Array<OrderGuide>
}

export type BulkUpdateV2OrderGuidesInput = {
  updateOrderGuideProductsInput: Array<UpdateV2OrderGuideInput>
}

export type BulkUpdateV2OrderGuidesResult = {
  __typename?: 'BulkUpdateV2OrderGuidesResult'
  nodes?: Maybe<Array<V2OrderGuide>>
}

export type BulkUpdateVendorProductsInput = {
  vendorProducts: Array<UpdateVendorProductInput>
}

export type BulkUpdateVendorProductsResult = {
  __typename?: 'BulkUpdateVendorProductsResult'
  nodes: Array<VendorProduct>
}

export type BulkUploadMultiVendorProductsInput = {
  catalogSource?: InputMaybe<VendorProductCatalogSource>
  inputProducts: Array<BulkVendorProductInput>
  isBannerUpload: Scalars['Boolean']
  overwrite: Scalars['Boolean']
  privateLabelUpload?: InputMaybe<Scalars['Boolean']>
  retailAccountID?: InputMaybe<Scalars['ID']>
}

export type BulkUploadSingleVendorProductsInput = {
  catalogSource?: InputMaybe<VendorProductCatalogSource>
  discontinueMissingProducts?: InputMaybe<Scalars['Boolean']>
  inputProducts: Array<BulkVendorProductInput>
  isBannerUpload: Scalars['Boolean']
  overwrite: Scalars['Boolean']
  privateLabelUpload?: InputMaybe<Scalars['Boolean']>
  retailAccountID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type BulkUploadStoreVendorProductsInput = {
  bannerSQLID: Scalars['ID']
  inputProducts: Array<BulkStoreVendorProductInput>
  overwrite: Scalars['Boolean']
  storeSQLIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type BulkUploadStoreVendorProductsResult = {
  __typename?: 'BulkUploadStoreVendorProductsResult'
  bannerSQLID: Scalars['ID']
  errors: Array<UploadError>
  id: Scalars['ID']
  newBannerAplSize: Scalars['Int']
  numStoreProductsCreated: Scalars['Int']
  numStoreProductsOverwritten: Scalars['Int']
  spreadsheetURL: Scalars['String']
  storeSQLIDs: Array<Scalars['String']>
}

export type BulkUploadVendorProductsResult = {
  __typename?: 'BulkUploadVendorProductsResult'
  catalogSize: Scalars['Int']
  errors: Array<UploadError>
  id: Scalars['ID']
  numProductsCreated: Scalars['Int']
  numProductsOverwritten: Scalars['Int']
  spreadsheetURL: Scalars['String']
  uploadedProducts: Array<VendorProduct>
  vendor: Vendor
}

export type BulkVendorInventationResult = {
  __typename?: 'BulkVendorInventationResult'
  hasExistingUser: Scalars['Boolean']
  invitation: VendorInvitation
}

export type BulkVendorInvitationError = {
  __typename?: 'BulkVendorInvitationError'
  email: Scalars['String']
  message: Scalars['String']
}

export type BulkVendorInvitationsResult = {
  __typename?: 'BulkVendorInvitationsResult'
  errors?: Maybe<Array<BulkVendorInvitationError>>
  nodes: Array<BulkVendorInventationResult>
}

export type BulkVendorProductInput = {
  brandName?: InputMaybe<Scalars['String']>
  caseCRV?: InputMaybe<Scalars['Currency']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  imgURL?: InputMaybe<Scalars['String']>
  inventory?: InputMaybe<Scalars['Int']>
  itemCode: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  sizing?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorProductStatus>
  unitCRV?: InputMaybe<Scalars['Currency']>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type BuyXGetYFreeDeal = Deal & {
  __typename?: 'BuyXGetYFreeDeal'
  displayName: Scalars['String']
  freeCount: Scalars['Int']
  id: Scalars['ID']
  promotion: Promotion
  threshold: Scalars['Int']
  type: DealType
  unitOfMeasure: UnitOfMeasure
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type BuyXGetYFreeDealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type BuyXGetYFreeDealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

export type BuyerUsersInput = {
  query?: InputMaybe<Scalars['String']>
}

export type BuyerUsersResult = {
  __typename?: 'BuyerUsersResult'
  nodes: Array<User>
  totalCount: Scalars['Int']
}

/**
 * ****************************
 *       CSV Upload Log
 * ****************************
 */
export type CsvUploadLog = {
  __typename?: 'CSVUploadLog'
  additions: Scalars['Int']
  id: Scalars['ID']
  overwrites: Scalars['Int']
  progress: Scalars['Int']
  restoredBy?: Maybe<User>
  restoredOn?: Maybe<Scalars['Timestamp']>
  retailAccounts: Array<RetailCompany>
  rowCount: Scalars['Int']
  spreadsheetURL?: Maybe<Scalars['String']>
  status: CsvUploadLogStatus
  type?: Maybe<CsvUploadLogType>
  uploadedBy?: Maybe<User>
  uploadedOn: Scalars['Timestamp']
  vendors: Array<Vendor>
}

export enum CsvUploadLogStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS',
}

export enum CsvUploadLogType {
  AuthorizedFile = 'AUTHORIZED_FILE',
  CatalogUpdate = 'CATALOG_UPDATE',
  PrivateLabel = 'PRIVATE_LABEL',
}

export type CartLineItem = {
  __typename?: 'CartLineItem'
  deal?: Maybe<Deal>
  id: Scalars['ID']
  price: Scalars['Currency']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProduct: VendorProduct
}

export type CartLineItemInput = {
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['ID']
}

export type CartLineItems = {
  __typename?: 'CartLineItems'
  nodes: Array<CartLineItem>
}

export type CartOrderResult = {
  __typename?: 'CartOrderResult'
  cart: VendorCart
  order: Order
}

export type CartOutOfStockProductsResult = {
  __typename?: 'CartOutOfStockProductsResult'
  nodes: Array<VendorProduct>
}

export type CartReviewItem = {
  /** Message explaining the reason for this alert, eg 'Usually ordered in eaches'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  lineItem: CartLineItem
  type: CartReviewItemType
}

export enum CartReviewItemType {
  UnusualQuantity = 'UNUSUAL_QUANTITY',
  UnusualUom = 'UNUSUAL_UOM',
}

export type CartReviewItemUnusualQuantity = CartReviewItem & {
  __typename?: 'CartReviewItemUnusualQuantity'
  /** Message explaining the reason for this alert, eg 'Typical order is 12 cases'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  lineItem: CartLineItem
  suggestedQuantity: LineItemQuantity
  type: CartReviewItemType
}

export type CartReviewItemUnusualUom = CartReviewItem & {
  __typename?: 'CartReviewItemUnusualUOM'
  /** Message explaining the reason for this alert, eg 'Usually ordered in eaches'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  lineItem: CartLineItem
  suggestedQuantity: LineItemQuantity
  type: CartReviewItemType
}

export type CartReviewItemsResult = {
  __typename?: 'CartReviewItemsResult'
  nodes: Array<CartReviewItem>
}

export type CartSuggestedProductsResult = {
  __typename?: 'CartSuggestedProductsResult'
  nodes: Array<VendorProduct>
}

export type CartUnavailableProductsResult = {
  __typename?: 'CartUnavailableProductsResult'
  nodes: Array<VendorProduct>
}

export type CatalogRequest = {
  __typename?: 'CatalogRequest'
  fromStore: Store
  id: Scalars['ID']
  requestedAt?: Maybe<Scalars['Timestamp']>
  requestedBy: User
  toVendor: Vendor
}

export type CatalogRequestsResult = {
  __typename?: 'CatalogRequestsResult'
  nodes: Array<CatalogRequest>
  totalCount: Scalars['Int']
}

export enum CatalogSortType {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Description = 'DESCRIPTION',
  ItemCode = 'ITEM_CODE',
}

export enum Client {
  Ios = 'IOS',
  Market = 'MARKET',
}

/**
 * ****************************
 *      Order Mutations
 * ****************************
 */
export enum ClientType {
  Ios = 'IOS',
  Market = 'MARKET',
}

export type Company = Store | Vendor

export type CompanyFtpConfig = {
  __typename?: 'CompanyFTPConfig'
  companyID: Scalars['String']
  companyType: CompanyType
  id: Scalars['String']
  userName: Scalars['String']
}

export type CompanyFtpConfigResult = {
  __typename?: 'CompanyFTPConfigResult'
  nodes: Array<CompanyFtpConfig>
}

export enum CompanyType {
  Banner = 'BANNER',
  Store = 'STORE',
  Vendor = 'VENDOR',
}

export enum CompanyUserType {
  RetailUser = 'RETAIL_USER',
  Unknown = 'UNKNOWN',
  VendorUser = 'VENDOR_USER',
}

export type ConfirmOrderInput = {
  orderID: Scalars['ID']
  removeMisscans?: InputMaybe<Scalars['Boolean']>
  /** A JSON map where keys are misscanVendorProduct ids and values are vendorProduct ids used to resolve the misscan, e.g., `"{ yoInrkQ1Cd2IacpBTywO: '9qMMbKbTHl96bdBAaSlR' }"`. */
  resolvedProducts?: InputMaybe<Scalars['String']>
}

export type CopyAllUserOrderGuideInput = {
  copyFromUserID: Scalars['ID']
  copyToUserIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
}

export type CopyUserOrderGuideInput = {
  copyFromUserID: Scalars['ID']
  copyToUserIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type CopyUserOrderGuideResult = {
  __typename?: 'CopyUserOrderGuideResult'
  updatedUsers: Array<User>
}

export type CopyV2OrderGuideInput = {
  fromVendorStoreDepartmentAccountID: Scalars['ID']
  toStoreDepartmentIDs: Array<Scalars['ID']>
}

export type CopyV2OrderGuideResult = {
  __typename?: 'CopyV2OrderGuideResult'
  vendorStoreDepartmentAccounts: Array<VendorStoreDepartmentAccount>
}

export type CreateAndSubmitOrderFromCartInput = {
  client: Client
  deliveryDate?: InputMaybe<Scalars['Timestamp']>
  idempotencyKey: Scalars['String']
  noteToVendor?: InputMaybe<Scalars['String']>
  placedViaOnePassScan?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['String']
  vendorID: Scalars['String']
}

export type CreateAudienceInput = {
  name: Scalars['String']
  storeIDs: Array<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type CreateBannerInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  bannerType?: InputMaybe<StoreType>
  billingInfo?: InputMaybe<BillingInfoInput>
  frontOfficeURL?: InputMaybe<Scalars['String']>
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name: Scalars['String']
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<BannerStatus>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateBuyerAccountInput = {
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  password: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
}

export type CreateCodatCompanyMutationInput = {
  bannerFirestoreID?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  storeFirestoreID?: InputMaybe<Scalars['ID']>
}

export type CreateDealInput = {
  basisPoints?: InputMaybe<Scalars['Int']>
  dealValue?: InputMaybe<Scalars['Currency']>
  freeCount?: InputMaybe<Scalars['Int']>
  promotionID: Scalars['ID']
  threshold?: InputMaybe<Scalars['Int']>
  type: DealType
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  vendorDiscountCode?: InputMaybe<Scalars['String']>
  vendorProductIDs: Array<Scalars['ID']>
}

export type CreateInvoiceForNonVoriOrderMutationInput = {
  idempotencyKey: Scalars['String']
  invoiceBottleDeposit?: InputMaybe<MoneyInput>
  invoiceCases?: InputMaybe<Scalars['Int']>
  invoiceDate: Scalars['DateTime']
  invoiceEaches?: InputMaybe<Scalars['Int']>
  invoiceFreight?: InputMaybe<MoneyInput>
  invoiceNumber: Scalars['String']
  invoicePDFUrl: Scalars['String']
  invoiceTax?: InputMaybe<MoneyInput>
  invoiceTotal: MoneyInput
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type CreateLineItemCreditRequestMutationInput = {
  amount: MoneyInput
  lineItemID: Scalars['ID']
  notes: Scalars['String']
}

export type CreateMisscanInput = {
  associatedProductID?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  photoURL?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
  type: MisscanType
  upc: Scalars['String']
  vendorID: Scalars['ID']
}

export type CreateOrUpdateVendorStoreDepartmentAccountForm = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  departmentName: Scalars['String']
  dunsNumber?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  status: VendorStoreDepartmentAccountStatus
  storeEmails?: InputMaybe<Array<StoreEmailInput>>
  storeID: Scalars['String']
  vendorEmails?: InputMaybe<Array<VendorEmailInput>>
  vendorID: Scalars['String']
}

export type CreateOrderInput = {
  client: Client
  deliveryDate?: InputMaybe<Scalars['Timestamp']>
  idempotencyKey: Scalars['String']
  misscans?: InputMaybe<Array<OrderMisscanLineItemInput>>
  noteToVendor?: InputMaybe<Scalars['String']>
  orderContents: Array<OrderLineItemInput>
  placedViaOnePassScan?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['String']
  suggestedCartsModelTimestamp?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
}

export type CreateOrderReceivingLineItemInput = {
  brandName?: InputMaybe<Scalars['String']>
  createMispickItem?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  idempotencyKey?: InputMaybe<Scalars['String']>
  imageURLs?: InputMaybe<Array<Scalars['String']>>
  issueQuantity?: InputMaybe<Scalars['Int']>
  orderID: Scalars['ID']
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  upc?: InputMaybe<Scalars['String']>
  vendorProductID?: InputMaybe<Scalars['ID']>
}

export type CreatePaymentProfileJwtInput = {
  bannerID?: InputMaybe<Scalars['String']>
  deviceBillingInfo?: InputMaybe<DeviceBillingInfoInput>
  email: Scalars['String']
  name: Scalars['String']
  orderBillingInfo?: InputMaybe<OrderBillingInfoInput>
  setupFee?: InputMaybe<SetupFeeInput>
  storeID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type CreatePaymentProfileJwtResult = {
  __typename?: 'CreatePaymentProfileJWTResult'
  email: Scalars['String']
  token: Scalars['String']
}

export type CreateProductSampleRequest = {
  status?: InputMaybe<SampleRequestStatus>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type CreateProductSampleRequestsInput = {
  requests: Array<CreateProductSampleRequest>
}

export type CreatePromotionInput = {
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  isPublished: Scalars['Boolean']
  name: Scalars['String']
  startDate?: InputMaybe<Scalars['Timestamp']>
  vendorID: Scalars['ID']
}

export type CreateSftpConnectionInput = {
  SQLBannerID?: InputMaybe<Scalars['String']>
  SQLStoreID?: InputMaybe<Scalars['String']>
  SQLUserID: Scalars['String']
  SQLVendorID?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  direction: Scalars['String']
  path: Scalars['String']
}

export type CreateSftpUserInput = {
  SQLBannerID?: InputMaybe<Scalars['String']>
  SQLStoreID?: InputMaybe<Scalars['String']>
  SQLVendorID?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  homeDir: Scalars['String']
  host: Scalars['String']
  port: Scalars['Float']
  userName: Scalars['String']
}

export type CreateStoreAccountForVendorError = {
  __typename?: 'CreateStoreAccountForVendorError'
  error: CreateStoreAccountForVendorErrorType
  /** In case of DUPLICATE_STORE errors, the ID of the existing store. */
  existingStoreID?: Maybe<Scalars['ID']>
  /** The index of the errored CreateStoreAccountsForVendorAccountInput object */
  inputAccountIndex: Scalars['Int']
  /** Details about the input failure, eg 'Email a@b.com is already in use' */
  message: Scalars['String']
}

export enum CreateStoreAccountForVendorErrorType {
  DuplicateAccountNumber = 'DUPLICATE_ACCOUNT_NUMBER',
  DuplicateStore = 'DUPLICATE_STORE',
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidEmail = 'INVALID_EMAIL',
}

export type CreateStoreAccountsForVendorAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  address?: InputMaybe<Scalars['String']>
  dunsNumber?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  storeEmails?: InputMaybe<Array<Scalars['String']>>
  /** Optional storeID, if the store is already known. If not specified, we create a new store from name+address+email+placeID, (assuming the store input passes dupe checks). */
  storeID?: InputMaybe<Scalars['ID']>
  storeName?: InputMaybe<Scalars['String']>
}

export type CreateStoreAccountsForVendorInput = {
  accounts: Array<CreateStoreAccountsForVendorAccountInput>
  skipDuplicateCheck?: InputMaybe<Scalars['Boolean']>
  /**
   * If true, does not create any stores or accounts, and only validates the input.
   * If true, the `accounts` field in the response contains existing accounts.
   */
  validateOnly?: InputMaybe<Scalars['Boolean']>
  vendorID: Scalars['ID']
}

export type CreateStoreAccountsForVendorResult = {
  __typename?: 'CreateStoreAccountsForVendorResult'
  accounts: Array<VendorStoreDepartmentAccount>
  errors: Array<CreateStoreAccountForVendorError>
}

/**
 * ****************************
 *       StoreDepartment
 * ****************************
 */
export type CreateStoreDepartmentInput = {
  departmentName: Scalars['String']
  email?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
}

export type CreateStoreDepartmentsInput = {
  bannerID: Scalars['String']
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name: Scalars['String']
  parentDepartmentID?: InputMaybe<Scalars['ID']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateStoreInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']>>
  geographicCoordinates?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  storeType?: InputMaybe<StoreType>
  vendorIDs?: InputMaybe<Array<Scalars['String']>>
}

export type CreateStoreProductFields = {
  active?: InputMaybe<Scalars['Boolean']>
  additionalBarcodes?: InputMaybe<Array<Scalars['String']>>
  alcoholByVolume?: InputMaybe<Scalars['Float']>
  barcode: Scalars['String']
  brand?: InputMaybe<Scalars['String']>
  caseSize?: InputMaybe<Scalars['Float']>
  countryOfOrigin?: InputMaybe<Scalars['String']>
  ebtEnabled?: InputMaybe<Scalars['Boolean']>
  ecommerceEnabled?: InputMaybe<Scalars['Boolean']>
  eslEnabled?: InputMaybe<Scalars['Boolean']>
  isTippable?: InputMaybe<Scalars['Boolean']>
  itemModifierIDs?: InputMaybe<Array<Scalars['String']>>
  longDescription?: InputMaybe<Scalars['String']>
  loyaltyPoints?: InputMaybe<Scalars['Decimal']>
  manualItem?: InputMaybe<Scalars['Boolean']>
  minCustomerAge?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
  packSize?: InputMaybe<Scalars['Float']>
  price?: InputMaybe<Scalars['Decimal']>
  priceInputMethod?: InputMaybe<StoreProductPriceInputMethod>
  priceSource?: InputMaybe<StoreProductPriceSource>
  priceSourcePlatform?: InputMaybe<StoreProductPriceSourcePlatform>
  printPhysicalTag?: InputMaybe<Scalars['Boolean']>
  promptForQuantity?: InputMaybe<Scalars['Boolean']>
  receiptDescription?: InputMaybe<Scalars['String']>
  retailPriceUnitOfMeasureID?: InputMaybe<Scalars['String']>
  snapEnabled?: InputMaybe<Scalars['Boolean']>
  soldByWeight?: InputMaybe<Scalars['Boolean']>
  storeDepartmentID?: InputMaybe<Scalars['String']>
  syncToDeliScales?: Scalars['Boolean']
  targetMargin?: InputMaybe<Scalars['Float']>
  taxRateIDs?: InputMaybe<Array<Scalars['String']>>
  unitOfMeasure?: InputMaybe<Scalars['String']>
  unitOfMeasureAmount?: InputMaybe<Scalars['Decimal']>
  upc?: InputMaybe<Scalars['String']>
  variableSalePrice?: InputMaybe<Scalars['Boolean']>
  variableWeightIDs?: InputMaybe<Array<Scalars['String']>>
  wicEnabled?: InputMaybe<Scalars['Boolean']>
}

export type CreateStoreProductsInput = {
  data: CreateStoreProductFields
  storeDepartmentIDs: Array<Scalars['ID']>
}

export type CreateStoreReceiverInput = {
  storeID: Scalars['ID']
  userID: Scalars['ID']
}

export type CreateTaskInput = {
  payloadJson: Scalars['String']
  taskName: Scalars['String']
}

export type CreateUserInput = {
  companyID?: InputMaybe<Scalars['String']>
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  password: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  userType: UserType
}

export type CreateUserStoreDepartmentInput = {
  storeDepartmentID: Scalars['ID']
  userID: Scalars['ID']
}

export type CreateVendorInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  billingInfo?: InputMaybe<BillingInfoInput>
  defaultOrderSubmissionMethod?: InputMaybe<SubmissionMethod>
  departmentTags?: InputMaybe<Array<DepartmentName>>
  description?: InputMaybe<Scalars['String']>
  disableDiscontinuedPurchases?: InputMaybe<Scalars['Boolean']>
  disableOutOfStockPurchases?: InputMaybe<Scalars['Boolean']>
  distributionCenterID?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  headerImageURL?: InputMaybe<Scalars['String']>
  headerImageURLFile?: InputMaybe<Scalars['Upload']>
  hideWholesalePricing?: InputMaybe<Scalars['Boolean']>
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  isInventoryEnabled?: InputMaybe<Scalars['Boolean']>
  lockUOMSelection?: InputMaybe<UomLock>
  misscanPolicy?: InputMaybe<VendorMisscanPolicy>
  name: Scalars['String']
  orderDeadline?: InputMaybe<Scalars['String']>
  orderMin?: InputMaybe<Scalars['Currency']>
  orderMinimums?: InputMaybe<Array<VendorOrderMinimumInput>>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  retailerPricing?: InputMaybe<Scalars['Boolean']>
  showImages?: InputMaybe<Scalars['Boolean']>
  skipEmailWithEDIOrderSubmission?: InputMaybe<Scalars['Boolean']>
  spsTenetID?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorStatus>
  trueCommerceTenetID?: InputMaybe<Scalars['String']>
  useAccountMetadataEmailOverVendorEmail?: InputMaybe<Scalars['Boolean']>
  vendorManagedCatalog?: InputMaybe<Scalars['Boolean']>
}

/**
 * ****************************
 *      Product Mutations
 * ****************************
 */
export type CreateVendorProductInput = {
  accountSpecificCasePrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  accountSpecificUnitPrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  brand?: InputMaybe<Scalars['String']>
  caseCRV?: InputMaybe<Scalars['Currency']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  crvCost?: InputMaybe<Scalars['Currency']>
  departmentName?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  erpID?: InputMaybe<Scalars['String']>
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  inventory?: InputMaybe<Scalars['Int']>
  isDeleted?: InputMaybe<Scalars['Boolean']>
  isDiscontinued?: InputMaybe<Scalars['Boolean']>
  isStoreSpecific?: InputMaybe<Scalars['Boolean']>
  itemCode: Scalars['String']
  missScanMethod?: InputMaybe<MissScanMethod>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  privateLabelProductBannerIDs?: InputMaybe<Array<Scalars['ID']>>
  privateLabelProductStoreIDs?: InputMaybe<Array<Scalars['ID']>>
  sizing?: InputMaybe<Scalars['String']>
  srp?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorProductStatus>
  storeID?: InputMaybe<Scalars['String']>
  unitCRV?: InputMaybe<Scalars['Currency']>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  upc?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
  wholesaleCasePrice?: InputMaybe<Scalars['Currency']>
  wholesaleUnitPrice?: InputMaybe<Scalars['Currency']>
}

export type CreateVendorStoreDepartmentAccountForm = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  dunsNumber?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  storeDepartmentID: Scalars['String']
  storeEmails?: InputMaybe<Array<StoreEmailInput>>
  vendorEmails?: InputMaybe<Array<VendorEmailInput>>
  vendorID: Scalars['String']
}

export type CreditRequest = {
  __typename?: 'CreditRequest'
  amount: Money
  createdAt: Scalars['DateTime']
  createdBy: Scalars['String']
  id: Scalars['ID']
  note: Scalars['String']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export enum CurrencyFormat {
  Short = 'SHORT',
}

export type CustomerInviteResult = {
  __typename?: 'CustomerInviteResult'
  errors: Array<InviteResult>
  existingUsers: Array<InviteResult>
  numInvalidStores: Scalars['Int']
  numStoresCreated: Scalars['Int']
  numStoresInvited: Scalars['Int']
  numStoresUpdated: Scalars['Int']
  storesStatus: Array<InviteResult>
}

export type DateRangeBetweenFilter = {
  endDate?: InputMaybe<Scalars['Timestamp']>
  startDate: Scalars['Timestamp']
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type Deal = {
  displayName: Scalars['String']
  id: Scalars['ID']
  promotion: Promotion
  type: DealType
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type DealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type DealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

export enum DealType {
  BuyXGetYFree = 'BUY_X_GET_Y_FREE',
  Discount = 'DISCOUNT',
  Fixed = 'FIXED',
}

export type DealVendorProductsByBrandInput = {
  brandName?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type DealVendorProductsResult = {
  __typename?: 'DealVendorProductsResult'
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type DealsResults = {
  __typename?: 'DealsResults'
  nodes: Array<Deal>
}

export type DeleteBannerInput = {
  bannerID: Scalars['ID']
}

export type DeleteBannerResult = {
  __typename?: 'DeleteBannerResult'
  deletedBannerID: Scalars['ID']
}

export type DeleteDealInput = {
  id: Scalars['ID']
}

export type DeleteDealResult = {
  __typename?: 'DeleteDealResult'
  deletedDealID: Scalars['ID']
  updatedPromotion?: Maybe<Promotion>
}

export type DeleteMisscansInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  vendorID?: InputMaybe<Scalars['ID']>
}

export type DeleteMisscansResult = {
  __typename?: 'DeleteMisscansResult'
  deletedProductIDs: Array<Scalars['ID']>
}

export type DeletePromotionInput = {
  id: Scalars['ID']
}

export type DeletePromotionResult = {
  __typename?: 'DeletePromotionResult'
  deletedDealIDs: Array<Scalars['ID']>
  deletedPromotionID?: Maybe<Scalars['ID']>
}

export type DeleteStoreInput = {
  storeID: Scalars['ID']
}

export type DeleteStoreResult = {
  __typename?: 'DeleteStoreResult'
  storeID: Scalars['ID']
}

export type DeleteUserInput = {
  id: Scalars['ID']
}

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult'
  deletedUserID: Scalars['ID']
}

export type DeleteUserStoreDepartmentInput = {
  userStoreDepartmentID: Scalars['ID']
}

export type DeleteVendorProductInput = {
  productID: Scalars['ID']
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type DeleteVendorProductResult = {
  __typename?: 'DeleteVendorProductResult'
  deletedProductID: Scalars['ID']
}

export type DeletedVendorProductsInput = {
  deletedAfter?: InputMaybe<Scalars['Timestamp']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type Department = {
  __typename?: 'Department'
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  store: Store
}

export enum DepartmentName {
  Asian = 'ASIAN',
  Bakery = 'BAKERY',
  Beer = 'BEER',
  Beverage = 'BEVERAGE',
  Bulk = 'BULK',
  Cafe = 'CAFE',
  Cheese = 'CHEESE',
  Confectionary = 'CONFECTIONARY',
  Dairy = 'DAIRY',
  Deli = 'DELI',
  Default = 'Default',
  Floral = 'FLORAL',
  FoodService = 'FOOD_SERVICE',
  FrontEnd = 'FRONT_END',
  Frozen = 'FROZEN',
  Grocery = 'GROCERY',
  Haba = 'HABA',
  HomeGoods = 'HOME_GOODS',
  Maintenance = 'MAINTENANCE',
  Meat = 'MEAT',
  NaturalGrocery = 'NATURAL_GROCERY',
  PetStore = 'PET_STORE',
  Produce = 'PRODUCE',
  Retail = 'RETAIL',
  Seafood = 'SEAFOOD',
  SpecialtyGrocery = 'SPECIALTY_GROCERY',
  Wine = 'WINE',
}

export type DepartmentsResult = {
  __typename?: 'DepartmentsResult'
  nodes: Array<Department>
}

export type DeviceBillingInfoInput = {
  bundles: Array<DeviceBundleInput>
}

export type DeviceBundleInput = {
  cost: Scalars['Currency']
  deviceBundleID: Scalars['String']
}

export type DiscoverableVendorsInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type EslConfigInput = {
  storeID: Scalars['String']
}

export enum EslType {
  Danavation = 'DANAVATION',
  Ses = 'SES',
}

export type EdiPartner = {
  __typename?: 'EdiPartner'
  ediPartnerName: Scalars['String']
  id: Scalars['Int']
  interchangeNumber: Scalars['Int']
  vendorID: Scalars['ID']
}

export type EditableStoreProductFields = {
  active?: InputMaybe<Scalars['Boolean']>
  additionalBarcodes?: InputMaybe<Array<Scalars['String']>>
  alcoholByVolume?: InputMaybe<Scalars['Float']>
  barcode?: InputMaybe<Scalars['String']>
  brand?: InputMaybe<Scalars['String']>
  caseSize?: InputMaybe<Scalars['Float']>
  countryOfOrigin?: InputMaybe<Scalars['String']>
  ebtEnabled?: InputMaybe<Scalars['Boolean']>
  ecommerceEnabled?: InputMaybe<Scalars['Boolean']>
  eslEnabled?: InputMaybe<Scalars['Boolean']>
  isTippable?: InputMaybe<Scalars['Boolean']>
  itemModifierIDs?: InputMaybe<Array<Scalars['String']>>
  longDescription?: InputMaybe<Scalars['String']>
  loyaltyPoints?: InputMaybe<Scalars['Decimal']>
  manualItem?: InputMaybe<Scalars['Boolean']>
  minCustomerAge?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  packSize?: InputMaybe<Scalars['Float']>
  price?: InputMaybe<Scalars['Decimal']>
  priceInputMethod?: InputMaybe<StoreProductPriceInputMethod>
  priceSource?: InputMaybe<StoreProductPriceSource>
  priceSourcePlatform?: InputMaybe<StoreProductPriceSourcePlatform>
  printPhysicalTag?: InputMaybe<Scalars['Boolean']>
  promptForQuantity?: InputMaybe<Scalars['Boolean']>
  receiptDescription?: InputMaybe<Scalars['String']>
  retailPriceUnitOfMeasureID?: InputMaybe<Scalars['String']>
  snapEnabled?: InputMaybe<Scalars['Boolean']>
  soldByWeight?: InputMaybe<Scalars['Boolean']>
  storeDepartmentID?: InputMaybe<Scalars['String']>
  syncToDeliScales?: Scalars['Boolean']
  targetMargin?: InputMaybe<Scalars['Float']>
  taxRateIDs?: InputMaybe<Array<Scalars['String']>>
  unitOfMeasure?: InputMaybe<Scalars['String']>
  unitOfMeasureAmount?: InputMaybe<Scalars['Decimal']>
  upc?: InputMaybe<Scalars['String']>
  variableSalePrice?: InputMaybe<Scalars['Boolean']>
  variableWeightIDs?: InputMaybe<Array<Scalars['String']>>
  wicEnabled?: InputMaybe<Scalars['Boolean']>
}

export type ExploConfig = {
  __typename?: 'ExploConfig'
  customerToken: Scalars['String']
  eodURL: Scalars['String']
  loyaltyURL: Scalars['String']
  metricsURL: Scalars['String']
  overviewURL: Scalars['String']
  promotionsURL: Scalars['String']
  reportBuilderURL: Scalars['String']
  tillsURL: Scalars['String']
  timezone: Scalars['String']
  transactionsURL: Scalars['String']
}

export enum FtpFileType {
  MovementReport = 'MOVEMENT_REPORT',
  ProductUpdates = 'PRODUCT_UPDATES',
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  /** Whether the flag is on or off by default */
  defaultBehavior: FeatureFlagDefaultBehavior
  description: Scalars['String']
  excludedLaneIDs: Array<Scalars['ID']>
  excludedUserIDs: Array<Scalars['ID']>
  /** Same as name. Exposed for caching only */
  id: Scalars['ID']
  includedLaneIDs: Array<Scalars['ID']>
  includedUserIDs: Array<Scalars['ID']>
  /** Human-readable, unique handle for the feature. Clients can use feature flags by writing conditional code against specific names, which are obtained from User.enabledFeatures at run-time */
  name: Scalars['String']
  /** Pass rules that are executed against a given user in specific order. */
  rules: Array<FeatureFlagRule>
}

export enum FeatureFlagDefaultBehavior {
  ExcludeAll = 'EXCLUDE_ALL',
  IncludeAll = 'INCLUDE_ALL',
}

export type FeatureFlagRule = {
  __typename?: 'FeatureFlagRule'
  /** A list of conditions that are combined via logical AND */
  andConditions: Array<FeatureFlagRuleCondition>
  type: FeatureFlagRuleType
}

export type FeatureFlagRuleCondition = {
  __typename?: 'FeatureFlagRuleCondition'
  companyIDs?: Maybe<Array<Scalars['ID']>>
  companyTypes?: Maybe<Array<FeatureFlagRuleConditionCompanyType>>
  scope: FeatureFlagRuleConditionScope
  userTypes?: Maybe<Array<UserType>>
}

export enum FeatureFlagRuleConditionCompanyType {
  Banner = 'BANNER',
  Store = 'STORE',
  Vendor = 'VENDOR',
}

export type FeatureFlagRuleConditionInput = {
  companyIDs?: InputMaybe<Array<Scalars['ID']>>
  companyTypes?: InputMaybe<Array<FeatureFlagRuleConditionCompanyType>>
  scope: FeatureFlagRuleConditionScope
  userTypes?: InputMaybe<Array<UserType>>
}

export enum FeatureFlagRuleConditionScope {
  Company = 'COMPANY',
  CompanyType = 'COMPANY_TYPE',
  UserType = 'USER_TYPE',
}

export type FeatureFlagRuleInput = {
  andConditions: Array<FeatureFlagRuleConditionInput>
  type: FeatureFlagRuleType
}

export enum FeatureFlagRuleType {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export type FeatureFlagsResult = {
  __typename?: 'FeatureFlagsResult'
  nodes: Array<FeatureFlag>
}

export type File = {
  __typename?: 'File'
  encoding: Scalars['String']
  filename: Scalars['String']
  mimetype: Scalars['String']
}

export type FixMisscanInput = {
  productID: Scalars['String']
  storeID: Scalars['ID']
  upc: Scalars['String']
  vendorID: Scalars['ID']
}

export type FixedDeal = Deal & {
  __typename?: 'FixedDeal'
  dealValue: Scalars['Currency']
  displayName: Scalars['String']
  id: Scalars['ID']
  promotion: Promotion
  type: DealType
  unitOfMeasure: UnitOfMeasure
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type FixedDealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type FixedDealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

export type GqleslConfig = {
  __typename?: 'GQLESLConfig'
  apiKey?: Maybe<Scalars['String']>
  eslStoreID: Scalars['String']
  storeID: Scalars['String']
  type: Scalars['String']
}

export type GqlLineItemIssueBase = {
  createdBy: Scalars['String']
  creditRequest?: Maybe<CreditRequest>
  id: Scalars['ID']
}

export type GqlLineItemStatusCount = {
  __typename?: 'GQLLineItemStatusCount'
  count: Scalars['Int']
  status: ReconciledLineItemStatus
}

export type GqlMasterCatalogProductMetadata = {
  __typename?: 'GQLMasterCatalogProductMetadata'
  barcode: Scalars['String']
  brandName?: Maybe<Scalars['String']>
  caseSize?: Maybe<Scalars['Float']>
  name: Scalars['String']
  photoURL?: Maybe<Scalars['String']>
  source: Scalars['String']
  timestamp: Scalars['DateTime']
  unitOfMeasure?: Maybe<Scalars['String']>
  unitOfMeasureAmount?: Maybe<Scalars['String']>
  unitVolume?: Maybe<Scalars['String']>
  wholesaleEachCost?: Maybe<Scalars['Float']>
}

export type GqlOrderHistoryEventBase = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  status: OrderReceivingStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type GqlStoreProduct = {
  __typename?: 'GQLStoreProduct'
  active: Scalars['Boolean']
  additionalBarcodes: Array<Scalars['String']>
  barcode: Scalars['String']
  brand?: Maybe<Scalars['String']>
  caseSize?: Maybe<Scalars['Float']>
  countryOfOrigin?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  ebtEnabled: Scalars['Boolean']
  ecommerceEnabled: Scalars['Boolean']
  eslEnabled: Scalars['Boolean']
  id: Scalars['String']
  isTippable: Scalars['Boolean']
  itemModifierIDs: Array<Scalars['String']>
  longDescription?: Maybe<Scalars['String']>
  loyaltyPoints?: Maybe<Scalars['Decimal']>
  manualItem: Scalars['Boolean']
  minCustomerAge: Scalars['Int']
  name: Scalars['String']
  packSize?: Maybe<Scalars['Float']>
  price?: Maybe<Scalars['Decimal']>
  priceInputMethod?: Maybe<StoreProductPriceInputMethod>
  priceSource?: Maybe<StoreProductPriceSource>
  priceSourcePlatform?: Maybe<StoreProductPriceSourcePlatform>
  printPhysicalTag: Scalars['Boolean']
  promptForQuantity: Scalars['Boolean']
  receiptDescription?: Maybe<Scalars['String']>
  retailPriceUnitOfMeasureID?: Maybe<Scalars['String']>
  snapEnabled: Scalars['Boolean']
  soldByWeight: Scalars['Boolean']
  storeDepartmentID: Scalars['String']
  storeID: Scalars['String']
  targetMargin?: Maybe<Scalars['Float']>
  taxRates: Array<GqlTaxRate>
  unitOfMeasure?: Maybe<Scalars['String']>
  unitOfMeasureAmount?: Maybe<Scalars['Decimal']>
  upc: Scalars['String']
  updatedAt: Scalars['DateTime']
  variableSalePrice: Scalars['Boolean']
  variableWeightIDs: Array<Scalars['String']>
  wicEnabled: Scalars['Boolean']
}

export type GqlStoreVendor = {
  __typename?: 'GQLStoreVendor'
  accountNumber?: Maybe<Scalars['String']>
  billingAddress?: Maybe<AddressComponents>
  billingName?: Maybe<Scalars['String']>
  contactName?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  deactivatedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  invoicesEmail?: Maybe<Scalars['String']>
  minOrderValue?: Maybe<Scalars['Decimal']>
  name: Scalars['String']
  ordersEmail?: Maybe<Scalars['String']>
  store: Store
  taxID?: Maybe<Scalars['String']>
  vendorID?: Maybe<Scalars['String']>
}

export type GqlTaxRate = {
  __typename?: 'GQLTaxRate'
  bannerSerialID: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  productCount: Scalars['Float']
  status: Scalars['Boolean']
  taxType: TaxType
  type: TaxRateType
  updatedAt: Scalars['DateTime']
  value: Scalars['String']
}

export type GetCsvUploadLogsInput = {
  filterByVendorID?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
}

export type GetCsvUploadLogsResult = {
  __typename?: 'GetCSVUploadLogsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<CsvUploadLog>
}

export type GetDiscontinuedVendorProductsForRetailCompanyInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  retailCompanyID: Scalars['ID']
}

export type GetDiscontinuedVendorProductsForRetailCompanyResult = {
  __typename?: 'GetDiscontinuedVendorProductsForRetailCompanyResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<VendorProduct>
  totalCount?: Maybe<Scalars['Int']>
}

export type GetMatchingVendorProductsInput = {
  UPC?: InputMaybe<Scalars['String']>
  itemCode?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

export type GetMatchingVendorProductsResult = {
  __typename?: 'GetMatchingVendorProductsResult'
  nodes: Array<MatchingVendorProduct>
  totalCount: Scalars['Int']
}

export type GetNewVendorProductsForRetailCompanyInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  retailCompanyID: Scalars['ID']
}

export type GetNewVendorProductsForRetailCompanyResult = {
  __typename?: 'GetNewVendorProductsForRetailCompanyResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<VendorProduct>
  totalCount?: Maybe<Scalars['Int']>
}

export type GetStoreDepartmentsInput = {
  bannerID: Scalars['ID']
  filterByStoreID?: InputMaybe<Scalars['ID']>
}

export type GetUserAbandonedCartsInput = {
  endDate: Scalars['Timestamp']
  startDate: Scalars['Timestamp']
  storeID?: InputMaybe<Scalars['ID']>
  userID?: InputMaybe<Scalars['ID']>
}

export type GetUserAbandonedCartsResult = {
  __typename?: 'GetUserAbandonedCartsResult'
  nodes: Array<UserCart>
}

export type GetVendorAbandonedCartsInput = {
  endDate: Scalars['Timestamp']
  startDate: Scalars['Timestamp']
  storeID?: InputMaybe<Scalars['ID']>
  userID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type GetVendorAbandonedCartsResult = {
  __typename?: 'GetVendorAbandonedCartsResult'
  nodes: Array<VendorCart>
}

export type GetVendorProductsInput = {
  filterByBrand?: InputMaybe<Scalars['String']>
  filterByCategory?: InputMaybe<Scalars['String']>
  filterByCustomPricing?: InputMaybe<Scalars['Boolean']>
  filterByPrivateLabel?: InputMaybe<Scalars['Boolean']>
  filterByRetailerIDs?: InputMaybe<Array<Scalars['ID']>>
  filterByStatus?: InputMaybe<Array<VendorProductStatus>>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
  /** By default, VendorProducts are sorted by vendorName -> itemCode */
  sortBy?: InputMaybe<VendorProductsSortingInput>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type GetWholesaleProductsQueryInput = {
  lastRequestedAt?: InputMaybe<Scalars['String']>
}

export type InventoryHubOrderQueryFilters = {
  dateRange?: InputMaybe<DateRangeBetweenFilter>
  departmentIDs?: InputMaybe<Array<Scalars['ID']>>
  orderStatus?: InputMaybe<OrderReceivingStatus>
  searchString?: InputMaybe<Scalars['String']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type InventoryHubOrderQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  filters: InventoryHubOrderQueryFilters
  first: Scalars['Int']
}

export type InventoryHubOrdersViewConnection = {
  __typename?: 'InventoryHubOrdersViewConnection'
  creditRequestTotal: Money
  edges: Array<OrderEdge>
  invoiceTotal: Money
  orderTotal: Money
  pageInfo: PageInfo
}

export enum InventoryLevelStatus {
  InStock = 'IN_STOCK',
  LowStock = 'LOW_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  Unknown = 'UNKNOWN',
}

export type InvitationOrderGuide = {
  __typename?: 'InvitationOrderGuide'
  departmentName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  orderGuideName: Scalars['String']
  products: Array<VendorProduct>
  vendor: Vendor
}

export type InvitationOrderGuideInput = {
  departmentName?: InputMaybe<Scalars['String']>
  orderGuideName: Scalars['String']
  productIDs: Array<Scalars['ID']>
  vendorID: Scalars['ID']
}

export enum InvitationStatus {
  Invited = 'INVITED',
  ManuallyInvited = 'MANUALLY_INVITED',
  NotInvited = 'NOT_INVITED',
  SignedUp = 'SIGNED_UP',
}

export type InviteResult = {
  __typename?: 'InviteResult'
  deepLink?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  index: Scalars['Int']
  status: InviteStatus
  storeName: Scalars['String']
}

export enum InviteStatus {
  DuplicateStore = 'DUPLICATE_STORE',
  ExistingUser = 'EXISTING_USER',
  Failed = 'FAILED',
  InvalidAccountNum = 'INVALID_ACCOUNT_NUM',
  InvalidAddress = 'INVALID_ADDRESS',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidStoreName = 'INVALID_STORE_NAME',
  InviteSent = 'INVITE_SENT',
  ManualInvite = 'MANUAL_INVITE',
  StoreCreated = 'STORE_CREATED',
  StoreUpdated = 'STORE_UPDATED',
}

export type InviteStoreAccountInput = {
  emailToInvite: Scalars['String']
  storeID: Scalars['ID']
}

export type InviteStoreAccountsInput = {
  accounts: Array<InviteStoreAccountInput>
  vendorID: Scalars['ID']
}

export type InviteStoreAccountsResult = {
  __typename?: 'InviteStoreAccountsResult'
  accounts: Array<VendorStoreAccount>
}

export type Invoice = {
  __typename?: 'Invoice'
  accountingFilePath?: Maybe<Scalars['String']>
  accountingMappingComplete: Scalars['Boolean']
  accountingPlatformSyncStatus?: Maybe<AccountingPlatformInvoiceSyncStatus>
  accountingPlatformSyncedAt?: Maybe<Scalars['Timestamp']>
  billTo: AddressComponents
  billingDate: Scalars['DateTime']
  bottleDeposit?: Maybe<Money>
  caseCount?: Maybe<Scalars['Int']>
  creditRequestedTotal: Money
  dueDate: Scalars['DateTime']
  eachCount?: Maybe<Scalars['Int']>
  freight?: Maybe<Money>
  id: Scalars['ID']
  imageURL: Scalars['String']
  invoiceNumber?: Maybe<Scalars['String']>
  lineItems: Array<InvoiceLineItem>
  orderID: Scalars['ID']
  paymentMethod: InvoicePaymentMethod
  receivedAt?: Maybe<Scalars['DateTime']>
  receivedBy?: Maybe<Scalars['String']>
  receivedByName?: Maybe<Scalars['String']>
  receivingLineItems: Array<OrderReceivingLineItem>
  receivingReportID?: Maybe<Scalars['String']>
  remainingItemsReceived?: Maybe<Scalars['Boolean']>
  shipTo: AddressComponents
  status: InvoiceStatus
  tax?: Maybe<Money>
  term: Scalars['String']
  total: Money
}

export type InvoiceReceivingLineItemsArgs = {
  status?: InputMaybe<Array<OrderReceivingLineItemStatus>>
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem'
  brandName?: Maybe<Scalars['String']>
  description: Scalars['String']
  id: Scalars['ID']
  invoiceID: Scalars['ID']
  itemCode?: Maybe<Scalars['String']>
  numberDelivered?: Maybe<Scalars['Float']>
  numberOrdered?: Maybe<Scalars['Float']>
  quantity: Scalars['Int']
  unitOfMeasure: ReceivingUnitOfMeasure
  upc?: Maybe<Scalars['String']>
  upcVariants: Array<Scalars['String']>
  vendorProduct?: Maybe<VendorProduct>
  vendorProductID?: Maybe<Scalars['ID']>
}

export enum InvoicePaymentMethod {
  Ach = 'ACH',
  Cash = 'CASH',
  Check = 'CHECK',
  Credit = 'CREDIT',
}

export enum InvoiceStatus {
  Approved = 'APPROVED',
  Paid = 'PAID',
  Pending = 'PENDING',
}

export type LineItemQuantity = {
  __typename?: 'LineItemQuantity'
  quantity: Scalars['Int']
  uom: UnitOfMeasure
}

export type MapAccountingIntegrationMutationInput = {
  sourceID: Scalars['ID']
  sourceType: AccountingIntegrationSourceType
  targetID?: InputMaybe<Scalars['ID']>
  targetType: AccountingIntegrationTargetType
}

export type MarkInvoiceApprovedMutationInput = {
  invoiceID: Scalars['ID']
}

export type MarkInvoicePaidMutationInput = {
  invoiceID: Scalars['ID']
  notes: Scalars['String']
  paymentMethod: InvoicePaymentMethod
}

export type MatchError = {
  __typename?: 'MatchError'
  error: Scalars['String']
  index: Scalars['Int']
}

export type MatchingVendorProduct = {
  __typename?: 'MatchingVendorProduct'
  matchedBy: MatchingVendorProductReason
  vendorProduct: VendorProduct
}

export enum MatchingVendorProductReason {
  ItemCode = 'ITEM_CODE',
  Upc = 'UPC',
}

export enum MissScanMethod {
  Barebones = 'BAREBONES',
  Copy = 'COPY',
  Gs1 = 'GS1',
  NotMissScan = 'NOT_MISS_SCAN',
  Nutritionix = 'NUTRITIONIX',
}

export type Misscan = {
  id: Scalars['ID']
  misscanType: MisscanType
  misscanVendorProduct: MisscanVendorProduct
  store: Store
  time: Scalars['Timestamp']
  user: User
  vendor: Vendor
}

export type MisscanByIdInput = {
  id: Scalars['ID']
}

export type MisscanLineItem = {
  __typename?: 'MisscanLineItem'
  misscan: MisscanSubmission
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type MisscanLineItemInput = {
  misscanID: Scalars['ID']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type MisscanLineItems = {
  __typename?: 'MisscanLineItems'
  nodes: Array<MisscanLineItem>
}

export type MisscanResolution = Misscan & {
  __typename?: 'MisscanResolution'
  associatedProduct?: Maybe<VendorProduct>
  id: Scalars['ID']
  misscanType: MisscanType
  misscanVendorProduct: MisscanVendorProduct
  store: Store
  time: Scalars['Timestamp']
  user: User
  vendor: Vendor
}

export type MisscanSubmission = Misscan & {
  __typename?: 'MisscanSubmission'
  description: Scalars['String']
  id: Scalars['ID']
  misscanType: MisscanType
  misscanVendorProduct: MisscanVendorProduct
  photoURL?: Maybe<Scalars['String']>
  store: Store
  time: Scalars['Timestamp']
  user: User
  vendor: Vendor
}

export enum MisscanType {
  Resolution = 'RESOLUTION',
  Submission = 'SUBMISSION',
}

/**
 * ****************************
 *      Misscans
 * ****************************
 */
export type MisscanVendorProduct = {
  __typename?: 'MisscanVendorProduct'
  associatedProduct?: Maybe<VendorProduct>
  firstScanDate: Scalars['Timestamp']
  id: Scalars['ID']
  misscanByID?: Maybe<Misscan>
  misscans: MisscansResult
  upc: Scalars['String']
  vendor: Vendor
}

/**
 * ****************************
 *      Misscans
 * ****************************
 */
export type MisscanVendorProductMisscanByIdArgs = {
  input: MisscanByIdInput
}

export type MisscansResult = {
  __typename?: 'MisscansResult'
  nodes: Array<Misscan>
  totalCount: Scalars['Int']
}

export type MissingCartItem = {
  /** Message explaining the reason for this alert, eg 'In Order Guide, but not ordered recently'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  suggestedQuantity: LineItemQuantity
  type: MissingCartItemType
  vendorProduct: VendorProduct
}

export type MissingCartItemStockedNotScanned = MissingCartItem & {
  __typename?: 'MissingCartItemStockedNotScanned'
  /** Message explaining the reason for this alert, eg 'In Order Guide, but not ordered recently'. Clients should only use this field as a fallback when structured fields are not available */
  fallbackMessage: Scalars['String']
  suggestedQuantity: LineItemQuantity
  type: MissingCartItemType
  vendorProduct: VendorProduct
}

export enum MissingCartItemType {
  StockedNotScanned = 'STOCKED_NOT_SCANNED',
}

export type MissingItemSuggestionsResult = {
  __typename?: 'MissingItemSuggestionsResult'
  nodes: Array<MissingCartItem>
}

export type Money = {
  __typename?: 'Money'
  /** Returns the amount as a signed decimal number. ex. 20.41, -29.21 */
  amount: Scalars['Float']
  display: Scalars['String']
}

export type MoneyDisplayArgs = {
  format: CurrencyFormat
}

export type MoneyInput = {
  amount: Scalars['Float']
}

export type MutateTaxRateInput = {
  name: Scalars['String']
  status: Scalars['Boolean']
  taxType: TaxType
  type: TaxRateType
  value: Scalars['String']
}

export type Mutation = {
  __typename?: 'Mutation'
  /** @deprecated Use addProductsToV2OrderGuide */
  addProductsToUserOrderGuide: OrderGuide
  addProductsToV2OrderGuide: AddProductsToV2OrderGuideResult
  addProductsToV2OrderGuideForStoreDepartment: AddProductsToV2OrderGuideResult
  adminBulkEnqueueTasks: Array<TaskResponse>
  adminCreateEdiPartner: EdiPartner
  adminCreateFeatureFlag: FeatureFlag
  adminCreateSFTPConnection: SftpConnectionGql
  adminCreateSFTPGoUser: SftpUser
  adminCreateSFTPUser: SftpUserGql
  adminEnqueueTask: TaskResponse
  adminSyncStediUsers: Array<SyncStediUsersResultGql>
  adminUpdateFeatureFlag: FeatureFlag
  adminUpdateSFTPConnection: SftpConnectionGql
  bulkAddProductsToV2OrderGuide: BulkAddProductsToV2OrderGuideResult
  /** @deprecated Use v2 order guide resolvers */
  bulkCopyUserOrderGuide: CopyUserOrderGuideResult
  bulkCopyV2OrderGuide: CopyV2OrderGuideResult
  bulkCreateOrUpdateVendorStoreDepartmentAccounts: BulkCreateOrUpdateVendorStoreDepartmentAccountsResult
  bulkCreateStores: BulkCreateStoresResult
  bulkCreateVendorInvitation?: Maybe<BulkVendorInvitationsResult>
  bulkCreateVendorStoreDepartmentAccounts: BulkCreateVendorStoreDepartmentAccountsResult
  bulkParseCSVOrderGuides: BulkParsedOrderGuidesResult
  bulkUpdatePointOfSaleDepartmentNameValidationTable: Array<ValidatedPointOfSaleDepartmentName>
  bulkUpdatePointOfSaleItemCodeValidationTable: Array<ValidatedPointOfSaleItemCode>
  bulkUpdatePointOfSaleVendorNameValidationTable: Array<ValidatedPointOfSaleVendorName>
  bulkUpdateStoreDepartments: Array<StoreDepartment>
  bulkUpdateStoreProducts: Array<GqlStoreProduct>
  bulkUpdateUserAccountList: BulkUpdateUserAccountListResult
  /** @deprecated Use addProductsToV2OrderGuide */
  bulkUpdateUserOrderGuide: BulkUpdateUserOrderGuideResult
  bulkUpdateV2OrderGuides: BulkUpdateV2OrderGuidesResult
  bulkUpdateVendorProducts: BulkUpdateVendorProductsResult
  bulkUploadMultiVendorProducts: Array<BulkUploadVendorProductsResult>
  bulkUploadMultiVendorProductsWorker: Array<TaskResponse>
  bulkUploadSingleVendorProducts: BulkUploadVendorProductsResult
  bulkUploadSingleVendorProductsWorker: TaskResponse
  /** For bulk product uploads */
  bulkUploadStoreVendorProducts: BulkUploadStoreVendorProductsResult
  bulkUploadStoreVendorProductsWorker: TaskResponse
  /**
   * Confirms an order with the option to resolve misscans or remove them from
   * the order.
   */
  confirmOrder: Order
  /** @deprecated Use v2 order guide resolvers */
  copyAllUserOrderGuides: CopyUserOrderGuideResult
  /** @deprecated Use v2 order guide resolvers */
  copyUserOrderGuide: CopyUserOrderGuideResult
  copyV2OrderGuide: CopyV2OrderGuideResult
  createAndSubmitOrderFromCart: CartOrderResult
  createAndSubmitTestTrueCommerceOrder: Order
  createAudience: Audience
  createBanner: Banner
  /** Allows store admins to create buyer accounts tied to a specific store. */
  createBuyerAccount: RetailUser
  createCodatCompany: Scalars['Boolean']
  createCustomerInvite: CustomerInviteResult
  createDeal: Deal
  createInvitationOrderGuide: InvitationOrderGuide
  createLineItemCreditRequest: ReconciledLineItem
  createMisscan: Misscan
  createOrder: Order
  createOrderAndSubmit: Order
  createOrderReceivingLineItem: OrderReceivingLineItemListItem
  createPaymentProfile: PaymentProfile
  createPaymentProfileJWT: CreatePaymentProfileJwtResult
  createPlaidLinkToken: PlaidLinkTokenResponse
  /** Used by vori admins to create new (requestable by the store) sample requests */
  createProductSampleRequests: Array<ProductSampleRequest>
  createPromotion: Promotion
  createStore: Store
  /**
   * Allows Vendors to create new Vendor<>Store Accounts.
   * If the stores provided do not match, we create a new store for that account.
   */
  createStoreAccountsForVendor: CreateStoreAccountsForVendorResult
  createStoreDepartment: StoreDepartment
  createStoreDepartments: Array<StoreDepartment>
  createStoreProducts: Array<GqlStoreProduct>
  createStoreReceiver: StoreReceiver
  createStoreVendors: Array<GqlStoreVendor>
  createStripeBankAccountToken: StripeBankAccountTokenResponse
  createTaxRate: GqlTaxRate
  createUser: User
  createUserStoreDepartment: UserStoreDepartment
  createVendor: Vendor
  createVendorProduct: VendorProduct
  createVendorStoreDepartmentAccount: VendorStoreDepartmentAccount
  deleteBanner: DeleteBannerResult
  deleteDeal: DeleteDealResult
  deleteMisscanProducts: DeleteMisscansResult
  deleteOrderReceivingLineItem: OrderReceivingLineItemListItem
  deletePromotion: DeletePromotionResult
  deleteStore: DeleteStoreResult
  deleteUser: DeleteUserResult
  deleteUserStoreDepartment: UserStoreDepartment
  deleteVendorProduct: DeleteVendorProductResult
  exportStoreVendorProductsToCSV: Scalars['String']
  exportV2OrderGuideToCSV: V2OrderGuideCsvResult
  exportVendorCatalogToCSV: Scalars['String']
  fixMisscanVendorProduct: VendorProduct
  getPointOfSaleLogProductsByDepartmentSpreadsheet: Scalars['String']
  /** Allows vendors to send invites to their store customers */
  inviteStoreAccounts: InviteStoreAccountsResult
  mapAccountingIntegrationRecords: Scalars['Boolean']
  markInvoiceAsApproved: Scalars['Boolean']
  markInvoiceAsPaid: Scalars['Boolean']
  parseCSVOrderGuide: ParsedOrderGuideResult
  receivingAppCreateOrderWithInvoiceMutation: Order
  /** @deprecated Use removeProductsFromV2OrderGuide */
  removeProductsFromUserOrderGuide: OrderGuide
  removeProductsFromV2OrderGuide: RemoveProductsFromV2OrderGuideResult
  removeProductsFromV2OrderGuideForStoreDepartment: RemoveProductsFromV2OrderGuideResult
  /** Allows stores to request a catalog from a Vendor. */
  requestCatalog: CatalogRequest
  requestInvoiceForOrder: Scalars['Boolean']
  restoreOrderGuide: Scalars['String']
  sendCreatePaymentProfileEmail: SendCreatePaymentProfileEmailResult
  sendESLConfigUpdate: Scalars['Boolean']
  sendESLFileUpdate: Array<SendEslFileUpdateResult>
  sendESLItemFileRefresh: Array<Scalars['String']>
  sendVendorInvitation?: Maybe<VendorInvitation>
  /** (Re)submits the given order. If no submissionMethod is provided, the vendors' default method is used; otherwise we default to email. */
  submitOrder: Order
  submitOrderReceivingReport: Order
  triggerSESProductSync: Scalars['Boolean']
  undoVendorCatalogCSVUpload: UndoVendorCatalogCsvUploadResult
  /** @deprecated Use updateBannerV2OrderGuides */
  updateAllBannerUsersOrderGuide: BannerOrderGuideUpdateResult
  updateAudience: Audience
  updateBanner: Banner
  updateBannerAuthFileV2OrderGuides: BannerV2OrderGuidesUpdateResult
  updateBannerV2OrderGuides: BannerV2OrderGuidesUpdateResult
  updateBannerVendorEmails: UpdateBannerVendorEmailsResult
  /**
   * Allows store admins to update certain aspects of the buyer accounts they
   * manage.
   */
  updateBuyerProfile: RetailUser
  updateCartMisscanQuantity: UpdateCartMisscanQuantityResult
  /** Update cart quantity for a specific VendorProduct */
  updateCartProductQuantity: UpdateCartProductQuantityResult
  updateCompanyFTPConfig: CompanyFtpConfig
  updateDeal: Deal
  updateLineItemCreditRequest: ReconciledLineItem
  updateOrder: Order
  updateOrderAsDelivered: Order
  updateOrderAsReceived: Order
  updateOrderReceivingLineItem: OrderReceivingLineItemListItem
  updatePointOfSaleIngestLog: PointOfSaleIngestLog
  updateProductSampleRequest: ProductSampleRequest
  updateProfile: User
  updatePromotion: Promotion
  updateStore: Store
  updateStoreDepartmentsSuggestedVendorList: UpdateStoreDepartmentsSuggestedVendorListResult
  updateStoreProduct: GqlStoreProduct
  updateStoreVendor: GqlStoreVendor
  /**
   * Allows store admins to update a store's vendor list. Removing vendors from a
   * store's vendorList will also remove the vendor from all the buyers of
   * the given store.
   */
  updateStoreVendorList: Store
  updateStoreVendorMapping: StoreVendorResult
  /** Allows store admins to update certain store-related data from vendor products. */
  updateStoreVendorProduct: VendorProduct
  updateStoreVendorProductMapping: StoreVendorProductResult
  updateTaxRate: GqlTaxRate
  updateUser: User
  updateUserAccountList: User
  /** @deprecated Use updateV2OrderGuide */
  updateUserOrderGuide: OrderGuide
  updateV2OrderGuide: V2OrderGuide
  updateVendor: Vendor
  /**
   * Update all of the contents of a VendorCart at once
   * @deprecated Use updateVendorCartV2
   */
  updateVendorCart: VendorCart
  /** Update all of the contents of a VendorCart at once */
  updateVendorCartV2: UpdateVendorCartResult
  updateVendorProduct: VendorProduct
  /** @deprecated Use updateVendorStoreDepartmentAccount instead. */
  updateVendorStoreAccount: VendorStoreAccount
  updateVendorStoreDepartmentAccount: VendorStoreDepartmentAccount
  updateVendorStoreDepartmentAccountForVendor: VendorStoreDepartmentAccount
  updateVendorStoreDepartmentAccountStatus: VendorStoreDepartmentAccount
  updateVendorsForStoreDepartment: UpdateVendorsForStoreDepartmentResult
  uploadInvoiceFileForOrder: Array<Scalars['String']>
  uploadPointOfSaleIngest: Array<BulkUploadVendorProductsResult>
}

export type MutationAddProductsToUserOrderGuideArgs = {
  input: AddProductsToOrderGuideInput
}

export type MutationAddProductsToV2OrderGuideArgs = {
  input: AddProductsToV2OrderGuideInput
}

export type MutationAddProductsToV2OrderGuideForStoreDepartmentArgs = {
  input: AddProductsToV2OrderGuideForStoreDepartmentInput
}

export type MutationAdminBulkEnqueueTasksArgs = {
  input: BulkCreateTaskInput
}

export type MutationAdminCreateEdiPartnerArgs = {
  input: AdminCreateEdiPartnerInput
}

export type MutationAdminCreateFeatureFlagArgs = {
  input: AdminCreateFeatureFlagInput
}

export type MutationAdminCreateSftpConnectionArgs = {
  input: CreateSftpConnectionInput
}

export type MutationAdminCreateSftpGoUserArgs = {
  input: AdminCreateSftpGoUserInput
}

export type MutationAdminCreateSftpUserArgs = {
  input: CreateSftpUserInput
}

export type MutationAdminEnqueueTaskArgs = {
  input: CreateTaskInput
}

export type MutationAdminUpdateFeatureFlagArgs = {
  input: AdminUpdateFeatureFlagInput
}

export type MutationAdminUpdateSftpConnectionArgs = {
  input: UpdateSftpConnectionInput
}

export type MutationBulkAddProductsToV2OrderGuideArgs = {
  input: BulkAddProductsToV2OrderGuideInput
}

export type MutationBulkCopyUserOrderGuideArgs = {
  input: BulkCopyUserOrderGuideInput
}

export type MutationBulkCopyV2OrderGuideArgs = {
  input: BulkCopyV2OrderGuideInput
}

export type MutationBulkCreateOrUpdateVendorStoreDepartmentAccountsArgs = {
  input: Array<CreateOrUpdateVendorStoreDepartmentAccountForm>
}

export type MutationBulkCreateStoresArgs = {
  input: BulkCreateStoresInput
}

export type MutationBulkCreateVendorInvitationArgs = {
  input: BulkCreateVendorInvitationInput
}

export type MutationBulkCreateVendorStoreDepartmentAccountsArgs = {
  input: Array<CreateVendorStoreDepartmentAccountForm>
}

export type MutationBulkParseCsvOrderGuidesArgs = {
  input: BulkParseCsvOrderGuidesInput
}

export type MutationBulkUpdatePointOfSaleDepartmentNameValidationTableArgs = {
  bannerID?: InputMaybe<Scalars['ID']>
  input: Array<ValidatedPointOfSaleDepartmentNameInput>
  storeID?: InputMaybe<Scalars['ID']>
}

export type MutationBulkUpdatePointOfSaleItemCodeValidationTableArgs = {
  bannerID?: InputMaybe<Scalars['ID']>
  input: Array<ValidatedPointOfSaleItemCodeInput>
  storeID?: InputMaybe<Scalars['ID']>
}

export type MutationBulkUpdatePointOfSaleVendorNameValidationTableArgs = {
  bannerID?: InputMaybe<Scalars['ID']>
  input: Array<ValidatedPointOfSaleVendorNameInput>
  storeID?: InputMaybe<Scalars['ID']>
}

export type MutationBulkUpdateStoreDepartmentsArgs = {
  data: BulkUpdateStoreDepartmentsInput
}

export type MutationBulkUpdateStoreProductsArgs = {
  data: EditableStoreProductFields
  ids: Array<Scalars['ID']>
}

export type MutationBulkUpdateUserAccountListArgs = {
  input: Array<BulkUpdateUserAccountListInput>
}

export type MutationBulkUpdateUserOrderGuideArgs = {
  input: BulkUpdateUserOrderGuideInput
}

export type MutationBulkUpdateV2OrderGuidesArgs = {
  input: BulkUpdateV2OrderGuidesInput
}

export type MutationBulkUpdateVendorProductsArgs = {
  input: BulkUpdateVendorProductsInput
}

export type MutationBulkUploadMultiVendorProductsArgs = {
  input: BulkUploadMultiVendorProductsInput
}

export type MutationBulkUploadMultiVendorProductsWorkerArgs = {
  input: BulkUploadMultiVendorProductsInput
}

export type MutationBulkUploadSingleVendorProductsArgs = {
  input: BulkUploadSingleVendorProductsInput
}

export type MutationBulkUploadSingleVendorProductsWorkerArgs = {
  input: BulkUploadSingleVendorProductsInput
}

export type MutationBulkUploadStoreVendorProductsArgs = {
  input: BulkUploadStoreVendorProductsInput
}

export type MutationBulkUploadStoreVendorProductsWorkerArgs = {
  input: BulkUploadStoreVendorProductsInput
}

export type MutationConfirmOrderArgs = {
  input: ConfirmOrderInput
}

export type MutationCopyAllUserOrderGuidesArgs = {
  input: CopyAllUserOrderGuideInput
}

export type MutationCopyUserOrderGuideArgs = {
  input: CopyUserOrderGuideInput
}

export type MutationCopyV2OrderGuideArgs = {
  input: CopyV2OrderGuideInput
}

export type MutationCreateAndSubmitOrderFromCartArgs = {
  input: CreateAndSubmitOrderFromCartInput
}

export type MutationCreateAndSubmitTestTrueCommerceOrderArgs = {
  accountNumber: Scalars['String']
  dunsNumber?: InputMaybe<Scalars['String']>
  sampleVendorProductFirestoreID: Scalars['ID']
  storeFirestoreID?: InputMaybe<Scalars['ID']>
  trueCommerceTenetID: Scalars['ID']
  userEmail?: InputMaybe<Scalars['String']>
  vendorFirestoreID: Scalars['ID']
}

export type MutationCreateAudienceArgs = {
  input: CreateAudienceInput
}

export type MutationCreateBannerArgs = {
  input: CreateBannerInput
}

export type MutationCreateBuyerAccountArgs = {
  input: CreateBuyerAccountInput
}

export type MutationCreateCodatCompanyArgs = {
  input: CreateCodatCompanyMutationInput
}

export type MutationCreateCustomerInviteArgs = {
  skipEmail?: InputMaybe<Scalars['Boolean']>
  stores: Array<StoreInviteInput>
  vendorID: Scalars['ID']
}

export type MutationCreateDealArgs = {
  input: CreateDealInput
}

export type MutationCreateInvitationOrderGuideArgs = {
  input: InvitationOrderGuideInput
}

export type MutationCreateLineItemCreditRequestArgs = {
  input: CreateLineItemCreditRequestMutationInput
}

export type MutationCreateMisscanArgs = {
  input: CreateMisscanInput
}

export type MutationCreateOrderArgs = {
  input: CreateOrderInput
}

export type MutationCreateOrderAndSubmitArgs = {
  input: CreateOrderInput
}

export type MutationCreateOrderReceivingLineItemArgs = {
  input: CreateOrderReceivingLineItemInput
}

export type MutationCreatePaymentProfileArgs = {
  input: PaymentProfileInput
}

export type MutationCreatePaymentProfileJwtArgs = {
  input: CreatePaymentProfileJwtInput
}

export type MutationCreatePlaidLinkTokenArgs = {
  clientUserID: Scalars['String']
}

export type MutationCreateProductSampleRequestsArgs = {
  input: CreateProductSampleRequestsInput
}

export type MutationCreatePromotionArgs = {
  input: CreatePromotionInput
}

export type MutationCreateStoreArgs = {
  input: CreateStoreInput
}

export type MutationCreateStoreAccountsForVendorArgs = {
  input: CreateStoreAccountsForVendorInput
}

export type MutationCreateStoreDepartmentArgs = {
  input: CreateStoreDepartmentInput
}

export type MutationCreateStoreDepartmentsArgs = {
  data: CreateStoreDepartmentsInput
}

export type MutationCreateStoreProductsArgs = {
  data: CreateStoreProductsInput
}

export type MutationCreateStoreReceiverArgs = {
  input: CreateStoreReceiverInput
}

export type MutationCreateStoreVendorsArgs = {
  bannerFirestoreID: Scalars['String']
  data: StoreVendorCreateFields
  storeSerialIDs?: InputMaybe<Array<Scalars['String']>>
}

export type MutationCreateStripeBankAccountTokenArgs = {
  input: StripeBankAccountTokenForm
}

export type MutationCreateTaxRateArgs = {
  data: MutateTaxRateInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUserStoreDepartmentArgs = {
  input: CreateUserStoreDepartmentInput
}

export type MutationCreateVendorArgs = {
  input: CreateVendorInput
}

export type MutationCreateVendorProductArgs = {
  input: CreateVendorProductInput
}

export type MutationCreateVendorStoreDepartmentAccountArgs = {
  input: CreateVendorStoreDepartmentAccountForm
}

export type MutationDeleteBannerArgs = {
  input: DeleteBannerInput
}

export type MutationDeleteDealArgs = {
  input: DeleteDealInput
}

export type MutationDeleteMisscanProductsArgs = {
  input: DeleteMisscansInput
}

export type MutationDeleteOrderReceivingLineItemArgs = {
  id: Scalars['ID']
}

export type MutationDeletePromotionArgs = {
  input: DeletePromotionInput
}

export type MutationDeleteStoreArgs = {
  input: DeleteStoreInput
}

export type MutationDeleteUserArgs = {
  input: DeleteUserInput
}

export type MutationDeleteUserStoreDepartmentArgs = {
  input: DeleteUserStoreDepartmentInput
}

export type MutationDeleteVendorProductArgs = {
  input: DeleteVendorProductInput
}

export type MutationExportStoreVendorProductsToCsvArgs = {
  adminOverideCompanyFirestoreID?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  filterByStoreProductSQLIDs?: InputMaybe<Array<Scalars['String']>>
  filterByStoreSQLIDs?: InputMaybe<Array<Scalars['String']>>
  isSESExport?: InputMaybe<Scalars['Boolean']>
  startDate?: InputMaybe<Scalars['Timestamp']>
}

export type MutationExportV2OrderGuideToCsvArgs = {
  id: Scalars['ID']
}

export type MutationExportVendorCatalogToCsvArgs = {
  vendorID: Scalars['String']
}

export type MutationFixMisscanVendorProductArgs = {
  input: FixMisscanInput
}

export type MutationGetPointOfSaleLogProductsByDepartmentSpreadsheetArgs = {
  logID: Scalars['String']
}

export type MutationInviteStoreAccountsArgs = {
  input: InviteStoreAccountsInput
}

export type MutationMapAccountingIntegrationRecordsArgs = {
  input: MapAccountingIntegrationMutationInput
}

export type MutationMarkInvoiceAsApprovedArgs = {
  input: MarkInvoiceApprovedMutationInput
}

export type MutationMarkInvoiceAsPaidArgs = {
  input: MarkInvoicePaidMutationInput
}

export type MutationParseCsvOrderGuideArgs = {
  input: ParseCsvOrderGuideInput
}

export type MutationReceivingAppCreateOrderWithInvoiceMutationArgs = {
  input: CreateInvoiceForNonVoriOrderMutationInput
}

export type MutationRemoveProductsFromUserOrderGuideArgs = {
  input: RemoveProductsFromOrderGuideInput
}

export type MutationRemoveProductsFromV2OrderGuideArgs = {
  input: RemoveProductsFromV2OrderGuideInput
}

export type MutationRemoveProductsFromV2OrderGuideForStoreDepartmentArgs = {
  input: RemoveProductsFromV2OrderGuideForStoreDepartmentInput
}

export type MutationRequestCatalogArgs = {
  input: RequestCatalogInput
}

export type MutationRequestInvoiceForOrderArgs = {
  input: RequestInvoiceForOrderMutationInput
}

export type MutationRestoreOrderGuideArgs = {
  input: RestoreOrderGuideInput
}

export type MutationSendCreatePaymentProfileEmailArgs = {
  input: SendCreatePaymentProfileEmailInput
}

export type MutationSendEslConfigUpdateArgs = {
  input: UpdateEslConfigInput
}

export type MutationSendEslFileUpdateArgs = {
  input: SendEslFileUpdateInput
}

export type MutationSendEslItemFileRefreshArgs = {
  input: SendEslFileRefreshInput
}

export type MutationSendVendorInvitationArgs = {
  input: SendVendorInvitationInput
}

export type MutationSubmitOrderArgs = {
  orderID: Scalars['ID']
  skipEmailWithEDIOrderReSubmission?: InputMaybe<Scalars['Boolean']>
  submissionMethod?: InputMaybe<SubmissionMethod>
}

export type MutationSubmitOrderReceivingReportArgs = {
  input: SubmitOrderReceivingReportInput
}

export type MutationTriggerSesProductSyncArgs = {
  storeID: Scalars['ID']
}

export type MutationUndoVendorCatalogCsvUploadArgs = {
  input?: InputMaybe<UndoVendorCatalogCsvUploadInput>
}

export type MutationUpdateAllBannerUsersOrderGuideArgs = {
  input: UpdateAllBannerUsersOrderGuideInput
}

export type MutationUpdateAudienceArgs = {
  input: UpdateAudienceInput
}

export type MutationUpdateBannerArgs = {
  input: UpdateBannerInput
}

export type MutationUpdateBannerAuthFileV2OrderGuidesArgs = {
  input: UpdateBannerAuthFileV2OrderGuidesInput
}

export type MutationUpdateBannerV2OrderGuidesArgs = {
  input: UpdateBannerV2OrderGuidesInput
}

export type MutationUpdateBannerVendorEmailsArgs = {
  input: UpdateBannerVendorEmailsInput
}

export type MutationUpdateBuyerProfileArgs = {
  input: UpdateBuyerProfileInput
}

export type MutationUpdateCartMisscanQuantityArgs = {
  input: UpdateCartMisscanQuantityInput
}

export type MutationUpdateCartProductQuantityArgs = {
  input: UpdateCartProductQuantityInput
}

export type MutationUpdateCompanyFtpConfigArgs = {
  companyID: Scalars['String']
  companyType: CompanyType
  userName: Scalars['String']
}

export type MutationUpdateDealArgs = {
  input: UpdateDealInput
}

export type MutationUpdateLineItemCreditRequestArgs = {
  input: UpdateLineItemCreditRequestMutationInput
}

export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput
}

export type MutationUpdateOrderAsDeliveredArgs = {
  orderID: Scalars['ID']
}

export type MutationUpdateOrderAsReceivedArgs = {
  orderID: Scalars['ID']
}

export type MutationUpdateOrderReceivingLineItemArgs = {
  id: Scalars['ID']
  input: UpdateOrderReceivingLineItemInput
}

export type MutationUpdatePointOfSaleIngestLogArgs = {
  input?: InputMaybe<PointOfSaleIngestLogInput>
}

export type MutationUpdateProductSampleRequestArgs = {
  input: UpdateProductSampleRequestInput
}

export type MutationUpdateProfileArgs = {
  input?: InputMaybe<UpdateProfileInput>
}

export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput
}

export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput
}

export type MutationUpdateStoreDepartmentsSuggestedVendorListArgs = {
  input: UpdateStoreDepartmentsSuggestedVendorListInput
}

export type MutationUpdateStoreProductArgs = {
  data: EditableStoreProductFields
  id: Scalars['String']
}

export type MutationUpdateStoreVendorArgs = {
  data: StoreVendorEditableFields
  id: Scalars['ID']
}

export type MutationUpdateStoreVendorListArgs = {
  input: UpdateStoreVendorListInput
}

export type MutationUpdateStoreVendorMappingArgs = {
  input: StoreVendorMappingUpdateInput
}

export type MutationUpdateStoreVendorProductArgs = {
  input: UpdateStoreVendorProductInput
}

export type MutationUpdateStoreVendorProductMappingArgs = {
  input: StoreVendorProductsMappingUpdateInput
}

export type MutationUpdateTaxRateArgs = {
  data: MutateTaxRateInput
  id: Scalars['String']
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserAccountListArgs = {
  input: UpdateUserAccountListInput
}

export type MutationUpdateUserOrderGuideArgs = {
  input: UpdateUserOrderGuideInput
}

export type MutationUpdateV2OrderGuideArgs = {
  input: UpdateV2OrderGuideInput
}

export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput
}

export type MutationUpdateVendorCartArgs = {
  input: UpdateVendorCartInput
}

export type MutationUpdateVendorCartV2Args = {
  input: UpdateVendorCartInput
}

export type MutationUpdateVendorProductArgs = {
  input: UpdateVendorProductInput
}

export type MutationUpdateVendorStoreAccountArgs = {
  input: UpdateVendorStoreAccountInput
}

export type MutationUpdateVendorStoreDepartmentAccountArgs = {
  id: Scalars['ID']
  input: UpdateVendorStoreDepartmentAccountForm
}

export type MutationUpdateVendorStoreDepartmentAccountForVendorArgs = {
  input: UpdateVendorStoreDepartmentAccountForm
  storeDepartmentID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type MutationUpdateVendorStoreDepartmentAccountStatusArgs = {
  id: Scalars['ID']
  status: VendorStoreDepartmentAccountStatus
}

export type MutationUpdateVendorsForStoreDepartmentArgs = {
  input: UpdateVendorsForStoreDepartmentInput
}

export type MutationUploadInvoiceFileForOrderArgs = {
  input: UploadInvoiceFileForOrderMutationInput
}

export type MutationUploadPointOfSaleIngestArgs = {
  logID: Scalars['String']
}

export type Order = {
  __typename?: 'Order'
  accountNumber: Scalars['String']
  buyerName: Scalars['String']
  caseCount: Scalars['Int']
  client?: Maybe<ClientType>
  deliveredAt?: Maybe<Scalars['Timestamp']>
  deliveredAtUser?: Maybe<User>
  deliveryDate?: Maybe<Scalars['Timestamp']>
  eachCount: Scalars['Int']
  erpOrderSent: Scalars['Boolean']
  /** Boolean flag that indicates if the order currently contains any misscans. */
  hasMisscans: Scalars['Boolean']
  id: Scalars['ID']
  invoice?: Maybe<Invoice>
  invoicePDFUrl?: Maybe<Scalars['String']>
  isVoriOrder: Scalars['Boolean']
  itemCount: Scalars['Int']
  /** List of misscan products */
  misscans: Array<OrderMisscanLineItem>
  noteToVendor?: Maybe<Scalars['String']>
  orderConfirmed: Scalars['Boolean']
  orderConfirmedBy?: Maybe<Scalars['String']>
  orderContents: Array<OrderLineItem>
  orderDateTime: Scalars['Timestamp']
  orderEmailOpened: Scalars['Boolean']
  orderPlaced: Scalars['Boolean']
  orderPlacedByUserEmail: Scalars['String']
  orderReceivingLineItemList: OrderReceivingLineItemListResult
  orderTotal: Money
  purchaseOrderNum: Scalars['String']
  receivedAt?: Maybe<Scalars['Timestamp']>
  receivedByUser?: Maybe<User>
  receivingAppStatus: OrderReceivingStatus
  receivingStatus: OrderReceivingStatus
  statusHistory: Array<GqlOrderHistoryEventBase>
  storeAddress: Scalars['String']
  storeID: Scalars['String']
  storeName: Scalars['String']
  submissionMethod: SubmissionMethod
  subtotal: Scalars['Currency']
  totalPrice: Scalars['Float']
  user: User
  vendor: Vendor
  vendorID: Scalars['String']
  vendorStoreDepartmentAccount?: Maybe<VendorStoreDepartmentAccount>
}

export type OrderOrderReceivingLineItemListArgs = {
  input?: InputMaybe<OrderReceivingLineItemListInput>
}

export type OrderBillingInfoInput = {
  basisPoints?: InputMaybe<Scalars['Int']>
  billingType: BillingType
  cost?: InputMaybe<Scalars['Currency']>
}

export type OrderEdge = {
  __typename?: 'OrderEdge'
  cursor: Scalars['Cursor']
  node: Order
}

export type OrderGuide = {
  __typename?: 'OrderGuide'
  defaultUOM?: Maybe<UnitOfMeasure>
  products?: Maybe<OrderGuideProductsResult>
  readOnly?: Maybe<Scalars['Boolean']>
  retailUser?: Maybe<RetailUser>
}

export type OrderGuideCsvInput = {
  itemCode?: InputMaybe<Scalars['String']>
  upc?: InputMaybe<Scalars['String']>
}

export type OrderGuideProductsQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type OrderGuideProductsResult = {
  __typename?: 'OrderGuideProductsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type OrderGuideResult = {
  __typename?: 'OrderGuideResult'
  vendorProductIDs: Array<Scalars['String']>
}

export type OrderGuideVendorProductIDsResult = {
  __typename?: 'OrderGuideVendorProductIDsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  totalCount: Scalars['Int']
  vendorProductIDs: Array<Scalars['String']>
}

export type OrderGuideVendorProductsQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  storeDepartmentID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type OrderGuidesResult = {
  __typename?: 'OrderGuidesResult'
  nodes: Array<OrderGuideResult>
  totalCount: Scalars['Int']
}

export type OrderHistoryEventInvoiceApproved = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventInvoiceApproved'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  note: Scalars['String']
  pendingCredits: Money
  status: OrderReceivingStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderHistoryEventInvoicePaid = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventInvoicePaid'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  paymentMethod: InvoicePaymentMethod
  paymentNotes: Scalars['String']
  status: OrderReceivingStatus
  totalPaid: Money
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderHistoryEventOrdered = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventOrdered'
  caseCount: Scalars['Float']
  createdAt: Scalars['DateTime']
  departmentName: Scalars['String']
  eachCount: Scalars['Float']
  id: Scalars['ID']
  status: OrderReceivingStatus
  total: Money
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderHistoryEventReceived = GqlOrderHistoryEventBase & {
  __typename?: 'OrderHistoryEventReceived'
  caseCount: Scalars['Float']
  createdAt: Scalars['DateTime']
  eachCount: Scalars['Float']
  fillRate: Scalars['Float']
  id: Scalars['ID']
  issueCount: Scalars['Float']
  status: OrderReceivingStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export type OrderLineItem = {
  __typename?: 'OrderLineItem'
  deal?: Maybe<Deal>
  orderReceivingLineItem?: Maybe<OrderReceivingLineItem>
  price: Scalars['Int']
  product?: Maybe<VendorProduct>
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type OrderLineItemInput = {
  dealID?: InputMaybe<Scalars['ID']>
  price: Scalars['Int']
  promotion?: InputMaybe<Scalars['String']>
  quantity: Scalars['Int']
  uom: UnitOfMeasure
  vendorProductID: Scalars['ID']
}

export type OrderMispick = {
  __typename?: 'OrderMispick'
  brandName?: Maybe<Scalars['String']>
  createMispickItem?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  details: Scalars['String']
  id: Scalars['ID']
  idempotencyKey?: Maybe<Scalars['String']>
  imageURLs: Array<Scalars['String']>
  issueQuantity?: Maybe<Scalars['Int']>
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  upc?: Maybe<Scalars['String']>
  vendorProduct?: Maybe<VendorProduct>
}

export type OrderMispickInput = {
  brandName?: InputMaybe<Scalars['String']>
  createMispickItem?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  idempotencyKey: Scalars['String']
  imageURLs?: InputMaybe<Array<Scalars['String']>>
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  upc?: InputMaybe<Scalars['String']>
  vendorProductID?: InputMaybe<Scalars['String']>
}

export type OrderMisscanLineItem = {
  __typename?: 'OrderMisscanLineItem'
  misscanVendorProduct: MisscanVendorProduct
  quantity: Scalars['Int']
  resolution: MisscanSubmission
  unitOfMeasure: UnitOfMeasure
}

export type OrderMisscanLineItemInput = {
  misscanVendorProductID: Scalars['ID']
  quantity: Scalars['Int']
  resolutionID: Scalars['ID']
  unitOfMeasure: UnitOfMeasure
}

export type OrderReceivingLineItem = {
  __typename?: 'OrderReceivingLineItem'
  brandName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  details: Scalars['String']
  id: Scalars['ID']
  imageURLs: Array<Scalars['String']>
  issueQuantity?: Maybe<Scalars['Int']>
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  upc?: Maybe<Scalars['String']>
}

export type OrderReceivingLineItemInput = {
  issueQuantity?: InputMaybe<Scalars['Int']>
  quantity: Scalars['Int']
  status: OrderReceivingLineItemStatus
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['String']
}

export type OrderReceivingLineItemListInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  query?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<OrderReceivingLineItemListSortingInput>
  status?: InputMaybe<Array<OrderReceivingLineItemStatus>>
}

export type OrderReceivingLineItemListItem = OrderLineItem | OrderMispick

export type OrderReceivingLineItemListResult = {
  __typename?: 'OrderReceivingLineItemListResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<OrderReceivingLineItemListItem>
}

export enum OrderReceivingLineItemListSortingField {
  Brand = 'BRAND',
  Description = 'DESCRIPTION',
  ItemCode = 'ITEM_CODE',
}

export type OrderReceivingLineItemListSortingInput = {
  field: OrderReceivingLineItemListSortingField
}

export enum OrderReceivingLineItemStatus {
  Damaged = 'DAMAGED',
  Mispick = 'MISPICK',
  NotDelivered = 'NOT_DELIVERED',
  Ok = 'OK',
  Outdated = 'OUTDATED',
  Short = 'SHORT',
}

export enum OrderReceivingStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Paid = 'PAID',
  /** V2 */
  Pending = 'PENDING',
  Received = 'RECEIVED',
}

export type OrdersResult = {
  __typename?: 'OrdersResult'
  nodes: Array<Order>
  totalCount: Scalars['Int']
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor: Scalars['Cursor']
  hasNextPage: Scalars['Boolean']
  startCursor: Scalars['Cursor']
}

export type PaginatedInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  search?: InputMaybe<Scalars['String']>
}

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD',
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>
  direction?: InputMaybe<PaginationDirection>
}

export type ParseCsvOrderGuideInput = {
  forInvitationOrderGuide?: InputMaybe<Scalars['Boolean']>
  forRetailAccountIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  orderGuideCSVInput: Array<OrderGuideCsvInput>
  vendorID: Scalars['ID']
}

export type ParsedOrderGuideResult = {
  __typename?: 'ParsedOrderGuideResult'
  errors: Array<Maybe<Scalars['Int']>>
  hasErrors: Scalars['Boolean']
  retailAccountIDs?: Maybe<Array<Scalars['String']>>
  vendorID: Scalars['String']
  vendorProductIDs: Array<Scalars['String']>
}

export type ParsedProduct = {
  __typename?: 'ParsedProduct'
  errors?: Maybe<Array<ParsedProductErrorCode>>
  product?: Maybe<PointOfSaleVendorProduct>
  skipped?: Maybe<Scalars['Boolean']>
}

export enum ParsedProductErrorCode {
  MissingItemCode = 'MISSING_ITEM_CODE',
  UnmatchedDepartment = 'UNMATCHED_DEPARTMENT',
  UnmatchedVendorName = 'UNMATCHED_VENDOR_NAME',
}

export type ParsedProductInput = {
  errors?: InputMaybe<Array<ParsedProductErrorCode>>
  product?: InputMaybe<PointOfSaleVendorProductInput>
  skipped?: InputMaybe<Scalars['Boolean']>
}

export enum ParsedProductsFilters {
  InvalidProducts = 'INVALID_PRODUCTS',
  MissingItemCode = 'MISSING_ITEM_CODE',
  Skipped = 'SKIPPED',
  UnmatchedDepartment = 'UNMATCHED_DEPARTMENT',
  UnmatchedVendorName = 'UNMATCHED_VENDOR_NAME',
  ValidProducts = 'VALID_PRODUCTS',
}

export type ParsedProductsInput = {
  cursor?: InputMaybe<Scalars['Int']>
  filterBy?: InputMaybe<ParsedProductsFilters>
  limit?: InputMaybe<Scalars['Int']>
}

export type ParsedProductsResult = {
  __typename?: 'ParsedProductsResult'
  cursor: Scalars['Int']
  hasMore: Scalars['Boolean']
  nodes: Array<ParsedProduct>
  totalCount: Scalars['Int']
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod'
  accountHolderName?: Maybe<Scalars['String']>
  accountHolderType?: Maybe<Scalars['String']>
  bankName?: Maybe<Scalars['String']>
  brand?: Maybe<Scalars['String']>
  expMonth?: Maybe<Scalars['Int']>
  expYear?: Maybe<Scalars['Int']>
  last4: Scalars['String']
  paymentMethodType: PaymentMethodType
  routingNumber?: Maybe<Scalars['String']>
  stripeID: Scalars['String']
}

export enum PaymentMethodType {
  BankAccount = 'bank_account',
  Card = 'card',
}

/**
 * ****************************
 *       Payment Profile
 * ****************************
 */
export type PaymentProfile = {
  __typename?: 'PaymentProfile'
  bannerID?: Maybe<Scalars['String']>
  email: Scalars['String']
  id: Scalars['String']
  paymentMethods: Array<PaymentMethod>
  storeID?: Maybe<Scalars['String']>
  stripeCustomerID: Scalars['String']
  vendorID?: Maybe<Scalars['String']>
}

export type PaymentProfileInput = {
  bannerID?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  name: Scalars['String']
  paymentMethodType: PaymentMethodType
  storeID?: InputMaybe<Scalars['String']>
  stripeBankAccountTokenID?: InputMaybe<Scalars['String']>
  stripeCardTokenID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type PercentageDeal = Deal & {
  __typename?: 'PercentageDeal'
  basisPoints: Scalars['Int']
  displayName: Scalars['String']
  id: Scalars['ID']
  promotion: Promotion
  type: DealType
  vendorDiscountCode?: Maybe<Scalars['String']>
  vendorProducts: DealVendorProductsResult
  vendorProductsByBrand?: Maybe<VendorProductsByBrandResult>
}

export type PercentageDealVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type PercentageDealVendorProductsByBrandArgs = {
  input?: InputMaybe<DealVendorProductsByBrandInput>
}

/**
 * ****************************
 *       Bank Account
 * ****************************
 */
export type PlaidLinkTokenResponse = {
  __typename?: 'PlaidLinkTokenResponse'
  expiration: Scalars['Timestamp']
  plaidLinkToken: Scalars['String']
  requestID: Scalars['String']
}

export type PointOfSaleIngestLog = {
  __typename?: 'PointOfSaleIngestLog'
  banner?: Maybe<Banner>
  filePath: Scalars['String']
  id: Scalars['String']
  numOfStoreDiscontinuedProducts: Scalars['Int']
  numProducts: Scalars['Int']
  parsedProducts: ParsedProductsResult
  parsedProductsJSONFilePath: Scalars['String']
  skipped: Scalars['Boolean']
  store?: Maybe<Store>
  timestamp: Scalars['Timestamp']
  type: FtpFileType
  uploaded: Scalars['Boolean']
}

export type PointOfSaleIngestLogParsedProductsArgs = {
  input?: InputMaybe<ParsedProductsInput>
}

export type PointOfSaleIngestLogInput = {
  id: Scalars['String']
  parsedProducts?: InputMaybe<Array<ParsedProductInput>>
  skipProduct?: InputMaybe<PointOfSaleVendorProductInput>
  skipped?: InputMaybe<Scalars['Boolean']>
  unskipProduct?: InputMaybe<PointOfSaleVendorProductInput>
  uploaded?: InputMaybe<Scalars['Boolean']>
}

export type PointOfSaleIngestLogMetaData = {
  __typename?: 'PointOfSaleIngestLogMetaData'
  banner?: Maybe<Banner>
  filePath: Scalars['String']
  id: Scalars['String']
  numOfStoreDiscontinuedProducts: Scalars['Int']
  numProducts: Scalars['Int']
  parsedProductsJSONFilePath: Scalars['String']
  skipped: Scalars['Boolean']
  store?: Maybe<Store>
  timestamp: Scalars['Timestamp']
  type: FtpFileType
  uploaded: Scalars['Boolean']
}

export type PointOfSaleVendorProduct = {
  __typename?: 'PointOfSaleVendorProduct'
  brandName?: Maybe<Scalars['String']>
  casePrice?: Maybe<Scalars['Currency']>
  caseSize?: Maybe<Scalars['Float']>
  caseUPC?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  departmentName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  discontinuedDate?: Maybe<Scalars['Timestamp']>
  fuzzyMatchedVendorID?: Maybe<Scalars['String']>
  fuzzyMatchedVendorName?: Maybe<Scalars['String']>
  imgURL?: Maybe<Scalars['String']>
  inventory?: Maybe<Scalars['Int']>
  itemCode?: Maybe<Scalars['String']>
  notes?: Maybe<Scalars['String']>
  packUPC?: Maybe<Scalars['String']>
  pointOfSaleDepartmentName?: Maybe<Scalars['String']>
  pointOfSaleVendorName?: Maybe<Scalars['String']>
  sizing?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['Timestamp']>
  status?: Maybe<VendorProductStatus>
  unitPrice?: Maybe<Scalars['Currency']>
  unitUPC?: Maybe<Scalars['String']>
  unitVolume?: Maybe<Scalars['String']>
  vendor?: Maybe<Vendor>
  vendorID?: Maybe<Scalars['ID']>
}

export type PointOfSaleVendorProductInput = {
  brandName?: InputMaybe<Scalars['String']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  departmentName?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  discontinuedDate?: InputMaybe<Scalars['Timestamp']>
  fuzzyMatchedVendorID?: InputMaybe<Scalars['ID']>
  fuzzyMatchedVendorName?: InputMaybe<Scalars['String']>
  imgURL?: InputMaybe<Scalars['String']>
  inventory?: InputMaybe<Scalars['Int']>
  itemCode?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  pointOfSaleDepartmentName?: InputMaybe<Scalars['String']>
  pointOfSaleVendorName?: InputMaybe<Scalars['String']>
  sizing?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['Timestamp']>
  status?: InputMaybe<VendorProductStatus>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['ID']>
  vendorName?: InputMaybe<Scalars['String']>
}

export type PotentialPromotionConflictsInput = {
  /** Check for conflicts against all the vendor's store accounts. This flag will override any given `audienceID` */
  allAccounts?: InputMaybe<Scalars['Boolean']>
  /** Check for conflicts assuming a hypothetical audience. Defaults to the Promotion's existing deals. */
  audienceID?: InputMaybe<Scalars['ID']>
  /** Check for conflicts with a hypothetical end date. Defaults to the Promotion's existing endDate. */
  endDate: Scalars['Timestamp']
  /** Check for conflicts with a hypothetical start date. Defaults to the Promotion's existing startDate. */
  startDate: Scalars['Timestamp']
}

export type PotentialPromotionConflictsResult = {
  __typename?: 'PotentialPromotionConflictsResult'
  nodes: Array<VendorProductPromotionConflict>
  totalCount: Scalars['Int']
}

export type PricingInfo = {
  __typename?: 'PricingInfo'
  casePrice?: Maybe<Scalars['Currency']>
  unitPrice?: Maybe<Scalars['Currency']>
}

export type Product = {
  __typename?: 'Product'
  /** All VendorProducts (across all accessible Vendors) matching this Product's UPCs */
  allVendorProducts: ProductAllVendorProductsResult
  brandName?: Maybe<Scalars['String']>
  caseUPC?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  /** @deprecated Use top-level MissScan resolvers */
  createdInApp?: Maybe<Scalars['String']>
  departmentName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imgURL?: Maybe<Scalars['String']>
  /** @deprecated Use top-level MissScan resolvers */
  isMissScan?: Maybe<Scalars['Boolean']>
  /** @deprecated Use top-level MissScan resolvers */
  missScanMethod?: Maybe<MissScanMethod>
  packUPC?: Maybe<Scalars['String']>
  unitUPC?: Maybe<Scalars['String']>
  unitUPCVariants?: Maybe<Array<Maybe<Scalars['String']>>>
  unitVolume?: Maybe<Scalars['String']>
  /** @deprecated Use unitUPC instead */
  upc?: Maybe<Scalars['String']>
}

export type ProductAllVendorProductsResult = {
  __typename?: 'ProductAllVendorProductsResult'
  nodes: Array<VendorProduct>
}

export type ProductLookupMetadata = {
  __typename?: 'ProductLookupMetadata'
  brandName?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  photoURL?: Maybe<Scalars['String']>
  unitVolume?: Maybe<Scalars['String']>
  upc: Scalars['String']
}

/**
 * ****************************
 *      Product Order History
 * ****************************
 */
export type ProductOrderHistory = {
  __typename?: 'ProductOrderHistory'
  order?: Maybe<Order>
  orderDateTime: Scalars['Timestamp']
  orderID: Scalars['ID']
  price: Scalars['Currency']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProduct?: Maybe<VendorProduct>
}

export type ProductOrderHistoryInput = {
  limit?: InputMaybe<Scalars['Int']>
  productID: Scalars['ID']
}

export type ProductOrderHistoryResult = {
  __typename?: 'ProductOrderHistoryResult'
  nodes: Array<ProductOrderHistory>
}

export type ProductSampleRequest = {
  __typename?: 'ProductSampleRequest'
  id: Scalars['ID']
  /** null if PSR hasn't been requested yet */
  requestedAt?: Maybe<Scalars['Timestamp']>
  /** null if PSR hasn't been requested yet */
  requestedByUser?: Maybe<User>
  status: SampleRequestStatus
  store: Store
  vendor: Vendor
}

export type ProductSamplesResult = {
  __typename?: 'ProductSamplesResult'
  nodes: Array<ProductSampleRequest>
}

export enum ProductSourceFilter {
  StoreSpecific = 'STORE_SPECIFIC',
  Wholesale = 'WHOLESALE',
}

export type Promotion = {
  __typename?: 'Promotion'
  /** A boolean flag that determines if the promotion is to be applied to all the vendor store accounts. When `true` this flag will override any value defined on the `Promotion.audience` field. */
  allAccounts?: Maybe<Scalars['Boolean']>
  audience?: Maybe<Audience>
  deals: DealsResults
  endDate?: Maybe<Scalars['Timestamp']>
  id: Scalars['ID']
  isPublished?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['Timestamp']>
  status: PromotionStatus
  totalSales: Scalars['Currency']
  vendor: Vendor
}

export enum PromotionStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Upcoming = 'UPCOMING',
}

export type PromotionsResults = {
  __typename?: 'PromotionsResults'
  nodes: Array<Promotion>
}

export type ProspectiveStoresInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type ProspectiveStoresResults = {
  __typename?: 'ProspectiveStoresResults'
  cursor?: Maybe<Scalars['String']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Store>
  totalCount?: Maybe<Scalars['Int']>
}

export type Query = {
  __typename?: 'Query'
  accountingIntegrationMappingConfiguration: AccountingIntegrationMappingConfig
  accountingIntegrationRecords: AccountingIntegrationRecords
  /** @deprecated allBanners is more efficient and includes pagination */
  adminAllBanners: BannersResult
  adminAllCatalogRequests: CatalogRequestsResult
  adminAllFeatureFlags?: Maybe<FeatureFlagsResult>
  adminAllOrders: OrdersResult
  adminAllProductSampleRequests: ProductSamplesResult
  /** @deprecated allStores is more efficient and includes pagination */
  adminAllStores: StoresResult
  adminAllUsers: UsersResult
  adminAllVendorInvitations: VendorInvitationsResult
  adminAllVendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
  /** @deprecated allVendors is more efficient and includes pagination */
  adminAllVendors: VendorsResult
  adminGetLegacyOrderGuideVendorProductsForUserAndVendor: VendorProductsByIDsResult
  adminSimilarStores: StoresResult
  adminStoreInvitations: StoreInvitationsResult
  adminStoreVendorProductsQuery: AdminStoreVendorProductsQueryResult
  adminStoreVendorsQuery: AdminStoreVendorsQueryResult
  adminStoresByID: AdminStoresResult
  adminUsersPaginated: UsersResult
  adminVendorInvitations: AdminVendorInvitationsResult
  adminVendorStoreDepartmentAccountsByID: AdminVendorStoreDepartmentAccountsResult
  adminVendorsByID: AdminVendorsResult
  allBanners: AllBannersResult
  allStores: AllStoresResult
  allVendors: AllVendorsResult
  bannerByID?: Maybe<Banner>
  bannerOrders: BannerOrdersResult
  bulkGetOrderStoreCountByVendorIDs: BulkGetOrderStoreCountByVendorIDsResult
  bulkGetVSDAsOrderGuides: V2OrderGuidesResult
  bulkSuggestStores: BulkSuggestStoresResult
  dealByID?: Maybe<Deal>
  /** Returns a CSV upload log based on the given ID. */
  getCSVUploadLogByID?: Maybe<CsvUploadLog>
  /**
   * Returns a list of CSV upload logs. If this query is executed by a vendor
   * admin, they will only be able to fetch for logs made to their catalog.
   */
  getCSVUploadLogs: GetCsvUploadLogsResult
  getCompanyFTPConfigs: CompanyFtpConfigResult
  /** Returns discontinued vendor products based on the given `retailCompanyID`. */
  getDiscontinuedVendorProductsForRetailCompany: GetDiscontinuedVendorProductsForRetailCompanyResult
  getEPLUMProductsForStoreQuery: Scalars['String']
  getESLConfig?: Maybe<GqleslConfig>
  getExploDashboardForUserQuery: ExploConfig
  getMatchingVendorProducts: GetMatchingVendorProductsResult
  getMetabaseDashboardForUserQuery: Scalars['String']
  /**
   * Returns new vendor products based on the given `retailCompanyID`. Vendor
   * products are considered new, when they have been created within the span of
   * 7 days.
   */
  getNewVendorProductsForRetailCompany: GetNewVendorProductsForRetailCompanyResult
  getOrderMispickByID?: Maybe<OrderMispick>
  getPointOfSaleIngestLogByID: PointOfSaleIngestLog
  getPointOfSaleIngestLogs: Array<PointOfSaleIngestLogMetaData>
  getStoreDepartmentByID?: Maybe<StoreDepartment>
  getStoreDepartmentsByStoreID?: Maybe<Array<Maybe<StoreDepartment>>>
  getUserAbandonedCarts: GetUserAbandonedCartsResult
  getVendorAbandonedCarts: GetVendorAbandonedCartsResult
  getVendorStoreDepartmentAccountByID?: Maybe<VendorStoreDepartmentAccount>
  getVendorStoreDepartmentAccountForVendor?: Maybe<VendorStoreDepartmentAccount>
  /** @deprecated Use getVendorStoreDepartmentAccountsForVendorAndStore */
  getVendorStoreDepartmentAccountForVendorAndStore?: Maybe<VendorStoreDepartmentAccount>
  getVendorStoreDepartmentAccountsForStore: VendorStoreDepartmentAccountResult
  /** @deprecated Use store.vendorStoreDepartmentAccounts */
  getVendorStoreDepartmentAccountsForStores: VendorStoreDepartmentAccountResult
  getVendorStoreDepartmentAccountsForVendorAndStore: VendorStoreDepartmentAccountResult
  inventoryHubLineItemByID: ReconciledLineItem
  inventoryHubOrderByID: Order
  inventoryHubOrdersByIDs: Array<Order>
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleInvoices` instead. */
  inventoryHubStoreAPOrdersQuery: InventoryHubOrdersViewConnection
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleOrders` instead. */
  inventoryHubStoreAdminOrdersQuery: InventoryHubOrdersViewConnection
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleOrders` instead. */
  inventoryHubStoreBuyerOrdersQuery: InventoryHubOrdersViewConnection
  me?: Maybe<Viewer>
  misscanByID?: Maybe<Misscan>
  misscanVendorProductByID?: Maybe<MisscanVendorProduct>
  orderByID?: Maybe<Order>
  orderByPO?: Maybe<Order>
  promotionByID?: Maybe<Promotion>
  /** Get list of deleted product ids. Provide deletedAfter flag to limit search */
  queryDeletedVendorProducts: Array<Scalars['ID']>
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleInvoiceLineItems` instead. */
  queryInventoryHubAPViewLineItems: ReconciledLineItemsConnection
  /** @deprecated We are moving away from operations that are specific to certain user types. Please use `queryInvoiceModuleOrderLineItems` instead. */
  queryInventoryHubBuyerViewLineItems: ReconciledLineItemsConnection
  queryInvoiceModuleInvoiceLineItems: ReconciledLineItemsConnection
  queryInvoiceModuleInvoices: InventoryHubOrdersViewConnection
  queryInvoiceModuleOrderLineItems: ReconciledLineItemsConnection
  queryInvoiceModuleOrders: InventoryHubOrdersViewConnection
  queryInvoices: Array<Invoice>
  queryMasterCatalogProductMetadataByBarcode?: Maybe<GqlMasterCatalogProductMetadata>
  queryOrderGuideProducts: VendorProductsQueryResult
  queryOrderGuideVendorProducts: VendorProductsQueryResult
  queryStoreProductByBarcode: Array<GqlStoreProduct>
  queryVendorStoreAccountProducts: VendorProductsQueryResult
  searchAllVendorProducts: SearchAllVendorProductsQueryResult
  searchStores: SearchStoresQueryResult
  searchVendors: SearchVendorsQueryResult
  /** Returns a list of all vendor accounts that available for store admins to access. */
  storeAdminVendors: StoreAdminVendorsResult
  storeByID?: Maybe<Store>
  storeDepartments: Array<StoreDepartment>
  storeDepartmentsForCompany: StoreDepartmentViewConnection
  storeInvitation?: Maybe<StoreInvitation>
  /** @deprecated Use store.orders instead */
  storeOrders: StoreOrdersResult
  storeVendor: GqlStoreVendor
  storeVendors: Array<GqlStoreVendor>
  storesForCompany: StoreViewConnection
  /** Allow searching existing stores that might be relevant to a vendor */
  suggestStores: SuggestStoresResult
  taxRate: GqlTaxRate
  taxRates: Array<GqlTaxRate>
  userByID?: Maybe<User>
  /** Use to validate a csv for store vendor product upload */
  validateBulkUploadStoreVendorProducts: Array<ValidateBulkUploadStoreVendorProductsResult>
  /** Use to validate a csv for vendor catalog upload */
  validateBulkUploadVendorProducts: Array<ValidateBulkUploadVendorProductsResult>
  /** Returns a list of all duplicate invitation order guide names */
  validateInvitationOrderGuideNames?: Maybe<ValidateInvitationOrderGuideNamesResult>
  vendorByID?: Maybe<Vendor>
  /** Return vendors matching the passed-in URL slug. If no Vendors match, falls back to treating the input as an ID. */
  vendorBySlug?: Maybe<Vendor>
  vendorForVendorUser?: Maybe<Vendor>
  vendorOrders: VendorOrdersResult
  vendorProductByID?: Maybe<VendorProduct>
  vendorProductByUPC: VendorProductsResult
  vendorProductSuggestionsByUPC: VendorProductSuggestionsResult
  vendorProducts: VendorProductsResult
  vendorProductsByIDs?: Maybe<VendorProductsByIDsResult>
  vendorStoreAccountProductsByUpdateTime: VendorProductsResult
  vendorStoreDepartmentAccountsForCompany: VsdaViewConnection
  vendorsForCompany: VendorViewConnection
}

export type QueryAccountingIntegrationRecordsArgs = {
  input: AccountingIntegrationRecordsInput
}

export type QueryAdminAllBannersArgs = {
  posBannersOnly?: InputMaybe<Scalars['Boolean']>
}

export type QueryAdminAllOrdersArgs = {
  input?: InputMaybe<AdminAllOrdersInput>
}

export type QueryAdminAllStoresArgs = {
  input?: InputMaybe<AdminAllStoresInput>
  posStoresOnly?: InputMaybe<Scalars['Boolean']>
}

export type QueryAdminAllUsersArgs = {
  input?: InputMaybe<AdminAllUsersInput>
}

export type QueryAdminAllVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type QueryAdminGetLegacyOrderGuideVendorProductsForUserAndVendorArgs = {
  userID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryAdminSimilarStoresArgs = {
  input: AdminSimilarStoresInput
}

export type QueryAdminStoreInvitationsArgs = {
  input?: InputMaybe<AdminStoreInvitationsInput>
}

export type QueryAdminStoreVendorProductsQueryArgs = {
  input: StoreVendorProductsQueryInput
}

export type QueryAdminStoreVendorsQueryArgs = {
  input: StoreVendorsQueryInput
}

export type QueryAdminStoresByIdArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryAdminUsersPaginatedArgs = {
  input?: InputMaybe<AdminUsersPaginatedInput>
}

export type QueryAdminVendorInvitationsArgs = {
  input?: InputMaybe<AdminVendorInvitationsInput>
}

export type QueryAdminVendorStoreDepartmentAccountsByIdArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryAdminVendorsByIdArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryAllBannersArgs = {
  input?: InputMaybe<PaginatedInput>
}

export type QueryAllStoresArgs = {
  input?: InputMaybe<PaginatedInput>
}

export type QueryAllVendorsArgs = {
  filterStoreVendors?: InputMaybe<Scalars['Boolean']>
  input?: InputMaybe<PaginatedInput>
}

export type QueryBannerByIdArgs = {
  id: Scalars['ID']
}

export type QueryBannerOrdersArgs = {
  input: BannerOrdersInputRoot
}

export type QueryBulkGetOrderStoreCountByVendorIDsArgs = {
  vendorIDs: Array<Scalars['ID']>
}

export type QueryBulkGetVsdAsOrderGuidesArgs = {
  input: BulkGetVsdAsOrderGuidesInput
}

export type QueryBulkSuggestStoresArgs = {
  input: BulkSuggestStoresInput
}

export type QueryDealByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetCsvUploadLogByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetCsvUploadLogsArgs = {
  input?: InputMaybe<GetCsvUploadLogsInput>
}

export type QueryGetCompanyFtpConfigsArgs = {
  companyID?: InputMaybe<Scalars['String']>
}

export type QueryGetDiscontinuedVendorProductsForRetailCompanyArgs = {
  input: GetDiscontinuedVendorProductsForRetailCompanyInput
}

export type QueryGetEplumProductsForStoreQueryArgs = {
  storeID: Scalars['String']
}

export type QueryGetEslConfigArgs = {
  input: EslConfigInput
}

export type QueryGetMatchingVendorProductsArgs = {
  input: GetMatchingVendorProductsInput
}

export type QueryGetNewVendorProductsForRetailCompanyArgs = {
  input: GetNewVendorProductsForRetailCompanyInput
}

export type QueryGetOrderMispickByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetPointOfSaleIngestLogByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetPointOfSaleIngestLogsArgs = {
  filterOutUploaded: Scalars['Boolean']
  forBannerID?: InputMaybe<Scalars['String']>
  forStoreID?: InputMaybe<Scalars['String']>
}

export type QueryGetStoreDepartmentByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetStoreDepartmentsByStoreIdArgs = {
  id: Scalars['ID']
}

export type QueryGetUserAbandonedCartsArgs = {
  input?: InputMaybe<GetUserAbandonedCartsInput>
}

export type QueryGetVendorAbandonedCartsArgs = {
  input?: InputMaybe<GetVendorAbandonedCartsInput>
}

export type QueryGetVendorStoreDepartmentAccountByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountForVendorArgs = {
  storeDepartmentID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountForVendorAndStoreArgs = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountsForStoreArgs = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
}

export type QueryGetVendorStoreDepartmentAccountsForStoresArgs = {
  storeIDs: Array<Scalars['ID']>
}

export type QueryGetVendorStoreDepartmentAccountsForVendorAndStoreArgs = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type QueryInventoryHubLineItemByIdArgs = {
  id: Scalars['ID']
}

export type QueryInventoryHubOrderByIdArgs = {
  id: Scalars['ID']
}

export type QueryInventoryHubOrdersByIDsArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryInventoryHubStoreApOrdersQueryArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryInventoryHubStoreAdminOrdersQueryArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryInventoryHubStoreBuyerOrdersQueryArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryMeArgs = {
  input?: InputMaybe<MeQueryInput>
}

export type QueryMisscanByIdArgs = {
  id: Scalars['ID']
}

export type QueryMisscanVendorProductByIdArgs = {
  id: Scalars['ID']
}

export type QueryOrderByIdArgs = {
  id: Scalars['ID']
}

export type QueryOrderByPoArgs = {
  poNum: Scalars['String']
}

export type QueryPromotionByIdArgs = {
  id: Scalars['ID']
}

export type QueryQueryDeletedVendorProductsArgs = {
  input?: InputMaybe<DeletedVendorProductsInput>
}

export type QueryQueryInventoryHubApViewLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInventoryHubBuyerViewLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInvoiceModuleInvoiceLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInvoiceModuleInvoicesArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryQueryInvoiceModuleOrderLineItemsArgs = {
  input: ReconciledLineItemConnectionInput
}

export type QueryQueryInvoiceModuleOrdersArgs = {
  input: InventoryHubOrderQueryInput
}

export type QueryQueryMasterCatalogProductMetadataByBarcodeArgs = {
  barcode: Scalars['String']
}

export type QueryQueryOrderGuideProductsArgs = {
  input: OrderGuideProductsQueryInput
}

export type QueryQueryOrderGuideVendorProductsArgs = {
  input: OrderGuideVendorProductsQueryInput
}

export type QueryQueryStoreProductByBarcodeArgs = {
  barcode: Scalars['String']
  filterByStoreSQLIDs?: InputMaybe<Array<Scalars['String']>>
}

export type QueryQueryVendorStoreAccountProductsArgs = {
  input: VendorStoreProductsQueryInput
}

export type QuerySearchAllVendorProductsArgs = {
  input: UniversalVendorProductsQueryInput
}

export type QuerySearchStoresArgs = {
  input: SearchStoresQueryInput
}

export type QuerySearchVendorsArgs = {
  input: SearchVendorsQueryInput
}

export type QueryStoreAdminVendorsArgs = {
  input?: InputMaybe<StoreAdminVendorsInput>
}

export type QueryStoreByIdArgs = {
  id: Scalars['ID']
}

export type QueryStoreDepartmentsArgs = {
  data: GetStoreDepartmentsInput
}

export type QueryStoreDepartmentsForCompanyArgs = {
  input: StoreDepartmentQueryInput
}

export type QueryStoreInvitationArgs = {
  invitationCode: Scalars['String']
}

export type QueryStoreOrdersArgs = {
  input: StoreOrdersInput
}

export type QueryStoreVendorArgs = {
  id: Scalars['String']
}

export type QueryStoresForCompanyArgs = {
  input: StoreQueryInput
}

export type QuerySuggestStoresArgs = {
  input: SuggestStoresInput
}

export type QueryTaxRateArgs = {
  id: Scalars['String']
}

export type QueryUserByIdArgs = {
  id: Scalars['ID']
}

export type QueryValidateBulkUploadStoreVendorProductsArgs = {
  inputProducts: Array<BulkStoreVendorProductInput>
  storeSQLIDs: Array<Scalars['ID']>
}

export type QueryValidateBulkUploadVendorProductsArgs = {
  inputProducts: Array<BulkVendorProductInput>
  isMultiVendorUpload: Scalars['Boolean']
  vendorIDForSingleVendorValidation?: InputMaybe<Scalars['String']>
}

export type QueryValidateInvitationOrderGuideNamesArgs = {
  orderGuideNames: Array<Scalars['String']>
  vendorID: Scalars['ID']
}

export type QueryVendorByIdArgs = {
  id: Scalars['ID']
}

export type QueryVendorBySlugArgs = {
  slugOrID?: InputMaybe<Scalars['String']>
}

export type QueryVendorForVendorUserArgs = {
  userID: Scalars['ID']
}

export type QueryVendorOrdersArgs = {
  input: VendorOrdersInput
}

export type QueryVendorProductByIdArgs = {
  id: Scalars['String']
  storeID?: InputMaybe<Scalars['String']>
  vendorID: Scalars['String']
}

export type QueryVendorProductByUpcArgs = {
  storeID?: InputMaybe<Scalars['String']>
  upc: Scalars['String']
  vendorID: Scalars['String']
}

export type QueryVendorProductSuggestionsByUpcArgs = {
  input: VendorProductSuggestionsInput
}

export type QueryVendorProductsArgs = {
  input?: InputMaybe<GetVendorProductsInput>
}

export type QueryVendorProductsByIDsArgs = {
  input: VendorProductsByIDsInput
}

export type QueryVendorStoreAccountProductsByUpdateTimeArgs = {
  input: VendorStoreAccountProductsByUpdateTimeInput
}

export type QueryVendorStoreDepartmentAccountsForCompanyArgs = {
  input: VsdaQueryInput
}

export type QueryVendorsForCompanyArgs = {
  input: VendorQueryInput
}

export type ReceivingLineItemIssue = GqlLineItemIssueBase & {
  __typename?: 'ReceivingLineItemIssue'
  createdAt: Scalars['DateTime']
  createdBy: Scalars['String']
  creditRequest?: Maybe<CreditRequest>
  details: Scalars['String']
  id: Scalars['ID']
  imgURLs: Array<Scalars['String']>
  quantity: Scalars['Float']
  status: OrderReceivingLineItemStatus
  userName?: Maybe<Scalars['String']>
  userType?: Maybe<Scalars['String']>
}

export enum ReceivingUnitOfMeasure {
  Case = 'CASE',
  Each = 'EACH',
}

export type ReconciledLineItem = {
  __typename?: 'ReconciledLineItem'
  description: Scalars['String']
  id: Scalars['ID']
  /** Product Image URL */
  imgURL: Scalars['String']
  issue?: Maybe<ReceivingLineItemIssue>
  itemCode: Scalars['String']
  packSize: Scalars['String']
  price: Money
  quantity: Scalars['String']
  status: ReconciledLineItemStatus
  total: Money
  unitOfMeasure: UnitOfMeasure
  upc: Scalars['String']
}

export type ReconciledLineItemConnectionInput = {
  after?: InputMaybe<Scalars['Cursor']>
  first: Scalars['Int']
  orderID: Scalars['ID']
  status?: InputMaybe<ReconciledLineItemStatus>
}

export type ReconciledLineItemEdge = {
  __typename?: 'ReconciledLineItemEdge'
  cursor: Scalars['String']
  node: ReconciledLineItem
}

export enum ReconciledLineItemStatus {
  Accurate = 'ACCURATE',
  Invoiced = 'INVOICED',
  Issue = 'ISSUE',
  Ordered = 'ORDERED',
  Unfulfilled = 'UNFULFILLED',
}

export type ReconciledLineItemsConnection = {
  __typename?: 'ReconciledLineItemsConnection'
  creditRequested: Money
  edges: Array<ReconciledLineItemEdge>
  pageInfo: PageInfo
  statusCounts: Array<GqlLineItemStatusCount>
  totalCount: Scalars['Float']
}

export type RemoveProductsFromOrderGuideInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  /** Optional: which user's OrderGuide to update. If not provided, this mutation defaults to the authenticated user. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type RemoveProductsFromV2OrderGuideForStoreDepartmentInput = {
  storeDepartmentID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type RemoveProductsFromV2OrderGuideInput = {
  vendorProductIDs: Array<Scalars['ID']>
  vendorStoreDepartmentAccountID: Scalars['ID']
}

export type RemoveProductsFromV2OrderGuideResult = {
  __typename?: 'RemoveProductsFromV2OrderGuideResult'
  orderGuide: V2OrderGuide
  removedVendorProducts: Array<VendorProduct>
}

export type RequestCatalogInput = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type RequestInvoiceForOrderMutationInput = {
  orderID: Scalars['ID']
}

export type RestoreOrderGuideInput = {
  id: Scalars['String']
  timestamp: Scalars['String']
}

export type RetailCompany = {
  __typename?: 'RetailCompany'
  banner?: Maybe<Banner>
  id: Scalars['ID']
  /** Shorthand for banner name or store name, whichever is applicable */
  name?: Maybe<Scalars['String']>
  retailUsers: RetailUsersResult
  store?: Maybe<Store>
}

export type RetailUser = {
  __typename?: 'RetailUser'
  allOrderGuideProducts: AllOrderGuideProductsResult
  /** @deprecated Use storeDepartments instead */
  departments: DepartmentsResult
  /** The last order placed by this user */
  lastOrder?: Maybe<Order>
  /** @deprecated Use v2 order guide resolvers */
  orderGuideByAccount: OrderGuide
  /** @deprecated Use v2 order guide resolvers */
  orderGuidesByAccount: RetailUserOrderGuidesResult
  /** A boolean flag that indicates if the buyer can only read order guides. */
  readOnlyOrderGuides?: Maybe<Scalars['Boolean']>
  retailCompany: RetailCompany
  storeDepartments: StoreDepartmentsResult
  user: User
  userStoreDepartments: UserStoreDepartmentsResult
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccounts: VendorStoreAccountsResult
  vendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
  /** Returns the total amount spent in placed orders by the user in the current week (starting from Sunday) */
  weeklyOrderSpending: Scalars['Currency']
  /** Returns all orders placed by the user in the current week (starting from Sunday) */
  weeklyOrders: Array<Order>
}

export type RetailUserAllOrderGuideProductsArgs = {
  input?: InputMaybe<AllOrderGuideProductsInput>
}

export type RetailUserLastOrderArgs = {
  storeID: Scalars['ID']
}

export type RetailUserOrderGuideByAccountArgs = {
  input: RetailUserOrderGuideInput
}

export type RetailUserOrderGuidesByAccountArgs = {
  input: RetailUserOrderGuidesInput
}

export type RetailUserVendorAccountsArgs = {
  input?: InputMaybe<VendorStoreAccountInput>
}

export type RetailUserVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountInput>
}

export type RetailUserWeeklyOrderSpendingArgs = {
  storeID: Scalars['ID']
}

export type RetailUserWeeklyOrdersArgs = {
  storeID: Scalars['ID']
}

export type RetailUserOrderGuideInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  vendorID: Scalars['ID']
}

export type RetailUserOrderGuidesInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  vendorIDs: Array<Scalars['ID']>
}

export type RetailUserOrderGuidesResult = {
  __typename?: 'RetailUserOrderGuidesResult'
  nodes: Array<OrderGuide>
}

export type RetailUsersResult = {
  __typename?: 'RetailUsersResult'
  nodes: Array<RetailUser>
  totalCount: Scalars['Int']
}

export type RetailerDiscontinuedDate = {
  __typename?: 'RetailerDiscontinuedDate'
  date?: Maybe<Scalars['Timestamp']>
  retailCompany: RetailCompany
}

export type RetailerDiscontinuedDateInput = {
  date?: InputMaybe<Scalars['Timestamp']>
  retailerID: Scalars['String']
}

export type RetailerPricingInfo = {
  __typename?: 'RetailerPricingInfo'
  pricing: PricingInfo
  retailCompany: RetailCompany
}

export type RetailerVendorProductPriceResult = {
  __typename?: 'RetailerVendorProductPriceResult'
  price: Scalars['Currency']
}

export type SftpConnectionGql = {
  __typename?: 'SFTPConnectionGQL'
  bannerID?: Maybe<Scalars['String']>
  description: Scalars['String']
  direction: Scalars['String']
  id: Scalars['String']
  path: Scalars['String']
  resolvedPath: Scalars['String']
  storeID?: Maybe<Scalars['String']>
  userID: Scalars['String']
  vendorID?: Maybe<Scalars['String']>
}

export enum SftpFileType {
  Edi = 'EDI',
  Flat = 'FLAT',
}

export type SftpUser = {
  __typename?: 'SFTPUser'
  id: Scalars['Int']
  status: Scalars['Int']
  username: Scalars['String']
}

export type SftpUserGql = {
  __typename?: 'SFTPUserGQL'
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  userName: Scalars['String']
  userType: Scalars['String']
}

export enum SampleRequestStatus {
  Available = 'AVAILABLE',
  Requested = 'REQUESTED',
}

export type SearchAllVendorProductsQueryResult = {
  __typename?: 'SearchAllVendorProductsQueryResult'
  cursor: Scalars['ID']
  hasMore: Scalars['Boolean']
  nodes: Array<UniversalProductSearchItem>
  searchID: Scalars['String']
  totalCount: Scalars['Int']
}

export type SearchStoresQueryInput = {
  filterByUserAccountList?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search: Scalars['String']
}

export type SearchStoresQueryResult = {
  __typename?: 'SearchStoresQueryResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<Store>
  totalCount: Scalars['Int']
}

/**
 * ****************************
 *       Search
 * ****************************
 */
export type SearchVendorsQueryInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search: Scalars['String']
}

export type SearchVendorsQueryResult = {
  __typename?: 'SearchVendorsQueryResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type SendBulkVendorInvitationInput = {
  email: Scalars['String']
  vendorID: Scalars['ID']
}

export type SendCreatePaymentProfileEmailInput = {
  adminFirstName?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  deviceBillingInfo?: InputMaybe<DeviceBillingInfoInput>
  email?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  orderBillingInfo?: InputMaybe<OrderBillingInfoInput>
  setupFee?: InputMaybe<SetupFeeInput>
  storeID?: InputMaybe<Scalars['String']>
  userID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type SendCreatePaymentProfileEmailResult = {
  __typename?: 'SendCreatePaymentProfileEmailResult'
  email: Scalars['String']
  token: Scalars['String']
}

export type SendEslFileRefreshInput = {
  storeIDs: Array<Scalars['String']>
  type: EslType
}

export type SendEslFileUpdateInput = {
  file: Scalars['Upload']
  storeIDs: Array<Scalars['String']>
  type: EslType
}

export enum SendEslFileUpdateLogStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
}

export type SendEslFileUpdateResult = {
  __typename?: 'SendESLFileUpdateResult'
  status: SendEslFileUpdateLogStatus
  statusMessage: Scalars['String']
}

export type SendVendorInvitationInput = {
  email: Scalars['String']
  invitedByStoreID: Scalars['ID']
  /** Must be a STORE_ADMIN or BUYER user matching the store referenced by invitedByStoreID */
  invitedByUserID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type SetupFeeInput = {
  cost: Scalars['Currency']
}

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Store = {
  __typename?: 'Store'
  acquisitionDetail?: Maybe<Scalars['String']>
  acquisitionSource?: Maybe<AcquisitionSource>
  address?: Maybe<Scalars['String']>
  addressComponents?: Maybe<AddressComponents>
  authorizedVendors: VendorsResult
  banner?: Maybe<Banner>
  bannerStoreID?: Maybe<Scalars['String']>
  buyerUsers: BuyerUsersResult
  /** @deprecated Use storeDepartments instead */
  departments: DepartmentsResult
  discoverableVendors: VendorsResult
  emails: Array<Scalars['String']>
  firestoreID?: Maybe<Scalars['ID']>
  geographicCoordinates?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: Maybe<Scalars['String']>
  local_iana_timezone?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  orders: StoreOrdersResult
  paymentProfile?: Maybe<PaymentProfile>
  placeID?: Maybe<Scalars['String']>
  productOrderHistory: ProductOrderHistoryResult
  productSampleRequests: ProductSamplesResult
  referredByCompany?: Maybe<Company>
  regionalVendors: VendorsResult
  /** Returns a specific retailUser given a user ID. */
  retailUserByID?: Maybe<RetailUser>
  retailUsers: RetailUsersResult
  serialID?: Maybe<Scalars['ID']>
  storeDepartments: StoreDepartmentsResult
  storeReceivers: Array<StoreReceiver>
  storeType: StoreType
  /** @deprecated Use suggestedVendors on storeDepartments instead */
  suggestedVendors: VendorsResult
  supports_wic: Scalars['Boolean']
  userCount: Scalars['Int']
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccountByVendorID?: Maybe<VendorStoreAccount>
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  vendorAccounts: VendorStoreAccountsResult
  vendorCount: Scalars['Int']
  vendorProducts: VendorProductsResult
  /** Returns a list of all the store's VendorStoreDepartmentAccounts */
  vendorStoreDepartmentAccounts: StoreVendorStoreDepartmentAccountsResult
  /** Returns a deduped list of Vendors based on all the store's VendorStoreDepartmentAccounts. */
  vendors: StoreVendorsResult
  visibleVendors: VendorsResult
}

export type StoreAuthorizedVendorsArgs = {
  input?: InputMaybe<AuthorizedVendorsInput>
}

export type StoreBuyerUsersArgs = {
  input?: InputMaybe<BuyerUsersInput>
}

export type StoreDiscoverableVendorsArgs = {
  input?: InputMaybe<DiscoverableVendorsInput>
}

export type StoreOrdersArgs = {
  input: StoreSpecificOrdersInput
}

export type StoreProductOrderHistoryArgs = {
  input: ProductOrderHistoryInput
}

export type StoreRetailUserByIdArgs = {
  id: Scalars['ID']
}

export type StoreRetailUsersArgs = {
  input?: InputMaybe<StoreRetailUsersInput>
}

export type StoreSuggestedVendorsArgs = {
  input?: InputMaybe<SuggestedVendorsInput>
}

export type StoreVendorAccountByVendorIdArgs = {
  vendorID: Scalars['ID']
}

export type StoreVendorAccountsArgs = {
  input?: InputMaybe<VendorStoreAccountInput>
}

export type StoreVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type StoreVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<StoreVendorStoreDepartmentAccountsInput>
}

export type StoreVendorsArgs = {
  input?: InputMaybe<StoreVendorsInput>
}

export type StoreAdminVendorsInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
}

export type StoreAdminVendorsResult = {
  __typename?: 'StoreAdminVendorsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Vendor>
}

export type StoreDepartment = {
  __typename?: 'StoreDepartment'
  buyerUsers: BuyerUsersResult
  deactivatedAt?: Maybe<Scalars['DateTime']>
  discoverableVendors: VendorsResult
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: Maybe<Scalars['String']>
  name: Scalars['String']
  orderGuideVendorProductIDs: OrderGuideVendorProductIDsResult
  orders: StoreDepartmentOrdersResult
  parentDepartment?: Maybe<StoreDepartment>
  productCount: Scalars['Int']
  store: Store
  storeID: Scalars['String']
  subDepartments?: Maybe<Array<StoreDepartment>>
  suggestedCarts: StoreDepartmentSuggestedCartsResult
  suggestedVendors: VendorsResult
  totalBuyerCount?: Maybe<Scalars['Int']>
  totalVendorCount?: Maybe<Scalars['Int']>
  vendorStoreDepartmentAccounts: VendorStoreDepartmentAccountResult
}

export type StoreDepartmentBuyerUsersArgs = {
  input?: InputMaybe<BuyerUsersInput>
}

export type StoreDepartmentDiscoverableVendorsArgs = {
  input?: InputMaybe<DiscoverableVendorsInput>
}

export type StoreDepartmentOrderGuideVendorProductIDsArgs = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type StoreDepartmentOrdersArgs = {
  input?: InputMaybe<StoreDepartmentOrdersInput>
}

export type StoreDepartmentSuggestedCartsArgs = {
  input?: InputMaybe<StoreDepartmentSuggestedCartsInput>
}

export type StoreDepartmentSuggestedVendorsArgs = {
  input?: InputMaybe<SuggestedVendorsInput>
}

export type StoreDepartmentVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type StoreDepartmentEdge = {
  __typename?: 'StoreDepartmentEdge'
  cursor: Scalars['Cursor']
  node: StoreDepartment
}

export type StoreDepartmentOrdersInput = {
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
}

export type StoreDepartmentOrdersResult = {
  __typename?: 'StoreDepartmentOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export type StoreDepartmentQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  first: Scalars['Int']
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreDepartmentSuggestedCartsInput = {
  vendorID?: InputMaybe<Scalars['ID']>
}

export type StoreDepartmentSuggestedCartsResult = {
  __typename?: 'StoreDepartmentSuggestedCartsResult'
  nodes: Array<SuggestedCart>
}

export type StoreDepartmentViewConnection = {
  __typename?: 'StoreDepartmentViewConnection'
  edges: Array<StoreDepartmentEdge>
  pageInfo: PageInfo
}

export type StoreDepartmentsResult = {
  __typename?: 'StoreDepartmentsResult'
  nodes: Array<StoreDepartment>
}

export type StoreEdge = {
  __typename?: 'StoreEdge'
  cursor: Scalars['Cursor']
  node: Store
}

export type StoreEmail = {
  __typename?: 'StoreEmail'
  email: Scalars['String']
}

export type StoreEmailInput = {
  email: Scalars['String']
}

export type StoreInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type StoreInvitation = {
  __typename?: 'StoreInvitation'
  email: Scalars['String']
  /** ID is identical to the invitation code */
  id?: Maybe<Scalars['ID']>
  invitedByUser?: Maybe<User>
  invitedByVendor?: Maybe<Vendor>
  lastOrderPlaced?: Maybe<Order>
  signedUpEmail?: Maybe<Scalars['String']>
  status: InvitationStatus
  store: Store
}

export type StoreInvitationsResult = {
  __typename?: 'StoreInvitationsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<StoreInvitation>
  totalCount: Scalars['Int']
}

export type StoreInviteInput = {
  accountNum: Scalars['String']
  address: Scalars['String']
  defaultDepartmentName: DepartmentName
  email: Scalars['String']
  name: Scalars['String']
  orderGuideProductIDs?: InputMaybe<Array<Scalars['String']>>
  phoneNum?: InputMaybe<Scalars['String']>
}

export type StoreOrdersFilterInput = {
  hasInvoice?: InputMaybe<Scalars['Boolean']>
  placedInTheLastWeek?: InputMaybe<Scalars['Boolean']>
  receivingStatuses?: InputMaybe<Array<OrderReceivingStatus>>
  storeDepartmentIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreOrdersInput = {
  filterByThisWeek?: InputMaybe<Scalars['Boolean']>
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  storeID: Scalars['ID']
}

export type StoreOrdersResult = {
  __typename?: 'StoreOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export enum StoreProductPriceInputMethod {
  ManuallyEnteredPrice = 'MANUALLY_ENTERED_PRICE',
  UsedSuggestedPrice = 'USED_SUGGESTED_PRICE',
}

export enum StoreProductPriceSource {
  AcceptedCostChange = 'ACCEPTED_COST_CHANGE',
  BulkUpdate = 'BULK_UPDATE',
  ProductDetails = 'PRODUCT_DETAILS',
}

export enum StoreProductPriceSourcePlatform {
  Mobile = 'MOBILE',
  Web = 'WEB',
}

export type StoreQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  first: Scalars['Int']
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreReceiver = {
  __typename?: 'StoreReceiver'
  createdByUser?: Maybe<User>
  user: User
}

export type StoreReceiverUser = {
  __typename?: 'StoreReceiverUser'
  stores: StoresResult
}

export type StoreRetailUsersInput = {
  departmentNames?: InputMaybe<Array<DepartmentName>>
  query?: InputMaybe<Scalars['String']>
  userTypes?: InputMaybe<Array<UserType>>
}

export type StoreSpecificOrdersInput = {
  filter?: InputMaybe<StoreOrdersFilterInput>
  /** Deprecated: Use placedInTheLastWeek in filter field */
  filterByThisWeek?: InputMaybe<Scalars['Boolean']>
  /** Deprecated: Use vendorIDs in filter field */
  filterByVendor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  /** Deprecated: Use receivingStatuses in filter field */
  receivingStatus?: InputMaybe<OrderReceivingStatus>
  /** Deprecated: Use vendorIDs in filter field */
  storeDepartmentID?: InputMaybe<Scalars['ID']>
}

export enum StoreSuggestionType {
  /** The store exists, but the querying vendor does not have an account yet */
  ExistingStore = 'EXISTING_STORE',
  /** The vendor querying storeSuggestions already has an active account at this store */
  ExistingStoreAndAccount = 'EXISTING_STORE_AND_ACCOUNT',
}

export enum StoreType {
  /** @deprecated use SINGLE_A or MULTI_A */
  A = 'A',
  /** @deprecated use SINGLE_B or MULTI_B */
  B = 'B',
  /** @deprecated use SINGLE_C or MULTI_C */
  C = 'C',
  Enterprise = 'ENTERPRISE',
  FoodService = 'FOOD_SERVICE',
  MultiA = 'MULTI_A',
  MultiB = 'MULTI_B',
  MultiC = 'MULTI_C',
  Other = 'OTHER',
  Regional = 'REGIONAL',
  SingleA = 'SINGLE_A',
  SingleB = 'SINGLE_B',
  SingleC = 'SINGLE_C',
  Unknown = 'UNKNOWN',
}

export type StoreVendorCreateFields = {
  accountNumber?: InputMaybe<Scalars['String']>
  billingAddressString?: InputMaybe<Scalars['String']>
  billingName?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contactPhone?: InputMaybe<Scalars['String']>
  deactivatedAt?: InputMaybe<Scalars['DateTime']>
  invoicesEmail?: InputMaybe<Scalars['String']>
  minOrderValue?: InputMaybe<Scalars['Decimal']>
  name: Scalars['String']
  ordersEmail?: InputMaybe<Scalars['String']>
  taxID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type StoreVendorEditableFields = {
  accountNumber?: InputMaybe<Scalars['String']>
  billingAddressString?: InputMaybe<Scalars['String']>
  billingName?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contactPhone?: InputMaybe<Scalars['String']>
  deactivatedAt?: InputMaybe<Scalars['DateTime']>
  invoicesEmail?: InputMaybe<Scalars['String']>
  minOrderValue?: InputMaybe<Scalars['Decimal']>
  name?: InputMaybe<Scalars['String']>
  ordersEmail?: InputMaybe<Scalars['String']>
  taxID?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
}

export type StoreVendorMappingUpdateInput = {
  parentVendorFirestoreID?: InputMaybe<Scalars['String']>
  storeVendorSerialID: Scalars['String']
}

export type StoreVendorProductOrderHistory = {
  __typename?: 'StoreVendorProductOrderHistory'
  orderDateTime: Scalars['Timestamp']
  orderID: Scalars['ID']
  price: Scalars['Currency']
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
}

export type StoreVendorProductOrderHistoryInput = {
  storeID: Scalars['ID']
}

export type StoreVendorProductResult = {
  __typename?: 'StoreVendorProductResult'
  brandName: Scalars['String']
  caseSize?: Maybe<Scalars['Float']>
  description: Scalars['String']
  firestoreID?: Maybe<Scalars['ID']>
  itemCode: Scalars['String']
  parentProductFirestoreID?: Maybe<Scalars['String']>
  parentProductSerialID?: Maybe<Scalars['String']>
  serialID: Scalars['ID']
  storeID?: Maybe<Scalars['String']>
  unitUPC: Scalars['String']
  unitVolume: Scalars['String']
  vendorID: Scalars['String']
  vendorName: Scalars['String']
}

export type StoreVendorProductsMappingUpdateInput = {
  parentVendorProductFirestoreID?: InputMaybe<Scalars['String']>
  storeVendorProductSerialID: Scalars['String']
}

export type StoreVendorProductsQueryInput = {
  cursor?: InputMaybe<Scalars['Float']>
  filterByBannerFirestoreID?: InputMaybe<Scalars['String']>
  filterByStoreFirestoreID?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Float']>
  mappedProductsOnly?: InputMaybe<Scalars['Boolean']>
  vendorFirestoreID?: InputMaybe<Scalars['String']>
}

export type StoreVendorResult = {
  __typename?: 'StoreVendorResult'
  firestoreID: Scalars['ID']
  name: Scalars['String']
  parentVendorFirestoreID?: Maybe<Scalars['String']>
  parentVendorSerialID?: Maybe<Scalars['String']>
  serialID: Scalars['ID']
  storeID: Scalars['String']
  storeName: Scalars['String']
}

export type StoreVendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  /** Note: This input will be superseded by any given `searchByVendor` input */
  query?: InputMaybe<Scalars['String']>
  /** Note: This input will supersede any given `query` input */
  searchByVendor?: InputMaybe<Scalars['String']>
  vendorIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorStoreDepartmentAccountIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type StoreVendorStoreDepartmentAccountsResult = {
  __typename?: 'StoreVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type StoreVendorsInput = {
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type StoreVendorsQueryInput = {
  cursor?: InputMaybe<Scalars['Float']>
  filterByBannerFirestoreID?: InputMaybe<Scalars['String']>
  filterByStoreFirestoreID?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Float']>
  mappedVendorsOnly?: InputMaybe<Scalars['Boolean']>
}

export type StoreVendorsResult = {
  __typename?: 'StoreVendorsResult'
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

export type StoreViewConnection = {
  __typename?: 'StoreViewConnection'
  edges: Array<StoreEdge>
  pageInfo: PageInfo
}

export type StoresResult = {
  __typename?: 'StoresResult'
  cursor?: Maybe<Scalars['ID']>
  nodes: Array<Store>
  totalCount?: Maybe<Scalars['Int']>
}

export type StripeBankAccountTokenForm = {
  plaidAccountID: Scalars['String']
  plaidPublicToken: Scalars['String']
}

export type StripeBankAccountTokenResponse = {
  __typename?: 'StripeBankAccountTokenResponse'
  requestID: Scalars['String']
  stripeBankAccountToken: Scalars['String']
}

export enum SubmissionMethod {
  Email = 'EMAIL',
  Qbc = 'QBC',
  Qbe = 'QBE',
  Sps = 'SPS',
  TrueCommerce = 'TRUE_COMMERCE',
  VoriEdi = 'VORI_EDI',
}

export type SubmitOrderReceivingReportInput = {
  lineItems?: InputMaybe<Array<OrderReceivingLineItemInput>>
  markAsReceived?: InputMaybe<Scalars['Boolean']>
  mispicks?: InputMaybe<Array<OrderMispickInput>>
  orderID: Scalars['ID']
  remainingItemsReceived?: InputMaybe<Scalars['Boolean']>
}

export type SuggestStoresInput = {
  address?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  placeID?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

export type SuggestStoresResult = {
  __typename?: 'SuggestStoresResult'
  nodes: Array<SuggestStoresResultNode>
}

export type SuggestStoresResultNode = {
  __typename?: 'SuggestStoresResultNode'
  store: Store
  suggestionType: StoreSuggestionType
}

export type SuggestedCart = {
  __typename?: 'SuggestedCart'
  lineItems: Array<SuggestedCartLineItem>
  modelTimestamp: Scalars['String']
  store: Store
  storeDepartment: StoreDepartment
  vendor: Vendor
}

export type SuggestedCartLineItem = {
  __typename?: 'SuggestedCartLineItem'
  lastOrderID?: Maybe<Scalars['ID']>
  lastOrderQuantity?: Maybe<Scalars['Int']>
  lastOrderUnitOfMeasure?: Maybe<UnitOfMeasure>
  lastOrderedAt?: Maybe<Scalars['Timestamp']>
  quantity: Scalars['Int']
  unitOfMeasure: UnitOfMeasure
  vendorProduct: VendorProduct
}

export type SuggestedVendorsInput = {
  filterByOrderPlaced?: InputMaybe<Scalars['Boolean']>
}

export type SyncStediUsersResultGql = {
  __typename?: 'SyncStediUsersResultGQL'
  message: Scalars['String']
  sftpUser?: Maybe<SftpUserGql>
}

/**
 * ****************************
 *       Tasks
 * ****************************
 */
export type TaskResponse = {
  __typename?: 'TaskResponse'
  jobID: Scalars['ID']
  taskUUID: Scalars['String']
}

export enum TaxRateType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE',
}

export enum TaxType {
  Other = 'Other',
  Sales = 'Sales',
}

export enum UomLock {
  CasesOnly = 'casesOnly',
  EachesOnly = 'eachesOnly',
  None = 'none',
}

export enum UploadErrorMessages {
  BadUpc = 'BAD_UPC',
  DuplicateItemCode = 'DUPLICATE_ITEM_CODE',
  DuplicateUpc = 'DUPLICATE_UPC',
  InvalidStoreDepartment = 'INVALID_STORE_DEPARTMENT',
  InvalidStoreVendor = 'INVALID_STORE_VENDOR',
  InvalidTaxId = 'INVALID_TAX_ID',
  MissingDescription = 'MISSING_DESCRIPTION',
  MissingItemCode = 'MISSING_ITEM_CODE',
}

export type UndoVendorCatalogCsvUploadInput = {
  deleteNewProducts: Scalars['Boolean']
  forceRestore: Scalars['Boolean']
  logID: Scalars['String']
  restoreOverwrittenProducts: Scalars['Boolean']
}

export type UndoVendorCatalogCsvUploadResult = {
  __typename?: 'UndoVendorCatalogCSVUploadResult'
  message: Scalars['String']
  numNewProductsDeleted: Scalars['Int']
  numProductsRestored: Scalars['Int']
  restoredOn?: Maybe<Scalars['Timestamp']>
}

export enum UnitOfMeasure {
  Case = 'CASE',
  Each = 'EACH',
  Lb = 'LB',
}

export type UniversalProductSearchItem = {
  __typename?: 'UniversalProductSearchItem'
  inOrderGuide: Scalars['Boolean']
  product: VendorProduct
}

export type UniversalVendorProductsQueryInput = {
  authorizedVendorsOnly?: InputMaybe<Scalars['Boolean']>
  inOrderGuide?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  paginationInput?: InputMaybe<PaginationInput>
  query?: InputMaybe<Scalars['String']>
  searchID?: InputMaybe<Scalars['String']>
  storeID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type UpdateAllBannerUsersOrderGuideInput = {
  bannerID: Scalars['ID']
  defaultUOM?: InputMaybe<UnitOfMeasure>
  productIDs: Array<Scalars['ID']>
  readOnly?: InputMaybe<Scalars['Boolean']>
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
  userIDs?: InputMaybe<Array<Scalars['ID']>>
  vendorID: Scalars['ID']
}

export type UpdateAudienceInput = {
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateBannerAuthFileV2OrderGuidesAccountInput = {
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  departmentName: DepartmentName
  readOnly?: InputMaybe<Scalars['Boolean']>
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
  vendorID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type UpdateBannerAuthFileV2OrderGuidesInput = {
  accounts: Array<UpdateBannerAuthFileV2OrderGuidesAccountInput>
  bannerID: Scalars['ID']
}

export type UpdateBannerInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  bannerType?: InputMaybe<StoreType>
  billingInfo?: InputMaybe<BillingInfoInput>
  frontOfficeURL?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  imageURL?: InputMaybe<Scalars['String']>
  imageURLFile?: InputMaybe<Scalars['Upload']>
  name?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<BannerStatus>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateBannerV2OrderGuidesInput = {
  bannerID: Scalars['ID']
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  departmentName: DepartmentName
  readOnly?: InputMaybe<Scalars['Boolean']>
  shouldOverwrite?: InputMaybe<Scalars['Boolean']>
  vendorID: Scalars['ID']
  vendorProductIDs: Array<Scalars['ID']>
}

export type UpdateBannerVendorEmailsInput = {
  bannerID: Scalars['ID']
  override?: InputMaybe<Scalars['Boolean']>
  vendorEmails: Array<VendorEmailInput>
  vendorID: Scalars['ID']
}

export type UpdateBannerVendorEmailsResult = {
  __typename?: 'UpdateBannerVendorEmailsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  updatedVSDAIds: Array<Scalars['String']>
}

export type UpdateBuyerProfileInput = {
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
}

export type UpdateCartMisscanQuantityInput = {
  misscanID: Scalars['ID']
  quantity: Scalars['Int']
  /** Vendor users must specify the store to update */
  storeID?: InputMaybe<Scalars['ID']>
  unitOfMeasure: UnitOfMeasure
}

export type UpdateCartMisscanQuantityResult = {
  __typename?: 'UpdateCartMisscanQuantityResult'
  updatedVendorCart?: Maybe<VendorCart>
}

export type UpdateDealInput = {
  basisPoints?: InputMaybe<Scalars['Int']>
  dealValue?: InputMaybe<Scalars['Currency']>
  freeCount?: InputMaybe<Scalars['Int']>
  id: Scalars['ID']
  threshold?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<DealType>
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  vendorDiscountCode?: InputMaybe<Scalars['String']>
  vendorProductIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateEslConfigInput = {
  apiKey?: InputMaybe<Scalars['String']>
  eslStoreID: Scalars['String']
  password?: InputMaybe<Scalars['String']>
  storeID: Scalars['String']
  type: EslType
  username?: InputMaybe<Scalars['String']>
}

export type UpdateLineItemCreditRequestMutationInput = {
  amount: MoneyInput
  lineItemID: Scalars['ID']
  notes: Scalars['String']
}

export type UpdateOrderInput = {
  orderConfirmed?: InputMaybe<Scalars['Boolean']>
  orderEmailOpened?: InputMaybe<Scalars['Boolean']>
  orderID: Scalars['ID']
  orderPlaced?: InputMaybe<Scalars['Boolean']>
  slackMsgID?: InputMaybe<Scalars['String']>
  suggestedCartsModelTimestamp?: InputMaybe<Scalars['String']>
}

export type UpdateOrderReceivingLineItemInput = {
  brandName?: InputMaybe<Scalars['String']>
  createMispickItem?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  details?: InputMaybe<Scalars['String']>
  imageURLs?: InputMaybe<Array<Scalars['String']>>
  issueQuantity?: InputMaybe<Scalars['Int']>
  orderID?: InputMaybe<Scalars['ID']>
  quantity?: InputMaybe<Scalars['Int']>
  status?: InputMaybe<OrderReceivingLineItemStatus>
  unitOfMeasure?: InputMaybe<UnitOfMeasure>
  upc?: InputMaybe<Scalars['String']>
}

export type UpdateProductSampleRequestInput = {
  id: Scalars['ID']
  status?: InputMaybe<SampleRequestStatus>
}

export type UpdateProfileInput = {
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  forceRealmSync?: InputMaybe<Scalars['Boolean']>
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
}

export type UpdatePromotionInput = {
  allAccounts?: InputMaybe<Scalars['Boolean']>
  audienceID?: InputMaybe<Scalars['ID']>
  endDate?: InputMaybe<Scalars['Timestamp']>
  id: Scalars['ID']
  isPublished?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['Timestamp']>
}

export type UpdateSftpConnectionInput = {
  SQLBannerID?: InputMaybe<Scalars['String']>
  SQLStoreID?: InputMaybe<Scalars['String']>
  SQLUserID: Scalars['String']
  SQLVendorID?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  direction: Scalars['String']
  id: Scalars['Float']
  path: Scalars['String']
}

export type UpdateStoreDepartmentsSuggestedVendorListInput = {
  overwrite?: InputMaybe<Scalars['Boolean']>
  storeDepartmentsIDs: Array<Scalars['ID']>
  suggestedVendorList: Array<Scalars['ID']>
}

export type UpdateStoreDepartmentsSuggestedVendorListResult = {
  __typename?: 'UpdateStoreDepartmentsSuggestedVendorListResult'
  nodes: Array<StoreDepartment>
}

export type UpdateStoreInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  bannerID?: InputMaybe<Scalars['String']>
  bannerStoreID?: InputMaybe<Scalars['String']>
  emails?: InputMaybe<Array<Scalars['String']>>
  geographicCoordinates?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  overwriteSuggestedVendorList?: InputMaybe<Scalars['Boolean']>
  placeID?: InputMaybe<Scalars['String']>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  storeType?: InputMaybe<StoreType>
  suggestedVendorList?: InputMaybe<Array<Scalars['ID']>>
  supportsWic?: InputMaybe<Scalars['Boolean']>
  vendorIDs?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateStoreVendorListInput = {
  addedVendorIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  removedVendorIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  storeID: Scalars['ID']
}

export type UpdateStoreVendorProductInput = {
  accountSpecificCasePrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  accountSpecificUnitPrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  productID: Scalars['ID']
  retailerDiscontinuedDates?: InputMaybe<Array<RetailerDiscontinuedDateInput>>
}

export type UpdateUserAccountListInput = {
  accountIDs: Array<Scalars['ID']>
}

export type UpdateUserInput = {
  companyID?: InputMaybe<Scalars['String']>
  defaultDepartmentName?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  forceRealmSync?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  phoneNumber?: InputMaybe<Scalars['String']>
  readOnlyOrderGuides?: InputMaybe<Scalars['Boolean']>
  userType?: InputMaybe<UserType>
}

export type UpdateUserOrderGuideAccountInput = {
  productIDs: Array<Scalars['ID']>
  storeID: Scalars['ID']
  type?: InputMaybe<Scalars['String']>
  userID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type UpdateUserOrderGuideInput = {
  defaultUOM?: InputMaybe<UnitOfMeasure>
  /** List of product IDs to update the order guide to. Note: this mutation does not merge product IDs with any pre-existing order guide (if you desire merge behavior, use the add/delete mutations instead) */
  productIDs: Array<Scalars['ID']>
  readOnly?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
  /** Optional: which user's OrderGuide to update. If not provided, this mutation defaults to the authenticated user. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type UpdateV2OrderGuideInput = {
  defaultUOM?: InputMaybe<UnitOfMeasure>
  readOnly?: InputMaybe<Scalars['Boolean']>
  vendorProductIDs: Array<Scalars['ID']>
  vendorStoreDepartmentAccountID: Scalars['ID']
}

export type UpdateVendorCartInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>
  lineItems: Array<CartLineItemInput>
  misscanLineItems: Array<MisscanLineItemInput>
  /** Vendor users must also specify the store to update */
  storeID?: InputMaybe<Scalars['ID']>
  suggestedCartsModelTimestamp?: InputMaybe<Scalars['String']>
  /** Which user to update the Cart for. If not passed, updates the authenticated user's cart. */
  userID?: InputMaybe<Scalars['ID']>
  vendorID: Scalars['ID']
}

export type UpdateVendorCartResult = {
  __typename?: 'UpdateVendorCartResult'
  cart: VendorCart
  missingProductIDs: Array<Scalars['ID']>
}

export type UpdateVendorInput = {
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  billingInfo?: InputMaybe<BillingInfoInput>
  defaultOrderSubmissionMethod?: InputMaybe<SubmissionMethod>
  departmentTags?: InputMaybe<Array<DepartmentName>>
  description?: InputMaybe<Scalars['String']>
  disableDiscontinuedPurchases?: InputMaybe<Scalars['Boolean']>
  disableOutOfStockPurchases?: InputMaybe<Scalars['Boolean']>
  distributionCenterID?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  headerImageURL?: InputMaybe<Scalars['String']>
  headerImageURLFile?: InputMaybe<Scalars['Upload']>
  hideWholesalePricing?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  isInventoryEnabled?: InputMaybe<Scalars['Boolean']>
  lockUOMSelection?: InputMaybe<UomLock>
  misscanPolicy?: InputMaybe<VendorMisscanPolicy>
  name?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderDeadlineInfo?: InputMaybe<VendorOrderDeadlineInfoInput>
  orderMin?: InputMaybe<Scalars['Currency']>
  orderMinimums?: InputMaybe<Array<VendorOrderMinimumInput>>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  referredByCompanyID?: InputMaybe<Scalars['ID']>
  retailerPricing?: InputMaybe<Scalars['Boolean']>
  showImages?: InputMaybe<Scalars['Boolean']>
  skipEmailWithEDIOrderSubmission?: InputMaybe<Scalars['Boolean']>
  spsTenetID?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorStatus>
  trueCommerceTenetID?: InputMaybe<Scalars['String']>
  useAccountMetadataEmailOverVendorEmail?: InputMaybe<Scalars['Boolean']>
  vendorManagedCatalog?: InputMaybe<Scalars['Boolean']>
}

export type UpdateVendorProductInput = {
  accountSpecificCasePrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  accountSpecificUnitPrice?: InputMaybe<Array<AccountSpecificPriceInput>>
  acquisitionDetail?: InputMaybe<Scalars['String']>
  acquisitionSource?: InputMaybe<AcquisitionSource>
  address?: InputMaybe<Scalars['String']>
  brand?: InputMaybe<Scalars['String']>
  caseCRV?: InputMaybe<Scalars['Currency']>
  casePrice?: InputMaybe<Scalars['Currency']>
  caseSize?: InputMaybe<Scalars['Float']>
  caseUPC?: InputMaybe<Scalars['String']>
  category?: InputMaybe<Scalars['String']>
  crvCost?: InputMaybe<Scalars['Currency']>
  departmentName?: InputMaybe<Scalars['String']>
  departmentTags?: InputMaybe<Array<DepartmentName>>
  description?: InputMaybe<Scalars['String']>
  erpID?: InputMaybe<Scalars['String']>
  imgURL?: InputMaybe<Scalars['String']>
  imgURLFile?: InputMaybe<Scalars['Upload']>
  inventory?: InputMaybe<Scalars['Int']>
  isDeleted?: InputMaybe<Scalars['Boolean']>
  isDiscontinued?: InputMaybe<Scalars['Boolean']>
  isStoreSpecific?: InputMaybe<Scalars['Boolean']>
  itemCode?: InputMaybe<Scalars['String']>
  missScanMethod?: InputMaybe<MissScanMethod>
  notes?: InputMaybe<Scalars['String']>
  packUPC?: InputMaybe<Scalars['String']>
  privateLabelProductBannerIDs?: InputMaybe<Array<Scalars['ID']>>
  privateLabelProductStoreIDs?: InputMaybe<Array<Scalars['ID']>>
  productID: Scalars['ID']
  referredByCompanyID?: InputMaybe<Scalars['String']>
  retailerDiscontinuedDates?: InputMaybe<Array<RetailerDiscontinuedDateInput>>
  sizing?: InputMaybe<Scalars['String']>
  srp?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VendorProductStatus>
  storeID?: InputMaybe<Scalars['String']>
  unitCRV?: InputMaybe<Scalars['Currency']>
  unitPrice?: InputMaybe<Scalars['Currency']>
  unitUPC?: InputMaybe<Scalars['String']>
  unitVolume?: InputMaybe<Scalars['String']>
  upc?: InputMaybe<Scalars['String']>
  vendorID?: InputMaybe<Scalars['String']>
  wholesaleCasePrice?: InputMaybe<Scalars['Currency']>
  wholesaleUnitPrice?: InputMaybe<Scalars['Currency']>
}

export type UpdateVendorStoreAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUOM?: InputMaybe<UnitOfMeasure>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  storeEmails?: InputMaybe<Array<Scalars['String']>>
  storeID: Scalars['String']
  vendorEmails?: InputMaybe<Array<Scalars['String']>>
  vendorID: Scalars['String']
}

export type UpdateVendorStoreDepartmentAccountForm = {
  accountNumber?: InputMaybe<Scalars['String']>
  defaultUnitOfMeasure?: InputMaybe<UnitOfMeasure>
  dunsNumber?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  orderDeadline?: InputMaybe<Scalars['String']>
  orderDeadlineInfo?: InputMaybe<VendorOrderDeadlineInfoInput>
  orderSubmissionMethod?: InputMaybe<SubmissionMethod>
  orderSubmissionUOMLock?: InputMaybe<UomLock>
  status?: InputMaybe<VendorStoreDepartmentAccountStatus>
  storeEmails?: InputMaybe<Array<StoreEmailInput>>
  vendorEmails?: InputMaybe<Array<VendorEmailInput>>
}

export type UpdateVendorsForStoreDepartmentInput = {
  storeDepartmentID: Scalars['ID']
  vendorIDs: Array<Scalars['ID']>
}

export type UpdateVendorsForStoreDepartmentResult = {
  __typename?: 'UpdateVendorsForStoreDepartmentResult'
  createdVendorIDs: Array<Scalars['ID']>
  deletedVendorIDs: Array<Scalars['ID']>
  nodes: Array<VendorStoreDepartmentAccount>
}

export type UploadError = {
  __typename?: 'UploadError'
  errorMessages: Array<UploadErrorMessages>
  index: Scalars['Int']
}

export type UploadInvoiceFileForOrderMutationInput = {
  files: Array<Scalars['Upload']>
  orderID: Scalars['ID']
}

export type User = {
  __typename?: 'User'
  accountListVendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
  canSeeFeatures: UserCanSeeFeaturesResult
  cartByID?: Maybe<VendorCart>
  carts: Array<VendorCart>
  catalogRequests: CatalogRequestsResult
  companyImageURL?: Maybe<Scalars['String']>
  companyUserType?: Maybe<CompanyUserType>
  defaultDepartmentName?: Maybe<Scalars['String']>
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  forceRealmSync: Scalars['Boolean']
  id: Scalars['ID']
  phoneNumber?: Maybe<Scalars['String']>
  primaryCompanyID?: Maybe<Scalars['ID']>
  primaryCompanyName?: Maybe<Scalars['String']>
  primaryCompanyType?: Maybe<Scalars['String']>
  readOnlyOrderGuides?: Maybe<Scalars['Boolean']>
  retailUser?: Maybe<RetailUser>
  signupDate?: Maybe<Scalars['Timestamp']>
  storeDepartments: StoreDepartmentsResult
  storeReceiver?: Maybe<StoreReceiverUser>
  stores: StoresResult
  userSqlID?: Maybe<Scalars['String']>
  userType?: Maybe<UserType>
  vendorUser?: Maybe<VendorUser>
}

export type UserAccountListVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type UserCanSeeFeaturesArgs = {
  input?: InputMaybe<UserCanSeeFeaturesInput>
}

export type UserCartByIdArgs = {
  storeID: Scalars['ID']
  vendorID: Scalars['ID']
}

export type UserStoreDepartmentsArgs = {
  input?: InputMaybe<UserStoreDepartmentsQueryInput>
}

export type UserStoresArgs = {
  input?: InputMaybe<UserSearchStoresQueryInput>
}

export type UserCanSeeFeaturesInput = {
  /** List of feature IDs to check */
  featureIDs?: InputMaybe<Array<Scalars['String']>>
}

export type UserCanSeeFeaturesResult = {
  __typename?: 'UserCanSeeFeaturesResult'
  /** The subset of input feature IDs visible to this user */
  enabledFeatures: Array<Scalars['String']>
}

export type UserCart = {
  __typename?: 'UserCart'
  id: Scalars['ID']
  storeID: Scalars['ID']
  updatedAt?: Maybe<Scalars['Timestamp']>
  userID: Scalars['ID']
}

export type UserSearchStoresQueryInput = {
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
}

/**
 * ****************************
 *       UserStoreDepartment
 * ****************************
 */
export type UserStoreDepartment = {
  __typename?: 'UserStoreDepartment'
  id: Scalars['String']
  storeDepartment: StoreDepartment
  user: User
}

export type UserStoreDepartmentsQueryInput = {
  filterByStoreID: Scalars['ID']
}

export type UserStoreDepartmentsResult = {
  __typename?: 'UserStoreDepartmentsResult'
  nodes: Array<UserStoreDepartment>
}

export type UserStoreQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export enum UserType {
  Buyer = 'BUYER',
  DepartmentManager = 'DEPARTMENT_MANAGER',
  SalesRep = 'SALES_REP',
  StoreAccountsPayable = 'STORE_ACCOUNTS_PAYABLE',
  StoreAdmin = 'STORE_ADMIN',
  StoreReceiver = 'STORE_RECEIVER',
  VendorAdmin = 'VENDOR_ADMIN',
  VoriAdmin = 'VORI_ADMIN',
}

export type UsersResult = {
  __typename?: 'UsersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<User>
  totalCount: Scalars['Int']
}

export type V2OrderGuide = {
  __typename?: 'V2OrderGuide'
  defaultUnitOfMeasure?: Maybe<UnitOfMeasure>
  id: Scalars['ID']
  readOnly?: Maybe<Scalars['Boolean']>
  storeDepartmentID: Scalars['String']
  vendorID: Scalars['String']
  vendorProductIDs: Array<Scalars['String']>
  vendorProducts?: Maybe<OrderGuideProductsResult>
  vendorStoreDepartmentAccount: VendorStoreDepartmentAccount
}

export type V2OrderGuideVendorProductsArgs = {
  input?: InputMaybe<V2OrderGuideProductsInput>
}

export type V2OrderGuideCsvResult = {
  __typename?: 'V2OrderGuideCSVResult'
  url: Scalars['String']
}

export type V2OrderGuideProductsInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type V2OrderGuidesResult = {
  __typename?: 'V2OrderGuidesResult'
  nodes?: Maybe<Array<V2OrderGuide>>
}

export type VsdaEdge = {
  __typename?: 'VSDAEdge'
  cursor: Scalars['Cursor']
  node: VendorStoreDepartmentAccount
}

export type VsdaQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  first: Scalars['Int']
  includeInactive?: InputMaybe<Scalars['Boolean']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export type VsdaViewConnection = {
  __typename?: 'VSDAViewConnection'
  edges: Array<VsdaEdge>
  pageInfo: PageInfo
}

export type ValidateBulkUploadStoreVendorProductsResult = {
  __typename?: 'ValidateBulkUploadStoreVendorProductsResult'
  errors: Array<UploadError>
  numExistingProducts: Scalars['Int']
  numNewProducts: Scalars['Int']
  numProducts: Scalars['Int']
  numValidProducts: Scalars['Int']
  spreadsheetURL: Scalars['String']
}

export type ValidateBulkUploadVendorProductsResult = {
  __typename?: 'ValidateBulkUploadVendorProductsResult'
  errors: Array<UploadError>
  matchErrors: Array<MatchError>
  numDeletedProductsRestored: Scalars['Int']
  numExistingProducts: Scalars['Int']
  numNewProducts: Scalars['Int']
  numProducts: Scalars['Int']
  numValidProducts: Scalars['Int']
  spreadsheetURL: Scalars['String']
  vendor: Vendor
}

export type ValidateInvitationOrderGuideNamesResult = {
  __typename?: 'ValidateInvitationOrderGuideNamesResult'
  duplicates: Array<Scalars['String']>
}

export type ValidatedPointOfSaleDepartmentName = {
  __typename?: 'ValidatedPointOfSaleDepartmentName'
  bannerID: Scalars['ID']
  id: Scalars['String']
  matchedDepartmentName: Scalars['String']
  providedDepartmentName: Scalars['String']
  timestamp: Scalars['Timestamp']
}

export type ValidatedPointOfSaleDepartmentNameInput = {
  matchedDepartmentName: Scalars['String']
  providedDepartmentName: Scalars['String']
}

export type ValidatedPointOfSaleItemCode = {
  __typename?: 'ValidatedPointOfSaleItemCode'
  bannerID: Scalars['ID']
  id: Scalars['String']
  matchedItemCode: Scalars['String']
  providedUPC: Scalars['String']
  timestamp: Scalars['Timestamp']
  vendorID: Scalars['ID']
}

export type ValidatedPointOfSaleItemCodeInput = {
  matchedItemCode: Scalars['String']
  providedUPC: Scalars['String']
  vendorID: Scalars['ID']
}

export type ValidatedPointOfSaleVendorName = {
  __typename?: 'ValidatedPointOfSaleVendorName'
  bannerID: Scalars['ID']
  id: Scalars['String']
  matchedVendorID: Scalars['ID']
  matchedVendorName: Scalars['String']
  providedVendorName: Scalars['String']
  timestamp: Scalars['Timestamp']
}

export type ValidatedPointOfSaleVendorNameInput = {
  matchedVendorID: Scalars['ID']
  providedVendorName: Scalars['String']
}

export type Vendor = {
  __typename?: 'Vendor'
  acquisitionDetail?: Maybe<Scalars['String']>
  acquisitionSource?: Maybe<AcquisitionSource>
  /** Promotions that are published and currently active */
  activePromotions?: Maybe<PromotionsResults>
  address?: Maybe<Scalars['String']>
  addressComponents?: Maybe<AddressComponents>
  /** All promotions, regardless of status. */
  allPromotions?: Maybe<PromotionsResults>
  /** All employees of this vendor */
  audiences: AudiencesResult
  bestSellers?: Maybe<Array<VendorProduct>>
  billingInfo?: Maybe<BillingInfo>
  /** For vendors of status PROVIDED_CATALOG or CERTIFIED, the date on which we ingested their catalog for the first time */
  catalogFirstProvidedDate?: Maybe<Scalars['Timestamp']>
  catalogLastUpdatedAt?: Maybe<Scalars['Timestamp']>
  defaultOrderSubmissionMethod: SubmissionMethod
  departmentTags?: Maybe<Array<DepartmentName>>
  description?: Maybe<Scalars['String']>
  disableDiscontinuedPurchases: Scalars['Boolean']
  /**
   * Used on Market to prevent stores from ordering products that are currently
   * out of stock.
   */
  disableOutOfStockPurchases: Scalars['Boolean']
  distributionCenterID?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  geographicCoordinates?: Maybe<Scalars['String']>
  hasItemCodes?: Maybe<Scalars['Boolean']>
  hasVendorDashAccess: Scalars['Boolean']
  headerImageURL?: Maybe<Scalars['String']>
  hideWholesalePricing?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  imgURL?: Maybe<Scalars['String']>
  isInventoryEnabled: Scalars['Boolean']
  isMarketEnabled: Scalars['Boolean']
  lastVendorProductUpdate?: Maybe<Scalars['Timestamp']>
  /** Whether this Vendor limits the unit of measure that customers may use to express item quantities. */
  lockUOMSelection?: Maybe<UomLock>
  misscanPolicy?: Maybe<VendorMisscanPolicy>
  name?: Maybe<Scalars['String']>
  orderDeadline?: Maybe<Scalars['String']>
  orderDeadlineInfo?: Maybe<VendorOrderDeadlineInfo>
  orderMin?: Maybe<Scalars['Currency']>
  orderMinimums?: Maybe<Array<VendorOrderMinimum>>
  orderSubmissionUOMLock?: Maybe<UomLock>
  ordersSinceDate: OrdersResult
  paymentProfile?: Maybe<PaymentProfile>
  placeID?: Maybe<Scalars['String']>
  potentialPromotionConflicts?: Maybe<PotentialPromotionConflictsResult>
  prospectiveStoreAccounts: StoresResult
  referredByCompany?: Maybe<Company>
  /** The number of retail users that have this Vendor in their vendor list */
  retailUserCount: Scalars['Int']
  retailerPricing?: Maybe<Scalars['Boolean']>
  serialID?: Maybe<Scalars['ID']>
  showImages?: Maybe<Scalars['Boolean']>
  skipEmailWithEDIOrderSubmission?: Maybe<Scalars['Boolean']>
  /** Optional slug used to construct human-friendly vendor URLs */
  slug?: Maybe<Scalars['String']>
  sortCatalogBy: CatalogSortType
  status: VendorStatus
  /** @deprecated Use storeDepartmentAccountsByStoreID */
  storeAccountByStoreID?: Maybe<VendorStoreAccount>
  storeAccounts: VendorStoreAccountsResult
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  storeDepartmentAccountsByStoreID: VendorVendorStoreDepartmentAccountsResult
  stores: StoresResult
  totalProductCount: Scalars['Int']
  trueCommerceTenetID?: Maybe<Scalars['String']>
  /**
   * Hack to accommodate vendors that receive orders through brokers,
   * and thus shouldn't receive PO emails at the vendor's default order email.
   */
  useAccountMetadataEmailOverVendorEmail: Scalars['Boolean']
  validOrderSubmissionMethods: Array<SubmissionMethod>
  vendorBrands: VendorBrandsResult
  vendorCategories: VendorCategoriesResult
  /** Temp protection of vendor catalog from store vendor product ingest */
  vendorManagedCatalog?: Maybe<Scalars['Boolean']>
  vendorProducts: VendorProductsResult
  vendorStoreDepartmentAccounts: VendorVendorStoreDepartmentAccountsResult
  vendorUsers: VendorUserResults
}

export type VendorOrdersSinceDateArgs = {
  input: VendorOrdersSinceDateInput
}

export type VendorPotentialPromotionConflictsArgs = {
  input: PotentialPromotionConflictsInput
}

export type VendorStoreAccountByStoreIdArgs = {
  storeID: Scalars['ID']
}

export type VendorStoreDepartmentAccountsByStoreIdArgs = {
  storeID: Scalars['ID']
}

export type VendorStoresArgs = {
  input?: InputMaybe<StoreInput>
}

export type VendorVendorProductsArgs = {
  input?: InputMaybe<VendorProductsInput>
}

export type VendorVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorVendorStoreDepartmentAccountsInput>
}

export type VendorBrandsResult = {
  __typename?: 'VendorBrandsResult'
  nodes: Array<Scalars['String']>
}

export type VendorCart = {
  __typename?: 'VendorCart'
  createdAt?: Maybe<Scalars['Timestamp']>
  /** Free items from active Promotions */
  freeItemCount: Scalars['Int']
  id: Scalars['ID']
  idempotencyKey?: Maybe<Scalars['String']>
  /** Number of unique SKUs in Cart */
  lineItemCount: Scalars['Int']
  lineItems: CartLineItems
  /** Line Items with anomalous quantities / UOM */
  lineItemsRequiringReview: CartReviewItemsResult
  misscanLineItems: MisscanLineItems
  /** Items eg from the order guide that are missing from the cart */
  missingItemSuggestions: MissingItemSuggestionsResult
  /** Line items that are currently out of stock from vendor */
  outOfStockProducts: CartOutOfStockProductsResult
  /** Sum of quantities in Cart */
  productCount: Scalars['Int']
  store: Store
  /** Subtotal of items in cart, inclusive of applicable deal value */
  subTotal: Scalars['Currency']
  suggestedCartsModelTimestamp?: Maybe<Scalars['String']>
  /** Suggested products to add to cart, based on current cart contents */
  suggestedProducts: CartSuggestedProductsResult
  /** Money saved through active Promotions */
  totalDiscount: Scalars['Currency']
  /** Line items that are currently out of stock from vendor */
  unavailableProducts: CartUnavailableProductsResult
  updatedAt?: Maybe<Scalars['Timestamp']>
  user: User
  vendor: Vendor
}

export type VendorCategoriesResult = {
  __typename?: 'VendorCategoriesResult'
  nodes: Array<Scalars['String']>
}

export type VendorEdge = {
  __typename?: 'VendorEdge'
  cursor: Scalars['Cursor']
  node: Vendor
}

export type VendorEmail = {
  __typename?: 'VendorEmail'
  email: Scalars['String']
  type: VendorEmailType
}

export type VendorEmailInput = {
  email: Scalars['String']
  type: VendorEmailType
}

export enum VendorEmailType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export type VendorInvitation = {
  __typename?: 'VendorInvitation'
  email: Scalars['String']
  /** ID is identical to the invitation code */
  id: Scalars['ID']
  invitedByStore?: Maybe<Store>
  invitedByUser?: Maybe<User>
  status: InvitationStatus
  vendor: Vendor
}

export type VendorInvitationsResult = {
  __typename?: 'VendorInvitationsResult'
  nodes: Array<VendorInvitation>
}

export enum VendorMisscanPolicy {
  /** @deprecated Misscan 1.0 is deprecated. Use STANDARD instead */
  Legacy = 'LEGACY',
  Locked = 'LOCKED',
  Standard = 'STANDARD',
}

export type VendorOrderDeadline = {
  __typename?: 'VendorOrderDeadline'
  deadlineDay: DayOfWeek
  deadlineTime?: Maybe<Scalars['String']>
  deliveryDay: DayOfWeek
}

export type VendorOrderDeadlineInfo = {
  __typename?: 'VendorOrderDeadlineInfo'
  orderDeadlines: Array<VendorOrderDeadline>
  timezone: Scalars['String']
}

export type VendorOrderDeadlineInfoInput = {
  orderDeadlines: Array<VendorOrderDeadlineInput>
  timezone: Scalars['String']
}

export type VendorOrderDeadlineInput = {
  deadlineDay: DayOfWeek
  deadlineTime?: InputMaybe<Scalars['String']>
  deliveryDay: DayOfWeek
}

export type VendorOrderMinimum = {
  __typename?: 'VendorOrderMinimum'
  orderMin: Scalars['Currency']
  storeID: Scalars['String']
}

export type VendorOrderMinimumInput = {
  orderMin: Scalars['Currency']
  storeID: Scalars['String']
}

export type VendorOrdersInput = {
  filterByActionRequired?: InputMaybe<Scalars['Boolean']>
  filterByConfirmed?: InputMaybe<Scalars['Boolean']>
  filterByReceived?: InputMaybe<Scalars['Boolean']>
  filterByStore?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  vendorID: Scalars['ID']
}

export type VendorOrdersResult = {
  __typename?: 'VendorOrdersResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<Order>
}

export type VendorOrdersSinceDateInput = {
  since: Scalars['Timestamp']
}

export type VendorProduct = {
  __typename?: 'VendorProduct'
  /** The currently active deal including this product, if applicable. VendorProducts can be featured in at most one deal at a time. */
  activeDeal?: Maybe<Deal>
  /** Custom pricing info across all retail accounts (where custom prices are set) */
  allRetailerPricing: Array<RetailerPricingInfo>
  caseCRV?: Maybe<Scalars['Currency']>
  /** @deprecated Use retailerPricing.casePrice instead */
  casePrice?: Maybe<Scalars['Currency']>
  caseSize?: Maybe<Scalars['Float']>
  /** @deprecated Use Product.caseUPC instead */
  caseUPC?: Maybe<Scalars['String']>
  /** The user id that deleted the vendor product */
  createdAt?: Maybe<Scalars['Timestamp']>
  deletedAt?: Maybe<Scalars['Timestamp']>
  /** The date in which the product was created */
  deletedByUserID?: Maybe<Scalars['String']>
  erpID?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** @deprecated use orderGuides instead */
  inOrderGuides?: Maybe<VendorProductInOrderGuidesResult>
  inventory?: Maybe<Scalars['Int']>
  inventoryLevelStatus?: Maybe<InventoryLevelStatus>
  /** @deprecated Unused. */
  isDeleted?: Maybe<Scalars['Boolean']>
  /** @deprecated Replaced by status. */
  isDiscontinued?: Maybe<Scalars['Boolean']>
  /** Only Products from certified vendors are displayed on Market. */
  isMarketplaceEnabled?: Maybe<Scalars['Boolean']>
  isPrivateLabelProduct: Scalars['Boolean']
  /** @deprecated Use isPrivateLabelProduct instead. */
  isStoreSpecific?: Maybe<Scalars['Boolean']>
  itemCode?: Maybe<Scalars['String']>
  lastOrder?: Maybe<StoreVendorProductOrderHistory>
  /**
   * Used primarily by the iOS app to populate offline cache with a diff of products that were updated since the last sync.
   * @deprecated Use updatedAt instead
   */
  lastUpdated?: Maybe<Scalars['Timestamp']>
  notes?: Maybe<Scalars['String']>
  orderGuides?: Maybe<VendorProductOrderGuidesResult>
  product: Product
  replacements: VendorProductReplacementsResult
  /** Displays a list of dates in which the product was discontinued by a retail company. */
  retailerDiscontinuedDates?: Maybe<Array<RetailerDiscontinuedDate>>
  /** The actual price for specific retailers, who might get discounts or markups depending on their relationship with the vendor. If no retailCompanyID is passed, defaults to the user's own company ID to determine the retailer. */
  retailerPricing: PricingInfo
  sizing?: Maybe<Scalars['String']>
  /** @deprecated Unused. */
  srp?: Maybe<Scalars['String']>
  status: VendorProductStatus
  /** @deprecated Use VendorProduct.Stores instead */
  store?: Maybe<Store>
  stores?: Maybe<Array<Maybe<Store>>>
  unitCRV?: Maybe<Scalars['Currency']>
  /** @deprecated Use retailerPricing.unitPrice instead */
  unitPrice?: Maybe<Scalars['Currency']>
  /** The date in which the product was last updated. Used primarily by the iOS app to populate offline cache with a diff of products that were updated since the last sync. */
  updatedAt?: Maybe<Scalars['Timestamp']>
  vendor?: Maybe<Vendor>
  /** The generally-available catalog pricing for this product. See also: retailerPricing */
  wholesalePricing: PricingInfo
}

export type VendorProductInOrderGuidesArgs = {
  input?: InputMaybe<VendorProductInOrderGuidesInput>
}

export type VendorProductLastOrderArgs = {
  input: StoreVendorProductOrderHistoryInput
}

export type VendorProductOrderGuidesArgs = {
  input?: InputMaybe<VendorProductOrderGuidesInput>
}

export type VendorProductReplacementsArgs = {
  input?: InputMaybe<VendorProductReplacementsInput>
}

export type VendorProductRetailerPricingArgs = {
  input?: InputMaybe<VendorProductRetailerPricingInput>
}

export type VendorProductByBrand = {
  __typename?: 'VendorProductByBrand'
  brandName?: Maybe<Scalars['String']>
  vendorProducts: VendorProductsResult
}

export enum VendorProductCatalogSource {
  Retailer = 'RETAILER',
  Vendor = 'VENDOR',
}

export type VendorProductInOrderGuidesInput = {
  retailCompanyID?: InputMaybe<Scalars['ID']>
}

export type VendorProductInOrderGuidesResult = {
  __typename?: 'VendorProductInOrderGuidesResult'
  nodes: Array<OrderGuide>
  totalCount: Scalars['Int']
}

export type VendorProductOrderGuidesInput = {
  bannerID?: InputMaybe<Scalars['ID']>
  storeID?: InputMaybe<Scalars['ID']>
}

export type VendorProductOrderGuidesResult = {
  __typename?: 'VendorProductOrderGuidesResult'
  nodes: Array<V2OrderGuide>
  totalCount: Scalars['Int']
}

export type VendorProductPromotionConflict = {
  __typename?: 'VendorProductPromotionConflict'
  deal: Deal
  vendorProduct: VendorProduct
}

export type VendorProductReplacement = {
  __typename?: 'VendorProductReplacement'
  score: Scalars['Float']
  vendorProduct: VendorProduct
}

export type VendorProductReplacementsCartFilterInput = {
  storeID?: InputMaybe<Scalars['ID']>
  userID?: InputMaybe<Scalars['ID']>
  vendorID?: InputMaybe<Scalars['ID']>
}

export type VendorProductReplacementsFilterInput = {
  cart?: InputMaybe<VendorProductReplacementsCartFilterInput>
}

export type VendorProductReplacementsInput = {
  filter?: InputMaybe<VendorProductReplacementsFilterInput>
  limit?: InputMaybe<Scalars['Int']>
}

export type VendorProductReplacementsResult = {
  __typename?: 'VendorProductReplacementsResult'
  nodes: Array<VendorProductReplacement>
}

export type VendorProductRetailerPricingInput = {
  retailCompanyID?: InputMaybe<Scalars['ID']>
}

export enum VendorProductStatus {
  Available = 'AVAILABLE',
  Discontinued = 'DISCONTINUED',
  StoreDiscontinued = 'STORE_DISCONTINUED',
  Unavailable = 'UNAVAILABLE',
}

export type VendorProductSuggestionsInput = {
  orderGuideProductsOnly?: InputMaybe<Scalars['Boolean']>
  storeID: Scalars['ID']
  upc: Scalars['String']
  vendorID?: InputMaybe<Scalars['ID']>
}

export type VendorProductSuggestionsResult = {
  __typename?: 'VendorProductSuggestionsResult'
  matchedVendorProducts?: Maybe<Array<VendorProduct>>
  matchingVendorProduct?: Maybe<VendorProduct>
  metadata?: Maybe<ProductLookupMetadata>
  misscans?: Maybe<Array<MisscanResolution>>
  suggestions?: Maybe<Array<VendorProduct>>
}

export type VendorProductsByBrandResult = {
  __typename?: 'VendorProductsByBrandResult'
  nodes: Array<VendorProductByBrand>
}

export type VendorProductsByIDsInput = {
  storeID?: InputMaybe<Scalars['ID']>
  vendorProductIDs: Array<Scalars['ID']>
}

export type VendorProductsByIDsResult = {
  __typename?: 'VendorProductsByIDsResult'
  nodes: Array<VendorProduct>
}

export type VendorProductsInput = {
  filterByBrand?: InputMaybe<Scalars['String']>
  filterByCategory?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<VendorProductsSortingInput>
}

export type VendorProductsQueryResult = {
  __typename?: 'VendorProductsQueryResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore: Scalars['Boolean']
  nodes: Array<VendorProduct>
  totalCount: Scalars['Int']
}

export type VendorProductsResult = {
  __typename?: 'VendorProductsResult'
  cursor?: Maybe<Scalars['ID']>
  hasMore?: Maybe<Scalars['Boolean']>
  nodes: Array<VendorProduct>
}

export enum VendorProductsSortingField {
  ItemCode = 'ITEM_CODE',
}

export type VendorProductsSortingInput = {
  direction?: InputMaybe<SortingDirection>
  field: VendorProductsSortingField
}

export type VendorQueryInput = {
  after?: InputMaybe<Scalars['Cursor']>
  filterByAccountStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  first: Scalars['Int']
  includeInactive?: InputMaybe<Scalars['Boolean']>
  storeIDs?: InputMaybe<Array<Scalars['ID']>>
}

export enum VendorStatus {
  Certified = 'CERTIFIED',
  Hidden = 'HIDDEN',
  None = 'NONE',
  ProvidedCatalog = 'PROVIDED_CATALOG',
}

export type VendorStoreAccount = {
  __typename?: 'VendorStoreAccount'
  accountNumber?: Maybe<Scalars['String']>
  activePromotions?: Maybe<PromotionsResults>
  /** @deprecated Use defaultUnitOfMeasure instead */
  defaultUOM?: Maybe<UnitOfMeasure>
  defaultUnitOfMeasure?: Maybe<UnitOfMeasure>
  orderDeadline?: Maybe<Scalars['String']>
  orderSubmissionMethod?: Maybe<SubmissionMethod>
  /** Orders placed by this account's store to the vendor, ordered by most recent. */
  recentOrders: VendorStoreAccountOrdersResult
  status: VendorStoreAccountStatus
  store?: Maybe<Store>
  storeEmailList: Array<StoreEmail>
  /** @deprecated Use storeEmailList instead */
  storeEmails?: Maybe<Array<Scalars['String']>>
  vendor: Vendor
  vendorEmailList: Array<VendorEmail>
  /** @deprecated Use vendorEmailList instead */
  vendorEmails?: Maybe<Array<Scalars['String']>>
  vendorID?: Maybe<Scalars['String']>
}

export type VendorStoreAccountRecentOrdersArgs = {
  input?: InputMaybe<VendorStoreAccountOrdersInput>
}

export type VendorStoreAccountInput = {
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type VendorStoreAccountOrdersInput = {
  after?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
}

export type VendorStoreAccountOrdersResult = {
  __typename?: 'VendorStoreAccountOrdersResult'
  nodes: Array<Order>
}

export type VendorStoreAccountProductsByUpdateTimeInput = {
  accountID: Scalars['ID']
  cursor?: InputMaybe<Scalars['ID']>
  filterBySource?: InputMaybe<ProductSourceFilter>
  lastRequestedAt?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
  vendorID: Scalars['ID']
}

export enum VendorStoreAccountStatus {
  /** Account placed and order within the past ~30 days */
  Active = 'ACTIVE',
  /** We sent an invite but the account hasn't been created */
  InvitedButNotSignedUp = 'INVITED_BUT_NOT_SIGNED_UP',
  /** Account Created, but no invite was sent yet */
  NeverInvited = 'NEVER_INVITED',
  /** No orders last month, but was previously active */
  NoRecentOrders = 'NO_RECENT_ORDERS',
}

export type VendorStoreAccountsResult = {
  __typename?: 'VendorStoreAccountsResult'
  nodes: Array<VendorStoreAccount>
  totalCount: Scalars['Int']
}

/**
 * ****************************
 *      Vendor Store Department Acccount
 * ****************************
 */
export type VendorStoreDepartmentAccount = {
  __typename?: 'VendorStoreDepartmentAccount'
  accountActivityStatus: VendorStoreDepartmentAccountActivityStatus
  accountNumber?: Maybe<Scalars['String']>
  activePromotions?: Maybe<PromotionsResults>
  deactivatedAt?: Maybe<Scalars['Timestamp']>
  defaultUnitOfMeasure?: Maybe<UnitOfMeasure>
  dunsNumber?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastOrder?: Maybe<Order>
  name: Scalars['String']
  orderDeadline?: Maybe<Scalars['String']>
  orderDeadlineInfo?: Maybe<VendorOrderDeadlineInfo>
  /** Orders placed by this account's store to the vendor, ordered by most recent. */
  orderGuide?: Maybe<V2OrderGuide>
  orderSubmissionMethod?: Maybe<SubmissionMethod>
  orderSubmissionUOMLock?: Maybe<UomLock>
  recentOrders: VendorStoreDepartmentAccountOrdersResult
  status: VendorStoreDepartmentAccountStatus
  store?: Maybe<Store>
  storeDepartment: StoreDepartment
  storeDepartmentID: Scalars['String']
  storeEmails: Array<StoreEmail>
  vendor: Vendor
  vendorEmails: Array<VendorEmail>
  vendorID: Scalars['String']
  vendorName: Scalars['String']
}

/**
 * ****************************
 *      Vendor Store Department Acccount
 * ****************************
 */
export type VendorStoreDepartmentAccountRecentOrdersArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountOrdersInput>
}

export enum VendorStoreDepartmentAccountActivityStatus {
  /** Account placed and order within the past ~30 days */
  Active = 'ACTIVE',
  /** We sent an invite but the account hasn't been created */
  InvitedButNotSignedUp = 'INVITED_BUT_NOT_SIGNED_UP',
  /** Hasn't placed an order yet */
  NeverActive = 'NEVER_ACTIVE',
  /** Account Created, but no invite was sent yet */
  NeverInvited = 'NEVER_INVITED',
  /** No orders last month, but was previously active */
  NoRecentOrders = 'NO_RECENT_ORDERS',
}

export type VendorStoreDepartmentAccountInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  query?: InputMaybe<Scalars['String']>
}

export type VendorStoreDepartmentAccountOrdersInput = {
  after?: InputMaybe<Scalars['Timestamp']>
  limit?: InputMaybe<Scalars['Int']>
}

export type VendorStoreDepartmentAccountOrdersResult = {
  __typename?: 'VendorStoreDepartmentAccountOrdersResult'
  nodes: Array<Order>
}

export type VendorStoreDepartmentAccountResult = {
  __typename?: 'VendorStoreDepartmentAccountResult'
  nodes: Array<VendorStoreDepartmentAccount>
}

export enum VendorStoreDepartmentAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type VendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  filterByUserDepartmentList?: InputMaybe<Scalars['Boolean']>
  includeInactive?: InputMaybe<Scalars['Boolean']>
  marketEnabledOnly?: InputMaybe<Scalars['Boolean']>
  searchByVendor?: InputMaybe<Scalars['String']>
}

export type VendorStoreDepartmentAccountsResult = {
  __typename?: 'VendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type VendorStoreProductsQueryInput = {
  cursor?: InputMaybe<Scalars['ID']>
  filterByStoreID?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  vendorID: Scalars['ID']
}

/**
 * ****************************
 *         User Types
 * ****************************
 */
export type VendorUser = {
  __typename?: 'VendorUser'
  /** @deprecated Use v2 order guide resolvers */
  orderGuideByAccount: OrderGuide
  /** @deprecated Use vendorStoreDepartmentAccounts instead */
  storeAccounts: VendorStoreAccountsResult
  user: User
  vendor: Vendor
  vendorStoreDepartmentAccounts: VendorStoreDepartmentAccountsResult
}

/**
 * ****************************
 *         User Types
 * ****************************
 */
export type VendorUserOrderGuideByAccountArgs = {
  input: VendorUserOrderGuideInput
}

/**
 * ****************************
 *         User Types
 * ****************************
 */
export type VendorUserVendorStoreDepartmentAccountsArgs = {
  input?: InputMaybe<VendorStoreDepartmentAccountsInput>
}

export type VendorUserOrderGuideInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  storeID: Scalars['ID']
}

export type VendorUserResults = {
  __typename?: 'VendorUserResults'
  nodes: Array<VendorUser>
}

export type VendorVendorStoreDepartmentAccountsInput = {
  filterByStatus?: InputMaybe<VendorStoreDepartmentAccountStatus>
  filterByStore?: InputMaybe<Scalars['ID']>
  filterByUserDepartmentList?: InputMaybe<Scalars['Boolean']>
  includeInactive?: InputMaybe<Scalars['Boolean']>
}

export type VendorVendorStoreDepartmentAccountsResult = {
  __typename?: 'VendorVendorStoreDepartmentAccountsResult'
  nodes: Array<VendorStoreDepartmentAccount>
  totalCount: Scalars['Int']
}

export type VendorViewConnection = {
  __typename?: 'VendorViewConnection'
  edges: Array<VendorEdge>
  pageInfo: PageInfo
}

export type VendorsResult = {
  __typename?: 'VendorsResult'
  cursor: Scalars['String']
  hasMore: Scalars['Boolean']
  nodes: Array<Vendor>
  totalCount: Scalars['Int']
}

/** Metadata about the currently authenticated user session.  */
export type Viewer = {
  __typename?: 'Viewer'
  /** The authenticated user, while impersonating user */
  impersonatingUser?: Maybe<User>
  isImpersonating?: Maybe<Scalars['Boolean']>
  user: User
}

export type MeQueryInput = {
  impersonatedUserEmail?: InputMaybe<Scalars['String']>
  impersonatedUserID?: InputMaybe<Scalars['ID']>
}

export type UpdateCartProductQuantityInput = {
  quantity: Scalars['Int']
  /** Vendor users must specify the store to update */
  storeID?: InputMaybe<Scalars['ID']>
  unitOfMeasure: UnitOfMeasure
  vendorProductID: Scalars['ID']
}

export type UpdateCartProductQuantityResult = {
  __typename?: 'updateCartProductQuantityResult'
  updatedVendorCart?: Maybe<VendorCart>
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type EnumValue = {
  __typename?: '__EnumValue'
  name: Scalars['String']
  description?: Maybe<Scalars['String']>
  isDeprecated: Scalars['Boolean']
  deprecationReason?: Maybe<Scalars['String']>
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type Field = {
  __typename?: '__Field'
  name: Scalars['String']
  description?: Maybe<Scalars['String']>
  args: Array<InputValue>
  type: Type
  isDeprecated: Scalars['Boolean']
  deprecationReason?: Maybe<Scalars['String']>
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type InputValue = {
  __typename?: '__InputValue'
  name: Scalars['String']
  description?: Maybe<Scalars['String']>
  type: Type
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>
  isDeprecated: Scalars['Boolean']
  deprecationReason?: Maybe<Scalars['String']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type Type = {
  __typename?: '__Type'
  kind: TypeKind
  name?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  specifiedByUrl?: Maybe<Scalars['String']>
  fields?: Maybe<Array<Field>>
  interfaces?: Maybe<Array<Type>>
  possibleTypes?: Maybe<Array<Type>>
  enumValues?: Maybe<Array<EnumValue>>
  inputFields?: Maybe<Array<InputValue>>
  ofType?: Maybe<Type>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>
}

/** An enum describing what kind of type a given `__Type` is. */
export enum TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL',
}
